/**
 * GENERATED FILE — DO NOT EDIT BY HAND.
 *
 * Written by scripts/assemble-fleet.mjs (`npm run generate`, generator 1.4.1),
 * run run-e3cc0f891306, from:
 *   research/raw/welfare/AUDIT.json
 *   research/raw/welfare/RECONCILIATION.json
 *   research/raw/welfare/central.json
 *   research/raw/welfare/elections-timing.json
 *   research/raw/welfare/fiscal-results.json
 *   research/raw/welfare/literature.json
 *   research/raw/welfare/state-cash-other.json
 *   research/raw/welfare/vendors.json
 *   research/raw/welfare/women-cash.json
 *
 * To change it, change the research file, or the fleet's RECONCILIATION.json or
 * AUDIT.json, and re-run `npm run generate`. `npm run validate` fails when this
 * file no longer matches what its inputs assemble to, so a hand edit cannot ship.
 */

import type { GNode, GEdge } from '../graph/schema';
import type { BaseRateRow, BenefitRow, EntityIdentity, FleetMeta, FleetText, Narrative, Void } from '../graph/fleet';
import type { Coverage, Election, Scheme } from './welfare';

export const WELFARE_SCHEMES: Scheme[] = [
  {
    "id": "scheme:ap-smartcards-nregs-ssp",
    "name": "Andhra Pradesh biometric Smartcard payments for NREGS and social security pensions",
    "al": [
      "AP Smartcards"
    ],
    "level": "state",
    "st": "ap",
    "applicableStates": null,
    "category": "other",
    "party": "INC (AP government 2004–14)",
    "announced": null,
    "approved": null,
    "launched": null,
    "benefit": null,
    "eligibility": null,
    "beneficiaries": [],
    "outlay": [],
    "electionContext": null,
    "status": [],
    "results": [
      {
        "finding": "Muralidharan, Niehaus & Sukhtankar (AER 2016), large-scale RCT across 157 sub-districts: the biometric payment system made payments faster and less corrupt without increasing exclusion — the canonical positive evidence for DBT-style reform; specific effect sizes not re-read in this sweep.",
        "tier": "reported",
        "srcs": [
          [
            "Muralidharan, Niehaus & Sukhtankar (2016) Building State Capacity: Evidence from Biometric Smartcards in India — AER 106(10):2895–2929 (Crossref metadata)",
            "https://api.crossref.org/works/10.1257/aer.20141346"
          ]
        ]
      }
    ],
    "ministers": [],
    "whoElseBenefits": [],
    "srcs": [
      [
        "Muralidharan, Niehaus & Sukhtankar (2016) Building State Capacity: Evidence from Biometric Smartcards in India — AER 106(10):2895–2929 (Crossref metadata)",
        "https://api.crossref.org/works/10.1257/aer.20141346"
      ]
    ],
    "domain": "literature"
  },
  {
    "id": "scheme:ap-talliki-vandanam",
    "name": "Talliki Vandanam",
    "al": [
      "Thalliki Vandanam",
      "తల్లికి వందనం"
    ],
    "level": "state",
    "st": "ap",
    "applicableStates": null,
    "category": "women-cash",
    "party": "TDP",
    "announced": {
      "date": "2024",
      "byPersonId": "wel:n-chandrababu-naidu",
      "office": "TDP president ('Super Six' promises for the May 2024 election)",
      "srcs": [
        [
          "Deccan Herald/PTI, 13 Jun 2025: AP launches Talliki Vandanam Rs 15,000 per child",
          "https://www.deccanherald.com/india/andhra-pradesh/andhra-govt-launches-talliki-vandanam-scheme-rs-15000-to-be-given-for-school-going-child-3584484"
        ]
      ]
    },
    "approved": {
      "date": "2025-06",
      "body": "Government order/guidelines issued by Secretary Kona Sasidhar",
      "srcs": [
        [
          "Deccan Herald/PTI, 13 Jun 2025: AP launches Talliki Vandanam Rs 15,000 per child",
          "https://www.deccanherald.com/india/andhra-pradesh/andhra-govt-launches-talliki-vandanam-scheme-rs-15000-to-be-given-for-school-going-child-3584484"
        ]
      ]
    },
    "launched": {
      "date": "2025-06-12",
      "srcs": [
        [
          "Deccan Herald/PTI, 13 Jun 2025: AP launches Talliki Vandanam Rs 15,000 per child",
          "https://www.deccanherald.com/india/andhra-pradesh/andhra-govt-launches-talliki-vandanam-scheme-rs-15000-to-be-given-for-school-going-child-3584484"
        ]
      ]
    },
    "benefit": {
      "amount": 15000,
      "unit": "₹ per year per school-going child (Class I–Intermediate), paid to the mother/guardian; ₹2,000 deducted at source for school maintenance",
      "changes": []
    },
    "eligibility": "Every eligible household with children in government, aided or private schools/junior colleges; no cap on number of children (explicitly pro-natalist per the government)",
    "beneficiaries": [
      {
        "asOf": "2025-06",
        "count": 4300000,
        "srcs": [
          [
            "Deccan Herald/PTI, 13 Jun 2025: AP launches Talliki Vandanam Rs 15,000 per child",
            "https://www.deccanherald.com/india/andhra-pradesh/andhra-govt-launches-talliki-vandanam-scheme-rs-15000-to-be-given-for-school-going-child-3584484"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2025-26",
        "budgetedCr": null,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Deccan Herald/PTI, 13 Jun 2025: AP launches Talliki Vandanam Rs 15,000 per child",
            "https://www.deccanherald.com/india/andhra-pradesh/andhra-govt-launches-talliki-vandanam-scheme-rs-15000-to-be-given-for-school-going-child-3584484"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Andhra Pradesh assembly",
      "date": "2024-05-13",
      "monthsFromLaunch": -13,
      "incumbentParty": "YSRCP",
      "result": "challenger (TDP-led NDA) won; launched 13 months later",
      "seatChange": "TDP 135 (+112)",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI results): 2024 Andhra Pradesh Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2025-06-12",
        "status": "live",
        "note": null,
        "srcs": [
          [
            "Deccan Herald/PTI, 13 Jun 2025: AP launches Talliki Vandanam Rs 15,000 per child",
            "https://www.deccanherald.com/india/andhra-pradesh/andhra-govt-launches-talliki-vandanam-scheme-rs-15000-to-be-given-for-school-going-child-3584484"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Successor to YSRCP's Amma Vodi (one child per household) and YSR Cheyutha (Rs 18,750/yr to women 45–60) — neither verified in an opened source; recorded as a gap",
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald/PTI, 13 Jun 2025: AP launches Talliki Vandanam Rs 15,000 per child",
            "https://www.deccanherald.com/india/andhra-pradesh/andhra-govt-launches-talliki-vandanam-scheme-rs-15000-to-be-given-for-school-going-child-3584484"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:n-chandrababu-naidu",
        "role": "Chief Minister",
        "action": "announced",
        "date": "2024",
        "party": "TDP",
        "srcs": [
          [
            "Deccan Herald/PTI, 13 Jun 2025: AP launches Talliki Vandanam Rs 15,000 per child",
            "https://www.deccanherald.com/india/andhra-pradesh/andhra-govt-launches-talliki-vandanam-scheme-rs-15000-to-be-given-for-school-going-child-3584484"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "private unaided schools",
        "how": "Rs 15,000 per child flows to households with children in private schools too, supporting fee payment; Rs 2,000 retained for school maintenance",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald/PTI, 13 Jun 2025: AP launches Talliki Vandanam Rs 15,000 per child",
            "https://www.deccanherald.com/india/andhra-pradesh/andhra-govt-launches-talliki-vandanam-scheme-rs-15000-to-be-given-for-school-going-child-3584484"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Deccan Herald/PTI, 13 Jun 2025: AP launches Talliki Vandanam Rs 15,000 per child",
        "https://www.deccanherald.com/india/andhra-pradesh/andhra-govt-launches-talliki-vandanam-scheme-rs-15000-to-be-given-for-school-going-child-3584484"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2024 Andhra Pradesh Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"
      ]
    ],
    "domain": "women-cash"
  },
  {
    "id": "scheme:ap-village-volunteers",
    "name": "Andhra Pradesh village/ward volunteer system (delivery layer for YSR pensions and schemes)",
    "al": [
      "Grama Volunteers",
      "Ward Volunteers"
    ],
    "level": "state",
    "st": "ap",
    "applicableStates": null,
    "category": "other",
    "party": "YSRCP",
    "announced": {
      "date": null,
      "byPersonId": "wel:ys-jagan-mohan-reddy",
      "office": "Chief Minister, Andhra Pradesh (system introduced 2019; date not in opened source)",
      "srcs": [
        [
          "ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024",
          "https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Andhra Pradesh Cabinet",
      "srcs": []
    },
    "launched": {
      "date": null,
      "srcs": [
        [
          "ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024",
          "https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"
        ]
      ]
    },
    "benefit": {
      "amount": 5000,
      "unit": "₹ per month honorarium per volunteer (one per ~50 households)",
      "changes": []
    },
    "eligibility": "Volunteers: local youth recruited per 50 households under 15,425 sachivalayams; they deliver pensions and scheme benefits door to door",
    "beneficiaries": [
      {
        "asOf": "2024-04-05",
        "count": 256000,
        "srcs": [
          [
            "ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024",
            "https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2023-24",
        "budgetedCr": null,
        "actualCr": 1536,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024",
            "https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Andhra Pradesh assembly",
      "date": "2024-05-13",
      "monthsFromLaunch": null,
      "incumbentParty": "YSRCP",
      "result": "incumbent lost; TDP 135 (+112), JSP 21",
      "seatChange": "YSRCP lost ~140 seats",
      "srcs": [
        [
          "Wikipedia (pointer), 2024 Andhra Pradesh Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2024-04-05",
        "status": "eligibility-tightened",
        "note": "EC removed ~100 volunteers and barred volunteers from pension distribution during the MCC; only 8.6 lakh beneficiaries got home delivery by government staff",
        "srcs": [
          [
            "ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024",
            "https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"
          ]
        ]
      },
      {
        "date": "2024-06-12",
        "status": "discontinued",
        "note": "system wound down under the TDP government (widely reported; not verified from an opened source — gap)",
        "srcs": [
          [
            "Wikipedia (pointer), 2024 Andhra Pradesh Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "TDP (Varla Ramaiah) and JSP alleged volunteers acted as YSRCP door-to-door agents and gathered data; YSRCP's Sajjala Ramakrishna Reddy denied it and said the opposition wanted to restore TDP-era committees",
        "tier": "alleged",
        "srcs": [
          [
            "ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024",
            "https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:ys-jagan-mohan-reddy",
        "role": "Chief Minister",
        "action": "administers",
        "date": "2019-05-30",
        "party": "YSRCP",
        "srcs": [
          [
            "ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024",
            "https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "2.56 lakh village/ward volunteers (honorarium recipients)",
        "how": "~₹1,536 crore/yr of honoraria to 2.56 lakh locally recruited volunteers — a paid last-mile layer that the opposition characterised as party machinery",
        "amountCr": 1536,
        "tier": "reported",
        "srcs": [
          [
            "ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024",
            "https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"
          ]
        ]
      },
      {
        "who": "party:ysrcp",
        "how": "Alleged electoral use of the volunteer network (EC acted on specific complaints; denied by party)",
        "amountCr": null,
        "tier": "alleged",
        "srcs": [
          [
            "ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024",
            "https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024",
        "https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"
      ],
      [
        "Wikipedia (pointer), 2024 Andhra Pradesh Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"
      ]
    ],
    "domain": "vendors"
  },
  {
    "id": "scheme:ap-ysr-amma-vodi",
    "name": "YSR Amma Vodi",
    "al": [
      "Amma Vodi",
      "అమ్మ ఒడి"
    ],
    "level": "state",
    "st": "ap",
    "applicableStates": null,
    "category": "student",
    "party": "YSRCP",
    "announced": {
      "date": null,
      "byPersonId": "wel:ys-jagan-mohan-reddy",
      "office": "Chief Minister, Andhra Pradesh",
      "srcs": []
    },
    "approved": {
      "date": null,
      "body": null,
      "srcs": []
    },
    "launched": {
      "date": null,
      "srcs": []
    },
    "benefit": {
      "amount": 15000,
      "unit": "₹ per year per school-going child, paid to the mother",
      "changes": [
        {
          "date": "2025-06-12",
          "amount": 15000,
          "note": "Superseded by Thalliki Vandanam (TDP-led govt), Rs 15,000 per child for every school-going child; disbursal from 12 Jun 2025 (search-level; not opened)",
          "srcs": [
            [
              "Deccan Herald/PTI, 13 Jun 2025: AP launches Talliki Vandanam Rs 15,000 per child",
              "https://www.deccanherald.com/india/andhra-pradesh/andhra-govt-launches-talliki-vandanam-scheme-rs-15000-to-be-given-for-school-going-child-3584484"
            ]
          ]
        }
      ]
    },
    "eligibility": "mothers/guardians of children enrolled in school, income criteria",
    "beneficiaries": [],
    "outlay": [
      {
        "fy": "2020-21",
        "budgetedCr": 6000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Andhra Pradesh Budget Analysis 2020-21",
            "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2020-21"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Andhra Pradesh assembly",
      "date": "2024-05-13",
      "monthsFromLaunch": 52,
      "incumbentParty": "YSRCP",
      "result": "incumbent lost",
      "seatChange": "TDP-led alliance 135/175, YSRCP 11/175",
      "srcs": [
        [
          "Wikipedia — 2024 Andhra Pradesh Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2024-06-12",
        "status": "live",
        "note": "Continued in some form by the incoming TDP-led government rather than abolished outright, per TDP's own campaign promise not to cut welfare — this file could not independently confirm the exact successor scheme's terms this session.",
        "srcs": []
      },
      {
        "date": "2020",
        "status": "live",
        "note": "Part of the Navaratnalu DBT package",
        "srcs": [
          [
            "PRS, Andhra Pradesh Budget Analysis 2020-21",
            "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2020-21"
          ]
        ]
      },
      {
        "date": "2025-06",
        "status": "renamed",
        "note": "Thalliki Vandanam under TDP-led government — supersession",
        "srcs": [
          [
            "Deccan Herald/PTI, 13 Jun 2025: AP launches Talliki Vandanam Rs 15,000 per child",
            "https://www.deccanherald.com/india/andhra-pradesh/andhra-govt-launches-talliki-vandanam-scheme-rs-15000-to-be-given-for-school-going-child-3584484"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Like Rythu Bharosa, a large, multi-year, conditional cash programme launched over four years before the election it is sometimes discussed alongside — the long gap and the incumbent's loss both weigh against a narrow timing-driven vote-buying reading.",
        "tier": "analytic",
        "srcs": []
      },
      {
        "finding": "Same as Rythu Bharosa: large, multi-year DBT with near-universal reach, incumbent lost 2024 decisively.",
        "tier": "analytic",
        "srcs": [
          [
            "The Print, 18 Apr 2024: As Jagan banks on direct benefit schemes in AP, voters split",
            "https://theprint.in/politics/as-jagan-banks-on-direct-benefit-schemes-in-ap-voters-split-anxiety-over-jobs-cost-of-living/2046063/"
          ],
          [
            "Wikipedia infobox (pointer to ECI): 2024 Andhra Pradesh Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:ys-jagan-mohan-reddy",
        "role": "Chief Minister, Andhra Pradesh",
        "action": "announced",
        "date": null,
        "party": "YSRCP",
        "srcs": []
      },
      {
        "personId": "wel:ys-jagan-mohan-reddy",
        "role": "Chief Minister, Andhra Pradesh",
        "action": "announced",
        "date": null,
        "party": "YSRCP",
        "srcs": [
          [
            "PRS, Andhra Pradesh Budget Analysis 2020-21",
            "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2020-21"
          ]
        ]
      }
    ],
    "whoElseBenefits": [],
    "srcs": [
      [
        "PRS, Andhra Pradesh Budget Analysis 2020-21",
        "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2020-21"
      ],
      [
        "The Print, 18 Apr 2024: As Jagan banks on direct benefit schemes in AP, voters split",
        "https://theprint.in/politics/as-jagan-banks-on-direct-benefit-schemes-in-ap-voters-split-anxiety-over-jobs-cost-of-living/2046063/"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2024 Andhra Pradesh Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:ap-ysr-pension-kanuka",
    "name": "YSR Pension Kanuka",
    "al": [
      "Pension Kanuka",
      "NTR Bharosa (2024 rename)"
    ],
    "level": "state",
    "st": "ap",
    "applicableStates": null,
    "category": "pension",
    "party": "YSRCP",
    "announced": {
      "date": "2019-06",
      "byPersonId": "wel:ys-jagan-mohan-reddy",
      "office": "Chief Minister, Andhra Pradesh",
      "srcs": [
        [
          "PRS, Andhra Pradesh Budget Analysis 2020-21",
          "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2020-21"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": null,
      "srcs": []
    },
    "launched": {
      "date": null,
      "srcs": []
    },
    "benefit": {
      "amount": 2250,
      "unit": "₹ per month (2019-20 level per fleet knowledge; the opened PRS note records the stated goal of Rs 3,000)",
      "changes": [
        {
          "date": "2023",
          "amount": 3000,
          "note": "Government sought to raise to Rs 3,000 \"in the coming years\" (PRS 2023-24)",
          "srcs": [
            [
              "PRS, Andhra Pradesh Budget Analysis 2023-24",
              "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2023-24"
            ]
          ]
        },
        {
          "date": "2024-07",
          "amount": 4000,
          "note": "TDP-led government renamed to NTR Bharosa and raised to Rs 4,000 (Super Six promise) — amount not verified in an opened page; PRS 2024-25 shows Rs 4,407 cr allocation line",
          "srcs": [
            [
              "PRS, Andhra Pradesh Budget Analysis 2024-25",
              "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2024-25"
            ]
          ]
        }
      ]
    },
    "eligibility": "Old age, widows, disabled, weavers, toddy tappers, etc.",
    "beneficiaries": [],
    "outlay": [
      {
        "fy": "2020-21",
        "budgetedCr": 16000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Andhra Pradesh Budget Analysis 2020-21",
            "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2020-21"
          ]
        ]
      },
      {
        "fy": "2023-24",
        "budgetedCr": 21434,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Andhra Pradesh Budget Analysis 2023-24",
            "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2023-24"
          ]
        ]
      },
      {
        "fy": "2024-25",
        "budgetedCr": 4407,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Andhra Pradesh Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Andhra Pradesh assembly",
      "date": "2024-05-13",
      "monthsFromLaunch": null,
      "incumbentParty": "YSRCP",
      "result": "incumbent lost",
      "seatChange": "YSRCP 151→11",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI): 2024 Andhra Pradesh Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2024-07",
        "status": "renamed",
        "note": "NTR Bharosa under TDP-led government — supersession",
        "srcs": [
          [
            "PRS, Andhra Pradesh Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Pensions of Rs 21,434 cr in 2023-24 were the single largest YSR DBT line in the opened PRS analyses; committed expenditure (salaries, pensions, interest) of Rs 49,840 cr in 2023-24 constrained capital outlay, which PRS notes was chronically under-spent (Rs 7,245 cr of Rs 30,678 cr in 2022-23).",
        "tier": "documented",
        "srcs": [
          [
            "PRS, Andhra Pradesh Budget Analysis 2023-24",
            "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2023-24"
          ],
          [
            "PRS, Andhra Pradesh Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:ys-jagan-mohan-reddy",
        "role": "Chief Minister, Andhra Pradesh",
        "action": "announced",
        "date": "2019-06",
        "party": "YSRCP",
        "srcs": [
          [
            "PRS, Andhra Pradesh Budget Analysis 2020-21",
            "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2020-21"
          ]
        ]
      }
    ],
    "whoElseBenefits": [],
    "srcs": [
      [
        "PRS, Andhra Pradesh Budget Analysis 2020-21",
        "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2020-21"
      ],
      [
        "PRS, Andhra Pradesh Budget Analysis 2023-24",
        "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2023-24"
      ],
      [
        "PRS, Andhra Pradesh Budget Analysis 2024-25",
        "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2024-25"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2024 Andhra Pradesh Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:ap-ysr-rythu-bharosa",
    "name": "YSR Rythu Bharosa",
    "al": [
      "Rythu Bharosa (AP)"
    ],
    "level": "state",
    "st": "ap",
    "applicableStates": null,
    "category": "farmer-cash",
    "party": "YSRCP",
    "announced": {
      "date": "2019-10-15",
      "byPersonId": "wel:ys-jagan-mohan-reddy",
      "office": "Chief Minister, Andhra Pradesh",
      "srcs": [
        [
          "ClearTax — YSR Rythu Bharosa",
          "https://cleartax.in/s/ysr-rythu-bharosa-scheme"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "AP cabinet — not verified",
      "srcs": []
    },
    "launched": {
      "date": "2019-10-15",
      "srcs": [
        [
          "ClearTax — YSR Rythu Bharosa",
          "https://cleartax.in/s/ysr-rythu-bharosa-scheme"
        ]
      ]
    },
    "benefit": {
      "amount": 13500,
      "unit": "₹ per year per farmer",
      "changes": [
        {
          "date": "2025-08-02",
          "amount": 20000,
          "note": "Superseded by TDP-led NDA government's Annadata Sukhibhava – PM KISAN (Rs 20,000/yr; Rs 1,000 cr in 2024-25 BE); details of the Aug 2025 launch not opened",
          "srcs": [
            [
              "PRS, Andhra Pradesh Budget Analysis 2024-25",
              "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2024-25"
            ]
          ]
        }
      ]
    },
    "eligibility": "cultivating farmer families",
    "beneficiaries": [],
    "outlay": [
      {
        "fy": "2022-23",
        "budgetedCr": 3900,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": 0.3,
        "srcs": [
          [
            "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
            "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
          ]
        ]
      },
      {
        "fy": "2023-24",
        "budgetedCr": 4020,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Andhra Pradesh Budget Analysis 2023-24",
            "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2023-24"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Andhra Pradesh assembly",
      "date": "2024-05-13",
      "monthsFromLaunch": 55,
      "incumbentParty": "YSRCP",
      "result": "incumbent lost",
      "seatChange": "TDP-led alliance 135/175, YSRCP 11/175; YSRCP vote share fell ~10.6pp",
      "srcs": [
        [
          "Wikipedia — 2024 Andhra Pradesh Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2025-01-01",
        "status": "discontinued",
        "note": "Superseded by the TDP-led government's Annadata Sukhibhava scheme after the 2024 change of government — supersession, not simple deletion.",
        "srcs": []
      },
      {
        "date": "2019-10-15",
        "status": "live",
        "note": "",
        "srcs": [
          [
            "Govt Schemes India — YSR Rythu Bharosa: launched 15 Oct 2019; ₹13,500/yr per farmer family (₹7,500 state + ₹6,000 PM-KISAN)",
            "https://www.govtschemes.in/ysr-rythu-bharosa-scheme"
          ],
          [
            "YSR Congress Party — YSR Rythu Bharosa: all you need to know (party source; launch 15 Oct at Kakaturu, Nellore; ₹13,500 incl. ₹6,000 PM-KISAN)",
            "https://www.ysrcongress.com/special-news/ysr-rythu-bharosa-all-you-need-69738"
          ]
        ]
      },
      {
        "date": "2024-06-12",
        "status": "renamed",
        "note": "Superseded by Annadata Sukhibhava under the TDP-led government (Rs 1,000 cr in 2024-25 BE) — supersession, not deletion",
        "srcs": [
          [
            "PRS, Andhra Pradesh Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "AP's Rythu Bharosa/Amma Vodi/other YSR-branded transfers together formed one of the largest state DBT programmes in India by outlay and beneficiary count, yet YSRCP lost the 2024 election decisively — the single most important counter-case in this file against any simple 'cash transfers buy elections' reading.",
        "tier": "analytic",
        "srcs": [
          [
            "Wikipedia — 2024 Andhra Pradesh Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"
          ]
        ]
      },
      {
        "finding": "RBI (Jun 2022) Annex 1 lists ten Andhra Pradesh schemes totalling ₹27,541 cr in 2022-23 BE = 2.1% of GSDP and 30.3% of own tax revenue (Amma Vodi ₹6,500 cr, YSR Aasra ₹6,400 cr, electricity subsidy ₹5,000 cr, YSR Cheyutha ₹4,236 cr, Rythu Bharosa ₹3,900 cr …). Note an internal inconsistency: Table 5 gives 14.1% of revenue receipts, Annex 1 total gives 14.4%.",
        "tier": "documented",
        "srcs": [
          [
            "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
            "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
          ]
        ]
      },
      {
        "finding": "Andhra Pradesh declared off-budget borrowings of ₹6,288 cr (2021-22), ₹1,976 cr, ₹613 cr and ₹0 (2024-25); guarantees 10.9% of GSDP (Mar 2024), second only to Telangana; agriculture 26% of AP's guarantees.",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "The Print (18 Apr 2024, pre-poll): \"nearly everyone avails DBT schemes\" yet voters were split, with anxiety over jobs and cost of living and low overall economic activity — DBT saturation did not translate into a vote; YSRCP lost 140 seats. The single largest counter-case in this file to \"cash buys elections\".",
        "tier": "reported",
        "srcs": [
          [
            "The Print, 18 Apr 2024: As Jagan banks on direct benefit schemes in AP, voters split",
            "https://theprint.in/politics/as-jagan-banks-on-direct-benefit-schemes-in-ap-voters-split-anxiety-over-jobs-cost-of-living/2046063/"
          ],
          [
            "Wikipedia infobox (pointer to ECI): 2024 Andhra Pradesh Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:ys-jagan-mohan-reddy",
        "role": "Chief Minister, Andhra Pradesh",
        "action": "announced",
        "date": "2019-10-15",
        "party": "YSRCP",
        "srcs": [
          [
            "ClearTax — YSR Rythu Bharosa",
            "https://cleartax.in/s/ysr-rythu-bharosa-scheme"
          ]
        ]
      },
      {
        "personId": "wel:ys-jagan-mohan-reddy",
        "role": "Chief Minister, Andhra Pradesh",
        "action": "announced",
        "date": "2019-10-15",
        "party": "YSRCP",
        "srcs": [
          [
            "Govt Schemes India — YSR Rythu Bharosa: launched 15 Oct 2019; ₹13,500/yr per farmer family (₹7,500 state + ₹6,000 PM-KISAN)",
            "https://www.govtschemes.in/ysr-rythu-bharosa-scheme"
          ],
          [
            "YSR Congress Party — YSR Rythu Bharosa: all you need to know (party source; launch 15 Oct at Kakaturu, Nellore; ₹13,500 incl. ₹6,000 PM-KISAN)",
            "https://www.ysrcongress.com/special-news/ysr-rythu-bharosa-all-you-need-69738"
          ]
        ]
      },
      {
        "personId": "wel:n-chandrababu-naidu",
        "role": "Chief Minister, Andhra Pradesh",
        "action": "approved",
        "date": "2024-06",
        "party": "TDP",
        "srcs": [
          [
            "PRS, Andhra Pradesh Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "AP village/ward volunteer system",
        "how": "doorstep delivery apparatus for Navasakam DBTs (see vendors.json scheme:ap-village-volunteers)",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "The Print, 18 Apr 2024: As Jagan banks on direct benefit schemes in AP, voters split",
            "https://theprint.in/politics/as-jagan-banks-on-direct-benefit-schemes-in-ap-voters-split-anxiety-over-jobs-cost-of-living/2046063/"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "ClearTax — YSR Rythu Bharosa",
        "https://cleartax.in/s/ysr-rythu-bharosa-scheme"
      ],
      [
        "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
        "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "PRS, Andhra Pradesh Budget Analysis 2023-24",
        "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2023-24"
      ],
      [
        "PRS, Andhra Pradesh Budget Analysis 2024-25",
        "https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2024-25"
      ],
      [
        "The Print, 18 Apr 2024: As Jagan banks on direct benefit schemes in AP, voters split",
        "https://theprint.in/politics/as-jagan-banks-on-direct-benefit-schemes-in-ap-voters-split-anxiety-over-jobs-cost-of-living/2046063/"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2024 Andhra Pradesh Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"
      ],
      [
        "Govt Schemes India — YSR Rythu Bharosa: launched 15 Oct 2019; ₹13,500/yr per farmer family (₹7,500 state + ₹6,000 PM-KISAN)",
        "https://www.govtschemes.in/ysr-rythu-bharosa-scheme"
      ],
      [
        "YSR Congress Party — YSR Rythu Bharosa: all you need to know (party source; launch 15 Oct at Kakaturu, Nellore; ₹13,500 incl. ₹6,000 PM-KISAN)",
        "https://www.ysrcongress.com/special-news/ysr-rythu-bharosa-all-you-need-69738"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:as-orunodoi",
    "name": "Orunodoi",
    "al": [
      "Arunodoi",
      "অৰুণোদয়"
    ],
    "level": "state",
    "st": "as",
    "applicableStates": null,
    "category": "women-cash",
    "party": "BJP",
    "announced": {
      "date": "2020-12-01",
      "byPersonId": "pol:sarbananda-sonowal",
      "office": "Chief Minister, Assam",
      "srcs": [
        [
          "Organiser — Orunodoi scheme launched in Assam",
          "https://organiser.org/2020/12/02/132039/bharat/orunodoi-scheme-launched-in-assam-to-empower-women/"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Assam Cabinet",
      "srcs": [
        [
          "ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month",
          "https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"
        ]
      ]
    },
    "launched": {
      "date": "2020-12-01",
      "srcs": [
        [
          "Organiser — Orunodoi scheme launched in Assam",
          "https://organiser.org/2020/12/02/132039/bharat/orunodoi-scheme-launched-in-assam-to-empower-women/"
        ]
      ]
    },
    "benefit": {
      "amount": 830,
      "unit": "₹ per month per household, paid to a woman member",
      "changes": [
        {
          "date": null,
          "amount": 1250,
          "note": "Raised to Rs 1,250 by Orunodoi 3.0 (Sep 2024); intermediate Rs 1,000 step date not verified",
          "srcs": [
            [
              "ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month",
              "https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"
            ]
          ]
        },
        {
          "date": "2026",
          "amount": 1250,
          "note": "Logical Indian (May 2026): Rs 1,250 to ~40 lakh women plus a Rs 10,000 initial assistance; Congress promised Rs 50,000",
          "srcs": [
            [
              "The Logical Indian, 4 May 2026: fiscal reality behind 2026 cash promises to women",
              "https://thelogicalindian.com/elections-results-2026-the-fiscal-reality-behind-indias-cash-promises-to-women/"
            ]
          ]
        }
      ]
    },
    "eligibility": "economically weaker households, one female beneficiary per household",
    "beneficiaries": [
      {
        "asOf": "2020-12-01",
        "count": 1800000,
        "srcs": [
          [
            "Organiser — Orunodoi scheme launched in Assam",
            "https://organiser.org/2020/12/02/132039/bharat/orunodoi-scheme-launched-in-assam-to-empower-women/"
          ]
        ]
      },
      {
        "asOf": "2024-09",
        "count": 2460000,
        "srcs": [
          [
            "ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month",
            "https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"
          ]
        ]
      },
      {
        "asOf": "2025-01",
        "count": 3720000,
        "srcs": [
          [
            "ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month",
            "https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"
          ]
        ]
      },
      {
        "asOf": "2026-05",
        "count": 4000000,
        "srcs": [
          [
            "The Logical Indian, 4 May 2026: fiscal reality behind 2026 cash promises to women",
            "https://thelogicalindian.com/elections-results-2026-the-fiscal-reality-behind-indias-cash-promises-to-women/"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2020-21",
        "budgetedCr": 2800,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Organiser — Orunodoi scheme launched in Assam",
            "https://organiser.org/2020/12/02/132039/bharat/orunodoi-scheme-launched-in-assam-to-empower-women/"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 5000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "fy": "2024-25",
        "budgetedCr": 5604,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month",
            "https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 5000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Assam assembly",
      "date": "2021-03-27",
      "monthsFromLaunch": 4,
      "incumbentParty": "BJP",
      "result": "incumbent won",
      "seatChange": null,
      "srcs": [
        [
          "Deccan Herald — BJP-led Assam govt launches Orunodoi ahead of polls",
          "https://www.deccanherald.com/amp/story/india%2Fbjp-led-assam-govt-launches-cash-transfer-scheme-orunodoi-ahead-of-assembly-elections-922119.html"
        ]
      ]
    },
    "status": [
      {
        "date": "2026-04-09",
        "status": "live",
        "note": "Continued through the 2026 Assam election, which BJP also won in a landslide (82/126 seats).",
        "srcs": [
          [
            "Wikipedia — 2026 Assam Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2026_Assam_Legislative_Assembly_election"
          ]
        ]
      },
      {
        "date": "2020-12",
        "status": "live",
        "note": "Rs 830",
        "srcs": [
          [
            "ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month",
            "https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"
          ]
        ]
      },
      {
        "date": "2024-09-19",
        "status": "raised",
        "note": "Orunodoi 3.0: Rs 1,250, 37.2 lakh; promised on the eve of LS 2024 and delivered 'within 100 days'",
        "srcs": [
          [
            "ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month",
            "https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"
          ]
        ]
      },
      {
        "date": "2024-09-19",
        "status": "eligibility-tightened",
        "note": "Existing 1.0/2.0 beneficiaries must reapply; ration card mandatory",
        "srcs": [
          [
            "ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month",
            "https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Contemporary press explicitly framed the December 2020 launch, four months before polling, as election-timed ('BJP-led Assam govt launches cash transfer scheme Orunodoi ahead of assembly elections' — the headline itself, not this file's inference). BJP won both the 2021 and 2026 elections with the scheme in place; the innocent reading is that Assam has had a strong BJP structural advantage in this period (2016, 2021, 2026 all BJP wins) independent of any one scheme, so the scheme's marginal contribution cannot be isolated from this file's data alone.",
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald — BJP-led Assam govt launches Orunodoi ahead of polls",
            "https://www.deccanherald.com/amp/story/india%2Fbjp-led-assam-govt-launches-cash-transfer-scheme-orunodoi-ahead-of-assembly-elections-922119.html"
          ]
        ]
      },
      {
        "finding": "PRS (Oct 2025): BE 2025-26 ₹5,000 cr = 4.3% of revenue expenditure, 4.3% of revenue receipts.",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "PRS: Assam raised its UCT allocation 31% over 2024-25 RE.",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "Oldest scheme in the file (2020) and the only one to span two winning assembly elections (2021, 2026) for the same party",
        "tier": "analytic",
        "srcs": [
          [
            "Wikipedia infobox (pointer to ECI results): 2021 Assam Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2021_Assam_Legislative_Assembly_election"
          ],
          [
            "India TV, 4 May 2026: Assam 2026 result — BJP 82 seats",
            "https://www.indiatvnews.com/north-east/assam/assam-election-result-2026-live-updates-himanta-biswa-sarma-led-bjp-wins-setback-for-congress-1039454"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:sarbananda-sonowal",
        "role": "Chief Minister, Assam",
        "action": "announced",
        "date": "2020-12-01",
        "party": "BJP",
        "srcs": [
          [
            "Organiser — Orunodoi scheme launched in Assam",
            "https://organiser.org/2020/12/02/132039/bharat/orunodoi-scheme-launched-in-assam-to-empower-women/"
          ]
        ]
      },
      {
        "personId": "wel:himanta-biswa-sarma",
        "role": "Chief Minister, Assam",
        "action": "administers",
        "date": "2021-05-10",
        "party": "BJP",
        "srcs": []
      },
      {
        "personId": "wel:himanta-biswa-sarma",
        "role": "Finance Minister → Chief Minister",
        "action": "presented budget",
        "date": "2020-03",
        "party": "BJP",
        "srcs": [
          [
            "ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month",
            "https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"
          ]
        ]
      },
      {
        "personId": "pol:sarbananda-sonowal",
        "role": "Chief Minister",
        "action": "administers",
        "date": "2020-12",
        "party": "BJP",
        "srcs": [
          [
            "ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month",
            "https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"
          ]
        ]
      },
      {
        "personId": "wel:himanta-biswa-sarma",
        "role": "Chief Minister",
        "action": "administers",
        "date": "2021-05-10",
        "party": "BJP",
        "srcs": [
          [
            "ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month",
            "https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "bjp",
        "how": "political: 3.0 expansion (12.6 lakh, ~10,000 per constituency) delivered as an LS-2024 promise 20 months before the 2026 assembly poll",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month",
            "https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Organiser — Orunodoi scheme launched in Assam",
        "https://organiser.org/2020/12/02/132039/bharat/orunodoi-scheme-launched-in-assam-to-empower-women/"
      ],
      [
        "Deccan Herald — BJP-led Assam govt launches Orunodoi ahead of polls",
        "https://www.deccanherald.com/amp/story/india%2Fbjp-led-assam-govt-launches-cash-transfer-scheme-orunodoi-ahead-of-assembly-elections-922119.html"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month",
        "https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "India TV, 4 May 2026: Assam 2026 result — BJP 82 seats",
        "https://www.indiatvnews.com/north-east/assam/assam-election-result-2026-live-updates-himanta-biswa-sarma-led-bjp-wins-setback-for-congress-1039454"
      ],
      [
        "The Logical Indian, 4 May 2026: fiscal reality behind 2026 cash promises to women",
        "https://thelogicalindian.com/elections-results-2026-the-fiscal-reality-behind-indias-cash-promises-to-women/"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:br-balika-cycle",
    "name": "Mukhyamantri Balika Cycle Yojana (Bihar)",
    "al": [
      "Bihar cycle scheme",
      "Balika Cycle Yojana",
      "Cycle Yojana",
      "मुख्यमंत्री बालिका साइकिल योजना"
    ],
    "level": "state",
    "st": "br",
    "applicableStates": null,
    "category": "student",
    "party": "JD(U)–BJP (Nitish Kumar government)",
    "announced": {
      "date": "2006",
      "byPersonId": "wel:nitish-kumar",
      "office": "Chief Minister, Bihar",
      "srcs": [
        [
          "Nitish Kumar's blog, Apr 2010: Mukhyamantri Balika Cycle Yojna",
          "http://nitishspeaks.blogspot.com/2010/04/mukhyamantri-balika-cycle-yojna.html"
        ],
        [
          "Muralidharan & Prakash (2017), 'Cycling to School', AEJ: Applied Economics 9(3) — AEA abstract page",
          "https://www.aeaweb.org/articles?id=10.1257/app.20160004"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Bihar cabinet — date not verified in an opened source",
      "srcs": []
    },
    "launched": {
      "date": "2006",
      "srcs": [
        [
          "Nitish Kumar's blog, Apr 2010: Mukhyamantri Balika Cycle Yojna",
          "http://nitishspeaks.blogspot.com/2010/04/mukhyamantri-balika-cycle-yojna.html"
        ],
        [
          "Muralidharan & Prakash (2017), 'Cycling to School', AEJ: Applied Economics 9(3) — AEA abstract page",
          "https://www.aeaweb.org/articles?id=10.1257/app.20160004"
        ]
      ]
    },
    "benefit": {
      "amount": 3000,
      "unit": "₹ per female student (RBI Annex 1, 2022-23)",
      "changes": [
        {
          "date": "2019-02",
          "amount": 3000,
          "note": "Raised from Rs 2,500 to Rs 3,000 in the 2019-20 budget (Mukhyamantri Balak-Balika Cycle Yojana); uniform grant also raised",
          "srcs": [
            [
              "PRS, Bihar Budget Analysis 2019-20",
              "https://prsindia.org/budgets/states/bihar-budget-analysis-2019-20"
            ]
          ]
        }
      ]
    },
    "eligibility": "Girls enrolling in secondary school (class 9) in Bihar",
    "beneficiaries": [],
    "outlay": [
      {
        "fy": "2022-23",
        "budgetedCr": 200,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": 0,
        "srcs": [
          [
            "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
            "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Bihar assembly",
      "date": "2010-10-21",
      "monthsFromLaunch": 50,
      "incumbentParty": "JD(U)-BJP",
      "result": "incumbent won",
      "seatChange": "JD(U) +27 (115), BJP +36 (91) of 243",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI): 2010 Bihar Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2010_Bihar_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2006",
        "status": "live",
        "note": "",
        "srcs": [
          [
            "Nitish Kumar's blog, Apr 2010: Mukhyamantri Balika Cycle Yojna",
            "http://nitishspeaks.blogspot.com/2010/04/mukhyamantri-balika-cycle-yojna.html"
          ]
        ]
      },
      {
        "date": "2019-02",
        "status": "raised",
        "note": "Rs 3,000; boys included",
        "srcs": [
          [
            "PRS, Bihar Budget Analysis 2019-20",
            "https://prsindia.org/budgets/states/bihar-budget-analysis-2019-20"
          ]
        ]
      },
      {
        "date": "2025-11",
        "status": "live",
        "note": "Still running at the Nov 2025 poll which the NDA won (fleet file, women-cash.json)",
        "srcs": [
          [
            "Wikipedia infobox (pointer to ECI results): 2025 Bihar Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2025_Bihar_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Muralidharan & Prakash (AEJ: Applied, 2017): exposure to the Cycle programme raised girls' age-appropriate secondary enrolment by 32% and cut the gender gap by 40%; +18% girls appearing and +12% passing the secondary certificate exam; gains concentrated in villages far from a secondary school; more cost-effective than comparable South Asian CCTs. Method: triple difference (boys and neighbouring Jharkhand as comparisons) — NOT a randomised trial, contrary to how it is often described (including in this sweep's brief).",
        "tier": "documented",
        "srcs": [
          [
            "Muralidharan & Prakash, 'Cycling to School: Increasing Secondary School Enrollment for Girls in India', AEJ: Applied Economics 9(3), Jul 2017 — abstract",
            "https://www.aeaweb.org/articles?id=10.1257/app.20160004"
          ]
        ]
      },
      {
        "finding": "RBI (Jun 2022) nonetheless listed the scheme in its 2022-23 'freebies' annex — the same table used to warn about fiscal risk. An in-kind transfer with one of the strongest causal evaluations in Indian social policy sits in the 'freebie' column: the category does not discriminate between effective and ineffective spending.",
        "tier": "analytic",
        "srcs": [
          [
            "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
            "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
          ],
          [
            "Muralidharan & Prakash, 'Cycling to School: Increasing Secondary School Enrollment for Girls in India', AEJ: Applied Economics 9(3), Jul 2017 — abstract",
            "https://www.aeaweb.org/articles?id=10.1257/app.20160004"
          ]
        ]
      },
      {
        "finding": "Muralidharan & Prakash (AEJ: Applied 2017): the conditional in-kind transfer raised girls’ secondary-school enrolment and narrowed the gender gap, most where schools were far — the reference case for a state ‘distribution’ scheme with a rigorous positive human-capital evaluation; effect sizes not re-read in this sweep.",
        "tier": "reported",
        "srcs": [
          [
            "Muralidharan & Prakash (2017) Cycling to School: Increasing Secondary School Enrollment for Girls in India — AEJ: Applied 9(3):321–350 (Crossref metadata)",
            "https://api.crossref.org/works/10.1257/app.20160004"
          ]
        ]
      },
      {
        "finding": "Muralidharan & Prakash (AEJ: Applied 2017), triple-difference vs boys and Jharkhand: exposure raised girls' age-appropriate secondary enrolment by 32% and cut the gender gap by 40%; +18% girls appearing for the class-X board exam, +12% passing; effects concentrated in villages far from a secondary school (distance mechanism); more cost-effective than comparable CCTs.",
        "tier": "documented",
        "srcs": [
          [
            "Muralidharan & Prakash (2017), 'Cycling to School', AEJ: Applied Economics 9(3) — AEA abstract page",
            "https://www.aeaweb.org/articles?id=10.1257/app.20160004"
          ]
        ]
      },
      {
        "finding": "Innocent reading is the dominant one: a small, conditional, in-kind-equivalent transfer with a peer-reviewed causal effect, launched post-poll and 50 months before the next election; also used politically as \"cycle wali sarkar\" branding (analytic).",
        "tier": "analytic",
        "srcs": [
          [
            "Muralidharan & Prakash (2017), 'Cycling to School', AEJ: Applied Economics 9(3) — AEA abstract page",
            "https://www.aeaweb.org/articles?id=10.1257/app.20160004"
          ],
          [
            "Nitish Kumar's blog, Apr 2010: Mukhyamantri Balika Cycle Yojna",
            "http://nitishspeaks.blogspot.com/2010/04/mukhyamantri-balika-cycle-yojna.html"
          ],
          [
            "Wikipedia infobox (pointer to ECI): 2010 Bihar Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2010_Bihar_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:nitish-kumar",
        "role": "Chief Minister, Bihar",
        "action": "announced",
        "date": "2006",
        "party": "JD(U)",
        "srcs": [
          [
            "Nitish Kumar's blog, Apr 2010: Mukhyamantri Balika Cycle Yojna",
            "http://nitishspeaks.blogspot.com/2010/04/mukhyamantri-balika-cycle-yojna.html"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "bicycle manufacturers/dealers",
        "how": "demand created for ~1.6 lakh cycles/yr at Rs 2,000–3,000 each (cash, so no tender)",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "PRS, Bihar Budget Analysis 2019-20",
            "https://prsindia.org/budgets/states/bihar-budget-analysis-2019-20"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Muralidharan & Prakash, 'Cycling to School: Increasing Secondary School Enrollment for Girls in India', AEJ: Applied Economics 9(3), Jul 2017 — abstract",
        "https://www.aeaweb.org/articles?id=10.1257/app.20160004"
      ],
      [
        "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
        "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
      ],
      [
        "Muralidharan & Prakash (2017) Cycling to School: Increasing Secondary School Enrollment for Girls in India — AEJ: Applied 9(3):321–350 (Crossref metadata)",
        "https://api.crossref.org/works/10.1257/app.20160004"
      ],
      [
        "Nitish Kumar's blog, Apr 2010: Mukhyamantri Balika Cycle Yojna",
        "http://nitishspeaks.blogspot.com/2010/04/mukhyamantri-balika-cycle-yojna.html"
      ],
      [
        "Muralidharan & Prakash (2017), 'Cycling to School', AEJ: Applied Economics 9(3) — AEA abstract page",
        "https://www.aeaweb.org/articles?id=10.1257/app.20160004"
      ],
      [
        "PRS, Bihar Budget Analysis 2019-20",
        "https://prsindia.org/budgets/states/bihar-budget-analysis-2019-20"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2010 Bihar Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2010_Bihar_Legislative_Assembly_election"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): October 2005 Bihar Legislative Assembly election",
        "https://en.wikipedia.org/wiki/October_2005_Bihar_Legislative_Assembly_election"
      ]
    ],
    "domain": "fiscal-results"
  },
  {
    "id": "scheme:br-mahila-rozgar-yojana",
    "name": "Mukhyamantri Mahila Rozgar Yojana",
    "al": [
      "MMRY",
      "Mahila Rozgar Yojana"
    ],
    "level": "state",
    "st": "br",
    "applicableStates": null,
    "category": "women-cash",
    "party": "JD(U)",
    "announced": {
      "date": "2025-09-26",
      "byPersonId": "pol:narendra-modi",
      "office": "Prime Minister",
      "srcs": [
        [
          "Deccan Herald — Bihar Rs 10,000 cash transfer to women",
          "https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-rs-10000-cash-transfer-to-women-may-prove-game-changer-for-nitish-kumar-3773893"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Bihar Cabinet",
      "srcs": [
        [
          "PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women",
          "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"
        ]
      ]
    },
    "launched": {
      "date": "2025-09-26",
      "srcs": [
        [
          "Deccan Herald — Bihar Rs 10,000 cash transfer to women",
          "https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-rs-10000-cash-transfer-to-women-may-prove-game-changer-for-nitish-kumar-3773893"
        ]
      ]
    },
    "benefit": {
      "amount": 10000,
      "unit": "₹ one-time transfer per woman via self-help groups, for self-employment/enterprise; up to ₹2 lakh further assistance for enterprises that succeed",
      "changes": []
    },
    "eligibility": "women members of Jeevika self-help groups",
    "beneficiaries": [
      {
        "asOf": "2025-10-06",
        "count": 11000000,
        "srcs": [
          [
            "News on Air — Nitish transfers Rs 10,000 to 25 lakh women",
            "https://www.newsonair.gov.in/bihar-cm-nitish-kumar-transferred-%E2%82%B910000-each-to-25-lakh-women-under-the-mukhyamantri-mahila-rozgar-yojana-promoting-self-employment"
          ]
        ]
      },
      {
        "asOf": "2025-09-26",
        "count": 7500000,
        "srcs": [
          [
            "PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2025-26",
        "budgetedCr": 7500,
        "actualCr": 7500,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Bihar assembly",
      "date": "2025-11-06",
      "monthsFromLaunch": 1,
      "incumbentParty": "JD(U)-BJP (NDA)",
      "result": "incumbent won (landslide)",
      "seatChange": "NDA 202/243 seats (BJP 89, JD(U) 85, LJP(RV) 19), ~40%+ vote share",
      "srcs": [
        [
          "Deccan Herald — Bihar 2025 NDA wins 202 seats",
          "https://www.deccanherald.com/amp/story/elections%2Fbihar%2Fbihar-assembly-elections-2025-results-nda-cruises-to-victory-by-winning-202-seats-and-a-vote-share-of-over-40-3798063"
        ]
      ]
    },
    "status": [
      {
        "date": "2025-11-06",
        "status": "live",
        "note": "First tranche of ₹10,000 to 75 lakh women disbursed by the PM on 26 September 2025; CM Nitish Kumar disbursed further tranches to 25 lakh (3 Oct) and 21 lakh (6 Oct) women, all within six weeks of polling day.",
        "srcs": [
          [
            "News on Air — Nitish transfers Rs 10,000 to 21 lakh women",
            "https://newsonair.gov.in/cm-nitish-kumar-transfers-%E2%82%B910000-each-to-21-lakh-women-under-mahila-rozgar-yojana/"
          ]
        ]
      },
      {
        "date": "2025-09-26",
        "status": "live",
        "note": null,
        "srcs": [
          [
            "PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "This is the closest launch-to-poll gap of any scheme in this file (~6 weeks from first disbursement to first phase of polling), targeted at >1 crore women shortly before an election the incumbent then won by the largest NDA margin in Bihar since 2010 — the case that best fits the 'schemes launched right before elections decide them' narrative on the numbers alone.",
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald — Bihar Rs 10,000 cash transfer to women",
            "https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-rs-10000-cash-transfer-to-women-may-prove-game-changer-for-nitish-kumar-3773893"
          ]
        ]
      },
      {
        "finding": "Opposition parties and commentators characterised the scheme's timing as an inducement to vote; the government's position is that it is a continuation of Bihar's existing Jeevika self-help-group programme and self-employment policy, disbursed at the pace SHG verification allowed, and that the amount (₹10,000, below the ₹2,000 threshold the ECI treats as needing special scrutiny in isolated transfers) was consistent with the scheme design rather than newly invented for the poll.",
        "tier": "alleged",
        "srcs": [
          [
            "The Federal — Bihar pre-poll cash push sparks concerns over ECI neutrality",
            "https://thefederal.com/category/elections-2025/pre-poll-cash-transfers-in-bihar-raise-concerns-over-voter-influence-eci-neutrality-214703"
          ]
        ]
      },
      {
        "finding": "The largest single-day pre-poll transfer in this file: Rs 7,500 cr to 75 lakh women 10 days before the ECI schedule and ~6 weeks before polling; the incumbent went from 125 to 202 seats",
        "tier": "analytic",
        "srcs": [
          [
            "PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"
          ],
          [
            "PIB/ECI, 6 Oct 2025: General Election to the Legislative Assembly of Bihar, 2025 (schedule release)",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2175533"
          ],
          [
            "Deccan Herald, 15 Nov 2025: Bihar results — NDA 202 seats",
            "https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-results-nda-cruises-to-victory-by-winning-202-seats-and-a-vote-share-of-over-40-3798063"
          ]
        ]
      },
      {
        "finding": "Bihar is absent from PRS's 12-state UCT list because MMRY is a one-time grant, not a monthly UCT — classification, not scale, kept it out",
        "tier": "analytic",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:narendra-modi",
        "role": "Prime Minister",
        "action": "announced",
        "date": "2025-09-26",
        "party": "BJP",
        "srcs": [
          [
            "Deccan Herald — Bihar Rs 10,000 cash transfer to women",
            "https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-rs-10000-cash-transfer-to-women-may-prove-game-changer-for-nitish-kumar-3773893"
          ]
        ]
      },
      {
        "personId": "wel:nitish-kumar",
        "role": "Chief Minister, Bihar",
        "action": "administers",
        "date": "2025-10-03",
        "party": "JD(U)",
        "srcs": [
          [
            "News on Air — Nitish transfers Rs 10,000 to 21 lakh women",
            "https://newsonair.gov.in/cm-nitish-kumar-transfers-%E2%82%B910000-each-to-21-lakh-women-under-mahila-rozgar-yojana/"
          ]
        ]
      },
      {
        "personId": "wel:nitish-kumar",
        "role": "Chief Minister",
        "action": "announced",
        "date": "2025-09",
        "party": "JD(U)",
        "srcs": [
          [
            "PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"
          ]
        ]
      },
      {
        "personId": "pol:narendra-modi",
        "role": "Prime Minister",
        "action": "announced",
        "date": "2025-09-26",
        "party": "BJP",
        "srcs": [
          [
            "PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "Jeevika self-help-group network / bank correspondents handling disbursal",
        "how": "administrative fees and disbursal-channel role for the DBT rollout",
        "amountCr": null,
        "tier": "analytic",
        "srcs": []
      },
      {
        "who": "JEEVIKA (Bihar Rural Livelihoods Promotion Society) community resource persons",
        "how": "training and SHG intermediation mandated by the scheme design; no contract values found",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"
          ]
        ]
      },
      {
        "who": "party:jdu and bjp",
        "how": "political: launch by the PM six weeks before polling",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"
          ],
          [
            "Deccan Herald, 15 Nov 2025: Bihar results — NDA 202 seats",
            "https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-results-nda-cruises-to-victory-by-winning-202-seats-and-a-vote-share-of-over-40-3798063"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Deccan Herald — Bihar Rs 10,000 cash transfer to women",
        "https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-rs-10000-cash-transfer-to-women-may-prove-game-changer-for-nitish-kumar-3773893"
      ],
      [
        "The Federal — Bihar pre-poll cash push sparks concerns over ECI neutrality",
        "https://thefederal.com/category/elections-2025/pre-poll-cash-transfers-in-bihar-raise-concerns-over-voter-influence-eci-neutrality-214703"
      ],
      [
        "PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"
      ],
      [
        "PIB/ECI, 6 Oct 2025: General Election to the Legislative Assembly of Bihar, 2025 (schedule release)",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2175533"
      ],
      [
        "Deccan Herald, 15 Nov 2025: Bihar results — NDA 202 seats",
        "https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-results-nda-cruises-to-victory-by-winning-202-seats-and-a-vote-share-of-over-40-3798063"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:ct-cheap-rice-2007",
    "name": "Chhattisgarh ₹1–2/kg rice (Mukhyamantri Khadyann Sahayata; Chhattisgarh Food Security Act 2012)",
    "al": [
      "Chaur wale baba scheme",
      "Re 1 rice",
      "Rs 2 rice"
    ],
    "level": "state",
    "st": "ct",
    "applicableStates": null,
    "category": "grain",
    "party": "BJP",
    "announced": {
      "date": null,
      "byPersonId": "wel:raman-singh",
      "office": "Chief Minister, Chhattisgarh",
      "srcs": [
        [
          "Business Standard, 13 Nov 2013: Politics over rice in Chhattisgarh",
          "https://www.business-standard.com/article/politics/politics-over-rice-in-chhattisgarh-113111300355_1.html"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": null,
      "srcs": []
    },
    "launched": {
      "date": null,
      "srcs": []
    },
    "benefit": {
      "amount": 35,
      "unit": "kg rice per month per BPL card at Rs 2/kg (Antyodaya Rs 1/kg) by 2013; 2013 BJP manifesto: Rs 1/kg for all",
      "changes": [
        {
          "date": "2019",
          "amount": 35,
          "note": "Congress government: 35 kg rice per ration card under a CM food security programme, Rs 4,000 cr (2019-20) — supersession by the successor party's own scheme",
          "srcs": [
            [
              "PRS, Chhattisgarh Budget Analysis 2019-20",
              "https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2019-20"
            ]
          ]
        }
      ]
    },
    "eligibility": "Antyodaya and BPL ration-card households; extended by the state Food Security Act 2012",
    "beneficiaries": [],
    "outlay": [
      {
        "fy": "2019-20 (successor scheme)",
        "budgetedCr": 4000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Chhattisgarh Budget Analysis 2019-20",
            "https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2019-20"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Chhattisgarh assembly",
      "date": "2008-11-14",
      "monthsFromLaunch": null,
      "incumbentParty": "BJP",
      "result": "incumbent won",
      "seatChange": "BJP 50 of 90 (unchanged); 40.33%",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI): 2008 Chhattisgarh Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2008_Chhattisgarh_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2013-11",
        "status": "live",
        "note": "BJP promised Rs 1/kg for all; Congress promised 35 kg free to BPL and non-taxpaying APL",
        "srcs": [
          [
            "Business Standard, 13 Nov 2013: Politics over rice in Chhattisgarh",
            "https://www.business-standard.com/article/politics/politics-over-rice-in-chhattisgarh-113111300355_1.html"
          ]
        ]
      },
      {
        "date": "2018-12",
        "status": "live",
        "note": "BJP lost 2018 (INC 68/90) despite the scheme; Congress re-badged it as 35 kg per card",
        "srcs": [
          [
            "PRS, Chhattisgarh Budget Analysis 2019-20",
            "https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2019-20"
          ],
          [
            "Wikipedia infobox (pointer to ECI results): 2018 Chhattisgarh Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2018_Chhattisgarh_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Business Standard (2013): Raman Singh known as \"Chaur wale baba\"; villagers \"express satisfaction\" with PDS reform; both parties bid on rice. The scheme ran through two wins (2008, 2013) and a loss (2018) — a long-lived in-kind transfer whose electoral effect cannot be separated from PDS delivery reform (the Chhattisgarh PDS computerisation is widely studied).",
        "tier": "analytic",
        "srcs": [
          [
            "Business Standard, 13 Nov 2013: Politics over rice in Chhattisgarh",
            "https://www.business-standard.com/article/politics/politics-over-rice-in-chhattisgarh-113111300355_1.html"
          ],
          [
            "Wikipedia infobox (pointer to ECI): 2008 Chhattisgarh Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2008_Chhattisgarh_Legislative_Assembly_election"
          ],
          [
            "Wikipedia infobox (pointer to ECI): 2013 Chhattisgarh Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2013_Chhattisgarh_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:raman-singh",
        "role": "Chief Minister, Chhattisgarh",
        "action": "announced",
        "date": "2007",
        "party": "BJP",
        "srcs": [
          [
            "Business Standard, 13 Nov 2013: Politics over rice in Chhattisgarh",
            "https://www.business-standard.com/article/politics/politics-over-rice-in-chhattisgarh-113111300355_1.html"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "rice millers and fair-price-shop network",
        "how": "custom-milling and PDS margin economy expanded by universalised cheap rice",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "Business Standard, 13 Nov 2013: Politics over rice in Chhattisgarh",
            "https://www.business-standard.com/article/politics/politics-over-rice-in-chhattisgarh-113111300355_1.html"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Business Standard, 13 Nov 2013: Politics over rice in Chhattisgarh",
        "https://www.business-standard.com/article/politics/politics-over-rice-in-chhattisgarh-113111300355_1.html"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2008 Chhattisgarh Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2008_Chhattisgarh_Legislative_Assembly_election"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2013 Chhattisgarh Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2013_Chhattisgarh_Legislative_Assembly_election"
      ],
      [
        "PRS, Chhattisgarh Budget Analysis 2019-20",
        "https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2019-20"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2018 Chhattisgarh Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2018_Chhattisgarh_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:ct-farm-loan-waiver-2018",
    "name": "Chhattisgarh farm loan waiver (2018)",
    "al": [],
    "level": "state",
    "st": "ct",
    "applicableStates": null,
    "category": "loan-waiver",
    "party": "INC",
    "announced": {
      "date": "2018-12-17",
      "byPersonId": "wel:bhupesh-baghel",
      "office": "Chief Minister, Chhattisgarh",
      "srcs": [
        [
          "National Herald — Chhattisgarh Rs 6,100-cr loan waiver",
          "https://www.nationalheraldindia.com/national/chhattisgarh-cm-bhupesh-baghel-announces-indian-rupee6100-cr-farm-loan-waiver"
        ]
      ]
    },
    "approved": {
      "date": "2018-12-17",
      "body": "First cabinet decision of the new Congress government",
      "srcs": [
        [
          "National Herald — Chhattisgarh Rs 6,100-cr loan waiver",
          "https://www.nationalheraldindia.com/national/chhattisgarh-cm-bhupesh-baghel-announces-indian-rupee6100-cr-farm-loan-waiver"
        ]
      ]
    },
    "launched": {
      "date": "2018-12-17",
      "srcs": [
        [
          "National Herald — Chhattisgarh Rs 6,100-cr loan waiver",
          "https://www.nationalheraldindia.com/national/chhattisgarh-cm-bhupesh-baghel-announces-indian-rupee6100-cr-farm-loan-waiver"
        ]
      ]
    },
    "benefit": {
      "amount": 6100,
      "unit": "₹ crore total waiver",
      "changes": []
    },
    "eligibility": "indebted farmers (co-operative and some nationalised bank loans)",
    "beneficiaries": [
      {
        "asOf": "2018-12-17",
        "count": 1665000,
        "srcs": [
          [
            "National Herald — Chhattisgarh Rs 6,100-cr loan waiver",
            "https://www.nationalheraldindia.com/national/chhattisgarh-cm-bhupesh-baghel-announces-indian-rupee6100-cr-farm-loan-waiver"
          ]
        ]
      },
      {
        "asOf": "2018-12-17",
        "count": 1660000,
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ]
        ]
      },
      {
        "asOf": "2020-05",
        "count": 1800000,
        "srcs": [
          [
            "National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21",
            "https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2018-19",
        "budgetedCr": 6100,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "National Herald — Chhattisgarh Rs 6,100-cr loan waiver",
            "https://www.nationalheraldindia.com/national/chhattisgarh-cm-bhupesh-baghel-announces-indian-rupee6100-cr-farm-loan-waiver"
          ]
        ]
      },
      {
        "fy": "2018-19 (announced)",
        "budgetedCr": 6100,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ]
        ]
      },
      {
        "fy": "2019-20",
        "budgetedCr": 5000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Chhattisgarh Budget Analysis 2019-20",
            "https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2019-20"
          ]
        ]
      },
      {
        "fy": "cumulative to 2020-05",
        "budgetedCr": null,
        "actualCr": 8800,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21",
            "https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Chhattisgarh assembly (next, after this delivery of a pre-poll promise)",
      "date": "2023-11-07",
      "monthsFromLaunch": 59,
      "incumbentParty": "INC",
      "result": "incumbent lost",
      "seatChange": "INC lost to BJP",
      "srcs": [
        [
          "National Herald — Chhattisgarh Rs 6,100-cr loan waiver",
          "https://www.nationalheraldindia.com/national/chhattisgarh-cm-bhupesh-baghel-announces-indian-rupee6100-cr-farm-loan-waiver"
        ]
      ]
    },
    "status": [
      {
        "date": "2018-12-17",
        "status": "live",
        "note": "",
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ]
        ]
      },
      {
        "date": "2020-05",
        "status": "live",
        "note": "Rs 8,800 cr waived for ~18 lakh farmers",
        "srcs": [
          [
            "National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21",
            "https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "This is the promise-delivered-immediately-after-winning pattern, not the promise-timed-before-an-election pattern: Congress waived the loans as literally its first act in office, five years before the election in which it then lost. Useful contrast case against any simple 'scheme timing determines outcome' reading — the same government that made good on this promise still lost the next election on a five-year time horizon.",
        "tier": "analytic",
        "srcs": []
      },
      {
        "finding": "One of three same-week Congress waivers (MP 17 Dec, CT 17 Dec, RJ 19 Dec 2018) delivered as post-poll promises; RBI's IWG (Sep 2019) found waivers cluster near elections, damage credit culture and squeeze productive farm investment. All three governments lost in 2023 (MP's fell in 2020).",
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ],
          [
            "PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)",
            "https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"
          ],
          [
            "Wikipedia infobox (pointer to ECI): 2023 Chhattisgarh Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:bhupesh-baghel",
        "role": "Chief Minister, Chhattisgarh",
        "action": "approved",
        "date": "2018-12-17",
        "party": "INC",
        "srcs": [
          [
            "National Herald — Chhattisgarh Rs 6,100-cr loan waiver",
            "https://www.nationalheraldindia.com/national/chhattisgarh-cm-bhupesh-baghel-announces-indian-rupee6100-cr-farm-loan-waiver"
          ]
        ]
      },
      {
        "personId": "wel:bhupesh-baghel",
        "role": "Chief Minister, Chhattisgarh",
        "action": "approved",
        "date": "2018-12-17",
        "party": "INC",
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "cooperative and nationalised banks",
        "how": "NPA cleanup funded by the state exchequer",
        "amountCr": 6100,
        "tier": "analytic",
        "srcs": []
      },
      {
        "who": "cooperative and commercial banks",
        "how": "overdue crop loans paid by the state",
        "amountCr": 8800,
        "tier": "reported",
        "srcs": [
          [
            "National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21",
            "https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"
          ],
          [
            "PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)",
            "https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "National Herald — Chhattisgarh Rs 6,100-cr loan waiver",
        "https://www.nationalheraldindia.com/national/chhattisgarh-cm-bhupesh-baghel-announces-indian-rupee6100-cr-farm-loan-waiver"
      ],
      [
        "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
        "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
      ],
      [
        "PRS, Chhattisgarh Budget Analysis 2019-20",
        "https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2019-20"
      ],
      [
        "National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21",
        "https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2023 Chhattisgarh Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2018 Chhattisgarh Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2018_Chhattisgarh_Legislative_Assembly_election"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:ct-mahtari-vandan",
    "name": "Mahtari Vandan Yojana",
    "al": [
      "Mahatari Vandana",
      "महतारी वंदन"
    ],
    "level": "state",
    "st": "ct",
    "applicableStates": null,
    "category": "women-cash",
    "party": "BJP",
    "announced": {
      "date": "2023-11",
      "byPersonId": "pol:narendra-modi",
      "office": "Prime Minister ('Modi ki guarantee' in the Nov 2023 Chhattisgarh campaign)",
      "srcs": [
        [
          "PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr",
          "https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"
        ]
      ]
    },
    "approved": {
      "date": "2024-02-02",
      "body": "WCD Department, Chhattisgarh — Order No F 3-23/2023/50 (PRS fn.14)",
      "srcs": [
        [
          "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
          "https://prsindia.org/files/budget/SOSF_2025.pdf"
        ]
      ]
    },
    "launched": {
      "date": "2024-03-10",
      "srcs": [
        [
          "PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr",
          "https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"
        ]
      ]
    },
    "benefit": {
      "amount": 1000,
      "unit": "₹ per month",
      "changes": []
    },
    "eligibility": "Married women over 21 (PRS Table 6)",
    "beneficiaries": [
      {
        "asOf": "2024-03-10",
        "count": 7000000,
        "srcs": [
          [
            "PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2025-26",
        "budgetedCr": 5500,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 5500,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Chhattisgarh assembly",
      "date": "2023-11-17",
      "monthsFromLaunch": -4,
      "incumbentParty": "INC",
      "result": "challenger (BJP) won on the promise; launched 4 months after; ~5 weeks before Lok Sabha 2024 polling began",
      "seatChange": "BJP 54 (+39)",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI results): 2023 Chhattisgarh Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"
        ],
        [
          "PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr",
          "https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"
        ]
      ]
    },
    "status": [
      {
        "date": "2024-03-10",
        "status": "live",
        "note": null,
        "srcs": [
          [
            "PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "PRS (Oct 2025): BE 2025-26 ₹5,500 cr = 4.0% of revenue expenditure, 3.9% of revenue receipts.",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "Launch (10 Mar 2024) fell five weeks before Lok Sabha polling; the launch event doubled as a PM address listing central schemes",
        "tier": "analytic",
        "srcs": [
          [
            "PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:narendra-modi",
        "role": "Prime Minister",
        "action": "announced",
        "date": "2024-03-10",
        "party": "BJP",
        "srcs": [
          [
            "PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"
          ]
        ]
      },
      {
        "personId": "wel:vishnu-deo-sai",
        "role": "Chief Minister",
        "action": "administers",
        "date": "2023-12-13",
        "party": "BJP",
        "srcs": [
          [
            "PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "bjp",
        "how": "political: a state scheme launched by the PM and branded 'Modi ki guarantee' before a national poll",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr",
        "https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ]
    ],
    "domain": "fiscal-results"
  },
  {
    "id": "scheme:ct-rajiv-gandhi-kisan-nyay",
    "name": "Rajiv Gandhi Kisan Nyay Yojana",
    "al": [
      "RGKNY",
      "Kisan Nyay"
    ],
    "level": "state",
    "st": "ct",
    "applicableStates": null,
    "category": "farmer-cash",
    "party": "INC",
    "announced": {
      "date": "2020-05-18",
      "byPersonId": "wel:bhupesh-baghel",
      "office": "Chief Minister, Chhattisgarh",
      "srcs": [
        [
          "National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21",
          "https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"
        ]
      ]
    },
    "approved": {
      "date": "2020-03",
      "body": "Chhattisgarh budget 2020-21 (Rs 5,100 cr for paddy bonus under RGKNY)",
      "srcs": [
        [
          "PRS, Chhattisgarh Budget Analysis 2020-21",
          "https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2020-21"
        ]
      ]
    },
    "launched": {
      "date": "2020-05-21",
      "srcs": [
        [
          "National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21",
          "https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"
        ],
        [
          "Wikipedia (pointer): Rajiv Gandhi Kisan Nyay Yojana",
          "https://en.wikipedia.org/wiki/Rajiv_Gandhi_Kisan_Nyay_Yojana"
        ]
      ]
    },
    "benefit": {
      "amount": 10000,
      "unit": "₹ per acre per year input subsidy (paddy, maize, sugarcane initially; Rs 13,000 sugarcane per Wikipedia pointer), paid in four instalments on registered Kharif 2019 area",
      "changes": []
    },
    "eligibility": "Farmers with registered/procured area for paddy, maize, sugarcane (Kharif 2019); pulses and oilseeds added 2020-21 (Wikipedia pointer)",
    "beneficiaries": [
      {
        "asOf": "2020-05",
        "count": 2000000,
        "srcs": [
          [
            "National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21",
            "https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"
          ],
          [
            "Wikipedia (pointer): Rajiv Gandhi Kisan Nyay Yojana",
            "https://en.wikipedia.org/wiki/Rajiv_Gandhi_Kisan_Nyay_Yojana"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2020-21",
        "budgetedCr": 5100,
        "actualCr": 5750,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Chhattisgarh Budget Analysis 2020-21",
            "https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2020-21"
          ],
          [
            "Wikipedia (pointer): Rajiv Gandhi Kisan Nyay Yojana",
            "https://en.wikipedia.org/wiki/Rajiv_Gandhi_Kisan_Nyay_Yojana"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Chhattisgarh assembly",
      "date": "2023-11-07",
      "monthsFromLaunch": 41,
      "incumbentParty": "INC",
      "result": "incumbent lost",
      "seatChange": "BJP +39 (54 of 90), INC 35",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI): 2023 Chhattisgarh Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2020-05-21",
        "status": "live",
        "note": "Launched during the Covid lockdown as rural stimulus",
        "srcs": [
          [
            "National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21",
            "https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"
          ]
        ]
      },
      {
        "date": "2023-12",
        "status": "discontinued",
        "note": "BJP government replaced it with its own paddy-bonus arrangements (Krishak Unnati Yojana) — successor not verified in an opened source; recorded as supersession pending source",
        "srcs": []
      }
    ],
    "results": [
      {
        "finding": "A per-acre cash top-up on procurement, launched mid-term (41 months before the poll); the INC lost anyway while the BJP promised a higher paddy price and a two-year bonus. Innocent reading: lockdown-era rural stimulus and a way around the Centre's cap on state bonuses over MSP.",
        "tier": "analytic",
        "srcs": [
          [
            "National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21",
            "https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"
          ],
          [
            "Wikipedia infobox (pointer to ECI): 2023 Chhattisgarh Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:bhupesh-baghel",
        "role": "Chief Minister, Chhattisgarh",
        "action": "announced",
        "date": "2020-05-21",
        "party": "INC",
        "srcs": [
          [
            "National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21",
            "https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"
          ]
        ]
      },
      {
        "personId": "wel:vishnu-deo-sai",
        "role": "Chief Minister, Chhattisgarh",
        "action": "approved",
        "date": "2023-12",
        "party": "BJP",
        "srcs": [
          [
            "PRS, Chhattisgarh Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "rice millers / procurement chain",
        "how": "bonus tied to procured area sustains the state paddy procurement economy (analytic)",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "PRS, Chhattisgarh Budget Analysis 2020-21",
            "https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2020-21"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21",
        "https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"
      ],
      [
        "Wikipedia (pointer): Rajiv Gandhi Kisan Nyay Yojana",
        "https://en.wikipedia.org/wiki/Rajiv_Gandhi_Kisan_Nyay_Yojana"
      ],
      [
        "PRS, Chhattisgarh Budget Analysis 2020-21",
        "https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2020-21"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2023 Chhattisgarh Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:dbt-apb-pfms",
    "name": "Direct Benefit Transfer (Aadhaar Payment Bridge / PFMS rails)",
    "al": [
      "DBT",
      "JAM trinity",
      "APBS"
    ],
    "level": "central",
    "st": null,
    "applicableStates": "all",
    "category": "other",
    "party": "INC (2013 launch) → BJP (scaled 2014→)",
    "announced": {
      "date": "2013-01-01",
      "byPersonId": null,
      "office": "Government of India (UPA-II) — DBT started 1 Jan 2013",
      "srcs": [
        [
          "PIB backgrounder, Direct Benefit Transfer (DBT), Jan 2022",
          "https://static.pib.gov.in/WriteReadData/specificdocs/documents/2022/jan/doc2022153101.pdf"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": null,
      "srcs": []
    },
    "launched": {
      "date": "2013-01-01",
      "srcs": [
        [
          "PIB backgrounder, Direct Benefit Transfer (DBT), Jan 2022",
          "https://static.pib.gov.in/WriteReadData/specificdocs/documents/2022/jan/doc2022153101.pdf"
        ]
      ]
    },
    "benefit": {
      "amount": null,
      "unit": "rail, not a benefit — carries 300+ central and 2,000+ state schemes",
      "changes": []
    },
    "eligibility": "Any beneficiary of a DBT-enabled scheme with an Aadhaar-seeded bank/post-office account",
    "beneficiaries": [
      {
        "asOf": "2024-03-31",
        "count": 1760000000,
        "srcs": [
          [
            "PIB (Ministry of Finance), 'India's DBT: Boosting Welfare Efficiency' — BlueKraft assessment, 21 Apr 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2123192"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2021-22",
        "budgetedCr": null,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB backgrounder, Direct Benefit Transfer (DBT), Jan 2022",
            "https://static.pib.gov.in/WriteReadData/specificdocs/documents/2022/jan/doc2022153101.pdf"
          ]
        ]
      },
      {
        "fy": "2024-25",
        "budgetedCr": null,
        "actualCr": 690000,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB, PMJDY completes 11 years — ₹6.9 lakh crore DBT in FY2024-25, 28 Aug 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2161401"
          ]
        ]
      }
    ],
    "electionContext": null,
    "status": [
      {
        "date": "2013-01-01",
        "status": "live",
        "note": "started under UPA-II",
        "srcs": [
          [
            "PIB backgrounder, Direct Benefit Transfer (DBT), Jan 2022",
            "https://static.pib.gov.in/WriteReadData/specificdocs/documents/2022/jan/doc2022153101.pdf"
          ]
        ]
      },
      {
        "date": "2014-08-28",
        "status": "live",
        "note": "PMJDY launched; 56 crore accounts by Aug 2025 make the account rail near-universal",
        "srcs": [
          [
            "PIB, PMJDY completes 11 years — ₹6.9 lakh crore DBT in FY2024-25, 28 Aug 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2161401"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "BlueKraft Digital Foundation assessment (released by PIB, Apr 2025): cumulative 'savings' of ₹3.48 lakh crore, of which PDS ₹1.85 lakh crore, MGNREGS ₹42,534 crore, PM-KISAN ₹22,106 crore (2.1 crore ineligible deleted), fertiliser ₹18,699.8 crore; subsidies fell from 16% to 9% of expenditure. This is a think-tank estimate of 'estimated gains', not an audit.",
        "tier": "reported",
        "srcs": [
          [
            "PIB (Ministry of Finance), 'India's DBT: Boosting Welfare Efficiency' — BlueKraft assessment, 21 Apr 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2123192"
          ]
        ]
      },
      {
        "finding": "PFMS moved ₹36,659 crore to 16.01 crore beneficiaries during the 2020 lockdown; 500+ banks integrated",
        "tier": "documented",
        "srcs": [
          [
            "PIB backgrounder, Direct Benefit Transfer (DBT), Jan 2022",
            "https://static.pib.gov.in/WriteReadData/specificdocs/documents/2022/jan/doc2022153101.pdf"
          ]
        ]
      },
      {
        "finding": "UIDAI found in Dec 2017 that ₹190 crore of LPG (PAHAL) subsidy had been routed to ~31 lakh Airtel Payments Bank accounts opened/seeded without informed consent — the APB mapper's 'last-seeded bank wins' rule was the mechanism",
        "tier": "reported",
        "srcs": [
          [
            "The Wire, 'Aadhaar Mess: How Airtel Pulled Off Its Rs 190 Crore Magic Trick', 21 Dec 2017",
            "https://m.thewire.in/article/banking/airtel-aadhaar-uidai"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:narendra-modi",
        "role": "Prime Minister",
        "action": "administers",
        "date": "2014-05-26",
        "party": "BJP",
        "srcs": [
          [
            "PIB, PMJDY completes 11 years — ₹6.9 lakh crore DBT in FY2024-25, 28 Aug 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2161401"
          ]
        ]
      },
      {
        "personId": "pol:nirmala-sitharaman",
        "role": "Finance Minister",
        "action": "administers",
        "date": "2019-05-31",
        "party": "BJP",
        "srcs": [
          [
            "PIB, PMJDY completes 11 years — ₹6.9 lakh crore DBT in FY2024-25, 28 Aug 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2161401"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "wel:npci",
        "how": "APB/AePS switching and interchange on every DBT credit and cash-out; fee schedule not obtained",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "PIB backgrounder, Direct Benefit Transfer (DBT), Jan 2022",
            "https://static.pib.gov.in/WriteReadData/specificdocs/documents/2022/jan/doc2022153101.pdf"
          ]
        ]
      },
      {
        "who": "co:state-bank-of-india",
        "how": "Float on DBT balances in 56 crore PMJDY-type accounts (₹2.68 lakh crore deposits system-wide); SBI's bank-wise DBT share not published in sources opened",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "PIB, PMJDY completes 11 years — ₹6.9 lakh crore DBT in FY2024-25, 28 Aug 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2161401"
          ]
        ]
      },
      {
        "who": "wel:fino-payments-bank",
        "how": "AePS/micro-ATM cash-out of DBT credits at ~19 lakh merchant points: ₹39,704 crore throughput, ₹185 crore revenue FY25",
        "amountCr": 185,
        "tier": "documented",
        "srcs": [
          [
            "Fino Payments Bank, Annual Report 2024-25",
            "https://www.fino.bank.in/files/fino/media/post_attachments/sites/default/files/uploads/pages/financials/annual-report-2025.pdf"
          ]
        ]
      },
      {
        "who": "wel:csc-egovernance-services",
        "how": "DigiPay AePS: 0.5% of withdrawal value capped at ₹15/transaction, 80% claimed passed to VLEs",
        "amountCr": null,
        "tier": "reported",
        "srcs": [
          [
            "Moneylife, 'Is CSC e-Governance Services a govt entity or SPV or a Section 8 company?', 29 Jun 2018",
            "https://www.moneylife.in/article/is-csc-egovernance-services-a-govt-entity-or-spv-or-a-section-8-company/54524.html"
          ]
        ]
      },
      {
        "who": "wel:india-post-payments-bank",
        "how": "Doorstep DBT cash-out through 1.61 lakh post offices; ₹45,000+ crore DBT handled in 7 years",
        "amountCr": null,
        "tier": "reported",
        "srcs": [
          [
            "Free Press Journal, IPPB disbursed over ₹45,000 crore in DBT in 7 years (Scindia), 1 Sep 2024",
            "https://www.freepressjournal.in/business/india-post-payments-bank-disbursed-over-45000-crore-in-dbt-in-last-7-years"
          ]
        ]
      },
      {
        "who": "wel:airtel-payments-bank",
        "how": "₹190 crore of LPG subsidy credited to its accounts via APB mapper re-seeding (2017); ordered reversed",
        "amountCr": 190,
        "tier": "reported",
        "srcs": [
          [
            "The Wire, 'Aadhaar Mess: How Airtel Pulled Off Its Rs 190 Crore Magic Trick', 21 Dec 2017",
            "https://m.thewire.in/article/banking/airtel-aadhaar-uidai"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "PIB backgrounder, Direct Benefit Transfer (DBT), Jan 2022",
        "https://static.pib.gov.in/WriteReadData/specificdocs/documents/2022/jan/doc2022153101.pdf"
      ],
      [
        "PIB (Ministry of Finance), 'India's DBT: Boosting Welfare Efficiency' — BlueKraft assessment, 21 Apr 2025",
        "https://pib.gov.in/PressReleasePage.aspx?PRID=2123192"
      ],
      [
        "PIB, PMJDY completes 11 years — ₹6.9 lakh crore DBT in FY2024-25, 28 Aug 2025",
        "https://pib.gov.in/PressReleasePage.aspx?PRID=2161401"
      ],
      [
        "Fino Payments Bank, Annual Report 2024-25",
        "https://www.fino.bank.in/files/fino/media/post_attachments/sites/default/files/uploads/pages/financials/annual-report-2025.pdf"
      ],
      [
        "Moneylife, 'Is CSC e-Governance Services a govt entity or SPV or a Section 8 company?', 29 Jun 2018",
        "https://www.moneylife.in/article/is-csc-egovernance-services-a-govt-entity-or-spv-or-a-section-8-company/54524.html"
      ],
      [
        "Free Press Journal, IPPB disbursed over ₹45,000 crore in DBT in 7 years (Scindia), 1 Sep 2024",
        "https://www.freepressjournal.in/business/india-post-payments-bank-disbursed-over-45000-crore-in-dbt-in-last-7-years"
      ],
      [
        "The Wire, 'Aadhaar Mess: How Airtel Pulled Off Its Rs 190 Crore Magic Trick', 21 Dec 2017",
        "https://m.thewire.in/article/banking/airtel-aadhaar-uidai"
      ]
    ],
    "domain": "vendors"
  },
  {
    "id": "scheme:dl-dtc-ebus-induction",
    "name": "Delhi electric-bus induction for DTC/cluster network (carrier of the free 'pink ticket' for women)",
    "al": [
      "DTC e-buses",
      "Delhi e-bus GCC"
    ],
    "level": "state",
    "st": "dl",
    "applicableStates": null,
    "category": "transport",
    "party": "AAP",
    "announced": {
      "date": null,
      "byPersonId": "wel:arvind-kejriwal",
      "office": "Chief Minister, Delhi (free-ride-for-women 'pink ticket' launch date not verified from an opened source; recorded as gap)",
      "srcs": [
        [
          "Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022",
          "https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"
        ]
      ]
    },
    "approved": {
      "date": "2022-12-23",
      "body": "Delhi Transport Corporation board / Delhi Transport Department (definitive agreement)",
      "srcs": [
        [
          "Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022",
          "https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"
        ]
      ]
    },
    "launched": {
      "date": "2022-12-23",
      "srcs": [
        [
          "Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022",
          "https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"
        ]
      ]
    },
    "benefit": {
      "amount": null,
      "unit": "fleet capacity; women ride free on DTC/cluster buses (fare figure not in opened sources)",
      "changes": []
    },
    "eligibility": "All women passengers on DTC and cluster buses (pink ticket)",
    "beneficiaries": [],
    "outlay": [],
    "electionContext": {
      "election": "Delhi assembly",
      "date": "2025-02-05",
      "monthsFromLaunch": 25,
      "incumbentParty": "AAP",
      "result": "incumbent lost",
      "seatChange": "BJP +40 (48), AAP −40 (22)",
      "srcs": [
        [
          "Wikipedia (pointer), 2025 Delhi Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2022-12-23",
        "status": "live",
        "note": "1,500 Tata e-buses, 12-year SOM contract",
        "srcs": [
          [
            "Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022",
            "https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"
          ]
        ]
      },
      {
        "date": "2023-09-22",
        "status": "raised",
        "note": "950 Switch Mobility 12-m + 1,040 JBM/PMI 9-m e-buses signed",
        "srcs": [
          [
            "EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023",
            "https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Per-km rates and contract values were not disclosed in the Tata press release or the Sep 2023 report; only bus counts and tenure (12 years) are public in the sources opened",
        "tier": "documented",
        "srcs": [
          [
            "Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022",
            "https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"
          ],
          [
            "EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023",
            "https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:arvind-kejriwal",
        "role": "Chief Minister",
        "action": "administers",
        "date": "2022-12-23",
        "party": "AAP",
        "srcs": [
          [
            "Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022",
            "https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "wel:tml-cv-mobility-solutions",
        "how": "12-year supply-operate-maintain contract for 1,500 e-buses via CESL Grand Challenge",
        "amountCr": null,
        "tier": "documented",
        "srcs": [
          [
            "Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022",
            "https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"
          ]
        ]
      },
      {
        "who": "wel:switch-mobility",
        "how": "950 12-m low-floor e-buses under CESL tender (Sep 2023)",
        "amountCr": null,
        "tier": "reported",
        "srcs": [
          [
            "EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023",
            "https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"
          ]
        ]
      },
      {
        "who": "wel:jbm-auto",
        "how": "Share of 1,040 9-m e-buses with PMI Electro (Sep 2023)",
        "amountCr": null,
        "tier": "reported",
        "srcs": [
          [
            "EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023",
            "https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"
          ]
        ]
      },
      {
        "who": "wel:pmi-electro-mobility",
        "how": "Share of 1,040 9-m e-buses with JBM (Sep 2023)",
        "amountCr": null,
        "tier": "reported",
        "srcs": [
          [
            "EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023",
            "https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022",
        "https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"
      ],
      [
        "EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023",
        "https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"
      ],
      [
        "Wikipedia (pointer), 2025 Delhi Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"
      ]
    ],
    "domain": "vendors"
  },
  {
    "id": "scheme:dl-free-power-200-units",
    "name": "Delhi free electricity up to 200 units",
    "al": [
      "zero power bill",
      "200 units free"
    ],
    "level": "state",
    "st": "dl",
    "applicableStates": null,
    "category": "energy-subsidy",
    "party": "AAP",
    "announced": {
      "date": null,
      "byPersonId": "wel:arvind-kejriwal",
      "office": "Chief Minister, Delhi",
      "srcs": []
    },
    "approved": {
      "date": "2019-08-01",
      "body": "Delhi Cabinet (annual subsidy scheme renewed each FY; 2024-25 renewal 7 Mar 2024)",
      "srcs": [
        [
          "Business Today, 1 Aug 2019: Kejriwal announces free electricity up to 200 units",
          "https://www.businesstoday.in/latest/economy-politics/story/arvind-kejriwal-free-electricity-up-to-200-units-delhi-from-august-220915-2019-08-01"
        ],
        [
          "Deccan Herald, 7 Mar 2024: Delhi cabinet approves power subsidy scheme for FY 2024-25; 22 lakh zero bills",
          "https://www.deccanherald.com/india/delhi/delhi-cabinet-approves-power-subsidy-scheme-for-fy-2024-25-2926614"
        ]
      ]
    },
    "launched": {
      "date": null,
      "srcs": []
    },
    "benefit": {
      "amount": 200,
      "unit": "units of electricity free per month per household (zero bill up to 200 units; 50% subsidy 201-400 units) — this file recalls the ~August 2019 expansion date from general knowledge but could not pin it to a fetched source this session, so the date is nulled and logged as a gap",
      "changes": [
        {
          "date": "2025-04-15",
          "amount": 200,
          "note": "BJP government (CM Rekha Gupta; Power Minister Ashish Sood) continued the subsidy for existing domestic consumers, farmers, 1984 riot victims and lawyers' chambers",
          "srcs": [
            [
              "Business Standard/ANI, 15 Apr 2025: Power subsidy for Delhi homes, farmers, lawyers, riot victims to continue (BJP govt)",
              "https://www.business-standard.com/india-news/power-subsidy-for-delhi-homes-farmers-lawyers-riot-victims-to-continue-125041501496_1.html"
            ]
          ]
        }
      ]
    },
    "eligibility": "domestic electricity consumers in Delhi",
    "beneficiaries": [
      {
        "asOf": "2024-03",
        "count": 2200000,
        "srcs": [
          [
            "Deccan Herald, 7 Mar 2024: Delhi cabinet approves power subsidy scheme for FY 2024-25; 22 lakh zero bills",
            "https://www.deccanherald.com/india/delhi/delhi-cabinet-approves-power-subsidy-scheme-for-fy-2024-25-2926614"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2019-20",
        "budgetedCr": 1720,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Delhi Budget Analysis 2019-20",
            "https://prsindia.org/budgets/states/delhi-budget-analysis-2019-20"
          ]
        ]
      },
      {
        "fy": "2020-21",
        "budgetedCr": 2820,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Delhi Budget Analysis 2020-21",
            "https://prsindia.org/budgets/states/delhi-budget-analysis-2020-21"
          ]
        ]
      },
      {
        "fy": "2023-24",
        "budgetedCr": 3250,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Delhi Budget Analysis 2023-24",
            "https://prsindia.org/budgets/states/delhi-budget-analysis-2023-24"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Delhi assembly",
      "date": "2020-02-08",
      "monthsFromLaunch": null,
      "incumbentParty": "AAP",
      "result": "incumbent won (62/70 seats)",
      "seatChange": null,
      "srcs": []
    },
    "status": [
      {
        "date": "2025-02-05",
        "status": "live",
        "note": "Continued through the 2025 election, which AAP nonetheless lost — see scheme:dl-mahila-samman-promise-2025 for the contrasting cash-promise case in the same election.",
        "srcs": [
          [
            "Deccan Herald — Delhi 2025 result, BJP vote share up 13pp",
            "https://www.deccanherald.com/elections/delhi/delhi-assembly-election-2025-results-bjps-vote-share-rises-by-13-aap-sees-10-decline-3397296"
          ]
        ]
      },
      {
        "date": "2019-08-01",
        "status": "live",
        "note": "",
        "srcs": [
          [
            "Business Today, 1 Aug 2019: Kejriwal announces free electricity up to 200 units",
            "https://www.businesstoday.in/latest/economy-politics/story/arvind-kejriwal-free-electricity-up-to-200-units-delhi-from-august-220915-2019-08-01"
          ]
        ]
      },
      {
        "date": "2024-03-07",
        "status": "live",
        "note": "Cabinet renewal to 31 Mar 2025 after an \"emergency\" meeting; Atishi alleged officers were threatened to block it",
        "srcs": [
          [
            "Deccan Herald, 7 Mar 2024: Delhi cabinet approves power subsidy scheme for FY 2024-25; 22 lakh zero bills",
            "https://www.deccanherald.com/india/delhi/delhi-cabinet-approves-power-subsidy-scheme-for-fy-2024-25-2926614"
          ]
        ]
      },
      {
        "date": "2025-04-15",
        "status": "live",
        "note": "Continued by the BJP government — the 2025 campaign claim that BJP would scrap it was answered by continuation",
        "srcs": [
          [
            "Business Standard/ANI, 15 Apr 2025: Power subsidy for Delhi homes, farmers, lawyers, riot victims to continue (BJP govt)",
            "https://www.business-standard.com/india-news/power-subsidy-for-delhi-homes-farmers-lawyers-riot-victims-to-continue-125041501496_1.html"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "The free-power subsidy is now old and stable (running six years by the 2025 election) rather than freshly timed; its persistence without renewal-adjacent-to-polling-day makes it a weak example of the 'timed launch' mechanism even though it remained politically salient throughout AAP's time in office.",
        "tier": "analytic",
        "srcs": []
      },
      {
        "finding": "Fiscal: power subsidy nearly doubled from Rs 1,720 cr (2019-20 BE) to Rs 3,250 cr (2023-24 BE); Delhi's committed expenditure is unusually low (Rs 3,097 cr, 2023-24) so the subsidy is affordable — the innocent reading of a rich UT choosing a universal tariff subsidy.",
        "tier": "documented",
        "srcs": [
          [
            "PRS, Delhi Budget Analysis 2019-20",
            "https://prsindia.org/budgets/states/delhi-budget-analysis-2019-20"
          ],
          [
            "PRS, Delhi Budget Analysis 2023-24",
            "https://prsindia.org/budgets/states/delhi-budget-analysis-2023-24"
          ]
        ]
      },
      {
        "finding": "Launched 6 months before the Feb 2020 poll (AAP retained 62/70); still live in Feb 2025 when AAP lost 40 seats and the BJP kept the scheme — the same instrument coexists with a win and a loss, and with adoption by the rival party.",
        "tier": "analytic",
        "srcs": [
          [
            "Wikipedia infobox (pointer to ECI): 2020 Delhi Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2020_Delhi_Legislative_Assembly_election"
          ],
          [
            "Wikipedia infobox (pointer to ECI): 2025 Delhi Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"
          ],
          [
            "Business Standard/ANI, 15 Apr 2025: Power subsidy for Delhi homes, farmers, lawyers, riot victims to continue (BJP govt)",
            "https://www.business-standard.com/india-news/power-subsidy-for-delhi-homes-farmers-lawyers-riot-victims-to-continue-125041501496_1.html"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:arvind-kejriwal",
        "role": "Chief Minister, Delhi",
        "action": "announced",
        "date": null,
        "party": "AAP",
        "srcs": []
      },
      {
        "personId": "wel:arvind-kejriwal",
        "role": "Chief Minister, Delhi",
        "action": "announced",
        "date": "2019-08-01",
        "party": "AAP",
        "srcs": [
          [
            "Business Today, 1 Aug 2019: Kejriwal announces free electricity up to 200 units",
            "https://www.businesstoday.in/latest/economy-politics/story/arvind-kejriwal-free-electricity-up-to-200-units-delhi-from-august-220915-2019-08-01"
          ]
        ]
      },
      {
        "personId": "wel:atishi",
        "role": "Power Minister (2023–24), Chief Minister (Sep 2024–Feb 2025), Delhi",
        "action": "approved",
        "date": "2024-03-07",
        "party": "AAP",
        "srcs": [
          [
            "Deccan Herald, 7 Mar 2024: Delhi cabinet approves power subsidy scheme for FY 2024-25; 22 lakh zero bills",
            "https://www.deccanherald.com/india/delhi/delhi-cabinet-approves-power-subsidy-scheme-for-fy-2024-25-2926614"
          ]
        ]
      },
      {
        "personId": "wel:ashish-sood",
        "role": "Power Minister, Delhi",
        "action": "approved",
        "date": "2025-04-15",
        "party": "BJP",
        "srcs": [
          [
            "Business Standard/ANI, 15 Apr 2025: Power subsidy for Delhi homes, farmers, lawyers, riot victims to continue (BJP govt)",
            "https://www.business-standard.com/india-news/power-subsidy-for-delhi-homes-farmers-lawyers-riot-victims-to-continue-125041501496_1.html"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "Delhi DISCOMs (BSES Rajdhani, BSES Yamuna, Tata Power-DDL)",
        "how": "subsidy is paid to consumers \"through DISCOMs\" — Rs 1,720/2,820/3,250 cr in the three opened budgets — guaranteeing collection on subsidised slabs",
        "amountCr": 3250,
        "tier": "documented",
        "srcs": [
          [
            "PRS, Delhi Budget Analysis 2019-20",
            "https://prsindia.org/budgets/states/delhi-budget-analysis-2019-20"
          ],
          [
            "PRS, Delhi Budget Analysis 2020-21",
            "https://prsindia.org/budgets/states/delhi-budget-analysis-2020-21"
          ],
          [
            "PRS, Delhi Budget Analysis 2023-24",
            "https://prsindia.org/budgets/states/delhi-budget-analysis-2023-24"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Business Today, 1 Aug 2019: Kejriwal announces free electricity up to 200 units",
        "https://www.businesstoday.in/latest/economy-politics/story/arvind-kejriwal-free-electricity-up-to-200-units-delhi-from-august-220915-2019-08-01"
      ],
      [
        "PRS, Delhi Budget Analysis 2019-20",
        "https://prsindia.org/budgets/states/delhi-budget-analysis-2019-20"
      ],
      [
        "PRS, Delhi Budget Analysis 2020-21",
        "https://prsindia.org/budgets/states/delhi-budget-analysis-2020-21"
      ],
      [
        "PRS, Delhi Budget Analysis 2023-24",
        "https://prsindia.org/budgets/states/delhi-budget-analysis-2023-24"
      ],
      [
        "Deccan Herald, 7 Mar 2024: Delhi cabinet approves power subsidy scheme for FY 2024-25; 22 lakh zero bills",
        "https://www.deccanherald.com/india/delhi/delhi-cabinet-approves-power-subsidy-scheme-for-fy-2024-25-2926614"
      ],
      [
        "Business Standard/ANI, 15 Apr 2025: Power subsidy for Delhi homes, farmers, lawyers, riot victims to continue (BJP govt)",
        "https://www.business-standard.com/india-news/power-subsidy-for-delhi-homes-farmers-lawyers-riot-victims-to-continue-125041501496_1.html"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2020 Delhi Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2020_Delhi_Legislative_Assembly_election"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2025 Delhi Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:dl-mahila-samman-promise-2025",
    "name": "Mukhya Mantri Mahila Samman Yojana (Delhi, AAP promise)",
    "al": [
      "Mahila Samman Yojana"
    ],
    "level": "state",
    "st": "dl",
    "applicableStates": null,
    "category": "women-cash",
    "party": "AAP",
    "announced": {
      "date": null,
      "byPersonId": "wel:arvind-kejriwal",
      "office": "Chief Minister, Delhi (campaign)",
      "srcs": [
        [
          "Wikipedia — 2025 Delhi Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"
        ]
      ]
    },
    "approved": {
      "date": "2024-12-12",
      "body": "Delhi Cabinet (CM Atishi) — Rs 1,000/month",
      "srcs": [
        [
          "Deccan Herald, 12 Dec 2024: Kejriwal announces Rs 1,000 (Rs 2,100 after polls) for Delhi women",
          "https://www.deccanherald.com/elections/delhi/delhi-assembly-elections-2025-ahead-of-polls-cabinet-approves-proposal-of-giving-rs-1000-to-women-every-months-3314631"
        ],
        [
          "ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs",
          "https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"
        ]
      ]
    },
    "launched": {
      "date": null,
      "srcs": [
        [
          "Deccan Herald, 12 Dec 2024: Kejriwal announces Rs 1,000 (Rs 2,100 after polls) for Delhi women",
          "https://www.deccanherald.com/elections/delhi/delhi-assembly-elections-2025-ahead-of-polls-cabinet-approves-proposal-of-giving-rs-1000-to-women-every-months-3314631"
        ]
      ]
    },
    "benefit": {
      "amount": 2100,
      "unit": "₹ per month promised by AAP (₹1,000 approved Dec 2024); the BJP's rival ₹2,500/month promise is scheme:dl-mahila-samriddhi",
      "changes": []
    },
    "eligibility": "women residents of Delhi (as promised; final eligibility for the BJP version set after the government changed)",
    "beneficiaries": [
      {
        "asOf": "2025-02",
        "count": 0,
        "srcs": [
          [
            "Deccan Herald, 12 Dec 2024: Kejriwal announces Rs 1,000 (Rs 2,100 after polls) for Delhi women",
            "https://www.deccanherald.com/elections/delhi/delhi-assembly-elections-2025-ahead-of-polls-cabinet-approves-proposal-of-giving-rs-1000-to-women-every-months-3314631"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2024-25",
        "budgetedCr": 2000,
        "actualCr": 0,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Deccan Herald, 12 Dec 2024: Kejriwal announces Rs 1,000 (Rs 2,100 after polls) for Delhi women",
            "https://www.deccanherald.com/elections/delhi/delhi-assembly-elections-2025-ahead-of-polls-cabinet-approves-proposal-of-giving-rs-1000-to-women-every-months-3314631"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Delhi assembly",
      "date": "2025-02-05",
      "monthsFromLaunch": null,
      "incumbentParty": "AAP",
      "result": "incumbent lost",
      "seatChange": "BJP 8→48 seats (47.15% vote share, +13pp), AAP 62→22 seats (43.57%, about -10pp)",
      "srcs": [
        [
          "Deccan Herald — Delhi 2025 result, BJP vote share up 13pp",
          "https://www.deccanherald.com/elections/delhi/delhi-assembly-election-2025-results-bjps-vote-share-rises-by-13-aap-sees-10-decline-3397296"
        ]
      ]
    },
    "status": [
      {
        "date": "2025-02-05",
        "status": "promised-not-enacted",
        "note": "AAP's ₹2,100/month promise was never disbursed — AAP lost the election before it could be implemented. BJP's own, larger (₹2,500/month) competing promise, made from opposition, was carried into its manifesto and pursued after it won; this file could not independently confirm the BJP scheme's actual rollout date this session (logged as a gap) beyond its status as a stated post-election priority under CM Rekha Gupta.",
        "srcs": [
          [
            "Wikipedia — 2025 Delhi Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"
          ]
        ]
      },
      {
        "date": "2024-12-12",
        "status": "promised-not-enacted",
        "note": null,
        "srcs": [
          [
            "Deccan Herald, 12 Dec 2024: Kejriwal announces Rs 1,000 (Rs 2,100 after polls) for Delhi women",
            "https://www.deccanherald.com/elections/delhi/delhi-assembly-elections-2025-ahead-of-polls-cabinet-approves-proposal-of-giving-rs-1000-to-women-every-months-3314631"
          ]
        ]
      },
      {
        "date": "2025-02-20",
        "status": "discontinued",
        "note": "superseded by BJP government's Mahila Samriddhi (also unpaid)",
        "srcs": [
          [
            "Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr",
            "https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "This is the case explicitly framed in this file's brief: 'AAP lost with its freebies; BJP promised more.' The AAP incumbent, already running the free-power/free-water schemes for a decade, added a fresh ₹2,100/month cash promise shortly before the poll and still lost to a challenger promising an even larger ₹2,500/month cash transfer plus continuation of the existing subsidies — the clearest evidence in this file that a welfare promise's credibility, the challenger's counter-offer, and a decade of incumbency fatigue and corruption allegations (the liquor-policy case) can outweigh scheme generosity on its own.",
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald — Delhi 2025 result, BJP vote share up 13pp",
            "https://www.deccanherald.com/elections/delhi/delhi-assembly-election-2025-results-bjps-vote-share-rises-by-13-aap-sees-10-decline-3397296"
          ]
        ]
      },
      {
        "finding": "ThePrint: Delhi planning department worried the scheme would discourage women's employment; finance department flagged fiscal stress",
        "tier": "reported",
        "srcs": [
          [
            "ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs",
            "https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"
          ]
        ]
      },
      {
        "finding": "An approved-but-unpaid Rs 1,000 with a Rs 2,100 promise did not save the incumbent; the rival's larger unpaid promise (Rs 2,500) won",
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald, 12 Dec 2024: Kejriwal announces Rs 1,000 (Rs 2,100 after polls) for Delhi women",
            "https://www.deccanherald.com/elections/delhi/delhi-assembly-elections-2025-ahead-of-polls-cabinet-approves-proposal-of-giving-rs-1000-to-women-every-months-3314631"
          ],
          [
            "Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr",
            "https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"
          ],
          [
            "Wikipedia infobox (pointer to ECI results): 2025 Delhi Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:arvind-kejriwal",
        "role": "Chief Minister, Delhi (campaign)",
        "action": "announced",
        "date": null,
        "party": "AAP",
        "srcs": []
      },
      {
        "personId": "wel:arvind-kejriwal",
        "role": "AAP convenor / ex-CM",
        "action": "announced",
        "date": "2024-12-12",
        "party": "AAP",
        "srcs": [
          [
            "Deccan Herald, 12 Dec 2024: Kejriwal announces Rs 1,000 (Rs 2,100 after polls) for Delhi women",
            "https://www.deccanherald.com/elections/delhi/delhi-assembly-elections-2025-ahead-of-polls-cabinet-approves-proposal-of-giving-rs-1000-to-women-every-months-3314631"
          ]
        ]
      },
      {
        "personId": "wel:atishi",
        "role": "Chief Minister",
        "action": "approved",
        "date": "2024-12-12",
        "party": "AAP",
        "srcs": [
          [
            "Deccan Herald, 12 Dec 2024: Kejriwal announces Rs 1,000 (Rs 2,100 after polls) for Delhi women",
            "https://www.deccanherald.com/elections/delhi/delhi-assembly-elections-2025-ahead-of-polls-cabinet-approves-proposal-of-giving-rs-1000-to-women-every-months-3314631"
          ]
        ]
      }
    ],
    "whoElseBenefits": [],
    "srcs": [
      [
        "Wikipedia — 2025 Delhi Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"
      ],
      [
        "Deccan Herald, 12 Dec 2024: Kejriwal announces Rs 1,000 (Rs 2,100 after polls) for Delhi women",
        "https://www.deccanherald.com/elections/delhi/delhi-assembly-elections-2025-ahead-of-polls-cabinet-approves-proposal-of-giving-rs-1000-to-women-every-months-3314631"
      ],
      [
        "ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs",
        "https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2025 Delhi Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:dl-mahila-samriddhi",
    "name": "Mahila Samriddhi Yojana (Delhi)",
    "al": [
      "Delhi Lakshmi Yojana (reported rename, Jul 2026 — unverified)",
      "Mahila Samridhi Yojana",
      "Mukhyamantri Mahila Samridhi Yojana"
    ],
    "level": "state",
    "st": "dl",
    "applicableStates": null,
    "category": "women-cash",
    "party": "BJP",
    "announced": {
      "date": "2025-01",
      "byPersonId": "pol:narendra-modi",
      "office": "Prime Minister (Delhi campaign): scheme to be approved at the first cabinet, money by 8 Mar 2025",
      "srcs": [
        [
          "Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr",
          "https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"
        ]
      ]
    },
    "approved": {
      "date": "2025-03-08",
      "body": "Delhi Cabinet (Rs 5,100 cr provision; four-member ministerial committee)",
      "srcs": [
        [
          "Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr",
          "https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"
        ]
      ]
    },
    "launched": {
      "date": null,
      "srcs": [
        [
          "India TV, 8 Jul 2026: Delhi to launch Mahila Samriddhi on Raksha Bandhan; Rs 5,110 cr 2026-27",
          "https://www.indiatvnews.com/delhi/delhi-govt-to-launch-mahila-samriddhi-yojana-on-raksha-bandhan-check-who-can-get-rs-2500-monthly-and-required-documents-2026-07-08-1047512"
        ]
      ]
    },
    "benefit": {
      "amount": 2500,
      "unit": "₹ per month",
      "changes": []
    },
    "eligibility": "Not specified in PRS Table 6",
    "beneficiaries": [
      {
        "asOf": "2026-07",
        "count": 0,
        "srcs": [
          [
            "India TV, 8 Jul 2026: Delhi to launch Mahila Samriddhi on Raksha Bandhan; Rs 5,110 cr 2026-27",
            "https://www.indiatvnews.com/delhi/delhi-govt-to-launch-mahila-samriddhi-yojana-on-raksha-bandhan-check-who-can-get-rs-2500-monthly-and-required-documents-2026-07-08-1047512"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2025-26",
        "budgetedCr": 5110,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 5110,
        "actualCr": 0,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr",
            "https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"
          ],
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "fy": "2026-27",
        "budgetedCr": 5110,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "India TV, 8 Jul 2026: Delhi to launch Mahila Samriddhi on Raksha Bandhan; Rs 5,110 cr 2026-27",
            "https://www.indiatvnews.com/delhi/delhi-govt-to-launch-mahila-samriddhi-yojana-on-raksha-bandhan-check-who-can-get-rs-2500-monthly-and-required-documents-2026-07-08-1047512"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Delhi assembly",
      "date": "2025-02-05",
      "monthsFromLaunch": null,
      "incumbentParty": "AAP",
      "result": "challenger (BJP) won; scheme not paid 17+ months later",
      "seatChange": "BJP 48 (+40)",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI results): 2025 Delhi Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2025-03-08",
        "status": "promised-not-enacted",
        "note": "Cabinet approval and committee only; Atishi: 'Modi lied'",
        "srcs": [
          [
            "Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr",
            "https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"
          ]
        ]
      },
      {
        "date": "2026-07-08",
        "status": "promised-not-enacted",
        "note": "Portal ready, launch pending",
        "srcs": [
          [
            "India TV, 8 Jul 2026: Delhi to launch Mahila Samriddhi on Raksha Bandhan; Rs 5,110 cr 2026-27",
            "https://www.indiatvnews.com/delhi/delhi-govt-to-launch-mahila-samriddhi-yojana-on-raksha-bandhan-check-who-can-get-rs-2500-monthly-and-required-documents-2026-07-08-1047512"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "PRS (Oct 2025): BE 2025-26 ₹5,110 cr = 7.1% of revenue expenditure, 6.3% of revenue receipts.",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "Budget provision only; PRS excludes Delhi from GSDP charts. Whether any payment was made is not established by sources opened here (see women-cash.json).",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "Budgeted twice (2025-26 and 2026-27) with zero disbursement through Jul 2026 — a 17-month gap between a poll promise of 'money by 8 March' and first payment",
        "tier": "reported",
        "srcs": [
          [
            "Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr",
            "https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"
          ],
          [
            "India TV, 8 Jul 2026: Delhi to launch Mahila Samriddhi on Raksha Bandhan; Rs 5,110 cr 2026-27",
            "https://www.indiatvnews.com/delhi/delhi-govt-to-launch-mahila-samriddhi-yojana-on-raksha-bandhan-check-who-can-get-rs-2500-monthly-and-required-documents-2026-07-08-1047512"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:rekha-gupta",
        "role": "Chief Minister",
        "action": "approved",
        "date": "2025-03-08",
        "party": "BJP",
        "srcs": [
          [
            "Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr",
            "https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"
          ]
        ]
      },
      {
        "personId": "pol:narendra-modi",
        "role": "Prime Minister",
        "action": "announced",
        "date": "2025-01",
        "party": "BJP",
        "srcs": [
          [
            "Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr",
            "https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"
          ]
        ]
      },
      {
        "personId": "wel:atishi",
        "role": "Leader of Opposition",
        "action": "opposed",
        "date": "2025-03-08",
        "party": "AAP",
        "srcs": [
          [
            "Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr",
            "https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"
          ]
        ]
      },
      {
        "personId": "wel:rekha-gupta",
        "role": "Chief Minister, Delhi",
        "action": "administers",
        "date": "2025-02-20",
        "party": "BJP",
        "srcs": []
      }
    ],
    "whoElseBenefits": [],
    "srcs": [
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr",
        "https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"
      ],
      [
        "India TV, 8 Jul 2026: Delhi to launch Mahila Samriddhi on Raksha Bandhan; Rs 5,110 cr 2026-27",
        "https://www.indiatvnews.com/delhi/delhi-govt-to-launch-mahila-samriddhi-yojana-on-raksha-bandhan-check-who-can-get-rs-2500-monthly-and-required-documents-2026-07-08-1047512"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ]
    ],
    "domain": "fiscal-results"
  },
  {
    "id": "scheme:gj-namo-laxmi-2024",
    "name": "Namo Laxmi Yojana (Gujarat girls' secondary scholarship) — with Gujarat's agricultural power subsidy as context",
    "al": [
      "Namo Lakshmi"
    ],
    "level": "state",
    "st": "gj",
    "applicableStates": null,
    "category": "student",
    "party": "BJP",
    "announced": {
      "date": "2024-02",
      "byPersonId": "wel:bhupendra-patel",
      "office": "Chief Minister, Gujarat (budget presented by FM Kanubhai Desai)",
      "srcs": [
        [
          "PRS, Gujarat Budget Analysis 2024-25",
          "https://prsindia.org/budgets/states/gujarat-budget-analysis-2024-25"
        ]
      ]
    },
    "approved": {
      "date": "2024-02",
      "body": "Gujarat budget 2024-25",
      "srcs": [
        [
          "PRS, Gujarat Budget Analysis 2024-25",
          "https://prsindia.org/budgets/states/gujarat-budget-analysis-2024-25"
        ]
      ]
    },
    "launched": {
      "date": null,
      "srcs": []
    },
    "benefit": {
      "amount": 50000,
      "unit": "₹ over four years per girl student (classes 9–12)",
      "changes": []
    },
    "eligibility": "Girls in secondary and higher secondary schools (income criteria per press, not opened)",
    "beneficiaries": [],
    "outlay": [
      {
        "fy": "2024-25",
        "budgetedCr": null,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Gujarat Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/gujarat-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Lok Sabha (Gujarat)",
      "date": "2024-05-07",
      "monthsFromLaunch": 3,
      "incumbentParty": "BJP",
      "result": "BJP/NDA won nationally (fleet file); Gujarat seat count not captured",
      "seatChange": null,
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI results): 2024 Indian general election",
          "https://en.wikipedia.org/wiki/2024_Indian_general_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2024-02",
        "status": "promised-not-enacted",
        "note": "budget announcement",
        "srcs": [
          [
            "PRS, Gujarat Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/gujarat-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Symmetry entry: the BJP's home state runs no large unconditional cash scheme (PRS SOSF 2025-26 lists 12 states with women's UCTs; Gujarat is not one) but spends Rs 12,207 cr/yr on farm power subsidy — the same \"free electricity\" instrument AAP uses in Punjab/Delhi, delivered to farmers rather than households. The absence of a cash scheme in a state the party wins comfortably is the base-rate control this file otherwise lacks.",
        "tier": "analytic",
        "srcs": [
          [
            "PRS, Gujarat Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/gujarat-budget-analysis-2024-25"
          ],
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.13-14 and subsidy section (PDF)",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:bhupendra-patel",
        "role": "Chief Minister, Gujarat",
        "action": "presented budget",
        "date": "2024-02",
        "party": "BJP",
        "srcs": [
          [
            "PRS, Gujarat Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/gujarat-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "Gujarat discoms (GUVNL subsidiaries)",
        "how": "Rs 12,207 cr agricultural power subsidy 2024-25",
        "amountCr": 12207,
        "tier": "documented",
        "srcs": [
          [
            "PRS, Gujarat Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/gujarat-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "PRS, Gujarat Budget Analysis 2024-25",
        "https://prsindia.org/budgets/states/gujarat-budget-analysis-2024-25"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.13-14 and subsidy section (PDF)",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2024 Indian general election",
        "https://en.wikipedia.org/wiki/2024_Indian_general_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:hp-indira-gandhi-pyari-behna",
    "name": "Indira Gandhi Pyari Behna Sukh Samman Nidhi Yojana",
    "al": [
      "Pyari Behna",
      "IGPBSSNY"
    ],
    "level": "state",
    "st": "hp",
    "applicableStates": null,
    "category": "women-cash",
    "party": "INC",
    "announced": {
      "date": "2024-03",
      "byPersonId": "wel:sukhvinder-singh-sukhu",
      "office": "Chief Minister, Himachal Pradesh",
      "srcs": [
        [
          "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
          "https://prsindia.org/files/budget/SOSF_2025.pdf"
        ],
        [
          "ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals",
          "https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Himachal Pradesh Cabinet",
      "srcs": [
        [
          "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
          "https://prsindia.org/files/budget/SOSF_2025.pdf"
        ]
      ]
    },
    "launched": {
      "date": "2024",
      "srcs": [
        [
          "ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals",
          "https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"
        ],
        [
          "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
          "https://prsindia.org/files/budget/SOSF_2025.pdf"
        ]
      ]
    },
    "benefit": {
      "amount": 1500,
      "unit": "₹ per month",
      "changes": []
    },
    "eligibility": "Phased roll-out, women 18–59 (PRS Table 6)",
    "beneficiaries": [
      {
        "asOf": "2024-03-31",
        "count": 1103,
        "srcs": [
          [
            "ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals",
            "https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"
          ]
        ]
      },
      {
        "asOf": "2025-03-31",
        "count": 30929,
        "srcs": [
          [
            "ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals",
            "https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"
          ]
        ]
      },
      {
        "asOf": "2026-08-01",
        "count": 35687,
        "srcs": [
          [
            "ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals",
            "https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2025-26",
        "budgetedCr": 138,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "fy": "2023-24",
        "budgetedCr": null,
        "actualCr": 1.29,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals",
            "https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"
          ]
        ]
      },
      {
        "fy": "2024-25",
        "budgetedCr": null,
        "actualCr": 16.19,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals",
            "https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 138,
        "actualCr": 11.64,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ],
          [
            "ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals",
            "https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Himachal Pradesh assembly",
      "date": "2022-11",
      "monthsFromLaunch": null,
      "incumbentParty": "BJP",
      "result": "challenger (INC) won on ten guarantees incl. Rs 1,500 for women; election page not retrievable (Wikipedia rate-limit) — see gaps",
      "seatChange": null,
      "srcs": [
        [
          "ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals",
          "https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"
        ]
      ]
    },
    "status": [
      {
        "date": "2024",
        "status": "live",
        "note": "phased",
        "srcs": [
          [
            "ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals",
            "https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"
          ]
        ]
      },
      {
        "date": "2025",
        "status": "promised-not-enacted",
        "note": "2025–2026 (date field holds the first year): Statewide promise to ~5 lakh+ women unmet: 35,687 paid by Aug 2026; Rs 29.12 cr over three years; quorum failures in gram sabhas; age floor raised 18→21",
        "srcs": [
          [
            "ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals",
            "https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "PRS (Oct 2025): BE 2025-26 ₹138 cr = 0.3% of revenue expenditure, 0.3% of revenue receipts.",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "PRS: introduced in a phased manner, to be expanded later.",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "Himachal's HP assembly reply (Sep 2026): Rs 29.12 cr disbursed in three years vs a Rs 138 cr BE for 2025-26 alone — the largest promise-to-delivery gap among enacted schemes in this file",
        "tier": "reported",
        "srcs": [
          [
            "ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals",
            "https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"
          ],
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "PRS: HP spends 85% of revenue receipts on committed items and subsidies — the innocent reading for the slow roll-out",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:sukhvinder-singh-sukhu",
        "role": "Chief Minister",
        "action": "announced",
        "date": "2024-03",
        "party": "INC",
        "srcs": [
          [
            "ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals",
            "https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"
          ]
        ]
      }
    ],
    "whoElseBenefits": [],
    "srcs": [
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals",
        "https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ]
    ],
    "domain": "fiscal-results"
  },
  {
    "id": "scheme:hp-ops-restoration",
    "name": "Old Pension Scheme restoration",
    "al": [
      "OPS"
    ],
    "level": "state",
    "st": "hp",
    "applicableStates": null,
    "category": "pension",
    "party": "INC",
    "announced": {
      "date": "2023-01-13",
      "byPersonId": "wel:sukhvinder-singh-sukhu",
      "office": "Chief Minister, Himachal Pradesh",
      "srcs": [
        [
          "Onmanorama — Himachal restores Old Pension Scheme",
          "https://www.onmanorama.com/news/india/2023/01/14/congress-himachal-pradesh-old-pension-scheme.html"
        ]
      ]
    },
    "approved": {
      "date": "2023-01-13",
      "body": "Himachal Pradesh Cabinet (first cabinet meeting of the new government)",
      "srcs": [
        [
          "Onmanorama — Himachal restores Old Pension Scheme",
          "https://www.onmanorama.com/news/india/2023/01/14/congress-himachal-pradesh-old-pension-scheme.html"
        ]
      ]
    },
    "launched": {
      "date": "2023-01-13",
      "srcs": [
        [
          "Onmanorama — Himachal restores Old Pension Scheme",
          "https://www.onmanorama.com/news/india/2023/01/14/congress-himachal-pradesh-old-pension-scheme.html"
        ]
      ]
    },
    "benefit": {
      "amount": null,
      "unit": "defined-benefit pension (last-drawn-salary formula) restored in place of the defined-contribution National Pension System for state government employees",
      "changes": []
    },
    "eligibility": "Himachal Pradesh state government employees",
    "beneficiaries": [],
    "outlay": [],
    "electionContext": {
      "election": "Himachal Pradesh assembly (next, after this delivery of a pre-poll promise)",
      "date": "2027-11-01",
      "monthsFromLaunch": 58,
      "incumbentParty": "INC",
      "result": "not yet held",
      "seatChange": null,
      "srcs": []
    },
    "status": [
      {
        "date": "2023-01-13",
        "status": "launched",
        "note": "Delivered as literally the first cabinet decision of the new government — same promise-then-deliver pattern as the Chhattisgarh 2018 loan waiver.",
        "srcs": [
          [
            "Onmanorama — Himachal restores Old Pension Scheme",
            "https://www.onmanorama.com/news/india/2023/01/14/congress-himachal-pradesh-old-pension-scheme.html"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Himachal Pradesh, like Rajasthan, has a strong historical pattern of voting out the incumbent almost every election since 1985 (broken only occasionally) — a structural base rate independent of any single welfare promise, and relevant context for reading the 2022 result that brought this government to power.",
        "tier": "analytic",
        "srcs": []
      }
    ],
    "ministers": [
      {
        "personId": "wel:sukhvinder-singh-sukhu",
        "role": "Chief Minister, Himachal Pradesh",
        "action": "approved",
        "date": "2023-01-13",
        "party": "INC",
        "srcs": [
          [
            "Onmanorama — Himachal restores Old Pension Scheme",
            "https://www.onmanorama.com/news/india/2023/01/14/congress-himachal-pradesh-old-pension-scheme.html"
          ]
        ]
      }
    ],
    "whoElseBenefits": [],
    "srcs": [
      [
        "Onmanorama — Himachal restores Old Pension Scheme",
        "https://www.onmanorama.com/news/india/2023/01/14/congress-himachal-pradesh-old-pension-scheme.html"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:hr-lado-lakshmi",
    "name": "Lado Laxmi Yojana",
    "al": [
      "Lado Lakshmi",
      "Lado Laxmi"
    ],
    "level": "state",
    "st": "hr",
    "applicableStates": null,
    "category": "women-cash",
    "party": "BJP",
    "announced": {
      "date": "2024-09",
      "byPersonId": "wel:nayab-singh-saini",
      "office": "Chief Minister, Haryana (BJP 2024 manifesto: Rs 2,100/month)",
      "srcs": [
        [
          "Deccan Herald/PTI, 28 Aug 2025: Haryana cabinet decides to roll out Lado Lakshmi from Sep 25",
          "https://www.deccanherald.com/india/haryana/haryana-decides-to-implement-lado-lakshmi-yojana-eligible-women-to-get-rs-2100-monthly-aid-3700884"
        ]
      ]
    },
    "approved": {
      "date": "2025-08-28",
      "body": "Haryana Cabinet; Gazette notification No.40/10/2025-4SW of 15 Sep 2025",
      "srcs": [
        [
          "Deccan Herald/PTI, 28 Aug 2025: Haryana cabinet decides to roll out Lado Lakshmi from Sep 25",
          "https://www.deccanherald.com/india/haryana/haryana-decides-to-implement-lado-lakshmi-yojana-eligible-women-to-get-rs-2100-monthly-aid-3700884"
        ],
        [
          "Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification",
          "https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"
        ]
      ]
    },
    "launched": {
      "date": "2025-09-25",
      "srcs": [
        [
          "Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification",
          "https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"
        ],
        [
          "Deccan Herald/PTI, 28 Aug 2025: Haryana cabinet decides to roll out Lado Lakshmi from Sep 25",
          "https://www.deccanherald.com/india/haryana/haryana-decides-to-implement-lado-lakshmi-yojana-eligible-women-to-get-rs-2100-monthly-aid-3700884"
        ]
      ]
    },
    "benefit": {
      "amount": 2100,
      "unit": "₹ per month",
      "changes": []
    },
    "eligibility": "Women over 18 (PRS Table 6)",
    "beneficiaries": [
      {
        "asOf": "2025-09",
        "count": null,
        "srcs": [
          [
            "Deccan Herald/PTI, 28 Aug 2025: Haryana cabinet decides to roll out Lado Lakshmi from Sep 25",
            "https://www.deccanherald.com/india/haryana/haryana-decides-to-implement-lado-lakshmi-yojana-eligible-women-to-get-rs-2100-monthly-aid-3700884"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2025-26",
        "budgetedCr": 5000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 5000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Haryana assembly",
      "date": "2024-10-05",
      "monthsFromLaunch": -11.5,
      "incumbentParty": "BJP",
      "result": "incumbent won on the promise; enacted 11.5 months later at a narrower income cut-off",
      "seatChange": "BJP 48 (+8)",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI results): 2024 Haryana Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2024_Haryana_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2025-09-25",
        "status": "live",
        "note": null,
        "srcs": [
          [
            "Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification",
            "https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"
          ]
        ]
      },
      {
        "date": "2025-09-15",
        "status": "eligibility-tightened",
        "note": "Manifesto promise to women generally; notification restricts phase 1 to income ≤ Rs 1 lakh and age 23+",
        "srcs": [
          [
            "Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification",
            "https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"
          ],
          [
            "Deccan Herald/PTI, 28 Aug 2025: Haryana cabinet decides to roll out Lado Lakshmi from Sep 25",
            "https://www.deccanherald.com/india/haryana/haryana-decides-to-implement-lado-lakshmi-yojana-eligible-women-to-get-rs-2100-monthly-aid-3700884"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "PRS (Oct 2025): BE 2025-26 ₹5,000 cr = 3.4% of revenue expenditure, 3.9% of revenue receipts.",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "Gazette specifies DBT via PFMS, an app by HARTRON, verification by CRID against the Parivar Pehchan Patra database within 15 days, and voluntary opt-down of the amount — the most fully specified delivery design among the schemes here",
        "tier": "documented",
        "srcs": [
          [
            "Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification",
            "https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:nayab-singh-saini",
        "role": "Chief Minister",
        "action": "approved",
        "date": "2025-08-28",
        "party": "BJP",
        "srcs": [
          [
            "Deccan Herald/PTI, 28 Aug 2025: Haryana cabinet decides to roll out Lado Lakshmi from Sep 25",
            "https://www.deccanherald.com/india/haryana/haryana-decides-to-implement-lado-lakshmi-yojana-eligible-women-to-get-rs-2100-monthly-aid-3700884"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "psu:hartron",
        "how": "state PSU developed the Lado Lakshmi app (named in the gazette); contract value not published",
        "amountCr": null,
        "tier": "documented",
        "srcs": [
          [
            "Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification",
            "https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification",
        "https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"
      ],
      [
        "Deccan Herald/PTI, 28 Aug 2025: Haryana cabinet decides to roll out Lado Lakshmi from Sep 25",
        "https://www.deccanherald.com/india/haryana/haryana-decides-to-implement-lado-lakshmi-yojana-eligible-women-to-get-rs-2100-monthly-aid-3700884"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ]
    ],
    "domain": "fiscal-results"
  },
  {
    "id": "scheme:in-lakhpati-didi",
    "name": "Lakhpati Didi (DAY-NRLM target)",
    "al": [
      "Lakhpati Didi",
      "लखपति दीदी"
    ],
    "level": "central",
    "st": null,
    "applicableStates": "all",
    "category": "other",
    "party": "BJP (NDA)",
    "announced": {
      "date": "2024-02-01",
      "byPersonId": "pol:nirmala-sitharaman",
      "office": "Union Finance Minister",
      "srcs": [
        [
          "PIB, Interim Budget 2024-25: Lakhpati Didi target 2 cr → 3 cr, 1 Feb 2024",
          "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2001109"
        ],
        [
          "Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)",
          "https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "programme target within DAY-NRLM (MoRD); no separate Cabinet approval identified",
      "srcs": [
        [
          "PIB, Interim Budget 2024-25: Lakhpati Didi target 2 cr → 3 cr, 1 Feb 2024",
          "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2001109"
        ]
      ]
    },
    "launched": {
      "date": null,
      "srcs": [
        [
          "PIB, Interim Budget 2024-25: Lakhpati Didi target 2 cr → 3 cr, 1 Feb 2024",
          "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2001109"
        ]
      ]
    },
    "benefit": {
      "amount": null,
      "unit": "not a cash transfer — livelihood target for SHG members; 83 lakh SHGs, 9 crore women",
      "changes": []
    },
    "eligibility": "women in DAY-NRLM self-help groups",
    "beneficiaries": [
      {
        "asOf": "2024-02-01",
        "count": 10000000,
        "srcs": [
          [
            "PIB, Interim Budget 2024-25: Lakhpati Didi target 2 cr → 3 cr, 1 Feb 2024",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2001109"
          ]
        ]
      }
    ],
    "outlay": [],
    "electionContext": {
      "election": "Lok Sabha 2024",
      "date": "2024-04-19",
      "monthsFromLaunch": 2.5,
      "incumbentParty": "BJP (NDA)",
      "result": "incumbent won (BJP −63)",
      "seatChange": null,
      "srcs": [
        [
          "Wikipedia (pointer), 2024 Indian general election",
          "https://en.wikipedia.org/wiki/2024_Indian_general_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2026-02-01",
        "status": "live",
        "note": "Budget 2026-27 proposes to build on the programme",
        "srcs": [
          [
            "Union Budget 2026-27 speech, Nirmala Sitharaman, 1 Feb 2026",
            "https://www.indiabudget.gov.in/doc/Budget_Speech.pdf"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "No independent verification of the 'one crore Lakhpati' count found; target-style scheme with no per-head transfer",
        "tier": "analytic",
        "srcs": [
          [
            "PIB, Interim Budget 2024-25: Lakhpati Didi target 2 cr → 3 cr, 1 Feb 2024",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2001109"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:nirmala-sitharaman",
        "role": "Union Finance Minister",
        "action": "presented budget",
        "date": "2024-02-01",
        "party": "BJP",
        "srcs": [
          [
            "PIB, Interim Budget 2024-25: Lakhpati Didi target 2 cr → 3 cr, 1 Feb 2024",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2001109"
          ]
        ]
      }
    ],
    "whoElseBenefits": [],
    "srcs": [
      [
        "PIB, Interim Budget 2024-25: Lakhpati Didi target 2 cr → 3 cr, 1 Feb 2024",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2001109"
      ],
      [
        "Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)",
        "https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"
      ],
      [
        "Union Budget 2026-27 speech, Nirmala Sitharaman, 1 Feb 2026",
        "https://www.indiabudget.gov.in/doc/Budget_Speech.pdf"
      ]
    ],
    "domain": "central"
  },
  {
    "id": "scheme:in-mssc",
    "name": "Mahila Samman Savings Certificate, 2023",
    "al": [
      "MSSC",
      "Mahila Samman Bachat Patra"
    ],
    "level": "central",
    "st": null,
    "applicableStates": "all",
    "category": "other",
    "party": "BJP (NDA)",
    "announced": {
      "date": "2023-02-01",
      "byPersonId": "pol:nirmala-sitharaman",
      "office": "Union Finance Minister",
      "srcs": [
        [
          "Union Budget 2023-24 speech, Nirmala Sitharaman, 1 Feb 2023",
          "https://www.indiabudget.gov.in/budget2023-24/doc/Budget_Speech.pdf"
        ]
      ]
    },
    "approved": {
      "date": "2023-02-01",
      "body": "Union Budget 2023-24 (small savings scheme notification by MoF)",
      "srcs": [
        [
          "Union Budget 2023-24 speech, Nirmala Sitharaman, 1 Feb 2023",
          "https://www.indiabudget.gov.in/budget2023-24/doc/Budget_Speech.pdf"
        ]
      ]
    },
    "launched": {
      "date": "2023-04-01",
      "srcs": [
        [
          "Akashvani News, over 14.83 lakh MSSC accounts opened, MoS Finance in LS, 31 Jul 2023",
          "https://www.newsonair.gov.in/over-14-83-lakh-accounts-opened-under-mahila-samman-savings-certificate-scheme-govt-in-ls"
        ]
      ]
    },
    "benefit": {
      "amount": 7.5,
      "unit": "% p.a. on deposits up to ₹2 lakh for two years (a savings product, not a transfer)",
      "changes": []
    },
    "eligibility": "women and girls, via post offices, all PSBs and four private banks",
    "beneficiaries": [
      {
        "asOf": "2023-07-31",
        "count": 1483000,
        "srcs": [
          [
            "Akashvani News, over 14.83 lakh MSSC accounts opened, MoS Finance in LS, 31 Jul 2023",
            "https://www.newsonair.gov.in/over-14-83-lakh-accounts-opened-under-mahila-samman-savings-certificate-scheme-govt-in-ls"
          ]
        ]
      }
    ],
    "outlay": [],
    "electionContext": {
      "election": "Lok Sabha 2024",
      "date": "2024-04-19",
      "monthsFromLaunch": 12.6,
      "incumbentParty": "BJP (NDA)",
      "result": "incumbent won (BJP −63)",
      "seatChange": null,
      "srcs": [
        [
          "Wikipedia (pointer), 2024 Indian general election",
          "https://en.wikipedia.org/wiki/2024_Indian_general_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2025-03-31",
        "status": "discontinued",
        "note": "two-year window closed as designed; no extension announced",
        "srcs": [
          [
            "Akashvani News, over 14.83 lakh MSSC accounts opened, MoS Finance in LS, 31 Jul 2023",
            "https://www.newsonair.gov.in/over-14-83-lakh-accounts-opened-under-mahila-samman-savings-certificate-scheme-govt-in-ls"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Take-up modest relative to Jan Dhan's 31 crore women account-holders: 14.83 lakh accounts in the first four months",
        "tier": "analytic",
        "srcs": [
          [
            "Akashvani News, over 14.83 lakh MSSC accounts opened, MoS Finance in LS, 31 Jul 2023",
            "https://www.newsonair.gov.in/over-14-83-lakh-accounts-opened-under-mahila-samman-savings-certificate-scheme-govt-in-ls"
          ],
          [
            "PIB (MoF), PMJDY completes 11 years, 28 Aug 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2161401"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:nirmala-sitharaman",
        "role": "Union Finance Minister",
        "action": "announced",
        "date": "2023-02-01",
        "party": "BJP",
        "srcs": [
          [
            "Union Budget 2023-24 speech, Nirmala Sitharaman, 1 Feb 2023",
            "https://www.indiabudget.gov.in/budget2023-24/doc/Budget_Speech.pdf"
          ]
        ]
      },
      {
        "personId": "pol:pankaj-chaudhary",
        "role": "Minister of State, Finance",
        "action": "administers",
        "date": "2023-07-31",
        "party": "BJP",
        "srcs": [
          [
            "Akashvani News, over 14.83 lakh MSSC accounts opened, MoS Finance in LS, 31 Jul 2023",
            "https://www.newsonair.gov.in/over-14-83-lakh-accounts-opened-under-mahila-samman-savings-certificate-scheme-govt-in-ls"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "India Post and participating banks",
        "how": "₹8,000 cr+ of two-year deposits; government pays the 7.5% coupon",
        "amountCr": 8000,
        "tier": "documented",
        "srcs": [
          [
            "Akashvani News, over 14.83 lakh MSSC accounts opened, MoS Finance in LS, 31 Jul 2023",
            "https://www.newsonair.gov.in/over-14-83-lakh-accounts-opened-under-mahila-samman-savings-certificate-scheme-govt-in-ls"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Union Budget 2023-24 speech, Nirmala Sitharaman, 1 Feb 2023",
        "https://www.indiabudget.gov.in/budget2023-24/doc/Budget_Speech.pdf"
      ],
      [
        "Akashvani News, over 14.83 lakh MSSC accounts opened, MoS Finance in LS, 31 Jul 2023",
        "https://www.newsonair.gov.in/over-14-83-lakh-accounts-opened-under-mahila-samman-savings-certificate-scheme-govt-in-ls"
      ]
    ],
    "domain": "central"
  },
  {
    "id": "scheme:in-namo-drone-didi",
    "name": "Namo Drone Didi",
    "al": [
      "Drone Didi",
      "drones to women SHGs"
    ],
    "level": "central",
    "st": null,
    "applicableStates": "all",
    "category": "other",
    "party": "BJP (NDA)",
    "announced": {
      "date": "2023-11-29",
      "byPersonId": "pol:narendra-modi",
      "office": "Prime Minister (Cabinet chair)",
      "srcs": [
        [
          "PIB, Cabinet approves Central Sector Scheme for providing drones to women SHGs (₹1,261 crore), 29 Nov 2023",
          "https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=1980683"
        ]
      ]
    },
    "approved": {
      "date": "2023-11-29",
      "body": "Union Cabinet",
      "srcs": [
        [
          "PIB, Cabinet approves Central Sector Scheme for providing drones to women SHGs (₹1,261 crore), 29 Nov 2023",
          "https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=1980683"
        ]
      ]
    },
    "launched": {
      "date": "2023-11-29",
      "srcs": [
        [
          "PIB, Cabinet approves Central Sector Scheme for providing drones to women SHGs (₹1,261 crore), 29 Nov 2023",
          "https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=1980683"
        ],
        [
          "PIB (MoA&FW reply), Implementation of Namo Drone Didi scheme, 29 Jul 2025",
          "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2149706"
        ]
      ]
    },
    "benefit": {
      "amount": 800000,
      "unit": "₹ maximum central assistance (80% of drone package) per SHG; balance via AIF loan at 3% subvention",
      "changes": []
    },
    "eligibility": "15,000 selected women SHGs in economically feasible clusters",
    "beneficiaries": [
      {
        "asOf": "2024-03-31",
        "count": 1094,
        "srcs": [
          [
            "PIB (MoA&FW reply), Implementation of Namo Drone Didi scheme, 29 Jul 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2149706"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2023-26",
        "budgetedCr": 1261,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB, Cabinet approves Central Sector Scheme for providing drones to women SHGs (₹1,261 crore), 29 Nov 2023",
            "https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=1980683"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Lok Sabha 2024",
      "date": "2024-04-19",
      "monthsFromLaunch": 4.7,
      "incumbentParty": "BJP (NDA)",
      "result": "incumbent won (BJP −63)",
      "seatChange": null,
      "srcs": [
        [
          "Wikipedia (pointer), 2024 Indian general election",
          "https://en.wikipedia.org/wiki/2024_Indian_general_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2025-07-29",
        "status": "live",
        "note": "ADRTC study: 42.68% of drone didis faced transport problems; provision for utility vehicles added",
        "srcs": [
          [
            "PIB (MoA&FW reply), Implementation of Namo Drone Didi scheme, 29 Jul 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2149706"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "ADRTC Bengaluru viability study on the first 500 drones: one acre sprayed in 7–8 minutes; transport costs a binding constraint",
        "tier": "reported",
        "srcs": [
          [
            "PIB (MoA&FW reply), Implementation of Namo Drone Didi scheme, 29 Jul 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2149706"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:narendra-modi",
        "role": "Prime Minister",
        "action": "approved",
        "date": "2023-11-29",
        "party": "BJP",
        "srcs": [
          [
            "PIB, Cabinet approves Central Sector Scheme for providing drones to women SHGs (₹1,261 crore), 29 Nov 2023",
            "https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=1980683"
          ]
        ]
      },
      {
        "personId": "pol:shivraj-singh-chouhan",
        "role": "Union Minister of Agriculture & Farmers' Welfare",
        "action": "administers",
        "date": "2025-07-29",
        "party": "BJP",
        "srcs": [
          [
            "PIB (MoA&FW reply), Implementation of Namo Drone Didi scheme, 29 Jul 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2149706"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "Lead Fertilizer Companies (unnamed in release) and drone manufacturers",
        "how": "LFCs procure drones, act as intermediaries and are directed to promote their own Nano Urea / Nano DAP through SHG spraying",
        "amountCr": 1261,
        "tier": "documented",
        "srcs": [
          [
            "PIB, Cabinet approves Central Sector Scheme for providing drones to women SHGs (₹1,261 crore), 29 Nov 2023",
            "https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=1980683"
          ],
          [
            "PIB (MoA&FW reply), Implementation of Namo Drone Didi scheme, 29 Jul 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2149706"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "PIB, Cabinet approves Central Sector Scheme for providing drones to women SHGs (₹1,261 crore), 29 Nov 2023",
        "https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=1980683"
      ],
      [
        "PIB (MoA&FW reply), Implementation of Namo Drone Didi scheme, 29 Jul 2025",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2149706"
      ]
    ],
    "domain": "central"
  },
  {
    "id": "scheme:in-nfsa",
    "name": "National Food Security Act, 2013",
    "al": [
      "NFSA",
      "Food Security Act",
      "Right to Food Act",
      "PDS",
      "TPDS",
      "NFSA PDS"
    ],
    "level": "central",
    "st": null,
    "applicableStates": "all",
    "category": "grain",
    "party": "INC (UPA)",
    "announced": {
      "date": "2011-12-22",
      "byPersonId": "wel:kv-thomas",
      "office": "Minister of State (IC), Consumer Affairs, Food & Public Distribution, 2011 → 2014-05",
      "srcs": [
        [
          "Wikipedia (pointer), National Food Security Act 2013",
          "https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"
        ],
        [
          "Wikipedia (pointer), K. V. Thomas",
          "https://en.wikipedia.org/wiki/K._V._Thomas"
        ]
      ]
    },
    "approved": {
      "date": "2013-07-05",
      "body": "Presidential ordinance (Cabinet), then Lok Sabha 26 Aug 2013, gazette 10 Sep 2013",
      "srcs": [
        [
          "Wikipedia (pointer), National Food Security Act 2013",
          "https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"
        ]
      ]
    },
    "launched": {
      "date": "2013-07-05",
      "srcs": [
        [
          "Wikipedia (pointer), National Food Security Act 2013",
          "https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"
        ]
      ]
    },
    "benefit": {
      "amount": 5,
      "unit": "kg foodgrain per person per month at ₹3/2/1 per kg (rice/wheat/coarse grain); AAY households 35 kg",
      "changes": [
        {
          "date": "2023-01-01",
          "amount": 5,
          "note": "made free of cost for 2023 (₹0/kg) — merged with PMGKAY",
          "srcs": [
            [
              "Wikipedia (pointer), PMGKAY",
              "https://en.wikipedia.org/wiki/Pradhan_Mantri_Garib_Kalyan_Anna_Yojana"
            ],
            [
              "PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023",
              "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"
            ]
          ]
        },
        {
          "date": "2024-01-01",
          "amount": 5,
          "note": "free for five years to Dec 2028 under PMGKAY",
          "srcs": [
            [
              "PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023",
              "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"
            ]
          ]
        }
      ]
    },
    "eligibility": "up to 75% of rural and 50% of urban population (state-wise ceilings set by Centre; identification by states)",
    "beneficiaries": [
      {
        "asOf": "2023-11-29",
        "count": 813500000,
        "srcs": [
          [
            "PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2013-14",
        "budgetedCr": null,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Wikipedia (pointer), National Food Security Act 2013",
            "https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"
          ]
        ]
      },
      {
        "fy": "2023-24",
        "budgetedCr": null,
        "actualCr": 213000,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Wikipedia (pointer), PMGKAY",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Garib_Kalyan_Anna_Yojana"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Lok Sabha 2014",
      "date": "2014-04-07",
      "monthsFromLaunch": 9,
      "incumbentParty": "INC (UPA)",
      "result": "incumbent lost",
      "seatChange": "INC −162 (206→44)",
      "srcs": [
        [
          "Wikipedia (pointer), 2014 Indian general election",
          "https://en.wikipedia.org/wiki/2014_Indian_general_election"
        ],
        [
          "Wikipedia (pointer), National Food Security Act 2013",
          "https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"
        ]
      ]
    },
    "status": [
      {
        "date": "2020-03-26",
        "status": "raised",
        "note": "additional free 5 kg/person under PMGKAY (COVID)",
        "srcs": [
          [
            "PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"
          ]
        ]
      },
      {
        "date": "2023-01-01",
        "status": "raised",
        "note": "NFSA grain made free for 2023; PMGKAY additional grain ended Dec 2022",
        "srcs": [
          [
            "Wikipedia (pointer), PMGKAY",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Garib_Kalyan_Anna_Yojana"
          ]
        ]
      },
      {
        "date": "2024-01-01",
        "status": "live",
        "note": "free grain continued to Dec 2028",
        "srcs": [
          [
            "PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "BJP (2013): 'This isn't food security, it's vote security' — the Act attacked as pre-poll politics",
        "tier": "alleged",
        "srcs": [
          [
            "Wikipedia (pointer), National Food Security Act 2013",
            "https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"
          ]
        ]
      },
      {
        "finding": "Minister K.V. Thomas defended implementation as a joint Centre-state task; economist Jean Drèze (former NAC member) called it an investment in human capital",
        "tier": "reported",
        "srcs": [
          [
            "Wikipedia (pointer), National Food Security Act 2013",
            "https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"
          ]
        ]
      },
      {
        "finding": "Lokniti-CSDS 2024: PDS is the most widely received benefit — 67.4% of households; 54.7% credit the Centre, 35.1% the state",
        "tier": "documented",
        "srcs": [
          [
            "Lokniti-CSDS, Social and Political Barometer Post-poll Study 2024 — Survey Findings (PDF on file, dated 14 Jun 2024; exact URL not recovered — see gaps)",
            "https://www.lokniti.org/"
          ]
        ]
      },
      {
        "finding": "Muralidharan, Niehaus & Sukhtankar (NBER 26744, revised): integrating stricter biometric ID requirements into 'India's largest social protection program' (PDS; Jharkhand) reduced corruption 'but with substantial costs to legitimate beneficiaries, 1.5–2 million of whom lost access to benefits at some point'; adverse effects driven by how the transition was managed. This is the exclusion-error counterweight to the leakage gains in the AP Smartcards study.",
        "tier": "documented",
        "srcs": [
          [
            "Muralidharan, Niehaus & Sukhtankar, 'Identity Verification Standards in Welfare Programs: Experimental Evidence from India', NBER WP 26744 (Feb 2020, revised) — abstract",
            "https://www.nber.org/papers/w26744"
          ]
        ]
      },
      {
        "finding": "Khera (EPW, 16 Dec 2017): Aadhaar ‘is becoming a tool of exclusion’ in welfare; claimed savings often represent denial of legitimate entitlements rather than efficiency; the project ‘in its current form … undermines the right to life’.",
        "tier": "documented",
        "srcs": [
          [
            "Khera (2017) Impact of Aadhaar on Welfare Programmes — EPW 52(50), 16 Dec 2017 (EPW page opened)",
            "https://www.epw.in/journal/2017/50/special-articles/impact-aadhaar-welfare-programmes.html"
          ]
        ]
      },
      {
        "finding": "Drèze, Khalid, Khera & Somanchi (EPW, 16 Dec 2017) ‘Aadhaar and Food Security in Jharkhand: Pain without Gain?’ — field survey of Aadhaar-based biometric authentication in Jharkhand’s PDS; exclusion and transaction-failure figures are in the full text, which was not extracted here.",
        "tier": "documented",
        "srcs": [
          [
            "Drèze, Khalid, Khera & Somanchi (2017) Aadhaar and Food Security in Jharkhand: Pain without Gain? — EPW 52(50), 16 Dec 2017 (EPW page opened; full text not extracted)",
            "https://www.epw.in/journal/2017/50/special-articles/aadhaar-and-food-security-jharkhand.html"
          ]
        ]
      },
      {
        "finding": "Muralidharan, Niehaus & Sukhtankar (REStat 2025; NBER 2020) — randomised evaluation of identity-verification (ABBA) standards in Jharkhand’s PDS; findings on exclusion versus leakage not re-read in this sweep.",
        "tier": "reported",
        "srcs": [
          [
            "Muralidharan, Niehaus & Sukhtankar (2025) Identity Verification Standards in Welfare Programs: Experimental Evidence from India — REStat 107(2):372–392; NBER w26744 (2020) (Crossref metadata)",
            "https://api.crossref.org/works/10.1162/rest_a_01296"
          ]
        ]
      },
      {
        "finding": "Deshpande, Tillin & Kailash (2019): PDS and old-age pensions are still more likely to be credited to state governments, unlike Ujjwala/Jan Dhan, which voters credit to the Centre.",
        "tier": "documented",
        "srcs": [
          [
            "Deshpande, Tillin & Kailash (2019) The BJP’s Welfare Schemes: Did They Make a Difference in the 2019 Elections? — Studies in Indian Politics 7(2):219–233 (Crossref metadata + abstract)",
            "https://api.crossref.org/works/10.1177/2321023019874911"
          ]
        ]
      },
      {
        "finding": "Khera (Food Policy 2014): Indian survey data on cash versus in-kind preferences — beneficiaries’ preference for grain over cash depends on market access and PDS functioning; figures not re-read.",
        "tier": "reported",
        "srcs": [
          [
            "Khera (2014) Cash vs. in-kind transfers: Indian data meets theory — Food Policy 46:116–128 (Crossref metadata)",
            "https://api.crossref.org/works/10.1016/j.foodpol.2014.03.009"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:kv-thomas",
        "role": "MoS (IC) Consumer Affairs, Food & PD",
        "action": "administers",
        "date": "2013-07-05",
        "party": "INC",
        "srcs": [
          [
            "Wikipedia (pointer), K. V. Thomas",
            "https://en.wikipedia.org/wiki/K._V._Thomas"
          ],
          [
            "Wikipedia (pointer), National Food Security Act 2013",
            "https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"
          ]
        ]
      },
      {
        "personId": "wel:manmohan-singh",
        "role": "Prime Minister",
        "action": "approved",
        "date": "2013-07-05",
        "party": "INC",
        "srcs": [
          [
            "Wikipedia (pointer), National Food Security Act 2013",
            "https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "fair price shop dealers (~5 lakh)",
        "how": "dealer margins reimbursed by Centre under NFSA; network kept alive by free-grain volumes",
        "amountCr": null,
        "tier": "documented",
        "srcs": [
          [
            "Wikipedia (pointer), National Food Security Act 2013",
            "https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"
          ],
          [
            "PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Wikipedia (pointer), National Food Security Act 2013",
        "https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"
      ],
      [
        "PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"
      ],
      [
        "Muralidharan, Niehaus & Sukhtankar, 'Identity Verification Standards in Welfare Programs: Experimental Evidence from India', NBER WP 26744 (Feb 2020, revised) — abstract",
        "https://www.nber.org/papers/w26744"
      ],
      [
        "Khera (2017) Impact of Aadhaar on Welfare Programmes — EPW 52(50), 16 Dec 2017 (EPW page opened)",
        "https://www.epw.in/journal/2017/50/special-articles/impact-aadhaar-welfare-programmes.html"
      ],
      [
        "Drèze, Khalid, Khera & Somanchi (2017) Aadhaar and Food Security in Jharkhand: Pain without Gain? — EPW 52(50), 16 Dec 2017 (EPW page opened; full text not extracted)",
        "https://www.epw.in/journal/2017/50/special-articles/aadhaar-and-food-security-jharkhand.html"
      ],
      [
        "Deshpande, Tillin & Kailash (2019) The BJP’s Welfare Schemes: Did They Make a Difference in the 2019 Elections? — Studies in Indian Politics 7(2):219–233 (Crossref metadata + abstract)",
        "https://api.crossref.org/works/10.1177/2321023019874911"
      ]
    ],
    "domain": "central"
  },
  {
    "id": "scheme:in-nsap",
    "name": "National Social Assistance Programme (IGNOAPS, IGNWPS, IGNDPS, NFBS, Annapurna)",
    "al": [
      "NSAP",
      "Indira Gandhi National Old Age Pension Scheme",
      "IGNOAPS"
    ],
    "level": "central",
    "st": null,
    "applicableStates": "all",
    "category": "pension",
    "party": "INC (introduced 1995); administered by all governments since",
    "announced": {
      "date": "1995-08-15",
      "byPersonId": null,
      "office": "Government of India (PM P.V. Narasimha Rao era; announcing minister not verified here)",
      "srcs": [
        [
          "PIB Backgrounder, National Social Assistance Programme, 7 Nov 2025",
          "https://www.pib.gov.in/PressNoteDetails.aspx?NoteId=155928&ModuleId=3"
        ]
      ]
    },
    "approved": {
      "date": "1995-08-15",
      "body": "Centrally Sponsored Scheme, Ministry of Rural Development",
      "srcs": [
        [
          "PIB Backgrounder, National Social Assistance Programme, 7 Nov 2025",
          "https://www.pib.gov.in/PressNoteDetails.aspx?NoteId=155928&ModuleId=3"
        ]
      ]
    },
    "launched": {
      "date": "1995-08-15",
      "srcs": [
        [
          "PIB Backgrounder, National Social Assistance Programme, 7 Nov 2025",
          "https://www.pib.gov.in/PressNoteDetails.aspx?NoteId=155928&ModuleId=3"
        ]
      ]
    },
    "benefit": {
      "amount": 200,
      "unit": "₹ per month central share, old-age pension 60–79 (₹500 for 80+); widow/disability ₹300 (₹500 for 80+); NFBS ₹20,000 lump sum",
      "changes": [
        {
          "date": "2020-03-26",
          "amount": 1000,
          "note": "one-off ₹1,000 ex gratia to ~3 crore poor elderly, widows, disabled (COVID package)",
          "srcs": [
            [
              "PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020",
              "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"
            ]
          ]
        }
      ]
    },
    "eligibility": "BPL individuals; state-wise beneficiary ceilings; states top up ₹50–₹5,700/month (average pension ~₹1,100 in many states)",
    "beneficiaries": [
      {
        "asOf": "2025-11-07",
        "count": 30900000,
        "srcs": [
          [
            "PIB Backgrounder, National Social Assistance Programme, 7 Nov 2025",
            "https://www.pib.gov.in/PressNoteDetails.aspx?NoteId=155928&ModuleId=3"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2025-26",
        "budgetedCr": 9652,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB Backgrounder, National Social Assistance Programme, 7 Nov 2025",
            "https://www.pib.gov.in/PressNoteDetails.aspx?NoteId=155928&ModuleId=3"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "none specific — the notable fact is the absence of any pre-election raise across five general elections",
      "date": null,
      "monthsFromLaunch": null,
      "incumbentParty": null,
      "result": null,
      "seatChange": null,
      "srcs": [
        [
          "PIB Backgrounder, National Social Assistance Programme, 7 Nov 2025",
          "https://www.pib.gov.in/PressNoteDetails.aspx?NoteId=155928&ModuleId=3"
        ]
      ]
    },
    "status": [
      {
        "date": "2025-11-07",
        "status": "live",
        "note": "central share ₹200/month for 60–79 unchanged; the claim that it has been ₹200 since 2007 is consistent with the 2025 figure but the 2007 notification was not opened here (gap)",
        "srcs": [
          [
            "PIB Backgrounder, National Social Assistance Programme, 7 Nov 2025",
            "https://www.pib.gov.in/PressNoteDetails.aspx?NoteId=155928&ModuleId=3"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "94% of disbursement by DBT; >2.5 crore Aadhaar-linked; Aadhaar-based digital life certificate app launched 15 Jul 2025",
        "tier": "documented",
        "srcs": [
          [
            "PIB Backgrounder, National Social Assistance Programme, 7 Nov 2025",
            "https://www.pib.gov.in/PressNoteDetails.aspx?NoteId=155928&ModuleId=3"
          ]
        ]
      },
      {
        "finding": "Muralidharan-Niehaus-Sukhtankar (AER 2016): Smartcard payments cut leakage in AP social security pensions as well as NREGS",
        "tier": "documented",
        "srcs": [
          [
            "Muralidharan, Niehaus & Sukhtankar, 'Building State Capacity: Evidence from Biometric Smartcards in India', AER 106(10), 2016",
            "https://www.aeaweb.org/articles?id=10.1257/aer.20141346"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:shivraj-singh-chouhan",
        "role": "Union Minister of Rural Development",
        "action": "administers",
        "date": "2025-07-15",
        "party": "BJP",
        "srcs": [
          [
            "PIB Backgrounder, National Social Assistance Programme, 7 Nov 2025",
            "https://www.pib.gov.in/PressNoteDetails.aspx?NoteId=155928&ModuleId=3"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "state governments",
        "how": "states carry the politically salient top-up (₹50–₹5,700) on a frozen central base of ₹200",
        "amountCr": null,
        "tier": "documented",
        "srcs": [
          [
            "PIB Backgrounder, National Social Assistance Programme, 7 Nov 2025",
            "https://www.pib.gov.in/PressNoteDetails.aspx?NoteId=155928&ModuleId=3"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "PIB Backgrounder, National Social Assistance Programme, 7 Nov 2025",
        "https://www.pib.gov.in/PressNoteDetails.aspx?NoteId=155928&ModuleId=3"
      ],
      [
        "PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"
      ]
    ],
    "domain": "central"
  },
  {
    "id": "scheme:in-pm-vishwakarma",
    "name": "PM Vishwakarma",
    "al": [
      "PM Vishwakarma Kaushal Samman",
      "PM VIKAS",
      "विश्वकर्मा योजना"
    ],
    "level": "central",
    "st": null,
    "applicableStates": "all",
    "category": "other",
    "party": "BJP (NDA)",
    "announced": {
      "date": "2023-02-01",
      "byPersonId": "pol:nirmala-sitharaman",
      "office": "Union Finance Minister",
      "srcs": [
        [
          "Union Budget 2023-24 speech, Nirmala Sitharaman, 1 Feb 2023",
          "https://www.indiabudget.gov.in/budget2023-24/doc/Budget_Speech.pdf"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Union Cabinet (approval widely reported as 16 Aug 2023; not verified from a document opened here)",
      "srcs": [
        [
          "PIB (MSME RS reply), PM Vishwakarma outlay ₹13,000 crore and year-wise allocation, 21 Dec 2023",
          "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1989108"
        ]
      ]
    },
    "launched": {
      "date": "2023-09-17",
      "srcs": [
        [
          "PIB Research Unit backgrounder 'PM Vishwakarma Scheme: Honouring Heritage, Powering Progress', 16 Sep 2025 (PDF on file; exact document URL not recovered — see gaps)",
          "https://www.pib.gov.in/"
        ],
        [
          "PIB (MSME RS reply), PM Vishwakarma outlay ₹13,000 crore and year-wise allocation, 21 Dec 2023",
          "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1989108"
        ]
      ]
    },
    "benefit": {
      "amount": 15000,
      "unit": "₹ toolkit e-voucher; ₹500/day training stipend; collateral-free loans ₹1 lakh then ₹2 lakh at 5% (interest subvention); digital-transaction incentive",
      "changes": []
    },
    "eligibility": "artisans in 18 hand-and-tool trades, 18+, unorganised, one member per family, no PMEGP/MUDRA/SVANidhi loan in 5 years, no government employee in family",
    "beneficiaries": [
      {
        "asOf": "2023-12-18",
        "count": 57815,
        "srcs": [
          [
            "PIB (MSME RS reply), PM Vishwakarma outlay ₹13,000 crore and year-wise allocation, 21 Dec 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1989108"
          ]
        ]
      },
      {
        "asOf": "2025-08-31",
        "count": 3000000,
        "srcs": [
          [
            "PIB Research Unit backgrounder 'PM Vishwakarma Scheme: Honouring Heritage, Powering Progress', 16 Sep 2025 (PDF on file; exact document URL not recovered — see gaps)",
            "https://www.pib.gov.in/"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2023-24",
        "budgetedCr": 1860,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MSME RS reply), PM Vishwakarma outlay ₹13,000 crore and year-wise allocation, 21 Dec 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1989108"
          ]
        ]
      },
      {
        "fy": "2024-25",
        "budgetedCr": 4824,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MSME RS reply), PM Vishwakarma outlay ₹13,000 crore and year-wise allocation, 21 Dec 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1989108"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 3009,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MSME RS reply), PM Vishwakarma outlay ₹13,000 crore and year-wise allocation, 21 Dec 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1989108"
          ]
        ]
      },
      {
        "fy": "2023-31",
        "budgetedCr": 13000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MSME RS reply), PM Vishwakarma outlay ₹13,000 crore and year-wise allocation, 21 Dec 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1989108"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Assembly polls Nov 2023; Lok Sabha 2024",
      "date": "2023-11-07",
      "monthsFromLaunch": 1.7,
      "incumbentParty": "BJP (Centre)",
      "result": "BJP won MP/CT/RJ; BJP 240 at LS 2024",
      "seatChange": null,
      "srcs": [
        [
          "Wikipedia (pointer), 2023 Chhattisgarh Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"
        ],
        [
          "Wikipedia (pointer), 2024 Indian general election",
          "https://en.wikipedia.org/wiki/2024_Indian_general_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2023-12-18",
        "status": "live",
        "note": "only 57,815 registrations and 133 certified three months after launch — slow start",
        "srcs": [
          [
            "PIB (MSME RS reply), PM Vishwakarma outlay ₹13,000 crore and year-wise allocation, 21 Dec 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1989108"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Registration scaled to ~30 lakh by Aug 2025 with ₹41,188 cr loans approved (government backgrounder); no independent evaluation found in this sweep",
        "tier": "reported",
        "srcs": [
          [
            "PIB Research Unit backgrounder 'PM Vishwakarma Scheme: Honouring Heritage, Powering Progress', 16 Sep 2025 (PDF on file; exact document URL not recovered — see gaps)",
            "https://www.pib.gov.in/"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:nirmala-sitharaman",
        "role": "Union Finance Minister",
        "action": "announced",
        "date": "2023-02-01",
        "party": "BJP",
        "srcs": [
          [
            "Union Budget 2023-24 speech, Nirmala Sitharaman, 1 Feb 2023",
            "https://www.indiabudget.gov.in/budget2023-24/doc/Budget_Speech.pdf"
          ]
        ]
      },
      {
        "personId": "pol:narendra-modi",
        "role": "Prime Minister",
        "action": "announced",
        "date": "2023-09-17",
        "party": "BJP",
        "srcs": [
          [
            "PIB Research Unit backgrounder 'PM Vishwakarma Scheme: Honouring Heritage, Powering Progress', 16 Sep 2025 (PDF on file; exact document URL not recovered — see gaps)",
            "https://www.pib.gov.in/"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "scheduled banks, RRBs, SFBs, NBFC-MFIs",
        "how": "₹41,188 cr of guaranteed, interest-subvented micro-loans",
        "amountCr": 41188,
        "tier": "reported",
        "srcs": [
          [
            "PIB Research Unit backgrounder 'PM Vishwakarma Scheme: Honouring Heritage, Powering Progress', 16 Sep 2025 (PDF on file; exact document URL not recovered — see gaps)",
            "https://www.pib.gov.in/"
          ]
        ]
      },
      {
        "who": "toolkit vendors on the e-voucher platform",
        "how": "₹15,000 vouchers × ~23 lakh redeemed ≈ ₹3,450 cr of directed demand",
        "amountCr": 3450,
        "tier": "analytic",
        "srcs": [
          [
            "PIB Research Unit backgrounder 'PM Vishwakarma Scheme: Honouring Heritage, Powering Progress', 16 Sep 2025 (PDF on file; exact document URL not recovered — see gaps)",
            "https://www.pib.gov.in/"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Union Budget 2023-24 speech, Nirmala Sitharaman, 1 Feb 2023",
        "https://www.indiabudget.gov.in/budget2023-24/doc/Budget_Speech.pdf"
      ],
      [
        "PIB (MSME RS reply), PM Vishwakarma outlay ₹13,000 crore and year-wise allocation, 21 Dec 2023",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1989108"
      ],
      [
        "PIB Research Unit backgrounder 'PM Vishwakarma Scheme: Honouring Heritage, Powering Progress', 16 Sep 2025 (PDF on file; exact document URL not recovered — see gaps)",
        "https://www.pib.gov.in/"
      ],
      [
        "Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)",
        "https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"
      ]
    ],
    "domain": "central"
  },
  {
    "id": "scheme:in-pmay-g",
    "name": "Pradhan Mantri Awaas Yojana – Gramin",
    "al": [
      "PMAY-G",
      "PM Awas",
      "Indira Awaas Yojana (predecessor)"
    ],
    "level": "central",
    "st": null,
    "applicableStates": "all",
    "category": "housing",
    "party": "BJP (NDA)",
    "announced": {
      "date": "2015-06-01",
      "byPersonId": "pol:narendra-modi",
      "office": "Prime Minister",
      "srcs": [
        [
          "Wikipedia (pointer), Pradhan Mantri Awas Yojana",
          "https://en.wikipedia.org/wiki/Pradhan_Mantri_Awas_Yojana"
        ],
        [
          "PIB (MoRD), PMAY-G progress and Cabinet approval of 2 crore more houses, 7 Feb 2025",
          "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2100659"
        ]
      ]
    },
    "approved": {
      "date": "2024-08-01",
      "body": "Union Cabinet — 2 crore additional houses FY 2024-25 to 2028-29 (exact Cabinet date not in the PIB text)",
      "srcs": [
        [
          "PIB (MoRD), PMAY-G progress and Cabinet approval of 2 crore more houses, 7 Feb 2025",
          "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2100659"
        ]
      ]
    },
    "launched": {
      "date": "2016-04-01",
      "srcs": [
        [
          "PIB (MoRD), PMAY-G progress and Cabinet approval of 2 crore more houses, 7 Feb 2025",
          "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2100659"
        ]
      ]
    },
    "benefit": {
      "amount": 120000,
      "unit": "₹ unit assistance per house (plains; ₹1.30 lakh hilly) — figure per scheme norms, not restated in the sources opened; treat as unverified here",
      "changes": []
    },
    "eligibility": "houseless / kutcha-house households per SECC-2011 and Awaas+ survey",
    "beneficiaries": [
      {
        "asOf": "2025-02-02",
        "count": 26900000,
        "srcs": [
          [
            "PIB (MoRD), PMAY-G progress and Cabinet approval of 2 crore more houses, 7 Feb 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2100659"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2024-25",
        "budgetedCr": null,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MoRD), PMAY-G progress and Cabinet approval of 2 crore more houses, 7 Feb 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2100659"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Lok Sabha 2024 — interim budget promise of 2 crore more houses",
      "date": "2024-04-19",
      "monthsFromLaunch": 2.5,
      "incumbentParty": "BJP (NDA)",
      "result": "incumbent won (BJP −63)",
      "seatChange": "BJP 303→240",
      "srcs": [
        [
          "Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)",
          "https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"
        ],
        [
          "Wikipedia (pointer), 2024 Indian general election",
          "https://en.wikipedia.org/wiki/2024_Indian_general_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2024-02-01",
        "status": "raised",
        "note": "interim budget: 'close to three crore houses'; two crore more over five years",
        "srcs": [
          [
            "Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)",
            "https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"
          ]
        ]
      },
      {
        "date": "2025-02-07",
        "status": "live",
        "note": null,
        "srcs": [
          [
            "PIB (MoRD), PMAY-G progress and Cabinet approval of 2 crore more houses, 7 Feb 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2100659"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Lokniti-CSDS 2024: 25.3% of households report a housing-scheme benefit; 63.9% credit the Centre",
        "tier": "documented",
        "srcs": [
          [
            "Lokniti-CSDS, Social and Political Barometer Post-poll Study 2024 — Survey Findings (PDF on file, dated 14 Jun 2024; exact URL not recovered — see gaps)",
            "https://www.lokniti.org/"
          ]
        ]
      },
      {
        "finding": "Government cites evaluations by NIPFP, NITI Aayog and NIRD&PR (findings not reproduced in the release)",
        "tier": "reported",
        "srcs": [
          [
            "PIB (MoRD), PMAY-G progress and Cabinet approval of 2 crore more houses, 7 Feb 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2100659"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:nirmala-sitharaman",
        "role": "Union Finance Minister",
        "action": "presented budget",
        "date": "2024-02-01",
        "party": "BJP",
        "srcs": [
          [
            "Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)",
            "https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"
          ]
        ]
      },
      {
        "personId": "pol:shivraj-singh-chouhan",
        "role": "Union Minister of Rural Development, 2024-06 →",
        "action": "administers",
        "date": "2025-02-07",
        "party": "BJP",
        "srcs": [
          [
            "PIB (MoRD), PMAY-G progress and Cabinet approval of 2 crore more houses, 7 Feb 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2100659"
          ],
          [
            "Akashvani News, Rajya Sabha takes up VB-G RAM G Bill, 18 Dec 2025",
            "https://www.newsonair.gov.in/lok-sabha-considers-viksit-bharat-bill-to-replace-2005-rural-employment-scheme"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "cement, steel and building-materials suppliers; rural masons",
        "how": "beneficiary-led construction of ~80 lakh houses/yr channels unit assistance into materials and labour",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "PIB (MoRD), PMAY-G progress and Cabinet approval of 2 crore more houses, 7 Feb 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2100659"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "PIB (MoRD), PMAY-G progress and Cabinet approval of 2 crore more houses, 7 Feb 2025",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2100659"
      ],
      [
        "Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)",
        "https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"
      ],
      [
        "Wikipedia (pointer), Pradhan Mantri Awas Yojana",
        "https://en.wikipedia.org/wiki/Pradhan_Mantri_Awas_Yojana"
      ]
    ],
    "domain": "central"
  },
  {
    "id": "scheme:jh-maiya-samman",
    "name": "Mukhyamantri Maiya Samman Yojana",
    "al": [
      "MMMSY",
      "Maiya Samman",
      "Maiyan Samman",
      "JMMSY"
    ],
    "level": "state",
    "st": "jh",
    "applicableStates": null,
    "category": "women-cash",
    "party": "JMM",
    "announced": {
      "date": "2024-08-01",
      "byPersonId": "wel:hemant-soren",
      "office": "Chief Minister, Jharkhand",
      "srcs": [
        [
          "IMPRI — Maiya Samman Yojana policy update",
          "https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Jharkhand Cabinet",
      "srcs": [
        [
          "Deccan Herald/PTI, 14 Oct 2024: Jharkhand cabinet raises Maiya Samman to Rs 2,500 from Dec 2024",
          "https://www.deccanherald.com/india/jharkhand/jharkhand-cabinet-nod-to-hike-financial-assistance-for-women-to-rs-30000-per-year-from-rs-12000-3231863"
        ]
      ]
    },
    "launched": {
      "date": "2024-08-18",
      "srcs": [
        [
          "IMPRI — Maiya Samman Yojana policy update",
          "https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"
        ]
      ]
    },
    "benefit": {
      "amount": 1000,
      "unit": "₹ per month (initial; range ₹1,000-1,500 by category)",
      "changes": [
        {
          "date": "2025-01-01",
          "amount": 2500,
          "note": "Raised to ₹2,500/month after the JMM-led alliance won the November 2024 election, fulfilling a campaign promise to raise the amount if re-elected.",
          "srcs": [
            [
              "IMPRI — Maiya Samman Yojana policy update",
              "https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"
            ]
          ]
        },
        {
          "date": null,
          "amount": 2500,
          "note": "PRS: in October 2024 Jharkhand raised the payout from ₹1,000 to ₹2,500 — weeks before the Nov 2024 assembly election (month-level date)",
          "srcs": [
            [
              "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
              "https://prsindia.org/files/budget/SOSF_2025.pdf"
            ]
          ]
        },
        {
          "date": "2024-12",
          "amount": 2500,
          "note": "Cabinet nod 14 Oct 2024 (one month before polling) to raise to Rs 2,500 from Dec 2024 for 50 lakh women; 'additional Rs 9,000 crore burden' (Cabinet Secretary Vandana Dadel); BJP counter-promised Rs 25,000/yr",
          "srcs": [
            [
              "Deccan Herald/PTI, 14 Oct 2024: Jharkhand cabinet raises Maiya Samman to Rs 2,500 from Dec 2024",
              "https://www.deccanherald.com/india/jharkhand/jharkhand-cabinet-nod-to-hike-financial-assistance-for-women-to-rs-30000-per-year-from-rs-12000-3231863"
            ]
          ]
        }
      ]
    },
    "eligibility": "women aged 21-50, income and other criteria",
    "beneficiaries": [
      {
        "asOf": "2025-01-01",
        "count": 5600000,
        "srcs": [
          [
            "IMPRI — Maiya Samman Yojana policy update",
            "https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"
          ]
        ]
      },
      {
        "asOf": "2024-10",
        "count": 5000000,
        "srcs": [
          [
            "Deccan Herald/PTI, 14 Oct 2024: Jharkhand cabinet raises Maiya Samman to Rs 2,500 from Dec 2024",
            "https://www.deccanherald.com/india/jharkhand/jharkhand-cabinet-nod-to-hike-financial-assistance-for-women-to-rs-30000-per-year-from-rs-12000-3231863"
          ]
        ]
      },
      {
        "asOf": "2026-02",
        "count": 5661000,
        "srcs": [
          [
            "IMPRI policy update: Mukhyamantri Maiya Samman Yojana in practice",
            "https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2025-26",
        "budgetedCr": 13363,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 13363,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ],
          [
            "IMPRI policy update: Mukhyamantri Maiya Samman Yojana in practice",
            "https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"
          ]
        ]
      },
      {
        "fy": "2026-27",
        "budgetedCr": 14066,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "IMPRI policy update: Mukhyamantri Maiya Samman Yojana in practice",
            "https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Jharkhand assembly",
      "date": "2024-11-13",
      "monthsFromLaunch": 3,
      "incumbentParty": "JMM-led (JMM-INC-RJD)",
      "result": "incumbent won",
      "seatChange": "JMM-led alliance 47(2019 combined)→56 seats, NDA 25→24",
      "srcs": [
        [
          "Republic World — Jharkhand 2024 result, JMM alliance 56 seats",
          "https://www.republicworld.com/elections/jharkhand-election-results-2024-live-updates-assembly-election-results-today-hemant-sorens-jmm-bjp-congress-winners-live-news"
        ]
      ]
    },
    "status": [
      {
        "date": "2025-01-01",
        "status": "raised",
        "note": "Amount doubled to ₹2,500/month immediately after re-election, fulfilling a campaign pledge — a post-election delivery, not a pre-election timing tactic, for the hike itself.",
        "srcs": [
          [
            "IMPRI — Maiya Samman Yojana policy update",
            "https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"
          ]
        ]
      },
      {
        "date": null,
        "status": "raised",
        "note": "₹1,000 → ₹2,500 per month (PRS).",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "date": "2024-08-18",
        "status": "live",
        "note": null,
        "srcs": [
          [
            "IMPRI policy update: Mukhyamantri Maiya Samman Yojana in practice",
            "https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"
          ]
        ]
      },
      {
        "date": "2024-12",
        "status": "raised",
        "note": "Rs 2,500 (Jan 2025 payment of two instalments)",
        "srcs": [
          [
            "Deccan Herald/PTI, 14 Oct 2024: Jharkhand cabinet raises Maiya Samman to Rs 2,500 from Dec 2024",
            "https://www.deccanherald.com/india/jharkhand/jharkhand-cabinet-nod-to-hike-financial-assistance-for-women-to-rs-30000-per-year-from-rs-12000-3231863"
          ],
          [
            "IMPRI policy update: Mukhyamantri Maiya Samman Yojana in practice",
            "https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"
          ]
        ]
      },
      {
        "date": "2026-05-31",
        "status": "eligibility-tightened",
        "note": "verification deadline; phased district-wise payments; arrears released in batches",
        "srcs": [
          [
            "IMPRI policy update: Mukhyamantri Maiya Samman Yojana in practice",
            "https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Launched three months before the poll and the incumbent alliance won with an increased seat count — consistent with, though not proof of, a scheme-timing effect; BJP's own welfare counter-offers and Hemant Soren's high-profile arrest-and-bail narrative in 2024 are confounding factors this file cannot separate from the scheme's own effect.",
        "tier": "analytic",
        "srcs": []
      },
      {
        "finding": "Highest fiscal weight of any women's UCT in India: 12.1% of Jharkhand's 2025-26 revenue expenditure (PRS).",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "RBI (Jun 2022) had already put Jharkhand's 2022-23 freebies (mainly free electricity up to 100 units) at 1.7% of GSDP, 8.0% of revenue receipts — third highest of nine states — and listed Jharkhand among the ten most indebted states.",
        "tier": "documented",
        "srcs": [
          [
            "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
            "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
          ]
        ]
      },
      {
        "finding": "Jharkhand's UCT is the largest relative to state finances among the 12 (PRS Fig.15 places JH highest, ~12% of revenue expenditure — read from chart, order unverified)",
        "tier": "analytic",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "PRS SOSF 2025 lists Jharkhand's Oct 2024 hike as the counter-case to Maharashtra's cut",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:hemant-soren",
        "role": "Chief Minister, Jharkhand",
        "action": "announced",
        "date": "2024-08-01",
        "party": "JMM",
        "srcs": [
          [
            "IMPRI — Maiya Samman Yojana policy update",
            "https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"
          ]
        ]
      },
      {
        "personId": "wel:hemant-soren",
        "role": "Chief Minister",
        "action": "announced",
        "date": "2024-08",
        "party": "JMM",
        "srcs": [
          [
            "IMPRI policy update: Mukhyamantri Maiya Samman Yojana in practice",
            "https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"
          ]
        ]
      },
      {
        "personId": "wel:hemant-soren",
        "role": "Chief Minister",
        "action": "approved",
        "date": "2024-10-14",
        "party": "JMM",
        "srcs": [
          [
            "Deccan Herald/PTI, 14 Oct 2024: Jharkhand cabinet raises Maiya Samman to Rs 2,500 from Dec 2024",
            "https://www.deccanherald.com/india/jharkhand/jharkhand-cabinet-nod-to-hike-financial-assistance-for-women-to-rs-30000-per-year-from-rs-12000-3231863"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "party:jmm",
        "how": "political: hike approved one month before polling; BJP matched with Rs 25,000/yr — a bidding war, not a one-sided inducement",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald/PTI, 14 Oct 2024: Jharkhand cabinet raises Maiya Samman to Rs 2,500 from Dec 2024",
            "https://www.deccanherald.com/india/jharkhand/jharkhand-cabinet-nod-to-hike-financial-assistance-for-women-to-rs-30000-per-year-from-rs-12000-3231863"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "IMPRI — Maiya Samman Yojana policy update",
        "https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
        "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
      ],
      [
        "IMPRI policy update: Mukhyamantri Maiya Samman Yojana in practice",
        "https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"
      ],
      [
        "Deccan Herald/PTI, 14 Oct 2024: Jharkhand cabinet raises Maiya Samman to Rs 2,500 from Dec 2024",
        "https://www.deccanherald.com/india/jharkhand/jharkhand-cabinet-nod-to-hike-financial-assistance-for-women-to-rs-30000-per-year-from-rs-12000-3231863"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:ka-anna-bhagya-2023",
    "name": "Anna Bhagya (2023 guarantee: 10 kg rice, paid as ₹170 cash in lieu of 5 kg)",
    "al": [
      "Annabhagya",
      "ಅನ್ನ ಭಾಗ್ಯ"
    ],
    "level": "state",
    "st": "ka",
    "applicableStates": null,
    "category": "grain",
    "party": "INC",
    "announced": {
      "date": "2023-05-10",
      "byPersonId": "wel:siddaramaiah",
      "office": "INC manifesto 2023; Siddaramaiah CM from 20 May 2023",
      "srcs": [
        [
          "The Tribune/IANS, 5 Jul 2018: Karnataka waives Rs 34,000 cr farm loans",
          "https://www.tribuneindia.com/news/archive/nation/karnataka-waives-rs-34-000-cr-farm-loans-615599"
        ],
        [
          "The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya",
          "https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"
        ]
      ]
    },
    "approved": {
      "date": "2023-05-20",
      "body": "Karnataka Cabinet",
      "srcs": [
        [
          "Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting",
          "https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"
        ]
      ]
    },
    "launched": {
      "date": "2023-07-01",
      "srcs": [
        [
          "The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya",
          "https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"
        ],
        [
          "Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024",
          "https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"
        ]
      ]
    },
    "benefit": {
      "amount": 170,
      "unit": "₹ per person per month DBT in lieu of 5 kg rice (on top of 5 kg NFSA rice)",
      "changes": [
        {
          "date": "2025-02",
          "amount": 5,
          "note": "Rice (5 kg) resumed from Feb 2025 after FCI agreed to sell at Rs 22.5/kg until June 2025 (with an oral assurance thereafter); saves the state Rs 150–190 cr/month",
          "srcs": [
            [
              "Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024",
              "https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"
            ],
            [
              "The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya",
              "https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"
            ]
          ]
        }
      ]
    },
    "eligibility": "BPL/Antyodaya card members (4.12–4.21 crore persons)",
    "beneficiaries": [
      {
        "asOf": "2024-10",
        "count": 41200000,
        "srcs": [
          [
            "Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024",
            "https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2023-24",
        "budgetedCr": 10275,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Karnataka Budget Analysis 2023-24",
            "https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"
          ]
        ]
      },
      {
        "fy": "Jul 2023–Oct 2024 (DBT paid)",
        "budgetedCr": null,
        "actualCr": 10452,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024",
            "https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Karnataka assembly (previous — the promise)",
      "date": "2023-05-10",
      "monthsFromLaunch": -2,
      "incumbentParty": "BJP",
      "result": "challenger (INC) won",
      "seatChange": "INC +55",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI): 2023 Karnataka Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2023-06",
        "status": "promised-not-enacted",
        "note": "10 kg rice promise blocked: FCI agreed on 13 Jun 2023 then reversed on 14 Jun after the Union food ministry stopped OMSS sales to states (except NE/hilly/calamity)",
        "srcs": [
          [
            "The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya",
            "https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"
          ]
        ]
      },
      {
        "date": "2023-07-01",
        "status": "live",
        "note": "Cash in lieu (Rs 170)",
        "srcs": [
          [
            "The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya",
            "https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"
          ]
        ]
      },
      {
        "date": "2024-11",
        "status": "paused",
        "note": "DBT for Nov, Dec, Jan delayed (\"in the pipeline\", minister, 19 Feb 2025)",
        "srcs": [
          [
            "Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024",
            "https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"
          ]
        ]
      },
      {
        "date": "2025-02",
        "status": "live",
        "note": "Rice resumed from FCI at Rs 22.5/kg",
        "srcs": [
          [
            "Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024",
            "https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Siddaramaiah alleged (Jun 2023) that the Union government took a \"political decision\" to stop selling rice to Karnataka to sabotage the guarantee; the Union's stated position was a nationwide discontinuation of OMSS sales to state governments for price stabilisation, with exceptions. Both sides on record; the state paid cash for 19 months as a result.",
        "tier": "alleged",
        "srcs": [
          [
            "The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya",
            "https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"
          ]
        ]
      },
      {
        "finding": "Innocent reading of the cash substitute: an in-kind promise converted to DBT at Rs 34/kg is fiscally transparent and avoids leakage; skeptical reading: the \"10 kg rice\" promise was never delivered as promised for the first 19 months, and DBTs slipped three months in late 2024.",
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024",
            "https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"
          ],
          [
            "The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya",
            "https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:siddaramaiah",
        "role": "Chief Minister, Karnataka",
        "action": "announced",
        "date": "2023-05",
        "party": "INC",
        "srcs": [
          [
            "The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya",
            "https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"
          ]
        ]
      },
      {
        "personId": "wel:kh-muniyappa",
        "role": "Food and Civil Supplies Minister, Karnataka",
        "action": "administers",
        "date": "2025-02-19",
        "party": "INC",
        "srcs": [
          [
            "Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024",
            "https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"
          ]
        ]
      },
      {
        "personId": "pol:pralhad-joshi",
        "role": "Union Minister, Consumer Affairs, Food & Public Distribution",
        "action": "approved",
        "date": "2025-02",
        "party": "BJP",
        "srcs": [
          [
            "Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024",
            "https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "wel:fci",
        "how": "sells rice to Karnataka at Rs 22.5/kg (~Rs 25 landed) under OMSS from Feb 2025; withheld supply Jun 2023–Jan 2025",
        "amountCr": null,
        "tier": "documented",
        "srcs": [
          [
            "Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024",
            "https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"
          ],
          [
            "The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya",
            "https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya",
        "https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"
      ],
      [
        "Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024",
        "https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"
      ],
      [
        "PRS, Karnataka Budget Analysis 2023-24",
        "https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"
      ],
      [
        "Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting",
        "https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"
      ],
      [
        "The Tribune/IANS, 5 Jul 2018: Karnataka waives Rs 34,000 cr farm loans",
        "https://www.tribuneindia.com/news/archive/nation/karnataka-waives-rs-34-000-cr-farm-loans-615599"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2023 Karnataka Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:ka-farm-loan-waiver-2018",
    "name": "Karnataka farm loan waiver 2018 (Kumaraswamy, ₹34,000 cr)",
    "al": [],
    "level": "state",
    "st": "ka",
    "applicableStates": null,
    "category": "loan-waiver",
    "party": "JD(S)-INC coalition",
    "announced": {
      "date": "2018-05-30",
      "byPersonId": "pol:hd-kumaraswamy",
      "office": "Chief Minister, Karnataka",
      "srcs": [
        [
          "Deccan Herald, 30 May 2018: Kumaraswamy announces two-phase farmer loan waiver",
          "https://www.deccanherald.com/india/karnataka/kumaraswamy-announces-two-phase-farmer-loan-waiver-672438.html"
        ]
      ]
    },
    "approved": {
      "date": "2018-07-05",
      "body": "Karnataka budget 2018-19 (presented by CM as Finance Minister): Rs 34,000 cr, Rs 2 lakh per family; first stage cooperative loans defaulted to 31 Dec 2017; Rs 25,000 or repaid amount credited to regular payers",
      "srcs": [
        [
          "The Tribune/IANS, 5 Jul 2018: Karnataka waives Rs 34,000 cr farm loans",
          "https://www.tribuneindia.com/news/archive/nation/karnataka-waives-rs-34-000-cr-farm-loans-615599"
        ],
        [
          "PRS, Karnataka Budget Analysis 2018-19",
          "https://prsindia.org/budgets/states/karnataka-budget-analysis-2018-19"
        ]
      ]
    },
    "launched": {
      "date": "2018-07-05",
      "srcs": [
        [
          "The Tribune/IANS, 5 Jul 2018: Karnataka waives Rs 34,000 cr farm loans",
          "https://www.tribuneindia.com/news/archive/nation/karnataka-waives-rs-34-000-cr-farm-loans-615599"
        ]
      ]
    },
    "benefit": {
      "amount": 200000,
      "unit": "₹ maximum per farmer family; Rs 1 lakh cap in the operative scheme per DH 2024",
      "changes": []
    },
    "eligibility": "Crop loans defaulted up to 31 Dec 2017 (first stage: DCC/state cooperative banks); loans between 1 Apr 2009 and 31 Dec 2017 (announcement)",
    "beneficiaries": [
      {
        "asOf": "2024-01",
        "count": 1750000,
        "srcs": [
          [
            "Deccan Herald, 7 Jan 2024: Karnataka farmers in quicksand as govt continues to borrow time over loan waiver",
            "https://www.deccanherald.com/india/karnataka/karnataka-farmers-in-quicksand-as-govt-continues-to-borrow-time-over-loan-waiver-2838441"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2018-19 (announced total)",
        "budgetedCr": 34000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "The Tribune/IANS, 5 Jul 2018: Karnataka waives Rs 34,000 cr farm loans",
            "https://www.tribuneindia.com/news/archive/nation/karnataka-waives-rs-34-000-cr-farm-loans-615599"
          ],
          [
            "PRS, Karnataka Budget Analysis 2018-19",
            "https://prsindia.org/budgets/states/karnataka-budget-analysis-2018-19"
          ]
        ]
      },
      {
        "fy": "pending 2021–24",
        "budgetedCr": null,
        "actualCr": 232,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Deccan Herald, 7 Jan 2024: Karnataka farmers in quicksand as govt continues to borrow time over loan waiver",
            "https://www.deccanherald.com/india/karnataka/karnataka-farmers-in-quicksand-as-govt-continues-to-borrow-time-over-loan-waiver-2838441"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Karnataka assembly (previous)",
      "date": "2018-05-12",
      "monthsFromLaunch": -2,
      "incumbentParty": "INC",
      "result": "hung; INC-JD(S) coalition formed, CM Kumaraswamy 23 May 2018; waiver = coalition's first big act",
      "seatChange": "BJP 104, INC 80, JD(S) 37 (fleet file)",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI results): 2018 Karnataka Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2018_Karnataka_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2018-07-05",
        "status": "live",
        "note": "Budget; funded partly by petrol/diesel/liquor tax hikes and a 20 paise/unit power tariff rise",
        "srcs": [
          [
            "The Tribune/IANS, 5 Jul 2018: Karnataka waives Rs 34,000 cr farm loans",
            "https://www.tribuneindia.com/news/archive/nation/karnataka-waives-rs-34-000-cr-farm-loans-615599"
          ]
        ]
      },
      {
        "date": "2019-07",
        "status": "paused",
        "note": "Coalition collapsed July 2019; BJP government cited Covid for funding confusion (DH sources)",
        "srcs": [
          [
            "Deccan Herald, 7 Jan 2024: Karnataka farmers in quicksand as govt continues to borrow time over loan waiver",
            "https://www.deccanherald.com/india/karnataka/karnataka-farmers-in-quicksand-as-govt-continues-to-borrow-time-over-loan-waiver-2838441"
          ]
        ]
      },
      {
        "date": "2024-01-07",
        "status": "live",
        "note": "Rs 361.67 cr cumulatively pending since 2021 across the 2017 and 2018 waivers; Siddaramaiah announced a fresh interest waiver Dec 2023",
        "srcs": [
          [
            "Deccan Herald, 7 Jan 2024: Karnataka farmers in quicksand as govt continues to borrow time over loan waiver",
            "https://www.deccanherald.com/india/karnataka/karnataka-farmers-in-quicksand-as-govt-continues-to-borrow-time-over-loan-waiver-2838441"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Delivery lag: five years after announcement 30,733 eligible farmers were still unpaid; the delay itself blocked them from fresh cooperative credit (DH, Jan 2024).",
        "tier": "reported",
        "srcs": [
          [
            "Deccan Herald, 7 Jan 2024: Karnataka farmers in quicksand as govt continues to borrow time over loan waiver",
            "https://www.deccanherald.com/india/karnataka/karnataka-farmers-in-quicksand-as-govt-continues-to-borrow-time-over-loan-waiver-2838441"
          ]
        ]
      },
      {
        "finding": "Symmetry inside one state: Siddaramaiah (INC) waived up to Rs 50,000 in June 2017, 11 months before the May 2018 poll, and lost his majority; Kumaraswamy (JD(S)) waived post-poll and the coalition fell in 14 months; RBI IWG (2019) rates such waivers as election-clustered and credit-culture damaging.",
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald, 7 Jan 2024: Karnataka farmers in quicksand as govt continues to borrow time over loan waiver",
            "https://www.deccanherald.com/india/karnataka/karnataka-farmers-in-quicksand-as-govt-continues-to-borrow-time-over-loan-waiver-2838441"
          ],
          [
            "PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)",
            "https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"
          ],
          [
            "Wikipedia infobox (pointer to ECI results): 2018 Karnataka Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2018_Karnataka_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:hd-kumaraswamy",
        "role": "Chief Minister and Finance Minister, Karnataka",
        "action": "presented budget",
        "date": "2018-07-05",
        "party": "JD(S)",
        "srcs": [
          [
            "The Tribune/IANS, 5 Jul 2018: Karnataka waives Rs 34,000 cr farm loans",
            "https://www.tribuneindia.com/news/archive/nation/karnataka-waives-rs-34-000-cr-farm-loans-615599"
          ]
        ]
      },
      {
        "personId": "wel:siddaramaiah",
        "role": "Chief Minister, Karnataka (2017 waiver; 2023 interest waiver)",
        "action": "announced",
        "date": "2017-06",
        "party": "INC",
        "srcs": [
          [
            "Deccan Herald, 7 Jan 2024: Karnataka farmers in quicksand as govt continues to borrow time over loan waiver",
            "https://www.deccanherald.com/india/karnataka/karnataka-farmers-in-quicksand-as-govt-continues-to-borrow-time-over-loan-waiver-2838441"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "district central cooperative banks",
        "how": "first-stage waiver limited to cooperative-sector loans; Rs 6,500 cr provided for fresh lending on clearance certificates",
        "amountCr": 6500,
        "tier": "documented",
        "srcs": [
          [
            "The Tribune/IANS, 5 Jul 2018: Karnataka waives Rs 34,000 cr farm loans",
            "https://www.tribuneindia.com/news/archive/nation/karnataka-waives-rs-34-000-cr-farm-loans-615599"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Deccan Herald, 30 May 2018: Kumaraswamy announces two-phase farmer loan waiver",
        "https://www.deccanherald.com/india/karnataka/kumaraswamy-announces-two-phase-farmer-loan-waiver-672438.html"
      ],
      [
        "The Tribune/IANS, 5 Jul 2018: Karnataka waives Rs 34,000 cr farm loans",
        "https://www.tribuneindia.com/news/archive/nation/karnataka-waives-rs-34-000-cr-farm-loans-615599"
      ],
      [
        "PRS, Karnataka Budget Analysis 2018-19",
        "https://prsindia.org/budgets/states/karnataka-budget-analysis-2018-19"
      ],
      [
        "Deccan Herald, 7 Jan 2024: Karnataka farmers in quicksand as govt continues to borrow time over loan waiver",
        "https://www.deccanherald.com/india/karnataka/karnataka-farmers-in-quicksand-as-govt-continues-to-borrow-time-over-loan-waiver-2838441"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2023 Karnataka Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2018 Karnataka Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2018_Karnataka_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:ka-five-guarantees-2023",
    "name": "Karnataka five guarantees (Gruha Jyothi, Gruha Lakshmi, Anna Bhagya, Shakti, Yuva Nidhi)",
    "al": [
      "Panch guarantees",
      "ಗ್ಯಾರಂಟಿ ಯೋಜನೆಗಳು"
    ],
    "level": "state",
    "st": "ka",
    "applicableStates": null,
    "category": "other",
    "party": "INC",
    "announced": {
      "date": "2023-05-10",
      "byPersonId": "wel:siddaramaiah",
      "office": "INC 2023 manifesto; Siddaramaiah CM from 20 May 2023",
      "srcs": [
        [
          "Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting",
          "https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"
        ],
        [
          "PRS, Karnataka Budget Analysis 2023-24",
          "https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"
        ]
      ]
    },
    "approved": {
      "date": "2023-05-20",
      "body": "Karnataka Cabinet, first meeting",
      "srcs": [
        [
          "Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting",
          "https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"
        ]
      ]
    },
    "launched": {
      "date": "2023-06-11",
      "srcs": [
        [
          "The Federal, 12 Jun 2023: Free bus travel for women — Karnataka model vs TN, Delhi, Punjab",
          "https://thefederal.com/states/south/karnataka/karnataka-introduces-free-bus-travel-for-women-a-comparison-with-other-states"
        ],
        [
          "The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya",
          "https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"
        ],
        [
          "PRS, Karnataka Budget Analysis 2023-24",
          "https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"
        ]
      ]
    },
    "benefit": {
      "amount": null,
      "unit": "bundle: 200 units free power (Gruha Jyothi); Rs 2,000/month to woman head (Gruha Lakshmi — see women-cash.json scheme:ka-gruha-lakshmi); +5 kg foodgrain (Anna Bhagya); free bus travel for women (Shakti — vendors.json scheme:ka-shakti); Rs 3,000/1,500 per month unemployment aid (Yuva Nidhi)",
      "changes": []
    },
    "eligibility": "Varies by component; Congress estimate covered 1.3 crore women heads, 2.5 crore ration beneficiaries, 5 lakh youths (BS)",
    "beneficiaries": [
      {
        "asOf": "2025-03",
        "count": null,
        "srcs": [
          [
            "The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget",
            "https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2023-24 (Jul–Mar)",
        "budgetedCr": 39825,
        "actualCr": null,
        "pctOfStateBudget": 16,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Karnataka Budget Analysis 2023-24",
            "https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"
          ]
        ]
      },
      {
        "fy": "2024-25",
        "budgetedCr": 52000,
        "actualCr": 52525,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget",
            "https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"
          ],
          [
            "Deccan Herald, 26 Mar 2026: Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG",
            "https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 51034,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget",
            "https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"
          ]
        ]
      },
      {
        "fy": "cumulative to Aug 2025",
        "budgetedCr": null,
        "actualCr": 94177,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Deccan Herald, 26 Aug 2025: CAG report's conclusions on welfare schemes in Karnataka incorrect: H M Revanna",
            "https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Karnataka assembly (previous — the promise)",
      "date": "2023-05-10",
      "monthsFromLaunch": -1,
      "incumbentParty": "BJP",
      "result": "challenger (INC) won 135/224; guarantees delivered within 1–8 months of taking office",
      "seatChange": "INC +55",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI): 2023 Karnataka Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2023-05-20",
        "status": "live",
        "note": "Cabinet approval",
        "srcs": [
          [
            "Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting",
            "https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"
          ]
        ]
      },
      {
        "date": "2025-08",
        "status": "live",
        "note": "CAG (Aug 2025) called the schemes potentially \"detrimental\" to growth; GIA chair Revanna rejected the conclusions",
        "srcs": [
          [
            "Deccan Herald, 26 Aug 2025: CAG report's conclusions on welfare schemes in Karnataka incorrect: H M Revanna",
            "https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"
          ],
          [
            "Deccan Herald, 26 Mar 2026: Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG",
            "https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"
          ]
        ]
      },
      {
        "date": "2026-03-26",
        "status": "live",
        "note": "CAG 2024-25 state finances: guarantees shifted the state from revenue surplus to deficit in 2023-24 and 2024-25; net market borrowing Rs 71,525 cr in 2024-25; funds cut for nutrition, rural development, slum improvement",
        "srcs": [
          [
            "Deccan Herald, 26 Mar 2026: Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG",
            "https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "CAG state-finances report for 2024-25 (tabled 26 Mar 2026): \"loop of indebtedness\"; only 62.12% of borrowings used for development; revenue growth \"insufficient to absorb the recurring costs\"; recommends rationalising subsidies or better targeting. PRS SOSF 2025-26 likewise records Karnataka moving from a revenue surplus of 0.3% of GSDP to a deficit after the cash transfers.",
        "tier": "documented",
        "srcs": [
          [
            "Deccan Herald, 26 Mar 2026: Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG",
            "https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"
          ],
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.13-14 and subsidy section (PDF)",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "Government contra (H M Revanna, GIA chair, 25 Aug 2025): CAG's conclusions \"far from the truth\"; per-capita income and GST collections rose; 98% implemented; Rs 94,177 cr spent; 1.2 lakh eligible Gruha Lakshmi women wrongly denied over income-tax confusion, 59,000 restored. Siddaramaiah: \"neither a burden nor inflationary\".",
        "tier": "reported",
        "srcs": [
          [
            "Deccan Herald, 26 Aug 2025: CAG report's conclusions on welfare schemes in Karnataka incorrect: H M Revanna",
            "https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"
          ],
          [
            "Deccan Herald, 26 Mar 2026: Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG",
            "https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"
          ]
        ]
      },
      {
        "finding": "Business Standard (23 May 2023): Axis My India exit poll — Congress led BJP by 11 points among women; Lokniti-CSDS — rural poor voted Congress in larger numbers; the party credits the guarantees. These are pre-delivery promise effects, not transfer effects; the guarantees were a manifesto, not a running scheme, at the time of the vote.",
        "tier": "reported",
        "srcs": [
          [
            "Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting",
            "https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"
          ]
        ]
      },
      {
        "finding": "Same lens as MP/MH: a promise of ~Rs 52,000 cr/yr (about 16% of revenue expenditure) made by a challenger and delivered post-poll. Innocent reading: redistribution funded by taxes (Kumaraswamy-era petrol/liquor hikes precedent) and honoured as promised; skeptical reading: structural revenue deficit now financed by debt, with nutrition and rural development cut.",
        "tier": "analytic",
        "srcs": [
          [
            "PRS, Karnataka Budget Analysis 2023-24",
            "https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"
          ],
          [
            "Deccan Herald, 26 Mar 2026: Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG",
            "https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:siddaramaiah",
        "role": "Chief Minister, Karnataka",
        "action": "approved",
        "date": "2023-05-20",
        "party": "INC",
        "srcs": [
          [
            "Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting",
            "https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"
          ]
        ]
      },
      {
        "personId": "wel:dk-shivakumar",
        "role": "Deputy Chief Minister, Karnataka",
        "action": "approved",
        "date": "2023-05-20",
        "party": "INC",
        "srcs": [
          [
            "Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting",
            "https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"
          ]
        ]
      },
      {
        "personId": "wel:h-m-revanna",
        "role": "Chairperson, Guarantee Implementation Authority",
        "action": "administers",
        "date": "2025-08-25",
        "party": "INC",
        "srcs": [
          [
            "Deccan Herald, 26 Aug 2025: CAG report's conclusions on welfare schemes in Karnataka incorrect: H M Revanna",
            "https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"
          ]
        ]
      },
      {
        "personId": "wel:ramalinga-reddy",
        "role": "Transport Minister, Karnataka",
        "action": "announced",
        "date": "2023-06-01",
        "party": "INC",
        "srcs": [
          [
            "The Federal, 12 Jun 2023: Free bus travel for women — Karnataka model vs TN, Delhi, Punjab",
            "https://thefederal.com/states/south/karnataka/karnataka-introduces-free-bus-travel-for-women-a-comparison-with-other-states"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "wel:karnataka-rtcs",
        "how": "fare-loss reimbursement to the four state RTCs under Shakti: Rs 5,015 cr in 2024-25, Rs 5,300 cr 2025-26",
        "amountCr": 5015,
        "tier": "documented",
        "srcs": [
          [
            "The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget",
            "https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"
          ]
        ]
      },
      {
        "who": "ESCOMs (state discoms)",
        "how": "Gruha Jyothi subsidy paid to distribution companies: Rs 9,000 cr (2023-24 BE), Rs 9,657 cr (2024-25), Rs 10,100 cr (2025-26)",
        "amountCr": 9657,
        "tier": "documented",
        "srcs": [
          [
            "PRS, Karnataka Budget Analysis 2023-24",
            "https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"
          ],
          [
            "The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget",
            "https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"
          ]
        ]
      },
      {
        "who": "lenders to the state",
        "how": "net market borrowings of Rs 71,525.15 cr in 2024-25 \"to finance the guarantee schemes and the deficits arising thereof\" (CAG)",
        "amountCr": 71525,
        "tier": "documented",
        "srcs": [
          [
            "Deccan Herald, 26 Mar 2026: Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG",
            "https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"
          ]
        ]
      },
      {
        "who": "party:inc",
        "how": "five guarantees are the party's template for Telangana (2023) and the 2024 national campaign",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting",
            "https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting",
        "https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"
      ],
      [
        "PRS, Karnataka Budget Analysis 2023-24",
        "https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"
      ],
      [
        "The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget",
        "https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"
      ],
      [
        "Deccan Herald, 26 Mar 2026: Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG",
        "https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"
      ],
      [
        "Deccan Herald, 26 Aug 2025: CAG report's conclusions on welfare schemes in Karnataka incorrect: H M Revanna",
        "https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"
      ],
      [
        "The Federal, 12 Jun 2023: Free bus travel for women — Karnataka model vs TN, Delhi, Punjab",
        "https://thefederal.com/states/south/karnataka/karnataka-introduces-free-bus-travel-for-women-a-comparison-with-other-states"
      ],
      [
        "The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya",
        "https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.13-14 and subsidy section (PDF)",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2023 Karnataka Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:ka-gruha-lakshmi",
    "name": "Gruha Lakshmi Scheme",
    "al": [
      "Gruhalakshmi",
      "Gruha Lakshmi Yojana",
      "ಗೃಹಲಕ್ಷ್ಮಿ"
    ],
    "level": "state",
    "st": "ka",
    "applicableStates": null,
    "category": "women-cash",
    "party": "INC",
    "announced": {
      "date": "2023-05-20",
      "byPersonId": "wel:siddaramaiah",
      "office": "Chief Minister, Karnataka",
      "srcs": [
        [
          "Congress — Gruha Lakshmi launch",
          "https://inc.in/congress-sandesh/others/in-karnataka-gruha-lakshmi-scheme-launched-1-1-crore-women-heads-of-households-to-get-2000-monthly-aid"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Karnataka Cabinet",
      "srcs": [
        [
          "Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed",
          "https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"
        ]
      ]
    },
    "launched": {
      "date": "2023-08-30",
      "srcs": [
        [
          "Tribune — Gruha Lakshmi launch today",
          "https://www.tribuneindia.com/news/india/karnataka-govt-to-launch-gruha-lakshmi-scheme-today-to-benifit-1-1-crore-women-539715"
        ]
      ]
    },
    "benefit": {
      "amount": 2000,
      "unit": "₹ per month to one woman head-of-household per family",
      "changes": []
    },
    "eligibility": "women heads of eligible households (income/BPL criteria apply)",
    "beneficiaries": [
      {
        "asOf": "2023-08-30",
        "count": 11000000,
        "srcs": [
          [
            "Congress — Gruha Lakshmi launch",
            "https://inc.in/congress-sandesh/others/in-karnataka-gruha-lakshmi-scheme-launched-1-1-crore-women-heads-of-households-to-get-2000-monthly-aid"
          ]
        ]
      },
      {
        "asOf": "2023",
        "count": 13100000,
        "srcs": [
          [
            "Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed",
            "https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"
          ]
        ]
      },
      {
        "asOf": "2025-09",
        "count": 12800000,
        "srcs": [
          [
            "Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed",
            "https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2023-24",
        "budgetedCr": 17500,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Congress — Gruha Lakshmi launch",
            "https://inc.in/congress-sandesh/others/in-karnataka-gruha-lakshmi-scheme-launched-1-1-crore-women-heads-of-households-to-get-2000-monthly-aid"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 28608,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 28608,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "fy": "2023-24 to 2025-26",
        "budgetedCr": null,
        "actualCr": 50005,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed",
            "https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Karnataka assembly (scheme launched after this election, which Congress had already won)",
      "date": "2023-05-10",
      "monthsFromLaunch": -4,
      "incumbentParty": "BJP",
      "result": "incumbent lost (Congress, which promised the scheme, won)",
      "seatChange": "Congress 80→135 seats, BJP 104→66",
      "srcs": [
        [
          "Wikipedia — 2023 Karnataka Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2023-08-30",
        "status": "launched",
        "note": "One of Congress's five pre-poll 'guarantees'; the guarantee was promised before the May 2023 election but the scheme itself was only launched after Congress had already won and formed government — an important case where the promise, not the launch, sits close to the election.",
        "srcs": [
          [
            "Tribune — Gruha Lakshmi launch today",
            "https://www.tribuneindia.com/news/india/karnataka-govt-to-launch-gruha-lakshmi-scheme-today-to-benifit-1-1-crore-women-539715"
          ]
        ]
      },
      {
        "date": "2023-06",
        "status": "live",
        "note": null,
        "srcs": [
          [
            "Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed",
            "https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"
          ]
        ]
      },
      {
        "date": "2024",
        "status": "paused",
        "note": "FY 2024-25 (date field holds the FY's first calendar year; months not in the source): Two monthly instalments skipped in FY 2024-25 (DH, dept sources)",
        "srcs": [
          [
            "Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed",
            "https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"
          ]
        ]
      },
      {
        "date": "2025-08",
        "status": "eligibility-tightened",
        "note": "1.2 lakh eligible women wrongly denied over income-tax confusion; 59,000 restored (Revanna); Uttara Kannada district 'volunteered out'",
        "srcs": [
          [
            "Deccan Herald, 26 Aug 2025: H M Revanna rejects CAG conclusions on Karnataka guarantee schemes",
            "https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"
          ]
        ]
      },
      {
        "date": "2025-09",
        "status": "eligibility-tightened",
        "note": "2.13 lakh income-tax/GST-paying households removed; none had been paid",
        "srcs": [
          [
            "Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed",
            "https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Because the cash itself only started flowing after the election it is credited with helping win, this case shows the timing question needs to distinguish 'promise date' from 'launch date' — the promise (campaign guarantee) predates the poll; the transfer does not.",
        "tier": "analytic",
        "srcs": [
          [
            "Congress — Gruha Lakshmi launch",
            "https://inc.in/congress-sandesh/others/in-karnataka-gruha-lakshmi-scheme-launched-1-1-crore-women-heads-of-households-to-get-2000-monthly-aid"
          ]
        ]
      },
      {
        "finding": "PRS (Oct 2025): the UCT moves Karnataka from a revenue surplus of 0.3% of GSDP to a revenue deficit of 0.6% (2025-26 BE); it is 9.2% of revenue expenditure.",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "CAG State Finances Audit Report 2024-25 (tabled 26 Mar 2026, as reported by Deccan Herald): the five 'guarantee' schemes cost ₹52,525 cr in 2024-25; 'shifted the state from a revenue surplus to revenue deficit in 2023-24 and 2024-25'; the deficit is debt-financed, 'creating a loop of indebtedness'; only 62.12% of 2024-25 borrowings went to developmental expenditure; net market borrowings of ₹71,525.15 cr were availed 'to finance the guarantee schemes and the deficits arising thereof'; CAG urged rationalisation of existing subsidies or better targeting.",
        "tier": "reported",
        "srcs": [
          [
            "Deccan Herald, 26 Mar 2026: 'Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG' (CAG State Finances Audit Report 2024-25, tabled 26 Mar 2026)",
            "https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"
          ]
        ]
      },
      {
        "finding": "CAG's earlier report (Aug 2025, per DH) said the schemes could become 'detrimental' to growth; H M Revanna, chair of the Guarantee Implementation Authority, called the conclusion 'far from the truth', citing rising per-capita income and GST, ₹94,177 cr spent and 98% implementation.",
        "tier": "reported",
        "srcs": [
          [
            "Deccan Herald, 26 Aug 2025: ''CAG report's conclusions on welfare schemes in Karnataka incorrect': H M Revanna'",
            "https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"
          ],
          [
            "Deccan Herald, 26 Mar 2026: 'Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG' (CAG State Finances Audit Report 2024-25, tabled 26 Mar 2026)",
            "https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"
          ]
        ]
      },
      {
        "finding": "Headline claim (DH, 26 Mar 2026) that the guarantees 'forced' cuts to nutrition, rural development and slum improvement: the paywalled article body available to us does not show the CAG's supporting figures; treat the causal wording as the newspaper's summary until the CAG report text is read.",
        "tier": "reported",
        "srcs": [
          [
            "Deccan Herald, 26 Mar 2026: 'Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG' (CAG State Finances Audit Report 2024-25, tabled 26 Mar 2026)",
            "https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"
          ]
        ]
      },
      {
        "finding": "CAG report (Aug 2025) concluded the guarantee schemes were taxing state resources (as paraphrased by DH; report text not obtained)",
        "tier": "reported",
        "srcs": [
          [
            "Deccan Herald, 26 Aug 2025: H M Revanna rejects CAG conclusions on Karnataka guarantee schemes",
            "https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"
          ]
        ]
      },
      {
        "finding": "Contra: Guarantee Implementation Authority chair H M Revanna — CAG conclusion 'far from the truth'; per-capita income and GST collections rose; 98% implemented",
        "tier": "reported",
        "srcs": [
          [
            "Deccan Herald, 26 Aug 2025: H M Revanna rejects CAG conclusions on Karnataka guarantee schemes",
            "https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"
          ]
        ]
      },
      {
        "finding": "PRS SOSF 2025: Karnataka would be in revenue surplus (0.3% of GSDP) but for the UCT (deficit 0.6%)",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:siddaramaiah",
        "role": "Chief Minister, Karnataka",
        "action": "announced",
        "date": "2023-05-20",
        "party": "INC",
        "srcs": []
      },
      {
        "personId": "wel:h-m-revanna",
        "role": "Chairperson, Guarantee Implementation Authority, Karnataka",
        "action": "administers",
        "date": "2025-08-25",
        "party": "INC",
        "srcs": [
          [
            "Deccan Herald, 26 Aug 2025: ''CAG report's conclusions on welfare schemes in Karnataka incorrect': H M Revanna'",
            "https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"
          ]
        ]
      },
      {
        "personId": "wel:siddaramaiah",
        "role": "Chief Minister",
        "action": "administers",
        "date": "2023-05-20",
        "party": "INC",
        "srcs": [
          [
            "Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed",
            "https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"
          ]
        ]
      },
      {
        "personId": "wel:h-m-revanna",
        "role": "Chair, Guarantee Implementation Authority",
        "action": "administers",
        "date": "2025-08",
        "party": "INC",
        "srcs": [
          [
            "Deccan Herald, 26 Aug 2025: H M Revanna rejects CAG conclusions on Karnataka guarantee schemes",
            "https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "party:inc",
        "how": "political: the five guarantees were the 2023 platform; a post-election implementation, so no pre-poll timing benefit",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed",
            "https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Congress — Gruha Lakshmi launch",
        "https://inc.in/congress-sandesh/others/in-karnataka-gruha-lakshmi-scheme-launched-1-1-crore-women-heads-of-households-to-get-2000-monthly-aid"
      ],
      [
        "Tribune — Gruha Lakshmi launch today",
        "https://www.tribuneindia.com/news/india/karnataka-govt-to-launch-gruha-lakshmi-scheme-today-to-benifit-1-1-crore-women-539715"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "Deccan Herald, 26 Mar 2026: 'Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG' (CAG State Finances Audit Report 2024-25, tabled 26 Mar 2026)",
        "https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"
      ],
      [
        "Deccan Herald, 26 Aug 2025: ''CAG report's conclusions on welfare schemes in Karnataka incorrect': H M Revanna'",
        "https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"
      ],
      [
        "Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed",
        "https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"
      ],
      [
        "Deccan Herald, 26 Aug 2025: H M Revanna rejects CAG conclusions on Karnataka guarantee schemes",
        "https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:ka-shakti",
    "name": "Shakti (free bus travel for women, Karnataka)",
    "al": [
      "Shakti scheme",
      "ಶಕ್ತಿ"
    ],
    "level": "state",
    "st": "ka",
    "applicableStates": null,
    "category": "transport",
    "party": "INC",
    "announced": {
      "date": null,
      "byPersonId": "wel:siddaramaiah",
      "office": "Chief Minister, Karnataka (one of five 'guarantees' promised before the May 2023 election; cabinet date not verified from an opened source)",
      "srcs": [
        [
          "Deccan Herald, 'Rs 1,800 cr Shakti scheme reimbursement pending; transport corporations in red', Dec 2024",
          "https://www.deccanherald.com/india/karnataka/rs1-800-cr-shakti-scheme-reimbursement-pending-transport-corpns-in-red-3320295"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Karnataka Cabinet",
      "srcs": []
    },
    "launched": {
      "date": "2023-06-11",
      "srcs": [
        [
          "Deccan Herald, 'Rs 1,800 cr Shakti scheme reimbursement pending; transport corporations in red', Dec 2024",
          "https://www.deccanherald.com/india/karnataka/rs1-800-cr-shakti-scheme-reimbursement-pending-transport-corpns-in-red-3320295"
        ]
      ]
    },
    "benefit": {
      "amount": 0,
      "unit": "zero fare on non-premium state RTC buses for Karnataka-domiciled women",
      "changes": []
    },
    "eligibility": "Women domiciled in Karnataka, on ordinary/express services of the four RTCs",
    "beneficiaries": [
      {
        "asOf": "2024-12-01",
        "count": 3500000000,
        "srcs": [
          [
            "Deccan Herald, 'Rs 1,800 cr Shakti scheme reimbursement pending; transport corporations in red', Dec 2024",
            "https://www.deccanherald.com/india/karnataka/rs1-800-cr-shakti-scheme-reimbursement-pending-transport-corpns-in-red-3320295"
          ]
        ]
      },
      {
        "asOf": "2026-03-31",
        "count": 2757100000,
        "srcs": [
          [
            "ETV Bharat, 'Shakti scheme effect: male passengers drop; ₹5,172 crore reimbursement pending', 20 Jun 2026",
            "https://www.etvbharat.com/en/bharat/shakti-scheme-effect-number-of-male-passengers-travelling-in-karnataka-govt-run-buses-drops-significantly-in-karnataka-enn26062003798"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2024-25",
        "budgetedCr": 5800,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Deccan Herald, 'Rs 1,800 cr Shakti scheme reimbursement pending; transport corporations in red', Dec 2024",
            "https://www.deccanherald.com/india/karnataka/rs1-800-cr-shakti-scheme-reimbursement-pending-transport-corpns-in-red-3320295"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": null,
        "actualCr": 7701,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "ETV Bharat, 'Shakti scheme effect: male passengers drop; ₹5,172 crore reimbursement pending', 20 Jun 2026",
            "https://www.etvbharat.com/en/bharat/shakti-scheme-effect-number-of-male-passengers-travelling-in-karnataka-govt-run-buses-drops-significantly-in-karnataka-enn26062003798"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Karnataka assembly",
      "date": "2023-05-10",
      "monthsFromLaunch": -1,
      "incumbentParty": "BJP",
      "result": "challenger (INC) won; scheme launched one month after the result as a manifesto fulfilment",
      "seatChange": "INC +55 (135), BJP −38 (66)",
      "srcs": [
        [
          "Wikipedia (pointer), 2023 Karnataka Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"
        ],
        [
          "Deccan Herald, 'Rs 1,800 cr Shakti scheme reimbursement pending; transport corporations in red', Dec 2024",
          "https://www.deccanherald.com/india/karnataka/rs1-800-cr-shakti-scheme-reimbursement-pending-transport-corpns-in-red-3320295"
        ]
      ]
    },
    "status": [
      {
        "date": "2023-06-11",
        "status": "live",
        "note": null,
        "srcs": [
          [
            "Deccan Herald, 'Rs 1,800 cr Shakti scheme reimbursement pending; transport corporations in red', Dec 2024",
            "https://www.deccanherald.com/india/karnataka/rs1-800-cr-shakti-scheme-reimbursement-pending-transport-corpns-in-red-3320295"
          ]
        ]
      },
      {
        "date": "2024-12-01",
        "status": "live",
        "note": "~₹1,800 crore reimbursement arrears; state asks RTCs to claim only 'incremental' cost and to count ₹580 crore of vehicle-tax breaks as scheme cost",
        "srcs": [
          [
            "Deccan Herald, 'Rs 1,800 cr Shakti scheme reimbursement pending; transport corporations in red', Dec 2024",
            "https://www.deccanherald.com/india/karnataka/rs1-800-cr-shakti-scheme-reimbursement-pending-transport-corpns-in-red-3320295"
          ]
        ]
      },
      {
        "date": "2026-06-20",
        "status": "live",
        "note": "arrears ₹5,172 crore; RTCs post first loss since 2023; male share of passengers 36%",
        "srcs": [
          [
            "ETV Bharat, 'Shakti scheme effect: male passengers drop; ₹5,172 crore reimbursement pending', 20 Jun 2026",
            "https://www.etvbharat.com/en/bharat/shakti-scheme-effect-number-of-male-passengers-travelling-in-karnataka-govt-run-buses-drops-significantly-in-karnataka-enn26062003798"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Free-ticket value ₹7,701 crore in 2025-26 exceeded paid-ticket revenue from men (₹6,825 crore); the four RTCs registered a loss for the first time since 2023",
        "tier": "reported",
        "srcs": [
          [
            "ETV Bharat, 'Shakti scheme effect: male passengers drop; ₹5,172 crore reimbursement pending', 20 Jun 2026",
            "https://www.etvbharat.com/en/bharat/shakti-scheme-effect-number-of-male-passengers-travelling-in-karnataka-govt-run-buses-drops-significantly-in-karnataka-enn26062003798"
          ]
        ]
      },
      {
        "finding": "BMTC ridership rose 27.4 lakh → 40 lakh/day while its fleet shrank 6,888 → 6,158 — i.e. no procurement boom accompanied the scheme in its first 15 months",
        "tier": "documented",
        "srcs": [
          [
            "Deccan Herald, 'BMTC launches 100 new diesel buses, to get 820 of them by March', 12 Sep 2024",
            "https://www.deccanherald.com/india/karnataka/bengaluru/bmtc-launches-100-new-diesel-buses-to-get-820-of-them-by-march-3188420"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:siddaramaiah",
        "role": "Chief Minister",
        "action": "administers",
        "date": "2023-05-20",
        "party": "INC",
        "srcs": [
          [
            "Deccan Herald, 'BMTC launches 100 new diesel buses, to get 820 of them by March', 12 Sep 2024",
            "https://www.deccanherald.com/india/karnataka/bengaluru/bmtc-launches-100-new-diesel-buses-to-get-820-of-them-by-march-3188420"
          ]
        ]
      },
      {
        "personId": "wel:dk-shivakumar",
        "role": "Deputy Chief Minister",
        "action": "administers",
        "date": "2026-06-20",
        "party": "INC",
        "srcs": [
          [
            "ETV Bharat, 'Shakti scheme effect: male passengers drop; ₹5,172 crore reimbursement pending', 20 Jun 2026",
            "https://www.etvbharat.com/en/bharat/shakti-scheme-effect-number-of-male-passengers-travelling-in-karnataka-govt-run-buses-drops-significantly-in-karnataka-enn26062003798"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "co:ashok-leyland",
        "how": "Won BMTC's Feb 2024 tender for 820 BS6 diesel buses after Tata Motors' 840-bus award (Oct 2022) was scrapped; funded by a ₹336 crore state grant",
        "amountCr": 336,
        "tier": "reported",
        "srcs": [
          [
            "Deccan Herald, 'BMTC launches 100 new diesel buses, to get 820 of them by March', 12 Sep 2024",
            "https://www.deccanherald.com/india/karnataka/bengaluru/bmtc-launches-100-new-diesel-buses-to-get-820-of-them-by-march-3188420"
          ]
        ]
      },
      {
        "who": "co:tata-motors",
        "how": "Original BMTC 840-bus award (delivered 20, scrapped); 148 e-buses on ~₹41/km GCC (2025)",
        "amountCr": null,
        "tier": "reported",
        "srcs": [
          [
            "Deccan Herald, 'BMTC launches 100 new diesel buses, to get 820 of them by March', 12 Sep 2024",
            "https://www.deccanherald.com/india/karnataka/bengaluru/bmtc-launches-100-new-diesel-buses-to-get-820-of-them-by-march-3188420"
          ],
          [
            "Wikipedia (pointer), 'Bengaluru Metropolitan Transport Corporation'",
            "https://en.wikipedia.org/wiki/Bangalore_Metropolitan_Transport_Corporation"
          ]
        ]
      },
      {
        "who": "wel:karnataka-rtcs",
        "how": "Net loser: reimbursement lags of ₹1,800 → ₹5,172 crore; state offsets vehicle-tax breaks of ₹580 crore (2023-24)",
        "amountCr": -5172,
        "tier": "reported",
        "srcs": [
          [
            "Deccan Herald, 'Rs 1,800 cr Shakti scheme reimbursement pending; transport corporations in red', Dec 2024",
            "https://www.deccanherald.com/india/karnataka/rs1-800-cr-shakti-scheme-reimbursement-pending-transport-corpns-in-red-3320295"
          ],
          [
            "ETV Bharat, 'Shakti scheme effect: male passengers drop; ₹5,172 crore reimbursement pending', 20 Jun 2026",
            "https://www.etvbharat.com/en/bharat/shakti-scheme-effect-number-of-male-passengers-travelling-in-karnataka-govt-run-buses-drops-significantly-in-karnataka-enn26062003798"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Deccan Herald, 'Rs 1,800 cr Shakti scheme reimbursement pending; transport corporations in red', Dec 2024",
        "https://www.deccanherald.com/india/karnataka/rs1-800-cr-shakti-scheme-reimbursement-pending-transport-corpns-in-red-3320295"
      ],
      [
        "ETV Bharat, 'Shakti scheme effect: male passengers drop; ₹5,172 crore reimbursement pending', 20 Jun 2026",
        "https://www.etvbharat.com/en/bharat/shakti-scheme-effect-number-of-male-passengers-travelling-in-karnataka-govt-run-buses-drops-significantly-in-karnataka-enn26062003798"
      ],
      [
        "Deccan Herald, 'BMTC launches 100 new diesel buses, to get 820 of them by March', 12 Sep 2024",
        "https://www.deccanherald.com/india/karnataka/bengaluru/bmtc-launches-100-new-diesel-buses-to-get-820-of-them-by-march-3188420"
      ],
      [
        "Wikipedia (pointer), 'Bengaluru Metropolitan Transport Corporation'",
        "https://en.wikipedia.org/wiki/Bangalore_Metropolitan_Transport_Corporation"
      ],
      [
        "Wikipedia (pointer), 2023 Karnataka Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"
      ]
    ],
    "domain": "vendors"
  },
  {
    "id": "scheme:ka-yuva-nidhi",
    "name": "Yuva Nidhi (unemployment allowance)",
    "al": [
      "ಯುವ ನಿಧಿ"
    ],
    "level": "state",
    "st": "ka",
    "applicableStates": null,
    "category": "unemployment",
    "party": "INC",
    "announced": {
      "date": "2023-05-10",
      "byPersonId": "wel:siddaramaiah",
      "office": "INC manifesto 2023",
      "srcs": [
        [
          "PRS, Karnataka Budget Analysis 2023-24",
          "https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"
        ],
        [
          "Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting",
          "https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"
        ]
      ]
    },
    "approved": {
      "date": "2023-05-20",
      "body": "Karnataka Cabinet",
      "srcs": [
        [
          "Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting",
          "https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"
        ]
      ]
    },
    "launched": {
      "date": "2024-01",
      "srcs": [
        [
          "The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget",
          "https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"
        ]
      ]
    },
    "benefit": {
      "amount": 3000,
      "unit": "₹ per month for unemployed graduates (Rs 1,500 diploma holders) for up to two years (PRS)",
      "changes": []
    },
    "eligibility": "2022-23 graduates/diploma holders of Karnataka unemployed for 6 months",
    "beneficiaries": [
      {
        "asOf": "2025-03",
        "count": 258000,
        "srcs": [
          [
            "The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget",
            "https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2024-25",
        "budgetedCr": null,
        "actualCr": 286,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget",
            "https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Karnataka assembly (previous — the promise)",
      "date": "2023-05-10",
      "monthsFromLaunch": -8,
      "incumbentParty": "BJP",
      "result": "challenger (INC) won",
      "seatChange": "INC +55",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI): 2023 Karnataka Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2024-01",
        "status": "live",
        "note": "",
        "srcs": [
          [
            "The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget",
            "https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Smallest of the five guarantees by outlay (Rs 286 cr vs Rs 52,000 cr bundle); the gap between the 5 lakh estimate and 2.58 lakh registrants suggests either lower eligibility or low take-up — the file has no evaluation.",
        "tier": "analytic",
        "srcs": [
          [
            "The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget",
            "https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"
          ],
          [
            "Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting",
            "https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:siddaramaiah",
        "role": "Chief Minister, Karnataka",
        "action": "announced",
        "date": "2023-05",
        "party": "INC",
        "srcs": [
          [
            "PRS, Karnataka Budget Analysis 2023-24",
            "https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"
          ]
        ]
      }
    ],
    "whoElseBenefits": [],
    "srcs": [
      [
        "PRS, Karnataka Budget Analysis 2023-24",
        "https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"
      ],
      [
        "The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget",
        "https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"
      ],
      [
        "Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting",
        "https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2023 Karnataka Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:kl-welfare-pensions-arrears",
    "name": "Kerala social security pensions (₹1,600/month) and the 2023–26 arrears cycle",
    "al": [
      "Kerala welfare pension",
      "സാമൂഹ്യ സുരക്ഷാ പെൻഷൻ"
    ],
    "level": "state",
    "st": "kl",
    "applicableStates": null,
    "category": "pension",
    "party": "LDF (CPI(M)-led)",
    "announced": {
      "date": "2016-06",
      "byPersonId": "wel:pinarayi-vijayan",
      "office": "Chief Minister, Kerala",
      "srcs": [
        [
          "Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears",
          "https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Kerala budgets 2016–21 (step-wise increases; dates not itemised in opened pages)",
      "srcs": []
    },
    "launched": {
      "date": null,
      "srcs": []
    },
    "benefit": {
      "amount": 1600,
      "unit": "₹ per month to ~62 lakh beneficiaries under five pensions and 16 welfare-board pensions; Centre's share 2% (Rs 200–500 for 6.8 lakh)",
      "changes": [
        {
          "date": "2023",
          "amount": 0,
          "note": "Five months unpaid in FY2023-24 amid a borrowing squeeze (KIIFB/KSSPL loans counted as state debt by the Centre)",
          "srcs": [
            [
              "Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go",
              "https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"
            ],
            [
              "Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears",
              "https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"
            ]
          ]
        },
        {
          "date": "2024-04",
          "amount": 3200,
          "note": "Two months' dues (Rs 3,200) paid three weeks before the Lok Sabha poll",
          "srcs": [
            [
              "Deccan Herald, 8 Apr 2024: As polls approach, Kerala Left govt to pay pension dues",
              "https://www.deccanherald.com/elections/kerala/as-polls-approach-kerala-left-govt-to-pay-pension-dues-2969893"
            ]
          ]
        },
        {
          "date": "2024-09",
          "amount": 3200,
          "note": "Arrears instalment 1 (Onam); instalment 2 on 20 Jan 2025 (Rs 1,604 cr sanctioned); three more promised in 2025-26, before the Apr 2026 assembly poll",
          "srcs": [
            [
              "Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go",
              "https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"
            ],
            [
              "Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears",
              "https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"
            ]
          ]
        }
      ]
    },
    "eligibility": "Old-age, widow, disability, unmarried women 50+, agricultural labour pensions; income/land criteria",
    "beneficiaries": [
      {
        "asOf": "2024-07",
        "count": 6200000,
        "srcs": [
          [
            "Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears",
            "https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"
          ],
          [
            "Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go",
            "https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "annual",
        "budgetedCr": null,
        "actualCr": 11000,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go",
            "https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"
          ]
        ]
      },
      {
        "fy": "2024-25",
        "budgetedCr": 10729,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Kerala Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/kerala-budget-analysis-2024-25"
          ]
        ]
      },
      {
        "fy": "arrears 2023-24",
        "budgetedCr": null,
        "actualCr": 4250,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears",
            "https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Lok Sabha (Kerala)",
      "date": "2024-04-26",
      "monthsFromLaunch": null,
      "incumbentParty": "LDF (state)",
      "result": "LDF won 1 of 20 seats; CPI(M) named unpaid pensions a major cause",
      "seatChange": null,
      "srcs": [
        [
          "Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears",
          "https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"
        ],
        [
          "Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go",
          "https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"
        ]
      ]
    },
    "status": [
      {
        "date": "2016-06",
        "status": "raised",
        "note": "Rs 600 → Rs 1,600 in steps over 2016–21",
        "srcs": [
          [
            "Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears",
            "https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"
          ]
        ]
      },
      {
        "date": "2023",
        "status": "paused",
        "note": "Five months of FY2023-24 unpaid; protests, an elderly man's suicide reported (DH tag, not opened)",
        "srcs": [
          [
            "Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go",
            "https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"
          ],
          [
            "Deccan Herald, 8 Apr 2024: As polls approach, Kerala Left govt to pay pension dues",
            "https://www.deccanherald.com/elections/kerala/as-polls-approach-kerala-left-govt-to-pay-pension-dues-2969893"
          ]
        ]
      },
      {
        "date": "2024-04-08",
        "status": "live",
        "note": "Two months' dues released before the LS poll",
        "srcs": [
          [
            "Deccan Herald, 8 Apr 2024: As polls approach, Kerala Left govt to pay pension dues",
            "https://www.deccanherald.com/elections/kerala/as-polls-approach-kerala-left-govt-to-pay-pension-dues-2969893"
          ]
        ]
      },
      {
        "date": "2024-07-10",
        "status": "live",
        "note": "CM's Assembly statement: time-bound five-instalment settlement",
        "srcs": [
          [
            "Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears",
            "https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"
          ]
        ]
      },
      {
        "date": "2025-01-20",
        "status": "live",
        "note": "Second arrears instalment",
        "srcs": [
          [
            "Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go",
            "https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"
          ]
        ]
      },
      {
        "date": "2026-05",
        "status": "live",
        "note": "UDF government from May 2026; pension policy under the new government not opened",
        "srcs": [
          [
            "DD News, 4 May 2026: UDF crosses majority mark in Kerala (ECI trends)",
            "https://ddnews.gov.in/en/assembly-polls-2026-udf-crosses-majority-mark-in-kerala/"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Reverse case: not a launch but a lapse — a Left government defaulted on an existing pension for five months, paid dues in tranches timed to the Lok Sabha and assembly polls, lost the Lok Sabha 19–1 and then the assembly 102–35. Arrears timing is as election-shaped as any launch in this file; the innocent reading (genuine borrowing-limit squeeze after the Centre reclassified KIIFB/KSSPL debt) is on the record from the CM himself.",
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald, 8 Apr 2024: As polls approach, Kerala Left govt to pay pension dues",
            "https://www.deccanherald.com/elections/kerala/as-polls-approach-kerala-left-govt-to-pay-pension-dues-2969893"
          ],
          [
            "Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears",
            "https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"
          ],
          [
            "Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go",
            "https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"
          ],
          [
            "Wikipedia infobox (pointer to ECI): 2026 Kerala Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2026_Kerala_Legislative_Assembly_election"
          ]
        ]
      },
      {
        "finding": "CM Vijayan attributes the crunch to the Centre: KIIFB/KSSPL borrowings counted against the state's limit (Rs 12,560 cr lost), divisible-pool share cut from 2.505% to 1.92%, Centre paying 2% of the pension bill and in arrears itself (Rs 400 cr). Contra (Union position) not opened this session; recorded as the state's claim.",
        "tier": "alleged",
        "srcs": [
          [
            "Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go",
            "https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"
          ],
          [
            "Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears",
            "https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:pinarayi-vijayan",
        "role": "Chief Minister, Kerala",
        "action": "announced",
        "date": "2024-07-10",
        "party": "CPI(M)",
        "srcs": [
          [
            "Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears",
            "https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"
          ]
        ]
      },
      {
        "personId": "wel:kn-balagopal",
        "role": "Finance Minister, Kerala",
        "action": "administers",
        "date": "2025-01-20",
        "party": "CPI(M)",
        "srcs": [
          [
            "Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go",
            "https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"
          ]
        ]
      },
      {
        "personId": "wel:vd-satheesan",
        "role": "Chief Minister, Kerala (2026→)",
        "action": "administers",
        "date": "2026-05",
        "party": "INC",
        "srcs": [
          [
            "DD News, 4 May 2026: UDF crosses majority mark in Kerala (ECI trends)",
            "https://ddnews.gov.in/en/assembly-polls-2026-udf-crosses-majority-mark-in-kerala/"
          ],
          [
            "Wikipedia infobox (pointer to ECI): 2026 Kerala Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2026_Kerala_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "wel:ksspl",
        "how": "special-purpose vehicle that borrows to pay pensions (off-budget), receiving Rs 10,729 cr in 2024-25",
        "amountCr": 10729,
        "tier": "documented",
        "srcs": [
          [
            "PRS, Kerala Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/kerala-budget-analysis-2024-25"
          ],
          [
            "Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go",
            "https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"
          ]
        ]
      },
      {
        "who": "cooperative banks (doorstep delivery)",
        "how": "pay ~35 lakh beneficiaries in cash at the doorstep; 26.62 lakh by bank transfer",
        "amountCr": null,
        "tier": "documented",
        "srcs": [
          [
            "Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go",
            "https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Deccan Herald, 8 Apr 2024: As polls approach, Kerala Left govt to pay pension dues",
        "https://www.deccanherald.com/elections/kerala/as-polls-approach-kerala-left-govt-to-pay-pension-dues-2969893"
      ],
      [
        "Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears",
        "https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"
      ],
      [
        "Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go",
        "https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"
      ],
      [
        "PRS, Kerala Budget Analysis 2024-25",
        "https://prsindia.org/budgets/states/kerala-budget-analysis-2024-25"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2026 Kerala Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2026_Kerala_Legislative_Assembly_election"
      ],
      [
        "DD News, 4 May 2026: UDF crosses majority mark in Kerala (ECI trends)",
        "https://ddnews.gov.in/en/assembly-polls-2026-udf-crosses-majority-mark-in-kerala/"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2021 Kerala Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2021_Kerala_Legislative_Assembly_election"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2016 Kerala Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2016_Kerala_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:mgnrega",
    "name": "Mahatma Gandhi National Rural Employment Guarantee Act / Scheme",
    "al": [
      "MGNREGA",
      "NREGA",
      "MGNREGS",
      "मनरेगा"
    ],
    "level": "central",
    "st": null,
    "applicableStates": "all",
    "category": "unemployment",
    "party": "INC (UPA)",
    "announced": {
      "date": "2005-08-23",
      "byPersonId": "wel:raghuvansh-prasad-singh",
      "office": "Union Minister of Rural Development, 2004-05-24 → 2009-05",
      "srcs": [
        [
          "Wikipedia (pointer), MGNREGA 2005",
          "https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"
        ],
        [
          "Wikipedia (pointer), Raghuvansh Prasad Singh",
          "https://en.wikipedia.org/wiki/Raghuvansh_Prasad_Singh"
        ]
      ]
    },
    "approved": {
      "date": "2005-08-23",
      "body": "Parliament of India (statute)",
      "srcs": [
        [
          "Wikipedia (pointer), MGNREGA 2005",
          "https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"
        ]
      ]
    },
    "launched": {
      "date": "2006-02-01",
      "srcs": [
        [
          "Wikipedia (pointer), MGNREGA 2005",
          "https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"
        ]
      ]
    },
    "benefit": {
      "amount": 100,
      "unit": "days of guaranteed unskilled wage work per rural household per year (state-notified daily wage)",
      "changes": [
        {
          "date": "2020-03-26",
          "amount": 202,
          "note": "national notified wage floor raised ₹182 → ₹202/day under PM Garib Kalyan package (COVID)",
          "srcs": [
            [
              "PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020",
              "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"
            ]
          ]
        },
        {
          "date": "2026-07-01",
          "amount": 125,
          "note": "guarantee raised to 125 days under VB-G RAM G Act 2025, which repeals MGNREGA w.e.f. 1 Jul 2026",
          "srcs": [
            [
              "PIB Backgrounder, Viksit Bharat-G RAM G Act 2025 FAQ, 11 May 2026",
              "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2259712"
            ]
          ]
        }
      ]
    },
    "eligibility": "any rural household whose adult members volunteer for unskilled manual work; demand-driven; unemployment allowance if work not given within 15 days",
    "beneficiaries": [
      {
        "asOf": "2023-02-03",
        "count": null,
        "srcs": [
          [
            "PIB (MoRD), Clarifications on budget cut to MGNREGA, BE/RE/release series 2014-15 to 2022-23, 3 Feb 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"
          ]
        ]
      },
      {
        "asOf": "2025-12-18",
        "count": 121600000,
        "srcs": [
          [
            "BehanBox, 'The GRAMG Bill codifies the stealthy ways in which NREGA was being undermined', 18 Dec 2025",
            "https://behanbox.com/2025/12/18/the-gramg-bill-codifies-the-stealthy-ways-in-which-nrega-was-being-undermined/"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2014-15",
        "budgetedCr": 34000,
        "actualCr": 32977.43,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MoRD), Clarifications on budget cut to MGNREGA, BE/RE/release series 2014-15 to 2022-23, 3 Feb 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"
          ]
        ]
      },
      {
        "fy": "2015-16",
        "budgetedCr": 34699,
        "actualCr": 37340.72,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MoRD), Clarifications on budget cut to MGNREGA, BE/RE/release series 2014-15 to 2022-23, 3 Feb 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"
          ]
        ]
      },
      {
        "fy": "2016-17",
        "budgetedCr": 38500,
        "actualCr": 48219.05,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MoRD), Clarifications on budget cut to MGNREGA, BE/RE/release series 2014-15 to 2022-23, 3 Feb 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"
          ]
        ]
      },
      {
        "fy": "2017-18",
        "budgetedCr": 48000,
        "actualCr": 55166.06,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MoRD), Clarifications on budget cut to MGNREGA, BE/RE/release series 2014-15 to 2022-23, 3 Feb 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"
          ]
        ]
      },
      {
        "fy": "2018-19",
        "budgetedCr": 55000,
        "actualCr": 61829.55,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MoRD), Clarifications on budget cut to MGNREGA, BE/RE/release series 2014-15 to 2022-23, 3 Feb 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"
          ]
        ]
      },
      {
        "fy": "2019-20",
        "budgetedCr": 60000,
        "actualCr": 71687.71,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MoRD), Clarifications on budget cut to MGNREGA, BE/RE/release series 2014-15 to 2022-23, 3 Feb 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"
          ]
        ]
      },
      {
        "fy": "2020-21",
        "budgetedCr": 61500,
        "actualCr": 111170.86,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MoRD), Clarifications on budget cut to MGNREGA, BE/RE/release series 2014-15 to 2022-23, 3 Feb 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"
          ],
          [
            "PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      },
      {
        "fy": "2021-22",
        "budgetedCr": 73000,
        "actualCr": 98467.85,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      },
      {
        "fy": "2022-23",
        "budgetedCr": 73000,
        "actualCr": 90810.99,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      },
      {
        "fy": "2023-24",
        "budgetedCr": 60000,
        "actualCr": 89268.3,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ],
          [
            "PIB (MoRD), Clarifications on budget cut to MGNREGA, BE/RE/release series 2014-15 to 2022-23, 3 Feb 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"
          ]
        ]
      },
      {
        "fy": "2024-25",
        "budgetedCr": 86000,
        "actualCr": 85838.76,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 86000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      },
      {
        "fy": "2020-21",
        "budgetedCr": 61500,
        "actualCr": 111170.86,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB, Ministry of Rural Development — Budget allocation under MGNREGA, Rajya Sabha written reply by MoS Kamlesh Paswan, 2025-07-25 (Release ID 2148475)",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      },
      {
        "fy": "2021-22",
        "budgetedCr": 73000,
        "actualCr": 98467.85,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB, Ministry of Rural Development — Budget allocation under MGNREGA, Rajya Sabha written reply by MoS Kamlesh Paswan, 2025-07-25 (Release ID 2148475)",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      },
      {
        "fy": "2022-23",
        "budgetedCr": 73000,
        "actualCr": 90810.99,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB, Ministry of Rural Development — Budget allocation under MGNREGA, Rajya Sabha written reply by MoS Kamlesh Paswan, 2025-07-25 (Release ID 2148475)",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      },
      {
        "fy": "2023-24",
        "budgetedCr": 60000,
        "actualCr": 89268.3,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB, Ministry of Rural Development — Budget allocation under MGNREGA, Rajya Sabha written reply by MoS Kamlesh Paswan, 2025-07-25 (Release ID 2148475)",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      },
      {
        "fy": "2024-25",
        "budgetedCr": 86000,
        "actualCr": 85838.76,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB, Ministry of Rural Development — Budget allocation under MGNREGA, Rajya Sabha written reply by MoS Kamlesh Paswan, 2025-07-25 (Release ID 2148475)",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 86000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB, Ministry of Rural Development — Budget allocation under MGNREGA, Rajya Sabha written reply by MoS Kamlesh Paswan, 2025-07-25 (Release ID 2148475)",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Lok Sabha 2009",
      "date": "2009-04-16",
      "monthsFromLaunch": 38,
      "incumbentParty": "INC (UPA)",
      "result": "incumbent won",
      "seatChange": "INC +61 (145→206)",
      "srcs": [
        [
          "Wikipedia (pointer), 2009 Indian general election",
          "https://en.wikipedia.org/wiki/2009_Indian_general_election"
        ],
        [
          "Wikipedia (pointer), MGNREGA 2005",
          "https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"
        ]
      ]
    },
    "status": [
      {
        "date": "2023-02-01",
        "status": "cut",
        "note": "BE 2023-24 ₹60,000 cr, 18% below 2022-23 BE; MoRD said demand-driven releases would follow (they did: RE ₹86,000 cr)",
        "srcs": [
          [
            "PIB (MoRD), Clarifications on budget cut to MGNREGA, BE/RE/release series 2014-15 to 2022-23, 3 Feb 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"
          ],
          [
            "PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      },
      {
        "date": "2025-02-01",
        "status": "live",
        "note": "BE 2025-26 held at ₹86,000 cr — a nominal freeze, real-terms cut",
        "srcs": [
          [
            "PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      },
      {
        "date": "2025-12-18",
        "status": "renamed",
        "note": "VB-G RAM G Bill passed Lok Sabha by voice vote 18 Dec 2025 and Rajya Sabha after midnight the same day amid Opposition protests; 125 days; 60:40 Centre-state funding for most states; 'normative' state allocations; face-authentication attendance; peak-season work pause",
        "srcs": [
          [
            "BehanBox, 'The GRAMG Bill codifies the stealthy ways in which NREGA was being undermined', 18 Dec 2025",
            "https://behanbox.com/2025/12/18/the-gramg-bill-codifies-the-stealthy-ways-in-which-nrega-was-being-undermined/"
          ],
          [
            "Akashvani News, Rajya Sabha takes up VB-G RAM G Bill, 18 Dec 2025",
            "https://www.newsonair.gov.in/lok-sabha-considers-viksit-bharat-bill-to-replace-2005-rural-employment-scheme"
          ],
          [
            "Deccan Herald, Lok Sabha passes VB-G RAM G Bill amid Opposition protests, 18 Dec 2025",
            "https://www.deccanherald.com/india/lok-sabha-passes-vb-g-ram-g-bill-amid-opposition-protests-3835324"
          ],
          [
            "PIB Backgrounder, Viksit Bharat-G RAM G Act 2025 FAQ, 11 May 2026",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2259712"
          ]
        ]
      },
      {
        "date": "2026-07-01",
        "status": "discontinued",
        "note": "MGNREGA stands repealed w.e.f. 1 Jul 2026; superseded by VB-G RAM G Act 2025 (supersession, not deletion)",
        "srcs": [
          [
            "PIB Backgrounder, Viksit Bharat-G RAM G Act 2025 FAQ, 11 May 2026",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2259712"
          ]
        ]
      },
      {
        "date": "2008-04-01",
        "status": "raised",
        "note": "Scaled from 625 pilot districts to all districts of India.",
        "srcs": [
          [
            "Wikipedia — MGNREGA",
            "https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act"
          ]
        ]
      },
      {
        "date": "2023-02-03",
        "status": "cut",
        "note": "BE 2023-24 ₹60,000 crore, 18% below BE 2022-23; MoRD: demand-driven, releases exceed BE (RE 2022-23 ₹89,400 crore)",
        "srcs": [
          [
            "PIB, Ministry of Rural Development — Clarifications on budget cut to MGNREGA, 2023-02-03 (Release ID 1896038)",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"
          ]
        ]
      },
      {
        "date": "2025-07-25",
        "status": "live",
        "note": "BE 2024-25 and 2025-26 ₹86,000 crore, described as the highest-ever BE",
        "srcs": [
          [
            "PIB, Ministry of Rural Development — Budget allocation under MGNREGA, Rajya Sabha written reply by MoS Kamlesh Paswan, 2025-07-25 (Release ID 2148475)",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Imbert & Papp (AEJ Applied 2015): early-phase districts show public hiring crowded out private work and raised private-sector wages; welfare gains to the poor from the wage rise are large relative to gains to participants alone",
        "tier": "documented",
        "srcs": [
          [
            "Imbert & Papp, 'Labor Market Effects of Social Programs: Evidence from India's Employment Guarantee', AEJ: Applied 7(2), 2015",
            "https://www.aeaweb.org/articles?id=10.1257/app.20130401"
          ]
        ]
      },
      {
        "finding": "Muralidharan, Niehaus & Sukhtankar (AER 2016), AP Smartcards RCT over 157 subdistricts/19 mn people: faster, more predictable, less corrupt NREGS payments; significant leakage reduction; no loss of access; time savings alone covered cost",
        "tier": "documented",
        "srcs": [
          [
            "Muralidharan, Niehaus & Sukhtankar, 'Building State Capacity: Evidence from Biometric Smartcards in India', AER 106(10), 2016",
            "https://www.aeaweb.org/articles?id=10.1257/aer.20141346"
          ]
        ]
      },
      {
        "finding": "CAG performance audit (2013) found fall in employment, only 30.3% of planned works completed, planning norms unmet in a third of GPs (as summarised by Wikipedia pointer)",
        "tier": "reported",
        "srcs": [
          [
            "Wikipedia (pointer), MGNREGA 2005",
            "https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"
          ]
        ]
      },
      {
        "finding": "Lokniti-CSDS 2024 post-poll (N=19,663): 33.7% of households report MGNREGA benefit in last 5 years; of these 63.5% credit the central government, 27.0% the state",
        "tier": "documented",
        "srcs": [
          [
            "Lokniti-CSDS, Social and Political Barometer Post-poll Study 2024 — Survey Findings (PDF on file, dated 14 Jun 2024; exact URL not recovered — see gaps)",
            "https://www.lokniti.org/"
          ]
        ]
      },
      {
        "finding": "MoRD, Jul 2025: 99.79% of eligible households offered work against demand in FY 2025-26 (to 22 Jul 2025) — the government's rebuttal to 'cut' narratives",
        "tier": "documented",
        "srcs": [
          [
            "PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      },
      {
        "finding": "Critics (NREGA Sangharsh Morcha via BehanBox): 60:40 sharing could shift ~₹55,000 cr to states; caps on state fund requests introduced 2025; digital attendance excluded workers",
        "tier": "reported",
        "srcs": [
          [
            "BehanBox, 'The GRAMG Bill codifies the stealthy ways in which NREGA was being undermined', 18 Dec 2025",
            "https://behanbox.com/2025/12/18/the-gramg-bill-codifies-the-stealthy-ways-in-which-nrega-was-being-undermined/"
          ]
        ]
      },
      {
        "finding": "Widely credited by political scientists as a contributor to UPA's improved 2009 performance, but the 38-month gap between launch and that election makes a narrow 'pre-poll bribe' reading weak; the innocent reading (a multi-year employment guarantee, not a pre-poll cash drop) fits the timeline better.",
        "tier": "analytic",
        "srcs": []
      },
      {
        "finding": "Muralidharan, Niehaus & Sukhtankar (NBER 23838; Econometrica 2023), randomised at sub-district scale in Andhra Pradesh: improving NREGS implementation raised beneficiary households' earnings by 14% and cut poverty by 26%; 86% of income gains came from non-programme earnings via higher private wages and employment — a general-equilibrium gain invisible in programme-only accounting.",
        "tier": "documented",
        "srcs": [
          [
            "Muralidharan, Niehaus & Sukhtankar, 'General Equilibrium Effects of (Improving) Public Employment Programs: Experimental Evidence from India', NBER WP 23838 (2017; revised, published Econometrica 2023) — abstract",
            "https://www.nber.org/papers/w23838"
          ]
        ]
      },
      {
        "finding": "Same authors (AER 2016), RCT over 157 subdistricts and 19 million people: biometric Smartcard payments made NREGS payments faster, more predictable and less corrupt, reduced leakage in NREGS and social-security pensions without reducing access; time savings alone covered the cost.",
        "tier": "documented",
        "srcs": [
          [
            "Muralidharan, Niehaus & Sukhtankar, 'Building State Capacity: Evidence from Biometric Smartcards in India', AER 106(10), Oct 2016 — abstract",
            "https://www.aeaweb.org/articles?id=10.1257/aer.20141346"
          ]
        ]
      },
      {
        "finding": "Deshpande, Tillin & Kailash (2019, NES 2019): MGNREGA and pension recipients were less likely to vote BJP, while Ujjwala/Jan Dhan/Awas recipients were more likely; MGNREGA, a Congress-era scheme, is now more associated with the central government than before.",
        "tier": "documented",
        "srcs": [
          [
            "Deshpande, Tillin & Kailash (2019) The BJP’s Welfare Schemes: Did They Make a Difference in the 2019 Elections? — Studies in Indian Politics 7(2):219–233 (Crossref metadata + abstract)",
            "https://api.crossref.org/works/10.1177/2321023019874911"
          ]
        ]
      },
      {
        "finding": "Bihar RCT (Banerjee, Duflo, Imbert, Mathew & Pande 2020): a fund-flow/e-governance reform in MGNREGA reduced leakage — reported findings not re-read in this sweep (Crossref metadata only).",
        "tier": "reported",
        "srcs": [
          [
            "Banerjee, Duflo, Imbert, Mathew & Pande (2020) E-governance, Accountability, and Leakage in Public Programs: Experimental Evidence from a Financial Management Reform in India — AEJ: Applied 12(4):39–72 (Crossref metadata)",
            "https://api.crossref.org/works/10.1257/app.20180302"
          ]
        ]
      },
      {
        "finding": "Bihar RCT (Muralidharan, Niehaus, Sukhtankar & Weaver 2021): phone-based monitoring of MGNREGA improved last-mile delivery — findings not re-read in this sweep.",
        "tier": "reported",
        "srcs": [
          [
            "Muralidharan, Niehaus, Sukhtankar & Weaver (2021) Improving Last-Mile Service Delivery Using Phone-Based Monitoring — AEJ: Applied 13(2):52–82 (Crossref metadata)",
            "https://api.crossref.org/works/10.1257/app.20190783"
          ]
        ]
      },
      {
        "finding": "Andhra Pradesh (Muralidharan, Niehaus & Sukhtankar 2016, 2023): biometric smartcard payments and improved NREGS implementation raised wages and had general-equilibrium effects on rural labour markets — findings not re-read in this sweep.",
        "tier": "reported",
        "srcs": [
          [
            "Muralidharan, Niehaus & Sukhtankar (2016) Building State Capacity: Evidence from Biometric Smartcards in India — AER 106(10):2895–2929 (Crossref metadata)",
            "https://api.crossref.org/works/10.1257/aer.20141346"
          ],
          [
            "Muralidharan, Niehaus & Sukhtankar (2023) General Equilibrium Effects of (Improving) Public Employment Programs — Econometrica 91(4):1261–1295 (Crossref metadata)",
            "https://api.crossref.org/works/10.3982/ECTA18181"
          ]
        ]
      },
      {
        "finding": "MoRD (PIB 2023-02-03) rebutted the ‘18% cut’ reading: MGNREGA is demand-driven and actual releases have exceeded BE every year since 2014-15; the West Bengal fund stoppage under s.27 is not addressed in either PIB release opened.",
        "tier": "documented",
        "srcs": [
          [
            "PIB, Ministry of Rural Development — Clarifications on budget cut to MGNREGA, 2023-02-03 (Release ID 1896038)",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"
          ],
          [
            "PIB, Ministry of Rural Development — Budget allocation under MGNREGA, Rajya Sabha written reply by MoS Kamlesh Paswan, 2025-07-25 (Release ID 2148475)",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:raghuvansh-prasad-singh",
        "role": "Union Minister of Rural Development",
        "action": "administers",
        "date": "2004-05-24",
        "party": "RJD",
        "srcs": [
          [
            "Wikipedia (pointer), Raghuvansh Prasad Singh",
            "https://en.wikipedia.org/wiki/Raghuvansh_Prasad_Singh"
          ]
        ]
      },
      {
        "personId": "wel:manmohan-singh",
        "role": "Prime Minister",
        "action": "approved",
        "date": "2005-08-23",
        "party": "INC",
        "srcs": [
          [
            "Wikipedia (pointer), MGNREGA 2005",
            "https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"
          ]
        ]
      },
      {
        "personId": "wel:arun-jaitley",
        "role": "Union Finance Minister",
        "action": "presented budget",
        "date": "2017-02-01",
        "party": "BJP",
        "srcs": [
          [
            "Wikipedia (pointer), MGNREGA 2005",
            "https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"
          ]
        ]
      },
      {
        "personId": "pol:nirmala-sitharaman",
        "role": "Union Finance Minister",
        "action": "presented budget",
        "date": "2023-02-01",
        "party": "BJP",
        "srcs": [
          [
            "Union Budget 2023-24 speech, Nirmala Sitharaman, 1 Feb 2023",
            "https://www.indiabudget.gov.in/budget2023-24/doc/Budget_Speech.pdf"
          ],
          [
            "PIB (MoRD), Clarifications on budget cut to MGNREGA, BE/RE/release series 2014-15 to 2022-23, 3 Feb 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"
          ]
        ]
      },
      {
        "personId": "pol:shivraj-singh-chouhan",
        "role": "Union Minister of Rural Development; Agriculture & Farmers' Welfare",
        "action": "announced",
        "date": "2025-12-16",
        "party": "BJP",
        "srcs": [
          [
            "Akashvani News, Rajya Sabha takes up VB-G RAM G Bill, 18 Dec 2025",
            "https://www.newsonair.gov.in/lok-sabha-considers-viksit-bharat-bill-to-replace-2005-rural-employment-scheme"
          ],
          [
            "Akashvani News, Chouhan says VB-G RAM G Bill removes shortcomings of MGNREGA, 30 Dec 2025",
            "https://www.newsonair.gov.in/union-minister-shivraj-singh-chouhan-says-viksit-bharat-g-ram-g-bill-removes-shortcomings-of-mgnrega"
          ]
        ]
      },
      {
        "personId": "wel:kamlesh-paswan",
        "role": "Minister of State, Rural Development",
        "action": "administers",
        "date": "2025-07-25",
        "party": null,
        "srcs": [
          [
            "PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      },
      {
        "personId": "wel:manmohan-singh",
        "role": "Prime Minister",
        "action": "announced",
        "date": "2005-09-05",
        "party": "INC",
        "srcs": [
          [
            "Wikipedia — MGNREGA",
            "https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act"
          ]
        ]
      },
      {
        "personId": "wel:raghuvansh-prasad-singh",
        "role": "Union Minister of Rural Development",
        "action": "administers",
        "date": "2006-02-02",
        "party": "RJD",
        "srcs": [
          [
            "Wikipedia — MGNREGA",
            "https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act"
          ]
        ]
      },
      {
        "personId": "wel:kamlesh-paswan",
        "role": "Minister of State, Rural Development",
        "action": "administers",
        "date": "2025-07-25",
        "party": "BJP",
        "srcs": [
          [
            "PIB, Ministry of Rural Development — Budget allocation under MGNREGA, Rajya Sabha written reply by MoS Kamlesh Paswan, 2025-07-25 (Release ID 2148475)",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "state governments (fiscal transfer recipient)",
        "how": "Centre-funded wages flow through state implementing agencies; under G RAM G the burden shifts to states (60:40)",
        "amountCr": null,
        "tier": "documented",
        "srcs": [
          [
            "PIB Backgrounder, Viksit Bharat-G RAM G Act 2025 FAQ, 11 May 2026",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2259712"
          ]
        ]
      },
      {
        "who": "banks and post offices",
        "how": "wage DBT into worker accounts; float and account-opening (10 crore new accounts by 2012 per MGNREGA Sameeksha)",
        "amountCr": null,
        "tier": "reported",
        "srcs": [
          [
            "Wikipedia (pointer), MGNREGA 2005",
            "https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
      ],
      [
        "PIB (MoRD), Clarifications on budget cut to MGNREGA, BE/RE/release series 2014-15 to 2022-23, 3 Feb 2023",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"
      ],
      [
        "PIB Backgrounder, Viksit Bharat-G RAM G Act 2025 FAQ, 11 May 2026",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2259712"
      ],
      [
        "Wikipedia (pointer), MGNREGA 2005",
        "https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"
      ],
      [
        "Wikipedia — MGNREGA",
        "https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act"
      ],
      [
        "Muralidharan, Niehaus & Sukhtankar, 'General Equilibrium Effects of (Improving) Public Employment Programs: Experimental Evidence from India', NBER WP 23838 (2017; revised, published Econometrica 2023) — abstract",
        "https://www.nber.org/papers/w23838"
      ],
      [
        "Muralidharan, Niehaus & Sukhtankar, 'Building State Capacity: Evidence from Biometric Smartcards in India', AER 106(10), Oct 2016 — abstract",
        "https://www.aeaweb.org/articles?id=10.1257/aer.20141346"
      ],
      [
        "PIB, Ministry of Rural Development — Budget allocation under MGNREGA, Rajya Sabha written reply by MoS Kamlesh Paswan, 2025-07-25 (Release ID 2148475)",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"
      ],
      [
        "PIB, Ministry of Rural Development — Clarifications on budget cut to MGNREGA, 2023-02-03 (Release ID 1896038)",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"
      ],
      [
        "Deshpande, Tillin & Kailash (2019) The BJP’s Welfare Schemes: Did They Make a Difference in the 2019 Elections? — Studies in Indian Politics 7(2):219–233 (Crossref metadata + abstract)",
        "https://api.crossref.org/works/10.1177/2321023019874911"
      ]
    ],
    "domain": "central"
  },
  {
    "id": "scheme:mh-farm-loan-waiver-2017",
    "name": "Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017",
    "al": [
      "CSMSSY",
      "Maharashtra loan waiver 2017"
    ],
    "level": "state",
    "st": "mh",
    "applicableStates": null,
    "category": "loan-waiver",
    "party": "BJP-Shiv Sena",
    "announced": {
      "date": "2017-06",
      "byPersonId": "wel:devendra-fadnavis",
      "office": "Chief Minister, Maharashtra",
      "srcs": [
        [
          "Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)",
          "https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"
        ]
      ]
    },
    "approved": {
      "date": "2017-06-28",
      "body": "Government Resolution, Co-operation Dept",
      "srcs": [
        [
          "Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)",
          "https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"
        ]
      ]
    },
    "launched": {
      "date": "2017-06-28",
      "srcs": [
        [
          "Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)",
          "https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"
        ]
      ]
    },
    "benefit": {
      "amount": 150000,
      "unit": "₹ waiver of arrears up to Rs 1.5 lakh; OTS above; Rs 25,000 incentive for regular payers",
      "changes": []
    },
    "eligibility": "Loans 1 Apr 2001–31 Mar 2016 in arrears",
    "beneficiaries": [
      {
        "asOf": "2020",
        "count": 4404000,
        "srcs": [
          [
            "Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)",
            "https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "cumulative",
        "budgetedCr": null,
        "actualCr": 18762,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)",
            "https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"
          ]
        ]
      },
      {
        "fy": "2017-18",
        "budgetedCr": null,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Maharashtra Budget Analysis 2018-19",
            "https://prsindia.org/budgets/states/maharashtra-budget-analysis-2018-19"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Maharashtra assembly",
      "date": "2019-10-21",
      "monthsFromLaunch": 28,
      "incumbentParty": "BJP-Shiv Sena",
      "result": "pre-poll bloc largest (BJP 105, SHS 56) but government formed by SHS-NCP-INC (MVA)",
      "seatChange": "BJP -17 (fleet file)",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI results): 2019 Maharashtra Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2019_Maharashtra_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2017-06-28",
        "status": "live",
        "note": "",
        "srcs": [
          [
            "Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)",
            "https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"
          ]
        ]
      },
      {
        "date": "2020",
        "status": "live",
        "note": "Official page (undated; read Sep 2026): Rs 5,975.61 cr to 6.56 lakh accounts \"yet to be provided\" — unfinished at the time of the page",
        "srcs": [
          [
            "Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)",
            "https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Official outturn Rs 18,762 cr vs the ~Rs 34,000 cr headline at announcement (press); a third of the promised relief remained unpaid on the state's own page. Innocent reading: eligibility screening (Aadhaar/online forms) removed duplicates; skeptical reading: headline inflated, delivery incomplete through the 2019 poll.",
        "tier": "analytic",
        "srcs": [
          [
            "Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)",
            "https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"
          ],
          [
            "PRS, Maharashtra Budget Analysis 2018-19",
            "https://prsindia.org/budgets/states/maharashtra-budget-analysis-2018-19"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:devendra-fadnavis",
        "role": "Chief Minister, Maharashtra",
        "action": "approved",
        "date": "2017-06-28",
        "party": "BJP",
        "srcs": [
          [
            "Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)",
            "https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "DCC banks and commercial banks",
        "how": "Rs 13,705 cr arrears settled by the state",
        "amountCr": 13705,
        "tier": "documented",
        "srcs": [
          [
            "Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)",
            "https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)",
        "https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"
      ],
      [
        "PRS, Maharashtra Budget Analysis 2018-19",
        "https://prsindia.org/budgets/states/maharashtra-budget-analysis-2018-19"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2019 Maharashtra Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2019_Maharashtra_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:mh-farm-loan-waiver-2019",
    "name": "Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019",
    "al": [
      "MJPSKY",
      "Maharashtra loan waiver 2019"
    ],
    "level": "state",
    "st": "mh",
    "applicableStates": null,
    "category": "loan-waiver",
    "party": "MVA (Shiv Sena-NCP-INC)",
    "announced": {
      "date": "2019-12",
      "byPersonId": "wel:uddhav-thackeray",
      "office": "Chief Minister, Maharashtra",
      "srcs": [
        [
          "Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)",
          "https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"
        ]
      ]
    },
    "approved": {
      "date": "2019-12-27",
      "body": "Government Resolution, Co-operation Dept",
      "srcs": [
        [
          "Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)",
          "https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"
        ]
      ]
    },
    "launched": {
      "date": "2019-12-27",
      "srcs": [
        [
          "Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)",
          "https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"
        ]
      ]
    },
    "benefit": {
      "amount": 200000,
      "unit": "₹ waiver of crop loans (1 Apr 2015–31 Mar 2019) overdue as of 30 Sep 2019; Rs 50,000 incentive for regular payers per aggregator (not opened)",
      "changes": []
    },
    "eligibility": "Crop and restructured crop loans up to Rs 2 lakh overdue on 30 Sep 2019",
    "beneficiaries": [
      {
        "asOf": "2021",
        "count": 3237000,
        "srcs": [
          [
            "Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)",
            "https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "cumulative",
        "budgetedCr": null,
        "actualCr": 20497,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)",
            "https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"
          ]
        ]
      },
      {
        "fy": "2019-20",
        "budgetedCr": 15000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Maharashtra Budget Analysis 2020-21",
            "https://prsindia.org/budgets/states/maharashtra-budget-analysis-2020-21"
          ]
        ]
      },
      {
        "fy": "2020-21",
        "budgetedCr": 7000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Maharashtra Budget Analysis 2020-21",
            "https://prsindia.org/budgets/states/maharashtra-budget-analysis-2020-21"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Maharashtra assembly (previous)",
      "date": "2019-10-21",
      "monthsFromLaunch": -2,
      "incumbentParty": "BJP-Shiv Sena",
      "result": "MVA government formed 28 Nov 2019; waiver its first major act (one month in)",
      "seatChange": "n/a",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI results): 2019 Maharashtra Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2019_Maharashtra_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2019-12-27",
        "status": "live",
        "note": "",
        "srcs": [
          [
            "Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)",
            "https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"
          ]
        ]
      },
      {
        "date": "2022-06-30",
        "status": "live",
        "note": "MVA government fell (Shinde split); scheme page records Rs 20,497 cr delivered",
        "srcs": [
          [
            "Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)",
            "https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Two waivers by two different coalitions in the same state within 30 months (Rs 18,762 cr + Rs 20,497 cr); RBI IWG (2019) warning about credit culture applies to both — the file records them symmetrically.",
        "tier": "analytic",
        "srcs": [
          [
            "Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)",
            "https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"
          ],
          [
            "Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)",
            "https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"
          ],
          [
            "PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)",
            "https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:uddhav-thackeray",
        "role": "Chief Minister, Maharashtra",
        "action": "approved",
        "date": "2019-12-27",
        "party": "Shiv Sena (undivided)",
        "srcs": [
          [
            "Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)",
            "https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "nationalised, DCC and regional rural banks",
        "how": "Rs 20,497 cr settled by the state",
        "amountCr": 20497,
        "tier": "documented",
        "srcs": [
          [
            "Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)",
            "https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)",
        "https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"
      ],
      [
        "PRS, Maharashtra Budget Analysis 2020-21",
        "https://prsindia.org/budgets/states/maharashtra-budget-analysis-2020-21"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2024 Maharashtra Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2024_Maharashtra_Legislative_Assembly_election"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2019 Maharashtra Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2019_Maharashtra_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:mh-ladki-bahin",
    "name": "Mukhyamantri Majhi Ladki Bahin Yojana",
    "al": [
      "Ladki Bahin",
      "लाडकी बहीण",
      "Majhi Ladki Bahin",
      "माझी लाडकी बहीण"
    ],
    "level": "state",
    "st": "mh",
    "applicableStates": null,
    "category": "women-cash",
    "party": "BJP",
    "announced": {
      "date": "2024-06-28",
      "byPersonId": "wel:ajit-pawar",
      "office": "Deputy Chief Minister and Finance Minister, Maharashtra",
      "srcs": [
        [
          "Govt of Maharashtra (Nashik) — Ladki Bahin Yojana",
          "https://nashik.gov.in/en/scheme/mukhyamantri-mazi-ladki-bahin-yojana/"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Maharashtra Cabinet",
      "srcs": []
    },
    "launched": {
      "date": "2024-08-17",
      "srcs": [
        [
          "Govt of Maharashtra (Nashik) — Ladki Bahin Yojana",
          "https://nashik.gov.in/en/scheme/mukhyamantri-mazi-ladki-bahin-yojana/"
        ]
      ]
    },
    "benefit": {
      "amount": 1500,
      "unit": "₹ per month, with benefits backdated to July 2024",
      "changes": [
        {
          "date": null,
          "amount": 500,
          "note": "PRS: in April 2025 Maharashtra reduced the monthly benefit from ₹1,500 to ₹500 for women already receiving ₹1,000/month under another state-funded DBT scheme for women farmers (month-level date; day not given by source)",
          "srcs": [
            [
              "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
              "https://prsindia.org/files/budget/SOSF_2025.pdf"
            ]
          ]
        },
        {
          "date": "2025-04-01",
          "amount": 500,
          "note": "Reduced to ₹500 for women already receiving ₹1,000/month under the state’s women-farmer DBT scheme (PRS citing The Hindu; exact April 2025 date not verified)",
          "srcs": [
            [
              "PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)",
              "https://prsindia.org/policy/analytical-reports"
            ]
          ]
        },
        {
          "date": "2024-09-14",
          "amount": null,
          "note": "PROMISE: Shinde — Rs 2,000 with more strength, Rs 3,000 with a 'bigger mandate'; Mahayuti manifesto: Rs 2,100. Not enacted as of Jul 2026",
          "srcs": [
            [
              "Deccan Herald, 14 Sep 2024: Shinde — bigger mandate, will raise Ladki Bahin to Rs 3,000",
              "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-give-us-a-bigger-mandate-will-double-ladki-bahin-dole-to-rs-3000-eknath-shinde-3191037"
            ],
            [
              "Deccan Herald, 6 Nov 2024: NCP manifesto promises Ladki Bahin Rs 2,100",
              "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ajit-pawars-ncp-releases-constituency-wise-manifesto-promises-increase-in-ladki-bahin-yojana-amount-3264259"
            ],
            [
              "Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification",
              "https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"
            ]
          ]
        },
        {
          "date": "2025-04",
          "amount": 500,
          "note": "CUT for ~7.74–8 lakh women also receiving Rs 1,000 under Namo Shetkari Mahasanman Nidhi (combined cap Rs 1,500)",
          "srcs": [
            [
              "Scroll, 16 Apr 2025: Maharashtra cuts Ladki Bahin payout for 8 lakh women to Rs 500",
              "https://scroll.in/latest/1081399/maharashtra-cuts-ladki-bahin-yojana-payout-for-8-lakh-women-to-rs-500-per-month-report"
            ],
            [
              "Deccan Herald, 16 Apr 2025: Aaditya Thackeray says Ladki Bahin 'more or less ended'; Tatkare response",
              "https://www.deccanherald.com/india/maharashtra/ladki-bahin-scheme-more-or-less-finished-claims-aaditya-thackeray-3496353"
            ]
          ]
        }
      ]
    },
    "eligibility": "women aged 21-65 (age limit extended from an initial narrower band), income criteria",
    "beneficiaries": [
      {
        "asOf": "2024-08-14",
        "count": 8000000,
        "srcs": [
          [
            "Deccan Herald, 15 Aug 2024: Shinde govt begins releasing Ladki Bahin money",
            "https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"
          ]
        ]
      },
      {
        "asOf": "2024-12",
        "count": 24600000,
        "srcs": [
          [
            "Deccan Herald, 9 Feb 2025: Ladki Bahin beneficiaries drop by 5 lakh; no recovery",
            "https://www.deccanherald.com/india/maharashtra/ladki-bahin-beneficiaries-drop-by-5-lakh-no-taking-back-money-from-those-ineligible-says-minister-3397268"
          ]
        ]
      },
      {
        "asOf": "2025-01",
        "count": 24100000,
        "srcs": [
          [
            "Deccan Herald, 9 Feb 2025: Ladki Bahin beneficiaries drop by 5 lakh; no recovery",
            "https://www.deccanherald.com/india/maharashtra/ladki-bahin-beneficiaries-drop-by-5-lakh-no-taking-back-money-from-those-ineligible-says-minister-3397268"
          ]
        ]
      },
      {
        "asOf": "2025-03",
        "count": 25300000,
        "srcs": [
          [
            "Deccan Herald, 10 Mar 2025: Maharashtra budget gives Rs 36,000 cr to Ladki Bahin, silent on Rs 2,100",
            "https://www.deccanherald.com/india/maharashtra/maharashtra-govt-gives-rs-36000-crore-to-ladki-bahin-in-budget-mum-on-stipend-hike-ups-vehicle-tax-3440102"
          ]
        ]
      },
      {
        "asOf": "2025-07",
        "count": null,
        "srcs": [
          [
            "Deccan Herald, 29 Jul 2025: Supriya Sule alleges Rs 4,800 cr fraud, seeks SIT",
            "https://www.deccanherald.com/india/maharashtra/supriya-sule-alleges-rs-4800-crore-fraud-in-ladki-bahin-yojana-seeks-sit-probe-3654533"
          ]
        ]
      },
      {
        "asOf": "2026-07",
        "count": 15000000,
        "srcs": [
          [
            "Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification",
            "https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2025-26",
        "budgetedCr": 36000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "fy": "2024-25",
        "budgetedCr": null,
        "actualCr": 199.81,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024",
            "https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"
          ]
        ]
      },
      {
        "fy": "2024-25",
        "budgetedCr": 46000,
        "actualCr": 33232,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Deccan Herald, 15 Aug 2024: Shinde govt begins releasing Ladki Bahin money",
            "https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"
          ],
          [
            "Deccan Herald, 10 Mar 2025: Maharashtra budget gives Rs 36,000 cr to Ladki Bahin, silent on Rs 2,100",
            "https://www.deccanherald.com/india/maharashtra/maharashtra-govt-gives-rs-36000-crore-to-ladki-bahin-in-budget-mum-on-stipend-hike-ups-vehicle-tax-3440102"
          ],
          [
            "Scroll, 16 Apr 2025: Maharashtra cuts Ladki Bahin payout for 8 lakh women to Rs 500",
            "https://scroll.in/latest/1081399/maharashtra-cuts-ladki-bahin-yojana-payout-for-8-lakh-women-to-rs-500-per-month-report"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 36000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Deccan Herald, 10 Mar 2025: Maharashtra budget gives Rs 36,000 cr to Ladki Bahin, silent on Rs 2,100",
            "https://www.deccanherald.com/india/maharashtra/maharashtra-govt-gives-rs-36000-crore-to-ladki-bahin-in-budget-mum-on-stipend-hike-ups-vehicle-tax-3440102"
          ],
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "fy": "2026-27",
        "budgetedCr": 26500,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification",
            "https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Maharashtra assembly",
      "date": "2024-11-20",
      "monthsFromLaunch": 3,
      "incumbentParty": "Mahayuti (BJP-Shiv Sena(Shinde)-NCP(Ajit Pawar))",
      "result": "incumbent won",
      "seatChange": "Mahayuti 230/288, MVA 50/288 (one of the largest margins in Maharashtra's history)",
      "srcs": [
        [
          "ETV Bharat — Maharashtra 2024 final result, Mahayuti 230 seats",
          "https://www.etvbharat.com/en/!bharat/maharashtra-assembly-election-2024-counting-mahayuti-mva-bjp-shiv-sena-ubt-ncp-congress-enn24112205094"
        ]
      ]
    },
    "status": [
      {
        "date": "2024-07-02",
        "status": "raised",
        "note": "Eligible age band widened from 21-60 to 21-65 shortly after the scheme was announced, before the first payment went out — an eligibility loosening, not a tightening, in the run-up to the poll.",
        "srcs": []
      },
      {
        "date": null,
        "status": "cut",
        "note": "Benefit cut to ₹500 for overlapping beneficiaries (PRS cites this as a fiscal-pressure response).",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "date": "2024-08-14",
        "status": "launched",
        "note": "first instalments released on the eve of Independence Day",
        "srcs": [
          [
            "Deccan Herald, 2024-08-15 — Shinde govt begins releasing money under Ladki Bahin Yojana on eve of Independence Day",
            "https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"
          ]
        ]
      },
      {
        "date": "2024-09-14",
        "status": "announced",
        "note": "Shinde: dole to be doubled to ₹3,000 with a bigger mandate; manifesto figure ₹2,100",
        "srcs": [
          [
            "Deccan Herald, 2024-09-14 — ‘Give us a bigger mandate, will double Ladki Bahin dole to ₹3,000’: Eknath Shinde",
            "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-give-us-a-bigger-mandate-will-double-ladki-bahin-dole-to-rs-3000-eknath-shinde-3191037"
          ],
          [
            "Lokniti-CSDS Maharashtra 2024 post-poll analysis, The Hindu, 25 Nov 2024 (Deshpande, ‘Women sided with Mahayuti for Ladki Bahin Yojana’s monthly dole’; Mishra, women as deciders) — page PDF held locally; thehindu.com unreachable from this container",
            "https://www.lokniti.org/state-assembly-elections"
          ]
        ]
      },
      {
        "date": "2025-04-01",
        "status": "cut",
        "note": "₹1,500 → ₹500 for beneficiaries overlapping the women-farmer scheme; ₹2,100 promise not implemented as of PRS Oct 2025",
        "srcs": [
          [
            "PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)",
            "https://prsindia.org/policy/analytical-reports"
          ]
        ]
      },
      {
        "date": "2026-08-14",
        "status": "live",
        "note": "Fadnavis: promises fulfilled, scheme will not be discontinued",
        "srcs": [
          [
            "ThePrint, 2026-08-14 — Govt fulfilled promises made during 2024 polls, will not discontinue Ladki Bahin: Fadnavis",
            "https://theprint.in/india/govt-fulfilled-promises-made-during-2024-polls-will-not-discontinue-ladki-bahin-fadnavis/3015115/"
          ]
        ]
      },
      {
        "date": "2024-10-04",
        "status": "live",
        "note": null,
        "srcs": [
          [
            "Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024",
            "https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"
          ]
        ]
      },
      {
        "date": "2024-08-14",
        "status": "live",
        "note": null,
        "srcs": [
          [
            "Deccan Herald, 15 Aug 2024: Shinde govt begins releasing Ladki Bahin money",
            "https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"
          ]
        ]
      },
      {
        "date": "2024-08-05",
        "status": "live",
        "note": "Bombay HC dismissed PIL challenging the scheme as a burden on taxpayers",
        "srcs": [
          [
            "Deccan Herald, 5 Aug 2024: Bombay HC dismisses PIL against Ladki Bahin",
            "https://www.deccanherald.com/india/maharashtra/ladki-bahin-yojana-a-beneficiary-scheme-for-women-not-discriminatory-bombay-high-court-3137089"
          ]
        ]
      },
      {
        "date": "2025-01",
        "status": "eligibility-tightened",
        "note": "5 lakh removed; Rs 450 cr already paid not recovered",
        "srcs": [
          [
            "Deccan Herald, 9 Feb 2025: Ladki Bahin beneficiaries drop by 5 lakh; no recovery",
            "https://www.deccanherald.com/india/maharashtra/ladki-bahin-beneficiaries-drop-by-5-lakh-no-taking-back-money-from-those-ineligible-says-minister-3397268"
          ]
        ]
      },
      {
        "date": "2025-03-10",
        "status": "promised-not-enacted",
        "note": "Budget 2025-26 silent on Rs 2,100; Fadnavis: after 'fiscal balance'; Shinde: 'not a printing mistake… need some time'",
        "srcs": [
          [
            "Deccan Herald, 10 Mar 2025: Maharashtra budget gives Rs 36,000 cr to Ladki Bahin, silent on Rs 2,100",
            "https://www.deccanherald.com/india/maharashtra/maharashtra-govt-gives-rs-36000-crore-to-ladki-bahin-in-budget-mum-on-stipend-hike-ups-vehicle-tax-3440102"
          ]
        ]
      },
      {
        "date": "2025-04",
        "status": "cut",
        "note": "Rs 1,500→Rs 500 for ~8 lakh Namo Shetkari recipients; outlay Rs 46,000→36,000 cr",
        "srcs": [
          [
            "Scroll, 16 Apr 2025: Maharashtra cuts Ladki Bahin payout for 8 lakh women to Rs 500",
            "https://scroll.in/latest/1081399/maharashtra-cuts-ladki-bahin-yojana-payout-for-8-lakh-women-to-rs-500-per-month-report"
          ],
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "date": "2025-07",
        "status": "eligibility-tightened",
        "note": "26.34 lakh suspended; 14,298 men to face recovery and FIRs",
        "srcs": [
          [
            "Deccan Herald, 29 Jul 2025: Supriya Sule alleges Rs 4,800 cr fraud, seeks SIT",
            "https://www.deccanherald.com/india/maharashtra/supriya-sule-alleges-rs-4800-crore-fraud-in-ladki-bahin-yojana-seeks-sit-probe-3654533"
          ]
        ]
      },
      {
        "date": "2026-07",
        "status": "eligibility-tightened",
        "note": "92 lakh removed after eKYC; ~Rs 14,000 cr paid to since-ineligible beneficiaries; Rs 2,100 still unpaid; BE cut to Rs 26,500 cr",
        "srcs": [
          [
            "Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification",
            "https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "A Lokniti-CSDS post-poll survey found 54% of women who had applied for Ladki Bahin backed the Mahayuti, versus 43% among women who had not applied — an 11-point gap attributable to the scheme, and only a 3-point gender gap in Mahayuti support overall, i.e. the survey's own numbers argue against 'women as a monolithic pro-scheme voting bloc' even as they show a real, measurable, bounded scheme effect.",
        "tier": "reported",
        "srcs": [
          [
            "Outlook Business — women deciding Indian politics, cash transfers",
            "https://www.outlookbusiness.com/economy-and-policy/story-in-numbers-women-are-deciding-indian-politics-now-cash-transfers-are-proof"
          ],
          [
            "BehanBox — Maharashtra poll analyses miss women's agency",
            "https://behanbox.com/2024/12/04/how-maharashtra-poll-analyses-are-missing-the-rise-of-womens-agency/"
          ]
        ]
      },
      {
        "finding": "Largest UCT line in any state budget in 2025-26: ₹36,000 cr, 5.9% of Maharashtra's revenue expenditure (PRS).",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "Maharashtra's declared off-budget borrowings rose from ₹0 (2021-22) to ₹2,500 cr (2022-23), ₹7,700 cr (2023-24) and ₹13,990 cr (2024-25) — the only state in the PRS table with a steep rise, while the 19-state total fell from ₹67,075 cr to ₹24,955 cr. The rise precedes the scheme (Aug 2024) and the table does not say what the borrowing funded; no link to Ladki Bahin is established.",
        "tier": "analytic",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "Lokniti-CSDS Maharashtra 2024 post-poll (The Hindu, 25 Nov 2024): more than 80% of women respondents said they had applied for Ladki Bahin; support for the Mahayuti was higher among women than men by about 3 points, higher still among rural women and applicants; the analysts (Deshpande) judge it ‘too early’ to conclude a new constituency of women-as-beneficiaries exists and ‘an exaggeration’ to say women’s vote shaped the victory, though women ‘surely seem to have contributed’.",
        "tier": "reported",
        "srcs": [
          [
            "Lokniti-CSDS Maharashtra 2024 post-poll analysis, The Hindu, 25 Nov 2024 (Deshpande, ‘Women sided with Mahayuti for Ladki Bahin Yojana’s monthly dole’; Mishra, women as deciders) — page PDF held locally; thehindu.com unreachable from this container",
            "https://www.lokniti.org/state-assembly-elections"
          ]
        ]
      },
      {
        "finding": "The same Lokniti write-up notes ‘overall weak and uneven implementation of the welfare schemes’ and ‘hardly any connection between welfare and vote’ except for Ladki Bahin — an argument for a scheme-specific rather than a general welfare effect.",
        "tier": "reported",
        "srcs": [
          [
            "Lokniti-CSDS Maharashtra 2024 post-poll analysis, The Hindu, 25 Nov 2024 (Deshpande, ‘Women sided with Mahayuti for Ladki Bahin Yojana’s monthly dole’; Mishra, women as deciders) — page PDF held locally; thehindu.com unreachable from this container",
            "https://www.lokniti.org/state-assembly-elections"
          ]
        ]
      },
      {
        "finding": "Bombay High Court (Aug 2024) dismissed a challenge, calling it a beneficiary scheme for women, not discriminatory.",
        "tier": "reported",
        "srcs": [
          [
            "Deccan Herald, 2024-08-05 — Ladki Bahin Yojana a beneficiary scheme for women, not discriminatory: Bombay High Court",
            "https://www.deccanherald.com/india/maharashtra/ladki-bahin-yojana-a-beneficiary-scheme-for-women-not-discriminatory-bombay-high-court-3137089"
          ]
        ]
      },
      {
        "finding": "Promise vs delivery: manifesto ₹2,100/month; Shinde said ₹3,000 on 2024-09-14; ₹1,500 continued after the win and was cut to ₹500 for overlapping beneficiaries from April 2025 (PRS).",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)",
            "https://prsindia.org/policy/analytical-reports"
          ],
          [
            "Deccan Herald, 2024-09-14 — ‘Give us a bigger mandate, will double Ladki Bahin dole to ₹3,000’: Eknath Shinde",
            "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-give-us-a-bigger-mandate-will-double-ladki-bahin-dole-to-rs-3000-eknath-shinde-3191037"
          ],
          [
            "Lokniti-CSDS Maharashtra 2024 post-poll analysis, The Hindu, 25 Nov 2024 (Deshpande, ‘Women sided with Mahayuti for Ladki Bahin Yojana’s monthly dole’; Mishra, women as deciders) — page PDF held locally; thehindu.com unreachable from this container",
            "https://www.lokniti.org/state-assembly-elections"
          ]
        ]
      },
      {
        "finding": "Supriya Sule (NCP-SP) alleged a ₹4,800 crore fraud in DBT payments and sought an SIT (2025-07-29); the government’s response was not captured in the page text opened — a weakness of the record, not of the allegation.",
        "tier": "alleged",
        "srcs": []
      },
      {
        "finding": "Vijay Wadettiwar (INC) claimed 92.10 lakh women were removed from the rolls and that women were ‘used only for electoral gains’ (2026-08-19); Fadnavis five days earlier said promises were fulfilled and the scheme would continue.",
        "tier": "alleged",
        "srcs": []
      },
      {
        "finding": "Government/alliance response on record: Sunil Tatkare (NCP) — every government including the Centre advertises new schemes; Prasad Lad (BJP) — 'how else would people know?'",
        "tier": "reported",
        "srcs": [
          [
            "Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024",
            "https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"
          ]
        ]
      },
      {
        "finding": "Lokniti-CSDS Maharashtra post-poll (Nov 2024, N=3,959): women 50% vs men 47% for Mahayuti; among women who applied for Ladki Bahin 54% preferred Mahayuti vs 43% of non-applicants; authors: 'hardly any connection between welfare and vote' and a 3-point gender gap is 'too early' to call a women's constituency",
        "tier": "reported",
        "srcs": [
          [
            "BehanBox, 4 Dec 2024: Maharashtra poll analyses and women's agency (cites Lokniti-CSDS post-poll)",
            "https://behanbox.com/2024/12/04/how-maharashtra-poll-analyses-are-missing-the-rise-of-womens-agency/"
          ]
        ]
      },
      {
        "finding": "BehanBox: Shinde government spent Rs 250 crore on Ladki Bahin advertising (radio, TV, Marathi papers, hoardings)",
        "tier": "reported",
        "srcs": [
          [
            "BehanBox, 4 Dec 2024: Maharashtra poll analyses and women's agency (cites Lokniti-CSDS post-poll)",
            "https://behanbox.com/2024/12/04/how-maharashtra-poll-analyses-are-missing-the-rise-of-womens-agency/"
          ]
        ]
      },
      {
        "finding": "Bombay High Court, 5 Aug 2024: scheme is a policy decision; PIL dismissed",
        "tier": "documented",
        "srcs": [
          [
            "Deccan Herald, 5 Aug 2024: Bombay HC dismisses PIL against Ladki Bahin",
            "https://www.deccanherald.com/india/maharashtra/ladki-bahin-yojana-a-beneficiary-scheme-for-women-not-discriminatory-bombay-high-court-3137089"
          ]
        ]
      },
      {
        "finding": "PRS SOSF 2025: Maharashtra is one of the states that cut a women's UCT (Apr 2025) under fiscal pressure",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "Government's own 2026 verification: over 92 lakh of ~2.43 cr beneficiaries ineligible; ~Rs 14,000 cr paid to them before discontinuation",
        "tier": "reported",
        "srcs": [
          [
            "Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification",
            "https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:ajit-pawar",
        "role": "Deputy Chief Minister and Finance Minister, Maharashtra",
        "action": "presented budget",
        "date": "2024-06-28",
        "party": "NCP",
        "srcs": [
          [
            "Govt of Maharashtra (Nashik) — Ladki Bahin Yojana",
            "https://nashik.gov.in/en/scheme/mukhyamantri-mazi-ladki-bahin-yojana/"
          ]
        ]
      },
      {
        "personId": "wel:eknath-shinde",
        "role": "Chief Minister, Maharashtra",
        "action": "approved",
        "date": "2024-06-28",
        "party": "Shiv Sena",
        "srcs": []
      },
      {
        "personId": "wel:devendra-fadnavis",
        "role": "Deputy Chief Minister, Maharashtra (at launch); Chief Minister from Dec 2024",
        "action": "administers",
        "date": "2024-12-05",
        "party": "BJP",
        "srcs": []
      },
      {
        "personId": "wel:eknath-shinde",
        "role": "Chief Minister, Maharashtra",
        "action": "administers",
        "date": "2024-08-14",
        "party": "Shiv Sena",
        "srcs": [
          [
            "Deccan Herald, 2024-08-15 — Shinde govt begins releasing money under Ladki Bahin Yojana on eve of Independence Day",
            "https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"
          ]
        ]
      },
      {
        "personId": "wel:devendra-fadnavis",
        "role": "Chief Minister, Maharashtra",
        "action": "administers",
        "date": "2026-08-14",
        "party": "BJP",
        "srcs": [
          [
            "ThePrint, 2026-08-14 — Govt fulfilled promises made during 2024 polls, will not discontinue Ladki Bahin: Fadnavis",
            "https://theprint.in/india/govt-fulfilled-promises-made-during-2024-polls-will-not-discontinue-ladki-bahin-fadnavis/3015115/"
          ]
        ]
      },
      {
        "personId": "wel:aaditya-thackeray",
        "role": "MLA, Shiv Sena (UBT)",
        "action": "opposed",
        "date": "2025-04-16",
        "party": "Shiv Sena (UBT)",
        "srcs": [
          [
            "Deccan Herald (PTI), 2025-04-16 — Ladki Bahin scheme ‘more or less finished’, claims Aaditya Thackeray",
            "https://www.deccanherald.com/india/maharashtra/ladki-bahin-scheme-more-or-less-finished-claims-aaditya-thackeray-3496353"
          ]
        ]
      },
      {
        "personId": "wel:eknath-shinde",
        "role": "Chief Minister",
        "action": "administers",
        "date": "2024-10-04",
        "party": "Shiv Sena",
        "srcs": [
          [
            "Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024",
            "https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"
          ]
        ]
      },
      {
        "personId": "wel:aaditya-thackeray",
        "role": "MLA, former minister",
        "action": "opposed",
        "date": "2024-10-17",
        "party": "Shiv Sena (UBT)",
        "srcs": [
          [
            "Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024",
            "https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"
          ]
        ]
      },
      {
        "personId": "wel:ajit-pawar",
        "role": "Deputy CM, Finance",
        "action": "presented budget",
        "date": "2024-06-28",
        "party": "NCP",
        "srcs": [
          [
            "Deccan Herald, 15 Aug 2024: Shinde govt begins releasing Ladki Bahin money",
            "https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"
          ],
          [
            "Deccan Herald, 5 Aug 2024: Bombay HC dismisses PIL against Ladki Bahin",
            "https://www.deccanherald.com/india/maharashtra/ladki-bahin-yojana-a-beneficiary-scheme-for-women-not-discriminatory-bombay-high-court-3137089"
          ]
        ]
      },
      {
        "personId": "wel:eknath-shinde",
        "role": "Chief Minister",
        "action": "announced",
        "date": "2024-06",
        "party": "Shiv Sena",
        "srcs": [
          [
            "Deccan Herald, 15 Aug 2024: Shinde govt begins releasing Ladki Bahin money",
            "https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"
          ]
        ]
      },
      {
        "personId": "wel:aditi-tatkare",
        "role": "Minister, WCD",
        "action": "administers",
        "date": "2024-08",
        "party": "NCP",
        "srcs": [
          [
            "Deccan Herald, 15 Aug 2024: Shinde govt begins releasing Ladki Bahin money",
            "https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"
          ],
          [
            "Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification",
            "https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"
          ]
        ]
      },
      {
        "personId": "wel:devendra-fadnavis",
        "role": "Chief Minister",
        "action": "administers",
        "date": "2024-12-05",
        "party": "BJP",
        "srcs": [
          [
            "Deccan Herald, 10 Mar 2025: Maharashtra budget gives Rs 36,000 cr to Ladki Bahin, silent on Rs 2,100",
            "https://www.deccanherald.com/india/maharashtra/maharashtra-govt-gives-rs-36000-crore-to-ladki-bahin-in-budget-mum-on-stipend-hike-ups-vehicle-tax-3440102"
          ]
        ]
      },
      {
        "personId": "wel:supriya-sule",
        "role": "MP, NCP(SP)",
        "action": "opposed",
        "date": "2025-07-29",
        "party": "NCP(SP)",
        "srcs": [
          [
            "Deccan Herald, 29 Jul 2025: Supriya Sule alleges Rs 4,800 cr fraud, seeks SIT",
            "https://www.deccanherald.com/india/maharashtra/supriya-sule-alleges-rs-4800-crore-fraud-in-ladki-bahin-yojana-seeks-sit-probe-3654533"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "Media vendors paid by Maharashtra DGIPR (unnamed)",
        "how": "₹199.81 crore in ~4 months",
        "amountCr": 199.81,
        "tier": "reported",
        "srcs": [
          [
            "Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024",
            "https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"
          ]
        ]
      },
      {
        "who": "Portal / eKYC IT vendor for ladakibahin.maharashtra.gov.in and the Nari Shakti Doot app",
        "how": "Not identified in any source opened — recorded as a void",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024",
            "https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"
          ]
        ]
      },
      {
        "who": "media/advertising vendors (unnamed)",
        "how": "Rs 250 cr government advertising spend on the scheme in 2024 (BehanBox); contracts not published",
        "amountCr": 250,
        "tier": "reported",
        "srcs": [
          [
            "BehanBox, 4 Dec 2024: Maharashtra poll analyses and women's agency (cites Lokniti-CSDS post-poll)",
            "https://behanbox.com/2024/12/04/how-maharashtra-poll-analyses-are-missing-the-rise-of-womens-agency/"
          ]
        ]
      },
      {
        "who": "Mahayuti parties (bjp, party:shiv-sena, party:ncp)",
        "how": "political mobilisation: 'real brothers vs step brothers' campaign; BJP MLA Sawarkar called the scheme a 'jugaad' for votes",
        "amountCr": null,
        "tier": "alleged",
        "srcs": [
          [
            "Deccan Herald/PTI, 25 Sep 2024: BJP MLA Tekchand Sawarkar calls Ladki Bahin a 'jugaad' for women's votes",
            "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ladki-bahin-a-jugaad-to-get-womens-votes-says-bjp-mla-tekchand-sawarkar-3206053"
          ],
          [
            "BehanBox, 4 Dec 2024: Maharashtra poll analyses and women's agency (cites Lokniti-CSDS post-poll)",
            "https://behanbox.com/2024/12/04/how-maharashtra-poll-analyses-are-missing-the-rise-of-womens-agency/"
          ]
        ]
      },
      {
        "who": "ineligible recipients (men, govt-employee households, duplicates)",
        "how": "~Rs 14,000 cr paid before verification (state's own figure)",
        "amountCr": 14000,
        "tier": "reported",
        "srcs": [
          [
            "Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification",
            "https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Govt of Maharashtra (Nashik) — Ladki Bahin Yojana",
        "https://nashik.gov.in/en/scheme/mukhyamantri-mazi-ladki-bahin-yojana/"
      ],
      [
        "Outlook Business — women deciding Indian politics, cash transfers",
        "https://www.outlookbusiness.com/economy-and-policy/story-in-numbers-women-are-deciding-indian-politics-now-cash-transfers-are-proof"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "Lokniti-CSDS Maharashtra 2024 post-poll analysis, The Hindu, 25 Nov 2024 (Deshpande, ‘Women sided with Mahayuti for Ladki Bahin Yojana’s monthly dole’; Mishra, women as deciders) — page PDF held locally; thehindu.com unreachable from this container",
        "https://www.lokniti.org/state-assembly-elections"
      ],
      [
        "PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)",
        "https://prsindia.org/policy/analytical-reports"
      ],
      [
        "Deccan Herald, 2024-08-15 — Shinde govt begins releasing money under Ladki Bahin Yojana on eve of Independence Day",
        "https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"
      ],
      [
        "Deccan Herald, 2024-08-05 — Ladki Bahin Yojana a beneficiary scheme for women, not discriminatory: Bombay High Court",
        "https://www.deccanherald.com/india/maharashtra/ladki-bahin-yojana-a-beneficiary-scheme-for-women-not-discriminatory-bombay-high-court-3137089"
      ],
      [
        "Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024",
        "https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"
      ],
      [
        "Wikipedia (pointer), 2024 Maharashtra Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2024_Maharashtra_Legislative_Assembly_election"
      ],
      [
        "Deccan Herald, 15 Aug 2024: Shinde govt begins releasing Ladki Bahin money",
        "https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"
      ],
      [
        "Deccan Herald, 10 Mar 2025: Maharashtra budget gives Rs 36,000 cr to Ladki Bahin, silent on Rs 2,100",
        "https://www.deccanherald.com/india/maharashtra/maharashtra-govt-gives-rs-36000-crore-to-ladki-bahin-in-budget-mum-on-stipend-hike-ups-vehicle-tax-3440102"
      ],
      [
        "Scroll, 16 Apr 2025: Maharashtra cuts Ladki Bahin payout for 8 lakh women to Rs 500",
        "https://scroll.in/latest/1081399/maharashtra-cuts-ladki-bahin-yojana-payout-for-8-lakh-women-to-rs-500-per-month-report"
      ],
      [
        "Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification",
        "https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:mp-jai-kisan-fasal-rin-mafi-2018",
    "name": "Jai Kisan Fasal Rin Mafi Yojana (MP, Dec 2018)",
    "al": [
      "MP farm loan waiver 2018"
    ],
    "level": "state",
    "st": "mp",
    "applicableStates": null,
    "category": "loan-waiver",
    "party": "INC",
    "announced": {
      "date": "2018-12-17",
      "byPersonId": "wel:kamal-nath",
      "office": "Chief Minister, Madhya Pradesh",
      "srcs": [
        [
          "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
          "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
        ]
      ]
    },
    "approved": {
      "date": "2018-12-17",
      "body": "CM order on day one (cabinet ratification not verified)",
      "srcs": [
        [
          "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
          "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
        ]
      ]
    },
    "launched": {
      "date": null,
      "srcs": []
    },
    "benefit": {
      "amount": 200000,
      "unit": "₹ maximum waiver (press summaries; not verified in an opened page)",
      "changes": []
    },
    "eligibility": "Farmers with crop loans from nationalised and cooperative banks outstanding on 31 Mar 2018 (press summaries)",
    "beneficiaries": [],
    "outlay": [],
    "electionContext": {
      "election": "Madhya Pradesh assembly (previous — the promise)",
      "date": "2018-11-28",
      "monthsFromLaunch": -1,
      "incumbentParty": "BJP",
      "result": "challenger (INC) won narrowly (114 vs 109); waiver signed on day one",
      "seatChange": "INC +56 (fleet file)",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI results): 2018 Madhya Pradesh Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2018_Madhya_Pradesh_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2018-12-17",
        "status": "live",
        "note": "",
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ]
        ]
      },
      {
        "date": "2020-03",
        "status": "paused",
        "note": "Congress government fell; completion of later phases not verified in an opened source",
        "srcs": []
      }
    ],
    "results": [
      {
        "finding": "Rahul Gandhi's \"ten days\" promise delivered as a signature on day one in MP, CT and RJ alike; implementation depth for MP could not be verified this session (sources blocked). Logged as a gap rather than asserted.",
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:kamal-nath",
        "role": "Chief Minister, Madhya Pradesh",
        "action": "approved",
        "date": "2018-12-17",
        "party": "INC",
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "nationalised and cooperative banks",
        "how": "state takes over overdue crop loans",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)",
            "https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
        "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2023 Madhya Pradesh Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2018 Madhya Pradesh Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2018_Madhya_Pradesh_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:mp-ladli-behna",
    "name": "Mukhyamantri Ladli Behna Yojana",
    "al": [
      "Ladli Behna",
      "Ladli Bahna",
      "लाड़ली बहना"
    ],
    "level": "state",
    "st": "mp",
    "applicableStates": null,
    "category": "women-cash",
    "party": "BJP",
    "announced": {
      "date": null,
      "byPersonId": "pol:shivraj-singh-chouhan",
      "office": "Chief Minister, Madhya Pradesh (core scheme record is in the sibling women-cash file; this file records the delivery/publicity layer only)",
      "srcs": [
        [
          "Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025",
          "https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Madhya Pradesh Cabinet",
      "srcs": []
    },
    "launched": {
      "date": null,
      "srcs": [
        [
          "Wikipedia — Ladli Laxmi Yojana (mentions 2023 Ladli Behna successor scheme)",
          "https://en.wikipedia.org/wiki/Ladli_Laxmi_Yojana"
        ]
      ]
    },
    "benefit": {
      "amount": 1000,
      "unit": "₹ per month (initial)",
      "changes": [
        {
          "date": null,
          "amount": 1250,
          "note": "Raised from ₹1,000 to ₹1,250, per the scheme's own order history.",
          "srcs": [
            [
              "Govt of MP — Ladli Behna official portal",
              "https://cmladlibehna.mp.gov.in/"
            ]
          ]
        },
        {
          "date": null,
          "amount": 1500,
          "note": "Raised again to ₹1,500 (current).",
          "srcs": [
            [
              "Govt of MP — Ladli Behna official portal",
              "https://cmladlibehna.mp.gov.in/"
            ]
          ]
        },
        {
          "date": "2023-10",
          "amount": 1250,
          "note": "Raised to Rs 1,250 ahead of the 17 Nov 2023 poll; last pre-poll instalment paid 9–10 Nov 2023, seven days before voting",
          "srcs": [
            [
              "Deccan Herald, 3 Dec 2023: What worked for BJP in MP",
              "https://www.deccanherald.com/india/madhya-pradesh/focus-on-women-voters-to-pm-modis-magic-what-worked-for-bjp-in-madhya-pradesh-assembly-elections-2794883"
            ]
          ]
        },
        {
          "date": "2025-08",
          "amount": 1250,
          "note": "One-off Rs 250 Raksha Bandhan 'shagun' on top of Rs 1,250 (announced 16 Jun 2025)",
          "srcs": [
            [
              "Deccan Herald, 17 Jun 2025: Ladli Behna Rs 250 Raksha Bandhan shagun; 25th instalment Rs 1,551 cr to 1.27 cr women",
              "https://www.deccanherald.com/india/madhya-pradesh/ladli-behna-beneficiaries-to-get-rs-250-as-raksha-bandhan-shagun-mp-cm-3589260"
            ]
          ]
        },
        {
          "date": "2025-11-12",
          "amount": 1500,
          "note": "Rs 1,500 announced 12 Oct 2025 for Bhai Dooj; did not materialise then; cabinet approved 10 Nov 2025, paid from 12 Nov 2025 instalment",
          "srcs": [
            [
              "India TV, 12 Oct 2025: Mohan Yadav transfers Rs 1,541 cr (29th instalment), announces Rs 1,500",
              "https://www.indiatvnews.com/madhya-pradesh/madhya-pradesh-ladli-behna-scheme-yojana-cm-mohan-yadav-transfers-rs-1541-crore-announces-hike-to-rs-1500-2025-10-12-1012478"
            ],
            [
              "IANS via Prokerala, 10 Nov 2025: MP cabinet approves Rs 1,500 from Nov 12; Rs 3,000 by 2028 plan",
              "https://www.prokerala.com/news/articles/a1695417.html"
            ]
          ]
        }
      ]
    },
    "eligibility": "married/widowed/divorced/abandoned women aged 21-60, household income ≤₹2.5 lakh, no income-tax payer or govt pensioner in family, ≤5 acres agricultural land, no four-wheeler",
    "beneficiaries": [
      {
        "asOf": "2023-11",
        "count": null,
        "srcs": [
          [
            "Lokniti-CSDS, Madhya Pradesh Post-poll Survey 2023 — survey findings (PDF)",
            "https://www.lokniti.org/media/PDF-upload/1703684877_6052900_download_report.pdf"
          ]
        ]
      },
      {
        "asOf": "2025-06",
        "count": 12700000,
        "srcs": [
          [
            "Deccan Herald, 17 Jun 2025: Ladli Behna Rs 250 Raksha Bandhan shagun; 25th instalment Rs 1,551 cr to 1.27 cr women",
            "https://www.deccanherald.com/india/madhya-pradesh/ladli-behna-beneficiaries-to-get-rs-250-as-raksha-bandhan-shagun-mp-cm-3589260"
          ]
        ]
      },
      {
        "asOf": "2025-10",
        "count": 12600000,
        "srcs": [
          [
            "India TV, 12 Oct 2025: Mohan Yadav transfers Rs 1,541 cr (29th instalment), announces Rs 1,500",
            "https://www.indiatvnews.com/madhya-pradesh/madhya-pradesh-ladli-behna-scheme-yojana-cm-mohan-yadav-transfers-rs-1541-crore-announces-hike-to-rs-1500-2025-10-12-1012478"
          ],
          [
            "IANS via Prokerala, 10 Nov 2025: MP cabinet approves Rs 1,500 from Nov 12; Rs 3,000 by 2028 plan",
            "https://www.prokerala.com/news/articles/a1695417.html"
          ]
        ]
      },
      {
        "asOf": "2026-09",
        "count": 12522542,
        "srcs": [
          [
            "Mukhyamantri Ladli Bahna Yojana portal, WCD Madhya Pradesh (accessed 25 Sep 2026)",
            "https://cmladlibahna.mp.gov.in/home.aspx"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2025-26",
        "budgetedCr": 18669,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "fy": "2023-24 to 2025-26",
        "budgetedCr": null,
        "actualCr": 290,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025",
            "https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 18669,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": null,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Deccan Herald, 17 Jun 2025: Ladli Behna Rs 250 Raksha Bandhan shagun; 25th instalment Rs 1,551 cr to 1.27 cr women",
            "https://www.deccanherald.com/india/madhya-pradesh/ladli-behna-beneficiaries-to-get-rs-250-as-raksha-bandhan-shagun-mp-cm-3589260"
          ],
          [
            "India TV, 12 Oct 2025: Mohan Yadav transfers Rs 1,541 cr (29th instalment), announces Rs 1,500",
            "https://www.indiatvnews.com/madhya-pradesh/madhya-pradesh-ladli-behna-scheme-yojana-cm-mohan-yadav-transfers-rs-1541-crore-announces-hike-to-rs-1500-2025-10-12-1012478"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Madhya Pradesh assembly",
      "date": "2023-11-17",
      "monthsFromLaunch": 5,
      "incumbentParty": "BJP",
      "result": "incumbent won",
      "seatChange": "BJP 109→163 seats (+54), vote share 41.02%→48.62% (+7.6pp)",
      "srcs": [
        [
          "Wikipedia — 2023 MP Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2023-01-01",
        "status": "announced",
        "note": "Widely reported as announced by CM Shivraj Singh Chouhan in January 2023 with first instalment credited around June 2023 — this file could not independently pin the exact calendar dates against a fetched primary source this session; logged as a gap rather than asserted with false precision.",
        "srcs": []
      },
      {
        "date": "2025-10-01",
        "status": "live",
        "note": "PRS (Oct 2025) counts MP among 12 UCT states; the scheme reduces MP’s 2025-26 revenue surplus from 1.1% to 0.4% of GSDP",
        "srcs": [
          [
            "PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)",
            "https://prsindia.org/policy/analytical-reports"
          ]
        ]
      },
      {
        "date": "2025-07-30",
        "status": "live",
        "note": "no second beneficiary survey to be conducted (WCD minister)",
        "srcs": [
          [
            "Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025",
            "https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"
          ]
        ]
      },
      {
        "date": "2023-06-10",
        "status": "live",
        "note": "First instalment Rs 1,000",
        "srcs": [
          [
            "IANS via Prokerala, 10 Nov 2025: MP cabinet approves Rs 1,500 from Nov 12; Rs 3,000 by 2028 plan",
            "https://www.prokerala.com/news/articles/a1695417.html"
          ]
        ]
      },
      {
        "date": "2023-10",
        "status": "raised",
        "note": "Rs 1,250",
        "srcs": [
          [
            "Deccan Herald, 3 Dec 2023: What worked for BJP in MP",
            "https://www.deccanherald.com/india/madhya-pradesh/focus-on-women-voters-to-pm-modis-magic-what-worked-for-bjp-in-madhya-pradesh-assembly-elections-2794883"
          ]
        ]
      },
      {
        "date": "2025",
        "status": "eligibility-tightened",
        "note": "Women crossing 60 auto-removed from portal; beneficiary count fell from ~1.29–1.31 cr to 1.26 cr (press); a Rs 3,000 promise remains unmet",
        "srcs": [
          [
            "Deccan Herald, 17 Jun 2025: Ladli Behna Rs 250 Raksha Bandhan shagun; 25th instalment Rs 1,551 cr to 1.27 cr women",
            "https://www.deccanherald.com/india/madhya-pradesh/ladli-behna-beneficiaries-to-get-rs-250-as-raksha-bandhan-shagun-mp-cm-3589260"
          ],
          [
            "India TV, 12 Oct 2025: Mohan Yadav transfers Rs 1,541 cr (29th instalment), announces Rs 1,500",
            "https://www.indiatvnews.com/madhya-pradesh/madhya-pradesh-ladli-behna-scheme-yojana-cm-mohan-yadav-transfers-rs-1541-crore-announces-hike-to-rs-1500-2025-10-12-1012478"
          ]
        ]
      },
      {
        "date": "2025-10-23",
        "status": "paused",
        "note": "Rs 1,500 announced for Bhai Dooj (23 Oct 2025) 'could not materialise at that time' (IANS)",
        "srcs": [
          [
            "IANS via Prokerala, 10 Nov 2025: MP cabinet approves Rs 1,500 from Nov 12; Rs 3,000 by 2028 plan",
            "https://www.prokerala.com/news/articles/a1695417.html"
          ]
        ]
      },
      {
        "date": "2025-11-12",
        "status": "raised",
        "note": "Rs 1,500 from Nov 2025 instalment; government 'plans' Rs 3,000 by 2028 ahead of next election",
        "srcs": [
          [
            "IANS via Prokerala, 10 Nov 2025: MP cabinet approves Rs 1,500 from Nov 12; Rs 3,000 by 2028 plan",
            "https://www.prokerala.com/news/articles/a1695417.html"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "The scheme was the centrepiece of the BJP campaign and of Congress's post-defeat commentary; BJP's swing (+7.6pp) was its best MP performance since 2013. This is consistent with, but does not on its own prove, a scheme effect — MP had no equivalent scheme in 2018 when BJP still narrowly lost the seat count, and Congress's Kamal Nath also ran a competing cash promise.",
        "tier": "analytic",
        "srcs": [
          [
            "Wikipedia — 2023 MP Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"
          ]
        ]
      },
      {
        "finding": "PRS (Oct 2025): excluding UCT spending, Madhya Pradesh's revenue surplus would be 1.1% of GSDP; with it, 0.4% (2025-26 BE). The scheme is 6.4% of MP's revenue expenditure.",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "Before Ladli Behna existed, RBI's June 2022 freebies table already put BJP-ruled MP fourth of nine states at 1.6% of GSDP (10.8% of revenue receipts, 28.8% of own tax revenue) — all of it a ₹21,000 cr electricity subsidy to farmers and domestic users, a long-standing subsidy rather than a new promise.",
        "tier": "documented",
        "srcs": [
          [
            "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
            "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
          ]
        ]
      },
      {
        "finding": "RBI's 2022 'freebies' definition lumps legacy power subsidies (MP) together with new election promises (Punjab) — a definitional choice that inflates some states and not others. MP's position in any freebies ranking depends on whether pre-existing farm power subsidies are counted.",
        "tier": "analytic",
        "srcs": [
          [
            "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
            "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
          ]
        ]
      },
      {
        "finding": "Lokniti-CSDS post-poll (N=3,050, 18–24 Nov 2023): 80.4% of respondents said they or a female family member benefited from Ladli Behna (Q22: yes 2,454; no 403; don’t know 139; not eligible 54). BJP 48.6% and Congress 40.0% of valid votes after weighting to the actual result. 47.8% reported a Ladli Laxmi beneficiary. The public findings PDF as read carries no beneficiary × vote or gender × vote cross-tabulation.",
        "tier": "documented",
        "srcs": [
          [
            "Lokniti-CSDS — Madhya Pradesh Postpoll Survey 2023: Survey Findings (N=3,050, 18–24 Nov 2023; PDF held locally; Lokniti state-election index page opened)",
            "https://www.lokniti.org/state-assembly-elections"
          ]
        ]
      },
      {
        "finding": "With coverage at ~80% of households, the scheme cannot discriminate BJP from Congress voters in the sample: it is a near-universal exposure, so any vote effect must be inferred from turnout or swing, not from a beneficiary/non-beneficiary contrast.",
        "tier": "analytic",
        "srcs": []
      },
      {
        "finding": "Press consensus (Deccan Herald, 3 Dec 2023; ISAS, 6 Dec 2023) credited Ladli Behna as the ‘game-changer’ for the BJP’s 163-of-230 win; this is attribution by commentators, not an estimate.",
        "tier": "reported",
        "srcs": [
          [
            "Deccan Herald, 2023-12-03 — Focus on women voters to PM Modi’s ‘magic’: what worked for BJP in MP",
            "https://www.deccanherald.com/india/madhya-pradesh/focus-on-women-voters-to-pm-modis-magic-what-worked-for-bjp-in-madhya-pradesh-assembly-elections-2794883"
          ],
          [
            "Vinod Rai, ‘The BJP Wins the Semi-final: Impressive Gains in State Elections’, ISAS Brief No. 1081, 6 Dec 2023 (PDF held locally)",
            "https://www.isas.nus.edu.sg/"
          ]
        ]
      },
      {
        "finding": "Counter-offer: Congress’s Kamal Nath promised ₹1,500/month (₹18,000/yr) for women on 2023-03-05 — both parties bid for the same constituency, which weakens any one-party ‘vote-buying’ reading.",
        "tier": "reported",
        "srcs": [
          [
            "Deccan Herald, 2023-03-05 — Ahead of MP govt’s Ladli Behna launch, Kamal Nath promises women ₹18,000 per year",
            "https://www.deccanherald.com/india/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"
          ]
        ]
      },
      {
        "finding": "₹260 crore of publicity in the months before the Nov 2023 election is roughly 9× the ₹28 crore spent publicising the youth stipend scheme in the same period",
        "tier": "documented",
        "srcs": [
          [
            "Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025",
            "https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"
          ]
        ]
      },
      {
        "finding": "Lokniti-CSDS MP post-poll 2023: 80.4% of respondents reported a female household member benefiting from Ladli Behna — coverage so near-universal that beneficiary status cannot discriminate BJP from Congress voters in the sample",
        "tier": "documented",
        "srcs": [
          [
            "Lokniti-CSDS, Madhya Pradesh Post-poll Survey 2023 — survey findings (PDF)",
            "https://www.lokniti.org/media/PDF-upload/1703684877_6052900_download_report.pdf"
          ]
        ]
      },
      {
        "finding": "Lokniti-CSDS (as summarised by Oneindia): beneficiaries of Ladli Lakshmi/Ladli Behna 'were more inclined to vote for the BJP'; no gender cross-tab figures in the opened text",
        "tier": "reported",
        "srcs": [
          [
            "Oneindia, 7 Dec 2023: Lokniti-CSDS survey on how BJP defied anti-incumbency in MP",
            "https://www.oneindia.com/india/madhya-pradesh-lokniti-csds-survey-explains-how-the-bjp-defied-anti-incumbency-and-retained-power-3699573.html"
          ]
        ]
      },
      {
        "finding": "Deccan Herald: BJP's women vote share rose from 43% to 50% (2018→2023); women turnout up 2 pts; state turnout 77.15%",
        "tier": "reported",
        "srcs": [
          [
            "Deccan Herald, 3 Dec 2023: What worked for BJP in MP",
            "https://www.deccanherald.com/india/madhya-pradesh/focus-on-women-voters-to-pm-modis-magic-what-worked-for-bjp-in-madhya-pradesh-assembly-elections-2794883"
          ]
        ]
      },
      {
        "finding": "PRS: excluding UCT spending, MP's revenue surplus would be 1.1% of GSDP instead of 0.4% (2025-26 BE)",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:shivraj-singh-chouhan",
        "role": "Chief Minister, Madhya Pradesh",
        "action": "announced",
        "date": null,
        "party": "BJP",
        "srcs": []
      },
      {
        "personId": "pol:shivraj-singh-chouhan",
        "role": "Chief Minister, Madhya Pradesh",
        "action": "administers",
        "date": "2023-11-17",
        "party": "BJP",
        "srcs": [
          [
            "Lokniti-CSDS — Madhya Pradesh Postpoll Survey 2023: Survey Findings (N=3,050, 18–24 Nov 2023; PDF held locally; Lokniti state-election index page opened)",
            "https://www.lokniti.org/state-assembly-elections"
          ]
        ]
      },
      {
        "personId": "wel:kamal-nath",
        "role": "MP Congress president",
        "action": "opposed",
        "date": "2023-03-05",
        "party": "INC",
        "srcs": [
          [
            "Deccan Herald, 2023-03-05 — Ahead of MP govt’s Ladli Behna launch, Kamal Nath promises women ₹18,000 per year",
            "https://www.deccanherald.com/india/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"
          ]
        ]
      },
      {
        "personId": "wel:mohan-yadav",
        "role": "Chief Minister",
        "action": "administers",
        "date": "2025-07-30",
        "party": "BJP",
        "srcs": [
          [
            "Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025",
            "https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"
          ]
        ]
      },
      {
        "personId": "wel:nirmala-bhuria",
        "role": "Minister, Women and Child Development",
        "action": "administers",
        "date": "2025-07-30",
        "party": "BJP",
        "srcs": [
          [
            "Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025",
            "https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"
          ]
        ]
      },
      {
        "personId": "wel:atif-aqueel",
        "role": "MLA",
        "action": "opposed",
        "date": "2025-07-30",
        "party": "INC",
        "srcs": [
          [
            "Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025",
            "https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"
          ]
        ]
      },
      {
        "personId": "pol:shivraj-singh-chouhan",
        "role": "Chief Minister",
        "action": "announced",
        "date": "2023-01",
        "party": "BJP",
        "srcs": [
          [
            "Deccan Herald/PTI, 25 Feb 2023: MP cabinet clears Ladli Bahna Rs 1,000",
            "https://www.deccanherald.com/india/mp-govt-clears-scheme-to-give-rs-1000-to-women-above-23-under-ladli-bahna-yojana-1195069.html"
          ]
        ]
      },
      {
        "personId": "pol:shivraj-singh-chouhan",
        "role": "Chief Minister",
        "action": "approved",
        "date": "2023-02-25",
        "party": "BJP",
        "srcs": [
          [
            "Deccan Herald/PTI, 25 Feb 2023: MP cabinet clears Ladli Bahna Rs 1,000",
            "https://www.deccanherald.com/india/mp-govt-clears-scheme-to-give-rs-1000-to-women-above-23-under-ladli-bahna-yojana-1195069.html"
          ]
        ]
      },
      {
        "personId": "wel:mohan-yadav",
        "role": "Chief Minister",
        "action": "administers",
        "date": "2023-12-13",
        "party": "BJP",
        "srcs": [
          [
            "Deccan Herald, 17 Jun 2025: Ladli Behna Rs 250 Raksha Bandhan shagun; 25th instalment Rs 1,551 cr to 1.27 cr women",
            "https://www.deccanherald.com/india/madhya-pradesh/ladli-behna-beneficiaries-to-get-rs-250-as-raksha-bandhan-shagun-mp-cm-3589260"
          ],
          [
            "IANS via Prokerala, 10 Nov 2025: MP cabinet approves Rs 1,500 from Nov 12; Rs 3,000 by 2028 plan",
            "https://www.prokerala.com/news/articles/a1695417.html"
          ]
        ]
      },
      {
        "personId": "wel:kamal-nath",
        "role": "Opposition leader (INC)",
        "action": "opposed",
        "date": "2023-03-05",
        "party": "INC",
        "srcs": [
          [
            "Deccan Herald, 5 Mar 2023: Kamal Nath promises women Rs 18,000/yr ahead of Ladli Behna launch",
            "https://www.deccanherald.com/national/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "Media and event vendors paid by the MP Jansampark department (unnamed)",
        "how": "₹290 crore of state publicity for a scheme carrying the CM's branding; vendor-level breakdown not disclosed in the reply",
        "amountCr": 290,
        "tier": "documented",
        "srcs": [
          [
            "Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025",
            "https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"
          ]
        ]
      },
      {
        "who": "bjp",
        "how": "Publicity of a CM-branded scheme in the pre-election window; whether it moved votes is not established",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025",
            "https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"
          ],
          [
            "Wikipedia (pointer), 2023 Madhya Pradesh Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"
          ]
        ]
      },
      {
        "who": "bjp",
        "how": "political mobilisation: the scheme was the centrepiece of the 2023 campaign; the last pre-poll instalment landed a week before voting",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald, 3 Dec 2023: What worked for BJP in MP",
            "https://www.deccanherald.com/india/madhya-pradesh/focus-on-women-voters-to-pm-modis-magic-what-worked-for-bjp-in-madhya-pradesh-assembly-elections-2794883"
          ]
        ]
      },
      {
        "who": "banks / Aadhaar Payment Bridge participants",
        "how": "DBT float and account-opening volume for ~1.26 cr Aadhaar-seeded accounts; no per-bank data found",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "Mukhyamantri Ladli Bahna Yojana portal, WCD Madhya Pradesh (accessed 25 Sep 2026)",
            "https://cmladlibahna.mp.gov.in/home.aspx"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Govt of MP — Ladli Behna official portal",
        "https://cmladlibehna.mp.gov.in/"
      ],
      [
        "Wikipedia — 2023 MP Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
        "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
      ],
      [
        "Lokniti-CSDS — Madhya Pradesh Postpoll Survey 2023: Survey Findings (N=3,050, 18–24 Nov 2023; PDF held locally; Lokniti state-election index page opened)",
        "https://www.lokniti.org/state-assembly-elections"
      ],
      [
        "PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)",
        "https://prsindia.org/policy/analytical-reports"
      ],
      [
        "Deccan Herald, 2023-03-05 — Ahead of MP govt’s Ladli Behna launch, Kamal Nath promises women ₹18,000 per year",
        "https://www.deccanherald.com/india/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"
      ],
      [
        "Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025",
        "https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"
      ],
      [
        "Wikipedia (pointer), 2023 Madhya Pradesh Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"
      ],
      [
        "Deccan Herald/PTI, 25 Feb 2023: MP cabinet clears Ladli Bahna Rs 1,000",
        "https://www.deccanherald.com/india/mp-govt-clears-scheme-to-give-rs-1000-to-women-above-23-under-ladli-bahna-yojana-1195069.html"
      ],
      [
        "Mukhyamantri Ladli Bahna Yojana portal, WCD Madhya Pradesh (accessed 25 Sep 2026)",
        "https://cmladlibahna.mp.gov.in/home.aspx"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "IANS via Prokerala, 10 Nov 2025: MP cabinet approves Rs 1,500 from Nov 12; Rs 3,000 by 2028 plan",
        "https://www.prokerala.com/news/articles/a1695417.html"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:mp-ladli-laxmi",
    "name": "Mukhyamantri Ladli Laxmi Yojana",
    "al": [
      "Ladli Laxmi",
      "लाड़ली लक्ष्मी"
    ],
    "level": "state",
    "st": "mp",
    "applicableStates": null,
    "category": "women-cash",
    "party": "BJP",
    "announced": {
      "date": "2007-05-02",
      "byPersonId": "pol:shivraj-singh-chouhan",
      "office": "Chief Minister, Madhya Pradesh",
      "srcs": [
        [
          "Wikipedia — Ladli Laxmi Yojana",
          "https://en.wikipedia.org/wiki/Ladli_Laxmi_Yojana"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "MP cabinet — date not verified",
      "srcs": []
    },
    "launched": {
      "date": "2007-05-02",
      "srcs": [
        [
          "Wikipedia — Ladli Laxmi Yojana",
          "https://en.wikipedia.org/wiki/Ladli_Laxmi_Yojana"
        ]
      ]
    },
    "benefit": {
      "amount": 6000,
      "unit": "National Savings Certificates worth ₹6,000/yr for 5 yrs, plus staged payouts at schooling milestones, maturing to ~₹1 lakh at age 21",
      "changes": []
    },
    "eligibility": "girl children born in MP after the scheme's effective date (1 April 2007)",
    "beneficiaries": [],
    "outlay": [],
    "electionContext": {
      "election": "Madhya Pradesh assembly",
      "date": "2008-11-27",
      "monthsFromLaunch": 19,
      "incumbentParty": "BJP",
      "result": "incumbent won",
      "seatChange": null,
      "srcs": [
        [
          "Wikipedia — Ladli Laxmi Yojana",
          "https://en.wikipedia.org/wiki/Ladli_Laxmi_Yojana"
        ]
      ]
    },
    "status": [
      {
        "date": "2023-01-01",
        "status": "live",
        "note": "Continues alongside the newer, adult-focused Ladli Behna Yojana.",
        "srcs": []
      },
      {
        "date": "2007-05-02",
        "status": "live",
        "note": "",
        "srcs": [
          [
            "Wikipedia (pointer): Ladli Laxmi Yojana",
            "https://en.wikipedia.org/wiki/Ladli_Laxmi_Yojana"
          ]
        ]
      },
      {
        "date": "2023",
        "status": "live",
        "note": "Continues alongside Ladli Behna (women-cash.json); \"Ladli Laxmi 2.0\" details not opened",
        "srcs": []
      }
    ],
    "results": [
      {
        "finding": "A conditional, long-horizon deposit scheme, structurally different from a monthly cash-transfer — its 19-month gap to the next election is itself evidence against a narrow vote-buying reading, though the innocent reading (long-run girl-child welfare investment) and a slower-burn political-goodwill reading are not mutually exclusive.",
        "tier": "analytic",
        "srcs": []
      },
      {
        "finding": "Long-horizon conditional deposit, copied by six states per the pointer page; the direct ancestor of the 2023 Ladli Behna brand. Its 19-month gap to the 2008 poll and deferred payout (age 21) make it a poor fit for a vote-buying reading and a good fit for the \"welfare brand\" reading.",
        "tier": "analytic",
        "srcs": [
          [
            "Wikipedia (pointer): Ladli Laxmi Yojana",
            "https://en.wikipedia.org/wiki/Ladli_Laxmi_Yojana"
          ],
          [
            "Wikipedia infobox (pointer to ECI results): 2008 Madhya Pradesh Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2008_Madhya_Pradesh_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:shivraj-singh-chouhan",
        "role": "Chief Minister, Madhya Pradesh",
        "action": "announced",
        "date": "2007-05-02",
        "party": "BJP",
        "srcs": [
          [
            "Wikipedia — Ladli Laxmi Yojana",
            "https://en.wikipedia.org/wiki/Ladli_Laxmi_Yojana"
          ]
        ]
      },
      {
        "personId": "pol:shivraj-singh-chouhan",
        "role": "Chief Minister, Madhya Pradesh",
        "action": "announced",
        "date": "2007-05-02",
        "party": "BJP",
        "srcs": [
          [
            "Wikipedia (pointer): Ladli Laxmi Yojana",
            "https://en.wikipedia.org/wiki/Ladli_Laxmi_Yojana"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "India Post / NSC (small savings)",
        "how": "state purchases NSCs — deposits flow to the National Small Savings Fund",
        "amountCr": null,
        "tier": "documented",
        "srcs": [
          [
            "Wikipedia (pointer): Ladli Laxmi Yojana",
            "https://en.wikipedia.org/wiki/Ladli_Laxmi_Yojana"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Wikipedia — Ladli Laxmi Yojana",
        "https://en.wikipedia.org/wiki/Ladli_Laxmi_Yojana"
      ],
      [
        "Wikipedia (pointer): Ladli Laxmi Yojana",
        "https://en.wikipedia.org/wiki/Ladli_Laxmi_Yojana"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2008 Madhya Pradesh Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2008_Madhya_Pradesh_Legislative_Assembly_election"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:mp-nari-samman-promise-2023",
    "name": "Nari Samman Nidhi (MP INC 2023 promise, ₹1,500/month)",
    "al": [
      "Nari Samman Yojana"
    ],
    "level": "state",
    "st": "mp",
    "applicableStates": null,
    "category": "women-cash",
    "party": "INC",
    "announced": {
      "date": "2023-03-05",
      "byPersonId": "wel:kamal-nath",
      "office": "MPCC president / ex-CM",
      "srcs": [
        [
          "Deccan Herald, 5 Mar 2023: Kamal Nath promises women Rs 18,000/yr ahead of Ladli Behna launch",
          "https://www.deccanherald.com/national/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": null,
      "srcs": [
        [
          "Deccan Herald, 5 Mar 2023: Kamal Nath promises women Rs 18,000/yr ahead of Ladli Behna launch",
          "https://www.deccanherald.com/national/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"
        ]
      ]
    },
    "launched": {
      "date": null,
      "srcs": [
        [
          "Deccan Herald, 5 Mar 2023: Kamal Nath promises women Rs 18,000/yr ahead of Ladli Behna launch",
          "https://www.deccanherald.com/national/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"
        ]
      ]
    },
    "benefit": {
      "amount": 1500,
      "unit": "₹ per month (promised)",
      "changes": []
    },
    "eligibility": "Women (as promised)",
    "beneficiaries": [
      {
        "asOf": "2023-12",
        "count": 0,
        "srcs": [
          [
            "Deccan Herald, 5 Mar 2023: Kamal Nath promises women Rs 18,000/yr ahead of Ladli Behna launch",
            "https://www.deccanherald.com/national/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"
          ]
        ]
      }
    ],
    "outlay": [],
    "electionContext": {
      "election": "Madhya Pradesh assembly",
      "date": "2023-11-17",
      "monthsFromLaunch": null,
      "incumbentParty": "BJP",
      "result": "challenger (INC) lost despite promising more (Rs 1,500) than the incumbent paid (Rs 1,250)",
      "seatChange": "INC 66 (−48)",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI results): 2023 Madhya Pradesh Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2023-12-03",
        "status": "discontinued",
        "note": null,
        "srcs": [
          [
            "Wikipedia infobox (pointer to ECI results): 2023 Madhya Pradesh Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Voters preferred a paid Rs 1,250 to a promised Rs 1,500 — consistent with credibility (delivery) mattering more than the nominal amount",
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald, 5 Mar 2023: Kamal Nath promises women Rs 18,000/yr ahead of Ladli Behna launch",
            "https://www.deccanherald.com/national/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"
          ],
          [
            "Wikipedia infobox (pointer to ECI results): 2023 Madhya Pradesh Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:kamal-nath",
        "role": "Opposition leader",
        "action": "announced",
        "date": "2023-03-05",
        "party": "INC",
        "srcs": [
          [
            "Deccan Herald, 5 Mar 2023: Kamal Nath promises women Rs 18,000/yr ahead of Ladli Behna launch",
            "https://www.deccanherald.com/national/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"
          ]
        ]
      }
    ],
    "whoElseBenefits": [],
    "srcs": [
      [
        "Deccan Herald, 5 Mar 2023: Kamal Nath promises women Rs 18,000/yr ahead of Ladli Behna launch",
        "https://www.deccanherald.com/national/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2023 Madhya Pradesh Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"
      ]
    ],
    "domain": "women-cash"
  },
  {
    "id": "scheme:or-kalia",
    "name": "KALIA (Krushak Assistance for Livelihood and Income Augmentation)",
    "al": [
      "KALIA",
      "କାଳିଆ"
    ],
    "level": "state",
    "st": "or",
    "applicableStates": null,
    "category": "farmer-cash",
    "party": "BJD",
    "announced": {
      "date": "2018-12-21",
      "byPersonId": "wel:naveen-patnaik",
      "office": "Chief Minister, Odisha",
      "srcs": [
        [
          "Pressreader/Hindustan Times — Odisha Rs 10,180-cr KALIA package",
          "https://www.pressreader.com/india/hindustan-times-delhi/20181222/281788515170582"
        ]
      ]
    },
    "approved": {
      "date": "2018-12-21",
      "body": "Odisha Cabinet (Cabinet Memorandum No 23029 dated 21/12/2018, Dept of Agriculture & Farmers' Empowerment)",
      "srcs": [
        [
          "CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)",
          "https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"
        ]
      ]
    },
    "launched": {
      "date": "2018-12-21",
      "srcs": [
        [
          "Pressreader/Hindustan Times — Odisha Rs 10,180-cr KALIA package",
          "https://www.pressreader.com/india/hindustan-times-delhi/20181222/281788515170582"
        ]
      ]
    },
    "benefit": {
      "amount": 10000,
      "unit": "₹ per year for seeds/fertiliser/inputs, plus an interest-free loan of up to ₹50,000",
      "changes": [
        {
          "date": "2020",
          "amount": 2000,
          "note": "Third instalment cut to Rs 2,000 (SMF) / Rs 2,500 (landless); only three of five promised instalments paid by Feb 2021 (CAG)",
          "srcs": [
            [
              "CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)",
              "https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"
            ]
          ]
        }
      ]
    },
    "eligibility": "cultivators and landless agricultural labourers",
    "beneficiaries": [
      {
        "asOf": "2019-05",
        "count": 5105000,
        "srcs": [
          [
            "CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"
          ]
        ]
      },
      {
        "asOf": "2021-03",
        "count": 6564000,
        "srcs": [
          [
            "CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2018-21",
        "budgetedCr": 10180,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Pressreader/Hindustan Times — Odisha Rs 10,180-cr KALIA package",
            "https://www.pressreader.com/india/hindustan-times-delhi/20181222/281788515170582"
          ]
        ]
      },
      {
        "fy": "2018-19 to 2020-21 (assessed)",
        "budgetedCr": 10310,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"
          ]
        ]
      },
      {
        "fy": "2019-20",
        "budgetedCr": 5611,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Odisha Budget Analysis 2019-20",
            "https://prsindia.org/budgets/states/odisha-budget-analysis-2019-20"
          ]
        ]
      },
      {
        "fy": "2019-21 (paid)",
        "budgetedCr": null,
        "actualCr": 6444.3,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"
          ]
        ]
      },
      {
        "fy": "to 2021-22",
        "budgetedCr": null,
        "actualCr": 9333.01,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Odisha assembly",
      "date": "2019-04-11",
      "monthsFromLaunch": 4,
      "incumbentParty": "BJD",
      "result": "incumbent won",
      "seatChange": null,
      "srcs": []
    },
    "status": [
      {
        "date": "2024-06-12",
        "status": "discontinued",
        "note": "Superseded after the 2024 change of government by the BJP's Subhadra Yojana (a differently-designed women's cash scheme, not a direct KALIA successor) — recorded as supersession, not deletion.",
        "srcs": [
          [
            "Wikipedia — Subhadra Yojana",
            "https://en.wikipedia.org/wiki/Subhadra_Yojana"
          ]
        ]
      },
      {
        "date": "2019-01",
        "status": "live",
        "note": "Cash paid weeks before the April 2019 poll",
        "srcs": [
          [
            "CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"
          ]
        ]
      },
      {
        "date": "2019-08",
        "status": "eligibility-tightened",
        "note": "Beneficiary lists published on panchayat walls 6–14 Aug 2019; ineligible asked to refund voluntarily; ~1 crore fresh applications",
        "srcs": [
          [
            "Business Standard/PTI, 6 Aug 2019: Ineligible beneficiaries refund KALIA assistance: Odisha govt",
            "https://www.business-standard.com/article/pti-stories/ineligible-beneficiaries-refund-kalia-assistance-odisha-govt-119080601520_1.html"
          ]
        ]
      },
      {
        "date": "2019-09",
        "status": "eligibility-tightened",
        "note": "Government: 3.41 lakh ineligible (20,000 govt employees/pensioners, 9,000 minors, 12,000 large farmers, ~3 lakh duplicate family members)",
        "srcs": [
          [
            "ANI, 18 Sep 2019: Odisha: 3.41 lakh ineligible beneficiaries identified under KALIA",
            "https://www.aninews.in/news/national/general-news/odisha-341lakh-ineligible-beneficiaries-identified-under-kalia-scheme20190918023936/"
          ]
        ]
      },
      {
        "date": "2021-02",
        "status": "cut",
        "note": "Only three of five promised instalments paid; two components dropped, two never implemented (CAG)",
        "srcs": [
          [
            "CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"
          ]
        ]
      },
      {
        "date": "2024-06",
        "status": "renamed",
        "note": "BJP government's CM-Kisan/Samrudha Krushak Yojana (Rs 5,000 cr in 2024-25 BE) supersedes KALIA",
        "srcs": [
          [
            "PRS, Odisha Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/odisha-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "KALIA, launched four months before the 2019 poll, is one of the closest-in-time launches in this file, and BJD did win that election — but the same party's welfare architecture (KALIA plus later programmes) did not prevent a landslide loss five years later in 2024, when BJD lost 61 seats and its 24-year hold on power. A single scheme's timing is not a reliable predictor across a party's full run in office.",
        "tier": "analytic",
        "srcs": [
          [
            "Wikipedia — 2024 Odisha Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2024_Odisha_Legislative_Assembly_election"
          ]
        ]
      },
      {
        "finding": "CAG Report No 2 of 2024 (Odisha): implemented without beneficiary verification; the Bhulekh land-record database was not part of the exclusion logic; department itself found 14.08 lakh (27.58%) of the first 51.05 lakh ineligible (Rs 611.91 cr) and 9.76 lakh across phases; audit found a further 2.96 lakh (and 2.35 lakh in the first phase alone); Rs 782.26 cr paid to 12.72 lakh ineligible beneficiaries \"with remote chances of recovery\"; Rs 107.64 cr to 1.28 lakh accounts whose names differed from the beneficiaries; IT system built hastily without requirement study; only two of six components implemented.",
        "tier": "documented",
        "srcs": [
          [
            "CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"
          ],
          [
            "Business Standard/PTI, 12 Sep 2024: Rs 782.2 cr given to 12.2 lakh ineligible beneficiaries under KALIA: CAG",
            "https://www.business-standard.com/india-news/rs-782-2-cr-given-to-12-2l-ineligible-beneficiaries-under-kalia-scheme-cag-124091200419_1.html"
          ]
        ]
      },
      {
        "finding": "Government response (documented in the CAG exit conference and 2019 press): published lists, asked for voluntary refunds, formed panchayat/block/district committees to weed out fake beneficiaries.",
        "tier": "documented",
        "srcs": [
          [
            "Business Standard/PTI, 6 Aug 2019: Ineligible beneficiaries refund KALIA assistance: Odisha govt",
            "https://www.business-standard.com/article/pti-stories/ineligible-beneficiaries-refund-kalia-assistance-odisha-govt-119080601520_1.html"
          ],
          [
            "CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"
          ]
        ]
      },
      {
        "finding": "Timing: cabinet approval 21 Dec 2018, first cash Jan 2019, poll 11 Apr 2019 — a 3-month gap, and the payment universe (51 lakh) exceeded the eligible universe by a quarter. Innocent reading: a new scheme rushed for Rabi season under an admitted absence of khata/plot data (Scheme Implementation Committee, Jan 2019); over-inclusion, not targeted vote-buying, is what the audit describes. BJD still lost five seats and, five years later, the state.",
        "tier": "analytic",
        "srcs": [
          [
            "CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"
          ],
          [
            "Wikipedia infobox (pointer to ECI): 2019 Odisha Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2019_Odisha_Legislative_Assembly_election"
          ],
          [
            "Wikipedia infobox (pointer to ECI): 2024 Odisha Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2024_Odisha_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:naveen-patnaik",
        "role": "Chief Minister, Odisha",
        "action": "announced",
        "date": "2018-12-21",
        "party": "BJD",
        "srcs": [
          [
            "Pressreader/Hindustan Times — Odisha Rs 10,180-cr KALIA package",
            "https://www.pressreader.com/india/hindustan-times-delhi/20181222/281788515170582"
          ]
        ]
      },
      {
        "personId": "wel:naveen-patnaik",
        "role": "Chief Minister, Odisha",
        "action": "approved",
        "date": "2018-12-21",
        "party": "BJD",
        "srcs": [
          [
            "CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"
          ]
        ]
      },
      {
        "personId": "wel:mohan-charan-majhi",
        "role": "Chief Minister, Odisha",
        "action": "approved",
        "date": "2024-07",
        "party": "BJP",
        "srcs": [
          [
            "PRS, Odisha Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/odisha-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "State Bank of India (designated scheme account)",
        "how": "Rs 704.08 cr released to the designated SBI account for first-instalment transfers to ineligible beneficiaries alone",
        "amountCr": null,
        "tier": "documented",
        "srcs": [
          [
            "CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"
          ]
        ]
      },
      {
        "who": "unauthorised account holders",
        "how": "Rs 107.64 cr paid to 1.28 lakh accounts with names different from the beneficiaries (CAG)",
        "amountCr": 107.64,
        "tier": "documented",
        "srcs": [
          [
            "CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"
          ],
          [
            "Business Standard/PTI, 12 Sep 2024: Rs 782.2 cr given to 12.2 lakh ineligible beneficiaries under KALIA: CAG",
            "https://www.business-standard.com/india-news/rs-782-2-cr-given-to-12-2l-ineligible-beneficiaries-under-kalia-scheme-cag-124091200419_1.html"
          ]
        ]
      },
      {
        "who": "party:bjd",
        "how": "2019 campaign centrepiece; BJD narrowly held the state",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "Wikipedia infobox (pointer to ECI): 2019 Odisha Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2019_Odisha_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Pressreader/Hindustan Times — Odisha Rs 10,180-cr KALIA package",
        "https://www.pressreader.com/india/hindustan-times-delhi/20181222/281788515170582"
      ],
      [
        "CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)",
        "https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"
      ],
      [
        "Business Standard/PTI, 12 Sep 2024: Rs 782.2 cr given to 12.2 lakh ineligible beneficiaries under KALIA: CAG",
        "https://www.business-standard.com/india-news/rs-782-2-cr-given-to-12-2l-ineligible-beneficiaries-under-kalia-scheme-cag-124091200419_1.html"
      ],
      [
        "ANI, 18 Sep 2019: Odisha: 3.41 lakh ineligible beneficiaries identified under KALIA",
        "https://www.aninews.in/news/national/general-news/odisha-341lakh-ineligible-beneficiaries-identified-under-kalia-scheme20190918023936/"
      ],
      [
        "Business Standard/PTI, 6 Aug 2019: Ineligible beneficiaries refund KALIA assistance: Odisha govt",
        "https://www.business-standard.com/article/pti-stories/ineligible-beneficiaries-refund-kalia-assistance-odisha-govt-119080601520_1.html"
      ],
      [
        "PRS, Odisha Budget Analysis 2019-20",
        "https://prsindia.org/budgets/states/odisha-budget-analysis-2019-20"
      ],
      [
        "PRS, Odisha Budget Analysis 2024-25",
        "https://prsindia.org/budgets/states/odisha-budget-analysis-2024-25"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2019 Odisha Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2019_Odisha_Legislative_Assembly_election"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2024 Odisha Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2024_Odisha_Legislative_Assembly_election"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:or-subhadra",
    "name": "Subhadra Yojana",
    "al": [
      "SUBHADRA",
      "ସୁଭଦ୍ରା"
    ],
    "level": "state",
    "st": "or",
    "applicableStates": null,
    "category": "women-cash",
    "party": "BJP",
    "announced": {
      "date": "2024-09-17",
      "byPersonId": "pol:narendra-modi",
      "office": "Prime Minister",
      "srcs": [
        [
          "Wikipedia — Subhadra Yojana",
          "https://en.wikipedia.org/wiki/Subhadra_Yojana"
        ]
      ]
    },
    "approved": {
      "date": "2024-08",
      "body": "Odisha Cabinet / WCD Department guidelines (Aug 2024)",
      "srcs": [
        [
          "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
          "https://prsindia.org/files/budget/SOSF_2025.pdf"
        ],
        [
          "Wikipedia (pointer): Subhadra Yojana",
          "https://en.wikipedia.org/wiki/Subhadra_Yojana"
        ]
      ]
    },
    "launched": {
      "date": "2024-09-17",
      "srcs": [
        [
          "Wikipedia — Subhadra Yojana",
          "https://en.wikipedia.org/wiki/Subhadra_Yojana"
        ]
      ]
    },
    "benefit": {
      "amount": 10000,
      "unit": "₹ per year (₹5,000 twice yearly), ₹50,000 total over 5 years (2024-25 to 2028-29)",
      "changes": []
    },
    "eligibility": "women aged 21-60",
    "beneficiaries": [
      {
        "asOf": "2024-09-17",
        "count": 7600000,
        "srcs": [
          [
            "Deccan Herald/PTI, 17 Sep 2024: PM launches Subhadra; Rs 10,000/yr; 76 lakh registered; Rs 1,250 cr to 25 lakh",
            "https://www.deccanherald.com/india/odisha/pm-modi-launches-odisha-govts-subhadra-scheme-railway-nh-projects-worth-over-rs-3800-cr-3193991"
          ]
        ]
      },
      {
        "asOf": "2024-11",
        "count": 10600000,
        "srcs": [
          [
            "Wikipedia (pointer): Subhadra Yojana",
            "https://en.wikipedia.org/wiki/Subhadra_Yojana"
          ]
        ]
      },
      {
        "asOf": "2025-03-08",
        "count": 10000000,
        "srcs": [
          [
            "Wikipedia (pointer): Subhadra Yojana",
            "https://en.wikipedia.org/wiki/Subhadra_Yojana"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2024-29",
        "budgetedCr": 55825,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Wikipedia — Subhadra Yojana",
            "https://en.wikipedia.org/wiki/Subhadra_Yojana"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 10145,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "fy": "2024-25 to 2028-29",
        "budgetedCr": 55825,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Wikipedia (pointer): Subhadra Yojana",
            "https://en.wikipedia.org/wiki/Subhadra_Yojana"
          ]
        ]
      },
      {
        "fy": "2024-25",
        "budgetedCr": 8570,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Wikipedia (pointer): Subhadra Yojana",
            "https://en.wikipedia.org/wiki/Subhadra_Yojana"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 10145,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Odisha assembly (this scheme launched after the 2024 election it was promised for)",
      "date": "2024-05-13",
      "monthsFromLaunch": -4,
      "incumbentParty": "BJD",
      "result": "incumbent lost (BJP, which promised the scheme, won)",
      "seatChange": "BJP 23→78 seats, BJD 112→51 (24-year rule ended)",
      "srcs": [
        [
          "Wikipedia — 2024 Odisha Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2024_Odisha_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2024-09-17",
        "status": "launched",
        "note": "Delivery of a manifesto promise, launched by the Prime Minister roughly three months after the new BJP government took office — the same promise-then-deliver pattern seen in Karnataka's Gruha Lakshmi.",
        "srcs": [
          [
            "Wikipedia — Subhadra Yojana",
            "https://en.wikipedia.org/wiki/Subhadra_Yojana"
          ]
        ]
      },
      {
        "date": "2024-09-17",
        "status": "live",
        "note": null,
        "srcs": [
          [
            "PIB, 17 Sep 2024: PM launches SUBHADRA in Bhubaneswar",
            "https://www.pib.gov.in/PressReleseDetailm.aspx?PRID=2055572&reg=3&lang=2"
          ]
        ]
      },
      {
        "date": "2025-03-08",
        "status": "live",
        "note": "second instalment",
        "srcs": [
          [
            "Wikipedia (pointer): Subhadra Yojana",
            "https://en.wikipedia.org/wiki/Subhadra_Yojana"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Like Gruha Lakshmi, this is a promise made before an election and a scheme launched after winning it — evidence that the 'promise' timing matters as much as, or more than, the 'launch' timing this file has been tracking; a dataset built only on launch dates would miss this mechanism entirely.",
        "tier": "analytic",
        "srcs": []
      },
      {
        "finding": "PRS (Oct 2025): BE 2025-26 ₹10,145 cr = 5.1% of revenue expenditure, 4.4% of revenue receipts.",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "PIB: the scheme is 'linked to the pilot project of RBI's digital currency' (e₹) — first DBT scheme on CBDC rails",
        "tier": "documented",
        "srcs": [
          [
            "PIB, 17 Sep 2024: PM launches SUBHADRA in Bhubaneswar",
            "https://www.pib.gov.in/PressReleseDetailm.aspx?PRID=2055572&reg=3&lang=2"
          ]
        ]
      },
      {
        "finding": "Per-beneficiary amount (Rs 833/month equivalent) is the lowest of the 12 UCTs in PRS Table 6 while outlay is 5th largest",
        "tier": "analytic",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:narendra-modi",
        "role": "Prime Minister",
        "action": "announced",
        "date": "2024-09-17",
        "party": "BJP",
        "srcs": [
          [
            "Wikipedia — Subhadra Yojana",
            "https://en.wikipedia.org/wiki/Subhadra_Yojana"
          ]
        ]
      },
      {
        "personId": "wel:mohan-charan-majhi",
        "role": "Chief Minister, Odisha",
        "action": "administers",
        "date": "2024-09-17",
        "party": "BJP",
        "srcs": []
      },
      {
        "personId": "pol:narendra-modi",
        "role": "Prime Minister",
        "action": "announced",
        "date": "2024-09-17",
        "party": "BJP",
        "srcs": [
          [
            "PIB, 17 Sep 2024: PM launches SUBHADRA in Bhubaneswar",
            "https://www.pib.gov.in/PressReleseDetailm.aspx?PRID=2055572&reg=3&lang=2"
          ]
        ]
      },
      {
        "personId": "wel:mohan-charan-majhi",
        "role": "Chief Minister",
        "action": "administers",
        "date": "2024-06-12",
        "party": "BJP",
        "srcs": [
          [
            "PIB, 17 Sep 2024: PM launches SUBHADRA in Bhubaneswar",
            "https://www.pib.gov.in/PressReleseDetailm.aspx?PRID=2055572&reg=3&lang=2"
          ]
        ]
      },
      {
        "personId": "pol:jagat-prakash-nadda",
        "role": "BJP president",
        "action": "announced",
        "date": "2024-05-15",
        "party": "BJP",
        "srcs": [
          [
            "Business Standard, 16 May 2024: BJP 'promises' Rs 50,000 vouchers to women, then clarifies Odisha-only",
            "https://www.business-standard.com/elections/assembly-election/lok-sabha-elections-bjp-promises-rs-50-000-cash-vouchers-to-women-then-clarifies-124051600178_1.html"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "banks in the RBI e₹ retail pilot (unnamed)",
        "how": "CBDC wallet onboarding of up to 1 cr women; participating banks not named in opened sources",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "PIB, 17 Sep 2024: PM launches SUBHADRA in Bhubaneswar",
            "https://www.pib.gov.in/PressReleseDetailm.aspx?PRID=2055572&reg=3&lang=2"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Wikipedia — Subhadra Yojana",
        "https://en.wikipedia.org/wiki/Subhadra_Yojana"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "PIB, 17 Sep 2024: PM launches SUBHADRA in Bhubaneswar",
        "https://www.pib.gov.in/PressReleseDetailm.aspx?PRID=2055572&reg=3&lang=2"
      ],
      [
        "Deccan Herald/PTI, 17 Sep 2024: PM launches Subhadra; Rs 10,000/yr; 76 lakh registered; Rs 1,250 cr to 25 lakh",
        "https://www.deccanherald.com/india/odisha/pm-modi-launches-odisha-govts-subhadra-scheme-railway-nh-projects-worth-over-rs-3800-cr-3193991"
      ],
      [
        "Wikipedia (pointer): Subhadra Yojana",
        "https://en.wikipedia.org/wiki/Subhadra_Yojana"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "Business Standard, 16 May 2024: BJP 'promises' Rs 50,000 vouchers to women, then clarifies Odisha-only",
        "https://www.business-standard.com/elections/assembly-election/lok-sabha-elections-bjp-promises-rs-50-000-cash-vouchers-to-women-then-clarifies-124051600178_1.html"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:pb-farm-loan-waiver-2017",
    "name": "Punjab crop loan waiver 2017 (Amarinder Singh)",
    "al": [
      "Karza Kurki Khatam"
    ],
    "level": "state",
    "st": "pb",
    "applicableStates": null,
    "category": "loan-waiver",
    "party": "INC",
    "announced": {
      "date": "2017-06-19",
      "byPersonId": "wel:amarinder-singh",
      "office": "Chief Minister, Punjab",
      "srcs": [
        [
          "Business Standard, 19 Jun 2017: Punjab CM Amarinder Singh announces crop loan waiver for 10.25 lakh farmers",
          "https://www.business-standard.com/article/economy-policy/punjab-cm-amarinder-singh-announces-crop-loan-waiver-for-10-25-lakh-farmers-117061901226_1.html"
        ]
      ]
    },
    "approved": {
      "date": "2017-06-19",
      "body": "Punjab Cabinet/Assembly statement; process to start within two months",
      "srcs": [
        [
          "Business Standard, 19 Jun 2017: Punjab CM Amarinder Singh announces crop loan waiver for 10.25 lakh farmers",
          "https://www.business-standard.com/article/economy-policy/punjab-cm-amarinder-singh-announces-crop-loan-waiver-for-10-25-lakh-farmers-117061901226_1.html"
        ]
      ]
    },
    "launched": {
      "date": null,
      "srcs": []
    },
    "benefit": {
      "amount": 200000,
      "unit": "₹ maximum waiver per farmer (crop loans)",
      "changes": []
    },
    "eligibility": "Small (≤5 acres) and marginal farmers; 10.25 lakh of 18.5 lakh farming families",
    "beneficiaries": [
      {
        "asOf": "2017-06-19",
        "count": 1025000,
        "srcs": [
          [
            "Business Standard, 19 Jun 2017: Punjab CM Amarinder Singh announces crop loan waiver for 10.25 lakh farmers",
            "https://www.business-standard.com/article/economy-policy/punjab-cm-amarinder-singh-announces-crop-loan-waiver-for-10-25-lakh-farmers-117061901226_1.html"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2017-18 (announced)",
        "budgetedCr": null,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Business Standard, 19 Jun 2017: Punjab CM Amarinder Singh announces crop loan waiver for 10.25 lakh farmers",
            "https://www.business-standard.com/article/economy-policy/punjab-cm-amarinder-singh-announces-crop-loan-waiver-for-10-25-lakh-farmers-117061901226_1.html"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Punjab assembly (previous — the promise)",
      "date": "2017-02-04",
      "monthsFromLaunch": -4,
      "incumbentParty": "SAD-BJP",
      "result": "challenger (INC) won; waiver announced 3 months after taking office",
      "seatChange": "INC 77 of 117 (fleet file)",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI results): 2017 Punjab Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2017_Punjab_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2017-06-19",
        "status": "live",
        "note": "",
        "srcs": [
          [
            "Business Standard, 19 Jun 2017: Punjab CM Amarinder Singh announces crop loan waiver for 10.25 lakh farmers",
            "https://www.business-standard.com/article/economy-policy/punjab-cm-amarinder-singh-announces-crop-loan-waiver-for-10-25-lakh-farmers-117061901226_1.html"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Amarinder framed it as \"double the relief announced by UP and Maharashtra\" — the three 2017 waivers (UP-BJP, MH-BJP, PB-INC) were a bidding sequence across parties within three months.",
        "tier": "analytic",
        "srcs": [
          [
            "Business Standard, 19 Jun 2017: Punjab CM Amarinder Singh announces crop loan waiver for 10.25 lakh farmers",
            "https://www.business-standard.com/article/economy-policy/punjab-cm-amarinder-singh-announces-crop-loan-waiver-for-10-25-lakh-farmers-117061901226_1.html"
          ],
          [
            "Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'",
            "https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"
          ],
          [
            "Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)",
            "https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:amarinder-singh",
        "role": "Chief Minister, Punjab",
        "action": "announced",
        "date": "2017-06-19",
        "party": "INC",
        "srcs": [
          [
            "Business Standard, 19 Jun 2017: Punjab CM Amarinder Singh announces crop loan waiver for 10.25 lakh farmers",
            "https://www.business-standard.com/article/economy-policy/punjab-cm-amarinder-singh-announces-crop-loan-waiver-for-10-25-lakh-farmers-117061901226_1.html"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "cooperative and commercial banks",
        "how": "state takes over crop-loan books of ≤5-acre farmers",
        "amountCr": null,
        "tier": "reported",
        "srcs": [
          [
            "Business Standard, 19 Jun 2017: Punjab CM Amarinder Singh announces crop loan waiver for 10.25 lakh farmers",
            "https://www.business-standard.com/article/economy-policy/punjab-cm-amarinder-singh-announces-crop-loan-waiver-for-10-25-lakh-farmers-117061901226_1.html"
          ],
          [
            "PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)",
            "https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Business Standard, 19 Jun 2017: Punjab CM Amarinder Singh announces crop loan waiver for 10.25 lakh farmers",
        "https://www.business-standard.com/article/economy-policy/punjab-cm-amarinder-singh-announces-crop-loan-waiver-for-10-25-lakh-farmers-117061901226_1.html"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2022 Punjab Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"
      ],
      [
        "PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)",
        "https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2017 Punjab Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2017_Punjab_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:pb-free-power-300-units",
    "name": "Punjab free electricity up to 300 units",
    "al": [
      "300 units free"
    ],
    "level": "state",
    "st": "pb",
    "applicableStates": null,
    "category": "energy-subsidy",
    "party": "AAP",
    "announced": {
      "date": null,
      "byPersonId": "wel:bhagwant-mann",
      "office": "Chief Minister, Punjab",
      "srcs": []
    },
    "approved": {
      "date": "2022-06",
      "body": "Punjab budget 2022-23",
      "srcs": [
        [
          "PRS, Punjab Budget Analysis 2022-23",
          "https://prsindia.org/budgets/states/punjab-budget-analysis-2022-23"
        ]
      ]
    },
    "launched": {
      "date": null,
      "srcs": []
    },
    "benefit": {
      "amount": 300,
      "unit": "units of electricity free per month per household — this file recalls a ~July 2022 rollout from general knowledge but could not pin it to a fetched source this session, so the date is nulled and logged as a gap",
      "changes": []
    },
    "eligibility": "domestic electricity consumers in Punjab",
    "beneficiaries": [],
    "outlay": [
      {
        "fy": "2022-23",
        "budgetedCr": 5000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": 0.8,
        "srcs": [
          [
            "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
            "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
          ]
        ]
      },
      {
        "fy": "2024-25",
        "budgetedCr": 7780,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Punjab Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/punjab-budget-analysis-2024-25"
          ]
        ]
      },
      {
        "fy": "2022-23",
        "budgetedCr": 6395,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Punjab Budget Analysis 2022-23",
            "https://prsindia.org/budgets/states/punjab-budget-analysis-2022-23"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Punjab assembly (next, after this delivery of a pre-poll promise)",
      "date": "2027-02-01",
      "monthsFromLaunch": null,
      "incumbentParty": "AAP",
      "result": "not yet held",
      "seatChange": null,
      "srcs": []
    },
    "status": [
      {
        "date": null,
        "status": "launched",
        "note": "Delivered a few months after AAP's landslide March 2022 win — a post-election delivery of a campaign promise, structurally identical to Chhattisgarh's 2018 loan waiver and Himachal's 2023 OPS restoration.",
        "srcs": []
      },
      {
        "date": "2022-07-01",
        "status": "live",
        "note": "",
        "srcs": [
          [
            "PRS, Punjab Budget Analysis 2022-23",
            "https://prsindia.org/budgets/states/punjab-budget-analysis-2022-23"
          ]
        ]
      },
      {
        "date": "2024-03",
        "status": "live",
        "note": "No increase budgeted in 2024-25 vs 2023-24 RE (PRS)",
        "srcs": [
          [
            "PRS, Punjab Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/punjab-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "RBI (Jun 2022) ranked Punjab first of nine states on freebies: ₹17,000 cr = 2.7% of GSDP, 17.8% of revenue receipts, 45.4% of own tax revenue. But ₹12,000 cr of that (1.9% of GSDP) was the promised ₹1,000/month to every adult woman — a promise not enacted (see women-cash.json, scheme:pb-women-1000-promise). On enacted items alone (300 free units, ₹5,000 cr) Punjab's figure is ~0.8% of GSDP, below MP's 1.6%.",
        "tier": "analytic",
        "srcs": [
          [
            "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
            "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
          ]
        ]
      },
      {
        "finding": "PRS (Oct 2025): Punjab spends 21% of revenue receipts on subsidies — the highest in India — and 90% of its subsidy budget on power. RBI (2022) named Punjab among five highly stressed states and noted contingent liabilities above 5% of GSDP.",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ],
          [
            "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
            "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
          ]
        ]
      },
      {
        "finding": "PRS SOSF 2025-26: Punjab spends 21% of revenue receipts on subsidies, 90% of it on power — the highest subsidy share among states; the 15th Finance Commission observed that farm loan waivers and subsidy increases have crowded productive spending. Innocent reading: a small, high-tariff state with a long-standing free farm power regime (SAD-BJP/INC) to which AAP added a domestic slab.",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.13-14 and subsidy section (PDF)",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ],
          [
            "PRS, Punjab Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/punjab-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:bhagwant-mann",
        "role": "Chief Minister, Punjab",
        "action": "approved",
        "date": null,
        "party": "AAP",
        "srcs": []
      },
      {
        "personId": "wel:bhagwant-mann",
        "role": "Chief Minister, Punjab",
        "action": "approved",
        "date": "2022-07-01",
        "party": "AAP",
        "srcs": [
          [
            "PRS, Punjab Budget Analysis 2022-23",
            "https://prsindia.org/budgets/states/punjab-budget-analysis-2022-23"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "PSPCL (state discom)",
        "how": "receives the subsidy as revenue; Rs 20,200 cr total power subsidy 2024-25",
        "amountCr": 20200,
        "tier": "documented",
        "srcs": [
          [
            "PRS, Punjab Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/punjab-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Wikipedia — 2022 Punjab Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"
      ],
      [
        "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
        "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "PRS, Punjab Budget Analysis 2022-23",
        "https://prsindia.org/budgets/states/punjab-budget-analysis-2022-23"
      ],
      [
        "PRS, Punjab Budget Analysis 2024-25",
        "https://prsindia.org/budgets/states/punjab-budget-analysis-2024-25"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.13-14 and subsidy section (PDF)",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2022 Punjab Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:pb-smart-connect",
    "name": "Punjab Smart Connect (free smartphones to Class XII students)",
    "al": [
      "Captain Smart Connect"
    ],
    "level": "state",
    "st": "pb",
    "applicableStates": null,
    "category": "consumer-goods",
    "party": "INC",
    "announced": {
      "date": null,
      "byPersonId": "wel:amarinder-singh",
      "office": "Chief Minister, Punjab (2017 Congress manifesto promise; ₹100 crore budgeted 2017-18)",
      "srcs": [
        [
          "The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020",
          "https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Punjab Cabinet",
      "srcs": []
    },
    "launched": {
      "date": "2020-08-12",
      "srcs": [
        [
          "The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020",
          "https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"
        ]
      ]
    },
    "benefit": {
      "amount": null,
      "unit": "one smartphone per Class XII government-school student (unit price not in opened source; ₹92 crore / 1,74,015 ≈ ₹5,290)",
      "changes": []
    },
    "eligibility": "Class XII students of Punjab government schools; phase 1 1,74,015 (87,395 boys, 86,620 girls; 94,832 SC, 36,555 OBC)",
    "beneficiaries": [
      {
        "asOf": "2020-08-12",
        "count": 174015,
        "srcs": [
          [
            "The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020",
            "https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2020-21",
        "budgetedCr": 92,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020",
            "https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Punjab assembly",
      "date": "2022-02-20",
      "monthsFromLaunch": 18,
      "incumbentParty": "INC",
      "result": "incumbent lost; AAP 92 (+72), INC 18 (−59)",
      "seatChange": "INC −59",
      "srcs": [
        [
          "Wikipedia (pointer), 2022 Punjab Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"
        ],
        [
          "The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020",
          "https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"
        ]
      ]
    },
    "status": [
      {
        "date": "2020-08-12",
        "status": "live",
        "note": "launched 3.5 years after the promise, during COVID school closures",
        "srcs": [
          [
            "The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020",
            "https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Launched at 26 locations with three ministers each handing over 20 phones; CM framed it as a poll promise fulfilled; opposition criticism not reported in the launch coverage",
        "tier": "reported",
        "srcs": [
          [
            "The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020",
            "https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:amarinder-singh",
        "role": "Chief Minister",
        "action": "announced",
        "date": "2020-08-12",
        "party": "INC",
        "srcs": [
          [
            "The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020",
            "https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"
          ]
        ]
      },
      {
        "personId": "wel:manpreet-singh-badal",
        "role": "Finance Minister",
        "action": "presented budget",
        "date": "2017-06-20",
        "party": "INC",
        "srcs": [
          [
            "The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020",
            "https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"
          ]
        ]
      },
      {
        "personId": "wel:vijay-inder-singla",
        "role": "School Education Minister",
        "action": "administers",
        "date": "2020-08-12",
        "party": "INC",
        "srcs": [
          [
            "The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020",
            "https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "Handset vendor (widely reported as Lava International; not verified from an opened source)",
        "how": "₹92 crore phase-1 supply",
        "amountCr": 92,
        "tier": "analytic",
        "srcs": [
          [
            "The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020",
            "https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020",
        "https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"
      ],
      [
        "Wikipedia (pointer), 2022 Punjab Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"
      ]
    ],
    "domain": "vendors"
  },
  {
    "id": "scheme:pb-women-1000-promise",
    "name": "AAP Punjab ₹1,000 per month to women (2022 guarantee)",
    "al": [
      "Punjab women Rs 1,000 guarantee"
    ],
    "level": "state",
    "st": "pb",
    "applicableStates": null,
    "category": "women-cash",
    "party": "AAP",
    "announced": {
      "date": "2021-11",
      "byPersonId": "wel:arvind-kejriwal",
      "office": "AAP national convenor (Punjab 2022 campaign 'guarantees')",
      "srcs": [
        [
          "ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs",
          "https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": null,
      "srcs": [
        [
          "ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs",
          "https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"
        ]
      ]
    },
    "launched": {
      "date": null,
      "srcs": [
        [
          "ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs",
          "https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"
        ]
      ]
    },
    "benefit": {
      "amount": 1000,
      "unit": "₹ per month (promised) to women 18+",
      "changes": []
    },
    "eligibility": "All women 18+ (as promised)",
    "beneficiaries": [
      {
        "asOf": "2025-01",
        "count": 0,
        "srcs": [
          [
            "ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs",
            "https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2024-25",
        "budgetedCr": null,
        "actualCr": 0,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs",
            "https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Punjab assembly",
      "date": "2022-02-20",
      "monthsFromLaunch": null,
      "incumbentParty": "INC",
      "result": "challenger (AAP) won 92/117; promise unfulfilled after 3+ years",
      "seatChange": "AAP +72",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI results): 2022 Punjab Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2025-01-12",
        "status": "promised-not-enacted",
        "note": "AAP spokesperson: 'this shall also be done'",
        "srcs": [
          [
            "ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs",
            "https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "PRS: Punjab spends 107% of revenue receipts on salaries, pensions, interest and subsidies — no fiscal room for a Rs 12,000 cr scheme",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:bhagwant-mann",
        "role": "Chief Minister",
        "action": "administers",
        "date": "2022-03-16",
        "party": "AAP",
        "srcs": [
          [
            "ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs",
            "https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"
          ]
        ]
      },
      {
        "personId": "wel:arvind-kejriwal",
        "role": "AAP convenor",
        "action": "announced",
        "date": "2022-01",
        "party": "AAP",
        "srcs": [
          [
            "ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs",
            "https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"
          ]
        ]
      }
    ],
    "whoElseBenefits": [],
    "srcs": [
      [
        "ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs",
        "https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2022 Punjab Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"
      ]
    ],
    "domain": "women-cash"
  },
  {
    "id": "scheme:pm-kisan",
    "name": "Pradhan Mantri Kisan Samman Nidhi",
    "al": [
      "PM-KISAN",
      "PM Kisan",
      "किसान सम्मान निधि"
    ],
    "level": "central",
    "st": null,
    "applicableStates": "all",
    "category": "farmer-cash",
    "party": "BJP (NDA)",
    "announced": {
      "date": "2019-02-01",
      "byPersonId": "pol:piyush-goyal",
      "office": "Union Minister of Finance (interim charge), Jan–Feb 2019",
      "srcs": [
        [
          "Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)",
          "https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"
        ]
      ]
    },
    "approved": {
      "date": "2019-02-01",
      "body": "Interim Budget 2019-20 (Vote on Account); Cabinet approval date not separately verified",
      "srcs": [
        [
          "Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)",
          "https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"
        ]
      ]
    },
    "launched": {
      "date": "2019-02-24",
      "srcs": [
        [
          "Wikipedia (pointer), Pradhan Mantri Kisan Samman Nidhi",
          "https://en.wikipedia.org/wiki/Pradhan_Mantri_Kisan_Samman_Nidhi"
        ],
        [
          "PIB, PM to release 21st instalment of PM-KISAN on 19 Nov 2025",
          "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2190074"
        ]
      ]
    },
    "benefit": {
      "amount": 6000,
      "unit": "₹ per farmer family per year, three instalments of ₹2,000",
      "changes": [
        {
          "date": null,
          "amount": 6000,
          "note": "eligibility widened from ≤2 ha to all landholding farmer families (date of this extension not verified in this file — see gaps); amount unchanged since 2019 despite ~7 years of inflation",
          "srcs": [
            [
              "Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)",
              "https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"
            ],
            [
              "PIB, PM to release 21st instalment of PM-KISAN on 19 Nov 2025",
              "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2190074"
            ]
          ]
        },
        {
          "date": "2020-04-01",
          "amount": 2000,
          "note": "first 2020-21 instalment front-loaded to April 2020 for 8.7 crore farmers (COVID)",
          "srcs": [
            [
              "PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020",
              "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"
            ]
          ]
        }
      ]
    },
    "eligibility": "landholding farmer families with cultivable land, excluding income-tax payers, institutional landholders, serving/retired government and PSU staff, constitutional post holders, professionals; land seeding, Aadhaar-seeded account and e-KYC mandatory",
    "beneficiaries": [
      {
        "asOf": "2019-02-01",
        "count": 120000000,
        "srcs": [
          [
            "Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)",
            "https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"
          ]
        ]
      },
      {
        "asOf": "2020-03-26",
        "count": 87000000,
        "srcs": [
          [
            "PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"
          ]
        ]
      },
      {
        "asOf": "2024-02-01",
        "count": 118000000,
        "srcs": [
          [
            "Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)",
            "https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"
          ]
        ]
      },
      {
        "asOf": "2025-11-19",
        "count": 110000000,
        "srcs": [
          [
            "PIB, PM to release 21st instalment of PM-KISAN on 19 Nov 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2190074"
          ]
        ]
      },
      {
        "asOf": "2026-03-13",
        "count": 93200000,
        "srcs": [
          [
            "PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"
          ]
        ]
      },
      {
        "asOf": "2026-06-20",
        "count": 94900000,
        "srcs": [
          [
            "PMO, Cabinet approves continuation of PM-KISAN 2026-27 to 2030-31, ₹3.15 lakh crore, 31 Jul 2026",
            "https://www.pmindia.gov.in/en/news_updates/cabinet-approves-continuation-of-the-pm-kisan-scheme-from-2026-27-to-2030-31-with-a-financial-outlay-of-rs-3-15-lakh-crore/"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2018-19",
        "budgetedCr": 20000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)",
            "https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"
          ]
        ]
      },
      {
        "fy": "2019-20",
        "budgetedCr": 75000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)",
            "https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"
          ]
        ]
      },
      {
        "fy": "2026-27",
        "budgetedCr": 60000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"
          ]
        ]
      },
      {
        "fy": "2026-31",
        "budgetedCr": 315000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PMO, Cabinet approves continuation of PM-KISAN 2026-27 to 2030-31, ₹3.15 lakh crore, 31 Jul 2026",
            "https://www.pmindia.gov.in/en/news_updates/cabinet-approves-continuation-of-the-pm-kisan-scheme-from-2026-27-to-2030-31-with-a-financial-outlay-of-rs-3-15-lakh-crore/"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Lok Sabha 2019",
      "date": "2019-04-11",
      "monthsFromLaunch": 1.5,
      "incumbentParty": "BJP (NDA)",
      "result": "incumbent won",
      "seatChange": "BJP +21 (282→303)",
      "srcs": [
        [
          "Wikipedia (pointer), 2019 Indian general election",
          "https://en.wikipedia.org/wiki/2019_Indian_general_election"
        ],
        [
          "Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)",
          "https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"
        ],
        [
          "Wikipedia (pointer), Pradhan Mantri Kisan Samman Nidhi",
          "https://en.wikipedia.org/wiki/Pradhan_Mantri_Kisan_Samman_Nidhi"
        ]
      ]
    },
    "status": [
      {
        "date": "2023-11-15",
        "status": "raised",
        "note": "saturation drive from 15 Nov 2023 under Viksit Bharat Sankalp Yatra added >1 crore farmers (during the Nov 2023 assembly polls and before LS 2024)",
        "srcs": [
          [
            "PIB (MoA&FW RS reply), PM-KISAN 18th instalment beneficiaries and saturation drives, Feb 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2100758"
          ]
        ]
      },
      {
        "date": "2024-06-01",
        "status": "raised",
        "note": "second saturation drive from Jun 2024: 25 lakh+ added in first 100 days of the new government",
        "srcs": [
          [
            "PIB (MoA&FW RS reply), PM-KISAN 18th instalment beneficiaries and saturation drives, Feb 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2100758"
          ]
        ]
      },
      {
        "date": "2025-12-02",
        "status": "eligibility-tightened",
        "note": "benefits stopped for non-completion of land seeding/e-KYC; cross-checks with PDS, UIDAI death data, PFMS, Income Tax; ₹416.75 cr recovered from ineligible beneficiaries so far",
        "srcs": [
          [
            "Lok Sabha Unstarred Q.358 (MoS Agri Ramnath Thakur), discrepancy in PM-KISAN: ₹416.75 cr recovered from ineligible beneficiaries, 2 Dec 2025",
            "https://sansad.in/getFile/loksabhaquestions/annex/186/AU358_FPeZsZ.pdf?source=pqals"
          ]
        ]
      },
      {
        "date": "2026-07-31",
        "status": "live",
        "note": "continued to 2030-31 at ₹6,000 (no raise)",
        "srcs": [
          [
            "PMO, Cabinet approves continuation of PM-KISAN 2026-27 to 2030-31, ₹3.15 lakh crore, 31 Jul 2026",
            "https://www.pmindia.gov.in/en/news_updates/cabinet-approves-continuation-of-the-pm-kisan-scheme-from-2026-27-to-2030-31-with-a-financial-outlay-of-rs-3-15-lakh-crore/"
          ]
        ]
      },
      {
        "date": "2019-02-24",
        "status": "launched",
        "note": "Disbursement backdated to 2018-12-01, so the first transfer landed in accounts before the formal Gorakhpur launch event.",
        "srcs": [
          [
            "PIB — PM-KISAN Samman Nidhi",
            "https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=2039203"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "IFPRI 2019 and NITI Aayog DMEO evaluations (as cited by government): eased credit constraints, 92% spent on inputs, 85% report income improvement",
        "tier": "reported",
        "srcs": [
          [
            "PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"
          ]
        ]
      },
      {
        "finding": "BlueKraft/PIB: 2.1 crore ineligible beneficiaries deleted, ₹22,106 cr 'saved' — i.e. roughly one in six early registrants was later judged ineligible",
        "tier": "reported",
        "srcs": [
          [
            "PIB, 'India's DBT: Boosting Welfare Efficiency' (BlueKraft report relayed), 21 Apr 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2123192"
          ]
        ]
      },
      {
        "finding": "Government: ₹416.75 cr recovered from ineligible (income-tax payers, PSU/government staff) as of 2 Dec 2025; 24,605 grievances on portal FY 2024-25",
        "tier": "documented",
        "srcs": [
          [
            "Lok Sabha Unstarred Q.358 (MoS Agri Ramnath Thakur), discrepancy in PM-KISAN: ₹416.75 cr recovered from ineligible beneficiaries, 2 Dec 2025",
            "https://sansad.in/getFile/loksabhaquestions/annex/186/AU358_FPeZsZ.pdf?source=pqals"
          ],
          [
            "Lok Sabha Unstarred Q.305, PM-KISAN grievances FY 2024-25, 2 Dec 2025",
            "https://sansad.in/getFile/loksabhaquestions/annex/186/AU305_QjnVDu.pdf?source=pqals"
          ]
        ]
      },
      {
        "finding": "Per-instalment payees fell from ~11 crore ever-reached to 9.3–9.5 crore in 2026 after e-KYC/land-seeding gates — exclusion vs cleaning cannot be separated from published data",
        "tier": "analytic",
        "srcs": [
          [
            "PIB, PM to release 21st instalment of PM-KISAN on 19 Nov 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2190074"
          ],
          [
            "PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"
          ],
          [
            "PMO, Cabinet approves continuation of PM-KISAN 2026-27 to 2030-31, ₹3.15 lakh crore, 31 Jul 2026",
            "https://www.pmindia.gov.in/en/news_updates/cabinet-approves-continuation-of-the-pm-kisan-scheme-from-2026-27-to-2030-31-with-a-financial-outlay-of-rs-3-15-lakh-crore/"
          ]
        ]
      },
      {
        "finding": "Lokniti-CSDS 2024: among farming households asked, 53.7% report a PM-KISAN benefit",
        "tier": "documented",
        "srcs": [
          [
            "Lokniti-CSDS, Social and Political Barometer Post-poll Study 2024 — Survey Findings (PDF on file, dated 14 Jun 2024; exact URL not recovered — see gaps)",
            "https://www.lokniti.org/"
          ]
        ]
      },
      {
        "finding": "Scheme retained and expanded by every subsequent budget 2019-2026; no discontinuation. Independent leakage/targeting audits are not in this file's source set.",
        "tier": "reported",
        "srcs": [
          [
            "PIB — PM-KISAN Samman Nidhi",
            "https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=2039203"
          ]
        ]
      },
      {
        "finding": "Operational guidelines fix 01.12.2018 as the land-record cut-off and allow the first instalment for the Dec 2018–Mar 2019 trimester — i.e. the scheme announced in the 1 Feb 2019 interim budget was made retroactive so that a first ₹2,000 could be paid before the April 2019 Lok Sabha election. The cut-off is documented; the motive is not.",
        "tier": "documented",
        "srcs": [
          [
            "Ministry of Agriculture & Farmers Welfare, PM-KISAN Revised Operational Guidelines (PDF, pmkisan.gov.in)",
            "https://www.pmkisan.gov.in/Documents/Revised%20Operational%20Guidelines%20-%20PM-Kisan%20Scheme.pdf"
          ],
          [
            "Wikipedia, 'Pradhan Mantri Kisan Samman Nidhi' (pointer only)",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Kisan_Samman_Nidhi"
          ]
        ]
      },
      {
        "finding": "No independent evaluation of PM-KISAN's effects was opened in this sweep; evaluation claims (IFPRI, NITI DMEO) appear only as cited by government in central.json.",
        "tier": "analytic",
        "srcs": [
          [
            "Wikipedia, 'Pradhan Mantri Kisan Samman Nidhi' (pointer only)",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Kisan_Samman_Nidhi"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:piyush-goyal",
        "role": "Union Minister of Finance (interim)",
        "action": "presented budget",
        "date": "2019-02-01",
        "party": "BJP",
        "srcs": [
          [
            "Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)",
            "https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"
          ]
        ]
      },
      {
        "personId": "pol:narendra-modi",
        "role": "Prime Minister",
        "action": "announced",
        "date": "2019-02-24",
        "party": "BJP",
        "srcs": [
          [
            "Wikipedia (pointer), Pradhan Mantri Kisan Samman Nidhi",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Kisan_Samman_Nidhi"
          ],
          [
            "PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"
          ],
          [
            "PIB, PM to release 23rd instalment from Tarakeswar, Hooghly, WB on 20 Jun 2026, 18 Jun 2026",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2274616"
          ]
        ]
      },
      {
        "personId": "pol:nirmala-sitharaman",
        "role": "Union Finance Minister",
        "action": "presented budget",
        "date": "2024-02-01",
        "party": "BJP",
        "srcs": [
          [
            "Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)",
            "https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"
          ]
        ]
      },
      {
        "personId": "pol:shivraj-singh-chouhan",
        "role": "Union Minister of Agriculture & Farmers' Welfare, 2024-06 →",
        "action": "administers",
        "date": "2026-06-20",
        "party": "BJP",
        "srcs": [
          [
            "PIB, PM to release 23rd instalment from Tarakeswar, Hooghly, WB on 20 Jun 2026, 18 Jun 2026",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2274616"
          ]
        ]
      },
      {
        "personId": "wel:ramnath-thakur",
        "role": "Minister of State, Agriculture & Farmers' Welfare",
        "action": "administers",
        "date": "2025-12-02",
        "party": null,
        "srcs": [
          [
            "Lok Sabha Unstarred Q.358 (MoS Agri Ramnath Thakur), discrepancy in PM-KISAN: ₹416.75 cr recovered from ineligible beneficiaries, 2 Dec 2025",
            "https://sansad.in/getFile/loksabhaquestions/annex/186/AU358_FPeZsZ.pdf?source=pqals"
          ],
          [
            "PIB (MoA&FW RS reply), PM-KISAN 18th instalment beneficiaries and saturation drives, Feb 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2100758"
          ]
        ]
      },
      {
        "personId": "pol:piyush-goyal",
        "role": "Union Finance Minister (interim charge)",
        "action": "announced",
        "date": "2019-02-01",
        "party": "BJP",
        "srcs": [
          [
            "PMO — Cabinet approves PM-KISAN",
            "https://www.pmindia.gov.in/en/news_updates/cabinet-approves-pradhan-mantri-kisan-samman-nidhi-pm-kisan-scheme/"
          ]
        ]
      },
      {
        "personId": "pol:narendra-modi",
        "role": "Prime Minister",
        "action": "announced",
        "date": "2019-02-24",
        "party": "BJP",
        "srcs": [
          [
            "PIB — PM-KISAN Samman Nidhi",
            "https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=2039203"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "Common Service Centres and India Post Payments Bank",
        "how": "registration/e-KYC intermediation and doorstep account opening — a fee-earning channel created by the scheme's compliance gates",
        "amountCr": null,
        "tier": "documented",
        "srcs": [
          [
            "PIB, PM to release 21st instalment of PM-KISAN on 19 Nov 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2190074"
          ]
        ]
      },
      {
        "who": "wel:ekstep-foundation",
        "how": "technical support (with BHASHINI) for the Kisan-eMitra chatbot; EkStep is chaired by Nandan Nilekani — a documented association, not a payment claim",
        "amountCr": null,
        "tier": "documented",
        "srcs": [
          [
            "PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"
          ],
          [
            "Wikipedia (pointer), Nandan Nilekani",
            "https://en.wikipedia.org/wiki/Nandan_Nilekani"
          ]
        ]
      },
      {
        "who": "bjp",
        "how": "instalment-release events staged as 'PM-KISAN Utsav Diwas' with 1 crore farmers linked by video; venues in 2026 tracked the election calendar (Assam before its poll, West Bengal after BJP's win)",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"
          ],
          [
            "PIB, PM to release 23rd instalment from Tarakeswar, Hooghly, WB on 20 Jun 2026, 18 Jun 2026",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2274616"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)",
        "https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"
      ],
      [
        "PIB, PM to release 21st instalment of PM-KISAN on 19 Nov 2025",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2190074"
      ],
      [
        "PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"
      ],
      [
        "PIB, PM to release 23rd instalment from Tarakeswar, Hooghly, WB on 20 Jun 2026, 18 Jun 2026",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2274616"
      ],
      [
        "PMO, Cabinet approves continuation of PM-KISAN 2026-27 to 2030-31, ₹3.15 lakh crore, 31 Jul 2026",
        "https://www.pmindia.gov.in/en/news_updates/cabinet-approves-continuation-of-the-pm-kisan-scheme-from-2026-27-to-2030-31-with-a-financial-outlay-of-rs-3-15-lakh-crore/"
      ],
      [
        "Lok Sabha Unstarred Q.358 (MoS Agri Ramnath Thakur), discrepancy in PM-KISAN: ₹416.75 cr recovered from ineligible beneficiaries, 2 Dec 2025",
        "https://sansad.in/getFile/loksabhaquestions/annex/186/AU358_FPeZsZ.pdf?source=pqals"
      ],
      [
        "Wikipedia (pointer), Pradhan Mantri Kisan Samman Nidhi",
        "https://en.wikipedia.org/wiki/Pradhan_Mantri_Kisan_Samman_Nidhi"
      ],
      [
        "PIB — PM-KISAN Samman Nidhi",
        "https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=2039203"
      ],
      [
        "Ministry of Agriculture & Farmers Welfare, PM-KISAN Revised Operational Guidelines (PDF, pmkisan.gov.in)",
        "https://www.pmkisan.gov.in/Documents/Revised%20Operational%20Guidelines%20-%20PM-Kisan%20Scheme.pdf"
      ]
    ],
    "domain": "central"
  },
  {
    "id": "scheme:pm-ujjwala",
    "name": "Pradhan Mantri Ujjwala Yojana",
    "al": [
      "Ujjwala",
      "PMUY",
      "Ujjwala 2.0"
    ],
    "level": "central",
    "st": null,
    "applicableStates": "all",
    "category": "energy-subsidy",
    "party": "BJP (NDA)",
    "announced": {
      "date": "2016-05-01",
      "byPersonId": "pol:narendra-modi",
      "office": "Prime Minister",
      "srcs": [
        [
          "Wikipedia (pointer), Pradhan Mantri Ujjwala Yojana",
          "https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"
        ],
        [
          "CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)",
          "https://cag.gov.in/"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Union Cabinet (date not verified here); target revised Feb 2018 to 8 crore",
      "srcs": [
        [
          "CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)",
          "https://cag.gov.in/"
        ]
      ]
    },
    "launched": {
      "date": "2016-05-01",
      "srcs": [
        [
          "Wikipedia (pointer), Pradhan Mantri Ujjwala Yojana",
          "https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"
        ],
        [
          "CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)",
          "https://cag.gov.in/"
        ]
      ]
    },
    "benefit": {
      "amount": 1600,
      "unit": "₹ deposit-free connection (security deposit, regulator, hose, DGCC, installation); stove and first refill on loan, later free under Ujjwala 2.0",
      "changes": [
        {
          "date": "2020-04-01",
          "amount": 3,
          "note": "up to 3 free refills Apr–Dec 2020 under PM Garib Kalyan package",
          "srcs": [
            [
              "PIB (MoPNG RS reply), Average LPG refill consumption of PMUY beneficiaries 2018-19 to 2020-21, 20 Dec 2021",
              "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1783430"
            ],
            [
              "PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020",
              "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"
            ]
          ]
        },
        {
          "date": "2021-08-10",
          "amount": null,
          "note": "Ujjwala 2.0: 1 crore more connections; first refill and stove free",
          "srcs": [
            [
              "Wikipedia (pointer), Pradhan Mantri Ujjwala Yojana",
              "https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"
            ],
            [
              "PIB, Cabinet approves PMUY targeted subsidy FY 2025-26 (₹300, up to 9 refills), 8 Aug 2025",
              "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2154117"
            ]
          ]
        },
        {
          "date": "2022-05-01",
          "amount": 200,
          "note": "₹200 per 14.2 kg cylinder targeted subsidy, up to 12 refills/yr; ₹6,100 cr FY23, ₹7,680 cr FY24",
          "srcs": [
            [
              "PIB, Cabinet approves continuation of ₹300 PMUY subsidy for FY 2024-25, 7 Mar 2024",
              "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2012354"
            ],
            [
              "Wikipedia (pointer), Pradhan Mantri Ujjwala Yojana",
              "https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"
            ]
          ]
        },
        {
          "date": "2023-10-01",
          "amount": 300,
          "note": "raised to ₹300 per cylinder (October 2023, weeks before the Nov 2023 assembly polls)",
          "srcs": [
            [
              "PIB, Cabinet approves continuation of ₹300 PMUY subsidy for FY 2024-25, 7 Mar 2024",
              "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2012354"
            ]
          ]
        },
        {
          "date": "2025-08-08",
          "amount": 300,
          "note": "FY 2025-26: ₹300 kept but cap cut from 12 to 9 refills/yr; outlay held at ₹12,000 cr",
          "srcs": [
            [
              "PIB, Cabinet approves PMUY targeted subsidy FY 2025-26 (₹300, up to 9 refills), 8 Aug 2025",
              "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2154117"
            ]
          ]
        },
        {
          "date": "2021-08-10",
          "amount": null,
          "note": "Ujjwala 2.0 expansion, additional 1 crore connections.",
          "srcs": [
            [
              "Wikipedia — Ujjwala Yojana",
              "https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"
            ]
          ]
        },
        {
          "date": "2022-05-01",
          "amount": 200,
          "note": "targeted subsidy ₹200 per 14.2 kg cylinder, up to 12 refills/yr (month given as May 2022)",
          "srcs": [
            [
              "PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025",
              "https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"
            ]
          ]
        },
        {
          "date": "2023-10-01",
          "amount": 300,
          "note": "raised to ₹300 per cylinder (month given as Oct 2023), weeks before the Nov 2023 MP/Rajasthan/Chhattisgarh/Telangana polls",
          "srcs": [
            [
              "PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025",
              "https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"
            ],
            [
              "Wikipedia (pointer), 2023 Madhya Pradesh Legislative Assembly election",
              "https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"
            ]
          ]
        },
        {
          "date": "2025-08-08",
          "amount": 300,
          "note": "continued for FY2025-26 but capped at 9 refills/yr (from 12); ₹12,000 crore",
          "srcs": [
            [
              "PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025",
              "https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"
            ]
          ]
        }
      ]
    },
    "eligibility": "adult women of poor households (SECC-2011 BPL initially; relaxed under E-PMUY 2018 and Ujjwala 2.0)",
    "beneficiaries": [
      {
        "asOf": "2019-03-31",
        "count": 71900000,
        "srcs": [
          [
            "CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)",
            "https://cag.gov.in/"
          ]
        ]
      },
      {
        "asOf": "2024-03-01",
        "count": 102700000,
        "srcs": [
          [
            "PIB, Cabinet approves continuation of ₹300 PMUY subsidy for FY 2024-25, 7 Mar 2024",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2012354"
          ]
        ]
      },
      {
        "asOf": "2025-07-01",
        "count": 103300000,
        "srcs": [
          [
            "PIB, Cabinet approves PMUY targeted subsidy FY 2025-26 (₹300, up to 9 refills), 8 Aug 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2154117"
          ]
        ]
      },
      {
        "asOf": "2023-12-30",
        "count": 100000000,
        "srcs": [
          [
            "Wikipedia — Ujjwala Yojana",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"
          ]
        ]
      },
      {
        "asOf": "2019-03-31",
        "count": 71900000,
        "srcs": [
          [
            "CAG press release on Performance Audit Report No. 14 of 2019 on PMUY, 11 Dec 2019 (local copy; exact report URL unresolved — see gaps)",
            "https://cag.gov.in/en"
          ]
        ]
      },
      {
        "asOf": "2025-07-01",
        "count": 103300000,
        "srcs": [
          [
            "PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2016-20",
        "budgetedCr": 12800,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)",
            "https://cag.gov.in/"
          ]
        ]
      },
      {
        "fy": "2024-25",
        "budgetedCr": 12000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB, Cabinet approves continuation of ₹300 PMUY subsidy for FY 2024-25, 7 Mar 2024",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2012354"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 12000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB, Cabinet approves PMUY targeted subsidy FY 2025-26 (₹300, up to 9 refills), 8 Aug 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2154117"
          ]
        ]
      },
      {
        "fy": "2016-17",
        "budgetedCr": 8000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Wikipedia — Ujjwala Yojana",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"
          ]
        ]
      },
      {
        "fy": "2016-17 to 2019-20",
        "budgetedCr": 12800,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "CAG press release on Performance Audit Report No. 14 of 2019 on PMUY, 11 Dec 2019 (local copy; exact report URL unresolved — see gaps)",
            "https://cag.gov.in/en"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 12000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Assembly polls Nov 2023 (MP 17 Nov; Chhattisgarh 7/17 Nov; Rajasthan 25 Nov; Telangana 30 Nov) — for the ₹300 subsidy raise",
      "date": "2023-11-07",
      "monthsFromLaunch": 1,
      "incumbentParty": "BJP (Centre); MP BJP, CT/RJ INC, TG BRS",
      "result": "BJP won MP, CT, RJ; INC won TG",
      "seatChange": "MP BJP +54; CT BJP +39; RJ BJP +42",
      "srcs": [
        [
          "PIB, Cabinet approves continuation of ₹300 PMUY subsidy for FY 2024-25, 7 Mar 2024",
          "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2012354"
        ],
        [
          "Wikipedia (pointer), 2023 Madhya Pradesh Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"
        ],
        [
          "Wikipedia (pointer), 2023 Chhattisgarh Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"
        ],
        [
          "Wikipedia (pointer), 2023 Rajasthan Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"
        ],
        [
          "Wikipedia (pointer), 2023 Telangana Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2018-02-01",
        "status": "raised",
        "note": "target 5 → 8 crore; criteria relaxed",
        "srcs": [
          [
            "CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)",
            "https://cag.gov.in/"
          ]
        ]
      },
      {
        "date": "2023-10-01",
        "status": "raised",
        "note": "subsidy ₹200 → ₹300",
        "srcs": [
          [
            "PIB, Cabinet approves continuation of ₹300 PMUY subsidy for FY 2024-25, 7 Mar 2024",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2012354"
          ]
        ]
      },
      {
        "date": "2025-08-08",
        "status": "eligibility-tightened",
        "note": "refill cap 12 → 9 per year",
        "srcs": [
          [
            "PIB, Cabinet approves PMUY targeted subsidy FY 2025-26 (₹300, up to 9 refills), 8 Aug 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2154117"
          ]
        ]
      },
      {
        "date": "2021-08-10",
        "status": "raised",
        "note": "Ujjwala 2.0 launched.",
        "srcs": [
          [
            "Wikipedia — Ujjwala Yojana",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"
          ]
        ]
      },
      {
        "date": "2018-02-01",
        "status": "raised",
        "note": "target raised 5 → 8 crore connections; budget ₹8,000 → ₹12,800 crore",
        "srcs": [
          [
            "CAG press release on Performance Audit Report No. 14 of 2019 on PMUY, 11 Dec 2019 (local copy; exact report URL unresolved — see gaps)",
            "https://cag.gov.in/en"
          ]
        ]
      },
      {
        "date": "2022-05-01",
        "status": "raised",
        "note": "₹200/cylinder targeted subsidy begins",
        "srcs": [
          [
            "PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"
          ]
        ]
      },
      {
        "date": "2023-10-01",
        "status": "raised",
        "note": "₹300/cylinder",
        "srcs": [
          [
            "PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"
          ]
        ]
      },
      {
        "date": "2025-08-08",
        "status": "eligibility-tightened",
        "note": "refill cap cut from 12 to 9 per year",
        "srcs": [
          [
            "PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "CAG Report 14 of 2019: 42% of 3.78 cr connections de-duplicated on beneficiary Aadhaar only; 1.88 lakh connections to male AHL-TINs; 8.59 lakh to minors per SECC; 18% of 4,348 field-verified KYCs used intended beneficiaries' TINs for unintended persons; average refills 3.66/yr falling to 3.21; 1.98 lakh 'BPL' consumers took >12 cylinders/yr (diversion risk); ₹1,234.71 cr loan recovery stalled; ₹261.85 cr OMC CSR pool idle",
        "tier": "documented",
        "srcs": [
          [
            "CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)",
            "https://cag.gov.in/"
          ]
        ]
      },
      {
        "finding": "Refill consumption (government data): 3.01 (2019-20) → 3.68 (2022-23) → 3.87 prorated (2023-24) → 4.47 (2024-25); state-wise 2018-19 as low as 1.34 (Chhattisgarh), 2.73 (Assam)",
        "tier": "documented",
        "srcs": [
          [
            "PIB, Cabinet approves continuation of ₹300 PMUY subsidy for FY 2024-25, 7 Mar 2024",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2012354"
          ],
          [
            "PIB, Cabinet approves PMUY targeted subsidy FY 2025-26 (₹300, up to 9 refills), 8 Aug 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2154117"
          ],
          [
            "PIB (MoPNG RS reply), Average LPG refill consumption of PMUY beneficiaries 2018-19 to 2020-21, 20 Dec 2021",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1783430"
          ]
        ]
      },
      {
        "finding": "~90 lakh beneficiaries took no refill in 2021-22 due to price (The Hindu, via Wikipedia pointer)",
        "tier": "reported",
        "srcs": [
          [
            "Wikipedia (pointer), Pradhan Mantri Ujjwala Yojana",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"
          ]
        ]
      },
      {
        "finding": "Lokniti-CSDS 2024: 45.0% of households report an Ujjwala benefit; 68.3% of them credit the Centre — the highest central-credit share of any scheme asked",
        "tier": "documented",
        "srcs": [
          [
            "Lokniti-CSDS, Social and Political Barometer Post-poll Study 2024 — Survey Findings (PDF on file, dated 14 Jun 2024; exact URL not recovered — see gaps)",
            "https://www.lokniti.org/"
          ]
        ]
      },
      {
        "finding": "Refill rates among Ujjwala beneficiaries have been widely reported as well below general LPG consumer refill rates, i.e. many connections go under-used because recurring refill cost remains a barrier — a gap between connection count and sustained use this file could not pin to a specific fetched primary CAG/NSSO source this session, so it is recorded as an analytic inference from general reporting rather than a documented figure.",
        "tier": "analytic",
        "srcs": []
      },
      {
        "finding": "Deshpande, Tillin & Kailash (2019): Ujjwala is the clearest case of a scheme credited to the central government, and its beneficiaries were more likely to vote BJP in 2019 (NES 2019 post-poll) — an association, with the authors’ own caveats.",
        "tier": "documented",
        "srcs": [
          [
            "Deshpande, Tillin & Kailash (2019) The BJP’s Welfare Schemes: Did They Make a Difference in the 2019 Elections? — Studies in Indian Politics 7(2):219–233 (Crossref metadata + abstract)",
            "https://api.crossref.org/works/10.1177/2321023019874911"
          ]
        ]
      },
      {
        "finding": "CAG (Report 14 of 2019): 1.60 crore of 3.78 crore connections (42%) issued on the beneficiary's Aadhaar alone without family de-duplication; 1.93 crore consumers averaged 3.66 refills/yr; 1.98 lakh beneficiaries consumed >12 cylinders/yr (diversion risk); ₹1,234.71 crore of stove/first-refill loans outstanding; ₹261.85 crore lying idle; 10,000 new distributorships not commissioned",
        "tier": "documented",
        "srcs": [
          [
            "CAG press release on Performance Audit Report No. 14 of 2019 on PMUY, 11 Dec 2019 (local copy; exact report URL unresolved — see gaps)",
            "https://cag.gov.in/en"
          ]
        ]
      },
      {
        "finding": "State-wise average refills 2020-21 ranged from 2.57 (Chhattisgarh) to 8.12 (Delhi); national per-capita consumption rose to 4.47 refills in FY2024-25",
        "tier": "documented",
        "srcs": [
          [
            "PIB, Average LPG refill consumption of PMUY beneficiaries (Rajya Sabha reply), 20 Dec 2021",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=1783430"
          ],
          [
            "PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"
          ]
        ]
      },
      {
        "finding": "Lokniti-CSDS NES 2019: NDA vote 49% among Ujjwala-beneficiary households vs 42% among non-beneficiaries; 34% of households reported a connection",
        "tier": "documented",
        "srcs": [
          [
            "Seminar #720, Jyoti Mishra & Vibha Attri (Lokniti-CSDS), 'Did welfare win votes?' (NES 2019 post-poll), 2019",
            "https://india-seminar.com/2019/720/720_jyoti_and_vibha.htm"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:narendra-modi",
        "role": "Prime Minister",
        "action": "announced",
        "date": "2016-05-01",
        "party": "BJP",
        "srcs": [
          [
            "Wikipedia (pointer), Pradhan Mantri Ujjwala Yojana",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"
          ]
        ]
      },
      {
        "personId": "pradhan",
        "role": "Minister of Petroleum & Natural Gas, 2014 → 2021",
        "action": "administers",
        "date": "2016-05-01",
        "party": "BJP",
        "srcs": [
          [
            "CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)",
            "https://cag.gov.in/"
          ]
        ]
      },
      {
        "personId": "pol:hardeep-singh-puri",
        "role": "Minister of Petroleum & Natural Gas, 2021-07 →",
        "action": "administers",
        "date": "2024-03-07",
        "party": "BJP",
        "srcs": [
          [
            "PIB, Cabinet approves continuation of ₹300 PMUY subsidy for FY 2024-25, 7 Mar 2024",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2012354"
          ]
        ]
      },
      {
        "personId": "wel:rameswar-teli",
        "role": "Minister of State, Petroleum & Natural Gas",
        "action": "administers",
        "date": "2021-12-20",
        "party": null,
        "srcs": [
          [
            "PIB (MoPNG RS reply), Average LPG refill consumption of PMUY beneficiaries 2018-19 to 2020-21, 20 Dec 2021",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1783430"
          ]
        ]
      },
      {
        "personId": "pol:piyush-goyal",
        "role": "Union Minister (Commerce & Industry), briefed CCEA decision on ₹300 subsidy",
        "action": "announced",
        "date": "2024-03-07",
        "party": "BJP",
        "srcs": [
          [
            "Wikipedia (pointer), Pradhan Mantri Ujjwala Yojana",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"
          ]
        ]
      },
      {
        "personId": "pol:narendra-modi",
        "role": "Prime Minister",
        "action": "announced",
        "date": "2016-05-01",
        "party": "BJP",
        "srcs": [
          [
            "Wikipedia — Ujjwala Yojana",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"
          ]
        ]
      },
      {
        "personId": "pradhan",
        "role": "Union Minister of Petroleum and Natural Gas",
        "action": "administers",
        "date": "2016-05-01",
        "party": "BJP",
        "srcs": [
          [
            "Wikipedia — Ujjwala Yojana",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"
          ]
        ]
      },
      {
        "personId": "pol:hardeep-singh-puri",
        "role": "Union Minister of Petroleum and Natural Gas",
        "action": "administers",
        "date": "2024-06-10",
        "party": "BJP",
        "srcs": []
      },
      {
        "personId": "pol:hardeep-singh-puri",
        "role": "Minister of Petroleum and Natural Gas",
        "action": "administers",
        "date": "2021-07-07",
        "party": "BJP",
        "srcs": [
          [
            "PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"
          ]
        ]
      },
      {
        "personId": "pol:narendra-modi",
        "role": "Prime Minister",
        "action": "approved",
        "date": "2025-08-08",
        "party": "BJP",
        "srcs": [
          [
            "PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "co:indian-oil, co:hindustan-petroleum, co:bharat-petroleum (OMCs)",
        "how": "connection costs and refill subsidy reimbursed by the Centre; ~10 crore new LPG customers; CAG found OMC claims only partially settled in 2017-19 and a ₹261.85 cr CSR pool parked",
        "amountCr": 12000,
        "tier": "documented",
        "srcs": [
          [
            "CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)",
            "https://cag.gov.in/"
          ],
          [
            "PIB, Cabinet approves PMUY targeted subsidy FY 2025-26 (₹300, up to 9 refills), 8 Aug 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2154117"
          ]
        ]
      },
      {
        "who": "LPG distributors",
        "how": "new connections and refill margins; CAG: 18% of test-checked KYCs showed distributor misuse of TINs; 10,000 targeted new distributorships lagged",
        "amountCr": null,
        "tier": "documented",
        "srcs": [
          [
            "CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)",
            "https://cag.gov.in/"
          ]
        ]
      },
      {
        "who": "co:indian-oil",
        "how": "LPG cylinder refill and connection sales through OMC distributor network",
        "amountCr": null,
        "tier": "analytic",
        "srcs": []
      },
      {
        "who": "co:bharat-petroleum",
        "how": "LPG cylinder refill and connection sales",
        "amountCr": null,
        "tier": "analytic",
        "srcs": []
      },
      {
        "who": "co:hindustan-petroleum",
        "how": "LPG cylinder refill and connection sales",
        "amountCr": null,
        "tier": "analytic",
        "srcs": []
      },
      {
        "who": "wel:omcs",
        "how": "₹1,600 per connection reimbursed by GoI (~₹11,500 crore for 7.19 crore connections by Mar 2019) plus a captive refill market; CAG notes OMC claims were short-paid when budgets fell short",
        "amountCr": 11504,
        "tier": "documented",
        "srcs": [
          [
            "CAG press release on Performance Audit Report No. 14 of 2019 on PMUY, 11 Dec 2019 (local copy; exact report URL unresolved — see gaps)",
            "https://cag.gov.in/en"
          ]
        ]
      },
      {
        "who": "LPG cylinder, regulator and hose manufacturers (unnamed)",
        "how": "8 crore new connections = 8+ crore cylinders and regulators procured by OMCs; supplier names and order values not found in any source opened",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "CAG press release on Performance Audit Report No. 14 of 2019 on PMUY, 11 Dec 2019 (local copy; exact report URL unresolved — see gaps)",
            "https://cag.gov.in/en"
          ]
        ]
      },
      {
        "who": "bjp",
        "how": "Beneficiary vote premium of ~7 points (Lokniti 2019); correlation, not proof of causation",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "Seminar #720, Jyoti Mishra & Vibha Attri (Lokniti-CSDS), 'Did welfare win votes?' (NES 2019 post-poll), 2019",
            "https://india-seminar.com/2019/720/720_jyoti_and_vibha.htm"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)",
        "https://cag.gov.in/"
      ],
      [
        "PIB, Cabinet approves continuation of ₹300 PMUY subsidy for FY 2024-25, 7 Mar 2024",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2012354"
      ],
      [
        "PIB, Cabinet approves PMUY targeted subsidy FY 2025-26 (₹300, up to 9 refills), 8 Aug 2025",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2154117"
      ],
      [
        "PIB (MoPNG RS reply), Average LPG refill consumption of PMUY beneficiaries 2018-19 to 2020-21, 20 Dec 2021",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1783430"
      ],
      [
        "Wikipedia (pointer), Pradhan Mantri Ujjwala Yojana",
        "https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"
      ],
      [
        "Wikipedia — Ujjwala Yojana",
        "https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"
      ],
      [
        "Deshpande, Tillin & Kailash (2019) The BJP’s Welfare Schemes: Did They Make a Difference in the 2019 Elections? — Studies in Indian Politics 7(2):219–233 (Crossref metadata + abstract)",
        "https://api.crossref.org/works/10.1177/2321023019874911"
      ],
      [
        "CAG press release on Performance Audit Report No. 14 of 2019 on PMUY, 11 Dec 2019 (local copy; exact report URL unresolved — see gaps)",
        "https://cag.gov.in/en"
      ],
      [
        "PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025",
        "https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"
      ],
      [
        "PIB, Average LPG refill consumption of PMUY beneficiaries (Rajya Sabha reply), 20 Dec 2021",
        "https://pib.gov.in/PressReleasePage.aspx?PRID=1783430"
      ],
      [
        "Seminar #720, Jyoti Mishra & Vibha Attri (Lokniti-CSDS), 'Did welfare win votes?' (NES 2019 post-poll), 2019",
        "https://india-seminar.com/2019/720/720_jyoti_and_vibha.htm"
      ]
    ],
    "domain": "central"
  },
  {
    "id": "scheme:pmgkay",
    "name": "Pradhan Mantri Garib Kalyan Anna Yojana (free grain)",
    "al": [
      "PM-GKAY",
      "free ration scheme",
      "मुफ्त राशन",
      "PMGKAY",
      "free ration"
    ],
    "level": "central",
    "st": null,
    "applicableStates": "all",
    "category": "grain",
    "party": "BJP (NDA)",
    "announced": {
      "date": "2020-03-26",
      "byPersonId": "pol:nirmala-sitharaman",
      "office": "Union Finance Minister, 2019-05-31 →",
      "srcs": [
        [
          "PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020",
          "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"
        ]
      ]
    },
    "approved": {
      "date": "2023-11-29",
      "body": "Union Cabinet — five-year free-grain decision (₹11.80 lakh cr, 1 Jan 2024–31 Dec 2028); earlier phases approved by Cabinet/CCEA through 2020–22",
      "srcs": [
        [
          "PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023",
          "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"
        ],
        [
          "Wikipedia (pointer), PMGKAY",
          "https://en.wikipedia.org/wiki/Pradhan_Mantri_Garib_Kalyan_Anna_Yojana"
        ]
      ]
    },
    "launched": {
      "date": "2020-04-01",
      "srcs": [
        [
          "PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020",
          "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"
        ],
        [
          "Wikipedia (pointer), PMGKAY",
          "https://en.wikipedia.org/wiki/Pradhan_Mantri_Garib_Kalyan_Anna_Yojana"
        ]
      ]
    },
    "benefit": {
      "amount": 5,
      "unit": "kg free foodgrain per person per month (additional to NFSA quota until Dec 2022; from Jan 2023 the NFSA quota itself, free)",
      "changes": [
        {
          "date": "2022-12-23",
          "amount": 5,
          "note": "additional 5 kg discontinued; NFSA entitlement made free for 2023 (Wikipedia pointer to Cabinet decision; cited cost ₹2 lakh cr)",
          "srcs": [
            [
              "Wikipedia (pointer), PMGKAY",
              "https://en.wikipedia.org/wiki/Pradhan_Mantri_Garib_Kalyan_Anna_Yojana"
            ]
          ]
        },
        {
          "date": "2023-11-04",
          "amount": 5,
          "note": "PM at Durg rally: free ration for 80 crore extended five years — 'guarantee of Modi'",
          "srcs": [
            [
              "ThePrint/ANI, 'Guarantee of Modi': PM extends free ration scheme for 5 years in poll-bound Chhattisgarh, MP, 4 Nov 2023",
              "https://theprint.in/india/guarantee-of-modi-pm-extends-free-ration-scheme-for-5-years-in-poll-bound-chhattisgarh-mp/1832402/"
            ]
          ]
        },
        {
          "date": "2024-01-01",
          "amount": 5,
          "note": "Cabinet: free grain to 81.35 crore for five years",
          "srcs": [
            [
              "PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023",
              "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"
            ]
          ]
        },
        {
          "date": "2023-11-23",
          "amount": null,
          "note": "Extension by five years to December 2028 announced by PM Modi at an election rally in Durg, Chhattisgarh, days before the MP/Chhattisgarh/Telangana/Rajasthan state polls and roughly five months before the 2024 Lok Sabha poll.",
          "srcs": [
            [
              "Deccan Herald — PMGKAY extended 5 years from Jan 2024",
              "https://www.deccanherald.com/india/modi-govt-extends-pmgkay-scheme-for-another-5-years-from-jan-1-2024-2789220"
            ]
          ]
        }
      ]
    },
    "eligibility": "NFSA Antyodaya and Priority Household ration-card holders (81.35 crore); portable under One Nation One Ration Card",
    "beneficiaries": [
      {
        "asOf": "2020-03-26",
        "count": 800000000,
        "srcs": [
          [
            "PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"
          ]
        ]
      },
      {
        "asOf": "2023-11-29",
        "count": 813500000,
        "srcs": [
          [
            "PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"
          ]
        ]
      },
      {
        "asOf": "2024-03-31",
        "count": 800000000,
        "srcs": [
          [
            "PRS Legislative Research, 'Demand for Grants 2024-25 Analysis: Food and Public Distribution'",
            "https://prsindia.org/budgets/parliament/demand-for-grants-2024-25-analysis-food-and-public-distribution"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2020-21",
        "budgetedCr": 170000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"
          ]
        ]
      },
      {
        "fy": "2024-28",
        "budgetedCr": 1180000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"
          ]
        ]
      },
      {
        "fy": "2023-24 RE",
        "budgetedCr": 212332,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, 'Demand for Grants 2024-25 Analysis: Food and Public Distribution'",
            "https://prsindia.org/budgets/parliament/demand-for-grants-2024-25-analysis-food-and-public-distribution"
          ]
        ]
      },
      {
        "fy": "2024-25 BE",
        "budgetedCr": 205250,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, 'Demand for Grants 2024-25 Analysis: Food and Public Distribution'",
            "https://prsindia.org/budgets/parliament/demand-for-grants-2024-25-analysis-food-and-public-distribution"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Chhattisgarh assembly (phase 1) — announcement 3 days before; also MP 17 Nov, Rajasthan 25 Nov, Telangana 30 Nov 2023; Lok Sabha 19 Apr 2024",
      "date": "2023-11-07",
      "monthsFromLaunch": 0.1,
      "incumbentParty": "INC (Chhattisgarh); BJP (Centre)",
      "result": "BJP won Chhattisgarh (+39), MP (+54), Rajasthan (+42); lost Telangana; BJP 240 at LS 2024 (−63) but NDA retained office",
      "seatChange": "CT BJP 15→54",
      "srcs": [
        [
          "ThePrint/ANI, 'Guarantee of Modi': PM extends free ration scheme for 5 years in poll-bound Chhattisgarh, MP, 4 Nov 2023",
          "https://theprint.in/india/guarantee-of-modi-pm-extends-free-ration-scheme-for-5-years-in-poll-bound-chhattisgarh-mp/1832402/"
        ],
        [
          "Wikipedia (pointer), 2023 Chhattisgarh Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"
        ],
        [
          "Wikipedia (pointer), 2023 Madhya Pradesh Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"
        ],
        [
          "Wikipedia (pointer), 2023 Rajasthan Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"
        ],
        [
          "Wikipedia (pointer), 2023 Telangana Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"
        ],
        [
          "Wikipedia (pointer), 2024 Indian general election",
          "https://en.wikipedia.org/wiki/2024_Indian_general_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2020-07-01",
        "status": "raised",
        "note": "extended Jul–Nov 2020, then phases III–VII to Dec 2022",
        "srcs": [
          [
            "Wikipedia (pointer), PMGKAY",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Garib_Kalyan_Anna_Yojana"
          ]
        ]
      },
      {
        "date": "2023-01-01",
        "status": "renamed",
        "note": "merged with NFSA: additional grain ends, base quota free",
        "srcs": [
          [
            "Wikipedia (pointer), PMGKAY",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Garib_Kalyan_Anna_Yojana"
          ]
        ]
      },
      {
        "date": "2023-11-29",
        "status": "raised",
        "note": "five-year extension to Dec 2028 approved after polls closed in CT/MP/RJ and before counting (3 Dec)",
        "srcs": [
          [
            "PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"
          ],
          [
            "ThePrint/ANI, 'Guarantee of Modi': PM extends free ration scheme for 5 years in poll-bound Chhattisgarh, MP, 4 Nov 2023",
            "https://theprint.in/india/guarantee-of-modi-pm-extends-free-ration-scheme-for-5-years-in-poll-bound-chhattisgarh-mp/1832402/"
          ]
        ]
      },
      {
        "date": "2023-11-29",
        "status": "raised",
        "note": "Cabinet extended free-grain supply for five more years from 2024-01-01, announced at a Chhattisgarh campaign rally ~5 months before the 2024 Lok Sabha poll.",
        "srcs": [
          [
            "Deccan Herald — PMGKAY extended 5 years from Jan 2024",
            "https://www.deccanherald.com/india/modi-govt-extends-pmgkay-scheme-for-another-5-years-from-jan-1-2024-2789220"
          ]
        ]
      },
      {
        "date": "2023-01-01",
        "status": "live",
        "note": "grain made free; CIP ₹0",
        "srcs": [
          [
            "PRS Legislative Research, 'Demand for Grants 2024-25 Analysis: Food and Public Distribution'",
            "https://prsindia.org/budgets/parliament/demand-for-grants-2024-25-analysis-food-and-public-distribution"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Congress response to the Durg announcement: BJP made the charges 'as it is losing the assembly polls' in Chhattisgarh; the article records no Cabinet approval preceding the PM's announcement",
        "tier": "reported",
        "srcs": [
          [
            "ThePrint/ANI, 'Guarantee of Modi': PM extends free ration scheme for 5 years in poll-bound Chhattisgarh, MP, 4 Nov 2023",
            "https://theprint.in/india/guarantee-of-modi-pm-extends-free-ration-scheme-for-5-years-in-poll-bound-chhattisgarh-mp/1832402/"
          ]
        ]
      },
      {
        "finding": "Government: 20.4 crore ration cards digitised, 99.8% Aadhaar-linked; 5.8 crore fake/duplicate cards removed (BS Nov 2024 via Wikipedia pointer)",
        "tier": "reported",
        "srcs": [
          [
            "Wikipedia (pointer), PMGKAY",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Garib_Kalyan_Anna_Yojana"
          ]
        ]
      },
      {
        "finding": "Lokniti-CSDS 2024: PDS reached 67.4% of surveyed households; 54.7% credit the Centre, 35.1% the state",
        "tier": "documented",
        "srcs": [
          [
            "Lokniti-CSDS, Social and Political Barometer Post-poll Study 2024 — Survey Findings (PDF on file, dated 14 Jun 2024; exact URL not recovered — see gaps)",
            "https://www.lokniti.org/"
          ]
        ]
      },
      {
        "finding": "Early 2020 distribution failures in several states (lockdown, dealer corruption) then all-time-high offtake from late 2020 (Wikipedia pointer to HT/food ministry data)",
        "tier": "reported",
        "srcs": [
          [
            "Wikipedia (pointer), PMGKAY",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Garib_Kalyan_Anna_Yojana"
          ]
        ]
      },
      {
        "finding": "Extension announced from an election platform in an actively-polling state is a textbook case of scheme-timing coinciding with an electoral calendar; the innocent reading is that COVID-era food security support was popular and fiscally continued regardless of any single poll.",
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald — PMGKAY extended 5 years from Jan 2024",
            "https://www.deccanherald.com/india/modi-govt-extends-pmgkay-scheme-for-another-5-years-from-jan-1-2024-2789220"
          ]
        ]
      },
      {
        "finding": "Economic cost 2024-25: rice ₹39.8/kg, wheat ₹27.7/kg against a CIP of ₹0 — the entire economic cost (MSP + procurement incidentals + freight, handling, storage, interest) is the subsidy",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, 'Demand for Grants 2024-25 Analysis: Food and Public Distribution'",
            "https://prsindia.org/budgets/parliament/demand-for-grants-2024-25-analysis-food-and-public-distribution"
          ]
        ]
      },
      {
        "finding": "BlueKraft/PIB attribute ₹1.85 lakh crore of cumulative 'savings' (53% of all DBT savings) to Aadhaar-linked ration-card authentication in PDS",
        "tier": "reported",
        "srcs": [
          [
            "PIB (Ministry of Finance), 'India's DBT: Boosting Welfare Efficiency' — BlueKraft assessment, 21 Apr 2025",
            "https://pib.gov.in/PressReleasePage.aspx?PRID=2123192"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:nirmala-sitharaman",
        "role": "Union Finance Minister",
        "action": "announced",
        "date": "2020-03-26",
        "party": "BJP",
        "srcs": [
          [
            "PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"
          ]
        ]
      },
      {
        "personId": "pol:narendra-modi",
        "role": "Prime Minister",
        "action": "announced",
        "date": "2023-11-04",
        "party": "BJP",
        "srcs": [
          [
            "ThePrint/ANI, 'Guarantee of Modi': PM extends free ration scheme for 5 years in poll-bound Chhattisgarh, MP, 4 Nov 2023",
            "https://theprint.in/india/guarantee-of-modi-pm-extends-free-ration-scheme-for-5-years-in-poll-bound-chhattisgarh-mp/1832402/"
          ]
        ]
      },
      {
        "personId": "pol:piyush-goyal",
        "role": "Minister of Consumer Affairs, Food & PD, 2020 → 2024-06",
        "action": "administers",
        "date": "2023-11-29",
        "party": "BJP",
        "srcs": [
          [
            "Wikipedia (pointer), Pradhan Mantri Ujjwala Yojana",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"
          ]
        ]
      },
      {
        "personId": "pol:pralhad-joshi",
        "role": "Minister of Consumer Affairs, Food & PD, 2024-06-10 →",
        "action": "administers",
        "date": "2024-06-10",
        "party": "BJP",
        "srcs": [
          [
            "PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"
          ]
        ]
      },
      {
        "personId": "pol:nirmala-sitharaman",
        "role": "Union Finance Minister",
        "action": "announced",
        "date": "2020-03-26",
        "party": "BJP",
        "srcs": [
          [
            "Wikipedia — PMGKAY",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Garib_Kalyan_Anna_Yojana"
          ]
        ]
      },
      {
        "personId": "pol:narendra-modi",
        "role": "Prime Minister",
        "action": "announced",
        "date": "2023-11-23",
        "party": "BJP",
        "srcs": [
          [
            "Deccan Herald — PMGKAY extended 5 years from Jan 2024",
            "https://www.deccanherald.com/india/modi-govt-extends-pmgkay-scheme-for-another-5-years-from-jan-1-2024-2789220"
          ]
        ]
      },
      {
        "personId": "pol:pralhad-joshi",
        "role": "Union Minister of Consumer Affairs, Food and Public Distribution",
        "action": "administers",
        "date": "2024-06-10",
        "party": "BJP",
        "srcs": []
      },
      {
        "personId": "pol:pralhad-joshi",
        "role": "Minister of Consumer Affairs, Food and Public Distribution",
        "action": "administers",
        "date": "2024-06-10",
        "party": "BJP",
        "srcs": [
          [
            "PRS Legislative Research, 'Demand for Grants 2024-25 Analysis: Food and Public Distribution'",
            "https://prsindia.org/budgets/parliament/demand-for-grants-2024-25-analysis-food-and-public-distribution"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "fair price shop network (>5 lakh shops) and FCI",
        "how": "guaranteed offtake of ~5 kg × 81 crore per month; dealer margins; common-logo branding of shops",
        "amountCr": null,
        "tier": "documented",
        "srcs": [
          [
            "PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"
          ]
        ]
      },
      {
        "who": "bjp",
        "how": "'Modi ki guarantee' framing of a statutory NFSA entitlement; PM-branded announcement at campaign rallies",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "ThePrint/ANI, 'Guarantee of Modi': PM extends free ration scheme for 5 years in poll-bound Chhattisgarh, MP, 4 Nov 2023",
            "https://theprint.in/india/guarantee-of-modi-pm-extends-free-ration-scheme-for-5-years-in-poll-bound-chhattisgarh-mp/1832402/"
          ]
        ]
      },
      {
        "who": "Food Corporation of India and state PDS distribution networks",
        "how": "procurement and distribution logistics contracts, storage and transport",
        "amountCr": null,
        "tier": "analytic",
        "srcs": []
      },
      {
        "who": "wel:fci",
        "how": "Receives the food subsidy that funds MSP procurement and its own handling/freight/storage/interest costs",
        "amountCr": 139662,
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, 'Demand for Grants 2024-25 Analysis: Food and Public Distribution'",
            "https://prsindia.org/budgets/parliament/demand-for-grants-2024-25-analysis-food-and-public-distribution"
          ]
        ]
      },
      {
        "who": "Rice millers, road/rail transport and handling contractors (unnamed)",
        "how": "Custom-milling charges, freight and handling embedded in the ₹39.8/kg economic cost; a contractor-level breakdown was not found in sources opened",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "PRS Legislative Research, 'Demand for Grants 2024-25 Analysis: Food and Public Distribution'",
            "https://prsindia.org/budgets/parliament/demand-for-grants-2024-25-analysis-food-and-public-distribution"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"
      ],
      [
        "PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"
      ],
      [
        "ThePrint/ANI, 'Guarantee of Modi': PM extends free ration scheme for 5 years in poll-bound Chhattisgarh, MP, 4 Nov 2023",
        "https://theprint.in/india/guarantee-of-modi-pm-extends-free-ration-scheme-for-5-years-in-poll-bound-chhattisgarh-mp/1832402/"
      ],
      [
        "Wikipedia (pointer), PMGKAY",
        "https://en.wikipedia.org/wiki/Pradhan_Mantri_Garib_Kalyan_Anna_Yojana"
      ],
      [
        "Wikipedia — PMGKAY",
        "https://en.wikipedia.org/wiki/Pradhan_Mantri_Garib_Kalyan_Anna_Yojana"
      ],
      [
        "PRS Legislative Research, 'Demand for Grants 2024-25 Analysis: Food and Public Distribution'",
        "https://prsindia.org/budgets/parliament/demand-for-grants-2024-25-analysis-food-and-public-distribution"
      ],
      [
        "PIB (Ministry of Finance), 'India's DBT: Boosting Welfare Efficiency' — BlueKraft assessment, 21 Apr 2025",
        "https://pib.gov.in/PressReleasePage.aspx?PRID=2123192"
      ]
    ],
    "domain": "central"
  },
  {
    "id": "scheme:pmjdy",
    "name": "Pradhan Mantri Jan Dhan Yojana and the DBT/JAM architecture",
    "al": [
      "PMJDY",
      "Jan Dhan"
    ],
    "level": "central",
    "st": null,
    "applicableStates": "all",
    "category": "other",
    "party": "BJP (NDA)",
    "announced": {
      "date": "2014-08-15",
      "byPersonId": "pol:narendra-modi",
      "office": "Prime Minister, 2014-05-26 →",
      "srcs": [
        [
          "Wikipedia (pointer), Pradhan Mantri Jan Dhan Yojana",
          "https://en.wikipedia.org/wiki/Pradhan_Mantri_Jan_Dhan_Yojana"
        ],
        [
          "PIB (MoF), PMJDY completes 11 years, 28 Aug 2025",
          "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2161401"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Department of Financial Services, Ministry of Finance (mission-mode scheme); Cabinet approval date not verified here",
      "srcs": [
        [
          "Wikipedia (pointer), Pradhan Mantri Jan Dhan Yojana",
          "https://en.wikipedia.org/wiki/Pradhan_Mantri_Jan_Dhan_Yojana"
        ]
      ]
    },
    "launched": {
      "date": "2014-08-28",
      "srcs": [
        [
          "PIB (MoF), PMJDY completes 11 years, 28 Aug 2025",
          "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2161401"
        ],
        [
          "Wikipedia (pointer), Pradhan Mantri Jan Dhan Yojana",
          "https://en.wikipedia.org/wiki/Pradhan_Mantri_Jan_Dhan_Yojana"
        ]
      ]
    },
    "benefit": {
      "amount": 0,
      "unit": "zero-balance BSBD account with RuPay card, ₹2 lakh accident cover, overdraft up to ₹10,000",
      "changes": [
        {
          "date": "2020-03-26",
          "amount": 500,
          "note": "₹500/month ex gratia for 3 months to 20.40 crore women PMJDY account holders (COVID package)",
          "srcs": [
            [
              "PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020",
              "https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"
            ]
          ]
        }
      ]
    },
    "eligibility": "any unbanked adult (minors 10+ with guardian)",
    "beneficiaries": [
      {
        "asOf": "2025-08-13",
        "count": 561600000,
        "srcs": [
          [
            "PIB (MoF), PMJDY completes 11 years, 28 Aug 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2161401"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2024-25",
        "budgetedCr": null,
        "actualCr": 690000,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PIB (MoF), PMJDY completes 11 years, 28 Aug 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2161401"
          ],
          [
            "PIB, Ministry of Finance Year Ender 2024: Department of Expenditure (DBT via PFMS), 27 Dec 2024",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2088438"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Lok Sabha 2019",
      "date": "2019-04-11",
      "monthsFromLaunch": 56,
      "incumbentParty": "BJP (NDA)",
      "result": "incumbent won",
      "seatChange": "BJP +21 (282→303)",
      "srcs": [
        [
          "Wikipedia (pointer), 2019 Indian general election",
          "https://en.wikipedia.org/wiki/2019_Indian_general_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2025-07-01",
        "status": "live",
        "note": "saturation camps 1 Jul–30 Sep 2025 (1,77,102 camps) for re-KYC and dormancy reduction",
        "srcs": [
          [
            "PIB (MoF), PMJDY completes 11 years, 28 Aug 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2161401"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Government (relaying BlueKraft Digital Foundation, Apr 2025): DBT saved ₹3.48 lakh cr cumulatively (PDS ₹1.85 lakh cr; MGNREGS ₹42,534 cr; PM-KISAN ₹22,106 cr by deleting 2.1 crore ineligible; fertiliser ₹18,699.8 cr); subsidies fell from 16% to 9% of expenditure; a 'Welfare Efficiency Index' rose 0.32→0.91",
        "tier": "reported",
        "srcs": [
          [
            "PIB, 'India's DBT: Boosting Welfare Efficiency' (BlueKraft report relayed), 21 Apr 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2123192"
          ]
        ]
      },
      {
        "finding": "EPW (Dec 2016): the 'phenomenal success' savings claims for Aadhaar-linked LPG DBT cannot be confirmed from the underlying studies and data",
        "tier": "reported",
        "srcs": [
          [
            "EPW Vol 51 No 52, 'Questioning the Phenomenal Success of Aadhaar-linked DBT for LPG', 24 Dec 2016",
            "https://www.epw.in/journal/2016/52/web-exclusives/questioning-%E2%80%9Cphenomenal-success%E2%80%9D-aadhaar-linked-direct-benefit"
          ]
        ]
      },
      {
        "finding": "Muralidharan-Niehaus-Sukhtankar (NBER 26744; Jharkhand PDS, 15.1 mn people): Aadhaar-based biometric authentication had little average effect on leakage, raised transaction costs 17%, and among the 23% of beneficiaries without linked Aadhaar cut benefits ~10% (2.8% got nothing); 'reconciliation' cut grain disbursed 18–36%, of which roughly a quarter to a third was value lost by genuine beneficiaries; 1.5–2 million people lost access at some point",
        "tier": "documented",
        "srcs": [
          [
            "NBER WP 26744, Muralidharan, Niehaus & Sukhtankar, 'Identity Verification Standards in Welfare Programs: Experimental Evidence from India', Feb 2020 rev. Sep 2021",
            "https://www.nber.org/system/files/working_papers/w26744/w26744.pdf"
          ],
          [
            "Ideas for India, Muralidharan-Niehaus-Sukhtankar, 'Balancing corruption and exclusion: incorporating Aadhaar into PDS' (Jharkhand), 17 Apr 2020",
            "https://www.ideasforindia.in/topics/poverty-inequality/balancing-corruption-and-exclusion-incorporating-aadhaar-into-pds"
          ]
        ]
      },
      {
        "finding": "Drèze and co-authors (2017, cited in the I4I summary) called the Jharkhand reform 'pain without gain', linking exclusion to starvation deaths",
        "tier": "reported",
        "srcs": [
          [
            "Ideas for India, Muralidharan-Niehaus-Sukhtankar, 'Balancing corruption and exclusion: incorporating Aadhaar into PDS' (Jharkhand), 17 Apr 2020",
            "https://www.ideasforindia.in/topics/poverty-inequality/balancing-corruption-and-exclusion-incorporating-aadhaar-into-pds"
          ]
        ]
      },
      {
        "finding": "Critics of PMJDY (Wikipedia pointer): duplicate accounts opened for insurance/overdraft lure; work-burden on PSBs; dormancy",
        "tier": "reported",
        "srcs": [
          [
            "Wikipedia (pointer), Pradhan Mantri Jan Dhan Yojana",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Jan_Dhan_Yojana"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "pol:narendra-modi",
        "role": "Prime Minister",
        "action": "announced",
        "date": "2014-08-15",
        "party": "BJP",
        "srcs": [
          [
            "Wikipedia (pointer), Pradhan Mantri Jan Dhan Yojana",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Jan_Dhan_Yojana"
          ]
        ]
      },
      {
        "personId": "pol:nirmala-sitharaman",
        "role": "Union Finance Minister",
        "action": "administers",
        "date": "2025-08-28",
        "party": "BJP",
        "srcs": [
          [
            "PIB (MoF), PMJDY completes 11 years, 28 Aug 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2161401"
          ]
        ]
      },
      {
        "personId": "pol:pankaj-chaudhary",
        "role": "Minister of State, Finance",
        "action": "administers",
        "date": "2025-08-28",
        "party": "BJP",
        "srcs": [
          [
            "PIB (MoF), PMJDY completes 11 years, 28 Aug 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2161401"
          ]
        ]
      },
      {
        "personId": "wel:nandan-nilekani",
        "role": "Chairman, UIDAI (cabinet rank), 2009-07 → 2014-03",
        "action": "administers",
        "date": "2009-07-01",
        "party": null,
        "srcs": [
          [
            "Wikipedia (pointer), Nandan Nilekani",
            "https://en.wikipedia.org/wiki/Nandan_Nilekani"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "public-sector banks (co:state-bank-of-india led account opening)",
        "how": "₹2.68 lakh cr low-cost deposit float; DBT float; RuPay/PoS transaction volumes",
        "amountCr": 267756,
        "tier": "documented",
        "srcs": [
          [
            "PIB (MoF), PMJDY completes 11 years, 28 Aug 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2161401"
          ],
          [
            "Wikipedia (pointer), Pradhan Mantri Jan Dhan Yojana",
            "https://en.wikipedia.org/wiki/Pradhan_Mantri_Jan_Dhan_Yojana"
          ]
        ]
      },
      {
        "who": "wel:bluekraft-digital-foundation",
        "how": "private foundation whose savings estimate the government adopted as the official DBT narrative",
        "amountCr": null,
        "tier": "documented",
        "srcs": [
          [
            "PIB, 'India's DBT: Boosting Welfare Efficiency' (BlueKraft report relayed), 21 Apr 2025",
            "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2123192"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "PIB (MoF), PMJDY completes 11 years, 28 Aug 2025",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2161401"
      ],
      [
        "PIB, Ministry of Finance Year Ender 2024: Department of Expenditure (DBT via PFMS), 27 Dec 2024",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2088438"
      ],
      [
        "PIB, 'India's DBT: Boosting Welfare Efficiency' (BlueKraft report relayed), 21 Apr 2025",
        "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2123192"
      ],
      [
        "Wikipedia (pointer), Pradhan Mantri Jan Dhan Yojana",
        "https://en.wikipedia.org/wiki/Pradhan_Mantri_Jan_Dhan_Yojana"
      ]
    ],
    "domain": "central"
  },
  {
    "id": "scheme:rj-chiranjeevi",
    "name": "Mukhyamantri Chiranjeevi Swasthya Bima Yojana → Mukhyamantri Ayushman Arogya Yojana",
    "al": [
      "Chiranjeevi",
      "MAAY"
    ],
    "level": "state",
    "st": "rj",
    "applicableStates": null,
    "category": "other",
    "party": "INC",
    "announced": {
      "date": "2021-02-24",
      "byPersonId": "wel:ashok-gehlot",
      "office": "Chief Minister and Finance Minister, Rajasthan",
      "srcs": [
        [
          "PRS, Rajasthan Budget Analysis 2021-22",
          "https://prsindia.org/budgets/states/rajasthan-budget-analysis-2021-22"
        ]
      ]
    },
    "approved": {
      "date": "2021-02",
      "body": "Rajasthan budget 2021-22",
      "srcs": [
        [
          "PRS, Rajasthan Budget Analysis 2021-22",
          "https://prsindia.org/budgets/states/rajasthan-budget-analysis-2021-22"
        ]
      ]
    },
    "launched": {
      "date": null,
      "srcs": []
    },
    "benefit": {
      "amount": 500000,
      "unit": "₹ cashless cover per family per year",
      "changes": [
        {
          "date": "2022",
          "amount": 1000000,
          "note": "Raised to Rs 10 lakh (2022-23 budget) and Rs 25 lakh (2023-24 budget) per aggregator pages — not verified in an opened page",
          "srcs": [
            [
              "PRS, Rajasthan Budget Analysis 2022-23 (budget of 23 Feb 2022): \"annual medical insurance cover of Rs 10 lakh for each family\"",
              "https://prsindia.org/budgets/states/rajasthan-budget-analysis-2022-23"
            ]
          ]
        },
        {
          "date": "2024-02",
          "amount": 2500000,
          "note": "Renamed Mukhyamantri Ayushman Arogya Yojana by the BJP government (Feb 2024) with cover retained — supersession; source strength weak (insurer blogs)",
          "srcs": [
            [
              "Coverfox — Mukhyamantri Ayushman Arogya Yojana (MAAY): \"In February 2024, the Rajasthan government renamed it … while retaining its core benefits\"; ₹25 lakh cover (aggregator; weak)",
              "https://www.coverfox.com/government-schemes/health/mukhyamantri-ayushman-arogya-yojana-maay-rajasthan/"
            ]
          ]
        }
      ]
    },
    "eligibility": "NFSA/SECC families, small and marginal farmers, contract workers free; others at Rs 850 premium (aggregator pages)",
    "beneficiaries": [],
    "outlay": [
      {
        "fy": "2021-22",
        "budgetedCr": 1463,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Rajasthan Budget Analysis 2021-22",
            "https://prsindia.org/budgets/states/rajasthan-budget-analysis-2021-22"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Rajasthan assembly",
      "date": "2023-11-25",
      "monthsFromLaunch": 31,
      "incumbentParty": "INC",
      "result": "incumbent lost",
      "seatChange": "BJP +42",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI): 2023 Rajasthan Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2021-05",
        "status": "live",
        "note": "",
        "srcs": [
          [
            "PRS, Rajasthan Budget Analysis 2021-22",
            "https://prsindia.org/budgets/states/rajasthan-budget-analysis-2021-22"
          ]
        ]
      },
      {
        "date": "2024-02",
        "status": "renamed",
        "note": "MAAY under CM Bhajan Lal Sharma — continuation under a new name",
        "srcs": [
          [
            "Coverfox — Mukhyamantri Ayushman Arogya Yojana (MAAY): \"In February 2024, the Rajasthan government renamed it … while retaining its core benefits\"; ₹25 lakh cover (aggregator; weak)",
            "https://www.coverfox.com/government-schemes/health/mukhyamantri-ayushman-arogya-yojana-maay-rajasthan/"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "An insurance entitlement (Rs 25 lakh headline by 2023) is the Gehlot government's signature \"guarantee\"; the BJP kept it and renamed it. Neither the loss nor the retention supports a vote-buying reading; the retention supports the \"welfare, not bribe\" hypothesis for this category.",
        "tier": "analytic",
        "srcs": [
          [
            "PRS, Rajasthan Budget Analysis 2021-22",
            "https://prsindia.org/budgets/states/rajasthan-budget-analysis-2021-22"
          ],
          [
            "Wikipedia infobox (pointer to ECI): 2023 Rajasthan Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:ashok-gehlot",
        "role": "Chief Minister, Rajasthan",
        "action": "presented budget",
        "date": "2021-02-24",
        "party": "INC",
        "srcs": [
          [
            "PRS, Rajasthan Budget Analysis 2021-22",
            "https://prsindia.org/budgets/states/rajasthan-budget-analysis-2021-22"
          ]
        ]
      },
      {
        "personId": "wel:bhajan-lal-sharma",
        "role": "Chief Minister, Rajasthan",
        "action": "approved",
        "date": "2024-02",
        "party": "BJP",
        "srcs": [
          [
            "Wikipedia infobox (pointer to ECI): 2023 Rajasthan Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "empanelled private hospitals and the insurer/TPA",
        "how": "claims paid on cashless treatment; insurer identity not verified this session",
        "amountCr": null,
        "tier": "analytic",
        "srcs": []
      }
    ],
    "srcs": [
      [
        "PRS, Rajasthan Budget Analysis 2021-22",
        "https://prsindia.org/budgets/states/rajasthan-budget-analysis-2021-22"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2023 Rajasthan Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:rj-farm-loan-waiver-2018",
    "name": "Rajasthan farm loan waiver (Dec 2018) — and Raje's ₹50,000 pre-poll waiver (Feb 2018)",
    "al": [
      "Rajasthan Krishak Rin Mafi"
    ],
    "level": "state",
    "st": "rj",
    "applicableStates": null,
    "category": "loan-waiver",
    "party": "INC (Dec 2018); BJP (Feb 2018 precursor)",
    "announced": {
      "date": "2018-12-19",
      "byPersonId": "wel:ashok-gehlot",
      "office": "Chief Minister, Rajasthan",
      "srcs": [
        [
          "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
          "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
        ]
      ]
    },
    "approved": {
      "date": "2018-12-19",
      "body": "State Cooperative Department order, 19 Dec 2018",
      "srcs": [
        [
          "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
          "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
        ]
      ]
    },
    "launched": {
      "date": "2018-12-19",
      "srcs": [
        [
          "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
          "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
        ]
      ]
    },
    "benefit": {
      "amount": 200000,
      "unit": "₹ maximum for commercial-bank defaulters; full waiver of cooperative crop loans",
      "changes": [
        {
          "date": "2018-02",
          "amount": 50000,
          "note": "PRECURSOR (BJP, Vasundhara Raje): Rs 50,000 per farmer cooperative waiver announced in the Feb 2018 budget, 10 months before the poll; Rs 8,500 cr of loans settled with a Rs 5,000 cr NCDC loan; BJP claimed 30 lakh beneficiaries",
          "srcs": [
            [
              "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
              "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
            ]
          ]
        }
      ]
    },
    "eligibility": "Cooperative crop loans outstanding 30 Nov 2018 (full); commercial/nationalised bank defaulters up to Rs 2 lakh",
    "beneficiaries": [
      {
        "asOf": "2018-12",
        "count": 3000000,
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2018-19 (announced burden)",
        "budgetedCr": 8000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ]
        ]
      },
      {
        "fy": "2021-22",
        "budgetedCr": 3200,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Rajasthan Budget Analysis 2021-22",
            "https://prsindia.org/budgets/states/rajasthan-budget-analysis-2021-22"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Rajasthan assembly",
      "date": "2018-12-07",
      "monthsFromLaunch": -10,
      "incumbentParty": "BJP",
      "result": "BJP (Raje) waived pre-poll and lost; INC waived post-poll on day three",
      "seatChange": "INC 100, BJP 73 (fleet file)",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI results): 2018 Rajasthan Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2018_Rajasthan_Legislative_Assembly_election"
        ],
        [
          "Deccan Herald — Rajasthan 2023: change of guard, end of Gehlot–Raje era",
          "https://www.deccanherald.com/india/rajasthan/rajasthan-2023-change-of-guard-end-of-gehlot-raje-era-2829895"
        ]
      ]
    },
    "status": [
      {
        "date": "2018-02",
        "status": "live",
        "note": "Raje Rs 50,000 cooperative waiver (BJP) — 10 months pre-poll",
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ]
        ]
      },
      {
        "date": "2018-12-19",
        "status": "raised",
        "note": "Gehlot: full cooperative waiver + Rs 2 lakh commercial",
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ]
        ]
      },
      {
        "date": "2021-02",
        "status": "live",
        "note": "Rs 3,200 cr allocated for 2021-22; Gehlot blamed the Centre/banks for the commercial-bank leg (DH 2021 headline, not opened)",
        "srcs": [
          [
            "PRS, Rajasthan Budget Analysis 2021-22",
            "https://prsindia.org/budgets/states/rajasthan-budget-analysis-2021-22"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Cleanest within-state symmetry in the file: the BJP incumbent waived Rs 50,000 ten months before polling and lost; Congress promised more, won, and waived on day three; Congress then lost in 2023 with the scheme live. Two parties, two timings, two losses — timing of a waiver predicts neither outcome here.",
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ],
          [
            "Wikipedia infobox (pointer to ECI): 2023 Rajasthan Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"
          ],
          [
            "Wikipedia infobox (pointer to ECI results): 2018 Rajasthan Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2018_Rajasthan_Legislative_Assembly_election"
          ],
          [
            "Deccan Herald — Rajasthan 2023: change of guard, end of Gehlot–Raje era",
            "https://www.deccanherald.com/india/rajasthan/rajasthan-2023-change-of-guard-end-of-gehlot-raje-era-2829895"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:ashok-gehlot",
        "role": "Chief Minister, Rajasthan",
        "action": "approved",
        "date": "2018-12-19",
        "party": "INC",
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ]
        ]
      },
      {
        "personId": "wel:vasundhara-raje",
        "role": "Chief Minister, Rajasthan",
        "action": "presented budget",
        "date": "2018-02",
        "party": "BJP",
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ]
        ]
      },
      {
        "personId": "wel:sachin-pilot",
        "role": "Deputy Chief Minister, Rajasthan",
        "action": "announced",
        "date": "2018-12-18",
        "party": "INC",
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "Rajasthan cooperative banks",
        "how": "Rs 8,000 cr of cooperative crop loans settled (Rs 8,500 cr under Raje via NCDC)",
        "amountCr": 8000,
        "tier": "documented",
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ]
        ]
      },
      {
        "who": "National Cooperative Development Corporation",
        "how": "Rs 5,000 cr loan to the state to fund Raje's waiver",
        "amountCr": 5000,
        "tier": "documented",
        "srcs": [
          [
            "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
            "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)",
        "https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"
      ],
      [
        "PRS, Rajasthan Budget Analysis 2021-22",
        "https://prsindia.org/budgets/states/rajasthan-budget-analysis-2021-22"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2023 Rajasthan Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2018 Rajasthan Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2018_Rajasthan_Legislative_Assembly_election"
      ],
      [
        "Deccan Herald — Rajasthan 2023: change of guard, end of Gehlot–Raje era",
        "https://www.deccanherald.com/india/rajasthan/rajasthan-2023-change-of-guard-end-of-gehlot-raje-era-2829895"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:rj-grah-laxmi-guarantee-2023",
    "name": "Grah Laxmi Guarantee (Rajasthan INC 2023 promise)",
    "al": [
      "Gruha Lakshmi Guarantee Rajasthan"
    ],
    "level": "state",
    "st": "rj",
    "applicableStates": null,
    "category": "women-cash",
    "party": "INC",
    "announced": {
      "date": "2023-10-25",
      "byPersonId": "wel:ashok-gehlot",
      "office": "Chief Minister, Rajasthan (Jhunjhunu rally)",
      "srcs": [
        [
          "Deccan Herald, 25 Oct 2023: Gehlot promises Rs 10,000/yr to woman head of family",
          "https://www.deccanherald.com/elections/rajasthan/rajasthan-polls-gehlot-promises-rs-10000year-to-woman-head-of-families-lpg-cylinder-at-rs-500-2740998"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": null,
      "srcs": [
        [
          "Deccan Herald, 25 Oct 2023: Gehlot promises Rs 10,000/yr to woman head of family",
          "https://www.deccanherald.com/elections/rajasthan/rajasthan-polls-gehlot-promises-rs-10000year-to-woman-head-of-families-lpg-cylinder-at-rs-500-2740998"
        ]
      ]
    },
    "launched": {
      "date": null,
      "srcs": [
        [
          "Deccan Herald, 25 Oct 2023: Gehlot promises Rs 10,000/yr to woman head of family",
          "https://www.deccanherald.com/elections/rajasthan/rajasthan-polls-gehlot-promises-rs-10000year-to-woman-head-of-families-lpg-cylinder-at-rs-500-2740998"
        ]
      ]
    },
    "benefit": {
      "amount": 10000,
      "unit": "₹ per year (in instalments) to the woman head of family; plus LPG at ₹500 to 1.05 cr families",
      "changes": []
    },
    "eligibility": "Woman head of family (as promised)",
    "beneficiaries": [
      {
        "asOf": "2023-12",
        "count": 0,
        "srcs": [
          [
            "Deccan Herald, 25 Oct 2023: Gehlot promises Rs 10,000/yr to woman head of family",
            "https://www.deccanherald.com/elections/rajasthan/rajasthan-polls-gehlot-promises-rs-10000year-to-woman-head-of-families-lpg-cylinder-at-rs-500-2740998"
          ]
        ]
      }
    ],
    "outlay": [],
    "electionContext": {
      "election": "Rajasthan assembly",
      "date": "2023-11-25",
      "monthsFromLaunch": null,
      "incumbentParty": "INC",
      "result": "incumbent lost",
      "seatChange": "INC 70 (−30); BJP 115",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI results): 2023 Rajasthan Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2023-12-03",
        "status": "discontinued",
        "note": "promise lapsed with the government",
        "srcs": [
          [
            "Wikipedia infobox (pointer to ECI results): 2023 Rajasthan Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "A cash promise one month before polling by an incumbent did not prevent defeat — a Congress counter-example to the MP/MH pattern",
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald, 25 Oct 2023: Gehlot promises Rs 10,000/yr to woman head of family",
            "https://www.deccanherald.com/elections/rajasthan/rajasthan-polls-gehlot-promises-rs-10000year-to-woman-head-of-families-lpg-cylinder-at-rs-500-2740998"
          ],
          [
            "Wikipedia infobox (pointer to ECI results): 2023 Rajasthan Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:ashok-gehlot",
        "role": "Chief Minister",
        "action": "announced",
        "date": "2023-10-25",
        "party": "INC",
        "srcs": [
          [
            "Deccan Herald, 25 Oct 2023: Gehlot promises Rs 10,000/yr to woman head of family",
            "https://www.deccanherald.com/elections/rajasthan/rajasthan-polls-gehlot-promises-rs-10000year-to-woman-head-of-families-lpg-cylinder-at-rs-500-2740998"
          ]
        ]
      }
    ],
    "whoElseBenefits": [],
    "srcs": [
      [
        "Deccan Herald, 25 Oct 2023: Gehlot promises Rs 10,000/yr to woman head of family",
        "https://www.deccanherald.com/elections/rajasthan/rajasthan-polls-gehlot-promises-rs-10000year-to-woman-head-of-families-lpg-cylinder-at-rs-500-2740998"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2023 Rajasthan Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"
      ]
    ],
    "domain": "women-cash"
  },
  {
    "id": "scheme:rj-indira-gandhi-smartphone",
    "name": "Indira Gandhi Smartphone Yojana (Rajasthan)",
    "al": [
      "Rajasthan free mobile yojana"
    ],
    "level": "state",
    "st": "rj",
    "applicableStates": null,
    "category": "consumer-goods",
    "party": "INC",
    "announced": {
      "date": null,
      "byPersonId": "wel:ashok-gehlot",
      "office": "Chief Minister, Rajasthan (Budget 2022-23 promise; date not in opened source)",
      "srcs": [
        [
          "ThePrint (Hindi), 'Indira Gandhi Smartphone Yojana begins in Rajasthan; 40 lakh women in phase 1', 11 Aug 2023",
          "https://hindi.theprint.in/report/indira-gandhi-smartphone-yojana-started-in-rajasthan-40-lakh-women-will-get-smartphones-in-the-first-phase/582752/"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Rajasthan Cabinet",
      "srcs": []
    },
    "launched": {
      "date": "2023-08-10",
      "srcs": [
        [
          "ThePrint (Hindi), 'Indira Gandhi Smartphone Yojana begins in Rajasthan; 40 lakh women in phase 1', 11 Aug 2023",
          "https://hindi.theprint.in/report/indira-gandhi-smartphone-yojana-started-in-rajasthan-40-lakh-women-will-get-smartphones-in-the-first-phase/582752/"
        ]
      ]
    },
    "benefit": {
      "amount": 6800,
      "unit": "₹ per beneficiary by DBT (phone + SIM/data), with 20 GB initial data and 3 years' connectivity",
      "changes": []
    },
    "eligibility": "Women heads of Chiranjeevi families; phase 1: widow/single-woman pensioners, government-school girls of Class 9-12, college students; 40 lakh in phase 1 of 1.35 crore",
    "beneficiaries": [
      {
        "asOf": "2023-08-10",
        "count": 4000000,
        "srcs": [
          [
            "ThePrint (Hindi), 'Indira Gandhi Smartphone Yojana begins in Rajasthan; 40 lakh women in phase 1', 11 Aug 2023",
            "https://hindi.theprint.in/report/indira-gandhi-smartphone-yojana-started-in-rajasthan-40-lakh-women-will-get-smartphones-in-the-first-phase/582752/"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2023-24",
        "budgetedCr": null,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "ThePrint (Hindi), 'Indira Gandhi Smartphone Yojana begins in Rajasthan; 40 lakh women in phase 1', 11 Aug 2023",
            "https://hindi.theprint.in/report/indira-gandhi-smartphone-yojana-started-in-rajasthan-40-lakh-women-will-get-smartphones-in-the-first-phase/582752/"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Rajasthan assembly",
      "date": "2023-11-25",
      "monthsFromLaunch": 3,
      "incumbentParty": "INC",
      "result": "incumbent lost; BJP 115 (+42), INC 70 (−30)",
      "seatChange": "INC −30",
      "srcs": [
        [
          "Wikipedia (pointer), 2023 Rajasthan Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"
        ],
        [
          "ThePrint (Hindi), 'Indira Gandhi Smartphone Yojana begins in Rajasthan; 40 lakh women in phase 1', 11 Aug 2023",
          "https://hindi.theprint.in/report/indira-gandhi-smartphone-yojana-started-in-rajasthan-40-lakh-women-will-get-smartphones-in-the-first-phase/582752/"
        ]
      ]
    },
    "status": [
      {
        "date": "2023-08-10",
        "status": "live",
        "note": "phase 1 via camps",
        "srcs": [
          [
            "ThePrint (Hindi), 'Indira Gandhi Smartphone Yojana begins in Rajasthan; 40 lakh women in phase 1', 11 Aug 2023",
            "https://hindi.theprint.in/report/indira-gandhi-smartphone-yojana-started-in-rajasthan-40-lakh-women-will-get-smartphones-in-the-first-phase/582752/"
          ]
        ]
      },
      {
        "date": "2023-12-15",
        "status": "paused",
        "note": "second phase (80–95 lakh) not delivered before the government changed; post-election status not verified from an opened source (gap)",
        "srcs": [
          [
            "Wikipedia (pointer), 2023 Rajasthan Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Delivery by DBT to an e-wallet redeemed at camps — the state did not itself tender handsets; which telecom operators/OEMs sold at the camps is not in the opened source",
        "tier": "reported",
        "srcs": [
          [
            "ThePrint (Hindi), 'Indira Gandhi Smartphone Yojana begins in Rajasthan; 40 lakh women in phase 1', 11 Aug 2023",
            "https://hindi.theprint.in/report/indira-gandhi-smartphone-yojana-started-in-rajasthan-40-lakh-women-will-get-smartphones-in-the-first-phase/582752/"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:ashok-gehlot",
        "role": "Chief Minister",
        "action": "announced",
        "date": "2023-08-10",
        "party": "INC",
        "srcs": [
          [
            "ThePrint (Hindi), 'Indira Gandhi Smartphone Yojana begins in Rajasthan; 40 lakh women in phase 1', 11 Aug 2023",
            "https://hindi.theprint.in/report/indira-gandhi-smartphone-yojana-started-in-rajasthan-40-lakh-women-will-get-smartphones-in-the-first-phase/582752/"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "Handset OEMs and telecom operators selling at the camps (unnamed)",
        "how": "₹6,800 × 40 lakh ≈ ₹2,720 crore of consumer demand routed through camps in 3 months",
        "amountCr": 2720,
        "tier": "analytic",
        "srcs": [
          [
            "ThePrint (Hindi), 'Indira Gandhi Smartphone Yojana begins in Rajasthan; 40 lakh women in phase 1', 11 Aug 2023",
            "https://hindi.theprint.in/report/indira-gandhi-smartphone-yojana-started-in-rajasthan-40-lakh-women-will-get-smartphones-in-the-first-phase/582752/"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "ThePrint (Hindi), 'Indira Gandhi Smartphone Yojana begins in Rajasthan; 40 lakh women in phase 1', 11 Aug 2023",
        "https://hindi.theprint.in/report/indira-gandhi-smartphone-yojana-started-in-rajasthan-40-lakh-women-will-get-smartphones-in-the-first-phase/582752/"
      ],
      [
        "Wikipedia (pointer), 2023 Rajasthan Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"
      ]
    ],
    "domain": "vendors"
  },
  {
    "id": "scheme:rj-mehangai-rahat-camps",
    "name": "Mehangai Rahat Camps (inflation-relief camps) and Chiranjeevi enhancement",
    "al": [],
    "level": "state",
    "st": "rj",
    "applicableStates": null,
    "category": "energy-subsidy",
    "party": "INC",
    "announced": {
      "date": "2023-04-24",
      "byPersonId": "wel:ashok-gehlot",
      "office": "Chief Minister, Rajasthan",
      "srcs": [
        [
          "The Week — Rajasthan Mehangai Rahat camps",
          "https://www.theweek.in/wire-updates/national/2023/05/09/des56-rj-gehlot-inflation-relief.html"
        ]
      ]
    },
    "approved": null,
    "launched": {
      "date": "2023-04-24",
      "srcs": [
        [
          "The Week — Rajasthan Mehangai Rahat camps",
          "https://www.theweek.in/wire-updates/national/2023/05/09/des56-rj-gehlot-inflation-relief.html"
        ]
      ]
    },
    "benefit": {
      "amount": 500,
      "unit": "₹ subsidised LPG cylinders, plus 100 units free electricity and enrolment in 10 welfare schemes via camp",
      "changes": []
    },
    "eligibility": "registered households via camp attendance",
    "beneficiaries": [
      {
        "asOf": "2023-05-09",
        "count": 30000000,
        "srcs": [
          [
            "The Week — Rajasthan Mehangai Rahat camps",
            "https://www.theweek.in/wire-updates/national/2023/05/09/des56-rj-gehlot-inflation-relief.html"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2023-24",
        "budgetedCr": 19500,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "The Week — Gehlot welfare schemes Rajasthan 2023",
            "https://www.theweek.in/theweek/cover/2023/11/10/ashok-gehlot-welfware-schemes-rajasthan-elections-2023.html"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Rajasthan assembly",
      "date": "2023-11-25",
      "monthsFromLaunch": 7,
      "incumbentParty": "INC",
      "result": "incumbent lost",
      "seatChange": "BJP won, Congress lost — Rajasthan has changed the ruling party in every assembly election since 1993",
      "srcs": [
        [
          "The Week — Rajasthan 2023, change of guard",
          "https://www.deccanherald.com/india/rajasthan/rajasthan-2023-change-of-guard-end-of-gehlot-raje-era-2829895"
        ]
      ]
    },
    "status": [
      {
        "date": "2023-12-15",
        "status": "discontinued",
        "note": "Camps and enhanced Chiranjeevi cover ended with the change of government; the incoming BJP government has run its own welfare branding since.",
        "srcs": []
      }
    ],
    "results": [
      {
        "finding": "A large, statewide, multi-scheme relief push seven months before the poll — inside this file's 6-12-month window — and the incumbent still lost. Rajasthan's structural anti-incumbency (every election since 1993 has changed the ruling party) is the strongest available innocent reading and is large enough on its own to plausibly swamp any scheme-timing effect; this file cannot separate the two with the data it has.",
        "tier": "analytic",
        "srcs": []
      }
    ],
    "ministers": [
      {
        "personId": "wel:ashok-gehlot",
        "role": "Chief Minister, Rajasthan",
        "action": "announced",
        "date": "2023-04-24",
        "party": "INC",
        "srcs": [
          [
            "The Week — Rajasthan Mehangai Rahat camps",
            "https://www.theweek.in/wire-updates/national/2023/05/09/des56-rj-gehlot-inflation-relief.html"
          ]
        ]
      }
    ],
    "whoElseBenefits": [],
    "srcs": [
      [
        "The Week — Rajasthan Mehangai Rahat camps",
        "https://www.theweek.in/wire-updates/national/2023/05/09/des56-rj-gehlot-inflation-relief.html"
      ],
      [
        "The Week — Gehlot welfare schemes Rajasthan 2023",
        "https://www.theweek.in/theweek/cover/2023/11/10/ashok-gehlot-welfware-schemes-rajasthan-elections-2023.html"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:tg-aasara-pensions",
    "name": "Aasara Pensions",
    "al": [
      "Asara",
      "ఆసరా"
    ],
    "level": "state",
    "st": "tg",
    "applicableStates": null,
    "category": "pension",
    "party": "BRS (TRS)",
    "announced": {
      "date": "2014-11-08",
      "byPersonId": "wel:k-chandrashekar-rao",
      "office": "Chief Minister, Telangana",
      "srcs": [
        [
          "Wikipedia (pointer): Aasara pension",
          "https://en.wikipedia.org/wiki/Aasara_pension"
        ],
        [
          "CAG, Performance Audit of DBT scheme 'Aasara Pensions in Telangana' (2021), Chapter III (PDF)",
          "https://cag.gov.in/uploads/download_audit_report/2021/Chapter-III-Implementation-of-Aasara-Pensions-as-a-DBT-Scheme-065cdb90dd72180.15791130.pdf"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Telangana cabinet — date not verified in an opened source",
      "srcs": []
    },
    "launched": {
      "date": "2014-11-08",
      "srcs": [
        [
          "Wikipedia (pointer): Aasara pension",
          "https://en.wikipedia.org/wiki/Aasara_pension"
        ]
      ]
    },
    "benefit": {
      "amount": 1000,
      "unit": "₹ per month (Rs 1,500 disabled)",
      "changes": [
        {
          "date": "2019",
          "amount": 2016,
          "note": "Doubled to Rs 2,016 (Rs 3,016 disabled) in 2019 per Wikipedia pointer; not verified in a primary source opened this session",
          "srcs": [
            [
              "Wikipedia (pointer): Aasara pension",
              "https://en.wikipedia.org/wiki/Aasara_pension"
            ]
          ]
        }
      ]
    },
    "eligibility": "Old aged, widows, disabled, beedi workers, toddy tappers, HIV patients, single women, etc.; households with >3 acres wet or >7.5 acres dry land ineligible (G.O.Ms.27 of 2 May 2017, cited by CAG)",
    "beneficiaries": [
      {
        "asOf": "2018-03",
        "count": 4200000,
        "srcs": [
          [
            "Wikipedia (pointer): Aasara pension",
            "https://en.wikipedia.org/wiki/Aasara_pension"
          ]
        ]
      },
      {
        "asOf": "2021-03",
        "count": null,
        "srcs": [
          [
            "CAG, Performance Audit of DBT scheme 'Aasara Pensions in Telangana' (2021), Chapter III (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2021/Chapter-III-Implementation-of-Aasara-Pensions-as-a-DBT-Scheme-065cdb90dd72180.15791130.pdf"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "annual (Wikipedia pointer)",
        "budgetedCr": 5500,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Wikipedia (pointer): Aasara pension",
            "https://en.wikipedia.org/wiki/Aasara_pension"
          ]
        ]
      },
      {
        "fy": "2023-24",
        "budgetedCr": 2740,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Telangana Budget Analysis 2023-24",
            "https://prsindia.org/budgets/states/telangana-budget-analysis-2023-24"
          ]
        ]
      },
      {
        "fy": "2024-25",
        "budgetedCr": 7376,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Telangana Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/telangana-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Telangana assembly",
      "date": "2018-12-07",
      "monthsFromLaunch": 49,
      "incumbentParty": "TRS (BRS)",
      "result": "incumbent won",
      "seatChange": "+25",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI): 2018 Telangana Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2018_Telangana_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2014-11-08",
        "status": "live",
        "note": "Post-poll launch (state formed 2 Jun 2014)",
        "srcs": [
          [
            "Wikipedia (pointer): Aasara pension",
            "https://en.wikipedia.org/wiki/Aasara_pension"
          ]
        ]
      },
      {
        "date": "2019",
        "status": "raised",
        "note": "Rs 2,016/month (pointer only)",
        "srcs": [
          [
            "Wikipedia (pointer): Aasara pension",
            "https://en.wikipedia.org/wiki/Aasara_pension"
          ]
        ]
      },
      {
        "date": "2021",
        "status": "live",
        "note": "CAG performance audit tabled (audit period 2018-21)",
        "srcs": [
          [
            "CAG, Performance Audit of DBT scheme 'Aasara Pensions in Telangana' (2021), Chapter III (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2021/Chapter-III-Implementation-of-Aasara-Pensions-as-a-DBT-Scheme-065cdb90dd72180.15791130.pdf"
          ]
        ]
      },
      {
        "date": "2024-07",
        "status": "live",
        "note": "Rs 7,376 cr allocated for 2024-25 by the INC government",
        "srcs": [
          [
            "PRS, Telangana Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/telangana-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "CAG performance audit (2021): 16% of households in the Aasara database were ineligible per the Samagra Kutumba Survey and 19% were absent from it; Rs 535.39 cr irregular sanctions (disabled Rs 71.90 cr, beedi workers Rs 446.96 cr, multiple members per household Rs 14.83 cr); Rs 1,175 cr paid to 2.02 lakh beneficiaries already identified for exclusion; Rs 51.98 cr to four-wheeler owners; Rs 31.42 cr to 5,715 persons who registered assets >Rs 10 lakh; Rs 0.90 cr paid against 367 dead beneficiaries; biometric failure for 9% of beneficiaries with payments routed through Panchayat Secretary authentication; 7% of a 480-person survey self-reported ineligibility.",
        "tier": "documented",
        "srcs": [
          [
            "CAG, Performance Audit of DBT scheme 'Aasara Pensions in Telangana' (2021), Chapter III (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2021/Chapter-III-Implementation-of-Aasara-Pensions-as-a-DBT-Scheme-065cdb90dd72180.15791130.pdf"
          ]
        ]
      },
      {
        "finding": "Innocent reading: a universal-style pension launched at state formation with a manual verification layer; leakage rates found by CAG are in the range other Indian pension audits report, and the 2019 doubling coincided with the 2019 Lok Sabha cycle rather than the state poll.",
        "tier": "analytic",
        "srcs": [
          [
            "CAG, Performance Audit of DBT scheme 'Aasara Pensions in Telangana' (2021), Chapter III (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2021/Chapter-III-Implementation-of-Aasara-Pensions-as-a-DBT-Scheme-065cdb90dd72180.15791130.pdf"
          ],
          [
            "Wikipedia (pointer): Aasara pension",
            "https://en.wikipedia.org/wiki/Aasara_pension"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:k-chandrashekar-rao",
        "role": "Chief Minister, Telangana",
        "action": "announced",
        "date": "2014-11-08",
        "party": "BRS",
        "srcs": [
          [
            "Wikipedia (pointer): Aasara pension",
            "https://en.wikipedia.org/wiki/Aasara_pension"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "Panchayat Secretaries / Bill Collectors (cash disbursement chain)",
        "how": "payments made on their biometric authentication where beneficiary BFD failed; acquittance registers not maintained in test-checked units (CAG)",
        "amountCr": 58.33,
        "tier": "documented",
        "srcs": [
          [
            "CAG, Performance Audit of DBT scheme 'Aasara Pensions in Telangana' (2021), Chapter III (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2021/Chapter-III-Implementation-of-Aasara-Pensions-as-a-DBT-Scheme-065cdb90dd72180.15791130.pdf"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Wikipedia (pointer): Aasara pension",
        "https://en.wikipedia.org/wiki/Aasara_pension"
      ],
      [
        "CAG, Performance Audit of DBT scheme 'Aasara Pensions in Telangana' (2021), Chapter III (PDF)",
        "https://cag.gov.in/uploads/download_audit_report/2021/Chapter-III-Implementation-of-Aasara-Pensions-as-a-DBT-Scheme-065cdb90dd72180.15791130.pdf"
      ],
      [
        "PRS, Telangana Budget Analysis 2023-24",
        "https://prsindia.org/budgets/states/telangana-budget-analysis-2023-24"
      ],
      [
        "PRS, Telangana Budget Analysis 2024-25",
        "https://prsindia.org/budgets/states/telangana-budget-analysis-2024-25"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2018 Telangana Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2018_Telangana_Legislative_Assembly_election"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2023 Telangana Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:tg-crop-loan-waiver-2024",
    "name": "Telangana crop loan waiver 2024 (Rythu Runa Mafi, up to ₹2 lakh)",
    "al": [
      "Runa Mafi",
      "రుణమాఫీ"
    ],
    "level": "state",
    "st": "tg",
    "applicableStates": null,
    "category": "loan-waiver",
    "party": "INC",
    "announced": {
      "date": "2023-11",
      "byPersonId": "wel:revanth-reddy",
      "office": "Congress campaign promise (Revanth Reddy became CM 7 Dec 2023)",
      "srcs": [
        [
          "News On Air (AIR), 17 Jul 2024: Telangana to implement crop loan waiver from tomorrow",
          "https://www.newsonair.gov.in/telangana-to-implement-crop-loan-waiver-from-tomorrow-onwards"
        ]
      ]
    },
    "approved": {
      "date": "2024-07",
      "body": "Telangana government orders; phase 1 (≤Rs 1 lakh) 18 Jul 2024, phase 2 (≤Rs 1.5 lakh) July, ≤Rs 2 lakh by 15 Aug 2024",
      "srcs": [
        [
          "News On Air (AIR), 17 Jul 2024: Telangana to implement crop loan waiver from tomorrow",
          "https://www.newsonair.gov.in/telangana-to-implement-crop-loan-waiver-from-tomorrow-onwards"
        ],
        [
          "News On Air (AIR), 18 Jul 2024: Over Rs 6,000 cr released towards crop loan waiver; 11 lakh farmers in phase 1",
          "https://www.newsonair.gov.in/telangana-over-rs-6000-cr-released-by-state-govt-towards-crop-loan-waiver/"
        ]
      ]
    },
    "launched": {
      "date": "2024-07-18",
      "srcs": [
        [
          "News On Air (AIR), 18 Jul 2024: Over Rs 6,000 cr released towards crop loan waiver; 11 lakh farmers in phase 1",
          "https://www.newsonair.gov.in/telangana-over-rs-6000-cr-released-by-state-govt-towards-crop-loan-waiver/"
        ]
      ]
    },
    "benefit": {
      "amount": 200000,
      "unit": "₹ maximum waiver per farmer family (principal + interest), short-term crop loans",
      "changes": []
    },
    "eligibility": "Short-term crop loans up to Rs 2 lakh per farmer family; family defined via the food-security (ration) card — opposition said many farmers would be excluded by the conditions",
    "beneficiaries": [
      {
        "asOf": "2024-07-18",
        "count": 1100000,
        "srcs": [
          [
            "News On Air (AIR), 18 Jul 2024: Over Rs 6,000 cr released towards crop loan waiver; 11 lakh farmers in phase 1",
            "https://www.newsonair.gov.in/telangana-over-rs-6000-cr-released-by-state-govt-towards-crop-loan-waiver/"
          ]
        ]
      },
      {
        "asOf": "2024-08",
        "count": 4000000,
        "srcs": [
          [
            "News On Air (AIR), 18 Jul 2024: Over Rs 6,000 cr released towards crop loan waiver; 11 lakh farmers in phase 1",
            "https://www.newsonair.gov.in/telangana-over-rs-6000-cr-released-by-state-govt-towards-crop-loan-waiver/"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2024-25",
        "budgetedCr": 15470,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Telangana Budget Analysis 2024-25",
            "https://prsindia.org/budgets/states/telangana-budget-analysis-2024-25"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Telangana assembly (previous — the promise)",
      "date": "2023-11-30",
      "monthsFromLaunch": -8,
      "incumbentParty": "BRS",
      "result": "challenger (INC) won; waiver delivered 7.5 months after taking office",
      "seatChange": "INC +45",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI): 2023 Telangana Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2024-07-18",
        "status": "live",
        "note": "Phase 1 paid",
        "srcs": [
          [
            "News On Air (AIR), 18 Jul 2024: Over Rs 6,000 cr released towards crop loan waiver; 11 lakh farmers in phase 1",
            "https://www.newsonair.gov.in/telangana-over-rs-6000-cr-released-by-state-govt-towards-crop-loan-waiver/"
          ]
        ]
      },
      {
        "date": "2024-08",
        "status": "live",
        "note": "Phases 2–3 (≤Rs 2 lakh) scheduled by 15 Aug 2024; completion and final cost not verified in an opened source",
        "srcs": [
          [
            "News On Air (AIR), 17 Jul 2024: Telangana to implement crop loan waiver from tomorrow",
            "https://www.newsonair.gov.in/telangana-to-implement-crop-loan-waiver-from-tomorrow-onwards"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Post-poll delivery of a manifesto promise, structurally identical to the Dec 2018 Congress waivers in MP/CT/RJ and the BJP's UP 2017 waiver. Innocent reading: honouring a campaign pledge. Skeptical reading: ration-card gating and phased ceilings trimmed the promised universe (opposition claim in AIR report).",
        "tier": "analytic",
        "srcs": [
          [
            "News On Air (AIR), 17 Jul 2024: Telangana to implement crop loan waiver from tomorrow",
            "https://www.newsonair.gov.in/telangana-to-implement-crop-loan-waiver-from-tomorrow-onwards"
          ],
          [
            "News On Air (AIR), 18 Jul 2024: Over Rs 6,000 cr released towards crop loan waiver; 11 lakh farmers in phase 1",
            "https://www.newsonair.gov.in/telangana-over-rs-6000-cr-released-by-state-govt-towards-crop-loan-waiver/"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:revanth-reddy",
        "role": "Chief Minister, Telangana",
        "action": "announced",
        "date": "2024-07-17",
        "party": "INC",
        "srcs": [
          [
            "News On Air (AIR), 17 Jul 2024: Telangana to implement crop loan waiver from tomorrow",
            "https://www.newsonair.gov.in/telangana-to-implement-crop-loan-waiver-from-tomorrow-onwards"
          ]
        ]
      },
      {
        "personId": "wel:mallu-bhatti-vikramarka",
        "role": "Deputy CM and Finance Minister, Telangana",
        "action": "administers",
        "date": "2024-07-18",
        "party": "INC",
        "srcs": [
          [
            "News On Air (AIR), 18 Jul 2024: Over Rs 6,000 cr released towards crop loan waiver; 11 lakh farmers in phase 1",
            "https://www.newsonair.gov.in/telangana-over-rs-6000-cr-released-by-state-govt-towards-crop-loan-waiver/"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "scheduled, rural and district cooperative banks",
        "how": "state pays off overdue crop-loan books; RBI IWG (2019) found only ~66% of waivers announced since 2014 had reached banks",
        "amountCr": null,
        "tier": "documented",
        "srcs": [
          [
            "PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)",
            "https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"
          ],
          [
            "News On Air (AIR), 18 Jul 2024: Over Rs 6,000 cr released towards crop loan waiver; 11 lakh farmers in phase 1",
            "https://www.newsonair.gov.in/telangana-over-rs-6000-cr-released-by-state-govt-towards-crop-loan-waiver/"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "News On Air (AIR), 17 Jul 2024: Telangana to implement crop loan waiver from tomorrow",
        "https://www.newsonair.gov.in/telangana-to-implement-crop-loan-waiver-from-tomorrow-onwards"
      ],
      [
        "News On Air (AIR), 18 Jul 2024: Over Rs 6,000 cr released towards crop loan waiver; 11 lakh farmers in phase 1",
        "https://www.newsonair.gov.in/telangana-over-rs-6000-cr-released-by-state-govt-towards-crop-loan-waiver/"
      ],
      [
        "PRS, Telangana Budget Analysis 2024-25",
        "https://prsindia.org/budgets/states/telangana-budget-analysis-2024-25"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2023 Telangana Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:tg-mahalakshmi",
    "name": "Mahalakshmi Guarantee (Telangana Congress)",
    "al": [],
    "level": "state",
    "st": "tg",
    "applicableStates": null,
    "category": "women-cash",
    "party": "INC",
    "announced": {
      "date": "2023-09-18",
      "byPersonId": "wel:revanth-reddy",
      "office": "Telangana Pradesh Congress Committee President (pre-CM)",
      "srcs": [
        [
          "INC — Mahalakshmi guarantee announcement",
          "https://x.com/INCIndia/status/1703402712027549699"
        ]
      ]
    },
    "approved": null,
    "launched": null,
    "benefit": {
      "amount": 2500,
      "unit": "₹ per month promised to women (cash component never disbursed)",
      "changes": []
    },
    "eligibility": "women, income criteria (as promised in manifesto)",
    "beneficiaries": [],
    "outlay": [],
    "electionContext": {
      "election": "Telangana assembly",
      "date": "2023-11-30",
      "monthsFromLaunch": null,
      "incumbentParty": "BRS",
      "result": "incumbent lost (Congress, which promised the scheme, won)",
      "seatChange": "Congress 64/119, BRS 39/119 (down from 88 in 2018)",
      "srcs": [
        [
          "The News Minute — BRS losses, Congress gains, Telangana 2023",
          "https://www.thenewsminute.com/telangana/brs-losses-congress-gains-how-telangana-voted-in-2023"
        ]
      ]
    },
    "status": [
      {
        "date": "2025-01-01",
        "status": "promised-not-enacted",
        "note": "The ₹2,500/month cash component of the Mahalakshmi guarantee has not been launched, cited by the Revanth Reddy government as a fiscal-space constraint; the free-bus-travel and ₹500 LPG-refill components of the same guarantee were implemented.",
        "srcs": [
          [
            "The South First — Mahalakshmi fact-check",
            "https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Congress won the election the promise was made for, then did not deliver the cash element of that promise more than a year later — a documented broken-promise case that this file records as loudly as any launch.",
        "tier": "reported",
        "srcs": [
          [
            "The South First — Mahalakshmi fact-check",
            "https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:revanth-reddy",
        "role": "Chief Minister, Telangana",
        "action": "opposed",
        "date": "2025-01-01",
        "party": "INC",
        "srcs": []
      }
    ],
    "whoElseBenefits": [],
    "srcs": [
      [
        "INC — Mahalakshmi guarantee announcement",
        "https://x.com/INCIndia/status/1703402712027549699"
      ],
      [
        "The South First — Mahalakshmi fact-check",
        "https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:tg-mahalakshmi-cash",
    "name": "Mahalakshmi — ₹2,500 monthly cash component (Telangana)",
    "al": [
      "Mahalakshmi scheme"
    ],
    "level": "state",
    "st": "tg",
    "applicableStates": null,
    "category": "women-cash",
    "party": "INC",
    "announced": {
      "date": "2023",
      "byPersonId": "wel:revanth-reddy",
      "office": "TPCC president (INC six guarantees for the 30 Nov 2023 election)",
      "srcs": [
        [
          "The South First, 8 Jan 2025: fact check — Rs 2,500 Mahalakshmi not paid",
          "https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": null,
      "srcs": [
        [
          "The South First, 8 Jan 2025: fact check — Rs 2,500 Mahalakshmi not paid",
          "https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"
        ]
      ]
    },
    "launched": {
      "date": null,
      "srcs": [
        [
          "The South First, 8 Jan 2025: fact check — Rs 2,500 Mahalakshmi not paid",
          "https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"
        ]
      ]
    },
    "benefit": {
      "amount": 2500,
      "unit": "₹ per month (promised)",
      "changes": []
    },
    "eligibility": "Not notified",
    "beneficiaries": [
      {
        "asOf": "2025-01",
        "count": 0,
        "srcs": [
          [
            "The South First, 8 Jan 2025: fact check — Rs 2,500 Mahalakshmi not paid",
            "https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2024-25",
        "budgetedCr": null,
        "actualCr": 0,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "The South First, 8 Jan 2025: fact check — Rs 2,500 Mahalakshmi not paid",
            "https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Telangana assembly",
      "date": "2023-11-30",
      "monthsFromLaunch": null,
      "incumbentParty": "BRS",
      "result": "challenger (INC) won; cash promise unpaid 2.5+ years later",
      "seatChange": "INC 64 (+45)",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI results): 2023 Telangana Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2025-01-08",
        "status": "promised-not-enacted",
        "note": null,
        "srcs": [
          [
            "The South First, 8 Jan 2025: fact check — Rs 2,500 Mahalakshmi not paid",
            "https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"
          ]
        ]
      },
      {
        "date": "2026-06",
        "status": "promised-not-enacted",
        "note": "Search snippet reports women's protests in Jun 2026 over the unpaid Rs 2,500 (ntnews, not opened) — unverified",
        "srcs": [
          [
            "The South First, 8 Jan 2025: fact check — Rs 2,500 Mahalakshmi not paid",
            "https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Congress spokesperson claimed on national TV that 90 lakh women receive Rs 2,500; fact check found zero recipients; KTR (BRS) challenged the government to name one",
        "tier": "reported",
        "srcs": [
          [
            "The South First, 8 Jan 2025: fact check — Rs 2,500 Mahalakshmi not paid",
            "https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:revanth-reddy",
        "role": "Chief Minister",
        "action": "announced",
        "date": "2023",
        "party": "INC",
        "srcs": [
          [
            "The South First, 8 Jan 2025: fact check — Rs 2,500 Mahalakshmi not paid",
            "https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"
          ]
        ]
      }
    ],
    "whoElseBenefits": [],
    "srcs": [
      [
        "The South First, 8 Jan 2025: fact check — Rs 2,500 Mahalakshmi not paid",
        "https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2023 Telangana Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"
      ]
    ],
    "domain": "women-cash"
  },
  {
    "id": "scheme:tg-rythu-bandhu",
    "name": "Rythu Bandhu (Farmer's Investment Support Scheme)",
    "al": [
      "FISS",
      "Farmer Investment Support Scheme",
      "రైతు బంధు",
      "Rythu Bharosa (2025 rename)"
    ],
    "level": "state",
    "st": "tg",
    "applicableStates": null,
    "category": "farmer-cash",
    "party": "BRS",
    "announced": {
      "date": "2018-02-25",
      "byPersonId": "wel:k-chandrashekar-rao",
      "office": "Chief Minister, Telangana",
      "srcs": [
        [
          "Wikipedia — Rythu Bandhu scheme",
          "https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"
        ]
      ]
    },
    "approved": {
      "date": "2018-03",
      "body": "Telangana budget 2018-19 (Rs 12,000 cr allocation); cabinet decision date not verified in an opened source",
      "srcs": [
        [
          "PRS, Telangana Budget Analysis 2018-19",
          "https://prsindia.org/budgets/states/telangana-budget-analysis-2018-19"
        ]
      ]
    },
    "launched": {
      "date": "2018-05-10",
      "srcs": [
        [
          "Wikipedia — Rythu Bandhu scheme",
          "https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"
        ]
      ]
    },
    "benefit": {
      "amount": 10000,
      "unit": "₹ per acre per year (₹5,000/acre per season, uncapped)",
      "changes": [
        {
          "date": null,
          "amount": 5000,
          "note": "TOI (Jan 2021) describes ₹5,000 per acre per season",
          "srcs": [
            [
              "Times of India, 2 Jan 2021: 'Most of 13,000 rich farmers in Telangana still get Rythu Bandhu aid'",
              "https://timesofindia.indiatimes.com/city/hyderabad/most-of-13000-rich-farmers-in-t-still-get-rythu-bandhu-aid/articleshow/80066258.cms"
            ]
          ]
        },
        {
          "date": "2019-06",
          "amount": 10000,
          "note": "Raised to Rs 5,000/acre/season from Kharif 2019 — the 2019-20 budget nevertheless provided Rs 9,056 cr against the ~Rs 15,000 cr implied (IGIDR: shortfall unexplained)",
          "srcs": [
            [
              "Thomas, Uday & Zaveri (IGIDR/IFROGS), 'Linking welfare distribution to land records: a case-study of the Rythu Bandhu Scheme', TR-2020-4-27 (PDF)",
              "https://ifrogs.org/PDF/rbs_report.pdf"
            ],
            [
              "Wikipedia (pointer): Rythu Bandhu scheme",
              "https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"
            ]
          ]
        },
        {
          "date": "2025-01-26",
          "amount": 12000,
          "note": "Rs 12,000/acre/year as Rythu Bharosa under the Congress government (cabinet 4 Jan 2025; launch 26 Jan 2025); non-agricultural land excluded; Congress had promised Rs 15,000/acre before the 2023 poll",
          "srcs": [
            [
              "ANI, 5 Jan 2025: Telangana farmers to receive Rs 12,000 per acre annually under Rythu Bharosa",
              "https://www.aninews.in/news/national/general-news/telangana-farmers-to-receive-rs-12000-per-acre-annually-under-rythu-bharosa-scheme20250105033356/"
            ],
            [
              "Deccan Herald/PTI, 21 Dec 2024: Rythu Bandhu Rs 22,600 cr given to ineligible people in BRS regime, says Telangana CM",
              "https://www.deccanherald.com/india/telangana/rythu-bandhu-rs-22600-crore-given-to-ineligible-people-in-brs-regime-says-telangana-cm-3328152"
            ]
          ]
        }
      ]
    },
    "eligibility": "all landholding farmers, no acreage cap",
    "beneficiaries": [
      {
        "asOf": "2021",
        "count": 5833000,
        "srcs": [
          [
            "Wikipedia (pointer): Rythu Bandhu scheme",
            "https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2018-19",
        "budgetedCr": 12000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Wikipedia — Rythu Bandhu scheme",
            "https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"
          ]
        ]
      },
      {
        "fy": "2018-19",
        "budgetedCr": 12000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Business Standard/ANI, 26 Feb 2018: 'KCR govt to allocate Rs 12,000 cr for crop investment support'",
            "http://www.business-standard.com/article/news-ani/kcr-govt-to-allocate-rs-12-000-cr-for-crop-investment-support-118022600048_1.html"
          ]
        ]
      },
      {
        "fy": "2018-19",
        "budgetedCr": 12000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Telangana Budget Analysis 2018-19",
            "https://prsindia.org/budgets/states/telangana-budget-analysis-2018-19"
          ],
          [
            "Business Standard/ANI, 26 Feb 2018: KCR govt to allocate Rs 12,000 cr for crop investment support",
            "https://www.business-standard.com/article/news-ani/kcr-govt-to-allocate-rs-12-000-cr-for-crop-investment-support-118022600048_1.html"
          ]
        ]
      },
      {
        "fy": "2019-20",
        "budgetedCr": 9056,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Thomas, Uday & Zaveri (IGIDR/IFROGS), 'Linking welfare distribution to land records: a case-study of the Rythu Bandhu Scheme', TR-2020-4-27 (PDF)",
            "https://ifrogs.org/PDF/rbs_report.pdf"
          ]
        ]
      },
      {
        "fy": "2021-22",
        "budgetedCr": 14800,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Wikipedia (pointer): Rythu Bandhu scheme",
            "https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"
          ]
        ]
      },
      {
        "fy": "2023-24",
        "budgetedCr": 11704,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Telangana Budget Analysis 2023-24",
            "https://prsindia.org/budgets/states/telangana-budget-analysis-2023-24"
          ]
        ]
      },
      {
        "fy": "2018-24 cumulative",
        "budgetedCr": null,
        "actualCr": 72816,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Deccan Herald/PTI, 21 Dec 2024: Rythu Bandhu Rs 22,600 cr given to ineligible people in BRS regime, says Telangana CM",
            "https://www.deccanherald.com/india/telangana/rythu-bandhu-rs-22600-crore-given-to-ineligible-people-in-brs-regime-says-telangana-cm-3328152"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Telangana assembly",
      "date": "2018-12-07",
      "monthsFromLaunch": 7,
      "incumbentParty": "BRS (TRS)",
      "result": "incumbent won",
      "seatChange": null,
      "srcs": []
    },
    "status": [
      {
        "date": "2023-11-30",
        "status": "live",
        "note": "Continued through the 2023 election, which BRS still lost — see results.",
        "srcs": []
      },
      {
        "date": "2018-05-10",
        "status": "live",
        "note": "Launched by cheque before the Dec 2018 poll",
        "srcs": [
          [
            "Wikipedia (pointer): Rythu Bandhu scheme",
            "https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"
          ]
        ]
      },
      {
        "date": "2019-06",
        "status": "raised",
        "note": "Rs 5,000/acre/season",
        "srcs": [
          [
            "Thomas, Uday & Zaveri (IGIDR/IFROGS), 'Linking welfare distribution to land records: a case-study of the Rythu Bandhu Scheme', TR-2020-4-27 (PDF)",
            "https://ifrogs.org/PDF/rbs_report.pdf"
          ]
        ]
      },
      {
        "date": "2023-11-30",
        "status": "live",
        "note": "Ran through the 2023 election which BRS lost",
        "srcs": [
          [
            "Wikipedia infobox (pointer to ECI): 2023 Telangana Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"
          ]
        ]
      },
      {
        "date": "2024-12-21",
        "status": "eligibility-tightened",
        "note": "CM Revanth Reddy: Rs 22,600 cr of Rs 72,816 cr went to non-cultivated land (hillocks, roads, mining, crushers); scheme to be renamed Rythu Bharosa from Sankranti 2025",
        "srcs": [
          [
            "Deccan Herald/PTI, 21 Dec 2024: Rythu Bandhu Rs 22,600 cr given to ineligible people in BRS regime, says Telangana CM",
            "https://www.deccanherald.com/india/telangana/rythu-bandhu-rs-22600-crore-given-to-ineligible-people-in-brs-regime-says-telangana-cm-3328152"
          ]
        ]
      },
      {
        "date": "2025-01-26",
        "status": "renamed",
        "note": "Rythu Bharosa, Rs 12,000/acre/yr, non-agricultural land excluded — supersession, the BRS-era scheme is retained here as the same instrument",
        "srcs": [
          [
            "ANI, 5 Jan 2025: Telangana farmers to receive Rs 12,000 per acre annually under Rythu Bharosa",
            "https://www.aninews.in/news/national/general-news/telangana-farmers-to-receive-rs-12000-per-acre-annually-under-rythu-bharosa-scheme20250105033356/"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Rythu Bandhu ran uninterrupted through both the 2018 election (BRS won) and the 2023 election (BRS lost); its uncapped-per-acre design has been widely criticised in press commentary as favouring large landholders over tenant/landless farmers, though this file could not pin that critique to a specific fetched source this session, so it is recorded as analytic rather than documented/reported.",
        "tier": "analytic",
        "srcs": []
      },
      {
        "finding": "A scheme continuing unchanged cannot, on its own, explain opposite outcomes in two different elections — the innocent/necessary-but-not-sufficient reading is that Rythu Bandhu's presence was necessary for BRS's 2018 coalition but insufficient against 2023 anti-incumbency, corruption allegations and Congress's competing guarantees.",
        "tier": "analytic",
        "srcs": []
      },
      {
        "finding": "Inclusion error at the top: state estimates (TOI, Jan 2021) show ~13,000 farmers with 20–40 acres owning >3.19 lakh acres, eligible without cap; only 743 people returned money (up to ₹95 lakh) under the 'give it up' option; one season for large holders ≈ ₹150 cr. Principal Secretary (Agriculture) said payments 'depend on the financial condition of the state'.",
        "tier": "reported",
        "srcs": [
          [
            "Times of India, 2 Jan 2021: 'Most of 13,000 rich farmers in Telangana still get Rythu Bandhu aid'",
            "https://timesofindia.indiatimes.com/city/hyderabad/most-of-13000-rich-farmers-in-t-still-get-rythu-bandhu-aid/articleshow/80066258.cms"
          ]
        ]
      },
      {
        "finding": "Telangana declared the largest off-budget borrowings of any state in 2021-22 — ₹35,258 cr, 53% of the 19-state total of ₹67,075 cr — falling to ₹2,697 cr by 2024-25; its outstanding guarantees were 15.1% of GSDP (Mar 2024), the highest ratio in India, with irrigation 37% of guarantees. The PRS table does not attribute any of this borrowing to Rythu Bandhu.",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "A J-PAL-linked survey of the scheme was reported in 2019 (Wikipedia pointer to an archived Namasthe Telangana article); the archive copy could not be retrieved (connection reset), so no finding is recorded.",
        "tier": "analytic",
        "srcs": [
          [
            "Wikipedia, 'Rythu Bandhu scheme' (pointer only; oldid 1359986913)",
            "https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"
          ]
        ]
      },
      {
        "finding": "IGIDR/IFROGS field study (2020): the scheme relies wholly on the 2017-18 land-record purification and pattadar passbooks; tenant and landless farmers are excluded by design; the entitlement covers ~10% of a small/marginal farmer's annual expenditure and ~6% of a medium/large farmer's; the 2019-20 budget provision (Rs 9,056 cr) fell short of the raised entitlement with no explanation, matching higher reported non-receipt for Rabi 2019; no grievance-redress forum.",
        "tier": "documented",
        "srcs": [
          [
            "Thomas, Uday & Zaveri (IGIDR/IFROGS), 'Linking welfare distribution to land records: a case-study of the Rythu Bandhu Scheme', TR-2020-4-27 (PDF)",
            "https://ifrogs.org/PDF/rbs_report.pdf"
          ]
        ]
      },
      {
        "finding": "CAG (2021) cross-matched Rythu Bandhu land data (2018-20) with Aasara pension rolls: 12,152 pensioners from households holding >7.5 acres drew Rs 67.41 cr in undue pension; a further 2.04 lakh pensioners from 3–7.5 acre households drew Rs 1,150.71 cr whose eligibility could not be settled because wet/dry categorisation was missing — evidence that the Rythu Bandhu land base was usable for cross-checks that the state did not run.",
        "tier": "documented",
        "srcs": [
          [
            "CAG, Performance Audit of DBT scheme 'Aasara Pensions in Telangana' (2021), Chapter III (PDF)",
            "https://cag.gov.in/uploads/download_audit_report/2021/Chapter-III-Implementation-of-Aasara-Pensions-as-a-DBT-Scheme-065cdb90dd72180.15791130.pdf"
          ]
        ]
      },
      {
        "finding": "CM Revanth Reddy (INC) told the Assembly on 21 Dec 2024 that an estimated Rs 22,600 cr of the Rs 72,816 cr paid under BRS went to land not under cultivation. This is a government estimate stated by a political opponent of the scheme's authors; no audit report with this figure was opened. BRS working president K T Rama Rao replied that the Congress government was trying to evade implementing the scheme.",
        "tier": "alleged",
        "srcs": [
          [
            "Deccan Herald/PTI, 21 Dec 2024: Rythu Bandhu Rs 22,600 cr given to ineligible people in BRS regime, says Telangana CM",
            "https://www.deccanherald.com/india/telangana/rythu-bandhu-rs-22600-crore-given-to-ineligible-people-in-brs-regime-says-telangana-cm-3328152"
          ]
        ]
      },
      {
        "finding": "Per-acre, uncapped design pays most to the largest landowners and nothing to tenants (IGIDR). Innocent reading: an input-support scheme keyed to land records is administratively simple and was delivered to 58 lakh farmers twice a year with low leakage relative to in-kind input subsidies.",
        "tier": "analytic",
        "srcs": [
          [
            "Thomas, Uday & Zaveri (IGIDR/IFROGS), 'Linking welfare distribution to land records: a case-study of the Rythu Bandhu Scheme', TR-2020-4-27 (PDF)",
            "https://ifrogs.org/PDF/rbs_report.pdf"
          ],
          [
            "Wikipedia (pointer): Rythu Bandhu scheme",
            "https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:k-chandrashekar-rao",
        "role": "Chief Minister, Telangana",
        "action": "announced",
        "date": "2018-02-25",
        "party": "BRS",
        "srcs": [
          [
            "Wikipedia — Rythu Bandhu scheme",
            "https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"
          ]
        ]
      },
      {
        "personId": "wel:k-chandrashekar-rao",
        "role": "Chief Minister, Telangana",
        "action": "announced",
        "date": "2018-02-25",
        "party": "BRS (then TRS)",
        "srcs": [
          [
            "Business Standard/ANI, 26 Feb 2018: 'KCR govt to allocate Rs 12,000 cr for crop investment support'",
            "http://www.business-standard.com/article/news-ani/kcr-govt-to-allocate-rs-12-000-cr-for-crop-investment-support-118022600048_1.html"
          ]
        ]
      },
      {
        "personId": "wel:k-chandrashekar-rao",
        "role": "Chief Minister, Telangana",
        "action": "announced",
        "date": "2018-02-25",
        "party": "BRS",
        "srcs": [
          [
            "Business Standard/ANI, 26 Feb 2018: KCR govt to allocate Rs 12,000 cr for crop investment support",
            "https://www.business-standard.com/article/news-ani/kcr-govt-to-allocate-rs-12-000-cr-for-crop-investment-support-118022600048_1.html"
          ]
        ]
      },
      {
        "personId": "wel:revanth-reddy",
        "role": "Chief Minister, Telangana",
        "action": "approved",
        "date": "2025-01-04",
        "party": "INC",
        "srcs": [
          [
            "ANI, 5 Jan 2025: Telangana farmers to receive Rs 12,000 per acre annually under Rythu Bharosa",
            "https://www.aninews.in/news/national/general-news/telangana-farmers-to-receive-rs-12000-per-acre-annually-under-rythu-bharosa-scheme20250105033356/"
          ]
        ]
      },
      {
        "personId": "wel:tummala-nageswara-rao",
        "role": "Agriculture Minister, Telangana",
        "action": "administers",
        "date": "2024-12-21",
        "party": "INC",
        "srcs": [
          [
            "Deccan Herald/PTI, 21 Dec 2024: Rythu Bandhu Rs 22,600 cr given to ineligible people in BRS regime, says Telangana CM",
            "https://www.deccanherald.com/india/telangana/rythu-bandhu-rs-22600-crore-given-to-ineligible-people-in-brs-regime-says-telangana-cm-3328152"
          ]
        ]
      },
      {
        "personId": "wel:kt-rama-rao",
        "role": "BRS working president; former minister",
        "action": "opposed",
        "date": "2024-12-21",
        "party": "BRS",
        "srcs": [
          [
            "Deccan Herald/PTI, 21 Dec 2024: Rythu Bandhu Rs 22,600 cr given to ineligible people in BRS regime, says Telangana CM",
            "https://www.deccanherald.com/india/telangana/rythu-bandhu-rs-22600-crore-given-to-ineligible-people-in-brs-regime-says-telangana-cm-3328152"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "large landholding farmers",
        "how": "uncapped per-acre design disproportionately benefits owners of more land relative to tenant/landless farmers",
        "amountCr": null,
        "tier": "reported",
        "srcs": []
      },
      {
        "who": "large landowners (20–40 acre holders, ~13,000 per state estimate)",
        "how": "uncapped per-acre transfer to titled owners; tenants excluded",
        "amountCr": 150,
        "tier": "reported",
        "srcs": [
          [
            "Times of India, 2 Jan 2021: 'Most of 13,000 rich farmers in Telangana still get Rythu Bandhu aid'",
            "https://timesofindia.indiatimes.com/city/hyderabad/most-of-13000-rich-farmers-in-t-still-get-rythu-bandhu-aid/articleshow/80066258.cms"
          ]
        ]
      },
      {
        "who": "large landowners (per-acre, uncapped)",
        "how": "entitlement scales with acreage; owners of non-cultivated or converted land were paid until the 2025 exclusion",
        "amountCr": 22600,
        "tier": "alleged",
        "srcs": [
          [
            "Deccan Herald/PTI, 21 Dec 2024: Rythu Bandhu Rs 22,600 cr given to ineligible people in BRS regime, says Telangana CM",
            "https://www.deccanherald.com/india/telangana/rythu-bandhu-rs-22600-crore-given-to-ineligible-people-in-brs-regime-says-telangana-cm-3328152"
          ],
          [
            "Thomas, Uday & Zaveri (IGIDR/IFROGS), 'Linking welfare distribution to land records: a case-study of the Rythu Bandhu Scheme', TR-2020-4-27 (PDF)",
            "https://ifrogs.org/PDF/rbs_report.pdf"
          ]
        ]
      },
      {
        "who": "banks (cheque clearing, then DBT)",
        "how": "Rs 1–2 cr per district and Rs 40–60 cr for passbook printing out of a Rs 100 cr LRUP budget; cheque-printing and bank service charges in 2018-19 (IGIDR Table 26)",
        "amountCr": null,
        "tier": "documented",
        "srcs": [
          [
            "Thomas, Uday & Zaveri (IGIDR/IFROGS), 'Linking welfare distribution to land records: a case-study of the Rythu Bandhu Scheme', TR-2020-4-27 (PDF)",
            "https://ifrogs.org/PDF/rbs_report.pdf"
          ]
        ]
      },
      {
        "who": "party:brs",
        "how": "flagship of the 2018 campaign; first-in-India direct farmer support claimed by KCR",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "Business Standard/ANI, 26 Feb 2018: KCR govt to allocate Rs 12,000 cr for crop investment support",
            "https://www.business-standard.com/article/news-ani/kcr-govt-to-allocate-rs-12-000-cr-for-crop-investment-support-118022600048_1.html"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Wikipedia — Rythu Bandhu scheme",
        "https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"
      ],
      [
        "Business Standard/ANI, 26 Feb 2018: 'KCR govt to allocate Rs 12,000 cr for crop investment support'",
        "http://www.business-standard.com/article/news-ani/kcr-govt-to-allocate-rs-12-000-cr-for-crop-investment-support-118022600048_1.html"
      ],
      [
        "Times of India, 2 Jan 2021: 'Most of 13,000 rich farmers in Telangana still get Rythu Bandhu aid'",
        "https://timesofindia.indiatimes.com/city/hyderabad/most-of-13000-rich-farmers-in-t-still-get-rythu-bandhu-aid/articleshow/80066258.cms"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "Business Standard/ANI, 26 Feb 2018: KCR govt to allocate Rs 12,000 cr for crop investment support",
        "https://www.business-standard.com/article/news-ani/kcr-govt-to-allocate-rs-12-000-cr-for-crop-investment-support-118022600048_1.html"
      ],
      [
        "PRS, Telangana Budget Analysis 2018-19",
        "https://prsindia.org/budgets/states/telangana-budget-analysis-2018-19"
      ],
      [
        "Wikipedia (pointer): Rythu Bandhu scheme",
        "https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"
      ],
      [
        "Thomas, Uday & Zaveri (IGIDR/IFROGS), 'Linking welfare distribution to land records: a case-study of the Rythu Bandhu Scheme', TR-2020-4-27 (PDF)",
        "https://ifrogs.org/PDF/rbs_report.pdf"
      ],
      [
        "CAG, Performance Audit of DBT scheme 'Aasara Pensions in Telangana' (2021), Chapter III (PDF)",
        "https://cag.gov.in/uploads/download_audit_report/2021/Chapter-III-Implementation-of-Aasara-Pensions-as-a-DBT-Scheme-065cdb90dd72180.15791130.pdf"
      ],
      [
        "Deccan Herald/PTI, 21 Dec 2024: Rythu Bandhu Rs 22,600 cr given to ineligible people in BRS regime, says Telangana CM",
        "https://www.deccanherald.com/india/telangana/rythu-bandhu-rs-22600-crore-given-to-ineligible-people-in-brs-regime-says-telangana-cm-3328152"
      ],
      [
        "ANI, 5 Jan 2025: Telangana farmers to receive Rs 12,000 per acre annually under Rythu Bharosa",
        "https://www.aninews.in/news/national/general-news/telangana-farmers-to-receive-rs-12000-per-acre-annually-under-rythu-bharosa-scheme20250105033356/"
      ],
      [
        "PRS, Telangana Budget Analysis 2023-24",
        "https://prsindia.org/budgets/states/telangana-budget-analysis-2023-24"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2018 Telangana Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2018_Telangana_Legislative_Assembly_election"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2023 Telangana Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:tn-amma-unavagam",
    "name": "Amma Unavagam (Amma Canteens)",
    "al": [
      "Amma Canteen",
      "Amma canteen"
    ],
    "level": "state",
    "st": "tn",
    "applicableStates": null,
    "category": "other",
    "party": "AIADMK",
    "announced": {
      "date": "2013-02-19",
      "byPersonId": "wel:j-jayalalithaa",
      "office": "Chief Minister, Tamil Nadu",
      "srcs": [
        [
          "Business Today — Amma Unavagam canteen sustainability",
          "https://www.businesstoday.in/magazine/reporters-diary/story/amma-unavagam-project-canteen-in-tamil-nadu-sustainable-138224-2014-07-14"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Greater Chennai Corporation council",
      "srcs": []
    },
    "launched": {
      "date": "2013-02-19",
      "srcs": [
        [
          "Down To Earth — Amma Canteen scheme stood test of time",
          "https://www.downtoearth.org.in/governance/how-tamil-nadu-s-amma-canteen-scheme-stood-the-test-of-time-77776"
        ]
      ]
    },
    "benefit": {
      "amount": 15,
      "unit": "subsidised meals (idli/sambar/curd rice etc.) at state-run canteens, run by women's self-help groups",
      "changes": [
        {
          "date": "2020-03-25",
          "amount": 0,
          "note": "meals free during COVID lockdown until 31 May 2020",
          "srcs": [
            [
              "ThePrint, 'Now it's Rs 15 for 3 meals at Chennai's Amma Canteens', 1 Jun 2020",
              "https://theprint.in/india/now-its-rs-15-for-3-meals-at-chennais-amma-canteens-but-end-of-free-food-bad-news-for-many/433276/"
            ]
          ]
        }
      ]
    },
    "eligibility": "open to the public, urban-centred",
    "beneficiaries": [
      {
        "asOf": "2020-06-01",
        "count": 450000,
        "srcs": [
          [
            "ThePrint, 'Now it's Rs 15 for 3 meals at Chennai's Amma Canteens', 1 Jun 2020",
            "https://theprint.in/india/now-its-rs-15-for-3-meals-at-chennais-amma-canteens-but-end-of-free-food-bad-news-for-many/433276/"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2019-20",
        "budgetedCr": 100,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "ThePrint, 'Now it's Rs 15 for 3 meals at Chennai's Amma Canteens', 1 Jun 2020",
            "https://theprint.in/india/now-its-rs-15-for-3-meals-at-chennais-amma-canteens-but-end-of-free-food-bad-news-for-many/433276/"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Tamil Nadu assembly",
      "date": "2016-05-16",
      "monthsFromLaunch": 39,
      "incumbentParty": "AIADMK",
      "result": "incumbent won (rare back-to-back win in TN)",
      "seatChange": null,
      "srcs": []
    },
    "status": [
      {
        "date": "2016-05-16",
        "status": "live",
        "note": "Part of a broader 'Amma' consumer-goods and services brand (canteens, salt, water, laptops, mixer-grinders, cycles) associated with the AIADMK government.",
        "srcs": []
      },
      {
        "date": "2020-06-01",
        "status": "live",
        "note": "continued under DMK after 2021 (per later reports not opened here)",
        "srcs": [
          [
            "ThePrint, 'Now it's Rs 15 for 3 meals at Chennai's Amma Canteens', 1 Jun 2020",
            "https://theprint.in/india/now-its-rs-15-for-3-meals-at-chennais-amma-canteens-but-end-of-free-food-bad-news-for-many/433276/"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "AIADMK's 2016 win, unusual for breaking Tamil Nadu's until-then-consistent alternation between AIADMK and DMK every election, is often partly credited to the popularity of the low-cost Amma-branded goods and services — but the 39-month gap between canteen launch and that election argues against a narrow near-term timing effect specifically from the canteens.",
        "tier": "analytic",
        "srcs": []
      },
      {
        "finding": "Annual under-recovery of ~₹100 crore financed by the municipal corporation rather than the state budget — a delivery model in which the 'vendor' is the corporation and SHG cooks, not a private contractor",
        "tier": "reported",
        "srcs": [
          [
            "ThePrint, 'Now it's Rs 15 for 3 meals at Chennai's Amma Canteens', 1 Jun 2020",
            "https://theprint.in/india/now-its-rs-15-for-3-meals-at-chennais-amma-canteens-but-end-of-free-food-bad-news-for-many/433276/"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:j-jayalalithaa",
        "role": "Chief Minister, Tamil Nadu",
        "action": "announced",
        "date": "2013-02-19",
        "party": "AIADMK",
        "srcs": []
      },
      {
        "personId": "wel:j-jayalalithaa",
        "role": "Chief Minister",
        "action": "announced",
        "date": "2013-02-01",
        "party": "AIADMK",
        "srcs": [
          [
            "ThePrint, 'Now it's Rs 15 for 3 meals at Chennai's Amma Canteens', 1 Jun 2020",
            "https://theprint.in/india/now-its-rs-15-for-3-meals-at-chennais-amma-canteens-but-end-of-free-food-bad-news-for-many/433276/"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "wel:greater-chennai-corporation",
        "how": "Bears the ~₹100 crore/yr deficit (a cost, not a gain); supplier and labour arrangements not in opened sources",
        "amountCr": -100,
        "tier": "reported",
        "srcs": [
          [
            "ThePrint, 'Now it's Rs 15 for 3 meals at Chennai's Amma Canteens', 1 Jun 2020",
            "https://theprint.in/india/now-its-rs-15-for-3-meals-at-chennais-amma-canteens-but-end-of-free-food-bad-news-for-many/433276/"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "ThePrint, 'Now it's Rs 15 for 3 meals at Chennai's Amma Canteens', 1 Jun 2020",
        "https://theprint.in/india/now-its-rs-15-for-3-meals-at-chennais-amma-canteens-but-end-of-free-food-bad-news-for-many/433276/"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:tn-free-bus-women-2021",
    "name": "Tamil Nadu free bus travel for women (Vidiyal Payanam)",
    "al": [
      "Vidiyal Payanam",
      "Magalir Vidiyal Payanam",
      "free bus for women TN"
    ],
    "level": "state",
    "st": "tn",
    "applicableStates": null,
    "category": "transport",
    "party": "DMK",
    "announced": {
      "date": "2021-05-07",
      "byPersonId": "wel:mk-stalin",
      "office": "Chief Minister, Tamil Nadu",
      "srcs": [
        [
          "The Federal, 12 Jun 2023: Free bus travel for women — Karnataka model vs TN, Delhi, Punjab",
          "https://thefederal.com/states/south/karnataka/karnataka-introduces-free-bus-travel-for-women-a-comparison-with-other-states"
        ],
        [
          "Deccan Herald, 18 Mar 2022: Free travel — more women in Tamil Nadu now take government buses (budget 2022-23)",
          "https://www.deccanherald.com/india/free-travel-more-women-in-tamil-nadu-now-take-government-buses-1092556.html"
        ]
      ]
    },
    "approved": {
      "date": "2021-05-07",
      "body": "CM order on day one; budget provision Rs 1,200 cr (2021-22)",
      "srcs": [
        [
          "Deccan Herald, 18 Mar 2022: Free travel — more women in Tamil Nadu now take government buses (budget 2022-23)",
          "https://www.deccanherald.com/india/free-travel-more-women-in-tamil-nadu-now-take-government-buses-1092556.html"
        ]
      ]
    },
    "launched": {
      "date": "2021-05-07",
      "srcs": [
        [
          "The Federal, 12 Jun 2023: Free bus travel for women — Karnataka model vs TN, Delhi, Punjab",
          "https://thefederal.com/states/south/karnataka/karnataka-introduces-free-bus-travel-for-women-a-comparison-with-other-states"
        ]
      ]
    },
    "benefit": {
      "amount": 0,
      "unit": "zero fare on government ordinary town/city buses (white board), unlimited trips, all women regardless of domicile",
      "changes": []
    },
    "eligibility": "All women (no registration, no domicile test) on ordinary government town buses; not on express/AC services",
    "beneficiaries": [
      {
        "asOf": "2022-03",
        "count": null,
        "srcs": [
          [
            "Deccan Herald, 18 Mar 2022: Free travel — more women in Tamil Nadu now take government buses (budget 2022-23)",
            "https://www.deccanherald.com/india/free-travel-more-women-in-tamil-nadu-now-take-government-buses-1092556.html"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2021-22",
        "budgetedCr": 1200,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Deccan Herald, 18 Mar 2022: Free travel — more women in Tamil Nadu now take government buses (budget 2022-23)",
            "https://www.deccanherald.com/india/free-travel-more-women-in-tamil-nadu-now-take-government-buses-1092556.html"
          ]
        ]
      },
      {
        "fy": "2022-23",
        "budgetedCr": 1520,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Deccan Herald, 18 Mar 2022: Free travel — more women in Tamil Nadu now take government buses (budget 2022-23)",
            "https://www.deccanherald.com/india/free-travel-more-women-in-tamil-nadu-now-take-government-buses-1092556.html"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Tamil Nadu assembly (previous — the promise)",
      "date": "2021-04-06",
      "monthsFromLaunch": -1,
      "incumbentParty": "AIADMK",
      "result": "challenger (DMK) won 133/234; delivered on day one",
      "seatChange": "DMK +44",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI): 2021 Tamil Nadu Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2021_Tamil_Nadu_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2021-05-07",
        "status": "live",
        "note": "",
        "srcs": [
          [
            "The Federal, 12 Jun 2023: Free bus travel for women — Karnataka model vs TN, Delhi, Punjab",
            "https://thefederal.com/states/south/karnataka/karnataka-introduces-free-bus-travel-for-women-a-comparison-with-other-states"
          ]
        ]
      },
      {
        "date": "2022-03",
        "status": "raised",
        "note": "Allocation Rs 1,200 → 1,520 cr",
        "srcs": [
          [
            "Deccan Herald, 18 Mar 2022: Free travel — more women in Tamil Nadu now take government buses (budget 2022-23)",
            "https://www.deccanherald.com/india/free-travel-more-women-in-tamil-nadu-now-take-government-buses-1092556.html"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Budget speech (Mar 2022): women's passenger share 40% → 61% — the clearest behavioural result in this file for a transport subsidy; Delhi (Pink Ticket, Oct 2019, 4 months pre-poll), Punjab and Karnataka (Shakti, Jun 2023) copied the design across four parties. Cost is paid as fare-loss reimbursement to state transport undertakings.",
        "tier": "documented",
        "srcs": [
          [
            "Deccan Herald, 18 Mar 2022: Free travel — more women in Tamil Nadu now take government buses (budget 2022-23)",
            "https://www.deccanherald.com/india/free-travel-more-women-in-tamil-nadu-now-take-government-buses-1092556.html"
          ],
          [
            "The Federal, 12 Jun 2023: Free bus travel for women — Karnataka model vs TN, Delhi, Punjab",
            "https://thefederal.com/states/south/karnataka/karnataka-introduces-free-bus-travel-for-women-a-comparison-with-other-states"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:mk-stalin",
        "role": "Chief Minister, Tamil Nadu",
        "action": "approved",
        "date": "2021-05-07",
        "party": "DMK",
        "srcs": [
          [
            "The Federal, 12 Jun 2023: Free bus travel for women — Karnataka model vs TN, Delhi, Punjab",
            "https://thefederal.com/states/south/karnataka/karnataka-introduces-free-bus-travel-for-women-a-comparison-with-other-states"
          ]
        ]
      },
      {
        "personId": "wel:ptr-palanivel-thiaga-rajan",
        "role": "Finance Minister, Tamil Nadu",
        "action": "presented budget",
        "date": "2022-03-18",
        "party": "DMK",
        "srcs": [
          [
            "Deccan Herald, 18 Mar 2022: Free travel — more women in Tamil Nadu now take government buses (budget 2022-23)",
            "https://www.deccanherald.com/india/free-travel-more-women-in-tamil-nadu-now-take-government-buses-1092556.html"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "Tamil Nadu state transport undertakings (8 STUs)",
        "how": "fare-loss reimbursement Rs 1,200–1,520 cr/yr on top of Rs 1,300 cr diesel subsidy",
        "amountCr": 1520,
        "tier": "documented",
        "srcs": [
          [
            "Deccan Herald, 18 Mar 2022: Free travel — more women in Tamil Nadu now take government buses (budget 2022-23)",
            "https://www.deccanherald.com/india/free-travel-more-women-in-tamil-nadu-now-take-government-buses-1092556.html"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "The Federal, 12 Jun 2023: Free bus travel for women — Karnataka model vs TN, Delhi, Punjab",
        "https://thefederal.com/states/south/karnataka/karnataka-introduces-free-bus-travel-for-women-a-comparison-with-other-states"
      ],
      [
        "Deccan Herald, 18 Mar 2022: Free travel — more women in Tamil Nadu now take government buses (budget 2022-23)",
        "https://www.deccanherald.com/india/free-travel-more-women-in-tamil-nadu-now-take-government-buses-1092556.html"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2021 Tamil Nadu Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2021_Tamil_Nadu_Legislative_Assembly_election"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2026 Tamil Nadu Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:tn-free-colour-tv-2006",
    "name": "Tamil Nadu free colour television scheme (DMK, 2006–11)",
    "al": [
      "Free colour TV",
      "இலவச வண்ணத் தொலைக்காட்சி"
    ],
    "level": "state",
    "st": "tn",
    "applicableStates": null,
    "category": "consumer-goods",
    "party": "DMK",
    "announced": {
      "date": "2006-04",
      "byPersonId": "wel:m-karunanidhi",
      "office": "DMK president; Chief Minister, Tamil Nadu from 13 May 2006",
      "srcs": [
        [
          "Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme",
          "https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"
        ]
      ]
    },
    "approved": {
      "date": "2006",
      "body": "Tamil Nadu budget 2006-07 (Rs 750 cr first phase); legislators' committee for procurement transparency",
      "srcs": [
        [
          "Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme",
          "https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"
        ]
      ]
    },
    "launched": {
      "date": "2006-09-15",
      "srcs": [
        [
          "Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme",
          "https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"
        ]
      ]
    },
    "benefit": {
      "amount": 1,
      "unit": "14-inch colour TV set per eligible household",
      "changes": []
    },
    "eligibility": "Households without a TV, holding a family card, with electricity and cable connections (GO); Jayalalithaa (2011) alleged oral orders extended it to all ration-card holders",
    "beneficiaries": [
      {
        "asOf": "2010-09",
        "count": 13200000,
        "srcs": [
          [
            "IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?",
            "https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"
          ]
        ]
      },
      {
        "asOf": "2011-06",
        "count": 16400000,
        "srcs": [
          [
            "IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?",
            "https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2006-07 (first phase)",
        "budgetedCr": 750,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme",
            "https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"
          ]
        ]
      },
      {
        "fy": "2006-11 cumulative",
        "budgetedCr": null,
        "actualCr": 3687,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?",
            "https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Tamil Nadu assembly (previous — the promise)",
      "date": "2006-05-08",
      "monthsFromLaunch": -4,
      "incumbentParty": "AIADMK",
      "result": "challenger (DMK-led DPA) won; TVs delivered 4 months after taking office",
      "seatChange": "DMK 96 (+65), DPA 163",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI): 2006 Tamil Nadu Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2006_Tamil_Nadu_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2006-09-15",
        "status": "live",
        "note": "",
        "srcs": [
          [
            "Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme",
            "https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"
          ]
        ]
      },
      {
        "date": "2011-06",
        "status": "discontinued",
        "note": "Jayalalithaa scrapped the 6th phase (1 million target, 0.74 million unprocured); 127,000 purchased sets diverted to orphanages, schools and public centres",
        "srcs": [
          [
            "IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?",
            "https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "IndiaSpend (Oct 2011): purchased (~15 m) vs distributed (13.2 m) vs Jayalalithaa's 16.4 m do not tally; sets went to villages without electricity; eligibility was widened orally beyond the GO; no pre-survey of TV-less households was done.",
        "tier": "reported",
        "srcs": [
          [
            "IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?",
            "https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"
          ]
        ]
      },
      {
        "finding": "Jayalalithaa (2006 as LoP; 2011 as CM) alleged that the scheme served the Karunanidhi family's cable business (Sun TV / Maran family): Rs 300 cr/yr cable fees on 25 lakh sets (2006 claim) and Rs 4,000 cr/yr on 16.4 m sets (2011 claim). The revenue numbers are hers; no audit or court finding to this effect was opened. Contra: the DMK's position (manifesto welfare; legislators' procurement committee) and the absence of any adjudicated finding; the Colour TV case of the 1990s was against Jayalalithaa herself and ended in her acquittal in 2000.",
        "tier": "alleged",
        "srcs": [
          [
            "Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme",
            "https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"
          ],
          [
            "IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?",
            "https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"
          ],
          [
            "Wikipedia (pointer): Colour TV case (1990s, J. Jayalalithaa)",
            "https://en.wikipedia.org/wiki/Colour_TV_case"
          ]
        ]
      },
      {
        "finding": "Post-poll delivery of a headline manifesto item; the DMK still lost 2011 by a landslide. Innocent reading: mass consumer-durable welfare with real take-up (13–16 million sets); skeptical reading: procurement scale (Rs 3,687 cr through ELCOT tenders) and complementarity with a family-linked cable business — the bidder list IndiaSpend promised was not opened.",
        "tier": "analytic",
        "srcs": [
          [
            "IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?",
            "https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"
          ],
          [
            "Wikipedia infobox (pointer to ECI): 2011 Tamil Nadu Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2011_Tamil_Nadu_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:m-karunanidhi",
        "role": "Chief Minister, Tamil Nadu",
        "action": "announced",
        "date": "2006-09-15",
        "party": "DMK",
        "srcs": [
          [
            "Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme",
            "https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"
          ]
        ]
      },
      {
        "personId": "wel:mk-stalin",
        "role": "Local Administration Minister, Tamil Nadu (2006)",
        "action": "administers",
        "date": "2006-09-15",
        "party": "DMK",
        "srcs": [
          [
            "Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme",
            "https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"
          ]
        ]
      },
      {
        "personId": "wel:j-jayalalithaa",
        "role": "Leader of Opposition (2006); Chief Minister (2011)",
        "action": "opposed",
        "date": "2011-06",
        "party": "AIADMK",
        "srcs": [
          [
            "IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?",
            "https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "wel:elcot",
        "how": "state procurement agency that bought ~15 million sets 2006–10",
        "amountCr": 3687,
        "tier": "documented",
        "srcs": [
          [
            "IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?",
            "https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"
          ]
        ]
      },
      {
        "who": "co:sun-tv-network",
        "how": "alleged by Jayalalithaa to gain cable-subscription revenue from a larger TV base; unadjudicated",
        "amountCr": null,
        "tier": "alleged",
        "srcs": [
          [
            "IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?",
            "https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"
          ],
          [
            "Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme",
            "https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"
          ]
        ]
      },
      {
        "who": "TV manufacturers/bidders",
        "how": "ELCOT tender winners — list not opened",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?",
            "https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme",
        "https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"
      ],
      [
        "IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?",
        "https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"
      ],
      [
        "Wikipedia (pointer): Colour TV case (1990s, J. Jayalalithaa)",
        "https://en.wikipedia.org/wiki/Colour_TV_case"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2006 Tamil Nadu Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2006_Tamil_Nadu_Legislative_Assembly_election"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2011 Tamil Nadu Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2011_Tamil_Nadu_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:tn-free-consumer-goods",
    "name": "Tamil Nadu free consumer goods (DMK 2006 televisions; AIADMK 2011 mixers, grinders, fans)",
    "al": [
      "TN free TVs",
      "free mixer-grinder scheme"
    ],
    "level": "state",
    "st": "tn",
    "applicableStates": null,
    "category": "consumer-goods",
    "party": "DMK (2006) / AIADMK (2011)",
    "announced": null,
    "approved": null,
    "launched": null,
    "benefit": null,
    "eligibility": null,
    "beneficiaries": [],
    "outlay": [],
    "electionContext": null,
    "status": [],
    "results": [
      {
        "finding": "Supreme Court, S. Subramaniam Balaji v Tamil Nadu (2013-07-05, (2013) 9 SCC 659): manifesto promises to distribute TVs, mixers, grinders are not a corrupt practice under s.123 RPA; ECI directed to frame manifesto guidelines.",
        "tier": "documented",
        "srcs": [
          [
            "S. Subramaniam Balaji v Government of Tamil Nadu, SC, 2013-07-05, (2013) 9 SCC 659 — Indian Kanoon",
            "https://indiankanoon.org/doc/106854428/"
          ]
        ]
      },
      {
        "finding": "Supreme Court, Ashwini Kumar Upadhyay v UoI (2022-08-26): the freebies petitions were referred to a three-judge bench with a request that Balaji be reconsidered; the Union proposed an expert commission and the ECI said its powers over promises are limited.",
        "tier": "documented",
        "srcs": [
          [
            "Ashwini Kumar Upadhyay v Union of India, W.P.(C) 43/2022, SC order 2022-08-26 (reference to three-judge bench) — Indian Kanoon",
            "https://indiankanoon.org/doc/82460936/"
          ]
        ]
      }
    ],
    "ministers": [],
    "whoElseBenefits": [],
    "srcs": [
      [
        "S. Subramaniam Balaji v Government of Tamil Nadu, SC, 2013-07-05, (2013) 9 SCC 659 — Indian Kanoon",
        "https://indiankanoon.org/doc/106854428/"
      ],
      [
        "Ashwini Kumar Upadhyay v Union of India, W.P.(C) 43/2022, SC order 2022-08-26 (reference to three-judge bench) — Indian Kanoon",
        "https://indiankanoon.org/doc/82460936/"
      ]
    ],
    "domain": "literature"
  },
  {
    "id": "scheme:tn-free-laptops",
    "name": "Tamil Nadu free laptop scheme (AIADMK 2011→; DMK laptops/tablets 2025-26)",
    "al": [
      "ELCOT laptops",
      "Ulagam Ungal Kaiyil"
    ],
    "level": "state",
    "st": "tn",
    "applicableStates": null,
    "category": "consumer-goods",
    "party": "AIADMK (2011-21) / DMK (2025→)",
    "announced": {
      "date": null,
      "byPersonId": "wel:j-jayalalithaa",
      "office": "Chief Minister, Tamil Nadu (2011 manifesto/launch; exact date not in opened sources)",
      "srcs": [
        [
          "Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025",
          "https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Tamil Nadu Cabinet / Budget 2025-26 (₹2,000 crore for 20 lakh students)",
      "srcs": [
        [
          "Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025",
          "https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"
        ]
      ]
    },
    "launched": {
      "date": null,
      "srcs": [
        [
          "Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025",
          "https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"
        ]
      ]
    },
    "benefit": {
      "amount": null,
      "unit": "one laptop (or tablet, DMK phase) per eligible student",
      "changes": [
        {
          "date": "2025-03-14",
          "amount": null,
          "note": "DMK budget: ₹2,000 crore for 20 lakh college students, laptops or tablets",
          "srcs": [
            [
              "Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025",
              "https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"
            ]
          ]
        }
      ]
    },
    "eligibility": "Students of government and government-aided schools/colleges (AIADMK phase: Class 11-12 and college); DMK phase: 20 lakh college students",
    "beneficiaries": [
      {
        "asOf": "2021-05-01",
        "count": 5100000,
        "srcs": [
          [
            "Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025",
            "https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2025-26",
        "budgetedCr": 2000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025",
            "https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Tamil Nadu assembly",
      "date": "2021-04-06",
      "monthsFromLaunch": null,
      "incumbentParty": "AIADMK",
      "result": "incumbent lost; DMK 133 (+44), AIADMK 66 (−70)",
      "seatChange": "DMK +44",
      "srcs": [
        [
          "Wikipedia (pointer), 2021 Tamil Nadu Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2021_Tamil_Nadu_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2021-05-07",
        "status": "paused",
        "note": "each party says the other stopped it: AIADMK says DMK 'abruptly halted' it; DMK's Law Minister says it stopped under AIADMK",
        "srcs": [
          [
            "Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025",
            "https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"
          ]
        ]
      },
      {
        "date": "2025-03-14",
        "status": "renamed",
        "note": "revived by DMK as laptops/tablets for 20 lakh college students, ₹2,000 crore in 2025-26 — 13 months before the 2026 election",
        "srcs": [
          [
            "Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025",
            "https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Cumulative AIADMK-era distribution of 51 lakh units is a party claim; ELCOT tender winners and unit prices for either phase were not found in any source opened here",
        "tier": "reported",
        "srcs": [
          [
            "Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025",
            "https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:j-jayalalithaa",
        "role": "Chief Minister",
        "action": "announced",
        "date": "2011-05-16",
        "party": "AIADMK",
        "srcs": [
          [
            "Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025",
            "https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"
          ]
        ]
      },
      {
        "personId": "wel:rb-udayakumar",
        "role": "AIADMK deputy leader, Assembly",
        "action": "opposed",
        "date": "2025-03-19",
        "party": "AIADMK",
        "srcs": [
          [
            "Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025",
            "https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"
          ]
        ]
      },
      {
        "personId": "wel:s-regupathy",
        "role": "Law Minister",
        "action": "administers",
        "date": "2025-03-19",
        "party": "DMK",
        "srcs": [
          [
            "Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025",
            "https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "ELCOT-tendered OEMs (unnamed here)",
        "how": "Multi-thousand-crore laptop supply tenders in both phases; winners not verified from an opened primary/press record",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025",
            "https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025",
        "https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"
      ],
      [
        "Wikipedia (pointer), 2021 Tamil Nadu Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2021_Tamil_Nadu_Legislative_Assembly_election"
      ]
    ],
    "domain": "vendors"
  },
  {
    "id": "scheme:tn-free-mixie-grinder-fan-2011",
    "name": "Tamil Nadu free mixie, grinder and fan scheme (AIADMK, 2011–16)",
    "al": [
      "Amma mixie-grinder",
      "இலவச மிக்ஸி கிரைண்டர்"
    ],
    "level": "state",
    "st": "tn",
    "applicableStates": null,
    "category": "consumer-goods",
    "party": "AIADMK",
    "announced": {
      "date": "2011",
      "byPersonId": "wel:j-jayalalithaa",
      "office": "Chief Minister, Tamil Nadu",
      "srcs": [
        [
          "Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women",
          "https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"
        ]
      ]
    },
    "approved": {
      "date": "2011",
      "body": "Tamil Nadu budget 2011-12 (date not verified in an opened page)",
      "srcs": [
        [
          "Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women",
          "https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"
        ]
      ]
    },
    "launched": {
      "date": "2011-09-15",
      "srcs": [
        [
          "Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women",
          "https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"
        ]
      ]
    },
    "benefit": {
      "amount": 1,
      "unit": "set of electric fan, mixie and grinder per family-card household (women)",
      "changes": []
    },
    "eligibility": "Family-card (ration) holders, phased by year (25 lakh 2011-12; 35 lakh 2012-13; 35 lakh 2013-14)",
    "beneficiaries": [
      {
        "asOf": "2014-02",
        "count": 8000000,
        "srcs": [
          [
            "Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women",
            "https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2011-14",
        "budgetedCr": null,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women",
            "https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Tamil Nadu assembly (previous — the promise)",
      "date": "2011-04-13",
      "monthsFromLaunch": -5,
      "incumbentParty": "DMK",
      "result": "challenger (AIADMK) won 150/234; goods delivered 4 months after taking office",
      "seatChange": "AIADMK +89",
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI): 2011 Tamil Nadu Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2011_Tamil_Nadu_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2011-09-15",
        "status": "live",
        "note": "",
        "srcs": [
          [
            "Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women",
            "https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"
          ]
        ]
      },
      {
        "date": "2014-02",
        "status": "live",
        "note": "Goods for 2013-14 stocked at TNCSC godowns for distribution",
        "srcs": [
          [
            "Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women",
            "https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Mirror image of the 2006 DMK TV scheme (same launch date symbolism, same post-poll delivery, opposite party); AIADMK then won 2016 — one goods scheme precedes a loss (DMK 2011), one a win (AIADMK 2016). Procurement/tender detail not opened; the Tamil Nadu Civil Supplies Corporation held stocks.",
        "tier": "analytic",
        "srcs": [
          [
            "Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women",
            "https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"
          ],
          [
            "Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme",
            "https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"
          ],
          [
            "Wikipedia infobox (pointer to ECI results): 2016 Tamil Nadu Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2016_Tamil_Nadu_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:j-jayalalithaa",
        "role": "Chief Minister, Tamil Nadu",
        "action": "announced",
        "date": "2011",
        "party": "AIADMK",
        "srcs": [
          [
            "Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women",
            "https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"
          ]
        ]
      },
      {
        "personId": "wel:kt-rajendra-balaji",
        "role": "Special Programmes Implementation Minister, Tamil Nadu",
        "action": "administers",
        "date": "2014-02-21",
        "party": "AIADMK",
        "srcs": [
          [
            "Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women",
            "https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "Tamil Nadu Civil Supplies Corporation",
        "how": "warehousing and distribution of goods",
        "amountCr": null,
        "tier": "documented",
        "srcs": [
          [
            "Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women",
            "https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"
          ]
        ]
      },
      {
        "who": "appliance manufacturers (tender winners)",
        "how": "not identified in opened sources",
        "amountCr": null,
        "tier": "analytic",
        "srcs": []
      }
    ],
    "srcs": [
      [
        "Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women",
        "https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2011 Tamil Nadu Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2011_Tamil_Nadu_Legislative_Assembly_election"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2016 Tamil Nadu Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2016_Tamil_Nadu_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:tn-kalaignar-magalir-urimai-thogai",
    "name": "Kalaignar Magalir Urimai Thogai",
    "al": [
      "KMUT",
      "Kalaignar Magalir Urimai Thittam",
      "கலைஞர் மகளிர் உரிமைத் தொகை"
    ],
    "level": "state",
    "st": "tn",
    "applicableStates": null,
    "category": "women-cash",
    "party": "DMK",
    "announced": {
      "date": "2023-09-15",
      "byPersonId": "wel:mk-stalin",
      "office": "Chief Minister, Tamil Nadu",
      "srcs": [
        [
          "DT Next — Kalaignar Magalir Urimai Thogai",
          "https://www.dtnext.in/news/tamilnadu/kalaignar-magalir-urimai-thogai-scheme-over-148-lakh-women-file-fresh-appeals-now-eligible-for-rs-1000-monthly-aid-792929"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "Tamil Nadu Cabinet / Budget 2023-24",
      "srcs": [
        [
          "Deccan Herald, 15 Sep 2023: Stalin launches Rs 1,000 monthly scheme for 1.06 cr women",
          "https://www.deccanherald.com/india/tamil-nadu/stalin-launches-rs-1000-monthly-assistance-scheme-for-women-heads-of-families-2687619"
        ]
      ]
    },
    "launched": {
      "date": "2023-09-15",
      "srcs": [
        [
          "DT Next — Kalaignar Magalir Urimai Thogai",
          "https://www.dtnext.in/news/tamilnadu/kalaignar-magalir-urimai-thogai-scheme-over-148-lakh-women-file-fresh-appeals-now-eligible-for-rs-1000-monthly-aid-792929"
        ]
      ]
    },
    "benefit": {
      "amount": 1000,
      "unit": "₹ per month per eligible woman head-of-household",
      "changes": [
        {
          "date": "2026-01",
          "amount": null,
          "note": "One-off Rs 3,000 Pongal cash gift before the Apr 2026 election (Logical Indian); not a KMUT change",
          "srcs": [
            [
              "The Logical Indian, 4 May 2026: fiscal reality behind 2026 cash promises to women",
              "https://thelogicalindian.com/elections-results-2026-the-fiscal-reality-behind-indias-cash-promises-to-women/"
            ]
          ]
        }
      ]
    },
    "eligibility": "women heads of household, income and property criteria",
    "beneficiaries": [
      {
        "asOf": "2023-09-15",
        "count": 11300000,
        "srcs": [
          [
            "DT Next — Kalaignar Magalir Urimai Thogai",
            "https://www.dtnext.in/news/tamilnadu/kalaignar-magalir-urimai-thogai-scheme-over-148-lakh-women-file-fresh-appeals-now-eligible-for-rs-1000-monthly-aid-792929"
          ]
        ]
      },
      {
        "asOf": "2023-09-15",
        "count": 10600000,
        "srcs": [
          [
            "Deccan Herald, 15 Sep 2023: Stalin launches Rs 1,000 monthly scheme for 1.06 cr women",
            "https://www.deccanherald.com/india/tamil-nadu/stalin-launches-rs-1000-monthly-assistance-scheme-for-women-heads-of-families-2687619"
          ]
        ]
      },
      {
        "asOf": "2023-11-10",
        "count": 11300000,
        "srcs": [
          [
            "Deccan Herald, 10 Nov 2023: TN adds 7.35 lakh beneficiaries; 1.13 cr total",
            "https://www.deccanherald.com/india/tamil-nadu/tamil-nadu-expands-monthly-assistance-scheme-to-women-adds-7-lakh-beneficiaries-2766189"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2023-24",
        "budgetedCr": 12000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "DT Next — Kalaignar Magalir Urimai Thogai",
            "https://www.dtnext.in/news/tamilnadu/kalaignar-magalir-urimai-thogai-scheme-over-148-lakh-women-file-fresh-appeals-now-eligible-for-rs-1000-monthly-aid-792929"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 13807,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 13807,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Tamil Nadu assembly",
      "date": "2026-04-23",
      "monthsFromLaunch": 31,
      "incumbentParty": "DMK",
      "result": "incumbent lost",
      "seatChange": "DMK 133(2021)→59 seats, TVK (new party) 108, AIADMK 47",
      "srcs": [
        [
          "Wikipedia — 2026 Tamil Nadu Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2026-05-10",
        "status": "live",
        "note": "Continued through the change of government; a new DMK-era scheme surviving a change of government pending the incoming TVK government's own decision.",
        "srcs": []
      },
      {
        "date": "2023-09-15",
        "status": "live",
        "note": null,
        "srcs": [
          [
            "Deccan Herald, 15 Sep 2023: Stalin launches Rs 1,000 monthly scheme for 1.06 cr women",
            "https://www.deccanherald.com/india/tamil-nadu/stalin-launches-rs-1000-monthly-assistance-scheme-for-women-heads-of-families-2687619"
          ]
        ]
      },
      {
        "date": "2023-09-15",
        "status": "eligibility-tightened",
        "note": "Manifesto's universal promise implemented as a targeted scheme; opposition criticised the criteria",
        "srcs": [
          [
            "Deccan Herald, 15 Sep 2023: Stalin launches Rs 1,000 monthly scheme for 1.06 cr women",
            "https://www.deccanherald.com/india/tamil-nadu/stalin-launches-rs-1000-monthly-assistance-scheme-for-women-heads-of-families-2687619"
          ]
        ]
      },
      {
        "date": "2023-11-10",
        "status": "live",
        "note": "Expanded to 1.13 cr; further appeals processed from Dec 2023",
        "srcs": [
          [
            "Deccan Herald, 10 Nov 2023: TN adds 7.35 lakh beneficiaries; 1.13 cr total",
            "https://www.deccanherald.com/india/tamil-nadu/tamil-nadu-expands-monthly-assistance-scheme-to-women-adds-7-lakh-beneficiaries-2766189"
          ]
        ]
      },
      {
        "date": "2026-05",
        "status": "live",
        "note": "Post-election status under the TVK government not verified — see gaps",
        "srcs": [
          [
            "Wikipedia (pointer): 2026 Tamil Nadu Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "A large, DMK-branded women's cash scheme running for 2.5 years before the 2026 election in which DMK lost power to a first-time party (TVK, led by actor Vijay) — a second clear counter-case (alongside AP 2024 and WB 2026) against a simple cash-transfers-determine-outcomes reading, and notable because the challenger here was not the traditional opposition (AIADMK) but an entirely new entrant, complicating any single-variable account of the result.",
        "tier": "analytic",
        "srcs": [
          [
            "Wikipedia — 2026 Tamil Nadu Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"
          ]
        ]
      },
      {
        "finding": "PRS (Oct 2025): BE 2025-26 ₹13,807 cr = 3.7% of revenue expenditure, 4.2% of revenue receipts.",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "A 31-month-old Rs 1,000 transfer to 1.13 cr women did not prevent the incumbent's defeat in Apr 2026 (DMK 59 seats)",
        "tier": "analytic",
        "srcs": [
          [
            "Wikipedia (pointer): 2026 Tamil Nadu Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:mk-stalin",
        "role": "Chief Minister, Tamil Nadu",
        "action": "announced",
        "date": "2023-09-15",
        "party": "DMK",
        "srcs": []
      },
      {
        "personId": "wel:mk-stalin",
        "role": "Chief Minister",
        "action": "announced",
        "date": "2021-03",
        "party": "DMK",
        "srcs": [
          [
            "Deccan Herald, 15 Sep 2023: Stalin launches Rs 1,000 monthly scheme for 1.06 cr women",
            "https://www.deccanherald.com/india/tamil-nadu/stalin-launches-rs-1000-monthly-assistance-scheme-for-women-heads-of-families-2687619"
          ]
        ]
      },
      {
        "personId": "wel:mk-stalin",
        "role": "Chief Minister",
        "action": "administers",
        "date": "2023-09-15",
        "party": "DMK",
        "srcs": [
          [
            "Deccan Herald, 15 Sep 2023: Stalin launches Rs 1,000 monthly scheme for 1.06 cr women",
            "https://www.deccanherald.com/india/tamil-nadu/stalin-launches-rs-1000-monthly-assistance-scheme-for-women-heads-of-families-2687619"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "banks (ATM cards issued at launch)",
        "how": "1.06 cr new/active DBT accounts and ATM cards handed out at launch; bank partners unnamed",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald, 15 Sep 2023: Stalin launches Rs 1,000 monthly scheme for 1.06 cr women",
            "https://www.deccanherald.com/india/tamil-nadu/stalin-launches-rs-1000-monthly-assistance-scheme-for-women-heads-of-families-2687619"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "DT Next — Kalaignar Magalir Urimai Thogai",
        "https://www.dtnext.in/news/tamilnadu/kalaignar-magalir-urimai-thogai-scheme-over-148-lakh-women-file-fresh-appeals-now-eligible-for-rs-1000-monthly-aid-792929"
      ],
      [
        "Govt of TN — KMUT official portal",
        "https://kmut.tn.gov.in/"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "Deccan Herald, 15 Sep 2023: Stalin launches Rs 1,000 monthly scheme for 1.06 cr women",
        "https://www.deccanherald.com/india/tamil-nadu/stalin-launches-rs-1000-monthly-assistance-scheme-for-women-heads-of-families-2687619"
      ],
      [
        "Deccan Herald, 10 Nov 2023: TN adds 7.35 lakh beneficiaries; 1.13 cr total",
        "https://www.deccanherald.com/india/tamil-nadu/tamil-nadu-expands-monthly-assistance-scheme-to-women-adds-7-lakh-beneficiaries-2766189"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "Wikipedia (pointer): 2026 Tamil Nadu Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:up-farm-loan-waiver-2017",
    "name": "Uttar Pradesh farm loan waiver 2017 (Kisan Rin Mochan)",
    "al": [
      "Fasal Rin Mochan Yojana"
    ],
    "level": "state",
    "st": "up",
    "applicableStates": null,
    "category": "loan-waiver",
    "party": "BJP",
    "announced": {
      "date": "2017-04-04",
      "byPersonId": "wel:yogi-adityanath",
      "office": "Chief Minister, Uttar Pradesh",
      "srcs": [
        [
          "Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'",
          "https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"
        ],
        [
          "PRS, Uttar Pradesh Budget Analysis 2017-18",
          "https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2017-18"
        ]
      ]
    },
    "approved": {
      "date": "2017-04-04",
      "body": "Uttar Pradesh Cabinet (first meeting)",
      "srcs": [
        [
          "Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'",
          "https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"
        ]
      ]
    },
    "launched": {
      "date": "2017",
      "srcs": [
        [
          "PRS, Uttar Pradesh Budget Analysis 2018-19",
          "https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2018-19"
        ]
      ]
    },
    "benefit": {
      "amount": 100000,
      "unit": "₹ maximum crop-loan waiver per small/marginal farmer",
      "changes": []
    },
    "eligibility": "Small and marginal farmers (<5 acres) with crop loans to 31 Mar 2016",
    "beneficiaries": [],
    "outlay": [
      {
        "fy": "2017-18",
        "budgetedCr": 36000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Uttar Pradesh Budget Analysis 2017-18",
            "https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2017-18"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Uttar Pradesh assembly (previous — the promise)",
      "date": "2017-02-11",
      "monthsFromLaunch": -2,
      "incumbentParty": "SP",
      "result": "challenger (BJP) won 325/403; waiver = first cabinet decision",
      "seatChange": "BJP +265",
      "srcs": [
        [
          "Wikipedia (pointer): 2017 Uttar Pradesh Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2017_Uttar_Pradesh_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2017-04-04",
        "status": "live",
        "note": "",
        "srcs": [
          [
            "Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'",
            "https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Congress (Surjewala, 4 Apr 2017) called it a \"half truth\": Rs 36,000 cr against Rs 92,241 cr of farm debt in UP, term loans of Rs 56,241 cr untouched; Congress also alleged Rs 1.4 lakh cr of corporate loans written off. This is the opposition's characterisation, not an audit.",
        "tier": "alleged",
        "srcs": [
          [
            "Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'",
            "https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"
          ]
        ]
      },
      {
        "finding": "Innocent reading: the Prime Minister had promised a waiver in the campaign and the government delivered within three weeks; skeptical reading: the same instrument the BJP's 2022 \"revdi\" rhetoric later targeted when used by others. The PM's July 2022 Jalaun speech sits beside this record.",
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'",
            "https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"
          ],
          [
            "PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)",
            "https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:yogi-adityanath",
        "role": "Chief Minister, Uttar Pradesh",
        "action": "approved",
        "date": "2017-04-04",
        "party": "BJP",
        "srcs": [
          [
            "Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'",
            "https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "commercial and cooperative banks",
        "how": "Rs 5,630 cr of NPA accounts written off at bank level per press summaries; opened DH text only carries the Rs 36,000 cr total",
        "amountCr": null,
        "tier": "reported",
        "srcs": [
          [
            "Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'",
            "https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'",
        "https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"
      ],
      [
        "PRS, Uttar Pradesh Budget Analysis 2017-18",
        "https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2017-18"
      ],
      [
        "PRS, Uttar Pradesh Budget Analysis 2018-19",
        "https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2018-19"
      ],
      [
        "Wikipedia (pointer): 2017 Uttar Pradesh Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2017_Uttar_Pradesh_Legislative_Assembly_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:up-free-laptops-2012",
    "name": "Uttar Pradesh free laptop distribution (Samajwadi Party, 2012-13)",
    "al": [
      "UP laptop yojana",
      "Akhilesh laptops"
    ],
    "level": "state",
    "st": "up",
    "applicableStates": null,
    "category": "consumer-goods",
    "party": "SP",
    "announced": {
      "date": null,
      "byPersonId": "wel:akhilesh-yadav",
      "office": "SP 2012 manifesto promise (pre-election); CM from 2012-03-15",
      "srcs": [
        [
          "Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'",
          "https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "UP Cabinet — ₹2,800 crore scheme approved Jan 2013 (Business Standard, 24 Jan 2013, cited by Wikipedia; not opened here)",
      "srcs": [
        [
          "Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'",
          "https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"
        ]
      ]
    },
    "launched": {
      "date": null,
      "srcs": [
        [
          "Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'",
          "https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"
        ]
      ]
    },
    "benefit": {
      "amount": 19000,
      "unit": "₹ per HP laptop (approx. unit price per press reports cited by Wikipedia)",
      "changes": []
    },
    "eligibility": "Class 10 and 12 pass-outs of recognised boards, ITIs and polytechnics; quotas for minorities (20%) and SC/ST (21%)",
    "beneficiaries": [
      {
        "asOf": "2014-12-31",
        "count": 611794,
        "srcs": [
          [
            "Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'",
            "https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2012-13 to 2014-15",
        "budgetedCr": 2800,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'",
            "https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Uttar Pradesh assembly 2012 (promise) and 2017 (delivery judged)",
      "date": null,
      "monthsFromLaunch": null,
      "incumbentParty": "SP (2017)",
      "result": "SP lost 2017 (dates not in opened sources; see gaps)",
      "seatChange": null,
      "srcs": [
        [
          "Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'",
          "https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"
        ]
      ]
    },
    "status": [
      {
        "date": "2014-12-31",
        "status": "discontinued",
        "note": "Wikipedia records the scheme as closed/inactive after 2014; the 2017 BJP government ordered a probe into the undistributed ~8.7 lakh units",
        "srcs": [
          [
            "Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'",
            "https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "2017 probe: 14,81,118 laptops purchased, 6,11,794 distributed (2012-14) — ~8.7 lakh units unaccounted for in the public record cited",
        "tier": "reported",
        "srcs": [
          [
            "Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'",
            "https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:akhilesh-yadav",
        "role": "Chief Minister",
        "action": "announced",
        "date": "2012-03-15",
        "party": "SP",
        "srcs": [
          [
            "Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'",
            "https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"
          ]
        ]
      },
      {
        "personId": "wel:yogi-adityanath",
        "role": "Chief Minister",
        "action": "opposed",
        "date": "2017-03-19",
        "party": "BJP",
        "srcs": [
          [
            "Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'",
            "https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "wel:hewlett-packard-india",
        "how": "Sole supplier of ~15 lakh laptops in a tender contested by HP, HCL, Lenovo and Acer; ₹2,800 crore budget",
        "amountCr": 2800,
        "tier": "reported",
        "srcs": [
          [
            "Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'",
            "https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'",
        "https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"
      ]
    ],
    "domain": "vendors"
  },
  {
    "id": "scheme:up-kanya-sumangala-2019",
    "name": "Mukhyamantri Kanya Sumangala Yojana (UP)",
    "al": [
      "Kanya Sumangala",
      "कन्या सुमंगला"
    ],
    "level": "state",
    "st": "up",
    "applicableStates": null,
    "category": "student",
    "party": "BJP",
    "announced": {
      "date": "2019-02-07",
      "byPersonId": "wel:yogi-adityanath",
      "office": "Chief Minister, Uttar Pradesh",
      "srcs": [
        [
          "PRS, Uttar Pradesh Budget Analysis 2019-20",
          "https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2019-20"
        ]
      ]
    },
    "approved": {
      "date": "2019-02",
      "body": "Uttar Pradesh budget 2019-20",
      "srcs": [
        [
          "PRS, Uttar Pradesh Budget Analysis 2019-20",
          "https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2019-20"
        ]
      ]
    },
    "launched": {
      "date": null,
      "srcs": []
    },
    "benefit": {
      "amount": 15000,
      "unit": "₹ in six staged instalments from birth to graduation (press summaries; raised to Rs 25,000 in 2024 per summaries) — amounts not verified in an opened page",
      "changes": []
    },
    "eligibility": "Girls of UP-domiciled families with income ≤ Rs 3 lakh, up to two girls (press summaries)",
    "beneficiaries": [],
    "outlay": [
      {
        "fy": "2019-20",
        "budgetedCr": 1200,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, Uttar Pradesh Budget Analysis 2019-20",
            "https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2019-20"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Lok Sabha (UP)",
      "date": "2019-04-11",
      "monthsFromLaunch": 2,
      "incumbentParty": "BJP",
      "result": "BJP/NDA won nationally (fleet file); state-level seat count not captured",
      "seatChange": null,
      "srcs": [
        [
          "Wikipedia infobox (pointer to ECI results): 2019 Indian general election",
          "https://en.wikipedia.org/wiki/2019_Indian_general_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2019-02",
        "status": "promised-not-enacted",
        "note": "budget line",
        "srcs": [
          [
            "PRS, Uttar Pradesh Budget Analysis 2019-20",
            "https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2019-20"
          ]
        ]
      },
      {
        "date": "2019-10",
        "status": "live",
        "note": "launch per press (not opened)",
        "srcs": []
      }
    ],
    "results": [
      {
        "finding": "A Ladli Laxmi-type staged girl-child transfer announced in a pre-Lok-Sabha budget; too thinly sourced this session to say more — recorded so the symmetry table has the BJP-UP entry.",
        "tier": "analytic",
        "srcs": [
          [
            "PRS, Uttar Pradesh Budget Analysis 2019-20",
            "https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2019-20"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:yogi-adityanath",
        "role": "Chief Minister, Uttar Pradesh",
        "action": "presented budget",
        "date": "2019-02",
        "party": "BJP",
        "srcs": [
          [
            "PRS, Uttar Pradesh Budget Analysis 2019-20",
            "https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2019-20"
          ]
        ]
      }
    ],
    "whoElseBenefits": [],
    "srcs": [
      [
        "PRS, Uttar Pradesh Budget Analysis 2019-20",
        "https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2019-20"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2019 Indian general election",
        "https://en.wikipedia.org/wiki/2019_Indian_general_election"
      ]
    ],
    "domain": "state-cash-other"
  },
  {
    "id": "scheme:upa-farm-loan-waiver-2008",
    "name": "Agricultural Debt Waiver and Debt Relief Scheme, 2008",
    "al": [
      "2008 farm loan waiver",
      "ADWDRS"
    ],
    "level": "central",
    "st": null,
    "applicableStates": "all",
    "category": "loan-waiver",
    "party": "INC (UPA)",
    "announced": {
      "date": "2008-02-29",
      "byPersonId": "wel:p-chidambaram",
      "office": "Union Finance Minister, 2004-05 → 2008-11",
      "srcs": [
        [
          "Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)",
          "https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"
        ]
      ]
    },
    "approved": {
      "date": "2008-02-29",
      "body": "Union Budget 2008-09 (Parliament)",
      "srcs": [
        [
          "Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)",
          "https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"
        ]
      ]
    },
    "launched": {
      "date": "2008-06-30",
      "srcs": [
        [
          "Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)",
          "https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"
        ]
      ]
    },
    "benefit": {
      "amount": 60000,
      "unit": "full waiver of overdue loans for farmers ≤2 ha; 25% one-time-settlement rebate for others",
      "changes": []
    },
    "eligibility": "agricultural loans disbursed to 31 Mar 2007, overdue on 31 Dec 2007 and unpaid to 29 Feb 2008",
    "beneficiaries": [
      {
        "asOf": "2008-02-29",
        "count": 40000000,
        "srcs": [
          [
            "Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)",
            "https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"
          ]
        ]
      },
      {
        "asOf": "2008-06-30",
        "count": 40000000,
        "srcs": [
          [
            "Swarajya — CAG found irregularities in 2008 loan waiver",
            "https://swarajyamag.com/politics/when-cag-found-irregularities-in-upa-government-farm-loan-waiver-in-2008"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2008-09",
        "budgetedCr": 60000,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)",
            "https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"
          ]
        ]
      },
      {
        "fy": "2008-09",
        "budgetedCr": 60000,
        "actualCr": 52000,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "Swarajya — CAG found irregularities in 2008 loan waiver",
            "https://swarajyamag.com/politics/when-cag-found-irregularities-in-upa-government-farm-loan-waiver-in-2008"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "Lok Sabha 2009",
      "date": "2009-04-16",
      "monthsFromLaunch": 9.5,
      "incumbentParty": "INC (UPA)",
      "result": "incumbent won",
      "seatChange": "INC +61 (145→206)",
      "srcs": [
        [
          "Wikipedia (pointer), 2009 Indian general election",
          "https://en.wikipedia.org/wiki/2009_Indian_general_election"
        ],
        [
          "Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)",
          "https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"
        ]
      ]
    },
    "status": [
      {
        "date": "2013-03-05",
        "status": "live",
        "note": "CAG performance audit (Report 3 of 2013) tabled; scheme itself had closed",
        "srcs": [
          [
            "CAG Report No. 3 of 2013, ADWDRS 2008 executive summary (PDF is image-only; text not machine-verified)",
            "https://cag.gov.in/uploads/download_audit_report/2013/Union_Performance_Civil_Sector_3_2013_chapter_3_exe_summ.pdf"
          ]
        ]
      },
      {
        "date": "2013-01-01",
        "status": "discontinued",
        "note": "One-time window, closed 2008-06-30; not renewed.",
        "srcs": []
      }
    ],
    "results": [
      {
        "finding": "CAG Report 3 of 2013 audited ADWDRS; the widely cited headline is lapses/errors in 22.32% of 90,576 test-checked cases, including ineligible inclusions and eligible exclusions. The PDF opened here is image-only, so the figure is taken from the search-engine excerpt of the CAG summary and is not text-verified",
        "tier": "reported",
        "srcs": [
          [
            "CAG Report No. 3 of 2013, ADWDRS 2008 executive summary (PDF is image-only; text not machine-verified)",
            "https://cag.gov.in/uploads/download_audit_report/2013/Union_Performance_Civil_Sector_3_2013_chapter_3_exe_summ.pdf"
          ]
        ]
      },
      {
        "finding": "CAG's 2013 audit of the scheme found irregularities in implementation — ineligible beneficiaries included, eligible farmers excluded, and poor record-keeping in a test-check of ~90,500 cases.",
        "tier": "documented",
        "srcs": [
          [
            "Deccan Herald — CAG finds flaws in debt waiver implementation",
            "https://www.deccanherald.com/india/cag-finds-flaws-implementation-debt-2235970"
          ]
        ]
      },
      {
        "finding": "A former UPA agriculture secretary said the waiver was designed to be 'the last of its kind', i.e. framed internally as a one-off relief measure rather than a recurring electoral instrument — the innocent-reading account from within the government that designed it.",
        "tier": "reported",
        "srcs": [
          [
            "The Print — 2008 farm loan waiver designed to be last of its kind",
            "https://theprint.in/report/we-had-designed-2008-farm-loan-waiver-to-be-last-of-its-kind-upa-agriculture-secy/1511/"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:p-chidambaram",
        "role": "Union Finance Minister",
        "action": "presented budget",
        "date": "2008-02-29",
        "party": "INC",
        "srcs": [
          [
            "Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)",
            "https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"
          ]
        ]
      },
      {
        "personId": "wel:manmohan-singh",
        "role": "Prime Minister",
        "action": "approved",
        "date": "2008-02-29",
        "party": "INC",
        "srcs": [
          [
            "Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)",
            "https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"
          ]
        ]
      },
      {
        "personId": "wel:p-chidambaram",
        "role": "Union Finance Minister",
        "action": "presented budget",
        "date": "2008-02-29",
        "party": "INC",
        "srcs": [
          [
            "Swarajya — CAG found irregularities in 2008 loan waiver",
            "https://swarajyamag.com/politics/when-cag-found-irregularities-in-upa-government-farm-loan-waiver-in-2008"
          ]
        ]
      },
      {
        "personId": "wel:manmohan-singh",
        "role": "Prime Minister",
        "action": "approved",
        "date": "2008-02-29",
        "party": "INC",
        "srcs": []
      }
    ],
    "whoElseBenefits": [
      {
        "who": "scheduled commercial banks, RRBs, cooperative credit institutions",
        "how": "overdue farm NPAs reimbursed by the Centre; balance sheets cleaned",
        "amountCr": 60000,
        "tier": "documented",
        "srcs": [
          [
            "Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)",
            "https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"
          ]
        ]
      },
      {
        "who": "public-sector and cooperative banks",
        "how": "NPA cleanup — the waiver moved bad farm-loan debt off bank books, funded by the exchequer",
        "amountCr": 52000,
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald — CAG finds flaws in debt waiver implementation",
            "https://www.deccanherald.com/india/cag-finds-flaws-implementation-debt-2235970"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)",
        "https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"
      ],
      [
        "CAG Report No. 3 of 2013, ADWDRS 2008 executive summary (PDF is image-only; text not machine-verified)",
        "https://cag.gov.in/uploads/download_audit_report/2013/Union_Performance_Civil_Sector_3_2013_chapter_3_exe_summ.pdf"
      ],
      [
        "Swarajya — CAG found irregularities in 2008 loan waiver",
        "https://swarajyamag.com/politics/when-cag-found-irregularities-in-upa-government-farm-loan-waiver-in-2008"
      ],
      [
        "The Print — 2008 farm loan waiver designed to be last of its kind",
        "https://theprint.in/report/we-had-designed-2008-farm-loan-waiver-to-be-last-of-its-kind-upa-agriculture-secy/1511/"
      ]
    ],
    "domain": "central"
  },
  {
    "id": "scheme:wb-kanyashree",
    "name": "Kanyashree Prakalpa",
    "al": [
      "Kanyashree",
      "কন্যাশ্রী"
    ],
    "level": "state",
    "st": "wb",
    "applicableStates": null,
    "category": "student",
    "party": "TMC",
    "announced": {
      "date": "2013-03-08",
      "byPersonId": "wel:mamata-banerjee",
      "office": "Chief Minister, West Bengal",
      "srcs": [
        [
          "Wikipedia — Kanyashree Prakalpa",
          "https://en.wikipedia.org/wiki/Kanyashree_Prakalpa"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "West Bengal cabinet/budget — date not verified",
      "srcs": []
    },
    "launched": {
      "date": "2013-10-01",
      "srcs": [
        [
          "Wikipedia — Kanyashree Prakalpa",
          "https://en.wikipedia.org/wiki/Kanyashree_Prakalpa"
        ]
      ]
    },
    "benefit": {
      "amount": 1000,
      "unit": "annual scholarship while unmarried and in school (K1), one-time grant at 18 if unmarried (K2)",
      "changes": [
        {
          "date": "2019-02",
          "amount": null,
          "note": "Income ceiling removed — all girls 13–19 eligible (budget 2019-20); 52.5 lakh covered",
          "srcs": [
            [
              "PRS, West Bengal Budget Analysis 2019-20",
              "https://prsindia.org/budgets/states/west-bengal-budget-analysis-2019-20"
            ]
          ]
        }
      ]
    },
    "eligibility": "unmarried girls aged 13-18 in school/college, household income below threshold",
    "beneficiaries": [
      {
        "asOf": "2019-02",
        "count": 5250000,
        "srcs": [
          [
            "PRS, West Bengal Budget Analysis 2019-20",
            "https://prsindia.org/budgets/states/west-bengal-budget-analysis-2019-20"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2019-20",
        "budgetedCr": null,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS, West Bengal Budget Analysis 2019-20",
            "https://prsindia.org/budgets/states/west-bengal-budget-analysis-2019-20"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "West Bengal assembly",
      "date": "2016-05-04",
      "monthsFromLaunch": 31,
      "incumbentParty": "TMC",
      "result": "incumbent won",
      "seatChange": null,
      "srcs": []
    },
    "status": [
      {
        "date": "2017-01-01",
        "status": "live",
        "note": "Won a UN Public Service Award in 2017; widely regarded as one of the better-evaluated conditional cash-transfer designs in this file.",
        "srcs": [
          [
            "UNICEF — Kanyashree Prakalpa",
            "https://www.unicef.org/india/stories/kanyashree-prakalpa-building-brighter-future-every-girl-west-bengal-0"
          ]
        ]
      },
      {
        "date": "2013-10-01",
        "status": "live",
        "note": "",
        "srcs": [
          [
            "Wikipedia (pointer): Kanyashree Prakalpa",
            "https://en.wikipedia.org/wiki/Kanyashree_Prakalpa"
          ]
        ]
      },
      {
        "date": "2017-06",
        "status": "live",
        "note": "UN Public Service Award (first among 552 nominations from 62 countries)",
        "srcs": [
          [
            "Wikipedia (pointer): Kanyashree Prakalpa",
            "https://en.wikipedia.org/wiki/Kanyashree_Prakalpa"
          ]
        ]
      },
      {
        "date": "2019-02",
        "status": "raised",
        "note": "Eligibility widened: income criterion removed",
        "srcs": [
          [
            "PRS, West Bengal Budget Analysis 2019-20",
            "https://prsindia.org/budgets/states/west-bengal-budget-analysis-2019-20"
          ]
        ]
      },
      {
        "date": "2026-05",
        "status": "live",
        "note": "TMC lost the 2026 election (fleet files); scheme status under the BJP government not opened",
        "srcs": [
          [
            "Wikipedia infobox (pointer to ECI results): 2026 West Bengal Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2026_West_Bengal_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "Independent commentary (IGC, EPW) credits Kanyashree with reductions in child marriage and school dropout in its target cohort, though sustained follow-through by beneficiaries after payments end has been flagged as needing more programmatic push.",
        "tier": "reported",
        "srcs": [
          [
            "UNICEF — Kanyashree Prakalpa",
            "https://www.unicef.org/india/stories/kanyashree-prakalpa-building-brighter-future-every-girl-west-bengal-0"
          ]
        ]
      },
      {
        "finding": "UN Public Service Award 2017; 52.5 lakh girls covered by 2019. Universalisation in the Feb 2019 budget came two months before the 2019 Lok Sabha poll and 26 months before the 2021 state poll — the innocent reading (simplifying targeting) and the timing reading are both open; no evaluation with a control was opened this session.",
        "tier": "analytic",
        "srcs": [
          [
            "Wikipedia (pointer): Kanyashree Prakalpa",
            "https://en.wikipedia.org/wiki/Kanyashree_Prakalpa"
          ],
          [
            "PRS, West Bengal Budget Analysis 2019-20",
            "https://prsindia.org/budgets/states/west-bengal-budget-analysis-2019-20"
          ],
          [
            "Wikipedia infobox (pointer to ECI): 2021 West Bengal Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2021_West_Bengal_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:mamata-banerjee",
        "role": "Chief Minister, West Bengal",
        "action": "announced",
        "date": "2013-03-08",
        "party": "TMC",
        "srcs": [
          [
            "Wikipedia — Kanyashree Prakalpa",
            "https://en.wikipedia.org/wiki/Kanyashree_Prakalpa"
          ]
        ]
      },
      {
        "personId": "wel:mamata-banerjee",
        "role": "Chief Minister, West Bengal",
        "action": "announced",
        "date": "2013-03-08",
        "party": "TMC",
        "srcs": [
          [
            "Wikipedia (pointer): Kanyashree Prakalpa",
            "https://en.wikipedia.org/wiki/Kanyashree_Prakalpa"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "party:tmc",
        "how": "international award used as brand; Kanyashree Divas (14 Aug) is a state event",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "Wikipedia (pointer): Kanyashree Prakalpa",
            "https://en.wikipedia.org/wiki/Kanyashree_Prakalpa"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Wikipedia — Kanyashree Prakalpa",
        "https://en.wikipedia.org/wiki/Kanyashree_Prakalpa"
      ],
      [
        "UNICEF — Kanyashree Prakalpa",
        "https://www.unicef.org/india/stories/kanyashree-prakalpa-building-brighter-future-every-girl-west-bengal-0"
      ],
      [
        "Wikipedia (pointer): Kanyashree Prakalpa",
        "https://en.wikipedia.org/wiki/Kanyashree_Prakalpa"
      ],
      [
        "PRS, West Bengal Budget Analysis 2019-20",
        "https://prsindia.org/budgets/states/west-bengal-budget-analysis-2019-20"
      ],
      [
        "Wikipedia infobox (pointer to ECI): 2021 West Bengal Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2021_West_Bengal_Legislative_Assembly_election"
      ],
      [
        "Wikipedia infobox (pointer to ECI results): 2016 West Bengal Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2016_West_Bengal_Legislative_Assembly_election"
      ]
    ],
    "domain": "elections-timing"
  },
  {
    "id": "scheme:wb-lakshmir-bhandar",
    "name": "Lakshmir Bhandar",
    "al": [
      "Lakshmi Bhandar",
      "লক্ষ্মীর ভান্ডার"
    ],
    "level": "state",
    "st": "wb",
    "applicableStates": null,
    "category": "women-cash",
    "party": "TMC",
    "announced": {
      "date": "2021-02-05",
      "byPersonId": "wel:mamata-banerjee",
      "office": "Chief Minister, West Bengal",
      "srcs": [
        [
          "Vikaspedia — Lakshmir Bhandar scheme",
          "https://en.vikaspedia.in/viewcontent/schemesall/state-specific-schemes/welfare-schemes-of-west-bengal/lakhsmir-bhandar-scheme"
        ]
      ]
    },
    "approved": {
      "date": null,
      "body": "West Bengal Cabinet",
      "srcs": [
        [
          "South 24 Parganas district portal: Lakshmir Bhandar scheme page",
          "https://s24pgs.gov.in/lakshmir-bhandar/"
        ]
      ]
    },
    "launched": {
      "date": null,
      "srcs": [
        [
          "Vikaspedia — Lakshmir Bhandar scheme",
          "https://en.vikaspedia.in/viewcontent/schemesall/state-specific-schemes/welfare-schemes-of-west-bengal/lakhsmir-bhandar-scheme"
        ]
      ]
    },
    "benefit": {
      "amount": 1000,
      "unit": "₹ per month (general category; ₹1,200 for SC/ST at launch)",
      "changes": [
        {
          "date": "2026-02-05",
          "amount": 1500,
          "note": "Raised by ₹500/month (to ₹1,700 for SC/ST) in the interim 2026-27 state budget, roughly 2.5 months before the April 2026 assembly poll.",
          "srcs": [
            [
              "ETV Bharat — WB budget 2026 hikes Lakshmir Bhandar ahead of polls",
              "https://www.etvbharat.com/en/state/west-bengal-budget-2026-mamata-hikes-lakshmir-bhandar-unveils-youth-allowance-and-seventh-pay-commission-ahead-of-polls-enn26020506960"
            ],
            [
              "ANI — WB Rs 500 hike ahead of assembly polls",
              "https://aninews.in/news/national/politics/west-bengal-govt-announces-rs-500-hike-for-lakshmir-bhandar-beneficaries-ahead-of-assembly-polls20260206060332/"
            ]
          ]
        },
        {
          "date": null,
          "amount": 500,
          "note": "RBI Annex 1 describes the 2022-23 design as ₹1,000 to every SC/ST woman and ₹500 to every other woman; PRS gives ₹1,000–1,200 for 2025-26 — i.e. the benefit roughly doubled for the general category between the two documents",
          "srcs": [
            [
              "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
              "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
            ],
            [
              "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
              "https://prsindia.org/files/budget/SOSF_2025.pdf"
            ]
          ]
        },
        {
          "date": "2024-02",
          "amount": 1000,
          "note": "Raised to Rs 1,000 general / Rs 1,200 SC-ST 'just before the parliamentary polls' (announced in Feb 2024 budget)",
          "srcs": [
            [
              "Deccan Herald, 6 Jun 2024: Mamata cashes in on Lakshmir Bhandar in LS 2024",
              "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mamata-banerjee-cashes-in-on-lakshmir-bhandar-and-modis-shift-to-hindutva-in-west-bengal-3055262"
            ],
            [
              "South 24 Parganas district portal: Lakshmir Bhandar scheme page",
              "https://s24pgs.gov.in/lakshmir-bhandar/"
            ]
          ]
        },
        {
          "date": "2026-02",
          "amount": 1500,
          "note": "Rs 500 hike announced in interim budget 2026-27 on 5 Feb 2026, effective February 2026, ~11 weeks before the Apr 2026 poll; TMC manifesto Rs 1,500/1,700; BJP promised Rs 3,000",
          "srcs": [
            [
              "ANI, 6 Feb 2026: West Bengal announces Rs 500 Lakshmir Bhandar hike in interim budget 2026-27",
              "https://www.aninews.in/news/national/politics/west-bengal-govt-announces-rs-500-hike-for-lakshmir-bhandar-beneficaries-ahead-of-assembly-polls20260206060332/"
            ],
            [
              "The Logical Indian, 4 May 2026: fiscal reality behind 2026 cash promises to women",
              "https://thelogicalindian.com/elections-results-2026-the-fiscal-reality-behind-indias-cash-promises-to-women/"
            ]
          ]
        }
      ]
    },
    "eligibility": "women aged 25-60, enrolled in Swasthya Sathi",
    "beneficiaries": [
      {
        "asOf": null,
        "count": null,
        "srcs": [
          [
            "South 24 Parganas district portal: Lakshmir Bhandar scheme page",
            "https://s24pgs.gov.in/lakshmir-bhandar/"
          ]
        ]
      }
    ],
    "outlay": [
      {
        "fy": "2022-23",
        "budgetedCr": 10767,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": 0.6,
        "srcs": [
          [
            "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
            "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 26700,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "fy": "2025-26",
        "budgetedCr": 26700,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "fy": "2026-27",
        "budgetedCr": null,
        "actualCr": null,
        "pctOfStateBudget": null,
        "pctOfGSDP": null,
        "srcs": [
          [
            "The Logical Indian, 4 May 2026: fiscal reality behind 2026 cash promises to women",
            "https://thelogicalindian.com/elections-results-2026-the-fiscal-reality-behind-indias-cash-promises-to-women/"
          ]
        ]
      }
    ],
    "electionContext": {
      "election": "West Bengal assembly",
      "date": "2021-03-27",
      "monthsFromLaunch": 2,
      "incumbentParty": "TMC",
      "result": "incumbent won",
      "seatChange": "TMC 211→215 seats, 48.02% vote share",
      "srcs": [
        [
          "Wikipedia — 2021 West Bengal Legislative Assembly election",
          "https://en.wikipedia.org/wiki/2021_West_Bengal_Legislative_Assembly_election"
        ]
      ]
    },
    "status": [
      {
        "date": "2026-02-05",
        "status": "raised",
        "note": "Benefit raised ~2.5 months before the 2026 poll — textbook pre-election timing by the announcement date — yet TMC went on to lose that election to the BJP, ending 15 years in power. See results.",
        "srcs": [
          [
            "ETV Bharat — WB budget 2026 hikes Lakshmir Bhandar ahead of polls",
            "https://www.etvbharat.com/en/state/west-bengal-budget-2026-mamata-hikes-lakshmir-bhandar-unveils-youth-allowance-and-seventh-pay-commission-ahead-of-polls-enn26020506960"
          ]
        ]
      },
      {
        "date": null,
        "status": "raised",
        "note": "PRS: West Bengal raised its UCT allocation 15% over 2024-25 RE. Allocation grew ~2.5x from ₹10,767 cr (2022-23 BE) to ₹26,700 cr (2025-26 BE).",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ],
          [
            "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
            "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
          ]
        ]
      },
      {
        "date": "2021",
        "status": "live",
        "note": null,
        "srcs": [
          [
            "Deccan Herald, 6 Jun 2024: Mamata cashes in on Lakshmir Bhandar in LS 2024",
            "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mamata-banerjee-cashes-in-on-lakshmir-bhandar-and-modis-shift-to-hindutva-in-west-bengal-3055262"
          ]
        ]
      },
      {
        "date": "2024-04",
        "status": "raised",
        "note": null,
        "srcs": [
          [
            "Deccan Herald, 6 Jun 2024: Mamata cashes in on Lakshmir Bhandar in LS 2024",
            "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mamata-banerjee-cashes-in-on-lakshmir-bhandar-and-modis-shift-to-hindutva-in-west-bengal-3055262"
          ]
        ]
      },
      {
        "date": "2026-02",
        "status": "raised",
        "note": null,
        "srcs": [
          [
            "ANI, 6 Feb 2026: West Bengal announces Rs 500 Lakshmir Bhandar hike in interim budget 2026-27",
            "https://www.aninews.in/news/national/politics/west-bengal-govt-announces-rs-500-hike-for-lakshmir-bhandar-beneficaries-ahead-of-assembly-polls20260206060332/"
          ]
        ]
      },
      {
        "date": "2026-05",
        "status": "live",
        "note": "Status under the BJP government (which promised Rs 3,000) not verified — see gaps",
        "srcs": [
          [
            "The Logical Indian, 4 May 2026: fiscal reality behind 2026 cash promises to women",
            "https://thelogicalindian.com/elections-results-2026-the-fiscal-reality-behind-indias-cash-promises-to-women/"
          ]
        ]
      }
    ],
    "results": [
      {
        "finding": "The 2026 hike is the closest-to-a-poll benefit increase in this entire file by announcement date (~2.5 months), timed identically to the 2021 pre-poll pattern that preceded a TMC win — yet in 2026 TMC lost to the BJP by a wide margin (BJP ~207/294 seats). This is the single clearest counter-case in the file against 'a scheme increase near a poll determines the result': the same tactic, from the same party, on the same scheme, produced opposite outcomes five years apart.",
        "tier": "analytic",
        "srcs": [
          [
            "Republic World — WB 2026 results live, BJP ends TMC 15-year rule",
            "https://www.republicworld.com/elections/west-bengal-assembly-election-results-2026-live-updates-tmc-vs-bjp-mamata-banerjee-suvendu-adhikari-counting-trends-winners-leading-trailing-live-news"
          ]
        ]
      },
      {
        "finding": "RBI (Jun 2022) counted Lakshmir Bhandar as West Bengal's largest 'freebie' line for 2022-23: ₹10,767 cr = 0.6% of GSDP, 5.4% of revenue receipts, 13.6% of own tax revenue; WB total freebies 1.1% of GSDP. RBI also placed WB among five 'highly stressed' states (with Bihar, Kerala, Punjab, Rajasthan).",
        "tier": "documented",
        "srcs": [
          [
            "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
            "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
          ]
        ]
      },
      {
        "finding": "PRS (Oct 2025): at ₹26,700 cr (BE 2025-26) the scheme is 8.9% of West Bengal's revenue expenditure and 10.0% of revenue receipts — the second-highest ratio among the 12 UCT states after Jharkhand.",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      },
      {
        "finding": "No peer-reviewed or quasi-experimental evaluation of Lakshmir Bhandar's effect on consumption, health or women's agency was located in this sweep (Ideas for India search returned none). Effects are therefore unknown, not zero.",
        "tier": "analytic",
        "srcs": [
          [
            "Ideas for India site search 'Lakshmir Bhandar' (opened 25 Sep 2026; returned no evaluation)",
            "https://www.ideasforindia.in/search?q=Lakshmir+Bhandar"
          ]
        ]
      },
      {
        "finding": "Lakshmir Bhandar preceded an AITC gain in LS 2024 (+7 seats) but a landslide loss in the 2026 assembly election despite a pre-poll hike — the strongest single counter-example in this file to 'cash transfers buy elections'",
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald, 6 Jun 2024: Mamata cashes in on Lakshmir Bhandar in LS 2024",
            "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mamata-banerjee-cashes-in-on-lakshmir-bhandar-and-modis-shift-to-hindutva-in-west-bengal-3055262"
          ],
          [
            "Wikipedia (pointer): 2026 West Bengal Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2026_West_Bengal_Legislative_Assembly_election"
          ],
          [
            "The Logical Indian, 4 May 2026: fiscal reality behind 2026 cash promises to women",
            "https://thelogicalindian.com/elections-results-2026-the-fiscal-reality-behind-indias-cash-promises-to-women/"
          ]
        ]
      },
      {
        "finding": "PRS: Assam and West Bengal raised UCT allocations 31% and 15% over 2024-25 RE",
        "tier": "documented",
        "srcs": [
          [
            "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
            "https://prsindia.org/files/budget/SOSF_2025.pdf"
          ]
        ]
      }
    ],
    "ministers": [
      {
        "personId": "wel:mamata-banerjee",
        "role": "Chief Minister, West Bengal",
        "action": "announced",
        "date": "2021-02-05",
        "party": "TMC",
        "srcs": [
          [
            "Vikaspedia — Lakshmir Bhandar scheme",
            "https://en.vikaspedia.in/viewcontent/schemesall/state-specific-schemes/welfare-schemes-of-west-bengal/lakhsmir-bhandar-scheme"
          ]
        ]
      },
      {
        "personId": "wel:mamata-banerjee",
        "role": "Chief Minister",
        "action": "announced",
        "date": "2021-02",
        "party": "AITC",
        "srcs": [
          [
            "South 24 Parganas district portal: Lakshmir Bhandar scheme page",
            "https://s24pgs.gov.in/lakshmir-bhandar/"
          ],
          [
            "Deccan Herald, 6 Jun 2024: Mamata cashes in on Lakshmir Bhandar in LS 2024",
            "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mamata-banerjee-cashes-in-on-lakshmir-bhandar-and-modis-shift-to-hindutva-in-west-bengal-3055262"
          ]
        ]
      },
      {
        "personId": "wel:chandrima-bhattacharya",
        "role": "Finance Minister (MoS, independent charge)",
        "action": "presented budget",
        "date": "2026-02-05",
        "party": "AITC",
        "srcs": [
          [
            "ANI, 6 Feb 2026: West Bengal announces Rs 500 Lakshmir Bhandar hike in interim budget 2026-27",
            "https://www.aninews.in/news/national/politics/west-bengal-govt-announces-rs-500-hike-for-lakshmir-bhandar-beneficaries-ahead-of-assembly-polls20260206060332/"
          ]
        ]
      }
    ],
    "whoElseBenefits": [
      {
        "who": "party:tmc",
        "how": "political: DH describes a 'labharthi varg' (beneficiary class) blunting anti-incumbency in LS 2024",
        "amountCr": null,
        "tier": "analytic",
        "srcs": [
          [
            "Deccan Herald, 6 Jun 2024: Mamata cashes in on Lakshmir Bhandar in LS 2024",
            "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mamata-banerjee-cashes-in-on-lakshmir-bhandar-and-modis-shift-to-hindutva-in-west-bengal-3055262"
          ],
          [
            "Wikipedia (pointer): 2026 West Bengal Legislative Assembly election",
            "https://en.wikipedia.org/wiki/2026_West_Bengal_Legislative_Assembly_election"
          ]
        ]
      }
    ],
    "srcs": [
      [
        "Vikaspedia — Lakshmir Bhandar scheme",
        "https://en.vikaspedia.in/viewcontent/schemesall/state-specific-schemes/welfare-schemes-of-west-bengal/lakhsmir-bhandar-scheme"
      ],
      [
        "Business Today — TMC manifesto Lakshmir Bhandar hike",
        "https://www.businesstoday.in/elections/west-bengal/story/rise-in-lakshmir-bhandar-allocation-by-rs500-rs30000-crore-agriculture-budget-key-highlights-of-tmcs-manifesto-for-west-bengal-polls-521659-2026-03-20"
      ],
      [
        "RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)",
        "https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "South 24 Parganas district portal: Lakshmir Bhandar scheme page",
        "https://s24pgs.gov.in/lakshmir-bhandar/"
      ],
      [
        "Deccan Herald, 6 Jun 2024: Mamata cashes in on Lakshmir Bhandar in LS 2024",
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mamata-banerjee-cashes-in-on-lakshmir-bhandar-and-modis-shift-to-hindutva-in-west-bengal-3055262"
      ],
      [
        "ANI, 6 Feb 2026: West Bengal announces Rs 500 Lakshmir Bhandar hike in interim budget 2026-27",
        "https://www.aninews.in/news/national/politics/west-bengal-govt-announces-rs-500-hike-for-lakshmir-bhandar-beneficaries-ahead-of-assembly-polls20260206060332/"
      ],
      [
        "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6",
        "https://prsindia.org/files/budget/SOSF_2025.pdf"
      ],
      [
        "Wikipedia (pointer): 2026 West Bengal Legislative Assembly election",
        "https://en.wikipedia.org/wiki/2026_West_Bengal_Legislative_Assembly_election"
      ]
    ],
    "domain": "elections-timing"
  },
];

export const WELFARE_ENTITIES: GNode[] = [
  { id: "bjp", label: "BJP", sub: "ruling party", ty: "party", fam: "recipient", st: null, sz: 4, al: ["BJP","Bharatiya Janata Party"], resolved: true, d: ["party of the Union government 2014 →; state governments in MP, CT, RJ (from Dec 2023), Assam, WB (from May 2026) [documented]","Governs the states whose women’s cash schemes post-date the PM’s 16 Jul 2022 ‘freebies culture’ speech: MP Ladli Behna (2023), Maharashtra Ladki Bahin (2024, coalition), Delhi Mahila Samriddhi (2025), Haryana Lado Lakshmi (2025) [documented]","Cheap rice CT, UP waiver, CSMSSY, Raje waiver, Ladli Laxmi, Kanya Sumangala, Namo Laxmi; continued Delhi power subsidy [documented]","Runs Ladli Behna, Ladki Bahin (coalition), Subhadra, Mahtari Vandan, Orunodoi, Lado Lakshmi, Mahila Samriddhi; partner in Bihar MMRY [documented]"], srcs: [["Wikipedia (pointer), 2024 Indian general election","https://en.wikipedia.org/wiki/2024_Indian_general_election"],["India TV News, Assam Election Result 2026 live: BJP wins 82 of 126, 4 May 2026","https://www.indiatvnews.com/north-east/assam/assam-election-result-2026-live-updates-himanta-biswa-sarma-led-bjp-wins-setback-for-congress-1039454"],["India TV News, West Bengal Assembly Election 2026 result: full list of winners, 4 May 2026","https://www.indiatvnews.com/west-bengal/news-west-bengal-assembly-election-2026-full-list-of-winners-leading-candidates-294-seats-2026-05-04-1038758"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PM’s address at inauguration of Bundelkhand Expressway, Jalaun, 16 Jul 2022 — official English rendering (pmindia.gov.in)","https://www.pmindia.gov.in/en/news_updates/pms-address-at-inauguration-of-bundelkhand-expressway-at-jalaun-in-uttar-pradesh/"],["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"],["Deccan Herald, 2025-03-08 — Delhi cabinet clears ₹2,500 for women under Mahila Samriddhi Yojana","https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"],["Deccan Herald, 2025-08-28 — Haryana launches Lado Lakshmi Yojana; women to get ₹2,100 monthly","https://www.deccanherald.com/india/haryana/haryana-decides-to-implement-lado-lakshmi-yojana-eligible-women-to-get-rs-2100-monthly-aid-3700884"],["Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'","https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"],["Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"],["Business Standard/ANI, 15 Apr 2025: Power subsidy for Delhi homes, farmers, lawyers, riot victims to continue (BJP govt)","https://www.business-standard.com/india-news/power-subsidy-for-delhi-homes-farmers-lawyers-riot-victims-to-continue-125041501496_1.html"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "bombay-hc", label: "Bombay High Court", sub: "High Court of Maharashtra and Goa", ty: "agency", fam: "enforce", st: "mh", sz: 2, resolved: true, d: ["2024-08: dismissed a challenge to Ladki Bahin, calling it a beneficiary scheme for women and not discriminatory (as reported) [reported]","Dismissed PIL against Ladki Bahin, 5 Aug 2024: policy decision, no fundamental-rights violation [reported]"], srcs: [["Deccan Herald, 2024-08-05 — Ladki Bahin Yojana a beneficiary scheme for women, not discriminatory: Bombay High Court","https://www.deccanherald.com/india/maharashtra/ladki-bahin-yojana-a-beneficiary-scheme-for-women-not-discriminatory-bombay-high-court-3137089"],["Deccan Herald, 5 Aug 2024: Bombay HC dismisses PIL against Ladki Bahin","https://www.deccanherald.com/india/maharashtra/ladki-bahin-yojana-a-beneficiary-scheme-for-women-not-discriminatory-bombay-high-court-3137089"]] },
  { id: "cag", label: "CAG", sub: "national auditor", ty: "agency", fam: "enforce", st: "dl", sz: 3, al: ["Comptroller and Auditor General"], resolved: true, d: ["Report 14 of 2019 on PMUY; Report 3 of 2013 on ADWDRS; performance audit of MGNREGA 2013 [documented]","CAG Karnataka SFAR 2024-25 (tabled 26 Mar 2026): guarantee schemes cost ₹52,525 cr in 2024-25 and created a 'loop of indebtedness' [reported]","KALIA compliance audit (2024); Aasara performance audit (2021); Karnataka state finances 2024-25 (Mar 2026) [documented]","Report No. 14 of 2019 on PMUY: 42% of 3.78 crore connections issued on beneficiary Aadhaar alone; avg 3.66 refills; ₹1,234.71 crore loan outstanding [documented]","Delhi audit: ad spend ₹46.90 crore (2018) → ₹612.80 crore (2022), campaigns in violation of SC 2015 guidelines [documented]","2025 report on Karnataka guarantees said they were taxing state resources (as paraphrased by DH; report text not obtained) [reported]"], srcs: [["CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)","https://cag.gov.in/"],["CAG Report No. 3 of 2013, ADWDRS 2008 executive summary (PDF is image-only; text not machine-verified)","https://cag.gov.in/uploads/download_audit_report/2013/Union_Performance_Civil_Sector_3_2013_chapter_3_exe_summ.pdf"],["Wikipedia (pointer), MGNREGA 2005","https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"],["Deccan Herald — CAG finds flaws in debt waiver implementation","https://www.deccanherald.com/india/cag-finds-flaws-implementation-debt-2235970"],["Deccan Herald, 26 Mar 2026: 'Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG' (CAG State Finances Audit Report 2024-25, tabled 26 Mar 2026)","https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"],["CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)","https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"],["CAG, Performance Audit of DBT scheme 'Aasara Pensions in Telangana' (2021), Chapter III (PDF)","https://cag.gov.in/uploads/download_audit_report/2021/Chapter-III-Implementation-of-Aasara-Pensions-as-a-DBT-Scheme-065cdb90dd72180.15791130.pdf"],["Deccan Herald, 26 Mar 2026: Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG","https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"],["CAG press release on Performance Audit Report No. 14 of 2019 on PMUY, 11 Dec 2019 (local copy; exact report URL unresolved — see gaps)","https://cag.gov.in/en"],["The Tribune, 'AAP govt violated ad campaign norms, spending rose by 1,200% in 5 yrs: CAG report', 27 Feb 2025","https://www.tribuneindia.com/news/india/aap-govt-violated-ad-campaign-norms-spending-rose-by-1200-in-5-yrs-cag-report/"],["Deccan Herald, 26 Aug 2025: H M Revanna rejects CAG conclusions on Karnataka guarantee schemes","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"]] },
  { id: "co:ashok-leyland", label: "Ashok Leyland Ltd", sub: "Hinduja group commercial-vehicle OEM; parent of Switch Mobility", ty: "company", fam: "capital", st: "tn", sz: 3, resolved: true, d: ["Awarded BMTC's Feb 2024 tender for 820 BS6 diesel buses (₹336 crore state grant); first 100 delivered Sep 2024 [reported]"], srcs: [["Deccan Herald, 'BMTC launches 100 new diesel buses, to get 820 of them by March', 12 Sep 2024","https://www.deccanherald.com/india/karnataka/bengaluru/bmtc-launches-100-new-diesel-buses-to-get-820-of-them-by-march-3188420"]] },
  { id: "co:bharat-petroleum", label: "Bharat Petroleum", sub: "OMC; PMUY connections", ty: "company", fam: "capital", st: "mh", sz: 2, resolved: true, d: ["one of three OMCs issuing PMUY connections and receiving refill subsidy [documented]"], srcs: [["CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)","https://cag.gov.in/"],["PIB, Cabinet approves PMUY targeted subsidy FY 2025-26 (₹300, up to 9 refills), 8 Aug 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2154117"]] },
  { id: "co:bharti-airtel", label: "Bharti Airtel Ltd", sub: "Parent of Airtel Payments Bank", ty: "company", fam: "capital", st: "dl", sz: 3, resolved: true, d: ["Airtel/Airtel Payments Bank fined ₹2.5 crore (interim) and eKYC suspended, Dec 2017, over ₹190 crore of LPG subsidy routed to 31 lakh force-seeded accounts; media reported the money would be returned within 24 hours [reported]"], srcs: [["The Wire, 'Aadhaar Mess: How Airtel Pulled Off Its Rs 190 Crore Magic Trick', 21 Dec 2017","https://m.thewire.in/article/banking/airtel-aadhaar-uidai"]] },
  { id: "co:hindustan-media-ventures", label: "Hindustan Media Ventures Ltd (Hindustan)", sub: "Listed Hindi daily publisher", ty: "company", fam: "capital", st: "br", sz: 2, resolved: true, d: ["₹21.56 crore of central print ads FY2020-21 to FY2024-25 [documented]"], srcs: [["Newslaundry, 'Modi govt spent Rs 910 crore on print ads in 5 years; Times of India biggest beneficiary' (Lok Sabha reply), 4 Aug 2026","https://www.newslaundry.com/2026/08/04/modi-govt-spent-rs-910-crore-on-print-ads-in-5-years-times-of-india-biggest-beneficiary"]] },
  { id: "co:hindustan-petroleum", label: "Hindustan Petroleum", sub: "OMC; PMUY connections", ty: "company", fam: "capital", st: "mh", sz: 2, resolved: true, d: ["HPCL and IOCL issued 2–20 refills in a day to single-bottle PMUY consumers in 3.44 lakh instances (CAG) [documented]"], srcs: [["CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)","https://cag.gov.in/"]] },
  { id: "co:indian-oil", label: "Indian Oil Corporation", sub: "OMC; PMUY connections", ty: "company", fam: "capital", st: "mh", sz: 2, resolved: true, d: ["IOCL software lacked validation checks — 1.88 lakh PMUY connections to male TINs, 0.80 lakh to under-18s (CAG) [documented]"], srcs: [["CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)","https://cag.gov.in/"]] },
  { id: "co:state-bank-of-india", label: "State Bank of India", sub: "largest PMJDY account opener", ty: "psu", fam: "state", st: "mh", sz: 2, resolved: true, d: ["took the lead in Jan Dhan account opening, Sep 2014 (ET via Wikipedia pointer) [reported]","Bank-wise DBT share not published in the sources opened here; recorded as a void [analytic]"], srcs: [["Wikipedia (pointer), Pradhan Mantri Jan Dhan Yojana","https://en.wikipedia.org/wiki/Pradhan_Mantri_Jan_Dhan_Yojana"],["PIB, PMJDY completes 11 years — ₹6.9 lakh crore DBT in FY2024-25, 28 Aug 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2161401"]] },
  { id: "co:sun-tv-network", label: "Sun TV Network Ltd", sub: "Listed broadcaster/cable group associated with the Maran family", ty: "company", fam: "capital", st: "tn", sz: 3, resolved: true, d: ["Alleged by Jayalalithaa (2006, 2011) to gain cable revenue from the free-TV base; unadjudicated [alleged]"], srcs: [["IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?","https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"],["Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme","https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"]] },
  { id: "co:tata-motors", label: "Tata Motors Ltd", sub: "Commercial-vehicle OEM; e-bus GCC operator via TML CV Mobility Solutions", ty: "company", fam: "capital", st: "mh", sz: 3, resolved: true, d: ["Won BMTC's Oct 2022 840-bus BS6 diesel tender, delivered 20, contract later scrapped over technical snags [reported]","1,500 e-buses for DTC, 12-year SOM contract (Dec 2022); 148 e-buses to BMTC at ~₹41/km GCC (2025) [documented]"], srcs: [["Deccan Herald, 'BMTC launches 100 new diesel buses, to get 820 of them by March', 12 Sep 2024","https://www.deccanherald.com/india/karnataka/bengaluru/bmtc-launches-100-new-diesel-buses-to-get-820-of-them-by-march-3188420"],["Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022","https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"],["Wikipedia (pointer), 'Bengaluru Metropolitan Transport Corporation'","https://en.wikipedia.org/wiki/Bangalore_Metropolitan_Transport_Corporation"]] },
  { id: "min:ministry-of-agriculture-and-farmers-welfare", label: "Ministry of Agriculture & Farmers' Welfare", sub: "PM-KISAN, Drone Didi", ty: "ministry", fam: "state", st: null, sz: 3, resolved: true, d: ["implements PM-KISAN through states' land records and PFMS [documented]"], srcs: [["PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"],["PIB (MoA&FW reply), Implementation of Namo Drone Didi scheme, 29 Jul 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2149706"]] },
  { id: "min:ministry-of-consumer-affairs-food-and-public-distribution", label: "Ministry of Consumer Affairs, Food & PD", sub: "NFSA / PMGKAY", ty: "ministry", fam: "state", st: "dl", sz: 3, resolved: true, d: ["runs PMGKAY for 81.35 crore via >5 lakh FPS [documented]","Food subsidy BE 2024-25 ₹2,05,250 crore, 96% of the department's allocation [documented]"], srcs: [["PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"],["PRS Legislative Research, 'Demand for Grants 2024-25 Analysis: Food and Public Distribution'","https://prsindia.org/budgets/parliament/demand-for-grants-2024-25-analysis-food-and-public-distribution"]] },
  { id: "min:ministry-of-finance", label: "Ministry of Finance", sub: "DEA/DFS/DoE", ty: "ministry", fam: "state", st: "dl", sz: 3, resolved: true, d: ["DoE runs DBT via PFMS: 1,206 schemes, ₹20.23 lakh cr since 2014 (to Nov 2024); DFS runs PMJDY [documented]","Issued the DBT-savings and PMJDY releases used here [documented]"], srcs: [["PIB, Ministry of Finance Year Ender 2024: Department of Expenditure (DBT via PFMS), 27 Dec 2024","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2088438"],["PIB (MoF), PMJDY completes 11 years, 28 Aug 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2161401"],["PIB (Ministry of Finance), 'India's DBT: Boosting Welfare Efficiency' — BlueKraft assessment, 21 Apr 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2123192"],["PIB, PMJDY completes 11 years — ₹6.9 lakh crore DBT in FY2024-25, 28 Aug 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2161401"]] },
  { id: "min:ministry-of-information-and-broadcasting", label: "Ministry of Information and Broadcasting", sub: "Central Bureau of Communication buys government advertising", ty: "ministry", fam: "state", st: "dl", sz: 2, resolved: true, d: ["Lok Sabha reply (2026): ₹910.4 crore on print ads FY2020-21 to FY2024-25; ₹5,987.46 crore across all media 2014-15 to 2024-25 [documented]"], srcs: [["Newslaundry, 'Modi govt spent Rs 910 crore on print ads in 5 years; Times of India biggest beneficiary' (Lok Sabha reply), 4 Aug 2026","https://www.newslaundry.com/2026/08/04/modi-govt-spent-rs-910-crore-on-print-ads-in-5-years-times-of-india-biggest-beneficiary"]] },
  { id: "min:ministry-of-micro-small-and-medium-enterprises", label: "Ministry of MSME", sub: "PM Vishwakarma", ty: "ministry", fam: "state", st: null, sz: 2, resolved: true, d: ["₹13,000 cr PM Vishwakarma 2023-24 to 2027-28 [documented]"], srcs: [["PIB (MSME RS reply), PM Vishwakarma outlay ₹13,000 crore and year-wise allocation, 21 Dec 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1989108"]] },
  { id: "min:ministry-of-petroleum-and-natural-gas", label: "Ministry of Petroleum & Natural Gas", sub: "PMUY", ty: "ministry", fam: "state", st: "dl", sz: 2, resolved: true, d: ["PMUY subsidy ₹12,000 cr/yr FY25 and FY26 [documented]","PMUY: 10.33 crore connections (1 Jul 2025); targeted subsidy ₹200→₹300 per cylinder (May 2022, Oct 2023) [documented]"], srcs: [["PIB, Cabinet approves continuation of ₹300 PMUY subsidy for FY 2024-25, 7 Mar 2024","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2012354"],["PIB, Cabinet approves PMUY targeted subsidy FY 2025-26 (₹300, up to 9 refills), 8 Aug 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2154117"],["PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"]] },
  { id: "min:ministry-of-rural-development", label: "Ministry of Rural Development", sub: "MGNREGA, PMAY-G, NSAP, DAY-NRLM", ty: "ministry", fam: "state", st: null, sz: 3, resolved: true, d: ["administers MGNREGA (to 30 Jun 2026) and VB-G RAM G, PMAY-G, NSAP [documented]"], srcs: [["PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"],["PIB (MoRD), PMAY-G progress and Cabinet approval of 2 crore more houses, 7 Feb 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2100659"],["PIB Backgrounder, National Social Assistance Programme, 7 Nov 2025","https://www.pib.gov.in/PressNoteDetails.aspx?NoteId=155928&ModuleId=3"]] },
  { id: "ministry:hr-sewa", label: "Social Justice, Empowerment, Welfare of SCs & BCs and Antyodaya (SEWA) Department, Haryana", sub: "notified Lado Lakshmi", ty: "ministry", fam: "state", st: "hr", sz: 2, resolved: true, d: ["Notification No.40/10/2025-4SW of 15 Sep 2025 [documented]"], srcs: [["Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification","https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"]] },
  { id: "ministry:mh-wcd", label: "Women and Child Development Department, Maharashtra", sub: "administers Ladki Bahin", ty: "ministry", fam: "state", st: "mh", sz: 2, resolved: true, d: ["Ran eKYC and eligibility scrutiny 2025–26 [reported]"], srcs: [["Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification","https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"]] },
  { id: "ministry:mp-wcd", label: "Women and Child Development Department, Madhya Pradesh", sub: "administers Ladli Behna", ty: "ministry", fam: "state", st: "mp", sz: 2, resolved: true, d: ["Runs cmladlibahna.mp.gov.in; 1.31 cr applications, 1.25 cr eligible (portal) [documented]"], srcs: [["Mukhyamantri Ladli Bahna Yojana portal, WCD Madhya Pradesh (accessed 25 Sep 2026)","https://cmladlibahna.mp.gov.in/home.aspx"]] },
  { id: "ministry:or-wcd", label: "Women and Child Development Department, Odisha", sub: "administers Subhadra", ty: "ministry", fam: "state", st: "or", sz: 2, resolved: true, d: ["Issued Subhadra guidelines Aug 2024 (PRS fn.15) [documented]"], srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "party:aap", label: "Aam Aadmi Party", sub: "intervenor opposing the freebies PIL; governs Punjab", ty: "party", fam: "state", sz: 3, al: ["AAP"], resolved: true, d: ["200 units (Delhi), 300 units (Punjab) [documented]","Punjab Rs 1,000 promise (2022) unfulfilled; Delhi Rs 2,100 promise; lost Delhi 2025 [reported]"], srcs: [["LiveLaw, 9 Aug 2022: 'Welfare schemes for poor not freebies…' — AAP intervention opposing the Upadhyay PIL","https://www.livelaw.in/top-stories/welfare-schemes-poor-not-freebies-assess-cost-of-perks-ministers-mpsmlas-corporates-aap-to-supreme-court-206075"],["Business Today, 1 Aug 2019: Kejriwal announces free electricity up to 200 units","https://www.businesstoday.in/latest/economy-politics/story/arvind-kejriwal-free-electricity-up-to-200-units-delhi-from-august-220915-2019-08-01"],["PRS, Punjab Budget Analysis 2022-23","https://prsindia.org/budgets/states/punjab-budget-analysis-2022-23"],["ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs","https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"],["Deccan Herald, 12 Dec 2024: Kejriwal announces Rs 1,000 (Rs 2,100 after polls) for Delhi women","https://www.deccanherald.com/elections/delhi/delhi-assembly-elections-2025-ahead-of-polls-cabinet-approves-proposal-of-giving-rs-1000-to-women-every-months-3314631"],["Wikipedia infobox (pointer to ECI results): 2025 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"]] },
  { id: "party:aiadmk", label: "All India Anna Dravida Munnetra Kazhagam", sub: "Tamil Nadu party", ty: "party", fam: "state", st: "tn", sz: 2, al: ["AIADMK"], resolved: true, d: ["Its 2011 promises of mixers, grinders and fans were litigated in S. Subramaniam Balaji (2013) [documented]","Free mixie-grinder-fan 2011 [reported]"], srcs: [["S. Subramaniam Balaji v Government of Tamil Nadu, SC, 2013-07-05, (2013) 9 SCC 659 — Indian Kanoon","https://indiankanoon.org/doc/106854428/"],["Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women","https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"]] },
  { id: "party:bjd", label: "Biju Janata Dal", sub: "Odisha ruling party 2000–24", ty: "party", fam: "state", st: "or", sz: 2, al: ["BJD"], resolved: true, d: ["KALIA [documented]"], srcs: [["CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)","https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"],["Wikipedia infobox (pointer to ECI): 2019 Odisha Legislative Assembly election","https://en.wikipedia.org/wiki/2019_Odisha_Legislative_Assembly_election"]] },
  { id: "party:brs", label: "Bharat Rashtra Samithi", sub: "governed Telangana 2014–23 (Rythu Bandhu)", ty: "party", fam: "state", st: "tg", sz: 2, al: ["BRS","TRS","Telangana Rashtra Samithi"], resolved: true, d: ["Rythu Bandhu, Aasara [documented]"], srcs: [["Business Standard/ANI, 26 Feb 2018: 'KCR govt to allocate Rs 12,000 cr for crop investment support'","http://www.business-standard.com/article/news-ani/kcr-govt-to-allocate-rs-12-000-cr-for-crop-investment-support-118022600048_1.html"],["Wikipedia infobox (pointer to ECI): 2018 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Telangana_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2023 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"]] },
  { id: "party:cpim", label: "Communist Party of India (Marxist)", sub: "Leads Kerala LDF; in office 2016–26", ty: "party", fam: "recipient", st: "kl", sz: 3, al: ["CPI(M)","LDF"], resolved: true, d: ["Welfare pension raised to Rs 1,600; five months unpaid 2023-24 [reported]"], srcs: [["Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears","https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"],["Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go","https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"]] },
  { id: "party:dmk", label: "Dravida Munnetra Kazhagam", sub: "intervenor opposing the freebies PIL; governed Tamil Nadu 2021–26", ty: "party", fam: "state", st: "tn", sz: 3, al: ["DMK"], resolved: true, d: ["Its 2006 free-television promise was one of the manifesto promises litigated in S. Subramaniam Balaji (2013) [documented]","Free colour TV 2006; free bus for women 2021 [documented]","Ran KMUT from Sep 2023; lost 2026 (59 seats) [reported]"], srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["S. Subramaniam Balaji v Government of Tamil Nadu, SC, 2013-07-05, (2013) 9 SCC 659 — Indian Kanoon","https://indiankanoon.org/doc/106854428/"],["Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme","https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"],["The Federal, 12 Jun 2023: Free bus travel for women — Karnataka model vs TN, Delhi, Punjab","https://thefederal.com/states/south/karnataka/karnataka-introduces-free-bus-travel-for-women-a-comparison-with-other-states"],["Deccan Herald, 15 Sep 2023: Stalin launches Rs 1,000 monthly scheme for 1.06 cr women","https://www.deccanherald.com/india/tamil-nadu/stalin-launches-rs-1000-monthly-assistance-scheme-for-women-heads-of-families-2687619"],["Wikipedia (pointer): 2026 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"]] },
  { id: "party:inc", label: "Indian National Congress", sub: "UPA lead party 2004–14", ty: "party", fam: "recipient", st: null, sz: 3, al: ["Congress","INC"], resolved: true, d: ["led UPA governments that enacted NREGA 2005, ADWDRS 2008, NFSA 2013; 206 seats 2009 → 44 in 2014 → 99 in 2024 [documented]","Ran counter-offers to BJP women’s schemes (Kamal Nath’s ₹1,500/month promise in MP, 2023-03-05) and governs UCT states counted by PRS (Karnataka Gruha Lakshmi, Telangana, Himachal) [documented]","Five guarantees, Dec 2018 waivers, RGKNY, Chiranjeevi, TG waiver 2024, Rythu Bharosa [documented]","Runs Gruha Lakshmi (KA) and Indira Gandhi Pyari Behna (HP); Mahalakshmi cash (TG) unpaid; lost RJ 2023 and MP 2023 on similar promises [reported]"], srcs: [["Wikipedia (pointer), 2009 Indian general election","https://en.wikipedia.org/wiki/2009_Indian_general_election"],["Wikipedia (pointer), 2014 Indian general election","https://en.wikipedia.org/wiki/2014_Indian_general_election"],["Wikipedia (pointer), 2024 Indian general election","https://en.wikipedia.org/wiki/2024_Indian_general_election"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Deccan Herald, 2023-03-05 — Ahead of MP govt’s Ladli Behna launch, Kamal Nath promises women ₹18,000 per year","https://www.deccanherald.com/india/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"],["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"],["Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting","https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"],["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"],["Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed","https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"],["ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals","https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"],["The South First, 8 Jan 2025: fact check — Rs 2,500 Mahalakshmi not paid","https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"],["Deccan Herald, 25 Oct 2023: Gehlot promises Rs 10,000/yr to woman head of family","https://www.deccanherald.com/elections/rajasthan/rajasthan-polls-gehlot-promises-rs-10000year-to-woman-head-of-families-lpg-cylinder-at-rs-500-2740998"],["Deccan Herald, 5 Mar 2023: Kamal Nath promises women Rs 18,000/yr ahead of Ladli Behna launch","https://www.deccanherald.com/national/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"]] },
  { id: "party:jds", label: "Janata Dal (Secular)", sub: "Karnataka; led 2018–19 coalition", ty: "party", fam: "recipient", st: "ka", sz: 3, resolved: true, d: ["Rs 34,000 cr waiver 2018 [documented]"], srcs: [["The Tribune/IANS, 5 Jul 2018: Karnataka waives Rs 34,000 cr farm loans","https://www.tribuneindia.com/news/archive/nation/karnataka-waives-rs-34-000-cr-farm-loans-615599"]] },
  { id: "party:jdu", label: "Janata Dal (United)", sub: "Bihar ruling party 2005→ (NDA)", ty: "party", fam: "state", st: "br", sz: 2, al: ["JD(U)","JDU"], resolved: true, d: ["Balika Cycle 2006 [documented]","Bihar MMRY Sep 2025; won 85 seats Nov 2025 [reported]"], srcs: [["Nitish Kumar's blog, Apr 2010: Mukhyamantri Balika Cycle Yojna","http://nitishspeaks.blogspot.com/2010/04/mukhyamantri-balika-cycle-yojna.html"],["PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"],["Deccan Herald, 15 Nov 2025: Bihar results — NDA 202 seats","https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-results-nda-cruises-to-victory-by-winning-202-seats-and-a-vote-share-of-over-40-3798063"]] },
  { id: "party:jmm", label: "Jharkhand Mukti Morcha", sub: "leads Jharkhand government (Maiyan Samman)", ty: "party", fam: "state", st: "jh", sz: 2, al: ["JMM"], resolved: true, d: ["Launched Maiya Samman Aug 2024; won Nov 2024 (34 seats, alliance majority) [reported]"], srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["IMPRI policy update: Mukhyamantri Maiya Samman Yojana in practice","https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"],["Wikipedia infobox (pointer to ECI results): 2024 Jharkhand Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Jharkhand_Legislative_Assembly_election"]] },
  { id: "party:ncp", label: "Nationalist Congress Party (Ajit Pawar)", sub: "political party", ty: "party", fam: "state", st: "mh", sz: 2, al: ["NCP"], resolved: true, d: ["Holds Finance (Ajit Pawar) and WCD (Aditi Tatkare); manifesto promised Rs 2,100 [reported]"], srcs: [["Deccan Herald, 6 Nov 2024: NCP manifesto promises Ladki Bahin Rs 2,100","https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ajit-pawars-ncp-releases-constituency-wise-manifesto-promises-increase-in-ladki-bahin-yojana-amount-3264259"],["Deccan Herald, 10 Mar 2025: Maharashtra budget gives Rs 36,000 cr to Ladki Bahin, silent on Rs 2,100","https://www.deccanherald.com/india/maharashtra/maharashtra-govt-gives-rs-36000-crore-to-ladki-bahin-in-budget-mum-on-stipend-hike-ups-vehicle-tax-3440102"]] },
  { id: "party:rjd", label: "Rashtriya Janata Dal", sub: "UPA-I ally", ty: "party", fam: "recipient", st: null, sz: 2, al: ["RJD"], resolved: true, d: ["party of RD minister Raghuvansh Prasad Singh 2004-09 [documented]"], srcs: [["Wikipedia (pointer), Raghuvansh Prasad Singh","https://en.wikipedia.org/wiki/Raghuvansh_Prasad_Singh"]] },
  { id: "party:shiv-sena", label: "Shiv Sena (Shinde)", sub: "political party", ty: "party", fam: "state", st: "mh", sz: 2, al: ["SHS"], resolved: true, d: ["Led government that launched Ladki Bahin; promised Rs 3,000 [reported]"], srcs: [["Deccan Herald, 14 Sep 2024: Shinde — bigger mandate, will raise Ladki Bahin to Rs 3,000","https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-give-us-a-bigger-mandate-will-double-ladki-bahin-dole-to-rs-3000-eknath-shinde-3191037"]] },
  { id: "party:shiv-sena-ubt", label: "Shiv Sena (UBT)", sub: "Led the MVA government 2019–22 (undivided Shiv Sena)", ty: "party", fam: "recipient", st: "mh", sz: 3, al: ["SS(UBT)"], resolved: true, d: ["MJPSKY 2019 [documented]"], srcs: [["Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"]] },
  { id: "party:sp", label: "Samajwadi Party", sub: "political party", ty: "party", fam: "state", st: null, sz: 2, al: ["SP"], resolved: true },
  { id: "party:tdp", label: "Telugu Desam Party", sub: "AP ruling party 2014–19, 2024→", ty: "party", fam: "state", st: "ap", sz: 2, al: ["TDP"], resolved: true, d: ["Superseded YSR schemes (Annadata Sukhibhava, NTR Bharosa) [documented]","Super Six promises 2024; Talliki Vandanam Jun 2025 [reported]"], srcs: [["PRS, Andhra Pradesh Budget Analysis 2024-25","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2024-25"],["Deccan Herald/PTI, 13 Jun 2025: AP launches Talliki Vandanam Rs 15,000 per child","https://www.deccanherald.com/india/andhra-pradesh/andhra-govt-launches-talliki-vandanam-scheme-rs-15000-to-be-given-for-school-going-child-3584484"],["Wikipedia infobox (pointer to ECI results): 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"]] },
  { id: "party:tmc", label: "All India Trinamool Congress", sub: "governed West Bengal 2011–26 (Lakshmir Bhandar)", ty: "party", fam: "state", st: "wb", sz: 3, al: ["TMC","AITC","Trinamool"], resolved: true, d: ["Kanyashree [pointer]","Ran Lakshmir Bhandar 2021–26; won 2021 (215), gained in LS 2024, lost 2026 (80) [reported]"], srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Wikipedia (pointer): Kanyashree Prakalpa","https://en.wikipedia.org/wiki/Kanyashree_Prakalpa"],["Wikipedia infobox (pointer to ECI results): 2021 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2021_West_Bengal_Legislative_Assembly_election"],["Deccan Herald, 6 Jun 2024: Mamata cashes in on Lakshmir Bhandar in LS 2024","https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mamata-banerjee-cashes-in-on-lakshmir-bhandar-and-modis-shift-to-hindutva-in-west-bengal-3055262"],["Wikipedia (pointer): 2026 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2026_West_Bengal_Legislative_Assembly_election"]] },
  { id: "party:tvk", label: "Tamilaga Vettri Kazhagam", ty: "party", fam: "state", sz: 2, al: ["TVK"], resolved: true, srcs: [["Wikipedia — 2026 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"]] },
  { id: "party:ysrcp", label: "YSR Congress Party", sub: "governed Andhra Pradesh 2019–24", ty: "party", fam: "state", st: "ap", sz: 2, al: ["YSRCP"], resolved: true, d: ["Navaratnalu DBT package; lost 2024 [documented]"], srcs: [["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"],["Wikipedia infobox (pointer to ECI): 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"],["The Print, 18 Apr 2024: As Jagan banks on direct benefit schemes in AP, voters split","https://theprint.in/politics/as-jagan-banks-on-direct-benefit-schemes-in-ap-voters-split-anxiety-over-jobs-cost-of-living/2046063/"]] },
  { id: "pol:hardeep-singh-puri", label: "Hardeep Singh Puri", sub: "Union Minister", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["PMUY ₹300 subsidy continued FY25 (12 refills) and FY26 (9 refills) under his ministry [documented]","Administers PMUY through the three OMCs; 10.33 crore connections as of 1 Jul 2025 [documented]"], srcs: [["PIB, Cabinet approves continuation of ₹300 PMUY subsidy for FY 2024-25, 7 Mar 2024","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2012354"],["PIB, Cabinet approves PMUY targeted subsidy FY 2025-26 (₹300, up to 9 refills), 8 Aug 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2154117"],["PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"]] },
  { id: "pol:hd-kumaraswamy", label: "H. D. Kumaraswamy", sub: "Chief Minister", ty: "person", fam: "state", st: "ka", sz: 3, resolved: true, d: ["Waived Rs 34,000 cr in the 2018-19 budget, 5 Jul 2018 [documented]"], srcs: [["The Tribune/IANS, 5 Jul 2018: Karnataka waives Rs 34,000 cr farm loans","https://www.tribuneindia.com/news/archive/nation/karnataka-waives-rs-34-000-cr-farm-loans-615599"],["Deccan Herald, 30 May 2018: Kumaraswamy announces two-phase farmer loan waiver","https://www.deccanherald.com/india/karnataka/kumaraswamy-announces-two-phase-farmer-loan-waiver-672438.html"]] },
  { id: "pol:jagat-prakash-nadda", label: "Jagat Prakash Nadda", sub: "BJP national president 2020–25; Union Health Minister", ty: "person", fam: "state", st: null, sz: 2, al: ["J P Nadda"], resolved: true, d: ["Quoted promising Rs 50,000 vouchers to Odisha women under Subhadra, May 2024 [reported]","Congratulated Delhi CM on Mahila Samriddhi cabinet approval, 8 Mar 2025 [reported]"], srcs: [["Business Standard, 16 May 2024: BJP 'promises' Rs 50,000 vouchers to women, then clarifies Odisha-only","https://www.business-standard.com/elections/assembly-election/lok-sabha-elections-bjp-promises-rs-50-000-cash-vouchers-to-women-then-clarifies-124051600178_1.html"],["Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr","https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"]] },
  { id: "pol:narendra-modi", label: "Narendra Modi", sub: "Prime Minister", ty: "person", fam: "state", st: null, sz: 4, resolved: true, d: ["announced free ration for 80 crore for five years at Durg rally, 4 Nov 2023, three days before Chhattisgarh phase-1 polling [reported]","personally releases each PM-KISAN instalment; 22nd from Guwahati 13 Mar 2026, 23rd from Hooghly WB 20 Jun 2026 [documented]","16 Jul 2022, Bundelkhand Expressway, Jalaun: 'every effort is being made … to introduce the culture of collecting votes by distributing freebies. This culture of freebies is very dangerous for the development of the country'; 'The double-engine governments are not adopting the shortcut of distributing freebies' [documented]","Chaired the Union Cabinet that approved the PMUY targeted subsidy of ₹300/cylinder for FY2025-26 at ₹12,000 crore, 8 Aug 2025 [documented]","Launched PMJDY on 28 Aug 2014; PIB credits ₹6.9 lakh crore of DBT to bank accounts in FY2024-25 [documented]","Launched Odisha's Subhadra on 17 Sep 2024 in Bhubaneswar [documented]","Launched Chhattisgarh's Mahtari Vandan on 10 Mar 2024 via video conference [documented]","Launched Bihar's Mukhyamantri Mahila Rojgar Yojana on 26 Sep 2025 [documented]","Warned against 'revadi culture' of freebies for votes, Jalaun, 16 Jul 2022 [reported]"], srcs: [["ThePrint/ANI, 'Guarantee of Modi': PM extends free ration scheme for 5 years in poll-bound Chhattisgarh, MP, 4 Nov 2023","https://theprint.in/india/guarantee-of-modi-pm-extends-free-ration-scheme-for-5-years-in-poll-bound-chhattisgarh-mp/1832402/"],["PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"],["PIB, PM to release 23rd instalment from Tarakeswar, Hooghly, WB on 20 Jun 2026, 18 Jun 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2274616"],["PMO India, 'PM's address at inauguration of Bundelkhand Expressway at Jalaun, UP', 16 Jul 2022 (English text + PMO tweets in Hindi)","https://www.pmindia.gov.in/en/news_updates/pms-address-at-inauguration-of-bundelkhand-expressway-at-jalaun-in-uttar-pradesh/"],["PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"],["PIB, PMJDY completes 11 years — ₹6.9 lakh crore DBT in FY2024-25, 28 Aug 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2161401"],["PIB, 17 Sep 2024: PM launches SUBHADRA in Bhubaneswar","https://www.pib.gov.in/PressReleseDetailm.aspx?PRID=2055572&reg=3&lang=2"],["PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr","https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"],["PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"],["The Tribune/PTI, 16 Jul 2022: PM Modi warns against 'revadi culture' at Jalaun","https://www.tribuneindia.com/news/uncategorized/revadi-culture-dangerous-for-development-of-country-says-pm-modi-urges-youth-to-guard-against-it-413011/"]] },
  { id: "pol:nirmala-sitharaman", label: "Nirmala Sitharaman", sub: "Union Finance Minister", ty: "person", fam: "state", st: null, sz: 3, resolved: true, d: ["announced ₹1.70 lakh cr PM Garib Kalyan package incl. free grain, 26 Mar 2020 [documented]","interim budget 1 Feb 2024 raised Lakhpati Didi target to 3 crore and promised 2 crore more PMAY-G houses; no new cash transfer announced [documented]","Finance Ministry issued the 11-year PMJDY statement (56 crore accounts, ₹2.68 lakh crore deposits) and the DBT-savings release citing BlueKraft [documented]"], srcs: [["PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"],["Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)","https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"],["Union Budget 2023-24 speech, Nirmala Sitharaman, 1 Feb 2023","https://www.indiabudget.gov.in/budget2023-24/doc/Budget_Speech.pdf"],["PIB, PMJDY completes 11 years — ₹6.9 lakh crore DBT in FY2024-25, 28 Aug 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2161401"],["PIB (Ministry of Finance), 'India's DBT: Boosting Welfare Efficiency' — BlueKraft assessment, 21 Apr 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2123192"]] },
  { id: "pol:pankaj-chaudhary", label: "Pankaj Chaudhary", sub: "Minister of State, Finance", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["31 Jul 2023 LS reply: 14.83 lakh MSSC accounts, >₹8,000 cr [documented]","Quoted in the PMJDY 11-year release on saturation camps in 2.7 lakh gram panchayats [documented]"], srcs: [["Akashvani News, over 14.83 lakh MSSC accounts opened, MoS Finance in LS, 31 Jul 2023","https://www.newsonair.gov.in/over-14-83-lakh-accounts-opened-under-mahila-samman-savings-certificate-scheme-govt-in-ls"],["PIB (MoF), PMJDY completes 11 years, 28 Aug 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2161401"],["PIB, PMJDY completes 11 years — ₹6.9 lakh crore DBT in FY2024-25, 28 Aug 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2161401"]] },
  { id: "pol:piyush-goyal", label: "Piyush Goyal", sub: "Union Minister", ty: "person", fam: "state", st: null, sz: 3, resolved: true, d: ["presented Interim Budget 1 Feb 2019: PM-KISAN ₹6,000/yr, ₹75,000 cr BE 2019-20, ₹20,000 cr RE 2018-19, first instalment before 31 Mar 2019 [documented]"], srcs: [["Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)","https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"]] },
  { id: "pol:pralhad-joshi", label: "Pralhad Joshi", sub: "Union Minister", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["administers the five-year free-grain programme approved Nov 2023 [documented]","Agreed Rs 22.5/kg rice to Karnataka Feb–Jun 2025 [reported]","Administers PMGKAY/NFSA distribution via FCI; food subsidy BE 2024-25 ₹2,05,250 crore [documented]"], srcs: [["PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"],["Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024","https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"],["PRS Legislative Research, 'Demand for Grants 2024-25 Analysis: Food and Public Distribution'","https://prsindia.org/budgets/parliament/demand-for-grants-2024-25-analysis-food-and-public-distribution"]] },
  { id: "pol:sarbananda-sonowal", label: "Sarbananda Sonowal", sub: "CM Assam 2016–21; Union Minister", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["Chief Minister of Assam at Orunodoi's 2020 launch [reported]"], srcs: [["ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month","https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"]] },
  { id: "pol:shivraj-singh-chouhan", label: "Shivraj Singh Chouhan", sub: "Rural Development & Agriculture 2024→ (BJP)", ty: "person", fam: "state", st: "mp", sz: 3, al: ["Mama"], resolved: true, d: ["moved VB-G RAM G Bill in Rajya Sabha 18 Dec 2025; said it 'removes shortcomings of MGNREGA' (30 Dec 2025) [documented]","Ladli Behna Yojana was launched by his government in 2023; Lokniti-CSDS MP post-poll asked respondents to rate ‘Shivraj Singh Chouhan’s government’ (Q2a) and found 80.4% of households reporting a Ladli Behna beneficiary (Q22) [documented]","Inaugurated Ladli Laxmi 2 May 2007 [pointer]","Ladli Behna was announced and launched under his fourth term; the ₹260 crore pre-election publicity spend disclosed in 2025 relates to that period [documented]","Cabinet under him cleared Ladli Behna Rs 1,000/month on 25 Feb 2023 [documented]","Raised amount to Rs 1,250 before Nov 2023 poll [reported]","Promised Rs 450 LPG cylinders to Ladli Behna beneficiaries during campaign [reported]"], srcs: [["Akashvani News, Rajya Sabha takes up VB-G RAM G Bill, 18 Dec 2025","https://www.newsonair.gov.in/lok-sabha-considers-viksit-bharat-bill-to-replace-2005-rural-employment-scheme"],["Akashvani News, Chouhan says VB-G RAM G Bill removes shortcomings of MGNREGA, 30 Dec 2025","https://www.newsonair.gov.in/union-minister-shivraj-singh-chouhan-says-viksit-bharat-g-ram-g-bill-removes-shortcomings-of-mgnrega"],["Lokniti-CSDS — Madhya Pradesh Postpoll Survey 2023: Survey Findings (N=3,050, 18–24 Nov 2023; PDF held locally; Lokniti state-election index page opened)","https://www.lokniti.org/state-assembly-elections"],["Deccan Herald, 2023-03-05 — Ahead of MP govt’s Ladli Behna launch, Kamal Nath promises women ₹18,000 per year","https://www.deccanherald.com/india/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"],["Wikipedia (pointer): Ladli Laxmi Yojana","https://en.wikipedia.org/wiki/Ladli_Laxmi_Yojana"],["Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025","https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"],["Deccan Herald/PTI, 25 Feb 2023: MP cabinet clears Ladli Bahna Rs 1,000","https://www.deccanherald.com/india/mp-govt-clears-scheme-to-give-rs-1000-to-women-above-23-under-ladli-bahna-yojana-1195069.html"],["Deccan Herald, 3 Dec 2023: What worked for BJP in MP","https://www.deccanherald.com/india/madhya-pradesh/focus-on-women-voters-to-pm-modis-magic-what-worked-for-bjp-in-madhya-pradesh-assembly-elections-2794883"]] },
  { id: "pradhan", label: "Dharmendra Pradhan", sub: "Petroleum 2014–21", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["PMUY launched May 2016 under MoPNG; CAG Report 14 of 2019 audited May 2016–Dec 2018 [documented]"], srcs: [["CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)","https://cag.gov.in/"],["Wikipedia (pointer), Pradhan Mantri Ujjwala Yojana","https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"]] },
  { id: "psu:hartron", label: "HARTRON (Haryana State Electronics Development Corporation)", sub: "state PSU; developer of the Lado Lakshmi app", ty: "psu", fam: "state", st: "hr", sz: 1, resolved: true, d: ["Gazette names HARTRON as developer of the Lado Lakshmi App; verification by CRID against the PPP database [documented]"], srcs: [["Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification","https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"]] },
  { id: "sc", label: "Supreme Court of India", sub: "apex court; freebies PIL W.P.(C) 43/2022", ty: "agency", fam: "enforce", st: "dl", sz: 3, resolved: true, d: ["26 Aug 2022: referred the freebies petitions to a three-judge bench and flagged reconsideration of S. Subramaniam Balaji (2013) [documented]","1 Nov 2022: Lalit CJI bench directed early listing before a three-judge bench [reported]","19 Feb 2026: CJI Surya Kant, in a TN power-distribution case, asked 'Why suddenly schemes are announced near elections?' (oral remarks, not an order) [reported]","S. Subramaniam Balaji v Tamil Nadu (2013-07-05): manifesto promises of free TVs, mixers, grinders are not ‘corrupt practice’ under s.123 RPA; ECI directed to frame manifesto guidelines [documented]","Ashwini Kumar Upadhyay v UoI (2022-08-26): freebies petitions referred to a three-judge bench; parties asked for Balaji to be reconsidered; Union suggested an expert commission; ECI said it had limited power over party promises [documented]"], srcs: [["Supreme Court of India, order dated 26 Aug 2022 in W.P.(C) 43/2022 (N.V. Ramana CJI, Hima Kohli, C.T. Ravikumar JJ) — reference to three-judge bench (copy hosted by SCO)","https://www.scobserver.in/wp-content/uploads/2022/08/Freebies-Order-August-26th.pdf"],["LiveLaw, 1 Nov 2022: 'Election Freebies | Supreme Court directs matter to be listed before three judge bench at the earliest' (U.U. Lalit CJI, Bela M. Trivedi J)","https://www.livelaw.in/top-stories/election-freebies-supreme-court-directs-matter-to-be-listed-before-three-judge-bench-at-the-earliest-212939"],["LiveLaw, 19 Feb 2026: ''Why cash transfer schemes just before elections?' Supreme Court slams freebies culture' (Surya Kant CJI, Bagchi, Pancholi JJ; TN Power Distribution Co. challenge to Electricity Amendment Rules 2024)","https://www.livelaw.in/top-stories/why-cash-transfer-schemes-just-before-elections-supreme-court-slams-freebies-culture-says-nation-building-hampered-523778"],["S. Subramaniam Balaji v Government of Tamil Nadu, SC, 2013-07-05, (2013) 9 SCC 659 — Indian Kanoon","https://indiankanoon.org/doc/106854428/"],["Ashwini Kumar Upadhyay v Union of India, W.P.(C) 43/2022, SC order 2022-08-26 (reference to three-judge bench) — Indian Kanoon","https://indiankanoon.org/doc/82460936/"]] },
  { id: "wel:aaditya-thackeray", label: "Aaditya Thackeray", sub: "MLA Worli, Maharashtra; former Minister of Tourism and Environment (2019-12→2022-06); Shiv Sena (UBT) leader", ty: "person", fam: "state", st: "mh", sz: 2, resolved: true, d: ["On 2025-04-16 claimed the Ladki Bahin scheme was ‘more or less finished’ amid a state budget row [alleged]","Publicised the ~₹200 crore Ladki Bahin publicity RTI figure and said the money should have gone to beneficiaries (Oct 2024) [reported]","Apr 2025: scheme 'more or less ended' [alleged]"], srcs: [["Deccan Herald (PTI), 2025-04-16 — Ladki Bahin scheme ‘more or less finished’, claims Aaditya Thackeray","https://www.deccanherald.com/india/maharashtra/ladki-bahin-scheme-more-or-less-finished-claims-aaditya-thackeray-3496353"],["Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024","https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"],["Deccan Herald, 16 Apr 2025: Aaditya Thackeray says Ladki Bahin 'more or less ended'; Tatkare response","https://www.deccanherald.com/india/maharashtra/ladki-bahin-scheme-more-or-less-finished-claims-aaditya-thackeray-3496353"]] },
  { id: "wel:aditi-tatkare", label: "Aditi Tatkare", sub: "Minister, Women and Child Development, Maharashtra (NCP)", ty: "person", fam: "state", st: "mh", sz: 2, resolved: true, d: ["Aug 2024: 80 lakh paid, 1.62 cr registered [reported]","Feb 2025: 5 lakh found ineligible, no recovery [reported]","Jul 2025: 26.34 lakh suspended for June instalment [reported]","Jul 2026: eKYC delayed by MCC [reported]"], srcs: [["Deccan Herald, 15 Aug 2024: Shinde govt begins releasing Ladki Bahin money","https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"],["Deccan Herald, 9 Feb 2025: Ladki Bahin beneficiaries drop by 5 lakh; no recovery","https://www.deccanherald.com/india/maharashtra/ladki-bahin-beneficiaries-drop-by-5-lakh-no-taking-back-money-from-those-ineligible-says-minister-3397268"],["Deccan Herald, 29 Jul 2025: Supriya Sule alleges Rs 4,800 cr fraud, seeks SIT","https://www.deccanherald.com/india/maharashtra/supriya-sule-alleges-rs-4800-crore-fraud-in-ladki-bahin-yojana-seeks-sit-probe-3654533"],["Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification","https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"]] },
  { id: "wel:aea-journals", label: "American Economic Association journals", sub: "AER / AEJ: Applied", ty: "agency", fam: "enforce", st: null, sz: 2, resolved: true, d: ["Imbert-Papp (AEJ Applied 2015) and MNS Smartcards (AER 2016) [documented]","Bihar cycle programme: +32% girls' secondary enrolment [documented]"], srcs: [["Imbert & Papp, 'Labor Market Effects of Social Programs: Evidence from India's Employment Guarantee', AEJ: Applied 7(2), 2015","https://www.aeaweb.org/articles?id=10.1257/app.20130401"],["Muralidharan, Niehaus & Sukhtankar, 'Building State Capacity: Evidence from Biometric Smartcards in India', AER 106(10), 2016","https://www.aeaweb.org/articles?id=10.1257/aer.20141346"],["Muralidharan & Prakash, 'Cycling to School: Increasing Secondary School Enrollment for Girls in India', AEJ: Applied Economics 9(3), Jul 2017 — abstract","https://www.aeaweb.org/articles?id=10.1257/app.20160004"],["Muralidharan, Niehaus & Sukhtankar, 'Building State Capacity: Evidence from Biometric Smartcards in India', AER 106(10), Oct 2016 — abstract","https://www.aeaweb.org/articles?id=10.1257/aer.20141346"],["Muralidharan & Prakash (2017), 'Cycling to School', AEJ: Applied Economics 9(3) — AEA abstract page","https://www.aeaweb.org/articles?id=10.1257/app.20160004"]] },
  { id: "wel:airtel-payments-bank", label: "Airtel Payments Bank Ltd", sub: "Payments bank subsidiary of Bharti Airtel; BC network", ty: "company", fam: "capital", st: "dl", sz: 2, resolved: true, d: ["UIDAI action Dec 2017 over Aadhaar-seeded accounts receiving PAHAL LPG subsidy [reported]"], srcs: [["The Wire, 'Aadhaar Mess: How Airtel Pulled Off Its Rs 190 Crore Magic Trick', 21 Dec 2017","https://m.thewire.in/article/banking/airtel-aadhaar-uidai"]] },
  { id: "wel:ajit-pawar", label: "Ajit Pawar", sub: "Dy CM and Finance Minister, Maharashtra (NCP)", ty: "person", fam: "state", st: "mh", sz: 2, resolved: true, d: ["Budget 2025-26: Rs 36,000 cr for Ladki Bahin; 2.53 cr women got Rs 33,232 cr in 2024-25 [reported]","NCP manifesto Nov 2024 promised Rs 2,100 [reported]","Apr 2025: 'no question of scrapping' the scheme [reported]"], srcs: [["Govt of Maharashtra (Nashik) — Ladki Bahin Yojana","https://nashik.gov.in/en/scheme/mukhyamantri-mazi-ladki-bahin-yojana/"],["Deccan Herald, 10 Mar 2025: Maharashtra budget gives Rs 36,000 cr to Ladki Bahin, silent on Rs 2,100","https://www.deccanherald.com/india/maharashtra/maharashtra-govt-gives-rs-36000-crore-to-ladki-bahin-in-budget-mum-on-stipend-hike-ups-vehicle-tax-3440102"],["Deccan Herald, 6 Nov 2024: NCP manifesto promises Ladki Bahin Rs 2,100","https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ajit-pawars-ncp-releases-constituency-wise-manifesto-promises-increase-in-ladki-bahin-yojana-amount-3264259"],["Deccan Herald, 16 Apr 2025: Aaditya Thackeray says Ladki Bahin 'more or less ended'; Tatkare response","https://www.deccanherald.com/india/maharashtra/ladki-bahin-scheme-more-or-less-finished-claims-aaditya-thackeray-3496353"]] },
  { id: "wel:akhilesh-yadav", label: "Akhilesh Yadav", sub: "Chief Minister of Uttar Pradesh, 2012-03-15→2017-03-19; Samajwadi Party president", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["Government bought 14,81,118 HP laptops under the 2012-13 free-laptop scheme (₹2,800 crore budget) but distributed 6,11,794 by 2014, per the 2017 probe ordered by the successor government [reported]"], srcs: [["Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'","https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"]] },
  { id: "wel:amar-ujala", label: "Amar Ujala Publications", sub: "Private Hindi daily", ty: "company", fam: "capital", st: "up", sz: 1, resolved: true, d: ["₹24.92 crore of central print ads FY2020-21 to FY2024-25 [documented]"], srcs: [["Newslaundry, 'Modi govt spent Rs 910 crore on print ads in 5 years; Times of India biggest beneficiary' (Lok Sabha reply), 4 Aug 2026","https://www.newslaundry.com/2026/08/04/modi-govt-spent-rs-910-crore-on-print-ads-in-5-years-times-of-india-biggest-beneficiary"]] },
  { id: "wel:amarinder-singh", label: "Amarinder Singh", sub: "Chief Minister", ty: "person", fam: "state", st: "pb", sz: 3, resolved: true, d: ["Announced waiver for 10.25 lakh farmers in the Assembly, 19 Jun 2017 [documented]","Launched the ₹92 crore Punjab Smart Connect smartphone scheme on 12 Aug 2020 for 1,74,015 Class XII students, calling it a poll promise fulfilled [documented]"], srcs: [["Business Standard, 19 Jun 2017: Punjab CM Amarinder Singh announces crop loan waiver for 10.25 lakh farmers","https://www.business-standard.com/article/economy-policy/punjab-cm-amarinder-singh-announces-crop-loan-waiver-for-10-25-lakh-farmers-117061901226_1.html"],["The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020","https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"]] },
  { id: "wel:arun-jaitley", label: "Arun Jaitley", sub: "Finance Minister 2014–19 (BJP)", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["Budget 2017-18: ₹48,000 cr for MGNREGA, then the highest BE [reported]"], srcs: [["Wikipedia (pointer), MGNREGA 2005","https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"]] },
  { id: "wel:arvind-kejriwal", label: "Arvind Kejriwal", sub: "Chief Minister", ty: "person", fam: "state", st: "dl", sz: 2, resolved: true, d: ["Announced free power up to 200 units, 1 Aug 2019 [documented]","Delhi govt ad spend rose from ₹46.90 crore (2018) to ₹612.80 crore (2022) per CAG; L-G ordered recovery of ~₹97 crore for political ads published as government ads [documented]","RTI: ₹274 crore spent on ads Feb 2015–Feb 2019, about four times the Sheila Dikshit-era annual average [reported]","12 Dec 2024: Delhi cabinet cleared Rs 1,000; promised Rs 2,100 after polls [reported]","Punjab Rs 1,000 guarantee (2022) unfulfilled to Jan 2025 [reported]"], srcs: [["Wikipedia — 2025 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"],["Business Today, 1 Aug 2019: Kejriwal announces free electricity up to 200 units","https://www.businesstoday.in/latest/economy-politics/story/arvind-kejriwal-free-electricity-up-to-200-units-delhi-from-august-220915-2019-08-01"],["The Tribune, 'AAP govt violated ad campaign norms, spending rose by 1,200% in 5 yrs: CAG report', 27 Feb 2025","https://www.tribuneindia.com/news/india/aap-govt-violated-ad-campaign-norms-spending-rose-by-1200-in-5-yrs-cag-report/"],["ThePrint, 'Kejriwal govt spent Rs 274 crore on ads since 2015, four times Congress tab' (RTI), 1 Apr 2019","https://theprint.in/politics/kejriwals-delhi-govt-spent-rs-274-crore-on-ads-since-2015-four-times-more-than-congress/214151/"],["Deccan Herald, 12 Dec 2024: Kejriwal announces Rs 1,000 (Rs 2,100 after polls) for Delhi women","https://www.deccanherald.com/elections/delhi/delhi-assembly-elections-2025-ahead-of-polls-cabinet-approves-proposal-of-giving-rs-1000-to-women-every-months-3314631"],["ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs","https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"]] },
  { id: "wel:ashish-sood", label: "Ashish Sood", sub: "Power Minister", ty: "person", fam: "state", st: "dl", sz: 3, resolved: true, d: ["Cabinet decision to continue subsidy, 15 Apr 2025 [reported]"], srcs: [["Business Standard/ANI, 15 Apr 2025: Power subsidy for Delhi homes, farmers, lawyers, riot victims to continue (BJP govt)","https://www.business-standard.com/india-news/power-subsidy-for-delhi-homes-farmers-lawyers-riot-victims-to-continue-125041501496_1.html"]] },
  { id: "wel:ashok-gehlot", label: "Ashok Gehlot", sub: "Chief Minister", ty: "person", fam: "state", st: "rj", sz: 2, resolved: true, d: ["First order: cooperative loan waiver, Rs 8,000 cr burden, 19 Dec 2018 [documented]","Budget 2021-22: Rs 5 lakh universal health insurance [documented]","Launched the Indira Gandhi Smartphone Yojana on 10 Aug 2023: ₹6,800 per phone paid by DBT, 40 lakh women in phase 1 of a 1.35 crore target, ~3.5 months before the assembly election [documented]","Promised Rs 10,000/yr to woman head of family, 25 Oct 2023 [reported]"], srcs: [["The Week — Rajasthan Mehangai Rahat camps","https://www.theweek.in/wire-updates/national/2023/05/09/des56-rj-gehlot-inflation-relief.html"],["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"],["PRS, Rajasthan Budget Analysis 2021-22","https://prsindia.org/budgets/states/rajasthan-budget-analysis-2021-22"],["ThePrint (Hindi), 'Indira Gandhi Smartphone Yojana begins in Rajasthan; 40 lakh women in phase 1', 11 Aug 2023","https://hindi.theprint.in/report/indira-gandhi-smartphone-yojana-started-in-rajasthan-40-lakh-women-will-get-smartphones-in-the-first-phase/582752/"],["Deccan Herald, 25 Oct 2023: Gehlot promises Rs 10,000/yr to woman head of family","https://www.deccanherald.com/elections/rajasthan/rajasthan-polls-gehlot-promises-rs-10000year-to-woman-head-of-families-lpg-cylinder-at-rs-500-2740998"]] },
  { id: "wel:ashwini-upadhyay", label: "Ashwini Kumar Upadhyay", sub: "advocate; petitioner in W.P.(C) 43/2022; former BJP Delhi spokesperson", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["Filed the freebies PIL on 22 Jan 2022 arguing election freebies amount to bribery (IPC 171B) and undue influence (171C) [documented]"], srcs: [["Supreme Court Observer, case page 'Freebies in Electoral Democracy and Welfare State' — Ashwini Kumar Upadhyay v Union of India, W.P.(C) 43/2022 (status Pending; last updated 21 Aug 2024)","https://www.scobserver.in/cases/freebies/"],["Supreme Court Observer, 'Freebies in Elections Day #6: CJI Reiterates 3-Judge Bench Reference', 1 Nov 2022","https://www.scobserver.in/reports/freebies-in-elections-day-6-cji-reiterates-3-judge-bench-reference-ashwini-kumar-upadhyay-v-union-of-india/"],["LiveLaw, 1 Nov 2022: 'Election Freebies | Supreme Court directs matter to be listed before three judge bench at the earliest' (U.U. Lalit CJI, Bela M. Trivedi J)","https://www.livelaw.in/top-stories/election-freebies-supreme-court-directs-matter-to-be-listed-before-three-judge-bench-at-the-earliest-212939"],["Wikipedia, 'Ashwini Upadhyay' (pointer only; cites BOOM, 10 Aug 2021, on his BJP role)","https://en.wikipedia.org/wiki/Ashwini_Upadhyay"]] },
  { id: "wel:atif-aqueel", label: "Atif Aqueel", sub: "MLA, Bhopal North, Madhya Pradesh Legislative Assembly, 2023-12→", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["Asked the assembly question that produced the ₹290 crore Ladli Behna publicity figure [documented]"], srcs: [["Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025","https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"]] },
  { id: "wel:atishi", label: "Atishi", sub: "Power Minister", ty: "person", fam: "state", st: "dl", sz: 1, resolved: true, d: ["Cabinet approved subsidy to 31 Mar 2025; 22 lakh zero bills, 7 Mar 2024 [reported]","Cabinet under her approved Rs 1,000/month 12 Dec 2024 [reported]","Mar 2025: accused BJP of failing to pay Rs 2,500 by 8 Mar [reported]"], srcs: [["Deccan Herald, 7 Mar 2024: Delhi cabinet approves power subsidy scheme for FY 2024-25; 22 lakh zero bills","https://www.deccanherald.com/india/delhi/delhi-cabinet-approves-power-subsidy-scheme-for-fy-2024-25-2926614"],["Deccan Herald, 12 Dec 2024: Kejriwal announces Rs 1,000 (Rs 2,100 after polls) for Delhi women","https://www.deccanherald.com/elections/delhi/delhi-assembly-elections-2025-ahead-of-polls-cabinet-approves-proposal-of-giving-rs-1000-to-women-every-months-3314631"],["Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr","https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"]] },
  { id: "wel:basavaraj-bommai", label: "Basavaraj Bommai", ty: "person", fam: "state", sz: 1, resolved: true },
  { id: "wel:bennett-coleman", label: "Bennett, Coleman & Co Ltd (Times of India)", sub: "Largest recipient of central print ads", ty: "company", fam: "capital", st: "mh", sz: 2, resolved: true, d: ["₹78.22 crore of central print ads FY2020-21 to FY2024-25 [documented]"], srcs: [["Newslaundry, 'Modi govt spent Rs 910 crore on print ads in 5 years; Times of India biggest beneficiary' (Lok Sabha reply), 4 Aug 2026","https://www.newslaundry.com/2026/08/04/modi-govt-spent-rs-910-crore-on-print-ads-in-5-years-times-of-india-biggest-beneficiary"]] },
  { id: "wel:bhagwant-mann", label: "Bhagwant Mann", sub: "Chief Minister", ty: "person", fam: "state", st: "pb", sz: 2, resolved: true, d: ["300 units free domestic power from 1 Jul 2022 [documented, PRS]","Rs 1,000 guarantee of Feb 2022 unfulfilled after three years [reported]"], srcs: [["Wikipedia — 2022 Punjab Legislative Assembly election","https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"],["PRS, Punjab Budget Analysis 2022-23","https://prsindia.org/budgets/states/punjab-budget-analysis-2022-23"],["ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs","https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"]] },
  { id: "wel:bhajan-lal-sharma", label: "Bhajan Lal Sharma", sub: "Chief Minister", ty: "person", fam: "state", st: "rj", sz: 1, resolved: true, d: ["Renaming not verified in an opened page [gap]"], srcs: [["Wikipedia infobox (pointer to ECI): 2023 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"]] },
  { id: "wel:bhupendra-patel", label: "Bhupendra Patel", sub: "Chief Minister", ty: "person", fam: "state", st: "gj", sz: 3, resolved: true, d: ["Namo Laxmi Rs 50,000 per girl over four years, 2024-25 budget [documented]"], srcs: [["PRS, Gujarat Budget Analysis 2024-25","https://prsindia.org/budgets/states/gujarat-budget-analysis-2024-25"]] },
  { id: "wel:bhupesh-baghel", label: "Bhupesh Baghel", sub: "Chief Minister", ty: "person", fam: "state", st: "ct", sz: 2, resolved: true, d: ["Waived Rs 6,100 cr for 16.6 lakh farmers on 17 Dec 2018 [documented]","Launched RGKNY 21 May 2020 [documented]"], srcs: [["National Herald — Chhattisgarh Rs 6,100-cr loan waiver","https://www.nationalheraldindia.com/national/chhattisgarh-cm-bhupesh-baghel-announces-indian-rupee6100-cr-farm-loan-waiver"],["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"],["National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21","https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"]] },
  { id: "wel:bluekraft-digital-foundation", label: "BlueKraft Digital Foundation", sub: "private foundation; author of the ₹3.48 lakh cr DBT-savings paper", ty: "agency", fam: "recipient", st: null, sz: 2, resolved: true, d: ["its Apr 2025 paper was relayed verbatim by PIB as the official DBT savings figure [documented]","Author of the 2025 'Welfare Efficiency Index' assessment; not an audit body [reported]"], srcs: [["PIB, 'India's DBT: Boosting Welfare Efficiency' (BlueKraft report relayed), 21 Apr 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2123192"],["PIB (Ministry of Finance), 'India's DBT: Boosting Welfare Efficiency' — BlueKraft assessment, 21 Apr 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2123192"]] },
  { id: "wel:bmtc", label: "Bengaluru Metropolitan Transport Corporation", sub: "Karnataka state transport undertaking", ty: "psu", fam: "state", st: "ka", sz: 2, resolved: true, d: ["Daily ridership rose 27.4 lakh → 40 lakh after Shakti while fleet fell 6,888 → 6,158; 840-bus order under ₹336 crore state grant [documented]"], srcs: [["Deccan Herald, 'BMTC launches 100 new diesel buses, to get 820 of them by March', 12 Sep 2024","https://www.deccanherald.com/india/karnataka/bengaluru/bmtc-launches-100-new-diesel-buses-to-get-820-of-them-by-march-3188420"]] },
  { id: "wel:c-joseph-vijay", label: "C. Joseph Vijay", ty: "person", fam: "state", sz: 2, resolved: true, srcs: [["Variety — Vijay sworn in as Tamil Nadu CM","https://variety.com/2026/politics/news/vijay-sworn-in-tamil-nadu-chief-minister-1236742532/"]] },
  { id: "wel:cesl", label: "Convergence Energy Services Ltd", sub: "EESL subsidiary that ran the e-bus 'Grand Challenge' aggregated tender", ty: "psu", fam: "state", st: "dl", sz: 2, resolved: true, d: ["Tendering body for the Delhi 1,500-bus Tata award and the Switch Mobility 950-bus award [documented]"], srcs: [["Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022","https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"],["EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023","https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"]] },
  { id: "wel:champai-soren", label: "Champai Soren", ty: "person", fam: "state", sz: 1, resolved: true },
  { id: "wel:chandrima-bhattacharya", label: "Chandrima Bhattacharya", sub: "Finance Minister (independent charge), West Bengal (AITC)", ty: "person", fam: "state", st: "wb", sz: 2, resolved: true, d: ["Interim budget 2026-27 raised Lakshmir Bhandar by Rs 500 [reported]"], srcs: [["ANI, 6 Feb 2026: West Bengal announces Rs 500 Lakshmir Bhandar hike in interim budget 2026-27","https://www.aninews.in/news/national/politics/west-bengal-govt-announces-rs-500-hike-for-lakshmir-bhandar-beneficaries-ahead-of-assembly-polls20260206060332/"]] },
  { id: "wel:class-ap-pensioners", label: "Social-security pensioners of Andhra Pradesh", sub: "Beneficiary class: YSR Pension Kanuka / NTR Bharosa", ty: "group", fam: "recipient", st: "ap", sz: 3, resolved: true, d: ["Rs 21,434 cr in 2023-24 [documented]"], srcs: [["PRS, Andhra Pradesh Budget Analysis 2023-24","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2023-24"]] },
  { id: "wel:class-ap-school-mothers", label: "Mothers of school-going children, Andhra Pradesh", sub: "Beneficiary class: Amma Vodi / Thalliki Vandanam", ty: "group", fam: "recipient", st: "ap", sz: 3, resolved: true, d: ["Rs 6,000 cr in 2020-21 [documented]"], srcs: [["PRS, Andhra Pradesh Budget Analysis 2020-21","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2020-21"]] },
  { id: "wel:class-as-orunodoi-households", label: "Ration-card households < ₹2 lakh in Assam (paid to the woman)", sub: "Orunodoi beneficiaries (AS)", ty: "group", fam: "recipient", st: "as", sz: 2, resolved: true, d: ["₹1,250/month to ~37–40 lakh; ₹5,000 cr BE 2025-26 [documented]"], srcs: [["ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month","https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "wel:class-br-mmry-women", label: "One woman per family in Bihar, via JEEViKA SHGs", sub: "Mahila Rozgar Yojana beneficiaries (BR)", ty: "group", fam: "recipient", st: "br", sz: 2, resolved: true, d: ["₹10,000 one-time; up to ₹2 lakh later [documented]"], srcs: [["PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"]] },
  { id: "wel:class-ct-mahtari-vandan-women", label: "Married women 21+ in Chhattisgarh", sub: "Mahtari Vandan beneficiaries (CT)", ty: "group", fam: "recipient", st: "ct", sz: 2, resolved: true, d: ["₹1,000/month; ₹5,500 cr BE 2025-26 [documented]"], srcs: [["PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr","https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "wel:class-dl-domestic-consumers", label: "Domestic electricity consumers of Delhi", sub: "Beneficiary class: 200-unit subsidy (~22 lakh zero bills)", ty: "group", fam: "recipient", st: "dl", sz: 3, resolved: true, d: ["Subsidy paid through DISCOMs [documented]"], srcs: [["PRS, Delhi Budget Analysis 2023-24","https://prsindia.org/budgets/states/delhi-budget-analysis-2023-24"],["Deccan Herald, 7 Mar 2024: Delhi cabinet approves power subsidy scheme for FY 2024-25; 22 lakh zero bills","https://www.deccanherald.com/india/delhi/delhi-cabinet-approves-power-subsidy-scheme-for-fy-2024-25-2926614"]] },
  { id: "wel:class-gj-farmers", label: "Agricultural power consumers of Gujarat", sub: "Beneficiary class: farm power subsidy", ty: "group", fam: "recipient", st: "gj", sz: 3, resolved: true, d: ["Rs 12,207 cr 2024-25 [documented]"], srcs: [["PRS, Gujarat Budget Analysis 2024-25","https://prsindia.org/budgets/states/gujarat-budget-analysis-2024-25"]] },
  { id: "wel:class-hp-pyari-behna-women", label: "Women 21–59 in HP households ≤ ₹2 lakh (phased)", sub: "Indira Gandhi Pyari Behna beneficiaries (HP)", ty: "group", fam: "recipient", st: "hp", sz: 2, resolved: true, d: ["₹138 cr BE vs ₹11.64 cr paid (2025-26) [reported]"], srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals","https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"]] },
  { id: "wel:class-hr-lado-lakshmi-women", label: "Women 23+ in Haryana households ≤ ₹1 lakh", sub: "Lado Lakshmi beneficiaries (HR)", ty: "group", fam: "recipient", st: "hr", sz: 2, resolved: true, d: ["₹2,100/month; ₹5,000 cr BE 2025-26 [documented]"], srcs: [["Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification","https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "wel:class-jh-maiya-samman-women", label: "Women 18–50 in Jharkhand households (Maiya Samman)", sub: "Maiya Samman beneficiaries (JH)", ty: "group", fam: "recipient", st: "jh", sz: 2, resolved: true, d: ["₹2,500/month to 56.6 lakh; ₹13,363 cr BE 2025-26 [documented]"], srcs: [["IMPRI policy update: Mukhyamantri Maiya Samman Yojana in practice","https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "wel:class-ka-bpl-members", label: "BPL/Antyodaya card members of Karnataka", sub: "Beneficiary class: Anna Bhagya (4.12 cr)", ty: "group", fam: "recipient", st: "ka", sz: 3, resolved: true, d: ["Rs 170/month DBT Jul 2023–Jan 2025 [documented]"], srcs: [["Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024","https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"]] },
  { id: "wel:class-ka-farmers", label: "Crop-loan-defaulting farmers of Karnataka (2018 waiver)", sub: "Beneficiary class: 17.5 lakh eligible", ty: "group", fam: "recipient", st: "ka", sz: 3, resolved: true, d: ["Rs 232 cr pending Jan 2024 [reported]"], srcs: [["Deccan Herald, 7 Jan 2024: Karnataka farmers in quicksand as govt continues to borrow time over loan waiver","https://www.deccanherald.com/india/karnataka/karnataka-farmers-in-quicksand-as-govt-continues-to-borrow-time-over-loan-waiver-2838441"]] },
  { id: "wel:class-ka-gruha-lakshmi-women", label: "Women heads of household on Karnataka ration cards", sub: "Gruha Lakshmi beneficiaries (KA)", ty: "group", fam: "recipient", st: "ka", sz: 2, resolved: true, d: ["₹2,000/month; ₹50,005 cr cumulative [documented]"], srcs: [["Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed","https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "wel:class-ka-households", label: "Households of Karnataka (guarantee beneficiaries)", sub: "Beneficiary class: five guarantees", ty: "group", fam: "recipient", st: "ka", sz: 3, resolved: true, d: ["1.22 cr Gruha Lakshmi women; 1.62 cr Gruha Jyothi consumers; 4.21 cr Anna Bhagya [reported]"], srcs: [["The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget","https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"]] },
  { id: "wel:class-mh-ladki-bahin-ad-vendors", label: "Advertising and media vendors of the Ladki Bahin campaign (unnamed)", sub: "Vendors and contracts not published by the Maharashtra government", ty: "group", fam: "capital", st: "mh", sz: 1, resolved: true, d: ["₹250 cr Ladki Bahin advertising, Jul–Nov 2024 (BehanBox); vendor names not published [reported]","A DGIPR RTI reply puts Ladki Bahin publicity at ₹199.81 cr in ~4 months (vendors.json vendors:c031) [reported]"], srcs: [["BehanBox, 4 Dec 2024: Maharashtra poll analyses and women's agency (cites Lokniti-CSDS post-poll)","https://behanbox.com/2024/12/04/how-maharashtra-poll-analyses-are-missing-the-rise-of-womens-agency/"]] },
  { id: "wel:class-mh-ladki-bahin-women", label: "Women 21–65 in MH households with income < ₹2.5 lakh", sub: "Ladki Bahin beneficiaries (MH)", ty: "group", fam: "recipient", st: "mh", sz: 2, resolved: true, d: ["₹1,500/month; ₹33,232 cr paid 2024-25 [documented]"], srcs: [["Deccan Herald, 10 Mar 2025: Maharashtra budget gives Rs 36,000 cr to Ladki Bahin, silent on Rs 2,100","https://www.deccanherald.com/india/maharashtra/maharashtra-govt-gives-rs-36000-crore-to-ladki-bahin-in-budget-mum-on-stipend-hike-ups-vehicle-tax-3440102"],["Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification","https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "wel:class-mh-lending-banks", label: "DCC, nationalised and regional rural banks lending to Maharashtra farmers", sub: "Counterparty class paid under the 2017 and 2019 waivers", ty: "group", fam: "capital", st: "mh", sz: 3, resolved: true, d: ["Rs 13,705 cr arrears (2017) and Rs 20,497 cr (2019) settled by the state [documented]"], srcs: [["Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"],["Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"]] },
  { id: "wel:class-mp-ladli-behna-women", label: "Women 21–60 in MP households with income < ₹2.5 lakh", sub: "Ladli Behna beneficiaries (MP)", ty: "group", fam: "recipient", st: "mp", sz: 2, resolved: true, d: ["₹1,000→₹1,250→₹1,500/month [documented]"], srcs: [["India TV, 12 Oct 2025: Mohan Yadav transfers Rs 1,541 cr (29th instalment), announces Rs 1,500","https://www.indiatvnews.com/madhya-pradesh/madhya-pradesh-ladli-behna-scheme-yojana-cm-mohan-yadav-transfers-rs-1541-crore-announces-hike-to-rs-1500-2025-10-12-1012478"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "wel:class-or-small-farmers-landless", label: "Small/marginal farmers and landless agricultural households of Odisha", sub: "Beneficiary class: KALIA (65.64 lakh paid 2019-21)", ty: "group", fam: "recipient", st: "or", sz: 3, resolved: true, d: ["Rs 6,444.30 cr paid 2019-21 per KALIA database [documented]"], srcs: [["CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)","https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"]] },
  { id: "wel:class-or-subhadra-women", label: "Women 21–60 in Odisha households with income < ₹2.5 lakh", sub: "Subhadra beneficiaries (OR)", ty: "group", fam: "recipient", st: "or", sz: 2, resolved: true, d: ["₹10,000/yr; ₹55,825 cr over 5 years [documented]"], srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Wikipedia (pointer): Subhadra Yojana","https://en.wikipedia.org/wiki/Subhadra_Yojana"],["Deccan Herald/PTI, 17 Sep 2024: PM launches Subhadra; Rs 10,000/yr; 76 lakh registered; Rs 1,250 cr to 25 lakh","https://www.deccanherald.com/india/odisha/pm-modi-launches-odisha-govts-subhadra-scheme-railway-nh-projects-worth-over-rs-3800-cr-3193991"]] },
  { id: "wel:class-pb-domestic-consumers", label: "Domestic electricity consumers of Punjab", sub: "Beneficiary class: 300-unit free power", ty: "group", fam: "recipient", st: "pb", sz: 3, resolved: true, d: ["Rs 7,780 cr 2024-25 [documented]"], srcs: [["PRS, Punjab Budget Analysis 2024-25","https://prsindia.org/budgets/states/punjab-budget-analysis-2024-25"]] },
  { id: "wel:class-tg-landowning-farmers", label: "Landowning (pattadar) farmers of Telangana", sub: "Beneficiary class: Rythu Bandhu/Bharosa (58.33 lakh)", ty: "group", fam: "recipient", st: "tg", sz: 3, resolved: true, d: ["Paid per acre, uncapped, since May 2018 [documented]"], srcs: [["Wikipedia (pointer): Rythu Bandhu scheme","https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"],["PRS, Telangana Budget Analysis 2018-19","https://prsindia.org/budgets/states/telangana-budget-analysis-2018-19"]] },
  { id: "wel:class-tg-large-landowners", label: "Telangana landowners with 20–40 acres receiving Rythu Bandhu (~13,000)", sub: "Beneficiary sub-class: uncapped per-acre Rythu Bandhu transfers", ty: "group", fam: "recipient", st: "tg", sz: 1, resolved: true, d: ["~13,000 farmers with 20–40 acres (>3.19 lakh acres) receive payments; ~₹150 cr per season (state estimates via TOI, Jan 2021) [reported]"], srcs: [["Times of India, 2 Jan 2021: 'Most of 13,000 rich farmers in Telangana still get Rythu Bandhu aid'","https://timesofindia.indiatimes.com/city/hyderabad/most-of-13000-rich-farmers-in-t-still-get-rythu-bandhu-aid/articleshow/80066258.cms"]] },
  { id: "wel:class-tn-kmut-women", label: "Women heads of families in Tamil Nadu (targeted)", sub: "Kalaignar Magalir Urimai Thogai beneficiaries (TN)", ty: "group", fam: "recipient", st: "tn", sz: 2, resolved: true, d: ["₹1,000/month to 1.13 cr; ₹13,807 cr BE 2025-26 [documented]"], srcs: [["Deccan Herald, 10 Nov 2023: TN adds 7.35 lakh beneficiaries; 1.13 cr total","https://www.deccanherald.com/india/tamil-nadu/tamil-nadu-expands-monthly-assistance-scheme-to-women-adds-7-lakh-beneficiaries-2766189"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "wel:class-uct-states-12", label: "The 12 states running women's unconditional cash transfers (2025-26 BE)", sub: "State governments counted by PRS SOSF 2025", ty: "group", fam: "state", st: null, sz: 2, resolved: true, d: ["₹1,68,040 cr (0.5% of GDP) on women's UCTs, 2025-26 BE; 6 of 12 in revenue deficit [documented]"], srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Deccan Herald/PTI, 5 Nov 2025: 12 states to spend Rs 1.68 lakh crore on women's cash schemes (PRS)","https://www.deccanherald.com/india/12-states-to-spend-rs-168-lakh-crore-on-womens-cash-schemes-report-3787198"]] },
  { id: "wel:class-wb-lakshmir-bhandar-women", label: "Women 25–60 in West Bengal Swasthya Sathi households", sub: "Lakshmir Bhandar beneficiaries (WB)", ty: "group", fam: "recipient", st: "wb", sz: 2, resolved: true, d: ["₹1,000/1,200 → ₹1,500/1,700; ₹26,700 cr BE 2025-26 [documented]"], srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["ANI, 6 Feb 2026: West Bengal announces Rs 500 Lakshmir Bhandar hike in interim budget 2026-27","https://www.aninews.in/news/national/politics/west-bengal-govt-announces-rs-500-hike-for-lakshmir-bhandar-beneficaries-ahead-of-assembly-polls20260206060332/"]] },
  { id: "wel:csc-egovernance-services", label: "CSC e-Governance Services India Ltd", sub: "MeitY-promoted SPV (Section 8 status disputed) running Common Service Centres and DigiPay AePS", ty: "company", fam: "capital", st: "dl", sz: 2, resolved: true, d: ["Earns 0.5% of AePS cash-withdrawal value above ₹100, capped ₹15/transaction; says 80% passed to VLEs; 1.44 lakh VLEs AePS-enabled (2018) [reported]"], srcs: [["Moneylife, 'Is CSC e-Governance Services a govt entity or SPV or a Section 8 company?', 29 Jun 2018","https://www.moneylife.in/article/is-csc-egovernance-services-a-govt-entity-or-spv-or-a-section-8-company/54524.html"]] },
  { id: "wel:dbt-mission", label: "DBT Mission, Cabinet Secretariat", sub: "Coordinates Direct Benefit Transfer across 300+ central and 2,000+ state schemes", ty: "agency", fam: "state", st: "dl", sz: 3, resolved: true, d: ["Portal on 2026-09-25: cumulative DBT ₹53,45,314 crore; FY2026-27 ₹2,27,930 crore; 320 schemes, 56 ministries; ‘Estimated Gains’ ₹5,14,201.92 crore — a self-reported estimate, not an audited saving [documented]","DBT started 1 Jan 2013; PFMS integrated with 500+ banks; NPCI's APB routes Aadhaar-seeded payments [documented]"], srcs: [["DBT Bharat portal — headline figures as displayed 2026-09-25","https://dbtbharat.gov.in/"],["PIB backgrounder, Direct Benefit Transfer (DBT), Jan 2022","https://static.pib.gov.in/WriteReadData/specificdocs/documents/2022/jan/doc2022153101.pdf"]] },
  { id: "wel:delhi-dip", label: "Directorate of Information and Publicity, Delhi", sub: "Delhi government's advertising arm", ty: "agency", fam: "state", st: "dl", sz: 2, resolved: true, d: ["Released ₹57.90 crore during 2020-22 for 2015-17 ads without due procedure; ₹43.621 crore to 94 agencies without L-G cognisance (CAG) [documented]"], srcs: [["The Tribune, 'AAP govt violated ad campaign norms, spending rose by 1,200% in 5 yrs: CAG report', 27 Feb 2025","https://www.tribuneindia.com/news/india/aap-govt-violated-ad-campaign-norms-spending-rose-by-1200-in-5-yrs-cag-report/"],["ThePrint, 'Kejriwal govt spent Rs 274 crore on ads since 2015, four times Congress tab' (RTI), 1 Apr 2019","https://theprint.in/politics/kejriwals-delhi-govt-spent-rs-274-crore-on-ads-since-2015-four-times-more-than-congress/214151/"]] },
  { id: "wel:devendra-fadnavis", label: "Devendra Fadnavis", sub: "Chief Minister of Maharashtra, 2014-10-31→2019-11-12 and 2024-12-05→; Deputy CM 2022-06-30→2024-12-05", ty: "person", fam: "state", st: "mh", sz: 2, resolved: true, d: ["On 2026-08-14 said the government had fulfilled its 2024 poll promises and would not discontinue Ladki Bahin [reported]","GR of 28 Jun 2017; Rs 18,762 cr to 44.04 lakh beneficiaries [documented]","Mar 2025: promise will be fulfilled 'after fiscal balance is achieved… not from April' [reported]"], srcs: [["ETV Bharat — Maharashtra 2024 final result, Mahayuti 230 seats","https://www.etvbharat.com/en/!bharat/maharashtra-assembly-election-2024-counting-mahayuti-mva-bjp-shiv-sena-ubt-ncp-congress-enn24112205094"],["ThePrint, 2026-08-14 — Govt fulfilled promises made during 2024 polls, will not discontinue Ladki Bahin: Fadnavis","https://theprint.in/india/govt-fulfilled-promises-made-during-2024-polls-will-not-discontinue-ladki-bahin-fadnavis/3015115/"],["Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"],["Deccan Herald, 10 Mar 2025: Maharashtra budget gives Rs 36,000 cr to Ladki Bahin, silent on Rs 2,100","https://www.deccanherald.com/india/maharashtra/maharashtra-govt-gives-rs-36000-crore-to-ladki-bahin-in-budget-mum-on-stipend-hike-ups-vehicle-tax-3440102"]] },
  { id: "wel:dk-shivakumar", label: "D. K. Shivakumar", sub: "Deputy Chief Minister", ty: "person", fam: "state", st: "ka", sz: 3, resolved: true, d: ["Cabinet first meeting 20 May 2023 [reported]","Reviewed the guarantee schemes in June 2026 when transport officials reported ₹5,172 crore of Shakti reimbursement pending and the first RTC loss since 2023 [reported]"], srcs: [["Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting","https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"],["ETV Bharat, 'Shakti scheme effect: male passengers drop; ₹5,172 crore reimbursement pending', 20 Jun 2026","https://www.etvbharat.com/en/bharat/shakti-scheme-effect-number-of-male-passengers-travelling-in-karnataka-govt-run-buses-drops-significantly-in-karnataka-enn26062003798"]] },
  { id: "wel:dtc", label: "Delhi Transport Corporation", sub: "Delhi government bus undertaking", ty: "psu", fam: "state", st: "dl", sz: 2, resolved: true, d: ["Signed 12-year supply-operate-maintain agreement with TML CV Mobility Solutions for 1,500 e-buses (23 Dec 2022) under CESL Grand Challenge [documented]"], srcs: [["Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022","https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"]] },
  { id: "wel:eci", label: "Election Commission of India", sub: "constitutional election authority; respondent in the freebies PIL", ty: "agency", fam: "enforce", st: "dl", sz: 2, resolved: true, d: ["Told the Supreme Court it has limited scope to interfere in parties' promises (recorded in the 26 Aug 2022 order) [documented]","Removed ~100 AP volunteers and barred volunteers from pension distribution during the 2024 MCC [reported]"], srcs: [["Supreme Court of India, order dated 26 Aug 2022 in W.P.(C) 43/2022 (N.V. Ramana CJI, Hima Kohli, C.T. Ravikumar JJ) — reference to three-judge bench (copy hosted by SCO)","https://www.scobserver.in/wp-content/uploads/2022/08/Freebies-Order-August-26th.pdf"],["Supreme Court Observer, case page 'Freebies in Electoral Democracy and Welfare State' — Ashwini Kumar Upadhyay v Union of India, W.P.(C) 43/2022 (status Pending; last updated 21 Aug 2024)","https://www.scobserver.in/cases/freebies/"],["ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024","https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"]] },
  { id: "wel:eknath-shinde", label: "Eknath Shinde", sub: "Chief Minister of Maharashtra, 2022-06-30→2024-12-05; Deputy CM 2024-12-05→", ty: "person", fam: "state", st: "mh", sz: 2, resolved: true, d: ["Ladki Bahin payments began under his government on 2024-08-14, the eve of Independence Day [reported]","On 2024-09-14 said the dole would be doubled to ₹3,000 if the alliance got a bigger mandate; the Mahayuti manifesto figure was ₹2,100 [reported]","Ladki Bahin launched under his government in mid-2024; DGIPR RTI reply of 4 Oct 2024 put publicity spend at ~₹200 crore in the run-up to the Nov 2024 election [reported]","Government began Ladki Bahin disbursal 14 Aug 2024 [reported]","Said 14 Sep 2024: bigger mandate → Rs 3,000/month [reported]","Mar 2025: Rs 2,100 promise 'in process… need some time' [reported]"], srcs: [["Deccan Herald, 2024-08-15 — Shinde govt begins releasing money under Ladki Bahin Yojana on eve of Independence Day","https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"],["Deccan Herald, 2024-09-14 — ‘Give us a bigger mandate, will double Ladki Bahin dole to ₹3,000’: Eknath Shinde","https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-give-us-a-bigger-mandate-will-double-ladki-bahin-dole-to-rs-3000-eknath-shinde-3191037"],["Lokniti-CSDS Maharashtra 2024 post-poll analysis, The Hindu, 25 Nov 2024 (Deshpande, ‘Women sided with Mahayuti for Ladki Bahin Yojana’s monthly dole’; Mishra, women as deciders) — page PDF held locally; thehindu.com unreachable from this container","https://www.lokniti.org/state-assembly-elections"],["Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024","https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"],["Deccan Herald, 15 Aug 2024: Shinde govt begins releasing Ladki Bahin money","https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"],["Deccan Herald, 14 Sep 2024: Shinde — bigger mandate, will raise Ladki Bahin to Rs 3,000","https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-give-us-a-bigger-mandate-will-double-ladki-bahin-dole-to-rs-3000-eknath-shinde-3191037"],["Deccan Herald, 10 Mar 2025: Maharashtra budget gives Rs 36,000 cr to Ladki Bahin, silent on Rs 2,100","https://www.deccanherald.com/india/maharashtra/maharashtra-govt-gives-rs-36000-crore-to-ladki-bahin-in-budget-mum-on-stipend-hike-ups-vehicle-tax-3440102"]] },
  { id: "wel:ekstep-foundation", label: "EkStep Foundation", sub: "non-profit chaired by Nandan Nilekani", ty: "trust", fam: "recipient", st: null, sz: 2, resolved: true, d: ["technical support with BHASHINI for Kisan-eMitra chatbot on PM-KISAN (Sep 2023) [documented]"], srcs: [["PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"],["Wikipedia (pointer), Nandan Nilekani","https://en.wikipedia.org/wiki/Nandan_Nilekani"]] },
  { id: "wel:elcot", label: "Electronics Corporation of Tamil Nadu (ELCOT)", sub: "State PSU; procured ~15 million TV sets 2006–10", ty: "company", fam: "capital", st: "tn", sz: 3, resolved: true, d: ["~15 million sets purchased 2006–10; 13.2 million distributed by Sep 2010 [reported]"], srcs: [["IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?","https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"]] },
  { id: "wel:epw", label: "Economic and Political Weekly", sub: "journal", ty: "agency", fam: "enforce", st: null, sz: 2, resolved: true, d: ["24 Dec 2016 web exclusive questioning LPG-DBT savings claims [documented]"], srcs: [["EPW Vol 51 No 52, 'Questioning the Phenomenal Success of Aadhaar-linked DBT for LPG', 24 Dec 2016","https://www.epw.in/journal/2016/52/web-exclusives/questioning-%E2%80%9Cphenomenal-success%E2%80%9D-aadhaar-linked-direct-benefit"]] },
  { id: "wel:fci", label: "Food Corporation of India", sub: "Central grain procurement/stock agency", ty: "agency", fam: "state", st: "dl", sz: 3, resolved: true, d: ["Withheld OMSS rice to Karnataka Jun 2023–Jan 2025; sells at Rs 22.5/kg from Feb 2025 [documented]","Subsidy to FCI ₹1,39,662 crore (2023-24 RE); economic cost rice ₹39.8/kg, wheat ₹27.7/kg (2024-25); CIP ₹0 under PMGKAY [documented]"], srcs: [["The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya","https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"],["Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024","https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"],["PRS Legislative Research, 'Demand for Grants 2024-25 Analysis: Food and Public Distribution'","https://prsindia.org/budgets/parliament/demand-for-grants-2024-25-analysis-food-and-public-distribution"]] },
  { id: "wel:fino-payments-bank", label: "Fino Payments Bank Ltd", sub: "Listed payments bank; ~19 lakh merchant/BC points; AePS and micro-ATM cash-out network", ty: "company", fam: "capital", st: "mh", sz: 2, resolved: true, d: ["FY25 revenue ₹1,847.1 crore; total throughput ₹4.61 lakh crore; AePS/micro-ATM throughput ₹39,704 crore generating ₹185 crore revenue; partners with UP and Bihar SRLMs (BC Sakhi, Jeevika) [documented]"], srcs: [["Fino Payments Bank, Annual Report 2024-25","https://www.fino.bank.in/files/fino/media/post_attachments/sites/default/files/uploads/pages/financials/annual-report-2025.pdf"]] },
  { id: "wel:greater-chennai-corporation", label: "Greater Chennai Corporation", sub: "Municipal body running Amma Unavagam", ty: "agency", fam: "state", st: "tn", sz: 2, resolved: true, d: ["Bears ~₹100 crore/year for 407 canteens serving ~4.5 lakh people a day (2020) [reported]"], srcs: [["ThePrint, 'Now it's Rs 15 for 3 meals at Chennai's Amma Canteens', 1 Jun 2020","https://theprint.in/india/now-its-rs-15-for-3-meals-at-chennais-amma-canteens-but-end-of-free-food-bad-news-for-many/433276/"]] },
  { id: "wel:h-m-revanna", label: "H. M. Revanna", sub: "Chairperson, Guarantee Implementation Authority, Karnataka (INC)", ty: "person", fam: "state", st: "ka", sz: 2, resolved: true, d: ["25 Aug 2025: said CAG's conclusion that guarantees strain state resources was 'far from the truth' [reported]","CAG conclusions \"far from the truth\"; Rs 94,177 cr spent, 25 Aug 2025 [reported]","Said Rs 94,177 cr spent on guarantees; CAG conclusions 'far from the truth' [reported]"], srcs: [["Deccan Herald, 26 Aug 2025: ''CAG report's conclusions on welfare schemes in Karnataka incorrect': H M Revanna'","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"],["Deccan Herald, 26 Aug 2025: CAG report's conclusions on welfare schemes in Karnataka incorrect: H M Revanna","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"],["Deccan Herald, 26 Aug 2025: H M Revanna rejects CAG conclusions on Karnataka guarantee schemes","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"]] },
  { id: "wel:hemant-soren", label: "Hemant Soren", sub: "CM Jharkhand (JMM)", ty: "person", fam: "state", st: "jh", sz: 2, resolved: true, d: ["Cabinet approved Rs 2,500 on 14 Oct 2024, effective Dec 2024 [reported]"], srcs: [["IMPRI — Maiya Samman Yojana policy update","https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"],["Deccan Herald/PTI, 14 Oct 2024: Jharkhand cabinet raises Maiya Samman to Rs 2,500 from Dec 2024","https://www.deccanherald.com/india/jharkhand/jharkhand-cabinet-nod-to-hike-financial-assistance-for-women-to-rs-30000-per-year-from-rs-12000-3231863"],["IMPRI policy update: Mukhyamantri Maiya Samman Yojana in practice","https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"]] },
  { id: "wel:hewlett-packard-india", label: "Hewlett-Packard (HP) India", sub: "Supplier of the UP 2012-13 free laptops", ty: "company", fam: "capital", st: null, sz: 2, resolved: true, d: ["Supplied ~15 lakh laptops under the ₹2,800 crore UP scheme; HP, HCL, Lenovo and Acer bid [reported]"], srcs: [["Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'","https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"]] },
  { id: "wel:himanta-biswa-sarma", label: "Himanta Biswa Sarma", sub: "CM Assam (BJP)", ty: "person", fam: "state", st: "as", sz: 2, resolved: true, d: ["BJP won 82 of 126 seats, counting 4 May 2026 [reported]","Orunodoi envisaged in his 2020-21 budget speech [reported]","Orunodoi 3.0: 37.2 lakh beneficiaries, Rs 1,250, Rs 467 cr/month [reported]","BJP won 82/126 in May 2026 [reported]"], srcs: [["India TV News, Assam Election Result 2026 live: BJP wins 82 of 126, 4 May 2026","https://www.indiatvnews.com/north-east/assam/assam-election-result-2026-live-updates-himanta-biswa-sarma-led-bjp-wins-setback-for-congress-1039454"],["PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"],["Wikipedia — 2026 Assam Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Assam_Legislative_Assembly_election"],["ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month","https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"],["India TV, 4 May 2026: Assam 2026 result — BJP 82 seats","https://www.indiatvnews.com/north-east/assam/assam-election-result-2026-live-updates-himanta-biswa-sarma-led-bjp-wins-setback-for-congress-1039454"]] },
  { id: "wel:ht-media", label: "HT Media Ltd (Hindustan Times)", sub: "Listed publisher", ty: "company", fam: "capital", st: "dl", sz: 2, resolved: true, d: ["₹47.80 crore of central print ads FY2020-21 to FY2024-25 [documented]"], srcs: [["Newslaundry, 'Modi govt spent Rs 910 crore on print ads in 5 years; Times of India biggest beneficiary' (Lok Sabha reply), 4 Aug 2026","https://www.newslaundry.com/2026/08/04/modi-govt-spent-rs-910-crore-on-print-ads-in-5-years-times-of-india-biggest-beneficiary"]] },
  { id: "wel:ifpri", label: "IFPRI", sub: "International Food Policy Research Institute", ty: "agency", fam: "enforce", st: null, sz: 2, resolved: true, d: ["2019 PM-KISAN utilisation study cited by government [reported]"], srcs: [["PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"],["PIB (MoA&FW RS reply), PM-KISAN 18th instalment beneficiaries and saturation drives, Feb 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2100758"]] },
  { id: "wel:igidr", label: "Indira Gandhi Institute of Development Research (IFROGS)", sub: "Research institute; Rythu Bandhu land-records study (2020)", ty: "agency", fam: "enforce", st: "mh", sz: 3, resolved: true, d: ["Tenant exclusion, budget shortfall, 10% of small-farmer expenditure [documented]"], srcs: [["Thomas, Uday & Zaveri (IGIDR/IFROGS), 'Linking welfare distribution to land records: a case-study of the Rythu Bandhu Scheme', TR-2020-4-27 (PDF)","https://ifrogs.org/PDF/rbs_report.pdf"]] },
  { id: "wel:india-post", label: "Department of Posts / India Post Payments Bank", sub: "MSSC, NSAP disbursal, PM-KISAN doorstep accounts", ty: "agency", fam: "state", st: null, sz: 2, resolved: true, d: ["MSSC sold through post offices; IPPB opens Aadhaar-based accounts for PM-KISAN [documented]"], srcs: [["Akashvani News, over 14.83 lakh MSSC accounts opened, MoS Finance in LS, 31 Jul 2023","https://www.newsonair.gov.in/over-14-83-lakh-accounts-opened-under-mahila-samman-savings-certificate-scheme-govt-in-ls"],["PIB, PM to release 21st instalment of PM-KISAN on 19 Nov 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2190074"]] },
  { id: "wel:india-post-payments-bank", label: "India Post Payments Bank", sub: "Department of Posts payments bank, launched 1 Sep 2018", ty: "psu", fam: "state", st: "dl", sz: 2, resolved: true, d: ["Over ₹45,000 crore DBT disbursed in 7 years; 9.88 crore accounts; 12 lakh merchants; 1.61 lakh post offices [reported]"], srcs: [["Free Press Journal, IPPB disbursed over ₹45,000 crore in DBT in 7 years (Scindia), 1 Sep 2024","https://www.freepressjournal.in/business/india-post-payments-bank-disbursed-over-45000-crore-in-dbt-in-last-7-years"]] },
  { id: "wel:j-jayalalithaa", label: "J. Jayalalithaa", sub: "Chief Minister", ty: "person", fam: "state", st: "tn", sz: 2, resolved: true, d: ["Scrapped TV scheme 6th phase, Jun 2011; alleged Maran family cable gain [alleged]","Mixie-grinder-fan from 15 Sep 2011; 80 lakh by Feb 2014 [reported]","Launched Amma Unavagam subsidised canteens in Chennai (Feb 2013) and the 2011 free-laptop programme; AIADMK says 51 lakh laptops were distributed 2011-21 [reported]"], srcs: [["IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?","https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"],["Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women","https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"],["ThePrint, 'Now it's Rs 15 for 3 meals at Chennai's Amma Canteens', 1 Jun 2020","https://theprint.in/india/now-its-rs-15-for-3-meals-at-chennais-amma-canteens-but-end-of-free-food-bad-news-for-many/433276/"],["Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025","https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"]] },
  { id: "wel:jagran-prakashan", label: "Jagran Prakashan Ltd (Dainik Jagran)", sub: "Listed Hindi daily publisher", ty: "company", fam: "capital", st: "up", sz: 2, resolved: true, d: ["₹59.14 crore of central print ads FY2020-21 to FY2024-25 [documented]"], srcs: [["Newslaundry, 'Modi govt spent Rs 910 crore on print ads in 5 years; Times of India biggest beneficiary' (Lok Sabha reply), 4 Aug 2026","https://www.newslaundry.com/2026/08/04/modi-govt-spent-rs-910-crore-on-print-ads-in-5-years-times-of-india-biggest-beneficiary"]] },
  { id: "wel:jbm-auto", label: "JBM Auto Ltd", sub: "Listed bus and auto-component maker", ty: "company", fam: "capital", st: "hr", sz: 2, resolved: true, d: ["With PMI Electro, 1,040 9-m e-buses for Delhi (Sep 2023) [reported]"], srcs: [["EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023","https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"]] },
  { id: "wel:jyotiraditya-scindia", label: "Jyotiraditya Scindia", sub: "Union Minister of Communications, 2024-06-10→", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["Quoted on IPPB's seventh anniversary: over ₹45,000 crore of DBT disbursed in seven years, 12 lakh merchants onboarded [reported]"], srcs: [["Free Press Journal, IPPB disbursed over ₹45,000 crore in DBT in 7 years (Scindia), 1 Sep 2024","https://www.freepressjournal.in/business/india-post-payments-bank-disbursed-over-45000-crore-in-dbt-in-last-7-years"]] },
  { id: "wel:k-chandrashekar-rao", label: "K. Chandrashekar Rao", sub: "Chief Minister of Telangana 2014–2023; BRS (TRS) president", ty: "person", fam: "state", st: "tg", sz: 2, al: ["KCR"], resolved: true, d: ["Announced the farmers' investment support scheme with a ₹12,000 cr allocation (Feb 2018) [reported]","Announced Rythu Bandhu Rs 4,000/acre, Rs 12,000 cr, 25 Feb 2018 [documented]","Launched Aasara pensions 8 Nov 2014 [reported]","RTI (Society for Safety of Public and Good Governance): ~₹300 crore on publicity Jun 2014–Oct 2018 — ~₹177 crore outdoor, ~₹120 crore TV; ~₹8 crore to T News [reported]"], srcs: [["Wikipedia — Rythu Bandhu scheme","https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"],["Business Standard/ANI, 26 Feb 2018: 'KCR govt to allocate Rs 12,000 cr for crop investment support'","http://www.business-standard.com/article/news-ani/kcr-govt-to-allocate-rs-12-000-cr-for-crop-investment-support-118022600048_1.html"],["Business Standard/ANI, 26 Feb 2018: KCR govt to allocate Rs 12,000 cr for crop investment support","https://www.business-standard.com/article/news-ani/kcr-govt-to-allocate-rs-12-000-cr-for-crop-investment-support-118022600048_1.html"],["Wikipedia (pointer): Aasara pension","https://en.wikipedia.org/wiki/Aasara_pension"],["The News Minute, 'Telangana govt spent around Rs 300 cr on advertisement and publicity in 4 years' (RTI), 2020","https://www.thenewsminute.com/telangana/telangana-govt-spent-around-rs-300-cr-advertisement-and-publicity-4-years-137759"]] },
  { id: "wel:kamal-nath", label: "Kamal Nath", sub: "Chief Minister of Madhya Pradesh, 2018-12-17 to 2020-03-20; MP Congress president during the 2023 campaign", ty: "person", fam: "state", st: "mp", sz: 1, resolved: true, d: ["On 2023-03-05, ahead of the Ladli Behna launch, promised women ₹18,000 per year (₹1,500/month) if Congress won MP [reported]","Signed waiver documents 17 Dec 2018 [reported]","Promised Rs 18,000/yr to women if Congress won MP 2023, 5 Mar 2023 [reported]"], srcs: [["Deccan Herald, 2023-03-05 — Ahead of MP govt’s Ladli Behna launch, Kamal Nath promises women ₹18,000 per year","https://www.deccanherald.com/india/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"],["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"],["Deccan Herald, 5 Mar 2023: Kamal Nath promises women Rs 18,000/yr ahead of Ladli Behna launch","https://www.deccanherald.com/national/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"]] },
  { id: "wel:kamlesh-paswan", label: "Kamlesh Paswan", sub: "MoS Rural Development", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["BE 2024-25 ₹86,000 cr 'highest ever'; retained for 2025-26 [documented]","Gave the Rajya Sabha written reply of 2025-07-25 with MGNREGA BE/RE/release figures 2020-21 to 2024-25 [documented]"], srcs: [["PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"],["PIB, Ministry of Rural Development — Budget allocation under MGNREGA, Rajya Sabha written reply by MoS Kamlesh Paswan, 2025-07-25 (Release ID 2148475)","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"]] },
  { id: "wel:karnataka-rtcs", label: "Karnataka state road transport corporations (KSRTC, BMTC, NWKRTC, KKRTC)", sub: "State transport undertakings reimbursed under Shakti", ty: "company", fam: "state", st: "ka", sz: 3, resolved: true, d: ["Rs 5,015 cr Shakti reimbursement 2024-25 [documented]","Owed ~₹1,800 crore (Dec 2024) and ₹5,172 crore (Jun 2026) by the state for Shakti; free tickets worth ₹7,701 crore in 2025-26 [reported]"], srcs: [["The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget","https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"],["Deccan Herald, 'Rs 1,800 cr Shakti scheme reimbursement pending; transport corporations in red', Dec 2024","https://www.deccanherald.com/india/karnataka/rs1-800-cr-shakti-scheme-reimbursement-pending-transport-corpns-in-red-3320295"],["ETV Bharat, 'Shakti scheme effect: male passengers drop; ₹5,172 crore reimbursement pending', 20 Jun 2026","https://www.etvbharat.com/en/bharat/shakti-scheme-effect-number-of-male-passengers-travelling-in-karnataka-govt-run-buses-drops-significantly-in-karnataka-enn26062003798"]] },
  { id: "wel:kh-muniyappa", label: "K. H. Muniyappa", sub: "Food and Civil Supplies Minister", ty: "person", fam: "state", st: "ka", sz: 3, resolved: true, d: ["Rice resumed from Feb 2025; Rs 170 DBT ends [documented]"], srcs: [["Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024","https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"],["The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya","https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"]] },
  { id: "wel:kn-balagopal", label: "K. N. Balagopal", sub: "Finance Minister", ty: "person", fam: "state", st: "kl", sz: 3, resolved: true, d: ["Rs 1,604 cr sanctioned for second arrears instalment, 20 Jan 2025 [reported]"], srcs: [["Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go","https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"]] },
  { id: "wel:ksspl", label: "Kerala Social Security Pension Ltd", sub: "State SPV that borrows and disburses welfare pensions", ty: "company", fam: "state", st: "kl", sz: 3, resolved: true, d: ["Rs 10,729 cr assistance in 2024-25 BE; its loans counted as state debt by the Centre [documented]"], srcs: [["PRS, Kerala Budget Analysis 2024-25","https://prsindia.org/budgets/states/kerala-budget-analysis-2024-25"],["Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go","https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"]] },
  { id: "wel:kt-rajendra-balaji", label: "K. T. Rajendra Balaji", sub: "Special Programmes Implementation Minister", ty: "person", fam: "state", st: "tn", sz: 3, resolved: true, d: ["80 lakh beneficiaries by Feb 2014 [reported]"], srcs: [["Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women","https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"]] },
  { id: "wel:kt-rama-rao", label: "K. T. Rama Rao", sub: "Minister", ty: "person", fam: "state", st: "tg", sz: 3, al: ["KTR"], resolved: true, d: ["Alleged Congress trying to evade implementing the farmer scheme, 21 Dec 2024 [reported]"], srcs: [["Deccan Herald/PTI, 21 Dec 2024: Rythu Bandhu Rs 22,600 cr given to ineligible people in BRS regime, says Telangana CM","https://www.deccanherald.com/india/telangana/rythu-bandhu-rs-22600-crore-given-to-ineligible-people-in-brs-regime-says-telangana-cm-3328152"]] },
  { id: "wel:kv-thomas", label: "K. V. Thomas", sub: "Food minister 2011–14 (INC)", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["NFSA ordinance 5 Jul 2013; Act gazetted 10 Sep 2013 under his ministry [documented]"], srcs: [["Wikipedia (pointer), K. V. Thomas","https://en.wikipedia.org/wiki/K._V._Thomas"],["Wikipedia (pointer), National Food Security Act 2013","https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"]] },
  { id: "wel:lokniti-csds", label: "Lokniti-CSDS", sub: "post-poll survey programme", ty: "agency", fam: "enforce", st: "dl", sz: 2, al: ["Lokniti","CSDS"], resolved: true, d: ["2024 post-poll (N=19,663): scheme-benefit and credit-attribution tables [documented]","MP 2023 post-poll (N=3,050, 18–24 Nov 2023): 80.4% of respondents said they or a female family member had benefited from Ladli Behna; 48.6% of valid votes BJP, 40.0% Congress after weighting to the actual result [documented]","Maharashtra 2024 post-poll (The Hindu, 25 Nov 2024): more than 80% of women respondents had applied for Ladki Bahin; Mahayuti support 3 points higher among women than men; authors caution it is ‘too early’ to call women a welfare-beneficiary constituency [reported]","NES 2019 (as used by Deshpande, Tillin & Kailash 2019): Ujjwala, Jan Dhan and Awas beneficiaries more likely to vote BJP; pension and MGNREGA recipients less likely [documented]","NES 2019 post-poll: NDA vote among PM-KISAN beneficiaries 51% vs 44% non-beneficiaries; Ujjwala 49/42; Jan Dhan 50/43; PMAY 46/44 [documented]","MP 2023 post-poll: 80.4% of respondents' households benefited from Ladli Behna (N=3,050) [documented]","Maharashtra 2024 post-poll: women 50% vs men 47% for Mahayuti; >80% women applied for Ladki Bahin [reported]"], srcs: [["Lokniti-CSDS, Social and Political Barometer Post-poll Study 2024 — Survey Findings (PDF on file, dated 14 Jun 2024; exact URL not recovered — see gaps)","https://www.lokniti.org/"],["Lokniti-CSDS — Madhya Pradesh Postpoll Survey 2023: Survey Findings (N=3,050, 18–24 Nov 2023; PDF held locally; Lokniti state-election index page opened)","https://www.lokniti.org/state-assembly-elections"],["Lokniti-CSDS Maharashtra 2024 post-poll analysis, The Hindu, 25 Nov 2024 (Deshpande, ‘Women sided with Mahayuti for Ladki Bahin Yojana’s monthly dole’; Mishra, women as deciders) — page PDF held locally; thehindu.com unreachable from this container","https://www.lokniti.org/state-assembly-elections"],["Deshpande, Tillin & Kailash (2019) The BJP’s Welfare Schemes: Did They Make a Difference in the 2019 Elections? — Studies in Indian Politics 7(2):219–233 (Crossref metadata + abstract)","https://api.crossref.org/works/10.1177/2321023019874911"],["Seminar #720, Jyoti Mishra & Vibha Attri (Lokniti-CSDS), 'Did welfare win votes?' (NES 2019 post-poll), 2019","https://india-seminar.com/2019/720/720_jyoti_and_vibha.htm"],["Lokniti-CSDS, Madhya Pradesh Post-poll Survey 2023 — survey findings (PDF)","https://www.lokniti.org/media/PDF-upload/1703684877_6052900_download_report.pdf"],["BehanBox, 4 Dec 2024: Maharashtra poll analyses and women's agency (cites Lokniti-CSDS post-poll)","https://behanbox.com/2024/12/04/how-maharashtra-poll-analyses-are-missing-the-rise-of-womens-agency/"]] },
  { id: "wel:m-karunanidhi", label: "M. Karunanidhi", sub: "Chief Minister", ty: "person", fam: "state", st: "tn", sz: 3, resolved: true, d: ["Launched free colour TV scheme, 15 Sep 2006 [documented]"], srcs: [["Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme","https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"]] },
  { id: "wel:maharashtra-dgipr", label: "Directorate General of Information and Public Relations, Maharashtra", sub: "State advertising arm", ty: "agency", fam: "state", st: "mh", sz: 2, resolved: true, d: ["RTI reply of 4 Oct 2024: ~₹200 crore (₹199.81 crore) on Ladki Bahin publicity [reported]"], srcs: [["Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024","https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"]] },
  { id: "wel:mallu-bhatti-vikramarka", label: "Mallu Bhatti Vikramarka", sub: "Deputy Chief Minister and Finance Minister", ty: "person", fam: "state", st: "tg", sz: 3, resolved: true, d: ["Second phase up to Rs 1.5 lakh in July 2024; Rs 2 lakh by August [documented, AIR]"], srcs: [["News On Air (AIR), 18 Jul 2024: Over Rs 6,000 cr released towards crop loan waiver; 11 lakh farmers in phase 1","https://www.newsonair.gov.in/telangana-over-rs-6000-cr-released-by-state-govt-towards-crop-loan-waiver/"]] },
  { id: "wel:mamata-banerjee", label: "Mamata Banerjee", sub: "Chief Minister", ty: "person", fam: "state", st: "wb", sz: 3, resolved: true, d: ["Established Kanyashree 8 Mar 2013; UN award Jun 2017 [pointer]","Lakshmir Bhandar raised Rs 500→1,000 / 1,000→1,200 before LS 2024 [reported]","Announced Rs 500 hike from Feb 2026 in interim budget [reported]","TMC reduced to 80 seats in May 2026 [reported]"], srcs: [["Wikipedia — 2021 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2021_West_Bengal_Legislative_Assembly_election"],["Wikipedia (pointer): Kanyashree Prakalpa","https://en.wikipedia.org/wiki/Kanyashree_Prakalpa"],["Deccan Herald, 6 Jun 2024: Mamata cashes in on Lakshmir Bhandar in LS 2024","https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mamata-banerjee-cashes-in-on-lakshmir-bhandar-and-modis-shift-to-hindutva-in-west-bengal-3055262"],["ANI, 6 Feb 2026: West Bengal announces Rs 500 Lakshmir Bhandar hike in interim budget 2026-27","https://www.aninews.in/news/national/politics/west-bengal-govt-announces-rs-500-hike-for-lakshmir-bhandar-beneficaries-ahead-of-assembly-polls20260206060332/"],["Wikipedia (pointer): 2026 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2026_West_Bengal_Legislative_Assembly_election"]] },
  { id: "wel:manmohan-singh", label: "Manmohan Singh", sub: "Prime Minister 2004–14 (INC)", ty: "person", fam: "state", st: null, sz: 3, resolved: true, d: ["released 'MGNREGA Sameeksha' 14 Jul 2012; invited Nilekani to chair UIDAI 2009 [documented]"], srcs: [["Wikipedia (pointer), MGNREGA 2005","https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"],["Wikipedia (pointer), Nandan Nilekani","https://en.wikipedia.org/wiki/Nandan_Nilekani"],["Wikipedia — Manmohan Singh (infobox: Union Minister of Finance 21 June 1991 – 16 May 1996, under PM P.V. Narasimha Rao; predecessor Yashwant Sinha, successor Jaswant Singh)","https://en.wikipedia.org/wiki/Manmohan_Singh"]] },
  { id: "wel:manpreet-singh-badal", label: "Manpreet Singh Badal", sub: "Finance Minister of Punjab, 2017-03-16→2022-03", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["Distributed Smart Connect phones at Bathinda on launch day; budgeted ₹100 crore for the scheme in 2017-18 [documented]"], srcs: [["The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020","https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"]] },
  { id: "wel:mk-stalin", label: "M. K. Stalin", sub: "Chief Minister", ty: "person", fam: "state", st: "tn", sz: 2, resolved: true, d: ["Free bus travel for women from 7 May 2021 [reported]","Distributed TV sets at Enathur, 15 Sep 2006 [documented]","Launched KMUT at Kanchipuram 15 Sep 2023 [reported]","Lost Kolathur seat in 2026 [reported]"], srcs: [["Wikipedia — 2026 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"],["The Federal, 12 Jun 2023: Free bus travel for women — Karnataka model vs TN, Delhi, Punjab","https://thefederal.com/states/south/karnataka/karnataka-introduces-free-bus-travel-for-women-a-comparison-with-other-states"],["Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme","https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"],["Deccan Herald, 15 Sep 2023: Stalin launches Rs 1,000 monthly scheme for 1.06 cr women","https://www.deccanherald.com/india/tamil-nadu/stalin-launches-rs-1000-monthly-assistance-scheme-for-women-heads-of-families-2687619"],["Wikipedia (pointer): 2026 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"]] },
  { id: "wel:mohan-charan-majhi", label: "Mohan Charan Majhi", sub: "Chief Minister", ty: "person", fam: "state", st: "or", sz: 2, resolved: true, d: ["Rs 5,000 cr Samrudha Krushak in 2024-25 BE [documented]","Subhadra guidelines Aug 2024; launch 17 Sep 2024 [documented]"], srcs: [["Wikipedia — Subhadra Yojana","https://en.wikipedia.org/wiki/Subhadra_Yojana"],["PRS, Odisha Budget Analysis 2024-25","https://prsindia.org/budgets/states/odisha-budget-analysis-2024-25"],["PIB, 17 Sep 2024: PM launches SUBHADRA in Bhubaneswar","https://www.pib.gov.in/PressReleseDetailm.aspx?PRID=2055572&reg=3&lang=2"],["Wikipedia (pointer): Subhadra Yojana","https://en.wikipedia.org/wiki/Subhadra_Yojana"]] },
  { id: "wel:mohan-yadav", label: "Mohan Yadav", sub: "Chief Minister of Madhya Pradesh, 2023-12-13→", ty: "person", fam: "state", st: "mp", sz: 2, resolved: true, d: ["Told the assembly in a written reply (Jul 2025) that ₹260 crore was spent on Ladli Behna publicity before the 2023 election and ₹290 crore in total [documented]","Transferred 25th instalment Rs 1,551.44 cr to 1.27 cr women, Jun 2025 [reported]","Announced Rs 1,500 on 12 Oct 2025; cabinet approved 10 Nov 2025 [reported]"], srcs: [["Wikipedia — 2023 MP Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"],["Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025","https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"],["Deccan Herald, 17 Jun 2025: Ladli Behna Rs 250 Raksha Bandhan shagun; 25th instalment Rs 1,551 cr to 1.27 cr women","https://www.deccanherald.com/india/madhya-pradesh/ladli-behna-beneficiaries-to-get-rs-250-as-raksha-bandhan-shagun-mp-cm-3589260"],["India TV, 12 Oct 2025: Mohan Yadav transfers Rs 1,541 cr (29th instalment), announces Rs 1,500","https://www.indiatvnews.com/madhya-pradesh/madhya-pradesh-ladli-behna-scheme-yojana-cm-mohan-yadav-transfers-rs-1541-crore-announces-hike-to-rs-1500-2025-10-12-1012478"],["IANS via Prokerala, 10 Nov 2025: MP cabinet approves Rs 1,500 from Nov 12; Rs 3,000 by 2028 plan","https://www.prokerala.com/news/articles/a1695417.html"]] },
  { id: "wel:mp-jansampark", label: "Public Relations (Jansampark) Department, Madhya Pradesh", sub: "State advertising arm", ty: "agency", fam: "state", st: "mp", sz: 2, resolved: true, d: ["₹290 crore Ladli Behna publicity per CM's written reply (Jul 2025); ₹260 crore of it before the Nov 2023 election [documented]"], srcs: [["Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025","https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"]] },
  { id: "wel:n-chandrababu-naidu", label: "N. Chandrababu Naidu", sub: "Chief Minister", ty: "person", fam: "state", st: "ap", sz: 2, resolved: true, d: ["Annadata Sukhibhava Rs 1,000 cr in 2024-25 BE [documented]","Talliki Vandanam: Rs 15,000 per school-going child to mothers; 67 lakh students, 43 lakh mothers [reported]"], srcs: [["Wikipedia — 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"],["PRS, Andhra Pradesh Budget Analysis 2024-25","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2024-25"],["Wikipedia infobox (pointer to ECI): 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"],["Deccan Herald/PTI, 13 Jun 2025: AP launches Talliki Vandanam Rs 15,000 per child","https://www.deccanherald.com/india/andhra-pradesh/andhra-govt-launches-talliki-vandanam-scheme-rs-15000-to-be-given-for-school-going-child-3584484"]] },
  { id: "wel:nandan-nilekani", label: "Nandan Nilekani", sub: "UIDAI chairman 2009–14", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["left Infosys Jul 2009 to chair UIDAI under PM Manmohan Singh [documented]","contested 2014 Lok Sabha for INC, lost by 2,28,575 votes [documented]","chairs EkStep, which with BHASHINI supported Kisan-eMitra (Sep 2023) [documented]"], srcs: [["Wikipedia (pointer), Nandan Nilekani","https://en.wikipedia.org/wiki/Nandan_Nilekani"],["PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"]] },
  { id: "wel:naveen-patnaik", label: "Naveen Patnaik", sub: "Chief Minister", ty: "person", fam: "state", st: "or", sz: 3, resolved: true, d: ["Cabinet Memorandum No 23029 of 21 Dec 2018 approved KALIA [documented, CAG]","BJD lost 2024 [documented]"], srcs: [["Pressreader/Hindustan Times — Odisha Rs 10,180-cr KALIA package","https://www.pressreader.com/india/hindustan-times-delhi/20181222/281788515170582"],["CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)","https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"],["Wikipedia infobox (pointer to ECI): 2024 Odisha Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Odisha_Legislative_Assembly_election"]] },
  { id: "wel:nayab-singh-saini", label: "Nayab Singh Saini", sub: "CM Haryana (BJP)", ty: "person", fam: "state", st: "hr", sz: 2, resolved: true, d: ["Cabinet decision 28 Aug 2025; scheme operational 25 Sep 2025; phase 1 income < Rs 1 lakh [documented]"], srcs: [["Deccan Herald/PTI, 28 Aug 2025: Haryana cabinet decides to roll out Lado Lakshmi from Sep 25","https://www.deccanherald.com/india/haryana/haryana-decides-to-implement-lado-lakshmi-yojana-eligible-women-to-get-rs-2100-monthly-aid-3700884"],["Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification","https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"]] },
  { id: "wel:nber", label: "NBER / J-PAL-UCSD study team", sub: "academic publisher of MNS Jharkhand study", ty: "agency", fam: "enforce", st: null, sz: 2, resolved: true, d: ["WP 26744 (2020, rev. 2021): 1.5–2 million lost PDS access during Aadhaar reforms in Jharkhand [documented]"], srcs: [["NBER WP 26744, Muralidharan, Niehaus & Sukhtankar, 'Identity Verification Standards in Welfare Programs: Experimental Evidence from India', Feb 2020 rev. Sep 2021","https://www.nber.org/system/files/working_papers/w26744/w26744.pdf"],["Ideas for India, Muralidharan-Niehaus-Sukhtankar, 'Balancing corruption and exclusion: incorporating Aadhaar into PDS' (Jharkhand), 17 Apr 2020","https://www.ideasforindia.in/topics/poverty-inequality/balancing-corruption-and-exclusion-incorporating-aadhaar-into-pds"],["Muralidharan, Niehaus & Sukhtankar, 'General Equilibrium Effects of (Improving) Public Employment Programs: Experimental Evidence from India', NBER WP 23838 (2017; revised, published Econometrica 2023) — abstract","https://www.nber.org/papers/w23838"],["Muralidharan, Niehaus & Sukhtankar, 'Identity Verification Standards in Welfare Programs: Experimental Evidence from India', NBER WP 26744 (Feb 2020, revised) — abstract","https://www.nber.org/papers/w26744"]] },
  { id: "wel:nirmala-bhuria", label: "Nirmala Bhuria", sub: "Minister for Women and Child Development, Madhya Pradesh, 2023-12-25→", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["Told the assembly no second Ladli Behna beneficiary survey would be conducted (Jul 2025) [documented]"], srcs: [["Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025","https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"]] },
  { id: "wel:niti-aayog", label: "NITI Aayog (DMEO)", sub: "government evaluator", ty: "agency", fam: "state", st: null, sz: 2, resolved: true, d: ["DMEO evaluation of PM-KISAN cited by government: 92% spent on inputs [reported]"], srcs: [["PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"]] },
  { id: "wel:nitish-kumar", label: "Nitish Kumar", sub: "Chief Minister", ty: "person", fam: "state", st: "br", sz: 3, resolved: true, d: ["Called the cycle scheme \"very close to my heart\", Apr 2010 blog [documented]","Bihar MMRY: Rs 7,500 cr to 75 lakh women, launched by PM 26 Sep 2025 [documented]","NDA won 202/243 Nov 2025 [reported]"], srcs: [["Deccan Herald — Bihar Rs 10,000 cash transfer to women","https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-rs-10000-cash-transfer-to-women-may-prove-game-changer-for-nitish-kumar-3773893"],["Nitish Kumar's blog, Apr 2010: Mukhyamantri Balika Cycle Yojna","http://nitishspeaks.blogspot.com/2010/04/mukhyamantri-balika-cycle-yojna.html"],["Wikipedia infobox (pointer to ECI): 2010 Bihar Legislative Assembly election","https://en.wikipedia.org/wiki/2010_Bihar_Legislative_Assembly_election"],["PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"],["Deccan Herald, 15 Nov 2025: Bihar results — NDA 202 seats","https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-results-nda-cruises-to-victory-by-winning-202-seats-and-a-vote-share-of-over-40-3798063"]] },
  { id: "wel:npci", label: "National Payments Corporation of India", sub: "Not-for-profit umbrella payments body owned by banks; runs Aadhaar Payment Bridge (APB) and AePS", ty: "company", fam: "capital", st: "mh", sz: 3, resolved: true, d: ["APB maintains the Aadhaar→bank mapper on which DBT credits are routed [documented]","Interchange/switching fee on APB and AePS transactions not obtained here (gap)"], srcs: [["PIB backgrounder, Direct Benefit Transfer (DBT), Jan 2022","https://static.pib.gov.in/WriteReadData/specificdocs/documents/2022/jan/doc2022153101.pdf"]] },
  { id: "wel:omcs", label: "Oil marketing companies (IOC, BPCL, HPCL)", sub: "State-owned LPG marketers who issue PMUY connections and are reimbursed by GoI", ty: "psu", fam: "state", st: null, sz: 3, resolved: true, d: ["Issued 7.19 crore PMUY connections by 31 Mar 2019; GoI budget ₹8,000 crore → ₹12,800 crore for 5 → 8 crore connections (₹1,600 per connection) [documented]"], srcs: [["CAG press release on Performance Audit Report No. 14 of 2019 on PMUY, 11 Dec 2019 (local copy; exact report URL unresolved — see gaps)","https://cag.gov.in/en"]] },
  { id: "wel:p-chidambaram", label: "P. Chidambaram", sub: "Finance Minister 2004–08 (INC)", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["Budget speech 29 Feb 2008, para 73: waiver ₹50,000 cr + OTS ₹10,000 cr; ~4 crore farmers; completion by 30 Jun 2008 [documented]"], srcs: [["Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)","https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"]] },
  { id: "wel:pfms", label: "Public Financial Management System (PFMS)", sub: "Office of the Controller General of Accounts, Ministry of Finance — payment and reconciliation platform for DBT", ty: "agency", fam: "state", st: "dl", sz: 2, resolved: true, d: ["Integrated with 500+ banks for account/Aadhaar pre-validation; ₹36,659 crore to 16.01 crore beneficiaries during the 2020 lockdown [documented]"], srcs: [["PIB backgrounder, Direct Benefit Transfer (DBT), Jan 2022","https://static.pib.gov.in/WriteReadData/specificdocs/documents/2022/jan/doc2022153101.pdf"]] },
  { id: "wel:pinarayi-vijayan", label: "Pinarayi Vijayan", sub: "Chief Minister", ty: "person", fam: "state", st: "kl", sz: 3, resolved: true, d: ["Assembly statement: five-instalment settlement of Rs 4,250 cr dues, 10 Jul 2024 [reported]"], srcs: [["Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears","https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"]] },
  { id: "wel:pmi-electro-mobility", label: "PMI Electro Mobility Solutions Pvt Ltd", sub: "Private e-bus maker/operator", ty: "company", fam: "capital", st: "dl", sz: 1, resolved: true, d: ["Share of the 1,040 9-m Delhi e-bus deal (Sep 2023) [reported]"], srcs: [["EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023","https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"]] },
  { id: "wel:prasad-lad", label: "Prasad Lad", sub: "MLC, Maharashtra Legislative Council; BJP Maharashtra vice-president", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["Defended the Ladki Bahin ad spend as standard practice: 'how else would people know about the scheme?' (Oct 2024) [reported]"], srcs: [["Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024","https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"]] },
  { id: "wel:prs-legislative-research", label: "PRS Legislative Research", sub: "independent legislative research institute; State of State Finances reports", ty: "agency", fam: "enforce", st: "dl", sz: 2, al: ["PRS"], resolved: true, d: ["SOSF 2025-26: 12 states budget ₹1,68,040 cr (0.5% of GDP) for women's UCTs in 2025-26, up from two states in 2022-23 [documented]","State of State Finances 2025: 12 states run largely unconditional women’s cash transfers in 2025-26 (up from 2 in 2022-23), estimated ₹1,68,040 crore (0.5% of GDP, ~6% of revenue expenditure); six of the 12 project a revenue deficit; Karnataka’s balance moves from +0.3% to −0.6% of GSDP and MP’s from +1.1% to +0.4% once the schemes are counted [documented]","State budget analyses used for outlays; SOSF 2025-26 [documented]","SOSF 2025: 12 states, Rs 1,68,040 cr on women's UCTs in 2025-26 BE (0.5% of GDP); 6 in revenue deficit [documented]"], srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PRS Legislative Research, State of State Finances 2025 — landing page","https://prsindia.org/budgets/states/policy/state-of-state-finances-2025"],["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.13-14 and subsidy section (PDF)","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "wel:ptr-palanivel-thiaga-rajan", label: "P. T. R. Palanivel Thiaga Rajan", sub: "Finance Minister", ty: "person", fam: "state", st: "tn", sz: 3, resolved: true, d: ["Women passenger share 40%→61% (budget speech, Mar 2022) [documented]"], srcs: [["Deccan Herald, 18 Mar 2022: Free travel — more women in Tamil Nadu now take government buses (budget 2022-23)","https://www.deccanherald.com/india/free-travel-more-women-in-tamil-nadu-now-take-government-buses-1092556.html"]] },
  { id: "wel:raghuvansh-prasad-singh", label: "Raghuvansh Prasad Singh", sub: "Rural Development 2004–09 (RJD)", ty: "person", fam: "state", st: null, sz: 2, al: ["Raghuvansh Singh"], resolved: true, d: ["took charge as Union RD Minister 24 May 2004; NREGA passed 23 Aug 2005 [documented]"], srcs: [["Wikipedia (pointer), Raghuvansh Prasad Singh","https://en.wikipedia.org/wiki/Raghuvansh_Prasad_Singh"],["Wikipedia (pointer), MGNREGA 2005","https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"]] },
  { id: "wel:ramalinga-reddy", label: "Ramalinga Reddy", sub: "Transport Minister", ty: "person", fam: "state", st: "ka", sz: 3, resolved: true, d: ["Shakti from 11 Jun 2023 [reported]"], srcs: [["The Federal, 12 Jun 2023: Free bus travel for women — Karnataka model vs TN, Delhi, Punjab","https://thefederal.com/states/south/karnataka/karnataka-introduces-free-bus-travel-for-women-a-comparison-with-other-states"]] },
  { id: "wel:raman-singh", label: "Raman Singh", sub: "Chief Minister", ty: "person", fam: "state", st: "ct", sz: 3, resolved: true, d: ["Known as \"Chhaur wale baba\" for cheap rice, sought third term Nov 2013 [reported]"], srcs: [["Business Standard, 13 Nov 2013: Politics over rice in Chhattisgarh","https://www.business-standard.com/article/politics/politics-over-rice-in-chhattisgarh-113111300355_1.html"],["Wikipedia infobox (pointer to ECI): 2008 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2008_Chhattisgarh_Legislative_Assembly_election"]] },
  { id: "wel:rameswar-teli", label: "Rameswar Teli", sub: "MoS Petroleum 2021", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["state-wise average refills 2018-19 to 2020-21 tabled 20 Dec 2021 [documented]"], srcs: [["PIB (MoPNG RS reply), Average LPG refill consumption of PMUY beneficiaries 2018-19 to 2020-21, 20 Dec 2021","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1783430"]] },
  { id: "wel:ramnath-thakur", label: "Ramnath Thakur", sub: "MoS Agriculture", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["₹416.75 cr recovered from ineligible PM-KISAN beneficiaries as of 2 Dec 2025 [documented]"], srcs: [["Lok Sabha Unstarred Q.358 (MoS Agri Ramnath Thakur), discrepancy in PM-KISAN: ₹416.75 cr recovered from ineligible beneficiaries, 2 Dec 2025","https://sansad.in/getFile/loksabhaquestions/annex/186/AU358_FPeZsZ.pdf?source=pqals"],["PIB (MoA&FW RS reply), PM-KISAN 18th instalment beneficiaries and saturation drives, Feb 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2100758"]] },
  { id: "wel:rb-udayakumar", label: "R. B. Udayakumar", sub: "MLA Thirumangalam; AIADMK deputy leader in the TN Assembly; former Revenue Minister", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["Claimed 51 lakh laptops distributed under AIADMK and that DMK halted the scheme (Mar 2025) [reported]"], srcs: [["Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025","https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"]] },
  { id: "wel:rbi", label: "Reserve Bank of India", sub: "central bank; publishes State Finances: A Study of Budgets and the RBI Bulletin", ty: "agency", fam: "enforce", st: "mh", sz: 3, al: ["RBI"], resolved: true, d: ["RBI Bulletin June 2022 article 'State Finances: A Risk Analysis' named Punjab, Rajasthan, Kerala, West Bengal, Bihar, AP, Jharkhand, MP, UP and Haryana as the ten most indebted states, and Bihar, Kerala, Punjab, Rajasthan, WB as 'highly stressed' [documented]","State Finances: A Study of Budgets of 2025-26 released 23 Jan 2026; Ch. IV warns cash-transfer schemes risk 'crowding out critical investments' and asks for impact assessment and a state-level DBT database with separate budget codes [documented]","State Finances 2024-25 (Dec 2024) flagged the sharp rise in subsidies and cash transfers to farmers, youth and women as a source of stress and recommended rationalising such spending — as quoted by PRS (the RBI PDF sits behind a CAPTCHA in this container) [reported]","State Finances 2025-26 released 2026-01-23; chapters: Overview; Fiscal Position; Demographic Transition; Way Forward; Statement 36 covers subsidies [documented]","Ten states waived Rs 2.4 lakh cr since 2014-15, mostly near elections; recommends avoiding waivers [documented]","State Finances 2024 (Dec 2024) warned that subsidies and cash transfers to women, youth, farmers stress state finances; recommended rationalising (as summarised by PRS) [reported]"], srcs: [["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"],["RBI, State Finances: A Study of Budgets of 2025-26 (23 Jan 2026), Chapter IV 'The Way Forward', paras 4.1, 4.5, 4.8","https://www.rbi.org.in/Scripts/PublicationsView.aspx?id=23694"],["RBI, 'State Finances: A Study of Budgets' publication index (2025-26 edition dated 23 Jan 2026)","https://www.rbi.org.in/Scripts/AnnualPublications.aspx?head=State%20Finances%20:%20A%20Study%20of%20Budgets"],["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"],["RBI — State Finances: A Study of Budgets (publication index; 2025-26 edition released 2026-01-23; archive 2002–2024)","https://www.rbi.org.in/Scripts/AnnualPublications.aspx?head=State%20Finances%20:%20A%20Study%20of%20Budgets"],["RBI — State Finances: A Study of Budgets 2024-25 (Dec 2024) — PDF behind a CAPTCHA in this container; quoted via PRS","https://rbidocs.rbi.org.in/rdocs/Publications/PDFs/0STATEFINANCE2024AE6FF65F475C4934B53CC8ABE7FAB30E.PDF"],["PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)","https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "wel:rekha-gupta", label: "Rekha Gupta", sub: "CM Delhi (BJP) from Feb 2025", ty: "person", fam: "state", st: "dl", sz: 1, resolved: true, d: ["Cabinet approved Rs 2,500/month, Rs 5,100 cr, 8 Mar 2025 [reported]","Launch still pending Jul 2026; Rs 5,110 cr in 2026-27 budget [reported]"], srcs: [["Wikipedia — 2025 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"],["Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr","https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"],["India TV, 8 Jul 2026: Delhi to launch Mahila Samriddhi on Raksha Bandhan; Rs 5,110 cr 2026-27","https://www.indiatvnews.com/delhi/delhi-govt-to-launch-mahila-samriddhi-yojana-on-raksha-bandhan-check-who-can-get-rs-2500-monthly-and-required-documents-2026-07-08-1047512"]] },
  { id: "wel:revanth-reddy", label: "Revanth Reddy", sub: "Chief Minister", ty: "person", fam: "state", st: "tg", sz: 2, resolved: true, d: ["Told Assembly Rs 22,600 cr of Rythu Bandhu went to non-cultivated land, 21 Dec 2024 [reported]","Cabinet: Rythu Bharosa Rs 12,000/acre from 26 Jan 2025 [reported]","Jan 2025 fact check: Rs 2,500 not paid to any beneficiary; bus/LPG parts implemented [reported]"], srcs: [["The News Minute — BRS losses, Congress gains, Telangana 2023","https://www.thenewsminute.com/telangana/brs-losses-congress-gains-how-telangana-voted-in-2023"],["Deccan Herald/PTI, 21 Dec 2024: Rythu Bandhu Rs 22,600 cr given to ineligible people in BRS regime, says Telangana CM","https://www.deccanherald.com/india/telangana/rythu-bandhu-rs-22600-crore-given-to-ineligible-people-in-brs-regime-says-telangana-cm-3328152"],["ANI, 5 Jan 2025: Telangana farmers to receive Rs 12,000 per acre annually under Rythu Bharosa","https://www.aninews.in/news/national/general-news/telangana-farmers-to-receive-rs-12000-per-acre-annually-under-rythu-bharosa-scheme20250105033356/"],["The South First, 8 Jan 2025: fact check — Rs 2,500 Mahalakshmi not paid","https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"]] },
  { id: "wel:s-regupathy", label: "S. Regupathy", sub: "Minister for Law, Courts and Prisons, Tamil Nadu, 2021-05-07→", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["Countered that the laptop scheme was stopped during the AIADMK regime itself (Mar 2025) [reported]"], srcs: [["Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025","https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"]] },
  { id: "wel:sachin-pilot", label: "Sachin Pilot", sub: "Deputy Chief Minister", ty: "person", fam: "state", st: "rj", sz: 3, resolved: true, d: ["\"We will keep our poll promises\", Dec 2018 [reported]"], srcs: [["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"]] },
  { id: "wel:sajjala-ramakrishna-reddy", label: "Sajjala Ramakrishna Reddy", sub: "General Secretary, YSR Congress Party; Adviser (Public Affairs) to AP Government 2019→2024", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["Denied the volunteers were party agents; said Naidu wanted to remove the system to restore TDP-era committees (Apr 2024) [reported]"], srcs: [["ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024","https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"]] },
  { id: "wel:siddaramaiah", label: "Siddaramaiah", sub: "Chief Minister", ty: "person", fam: "state", st: "ka", sz: 2, resolved: true, d: ["Cabinet approved five guarantees at first meeting, 20 May 2023 [reported]","Alleged Union \"political decision\" on rice, Jun 2023 [alleged]","Flagged off 100 new BMTC diesel buses on 12 Sep 2024, part of an 840-bus order funded by a ₹336 crore state grant; pledged to continue the five guarantees [documented]","Government disbursed Rs 50,005 cr under Gruha Lakshmi to 1.28 cr women by Sep 2025 [reported]"], srcs: [["Wikipedia — 2023 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"],["Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting","https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"],["The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya","https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"],["Deccan Herald, 'BMTC launches 100 new diesel buses, to get 820 of them by March', 12 Sep 2024","https://www.deccanherald.com/india/karnataka/bengaluru/bmtc-launches-100-new-diesel-buses-to-get-820-of-them-by-march-3188420"],["Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed","https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"]] },
  { id: "wel:state-farm-loan-waivers-2014-19", label: "State farm loan waivers 2014-15 to 2019 (ten states, RBI IWG universe)", sub: "Instrument class audited by the RBI Internal Working Group", ty: "mechanism", fam: "instrument", st: null, sz: 3, resolved: true, d: ["Rs 2.4 lakh cr announced; ~66% released to banks [documented]"], srcs: [["PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)","https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"]] },
  { id: "wel:sukhvinder-singh-sukhu", label: "Sukhvinder Singh Sukhu", sub: "CM Himachal Pradesh (INC) from Dec 2022", ty: "person", fam: "state", st: "hp", sz: 1, resolved: true, d: ["Assembly reply Sep 2026: Rs 29.12 cr disbursed over three years; 16 seats with zero beneficiaries [reported]"], srcs: [["Onmanorama — Himachal restores Old Pension Scheme","https://www.onmanorama.com/news/india/2023/01/14/congress-himachal-pradesh-old-pension-scheme.html"],["ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals","https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"]] },
  { id: "wel:sunil-tatkare", label: "Sunil Tatkare", sub: "MP Raigad; President, NCP (Ajit Pawar) Maharashtra unit, 2023-07→", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["Responded that all governments, including the Centre, run media campaigns when a scheme launches (Oct 2024) [reported]"], srcs: [["Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024","https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"]] },
  { id: "wel:supriya-sule", label: "Supriya Sule", sub: "Member of Parliament (Lok Sabha), Baramati, 2009→; NCP (Sharadchandra Pawar) working president", ty: "person", fam: "state", st: "mh", sz: 2, resolved: true, d: ["On 2025-07-29 alleged a ₹4,800 crore fraud in Ladki Bahin DBT payments and sought an SIT probe; the state government’s reply was not captured in the page text opened [alleged]","Alleged Rs 4,800 cr scam and sought SIT, 29 Jul 2025 [alleged]"], srcs: [["Deccan Herald, 2025-07-29 — Supriya Sule alleges ₹4,800 crore fraud in Ladki Bahin Yojana, seeks SIT probe","https://www.deccanherald.com/india/maharashtra/supriya-sule-alleges-rs-4800-crore-fraud-in-ladki-bahin-yojana-seeks-sit-probe-3654533"],["Deccan Herald, 29 Jul 2025: Supriya Sule alleges Rs 4,800 cr fraud, seeks SIT","https://www.deccanherald.com/india/maharashtra/supriya-sule-alleges-rs-4800-crore-fraud-in-ladki-bahin-yojana-seeks-sit-probe-3654533"]] },
  { id: "wel:suvendu-adhikari", label: "Suvendu Adhikari", sub: "CM West Bengal 2026 (BJP)", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["named as CM in PIB release of 18 Jun 2026 [documented]"], srcs: [["PIB, PM to release 23rd instalment from Tarakeswar, Hooghly, WB on 20 Jun 2026, 18 Jun 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2274616"],["India TV News, West Bengal Assembly Election 2026 result: full list of winners, 4 May 2026","https://www.indiatvnews.com/west-bengal/news-west-bengal-assembly-election-2026-full-list-of-winners-leading-candidates-294-seats-2026-05-04-1038758"],["The Daily Star — Suvendu Adhikari sworn in as WB CM","https://www.thedailystar.net/news/asia/india/news/suvendu-sworn-chief-minister-west-bengal-4171876"]] },
  { id: "wel:switch-mobility", label: "Switch Mobility Ltd", sub: "Ashok Leyland e-bus subsidiary", ty: "company", fam: "capital", st: "tn", sz: 2, resolved: true, d: ["950 12-m low-floor e-buses for Delhi under the CESL tender (deal signed Sep 2023) [reported]"], srcs: [["EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023","https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"]] },
  { id: "wel:t-news", label: "T News (Telangana Broadcasting Pvt Ltd)", sub: "Telugu news channel widely described as BRS-aligned", ty: "company", fam: "capital", st: "tg", sz: 1, resolved: false, collisionRisk: "Ownership link to BRS leadership is widely reported but not verified from a primary record here; no edge drawn beyond the RTI-disclosed ad spend", d: ["~₹8 crore of Telangana government TV publicity Jun 2014–Oct 2018 per RTI [reported]"], srcs: [["The News Minute, 'Telangana govt spent around Rs 300 cr on advertisement and publicity in 4 years' (RTI), 2020","https://www.thenewsminute.com/telangana/telangana-govt-spent-around-rs-300-cr-advertisement-and-publicity-4-years-137759"]] },
  { id: "wel:tekchand-sawarkar", label: "Tekchand Sawarkar", sub: "BJP MLA, Kamthi (Nagpur)", ty: "person", fam: "state", st: "mh", sz: 2, resolved: true, d: ["Sep 2024 remark that Ladki Bahin was a 'jugaad' to get women's votes [reported]"], srcs: [["Deccan Herald/PTI, 25 Sep 2024: BJP MLA Tekchand Sawarkar calls Ladki Bahin a 'jugaad' for women's votes","https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ladki-bahin-a-jugaad-to-get-womens-votes-says-bjp-mla-tekchand-sawarkar-3206053"]] },
  { id: "wel:telangana-ipr", label: "Information and Public Relations Department, Telangana", sub: "State advertising arm", ty: "agency", fam: "state", st: "tg", sz: 2, resolved: true, d: ["~₹300 crore on publicity Jun 2014–Oct 2018 per RTI: ~₹177 crore outdoor, ~₹120 crore TV [reported]"], srcs: [["The News Minute, 'Telangana govt spent around Rs 300 cr on advertisement and publicity in 4 years' (RTI), 2020","https://www.thenewsminute.com/telangana/telangana-govt-spent-around-rs-300-cr-advertisement-and-publicity-4-years-137759"]] },
  { id: "wel:tml-cv-mobility-solutions", label: "TML CV Mobility Solutions Ltd", sub: "Wholly owned Tata Motors subsidiary operating e-bus GCC contracts", ty: "company", fam: "capital", st: "mh", sz: 2, resolved: true, d: ["Signatory to the DTC 1,500-bus agreement, 23 Dec 2022 [documented]"], srcs: [["Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022","https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"]] },
  { id: "wel:tn-state-transport-undertakings", label: "Tamil Nadu state transport undertakings (MTC, TNSTC, SETC)", sub: "State bus corporations reimbursed for free women's travel", ty: "psu", fam: "state", st: "tn", sz: 3, resolved: true, d: ["Rs 1,520 cr fare-loss subsidy 2022-23 [documented]"], srcs: [["Deccan Herald, 18 Mar 2022: Free travel — more women in Tamil Nadu now take government buses (budget 2022-23)","https://www.deccanherald.com/india/free-travel-more-women-in-tamil-nadu-now-take-government-buses-1092556.html"]] },
  { id: "wel:tummala-nageswara-rao", label: "Tummala Nageswara Rao", sub: "Agriculture Minister", ty: "person", fam: "state", st: "tg", sz: 3, resolved: true, d: ["Spoke in the Assembly short discussion on Rythu Bandhu, 21 Dec 2024 [reported]"], srcs: [["Deccan Herald/PTI, 21 Dec 2024: Rythu Bandhu Rs 22,600 cr given to ineligible people in BRS regime, says Telangana CM","https://www.deccanherald.com/india/telangana/rythu-bandhu-rs-22600-crore-given-to-ineligible-people-in-brs-regime-says-telangana-cm-3328152"]] },
  { id: "wel:uddhav-thackeray", label: "Uddhav Thackeray", sub: "Chief Minister", ty: "person", fam: "state", st: "mh", sz: 3, resolved: true, d: ["GR of 27 Dec 2019; Rs 20,497 cr to 32.37 lakh farmers [documented]"], srcs: [["Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"]] },
  { id: "wel:uidai", label: "UIDAI", sub: "Aadhaar authority", ty: "agency", fam: "state", st: "dl", sz: 2, al: ["Unique Identification Authority of India"], resolved: true, d: ["Aadhaar seeding mandatory for PM-KISAN, PMUY de-duplication, NSAP; chaired by Nilekani 2009-14 [documented]","Suspended Airtel/Airtel Payments Bank eKYC licence (16 Dec 2017) and imposed ₹2.5 crore interim penalty (18 Dec 2017) over force-seeded accounts receiving ₹190 crore of LPG subsidy [reported]"], srcs: [["Wikipedia (pointer), Nandan Nilekani","https://en.wikipedia.org/wiki/Nandan_Nilekani"],["PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"],["CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)","https://cag.gov.in/"],["The Wire, 'Aadhaar Mess: How Airtel Pulled Off Its Rs 190 Crore Magic Trick', 21 Dec 2017","https://m.thewire.in/article/banking/airtel-aadhaar-uidai"]] },
  { id: "wel:varla-ramaiah", label: "Varla Ramaiah", sub: "Politburo member, Telugu Desam Party", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["Complained to the EC that YSRCP candidates used volunteers for door-to-door electioneering (2024) [reported]"], srcs: [["ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024","https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"]] },
  { id: "wel:vasundhara-raje", label: "Vasundhara Raje", sub: "Chief Minister", ty: "person", fam: "state", st: "rj", sz: 1, resolved: true, d: ["Rs 50,000 waiver, Rs 8,500 cr via Rs 5,000 cr NCDC loan; claimed 30 lakh beneficiaries [reported]"], srcs: [["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"]] },
  { id: "wel:vd-satheesan", label: "V. D. Satheesan", sub: "Chief Minister", ty: "person", fam: "state", st: "kl", sz: 3, resolved: true, d: ["UDF 102 of 140, Apr–May 2026 [documented]"], srcs: [["DD News, 4 May 2026: UDF crosses majority mark in Kerala (ECI trends)","https://ddnews.gov.in/en/assembly-polls-2026-udf-crosses-majority-mark-in-kerala/"],["Wikipedia infobox (pointer to ECI): 2026 Kerala Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Kerala_Legislative_Assembly_election"]] },
  { id: "wel:vijay-inder-singla", label: "Vijay Inder Singla", sub: "School Education Minister of Punjab, 2018-04→2022-03", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["Distributed Smart Connect phones at Sangrur on launch day [documented]"], srcs: [["The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020","https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"]] },
  { id: "wel:vijay-wadettiwar", label: "Vijay Wadettiwar", sub: "MLA Brahmapuri, Maharashtra; Leader of the Opposition, Maharashtra Legislative Assembly, 2023-08→2024-11", ty: "person", fam: "state", st: null, sz: 2, resolved: true, d: ["On 2026-08-19 claimed 92.10 lakh women had been removed from Ladki Bahin and that the government ‘used women only for electoral gains’ [alleged]"], srcs: [["ThePrint, 2026-08-19 — 92.10 lakh women removed from Maharashtra govt’s Ladki Bahin scheme, claims Congress leader (Vijay Wadettiwar)","https://theprint.in/india/92-10-lakh-women-removed-from-maharashtra-govts-ladki-bahin-scheme-claims-congress-leader/3019624/"]] },
  { id: "wel:vishnu-deo-sai", label: "Vishnu Deo Sai", sub: "Chief Minister", ty: "person", fam: "state", st: "ct", sz: 1, resolved: true, d: ["Mahtari Vandan Rs 3,000 cr in 2024-25 BE [documented]","Present at 10 Mar 2024 launch; scheme Rs 1,000/month to ~70 lakh married women [documented]"], srcs: [["PRS, Chhattisgarh Budget Analysis 2024-25","https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2024-25"],["PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr","https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"]] },
  { id: "wel:yogi-adityanath", label: "Yogi Adityanath", sub: "Chief Minister", ty: "person", fam: "state", st: "up", sz: 3, resolved: true, d: ["First cabinet waived Rs 36,000 cr crop loans, 4 Apr 2017 [reported]","Kanya Sumangala Rs 1,200 cr in 2019-20 budget [documented]","Ordered a probe in 2017 into the gap between laptops purchased and distributed under the SP scheme [reported]"], srcs: [["Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'","https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"],["PRS, Uttar Pradesh Budget Analysis 2019-20","https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2019-20"],["Wikipedia (pointer): 2017 Uttar Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2017_Uttar_Pradesh_Legislative_Assembly_election"],["Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'","https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"]] },
  { id: "wel:ys-jagan-mohan-reddy", label: "Y. S. Jagan Mohan Reddy", sub: "Chief Minister", ty: "person", fam: "state", st: "ap", sz: 2, resolved: true, d: ["\"I have given lots of schemes in the last five years\", Apr 2024 [reported]","YSRCP fell from 151 to 11 seats, May 2024 [documented]","Created the 2.56 lakh village/ward volunteer system (₹5,000/month) that delivered pensions and scheme benefits door to door; EC restricted volunteers' role during the 2024 MCC [reported]"], srcs: [["ClearTax — YSR Rythu Bharosa","https://cleartax.in/s/ysr-rythu-bharosa-scheme"],["The Print, 18 Apr 2024: As Jagan banks on direct benefit schemes in AP, voters split","https://theprint.in/politics/as-jagan-banks-on-direct-benefit-schemes-in-ap-voters-split-anxiety-over-jobs-cost-of-living/2046063/"],["Wikipedia infobox (pointer to ECI): 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"],["ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024","https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"]] },
];

/** One node per scheme, so claims that point at a scheme have somewhere to land. */
export const WELFARE_SCHEME_NODES: GNode[] = [
  { id: "scheme:ap-smartcards-nregs-ssp", label: "Andhra Pradesh biometric Smartcard payments for NREGS and social security pensions", sub: "other · AP state scheme · INC (AP government 2004–14)", ty: "mechanism", fam: "instrument", st: "ap", sz: 2, al: ["AP Smartcards"], resolved: true, srcs: [["Muralidharan, Niehaus & Sukhtankar (2016) Building State Capacity: Evidence from Biometric Smartcards in India — AER 106(10):2895–2929 (Crossref metadata)","https://api.crossref.org/works/10.1257/aer.20141346"]] },
  { id: "scheme:ap-talliki-vandanam", label: "Talliki Vandanam", sub: "women-cash · AP state scheme · TDP", ty: "mechanism", fam: "instrument", st: "ap", sz: 2, al: ["Thalliki Vandanam","తల్లికి వందనం"], resolved: true, srcs: [["Deccan Herald/PTI, 13 Jun 2025: AP launches Talliki Vandanam Rs 15,000 per child","https://www.deccanherald.com/india/andhra-pradesh/andhra-govt-launches-talliki-vandanam-scheme-rs-15000-to-be-given-for-school-going-child-3584484"],["Wikipedia infobox (pointer to ECI results): 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"]] },
  { id: "scheme:ap-village-volunteers", label: "Andhra Pradesh village/ward volunteer system (delivery layer for YSR pensions and schemes)", sub: "other · AP state scheme · YSRCP", ty: "mechanism", fam: "instrument", st: "ap", sz: 2, al: ["Grama Volunteers","Ward Volunteers"], resolved: true, srcs: [["ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024","https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"],["Wikipedia (pointer), 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"]] },
  { id: "scheme:ap-ysr-amma-vodi", label: "YSR Amma Vodi", sub: "student · AP state scheme · YSRCP", ty: "mechanism", fam: "instrument", st: "ap", sz: 2, al: ["Amma Vodi","అమ్మ ఒడి"], resolved: true, srcs: [["PRS, Andhra Pradesh Budget Analysis 2020-21","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2020-21"],["The Print, 18 Apr 2024: As Jagan banks on direct benefit schemes in AP, voters split","https://theprint.in/politics/as-jagan-banks-on-direct-benefit-schemes-in-ap-voters-split-anxiety-over-jobs-cost-of-living/2046063/"],["Wikipedia infobox (pointer to ECI): 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"]] },
  { id: "scheme:ap-ysr-pension-kanuka", label: "YSR Pension Kanuka", sub: "pension · AP state scheme · YSRCP", ty: "mechanism", fam: "instrument", st: "ap", sz: 2, al: ["Pension Kanuka","NTR Bharosa (2024 rename)"], resolved: true, srcs: [["PRS, Andhra Pradesh Budget Analysis 2020-21","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2020-21"],["PRS, Andhra Pradesh Budget Analysis 2023-24","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2023-24"],["PRS, Andhra Pradesh Budget Analysis 2024-25","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2024-25"],["Wikipedia infobox (pointer to ECI): 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"]] },
  { id: "scheme:ap-ysr-rythu-bharosa", label: "YSR Rythu Bharosa", sub: "farmer-cash · AP state scheme · YSRCP", ty: "mechanism", fam: "instrument", st: "ap", sz: 2, al: ["Rythu Bharosa (AP)"], resolved: true, srcs: [["ClearTax — YSR Rythu Bharosa","https://cleartax.in/s/ysr-rythu-bharosa-scheme"],["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PRS, Andhra Pradesh Budget Analysis 2023-24","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2023-24"],["PRS, Andhra Pradesh Budget Analysis 2024-25","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2024-25"],["The Print, 18 Apr 2024: As Jagan banks on direct benefit schemes in AP, voters split","https://theprint.in/politics/as-jagan-banks-on-direct-benefit-schemes-in-ap-voters-split-anxiety-over-jobs-cost-of-living/2046063/"],["Wikipedia infobox (pointer to ECI): 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"],["Govt Schemes India — YSR Rythu Bharosa: launched 15 Oct 2019; ₹13,500/yr per farmer family (₹7,500 state + ₹6,000 PM-KISAN)","https://www.govtschemes.in/ysr-rythu-bharosa-scheme"],["YSR Congress Party — YSR Rythu Bharosa: all you need to know (party source; launch 15 Oct at Kakaturu, Nellore; ₹13,500 incl. ₹6,000 PM-KISAN)","https://www.ysrcongress.com/special-news/ysr-rythu-bharosa-all-you-need-69738"]] },
  { id: "scheme:as-orunodoi", label: "Orunodoi", sub: "women-cash · AS state scheme · BJP", ty: "mechanism", fam: "instrument", st: "as", sz: 2, al: ["Arunodoi","অৰুণোদয়"], resolved: true, srcs: [["Organiser — Orunodoi scheme launched in Assam","https://organiser.org/2020/12/02/132039/bharat/orunodoi-scheme-launched-in-assam-to-empower-women/"],["Deccan Herald — BJP-led Assam govt launches Orunodoi ahead of polls","https://www.deccanherald.com/amp/story/india%2Fbjp-led-assam-govt-launches-cash-transfer-scheme-orunodoi-ahead-of-assembly-elections-922119.html"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month","https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["India TV, 4 May 2026: Assam 2026 result — BJP 82 seats","https://www.indiatvnews.com/north-east/assam/assam-election-result-2026-live-updates-himanta-biswa-sarma-led-bjp-wins-setback-for-congress-1039454"],["The Logical Indian, 4 May 2026: fiscal reality behind 2026 cash promises to women","https://thelogicalindian.com/elections-results-2026-the-fiscal-reality-behind-indias-cash-promises-to-women/"]] },
  { id: "scheme:br-balika-cycle", label: "Mukhyamantri Balika Cycle Yojana (Bihar)", sub: "student · BR state scheme · JD(U)–BJP (Nitish Kumar government)", ty: "mechanism", fam: "instrument", st: "br", sz: 2, al: ["Bihar cycle scheme","Balika Cycle Yojana","Cycle Yojana","मुख्यमंत्री बालिका साइकिल योजना"], resolved: true, srcs: [["Muralidharan & Prakash, 'Cycling to School: Increasing Secondary School Enrollment for Girls in India', AEJ: Applied Economics 9(3), Jul 2017 — abstract","https://www.aeaweb.org/articles?id=10.1257/app.20160004"],["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"],["Muralidharan & Prakash (2017) Cycling to School: Increasing Secondary School Enrollment for Girls in India — AEJ: Applied 9(3):321–350 (Crossref metadata)","https://api.crossref.org/works/10.1257/app.20160004"],["Nitish Kumar's blog, Apr 2010: Mukhyamantri Balika Cycle Yojna","http://nitishspeaks.blogspot.com/2010/04/mukhyamantri-balika-cycle-yojna.html"],["Muralidharan & Prakash (2017), 'Cycling to School', AEJ: Applied Economics 9(3) — AEA abstract page","https://www.aeaweb.org/articles?id=10.1257/app.20160004"],["PRS, Bihar Budget Analysis 2019-20","https://prsindia.org/budgets/states/bihar-budget-analysis-2019-20"],["Wikipedia infobox (pointer to ECI): 2010 Bihar Legislative Assembly election","https://en.wikipedia.org/wiki/2010_Bihar_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): October 2005 Bihar Legislative Assembly election","https://en.wikipedia.org/wiki/October_2005_Bihar_Legislative_Assembly_election"]] },
  { id: "scheme:br-mahila-rozgar-yojana", label: "Mukhyamantri Mahila Rozgar Yojana", sub: "women-cash · BR state scheme · JD(U)", ty: "mechanism", fam: "instrument", st: "br", sz: 2, al: ["MMRY","Mahila Rozgar Yojana"], resolved: true, srcs: [["Deccan Herald — Bihar Rs 10,000 cash transfer to women","https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-rs-10000-cash-transfer-to-women-may-prove-game-changer-for-nitish-kumar-3773893"],["The Federal — Bihar pre-poll cash push sparks concerns over ECI neutrality","https://thefederal.com/category/elections-2025/pre-poll-cash-transfers-in-bihar-raise-concerns-over-voter-influence-eci-neutrality-214703"],["PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"],["PIB/ECI, 6 Oct 2025: General Election to the Legislative Assembly of Bihar, 2025 (schedule release)","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2175533"],["Deccan Herald, 15 Nov 2025: Bihar results — NDA 202 seats","https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-results-nda-cruises-to-victory-by-winning-202-seats-and-a-vote-share-of-over-40-3798063"]] },
  { id: "scheme:ct-cheap-rice-2007", label: "Chhattisgarh ₹1–2/kg rice (Mukhyamantri Khadyann Sahayata; Chhattisgarh Food Security Act 2012)", sub: "grain · CT state scheme · BJP", ty: "mechanism", fam: "instrument", st: "ct", sz: 2, al: ["Chaur wale baba scheme","Re 1 rice","Rs 2 rice"], resolved: true, srcs: [["Business Standard, 13 Nov 2013: Politics over rice in Chhattisgarh","https://www.business-standard.com/article/politics/politics-over-rice-in-chhattisgarh-113111300355_1.html"],["Wikipedia infobox (pointer to ECI): 2008 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2008_Chhattisgarh_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2013 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2013_Chhattisgarh_Legislative_Assembly_election"],["PRS, Chhattisgarh Budget Analysis 2019-20","https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2019-20"],["Wikipedia infobox (pointer to ECI results): 2018 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Chhattisgarh_Legislative_Assembly_election"]] },
  { id: "scheme:ct-farm-loan-waiver-2018", label: "Chhattisgarh farm loan waiver (2018)", sub: "loan-waiver · CT state scheme · INC", ty: "mechanism", fam: "instrument", st: "ct", sz: 2, resolved: true, srcs: [["National Herald — Chhattisgarh Rs 6,100-cr loan waiver","https://www.nationalheraldindia.com/national/chhattisgarh-cm-bhupesh-baghel-announces-indian-rupee6100-cr-farm-loan-waiver"],["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"],["PRS, Chhattisgarh Budget Analysis 2019-20","https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2019-20"],["National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21","https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"],["Wikipedia infobox (pointer to ECI): 2023 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2018 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Chhattisgarh_Legislative_Assembly_election"]] },
  { id: "scheme:ct-mahtari-vandan", label: "Mahtari Vandan Yojana", sub: "women-cash · CT state scheme · BJP", ty: "mechanism", fam: "instrument", st: "ct", sz: 2, al: ["Mahatari Vandana","महतारी वंदन"], resolved: true, srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr","https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "scheme:ct-rajiv-gandhi-kisan-nyay", label: "Rajiv Gandhi Kisan Nyay Yojana", sub: "farmer-cash · CT state scheme · INC", ty: "mechanism", fam: "instrument", st: "ct", sz: 2, al: ["RGKNY","Kisan Nyay"], resolved: true, srcs: [["National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21","https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"],["Wikipedia (pointer): Rajiv Gandhi Kisan Nyay Yojana","https://en.wikipedia.org/wiki/Rajiv_Gandhi_Kisan_Nyay_Yojana"],["PRS, Chhattisgarh Budget Analysis 2020-21","https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2020-21"],["Wikipedia infobox (pointer to ECI): 2023 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"]] },
  { id: "scheme:dbt-apb-pfms", label: "Direct Benefit Transfer (Aadhaar Payment Bridge / PFMS rails)", sub: "other · central scheme · INC (2013 launch) → BJP (scaled 2014→)", ty: "mechanism", fam: "instrument", st: null, sz: 3, al: ["DBT","JAM trinity","APBS"], resolved: true, srcs: [["PIB backgrounder, Direct Benefit Transfer (DBT), Jan 2022","https://static.pib.gov.in/WriteReadData/specificdocs/documents/2022/jan/doc2022153101.pdf"],["PIB (Ministry of Finance), 'India's DBT: Boosting Welfare Efficiency' — BlueKraft assessment, 21 Apr 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2123192"],["PIB, PMJDY completes 11 years — ₹6.9 lakh crore DBT in FY2024-25, 28 Aug 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2161401"],["Fino Payments Bank, Annual Report 2024-25","https://www.fino.bank.in/files/fino/media/post_attachments/sites/default/files/uploads/pages/financials/annual-report-2025.pdf"],["Moneylife, 'Is CSC e-Governance Services a govt entity or SPV or a Section 8 company?', 29 Jun 2018","https://www.moneylife.in/article/is-csc-egovernance-services-a-govt-entity-or-spv-or-a-section-8-company/54524.html"],["Free Press Journal, IPPB disbursed over ₹45,000 crore in DBT in 7 years (Scindia), 1 Sep 2024","https://www.freepressjournal.in/business/india-post-payments-bank-disbursed-over-45000-crore-in-dbt-in-last-7-years"],["The Wire, 'Aadhaar Mess: How Airtel Pulled Off Its Rs 190 Crore Magic Trick', 21 Dec 2017","https://m.thewire.in/article/banking/airtel-aadhaar-uidai"]] },
  { id: "scheme:dl-dtc-ebus-induction", label: "Delhi electric-bus induction for DTC/cluster network (carrier of the free 'pink ticket' for women)", sub: "transport · DL state scheme · AAP", ty: "mechanism", fam: "instrument", st: "dl", sz: 2, al: ["DTC e-buses","Delhi e-bus GCC"], resolved: true, srcs: [["Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022","https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"],["EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023","https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"],["Wikipedia (pointer), 2025 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"]] },
  { id: "scheme:dl-free-power-200-units", label: "Delhi free electricity up to 200 units", sub: "energy-subsidy · DL state scheme · AAP", ty: "mechanism", fam: "instrument", st: "dl", sz: 2, al: ["zero power bill","200 units free"], resolved: true, srcs: [["Business Today, 1 Aug 2019: Kejriwal announces free electricity up to 200 units","https://www.businesstoday.in/latest/economy-politics/story/arvind-kejriwal-free-electricity-up-to-200-units-delhi-from-august-220915-2019-08-01"],["PRS, Delhi Budget Analysis 2019-20","https://prsindia.org/budgets/states/delhi-budget-analysis-2019-20"],["PRS, Delhi Budget Analysis 2020-21","https://prsindia.org/budgets/states/delhi-budget-analysis-2020-21"],["PRS, Delhi Budget Analysis 2023-24","https://prsindia.org/budgets/states/delhi-budget-analysis-2023-24"],["Deccan Herald, 7 Mar 2024: Delhi cabinet approves power subsidy scheme for FY 2024-25; 22 lakh zero bills","https://www.deccanherald.com/india/delhi/delhi-cabinet-approves-power-subsidy-scheme-for-fy-2024-25-2926614"],["Business Standard/ANI, 15 Apr 2025: Power subsidy for Delhi homes, farmers, lawyers, riot victims to continue (BJP govt)","https://www.business-standard.com/india-news/power-subsidy-for-delhi-homes-farmers-lawyers-riot-victims-to-continue-125041501496_1.html"],["Wikipedia infobox (pointer to ECI): 2020 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2020_Delhi_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2025 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"]] },
  { id: "scheme:dl-mahila-samman-promise-2025", label: "Mukhya Mantri Mahila Samman Yojana (Delhi, AAP promise)", sub: "women-cash · DL state scheme · AAP", ty: "mechanism", fam: "instrument", st: "dl", sz: 2, al: ["Mahila Samman Yojana"], resolved: true, srcs: [["Wikipedia — 2025 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"],["Deccan Herald, 12 Dec 2024: Kejriwal announces Rs 1,000 (Rs 2,100 after polls) for Delhi women","https://www.deccanherald.com/elections/delhi/delhi-assembly-elections-2025-ahead-of-polls-cabinet-approves-proposal-of-giving-rs-1000-to-women-every-months-3314631"],["ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs","https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"],["Wikipedia infobox (pointer to ECI results): 2025 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"]] },
  { id: "scheme:dl-mahila-samriddhi", label: "Mahila Samriddhi Yojana (Delhi)", sub: "women-cash · DL state scheme · BJP", ty: "mechanism", fam: "instrument", st: "dl", sz: 2, al: ["Delhi Lakshmi Yojana (reported rename, Jul 2026 — unverified)","Mahila Samridhi Yojana","Mukhyamantri Mahila Samridhi Yojana"], resolved: true, srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr","https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"],["India TV, 8 Jul 2026: Delhi to launch Mahila Samriddhi on Raksha Bandhan; Rs 5,110 cr 2026-27","https://www.indiatvnews.com/delhi/delhi-govt-to-launch-mahila-samriddhi-yojana-on-raksha-bandhan-check-who-can-get-rs-2500-monthly-and-required-documents-2026-07-08-1047512"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "scheme:gj-namo-laxmi-2024", label: "Namo Laxmi Yojana (Gujarat girls' secondary scholarship) — with Gujarat's agricultural power subsidy as context", sub: "student · GJ state scheme · BJP", ty: "mechanism", fam: "instrument", st: "gj", sz: 2, al: ["Namo Lakshmi"], resolved: true, srcs: [["PRS, Gujarat Budget Analysis 2024-25","https://prsindia.org/budgets/states/gujarat-budget-analysis-2024-25"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.13-14 and subsidy section (PDF)","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Wikipedia infobox (pointer to ECI results): 2024 Indian general election","https://en.wikipedia.org/wiki/2024_Indian_general_election"]] },
  { id: "scheme:hp-indira-gandhi-pyari-behna", label: "Indira Gandhi Pyari Behna Sukh Samman Nidhi Yojana", sub: "women-cash · HP state scheme · INC", ty: "mechanism", fam: "instrument", st: "hp", sz: 2, al: ["Pyari Behna","IGPBSSNY"], resolved: true, srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals","https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "scheme:hp-ops-restoration", label: "Old Pension Scheme restoration", sub: "pension · HP state scheme · INC", ty: "mechanism", fam: "instrument", st: "hp", sz: 2, al: ["OPS"], resolved: true, srcs: [["Onmanorama — Himachal restores Old Pension Scheme","https://www.onmanorama.com/news/india/2023/01/14/congress-himachal-pradesh-old-pension-scheme.html"]] },
  { id: "scheme:hr-lado-lakshmi", label: "Lado Laxmi Yojana", sub: "women-cash · HR state scheme · BJP", ty: "mechanism", fam: "instrument", st: "hr", sz: 2, al: ["Lado Lakshmi","Lado Laxmi"], resolved: true, srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification","https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"],["Deccan Herald/PTI, 28 Aug 2025: Haryana cabinet decides to roll out Lado Lakshmi from Sep 25","https://www.deccanherald.com/india/haryana/haryana-decides-to-implement-lado-lakshmi-yojana-eligible-women-to-get-rs-2100-monthly-aid-3700884"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "scheme:in-lakhpati-didi", label: "Lakhpati Didi (DAY-NRLM target)", sub: "other · central scheme · BJP (NDA)", ty: "mechanism", fam: "instrument", st: null, sz: 3, al: ["Lakhpati Didi","लखपति दीदी"], resolved: true, srcs: [["PIB, Interim Budget 2024-25: Lakhpati Didi target 2 cr → 3 cr, 1 Feb 2024","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2001109"],["Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)","https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"],["Union Budget 2026-27 speech, Nirmala Sitharaman, 1 Feb 2026","https://www.indiabudget.gov.in/doc/Budget_Speech.pdf"]] },
  { id: "scheme:in-mssc", label: "Mahila Samman Savings Certificate, 2023", sub: "other · central scheme · BJP (NDA)", ty: "mechanism", fam: "instrument", st: null, sz: 3, al: ["MSSC","Mahila Samman Bachat Patra"], resolved: true, srcs: [["Union Budget 2023-24 speech, Nirmala Sitharaman, 1 Feb 2023","https://www.indiabudget.gov.in/budget2023-24/doc/Budget_Speech.pdf"],["Akashvani News, over 14.83 lakh MSSC accounts opened, MoS Finance in LS, 31 Jul 2023","https://www.newsonair.gov.in/over-14-83-lakh-accounts-opened-under-mahila-samman-savings-certificate-scheme-govt-in-ls"]] },
  { id: "scheme:in-namo-drone-didi", label: "Namo Drone Didi", sub: "other · central scheme · BJP (NDA)", ty: "mechanism", fam: "instrument", st: null, sz: 3, al: ["Drone Didi","drones to women SHGs"], resolved: true, srcs: [["PIB, Cabinet approves Central Sector Scheme for providing drones to women SHGs (₹1,261 crore), 29 Nov 2023","https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=1980683"],["PIB (MoA&FW reply), Implementation of Namo Drone Didi scheme, 29 Jul 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2149706"]] },
  { id: "scheme:in-nfsa", label: "National Food Security Act, 2013", sub: "grain · central scheme · INC (UPA)", ty: "mechanism", fam: "instrument", st: null, sz: 3, al: ["NFSA","Food Security Act","Right to Food Act","PDS","TPDS","NFSA PDS"], resolved: true, srcs: [["Wikipedia (pointer), National Food Security Act 2013","https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"],["PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"],["Muralidharan, Niehaus & Sukhtankar, 'Identity Verification Standards in Welfare Programs: Experimental Evidence from India', NBER WP 26744 (Feb 2020, revised) — abstract","https://www.nber.org/papers/w26744"],["Khera (2017) Impact of Aadhaar on Welfare Programmes — EPW 52(50), 16 Dec 2017 (EPW page opened)","https://www.epw.in/journal/2017/50/special-articles/impact-aadhaar-welfare-programmes.html"],["Drèze, Khalid, Khera & Somanchi (2017) Aadhaar and Food Security in Jharkhand: Pain without Gain? — EPW 52(50), 16 Dec 2017 (EPW page opened; full text not extracted)","https://www.epw.in/journal/2017/50/special-articles/aadhaar-and-food-security-jharkhand.html"],["Deshpande, Tillin & Kailash (2019) The BJP’s Welfare Schemes: Did They Make a Difference in the 2019 Elections? — Studies in Indian Politics 7(2):219–233 (Crossref metadata + abstract)","https://api.crossref.org/works/10.1177/2321023019874911"]] },
  { id: "scheme:in-nsap", label: "National Social Assistance Programme (IGNOAPS, IGNWPS, IGNDPS, NFBS, Annapurna)", sub: "pension · central scheme · INC (introduced 1995); administered by all governments since", ty: "mechanism", fam: "instrument", st: null, sz: 3, al: ["NSAP","Indira Gandhi National Old Age Pension Scheme","IGNOAPS"], resolved: true, srcs: [["PIB Backgrounder, National Social Assistance Programme, 7 Nov 2025","https://www.pib.gov.in/PressNoteDetails.aspx?NoteId=155928&ModuleId=3"],["PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"]] },
  { id: "scheme:in-pm-vishwakarma", label: "PM Vishwakarma", sub: "other · central scheme · BJP (NDA)", ty: "mechanism", fam: "instrument", st: null, sz: 3, al: ["PM Vishwakarma Kaushal Samman","PM VIKAS","विश्वकर्मा योजना"], resolved: true, srcs: [["Union Budget 2023-24 speech, Nirmala Sitharaman, 1 Feb 2023","https://www.indiabudget.gov.in/budget2023-24/doc/Budget_Speech.pdf"],["PIB (MSME RS reply), PM Vishwakarma outlay ₹13,000 crore and year-wise allocation, 21 Dec 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1989108"],["PIB Research Unit backgrounder 'PM Vishwakarma Scheme: Honouring Heritage, Powering Progress', 16 Sep 2025 (PDF on file; exact document URL not recovered — see gaps)","https://www.pib.gov.in/"],["Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)","https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"]] },
  { id: "scheme:in-pmay-g", label: "Pradhan Mantri Awaas Yojana – Gramin", sub: "housing · central scheme · BJP (NDA)", ty: "mechanism", fam: "instrument", st: null, sz: 3, al: ["PMAY-G","PM Awas","Indira Awaas Yojana (predecessor)"], resolved: true, srcs: [["PIB (MoRD), PMAY-G progress and Cabinet approval of 2 crore more houses, 7 Feb 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2100659"],["Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)","https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"],["Wikipedia (pointer), Pradhan Mantri Awas Yojana","https://en.wikipedia.org/wiki/Pradhan_Mantri_Awas_Yojana"]] },
  { id: "scheme:jh-maiya-samman", label: "Mukhyamantri Maiya Samman Yojana", sub: "women-cash · JH state scheme · JMM", ty: "mechanism", fam: "instrument", st: "jh", sz: 2, al: ["MMMSY","Maiya Samman","Maiyan Samman","JMMSY"], resolved: true, srcs: [["IMPRI — Maiya Samman Yojana policy update","https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"],["IMPRI policy update: Mukhyamantri Maiya Samman Yojana in practice","https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"],["Deccan Herald/PTI, 14 Oct 2024: Jharkhand cabinet raises Maiya Samman to Rs 2,500 from Dec 2024","https://www.deccanherald.com/india/jharkhand/jharkhand-cabinet-nod-to-hike-financial-assistance-for-women-to-rs-30000-per-year-from-rs-12000-3231863"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "scheme:ka-anna-bhagya-2023", label: "Anna Bhagya (2023 guarantee: 10 kg rice, paid as ₹170 cash in lieu of 5 kg)", sub: "grain · KA state scheme · INC", ty: "mechanism", fam: "instrument", st: "ka", sz: 2, al: ["Annabhagya","ಅನ್ನ ಭಾಗ್ಯ"], resolved: true, srcs: [["The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya","https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"],["Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024","https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"],["PRS, Karnataka Budget Analysis 2023-24","https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"],["Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting","https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"],["The Tribune/IANS, 5 Jul 2018: Karnataka waives Rs 34,000 cr farm loans","https://www.tribuneindia.com/news/archive/nation/karnataka-waives-rs-34-000-cr-farm-loans-615599"],["Wikipedia infobox (pointer to ECI): 2023 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"]] },
  { id: "scheme:ka-farm-loan-waiver-2018", label: "Karnataka farm loan waiver 2018 (Kumaraswamy, ₹34,000 cr)", sub: "loan-waiver · KA state scheme · JD(S)-INC coalition", ty: "mechanism", fam: "instrument", st: "ka", sz: 2, resolved: true, srcs: [["Deccan Herald, 30 May 2018: Kumaraswamy announces two-phase farmer loan waiver","https://www.deccanherald.com/india/karnataka/kumaraswamy-announces-two-phase-farmer-loan-waiver-672438.html"],["The Tribune/IANS, 5 Jul 2018: Karnataka waives Rs 34,000 cr farm loans","https://www.tribuneindia.com/news/archive/nation/karnataka-waives-rs-34-000-cr-farm-loans-615599"],["PRS, Karnataka Budget Analysis 2018-19","https://prsindia.org/budgets/states/karnataka-budget-analysis-2018-19"],["Deccan Herald, 7 Jan 2024: Karnataka farmers in quicksand as govt continues to borrow time over loan waiver","https://www.deccanherald.com/india/karnataka/karnataka-farmers-in-quicksand-as-govt-continues-to-borrow-time-over-loan-waiver-2838441"],["Wikipedia infobox (pointer to ECI): 2023 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2018 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Karnataka_Legislative_Assembly_election"]] },
  { id: "scheme:ka-five-guarantees-2023", label: "Karnataka five guarantees (Gruha Jyothi, Gruha Lakshmi, Anna Bhagya, Shakti, Yuva Nidhi)", sub: "other · KA state scheme · INC", ty: "mechanism", fam: "instrument", st: "ka", sz: 2, al: ["Panch guarantees","ಗ್ಯಾರಂಟಿ ಯೋಜನೆಗಳು"], resolved: true, srcs: [["Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting","https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"],["PRS, Karnataka Budget Analysis 2023-24","https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"],["The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget","https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"],["Deccan Herald, 26 Mar 2026: Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG","https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"],["Deccan Herald, 26 Aug 2025: CAG report's conclusions on welfare schemes in Karnataka incorrect: H M Revanna","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"],["The Federal, 12 Jun 2023: Free bus travel for women — Karnataka model vs TN, Delhi, Punjab","https://thefederal.com/states/south/karnataka/karnataka-introduces-free-bus-travel-for-women-a-comparison-with-other-states"],["The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya","https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.13-14 and subsidy section (PDF)","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Wikipedia infobox (pointer to ECI): 2023 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"]] },
  { id: "scheme:ka-gruha-lakshmi", label: "Gruha Lakshmi Scheme", sub: "women-cash · KA state scheme · INC", ty: "mechanism", fam: "instrument", st: "ka", sz: 2, al: ["Gruhalakshmi","Gruha Lakshmi Yojana","ಗೃಹಲಕ್ಷ್ಮಿ"], resolved: true, srcs: [["Congress — Gruha Lakshmi launch","https://inc.in/congress-sandesh/others/in-karnataka-gruha-lakshmi-scheme-launched-1-1-crore-women-heads-of-households-to-get-2000-monthly-aid"],["Tribune — Gruha Lakshmi launch today","https://www.tribuneindia.com/news/india/karnataka-govt-to-launch-gruha-lakshmi-scheme-today-to-benifit-1-1-crore-women-539715"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Deccan Herald, 26 Mar 2026: 'Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG' (CAG State Finances Audit Report 2024-25, tabled 26 Mar 2026)","https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"],["Deccan Herald, 26 Aug 2025: ''CAG report's conclusions on welfare schemes in Karnataka incorrect': H M Revanna'","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"],["Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed","https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"],["Deccan Herald, 26 Aug 2025: H M Revanna rejects CAG conclusions on Karnataka guarantee schemes","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "scheme:ka-shakti", label: "Shakti (free bus travel for women, Karnataka)", sub: "transport · KA state scheme · INC", ty: "mechanism", fam: "instrument", st: "ka", sz: 2, al: ["Shakti scheme","ಶಕ್ತಿ"], resolved: true, srcs: [["Deccan Herald, 'Rs 1,800 cr Shakti scheme reimbursement pending; transport corporations in red', Dec 2024","https://www.deccanherald.com/india/karnataka/rs1-800-cr-shakti-scheme-reimbursement-pending-transport-corpns-in-red-3320295"],["ETV Bharat, 'Shakti scheme effect: male passengers drop; ₹5,172 crore reimbursement pending', 20 Jun 2026","https://www.etvbharat.com/en/bharat/shakti-scheme-effect-number-of-male-passengers-travelling-in-karnataka-govt-run-buses-drops-significantly-in-karnataka-enn26062003798"],["Deccan Herald, 'BMTC launches 100 new diesel buses, to get 820 of them by March', 12 Sep 2024","https://www.deccanherald.com/india/karnataka/bengaluru/bmtc-launches-100-new-diesel-buses-to-get-820-of-them-by-march-3188420"],["Wikipedia (pointer), 'Bengaluru Metropolitan Transport Corporation'","https://en.wikipedia.org/wiki/Bangalore_Metropolitan_Transport_Corporation"],["Wikipedia (pointer), 2023 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"]] },
  { id: "scheme:ka-yuva-nidhi", label: "Yuva Nidhi (unemployment allowance)", sub: "unemployment · KA state scheme · INC", ty: "mechanism", fam: "instrument", st: "ka", sz: 2, al: ["ಯುವ ನಿಧಿ"], resolved: true, srcs: [["PRS, Karnataka Budget Analysis 2023-24","https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"],["The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget","https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"],["Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting","https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"],["Wikipedia infobox (pointer to ECI): 2023 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"]] },
  { id: "scheme:kl-welfare-pensions-arrears", label: "Kerala social security pensions (₹1,600/month) and the 2023–26 arrears cycle", sub: "pension · KL state scheme · LDF (CPI(M)-led)", ty: "mechanism", fam: "instrument", st: "kl", sz: 2, al: ["Kerala welfare pension","സാമൂഹ്യ സുരക്ഷാ പെൻഷൻ"], resolved: true, srcs: [["Deccan Herald, 8 Apr 2024: As polls approach, Kerala Left govt to pay pension dues","https://www.deccanherald.com/elections/kerala/as-polls-approach-kerala-left-govt-to-pay-pension-dues-2969893"],["Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears","https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"],["Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go","https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"],["PRS, Kerala Budget Analysis 2024-25","https://prsindia.org/budgets/states/kerala-budget-analysis-2024-25"],["Wikipedia infobox (pointer to ECI): 2026 Kerala Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Kerala_Legislative_Assembly_election"],["DD News, 4 May 2026: UDF crosses majority mark in Kerala (ECI trends)","https://ddnews.gov.in/en/assembly-polls-2026-udf-crosses-majority-mark-in-kerala/"],["Wikipedia infobox (pointer to ECI): 2021 Kerala Legislative Assembly election","https://en.wikipedia.org/wiki/2021_Kerala_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2016 Kerala Legislative Assembly election","https://en.wikipedia.org/wiki/2016_Kerala_Legislative_Assembly_election"]] },
  { id: "scheme:mgnrega", label: "Mahatma Gandhi National Rural Employment Guarantee Act / Scheme", sub: "unemployment · central scheme · INC (UPA)", ty: "mechanism", fam: "instrument", st: null, sz: 3, al: ["MGNREGA","NREGA","MGNREGS","मनरेगा"], resolved: true, srcs: [["PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"],["PIB (MoRD), Clarifications on budget cut to MGNREGA, BE/RE/release series 2014-15 to 2022-23, 3 Feb 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"],["PIB Backgrounder, Viksit Bharat-G RAM G Act 2025 FAQ, 11 May 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2259712"],["Wikipedia (pointer), MGNREGA 2005","https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"],["Wikipedia — MGNREGA","https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act"],["Muralidharan, Niehaus & Sukhtankar, 'General Equilibrium Effects of (Improving) Public Employment Programs: Experimental Evidence from India', NBER WP 23838 (2017; revised, published Econometrica 2023) — abstract","https://www.nber.org/papers/w23838"],["Muralidharan, Niehaus & Sukhtankar, 'Building State Capacity: Evidence from Biometric Smartcards in India', AER 106(10), Oct 2016 — abstract","https://www.aeaweb.org/articles?id=10.1257/aer.20141346"],["PIB, Ministry of Rural Development — Budget allocation under MGNREGA, Rajya Sabha written reply by MoS Kamlesh Paswan, 2025-07-25 (Release ID 2148475)","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"],["PIB, Ministry of Rural Development — Clarifications on budget cut to MGNREGA, 2023-02-03 (Release ID 1896038)","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"],["Deshpande, Tillin & Kailash (2019) The BJP’s Welfare Schemes: Did They Make a Difference in the 2019 Elections? — Studies in Indian Politics 7(2):219–233 (Crossref metadata + abstract)","https://api.crossref.org/works/10.1177/2321023019874911"]] },
  { id: "scheme:mh-farm-loan-waiver-2017", label: "Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017", sub: "loan-waiver · MH state scheme · BJP-Shiv Sena", ty: "mechanism", fam: "instrument", st: "mh", sz: 2, al: ["CSMSSY","Maharashtra loan waiver 2017"], resolved: true, srcs: [["Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"],["PRS, Maharashtra Budget Analysis 2018-19","https://prsindia.org/budgets/states/maharashtra-budget-analysis-2018-19"],["Wikipedia infobox (pointer to ECI results): 2019 Maharashtra Legislative Assembly election","https://en.wikipedia.org/wiki/2019_Maharashtra_Legislative_Assembly_election"]] },
  { id: "scheme:mh-farm-loan-waiver-2019", label: "Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019", sub: "loan-waiver · MH state scheme · MVA (Shiv Sena-NCP-INC)", ty: "mechanism", fam: "instrument", st: "mh", sz: 2, al: ["MJPSKY","Maharashtra loan waiver 2019"], resolved: true, srcs: [["Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"],["PRS, Maharashtra Budget Analysis 2020-21","https://prsindia.org/budgets/states/maharashtra-budget-analysis-2020-21"],["Wikipedia infobox (pointer to ECI): 2024 Maharashtra Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Maharashtra_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2019 Maharashtra Legislative Assembly election","https://en.wikipedia.org/wiki/2019_Maharashtra_Legislative_Assembly_election"]] },
  { id: "scheme:mh-ladki-bahin", label: "Mukhyamantri Majhi Ladki Bahin Yojana", sub: "women-cash · MH state scheme · BJP", ty: "mechanism", fam: "instrument", st: "mh", sz: 2, al: ["Ladki Bahin","लाडकी बहीण","Majhi Ladki Bahin","माझी लाडकी बहीण"], resolved: true, srcs: [["Govt of Maharashtra (Nashik) — Ladki Bahin Yojana","https://nashik.gov.in/en/scheme/mukhyamantri-mazi-ladki-bahin-yojana/"],["Outlook Business — women deciding Indian politics, cash transfers","https://www.outlookbusiness.com/economy-and-policy/story-in-numbers-women-are-deciding-indian-politics-now-cash-transfers-are-proof"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Lokniti-CSDS Maharashtra 2024 post-poll analysis, The Hindu, 25 Nov 2024 (Deshpande, ‘Women sided with Mahayuti for Ladki Bahin Yojana’s monthly dole’; Mishra, women as deciders) — page PDF held locally; thehindu.com unreachable from this container","https://www.lokniti.org/state-assembly-elections"],["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"],["Deccan Herald, 2024-08-15 — Shinde govt begins releasing money under Ladki Bahin Yojana on eve of Independence Day","https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"],["Deccan Herald, 2024-08-05 — Ladki Bahin Yojana a beneficiary scheme for women, not discriminatory: Bombay High Court","https://www.deccanherald.com/india/maharashtra/ladki-bahin-yojana-a-beneficiary-scheme-for-women-not-discriminatory-bombay-high-court-3137089"],["Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024","https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"],["Wikipedia (pointer), 2024 Maharashtra Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Maharashtra_Legislative_Assembly_election"],["Deccan Herald, 15 Aug 2024: Shinde govt begins releasing Ladki Bahin money","https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"],["Deccan Herald, 10 Mar 2025: Maharashtra budget gives Rs 36,000 cr to Ladki Bahin, silent on Rs 2,100","https://www.deccanherald.com/india/maharashtra/maharashtra-govt-gives-rs-36000-crore-to-ladki-bahin-in-budget-mum-on-stipend-hike-ups-vehicle-tax-3440102"],["Scroll, 16 Apr 2025: Maharashtra cuts Ladki Bahin payout for 8 lakh women to Rs 500","https://scroll.in/latest/1081399/maharashtra-cuts-ladki-bahin-yojana-payout-for-8-lakh-women-to-rs-500-per-month-report"],["Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification","https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "scheme:mp-jai-kisan-fasal-rin-mafi-2018", label: "Jai Kisan Fasal Rin Mafi Yojana (MP, Dec 2018)", sub: "loan-waiver · MP state scheme · INC", ty: "mechanism", fam: "instrument", st: "mp", sz: 2, al: ["MP farm loan waiver 2018"], resolved: true, srcs: [["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"],["Wikipedia infobox (pointer to ECI): 2023 Madhya Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2018 Madhya Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Madhya_Pradesh_Legislative_Assembly_election"]] },
  { id: "scheme:mp-ladli-behna", label: "Mukhyamantri Ladli Behna Yojana", sub: "women-cash · MP state scheme · BJP", ty: "mechanism", fam: "instrument", st: "mp", sz: 2, al: ["Ladli Behna","Ladli Bahna","लाड़ली बहना"], resolved: true, srcs: [["Govt of MP — Ladli Behna official portal","https://cmladlibehna.mp.gov.in/"],["Wikipedia — 2023 MP Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"],["Lokniti-CSDS — Madhya Pradesh Postpoll Survey 2023: Survey Findings (N=3,050, 18–24 Nov 2023; PDF held locally; Lokniti state-election index page opened)","https://www.lokniti.org/state-assembly-elections"],["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"],["Deccan Herald, 2023-03-05 — Ahead of MP govt’s Ladli Behna launch, Kamal Nath promises women ₹18,000 per year","https://www.deccanherald.com/india/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"],["Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025","https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"],["Wikipedia (pointer), 2023 Madhya Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"],["Deccan Herald/PTI, 25 Feb 2023: MP cabinet clears Ladli Bahna Rs 1,000","https://www.deccanherald.com/india/mp-govt-clears-scheme-to-give-rs-1000-to-women-above-23-under-ladli-bahna-yojana-1195069.html"],["Mukhyamantri Ladli Bahna Yojana portal, WCD Madhya Pradesh (accessed 25 Sep 2026)","https://cmladlibahna.mp.gov.in/home.aspx"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["IANS via Prokerala, 10 Nov 2025: MP cabinet approves Rs 1,500 from Nov 12; Rs 3,000 by 2028 plan","https://www.prokerala.com/news/articles/a1695417.html"]] },
  { id: "scheme:mp-ladli-laxmi", label: "Mukhyamantri Ladli Laxmi Yojana", sub: "women-cash · MP state scheme · BJP", ty: "mechanism", fam: "instrument", st: "mp", sz: 2, al: ["Ladli Laxmi","लाड़ली लक्ष्मी"], resolved: true, srcs: [["Wikipedia — Ladli Laxmi Yojana","https://en.wikipedia.org/wiki/Ladli_Laxmi_Yojana"],["Wikipedia (pointer): Ladli Laxmi Yojana","https://en.wikipedia.org/wiki/Ladli_Laxmi_Yojana"],["Wikipedia infobox (pointer to ECI results): 2008 Madhya Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2008_Madhya_Pradesh_Legislative_Assembly_election"]] },
  { id: "scheme:mp-nari-samman-promise-2023", label: "Nari Samman Nidhi (MP INC 2023 promise, ₹1,500/month)", sub: "women-cash · MP state scheme · INC", ty: "mechanism", fam: "instrument", st: "mp", sz: 2, al: ["Nari Samman Yojana"], resolved: true, srcs: [["Deccan Herald, 5 Mar 2023: Kamal Nath promises women Rs 18,000/yr ahead of Ladli Behna launch","https://www.deccanherald.com/national/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"],["Wikipedia infobox (pointer to ECI results): 2023 Madhya Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"]] },
  { id: "scheme:or-kalia", label: "KALIA (Krushak Assistance for Livelihood and Income Augmentation)", sub: "farmer-cash · OR state scheme · BJD", ty: "mechanism", fam: "instrument", st: "or", sz: 2, al: ["KALIA","କାଳିଆ"], resolved: true, srcs: [["Pressreader/Hindustan Times — Odisha Rs 10,180-cr KALIA package","https://www.pressreader.com/india/hindustan-times-delhi/20181222/281788515170582"],["CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)","https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"],["Business Standard/PTI, 12 Sep 2024: Rs 782.2 cr given to 12.2 lakh ineligible beneficiaries under KALIA: CAG","https://www.business-standard.com/india-news/rs-782-2-cr-given-to-12-2l-ineligible-beneficiaries-under-kalia-scheme-cag-124091200419_1.html"],["ANI, 18 Sep 2019: Odisha: 3.41 lakh ineligible beneficiaries identified under KALIA","https://www.aninews.in/news/national/general-news/odisha-341lakh-ineligible-beneficiaries-identified-under-kalia-scheme20190918023936/"],["Business Standard/PTI, 6 Aug 2019: Ineligible beneficiaries refund KALIA assistance: Odisha govt","https://www.business-standard.com/article/pti-stories/ineligible-beneficiaries-refund-kalia-assistance-odisha-govt-119080601520_1.html"],["PRS, Odisha Budget Analysis 2019-20","https://prsindia.org/budgets/states/odisha-budget-analysis-2019-20"],["PRS, Odisha Budget Analysis 2024-25","https://prsindia.org/budgets/states/odisha-budget-analysis-2024-25"],["Wikipedia infobox (pointer to ECI): 2019 Odisha Legislative Assembly election","https://en.wikipedia.org/wiki/2019_Odisha_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2024 Odisha Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Odisha_Legislative_Assembly_election"]] },
  { id: "scheme:or-subhadra", label: "Subhadra Yojana", sub: "women-cash · OR state scheme · BJP", ty: "mechanism", fam: "instrument", st: "or", sz: 2, al: ["SUBHADRA","ସୁଭଦ୍ରା"], resolved: true, srcs: [["Wikipedia — Subhadra Yojana","https://en.wikipedia.org/wiki/Subhadra_Yojana"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PIB, 17 Sep 2024: PM launches SUBHADRA in Bhubaneswar","https://www.pib.gov.in/PressReleseDetailm.aspx?PRID=2055572&reg=3&lang=2"],["Deccan Herald/PTI, 17 Sep 2024: PM launches Subhadra; Rs 10,000/yr; 76 lakh registered; Rs 1,250 cr to 25 lakh","https://www.deccanherald.com/india/odisha/pm-modi-launches-odisha-govts-subhadra-scheme-railway-nh-projects-worth-over-rs-3800-cr-3193991"],["Wikipedia (pointer): Subhadra Yojana","https://en.wikipedia.org/wiki/Subhadra_Yojana"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Business Standard, 16 May 2024: BJP 'promises' Rs 50,000 vouchers to women, then clarifies Odisha-only","https://www.business-standard.com/elections/assembly-election/lok-sabha-elections-bjp-promises-rs-50-000-cash-vouchers-to-women-then-clarifies-124051600178_1.html"]] },
  { id: "scheme:pb-farm-loan-waiver-2017", label: "Punjab crop loan waiver 2017 (Amarinder Singh)", sub: "loan-waiver · PB state scheme · INC", ty: "mechanism", fam: "instrument", st: "pb", sz: 2, al: ["Karza Kurki Khatam"], resolved: true, srcs: [["Business Standard, 19 Jun 2017: Punjab CM Amarinder Singh announces crop loan waiver for 10.25 lakh farmers","https://www.business-standard.com/article/economy-policy/punjab-cm-amarinder-singh-announces-crop-loan-waiver-for-10-25-lakh-farmers-117061901226_1.html"],["Wikipedia infobox (pointer to ECI): 2022 Punjab Legislative Assembly election","https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"],["PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)","https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"],["Wikipedia infobox (pointer to ECI results): 2017 Punjab Legislative Assembly election","https://en.wikipedia.org/wiki/2017_Punjab_Legislative_Assembly_election"]] },
  { id: "scheme:pb-free-power-300-units", label: "Punjab free electricity up to 300 units", sub: "energy-subsidy · PB state scheme · AAP", ty: "mechanism", fam: "instrument", st: "pb", sz: 2, al: ["300 units free"], resolved: true, srcs: [["Wikipedia — 2022 Punjab Legislative Assembly election","https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"],["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PRS, Punjab Budget Analysis 2022-23","https://prsindia.org/budgets/states/punjab-budget-analysis-2022-23"],["PRS, Punjab Budget Analysis 2024-25","https://prsindia.org/budgets/states/punjab-budget-analysis-2024-25"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.13-14 and subsidy section (PDF)","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Wikipedia infobox (pointer to ECI): 2022 Punjab Legislative Assembly election","https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"]] },
  { id: "scheme:pb-smart-connect", label: "Punjab Smart Connect (free smartphones to Class XII students)", sub: "consumer-goods · PB state scheme · INC", ty: "mechanism", fam: "instrument", st: "pb", sz: 2, al: ["Captain Smart Connect"], resolved: true, srcs: [["The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020","https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"],["Wikipedia (pointer), 2022 Punjab Legislative Assembly election","https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"]] },
  { id: "scheme:pb-women-1000-promise", label: "AAP Punjab ₹1,000 per month to women (2022 guarantee)", sub: "women-cash · PB state scheme · AAP", ty: "mechanism", fam: "instrument", st: "pb", sz: 2, al: ["Punjab women Rs 1,000 guarantee"], resolved: true, srcs: [["ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs","https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Wikipedia infobox (pointer to ECI results): 2022 Punjab Legislative Assembly election","https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"]] },
  { id: "scheme:pm-kisan", label: "Pradhan Mantri Kisan Samman Nidhi", sub: "farmer-cash · central scheme · BJP (NDA)", ty: "mechanism", fam: "instrument", st: null, sz: 3, al: ["PM-KISAN","PM Kisan","किसान सम्मान निधि"], resolved: true, srcs: [["Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)","https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"],["PIB, PM to release 21st instalment of PM-KISAN on 19 Nov 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2190074"],["PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"],["PIB, PM to release 23rd instalment from Tarakeswar, Hooghly, WB on 20 Jun 2026, 18 Jun 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2274616"],["PMO, Cabinet approves continuation of PM-KISAN 2026-27 to 2030-31, ₹3.15 lakh crore, 31 Jul 2026","https://www.pmindia.gov.in/en/news_updates/cabinet-approves-continuation-of-the-pm-kisan-scheme-from-2026-27-to-2030-31-with-a-financial-outlay-of-rs-3-15-lakh-crore/"],["Lok Sabha Unstarred Q.358 (MoS Agri Ramnath Thakur), discrepancy in PM-KISAN: ₹416.75 cr recovered from ineligible beneficiaries, 2 Dec 2025","https://sansad.in/getFile/loksabhaquestions/annex/186/AU358_FPeZsZ.pdf?source=pqals"],["Wikipedia (pointer), Pradhan Mantri Kisan Samman Nidhi","https://en.wikipedia.org/wiki/Pradhan_Mantri_Kisan_Samman_Nidhi"],["PIB — PM-KISAN Samman Nidhi","https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=2039203"],["Ministry of Agriculture & Farmers Welfare, PM-KISAN Revised Operational Guidelines (PDF, pmkisan.gov.in)","https://www.pmkisan.gov.in/Documents/Revised%20Operational%20Guidelines%20-%20PM-Kisan%20Scheme.pdf"]] },
  { id: "scheme:pm-ujjwala", label: "Pradhan Mantri Ujjwala Yojana", sub: "energy-subsidy · central scheme · BJP (NDA)", ty: "mechanism", fam: "instrument", st: null, sz: 3, al: ["Ujjwala","PMUY","Ujjwala 2.0"], resolved: true, srcs: [["CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)","https://cag.gov.in/"],["PIB, Cabinet approves continuation of ₹300 PMUY subsidy for FY 2024-25, 7 Mar 2024","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2012354"],["PIB, Cabinet approves PMUY targeted subsidy FY 2025-26 (₹300, up to 9 refills), 8 Aug 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2154117"],["PIB (MoPNG RS reply), Average LPG refill consumption of PMUY beneficiaries 2018-19 to 2020-21, 20 Dec 2021","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1783430"],["Wikipedia (pointer), Pradhan Mantri Ujjwala Yojana","https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"],["Wikipedia — Ujjwala Yojana","https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"],["Deshpande, Tillin & Kailash (2019) The BJP’s Welfare Schemes: Did They Make a Difference in the 2019 Elections? — Studies in Indian Politics 7(2):219–233 (Crossref metadata + abstract)","https://api.crossref.org/works/10.1177/2321023019874911"],["CAG press release on Performance Audit Report No. 14 of 2019 on PMUY, 11 Dec 2019 (local copy; exact report URL unresolved — see gaps)","https://cag.gov.in/en"],["PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"],["PIB, Average LPG refill consumption of PMUY beneficiaries (Rajya Sabha reply), 20 Dec 2021","https://pib.gov.in/PressReleasePage.aspx?PRID=1783430"],["Seminar #720, Jyoti Mishra & Vibha Attri (Lokniti-CSDS), 'Did welfare win votes?' (NES 2019 post-poll), 2019","https://india-seminar.com/2019/720/720_jyoti_and_vibha.htm"]] },
  { id: "scheme:pmgkay", label: "Pradhan Mantri Garib Kalyan Anna Yojana (free grain)", sub: "grain · central scheme · BJP (NDA)", ty: "mechanism", fam: "instrument", st: null, sz: 3, al: ["PM-GKAY","free ration scheme","मुफ्त राशन","PMGKAY","free ration"], resolved: true, srcs: [["PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"],["PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"],["ThePrint/ANI, 'Guarantee of Modi': PM extends free ration scheme for 5 years in poll-bound Chhattisgarh, MP, 4 Nov 2023","https://theprint.in/india/guarantee-of-modi-pm-extends-free-ration-scheme-for-5-years-in-poll-bound-chhattisgarh-mp/1832402/"],["Wikipedia (pointer), PMGKAY","https://en.wikipedia.org/wiki/Pradhan_Mantri_Garib_Kalyan_Anna_Yojana"],["Wikipedia — PMGKAY","https://en.wikipedia.org/wiki/Pradhan_Mantri_Garib_Kalyan_Anna_Yojana"],["PRS Legislative Research, 'Demand for Grants 2024-25 Analysis: Food and Public Distribution'","https://prsindia.org/budgets/parliament/demand-for-grants-2024-25-analysis-food-and-public-distribution"],["PIB (Ministry of Finance), 'India's DBT: Boosting Welfare Efficiency' — BlueKraft assessment, 21 Apr 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2123192"]] },
  { id: "scheme:pmjdy", label: "Pradhan Mantri Jan Dhan Yojana and the DBT/JAM architecture", sub: "other · central scheme · BJP (NDA)", ty: "mechanism", fam: "instrument", st: null, sz: 3, al: ["PMJDY","Jan Dhan"], resolved: true, srcs: [["PIB (MoF), PMJDY completes 11 years, 28 Aug 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2161401"],["PIB, Ministry of Finance Year Ender 2024: Department of Expenditure (DBT via PFMS), 27 Dec 2024","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2088438"],["PIB, 'India's DBT: Boosting Welfare Efficiency' (BlueKraft report relayed), 21 Apr 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2123192"],["Wikipedia (pointer), Pradhan Mantri Jan Dhan Yojana","https://en.wikipedia.org/wiki/Pradhan_Mantri_Jan_Dhan_Yojana"]] },
  { id: "scheme:rj-chiranjeevi", label: "Mukhyamantri Chiranjeevi Swasthya Bima Yojana → Mukhyamantri Ayushman Arogya Yojana", sub: "other · RJ state scheme · INC", ty: "mechanism", fam: "instrument", st: "rj", sz: 2, al: ["Chiranjeevi","MAAY"], resolved: true, srcs: [["PRS, Rajasthan Budget Analysis 2021-22","https://prsindia.org/budgets/states/rajasthan-budget-analysis-2021-22"],["Wikipedia infobox (pointer to ECI): 2023 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"]] },
  { id: "scheme:rj-farm-loan-waiver-2018", label: "Rajasthan farm loan waiver (Dec 2018) — and Raje's ₹50,000 pre-poll waiver (Feb 2018)", sub: "loan-waiver · RJ state scheme · INC (Dec 2018); BJP (Feb 2018 precursor)", ty: "mechanism", fam: "instrument", st: "rj", sz: 2, al: ["Rajasthan Krishak Rin Mafi"], resolved: true, srcs: [["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"],["PRS, Rajasthan Budget Analysis 2021-22","https://prsindia.org/budgets/states/rajasthan-budget-analysis-2021-22"],["Wikipedia infobox (pointer to ECI): 2023 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2018 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Rajasthan_Legislative_Assembly_election"],["Deccan Herald — Rajasthan 2023: change of guard, end of Gehlot–Raje era","https://www.deccanherald.com/india/rajasthan/rajasthan-2023-change-of-guard-end-of-gehlot-raje-era-2829895"]] },
  { id: "scheme:rj-grah-laxmi-guarantee-2023", label: "Grah Laxmi Guarantee (Rajasthan INC 2023 promise)", sub: "women-cash · RJ state scheme · INC", ty: "mechanism", fam: "instrument", st: "rj", sz: 2, al: ["Gruha Lakshmi Guarantee Rajasthan"], resolved: true, srcs: [["Deccan Herald, 25 Oct 2023: Gehlot promises Rs 10,000/yr to woman head of family","https://www.deccanherald.com/elections/rajasthan/rajasthan-polls-gehlot-promises-rs-10000year-to-woman-head-of-families-lpg-cylinder-at-rs-500-2740998"],["Wikipedia infobox (pointer to ECI results): 2023 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"]] },
  { id: "scheme:rj-indira-gandhi-smartphone", label: "Indira Gandhi Smartphone Yojana (Rajasthan)", sub: "consumer-goods · RJ state scheme · INC", ty: "mechanism", fam: "instrument", st: "rj", sz: 2, al: ["Rajasthan free mobile yojana"], resolved: true, srcs: [["ThePrint (Hindi), 'Indira Gandhi Smartphone Yojana begins in Rajasthan; 40 lakh women in phase 1', 11 Aug 2023","https://hindi.theprint.in/report/indira-gandhi-smartphone-yojana-started-in-rajasthan-40-lakh-women-will-get-smartphones-in-the-first-phase/582752/"],["Wikipedia (pointer), 2023 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"]] },
  { id: "scheme:rj-mehangai-rahat-camps", label: "Mehangai Rahat Camps (inflation-relief camps) and Chiranjeevi enhancement", sub: "energy-subsidy · RJ state scheme · INC", ty: "mechanism", fam: "instrument", st: "rj", sz: 2, resolved: true, srcs: [["The Week — Rajasthan Mehangai Rahat camps","https://www.theweek.in/wire-updates/national/2023/05/09/des56-rj-gehlot-inflation-relief.html"],["The Week — Gehlot welfare schemes Rajasthan 2023","https://www.theweek.in/theweek/cover/2023/11/10/ashok-gehlot-welfware-schemes-rajasthan-elections-2023.html"]] },
  { id: "scheme:tg-aasara-pensions", label: "Aasara Pensions", sub: "pension · TG state scheme · BRS (TRS)", ty: "mechanism", fam: "instrument", st: "tg", sz: 2, al: ["Asara","ఆసరా"], resolved: true, srcs: [["Wikipedia (pointer): Aasara pension","https://en.wikipedia.org/wiki/Aasara_pension"],["CAG, Performance Audit of DBT scheme 'Aasara Pensions in Telangana' (2021), Chapter III (PDF)","https://cag.gov.in/uploads/download_audit_report/2021/Chapter-III-Implementation-of-Aasara-Pensions-as-a-DBT-Scheme-065cdb90dd72180.15791130.pdf"],["PRS, Telangana Budget Analysis 2023-24","https://prsindia.org/budgets/states/telangana-budget-analysis-2023-24"],["PRS, Telangana Budget Analysis 2024-25","https://prsindia.org/budgets/states/telangana-budget-analysis-2024-25"],["Wikipedia infobox (pointer to ECI): 2018 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Telangana_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2023 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"]] },
  { id: "scheme:tg-crop-loan-waiver-2024", label: "Telangana crop loan waiver 2024 (Rythu Runa Mafi, up to ₹2 lakh)", sub: "loan-waiver · TG state scheme · INC", ty: "mechanism", fam: "instrument", st: "tg", sz: 2, al: ["Runa Mafi","రుణమాఫీ"], resolved: true, srcs: [["News On Air (AIR), 17 Jul 2024: Telangana to implement crop loan waiver from tomorrow","https://www.newsonair.gov.in/telangana-to-implement-crop-loan-waiver-from-tomorrow-onwards"],["News On Air (AIR), 18 Jul 2024: Over Rs 6,000 cr released towards crop loan waiver; 11 lakh farmers in phase 1","https://www.newsonair.gov.in/telangana-over-rs-6000-cr-released-by-state-govt-towards-crop-loan-waiver/"],["PRS, Telangana Budget Analysis 2024-25","https://prsindia.org/budgets/states/telangana-budget-analysis-2024-25"],["Wikipedia infobox (pointer to ECI): 2023 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"]] },
  { id: "scheme:tg-mahalakshmi", label: "Mahalakshmi Guarantee (Telangana Congress)", sub: "women-cash · TG state scheme · INC", ty: "mechanism", fam: "instrument", st: "tg", sz: 2, resolved: true, srcs: [["INC — Mahalakshmi guarantee announcement","https://x.com/INCIndia/status/1703402712027549699"],["The South First — Mahalakshmi fact-check","https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"]] },
  { id: "scheme:tg-mahalakshmi-cash", label: "Mahalakshmi — ₹2,500 monthly cash component (Telangana)", sub: "women-cash · TG state scheme · INC", ty: "mechanism", fam: "instrument", st: "tg", sz: 2, al: ["Mahalakshmi scheme"], resolved: true, srcs: [["The South First, 8 Jan 2025: fact check — Rs 2,500 Mahalakshmi not paid","https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"],["Wikipedia infobox (pointer to ECI results): 2023 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"]] },
  { id: "scheme:tg-rythu-bandhu", label: "Rythu Bandhu (Farmer's Investment Support Scheme)", sub: "farmer-cash · TG state scheme · BRS", ty: "mechanism", fam: "instrument", st: "tg", sz: 2, al: ["FISS","Farmer Investment Support Scheme","రైతు బంధు","Rythu Bharosa (2025 rename)"], resolved: true, srcs: [["Wikipedia — Rythu Bandhu scheme","https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"],["Business Standard/ANI, 26 Feb 2018: 'KCR govt to allocate Rs 12,000 cr for crop investment support'","http://www.business-standard.com/article/news-ani/kcr-govt-to-allocate-rs-12-000-cr-for-crop-investment-support-118022600048_1.html"],["Times of India, 2 Jan 2021: 'Most of 13,000 rich farmers in Telangana still get Rythu Bandhu aid'","https://timesofindia.indiatimes.com/city/hyderabad/most-of-13000-rich-farmers-in-t-still-get-rythu-bandhu-aid/articleshow/80066258.cms"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Business Standard/ANI, 26 Feb 2018: KCR govt to allocate Rs 12,000 cr for crop investment support","https://www.business-standard.com/article/news-ani/kcr-govt-to-allocate-rs-12-000-cr-for-crop-investment-support-118022600048_1.html"],["PRS, Telangana Budget Analysis 2018-19","https://prsindia.org/budgets/states/telangana-budget-analysis-2018-19"],["Wikipedia (pointer): Rythu Bandhu scheme","https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"],["Thomas, Uday & Zaveri (IGIDR/IFROGS), 'Linking welfare distribution to land records: a case-study of the Rythu Bandhu Scheme', TR-2020-4-27 (PDF)","https://ifrogs.org/PDF/rbs_report.pdf"],["CAG, Performance Audit of DBT scheme 'Aasara Pensions in Telangana' (2021), Chapter III (PDF)","https://cag.gov.in/uploads/download_audit_report/2021/Chapter-III-Implementation-of-Aasara-Pensions-as-a-DBT-Scheme-065cdb90dd72180.15791130.pdf"],["Deccan Herald/PTI, 21 Dec 2024: Rythu Bandhu Rs 22,600 cr given to ineligible people in BRS regime, says Telangana CM","https://www.deccanherald.com/india/telangana/rythu-bandhu-rs-22600-crore-given-to-ineligible-people-in-brs-regime-says-telangana-cm-3328152"],["ANI, 5 Jan 2025: Telangana farmers to receive Rs 12,000 per acre annually under Rythu Bharosa","https://www.aninews.in/news/national/general-news/telangana-farmers-to-receive-rs-12000-per-acre-annually-under-rythu-bharosa-scheme20250105033356/"],["PRS, Telangana Budget Analysis 2023-24","https://prsindia.org/budgets/states/telangana-budget-analysis-2023-24"],["Wikipedia infobox (pointer to ECI): 2018 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Telangana_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2023 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"]] },
  { id: "scheme:tn-amma-unavagam", label: "Amma Unavagam (Amma Canteens)", sub: "other · TN state scheme · AIADMK", ty: "mechanism", fam: "instrument", st: "tn", sz: 2, al: ["Amma Canteen","Amma canteen"], resolved: true, srcs: [["ThePrint, 'Now it's Rs 15 for 3 meals at Chennai's Amma Canteens', 1 Jun 2020","https://theprint.in/india/now-its-rs-15-for-3-meals-at-chennais-amma-canteens-but-end-of-free-food-bad-news-for-many/433276/"]] },
  { id: "scheme:tn-free-bus-women-2021", label: "Tamil Nadu free bus travel for women (Vidiyal Payanam)", sub: "transport · TN state scheme · DMK", ty: "mechanism", fam: "instrument", st: "tn", sz: 2, al: ["Vidiyal Payanam","Magalir Vidiyal Payanam","free bus for women TN"], resolved: true, srcs: [["The Federal, 12 Jun 2023: Free bus travel for women — Karnataka model vs TN, Delhi, Punjab","https://thefederal.com/states/south/karnataka/karnataka-introduces-free-bus-travel-for-women-a-comparison-with-other-states"],["Deccan Herald, 18 Mar 2022: Free travel — more women in Tamil Nadu now take government buses (budget 2022-23)","https://www.deccanherald.com/india/free-travel-more-women-in-tamil-nadu-now-take-government-buses-1092556.html"],["Wikipedia infobox (pointer to ECI): 2021 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2021_Tamil_Nadu_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2026 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"]] },
  { id: "scheme:tn-free-colour-tv-2006", label: "Tamil Nadu free colour television scheme (DMK, 2006–11)", sub: "consumer-goods · TN state scheme · DMK", ty: "mechanism", fam: "instrument", st: "tn", sz: 2, al: ["Free colour TV","இலவச வண்ணத் தொலைக்காட்சி"], resolved: true, srcs: [["Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme","https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"],["IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?","https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"],["Wikipedia (pointer): Colour TV case (1990s, J. Jayalalithaa)","https://en.wikipedia.org/wiki/Colour_TV_case"],["Wikipedia infobox (pointer to ECI): 2006 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2006_Tamil_Nadu_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2011 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2011_Tamil_Nadu_Legislative_Assembly_election"]] },
  { id: "scheme:tn-free-consumer-goods", label: "Tamil Nadu free consumer goods (DMK 2006 televisions; AIADMK 2011 mixers, grinders, fans)", sub: "consumer-goods · TN state scheme · DMK (2006) / AIADMK (2011)", ty: "mechanism", fam: "instrument", st: "tn", sz: 2, al: ["TN free TVs","free mixer-grinder scheme"], resolved: true, srcs: [["S. Subramaniam Balaji v Government of Tamil Nadu, SC, 2013-07-05, (2013) 9 SCC 659 — Indian Kanoon","https://indiankanoon.org/doc/106854428/"],["Ashwini Kumar Upadhyay v Union of India, W.P.(C) 43/2022, SC order 2022-08-26 (reference to three-judge bench) — Indian Kanoon","https://indiankanoon.org/doc/82460936/"]] },
  { id: "scheme:tn-free-laptops", label: "Tamil Nadu free laptop scheme (AIADMK 2011→; DMK laptops/tablets 2025-26)", sub: "consumer-goods · TN state scheme · AIADMK (2011-21) / DMK (2025→)", ty: "mechanism", fam: "instrument", st: "tn", sz: 2, al: ["ELCOT laptops","Ulagam Ungal Kaiyil"], resolved: true, srcs: [["Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025","https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"],["Wikipedia (pointer), 2021 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2021_Tamil_Nadu_Legislative_Assembly_election"]] },
  { id: "scheme:tn-free-mixie-grinder-fan-2011", label: "Tamil Nadu free mixie, grinder and fan scheme (AIADMK, 2011–16)", sub: "consumer-goods · TN state scheme · AIADMK", ty: "mechanism", fam: "instrument", st: "tn", sz: 2, al: ["Amma mixie-grinder","இலவச மிக்ஸி கிரைண்டர்"], resolved: true, srcs: [["Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women","https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"],["Wikipedia infobox (pointer to ECI): 2011 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2011_Tamil_Nadu_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2016 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2016_Tamil_Nadu_Legislative_Assembly_election"]] },
  { id: "scheme:tn-kalaignar-magalir-urimai-thogai", label: "Kalaignar Magalir Urimai Thogai", sub: "women-cash · TN state scheme · DMK", ty: "mechanism", fam: "instrument", st: "tn", sz: 2, al: ["KMUT","Kalaignar Magalir Urimai Thittam","கலைஞர் மகளிர் உரிமைத் தொகை"], resolved: true, srcs: [["DT Next — Kalaignar Magalir Urimai Thogai","https://www.dtnext.in/news/tamilnadu/kalaignar-magalir-urimai-thogai-scheme-over-148-lakh-women-file-fresh-appeals-now-eligible-for-rs-1000-monthly-aid-792929"],["Govt of TN — KMUT official portal","https://kmut.tn.gov.in/"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Deccan Herald, 15 Sep 2023: Stalin launches Rs 1,000 monthly scheme for 1.06 cr women","https://www.deccanherald.com/india/tamil-nadu/stalin-launches-rs-1000-monthly-assistance-scheme-for-women-heads-of-families-2687619"],["Deccan Herald, 10 Nov 2023: TN adds 7.35 lakh beneficiaries; 1.13 cr total","https://www.deccanherald.com/india/tamil-nadu/tamil-nadu-expands-monthly-assistance-scheme-to-women-adds-7-lakh-beneficiaries-2766189"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Wikipedia (pointer): 2026 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"]] },
  { id: "scheme:up-farm-loan-waiver-2017", label: "Uttar Pradesh farm loan waiver 2017 (Kisan Rin Mochan)", sub: "loan-waiver · UP state scheme · BJP", ty: "mechanism", fam: "instrument", st: "up", sz: 2, al: ["Fasal Rin Mochan Yojana"], resolved: true, srcs: [["Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'","https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"],["PRS, Uttar Pradesh Budget Analysis 2017-18","https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2017-18"],["PRS, Uttar Pradesh Budget Analysis 2018-19","https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2018-19"],["Wikipedia (pointer): 2017 Uttar Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2017_Uttar_Pradesh_Legislative_Assembly_election"]] },
  { id: "scheme:up-free-laptops-2012", label: "Uttar Pradesh free laptop distribution (Samajwadi Party, 2012-13)", sub: "consumer-goods · UP state scheme · SP", ty: "mechanism", fam: "instrument", st: "up", sz: 2, al: ["UP laptop yojana","Akhilesh laptops"], resolved: true, srcs: [["Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'","https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"]] },
  { id: "scheme:up-kanya-sumangala-2019", label: "Mukhyamantri Kanya Sumangala Yojana (UP)", sub: "student · UP state scheme · BJP", ty: "mechanism", fam: "instrument", st: "up", sz: 2, al: ["Kanya Sumangala","कन्या सुमंगला"], resolved: true, srcs: [["PRS, Uttar Pradesh Budget Analysis 2019-20","https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2019-20"],["Wikipedia infobox (pointer to ECI results): 2019 Indian general election","https://en.wikipedia.org/wiki/2019_Indian_general_election"]] },
  { id: "scheme:upa-farm-loan-waiver-2008", label: "Agricultural Debt Waiver and Debt Relief Scheme, 2008", sub: "loan-waiver · central scheme · INC (UPA)", ty: "mechanism", fam: "instrument", st: null, sz: 3, al: ["2008 farm loan waiver","ADWDRS"], resolved: true, srcs: [["Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)","https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"],["CAG Report No. 3 of 2013, ADWDRS 2008 executive summary (PDF is image-only; text not machine-verified)","https://cag.gov.in/uploads/download_audit_report/2013/Union_Performance_Civil_Sector_3_2013_chapter_3_exe_summ.pdf"],["Swarajya — CAG found irregularities in 2008 loan waiver","https://swarajyamag.com/politics/when-cag-found-irregularities-in-upa-government-farm-loan-waiver-in-2008"],["The Print — 2008 farm loan waiver designed to be last of its kind","https://theprint.in/report/we-had-designed-2008-farm-loan-waiver-to-be-last-of-its-kind-upa-agriculture-secy/1511/"]] },
  { id: "scheme:wb-kanyashree", label: "Kanyashree Prakalpa", sub: "student · WB state scheme · TMC", ty: "mechanism", fam: "instrument", st: "wb", sz: 2, al: ["Kanyashree","কন্যাশ্রী"], resolved: true, srcs: [["Wikipedia — Kanyashree Prakalpa","https://en.wikipedia.org/wiki/Kanyashree_Prakalpa"],["UNICEF — Kanyashree Prakalpa","https://www.unicef.org/india/stories/kanyashree-prakalpa-building-brighter-future-every-girl-west-bengal-0"],["Wikipedia (pointer): Kanyashree Prakalpa","https://en.wikipedia.org/wiki/Kanyashree_Prakalpa"],["PRS, West Bengal Budget Analysis 2019-20","https://prsindia.org/budgets/states/west-bengal-budget-analysis-2019-20"],["Wikipedia infobox (pointer to ECI): 2021 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2021_West_Bengal_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2016 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2016_West_Bengal_Legislative_Assembly_election"]] },
  { id: "scheme:wb-lakshmir-bhandar", label: "Lakshmir Bhandar", sub: "women-cash · WB state scheme · TMC", ty: "mechanism", fam: "instrument", st: "wb", sz: 2, al: ["Lakshmi Bhandar","লক্ষ্মীর ভান্ডার"], resolved: true, srcs: [["Vikaspedia — Lakshmir Bhandar scheme","https://en.vikaspedia.in/viewcontent/schemesall/state-specific-schemes/welfare-schemes-of-west-bengal/lakhsmir-bhandar-scheme"],["Business Today — TMC manifesto Lakshmir Bhandar hike","https://www.businesstoday.in/elections/west-bengal/story/rise-in-lakshmir-bhandar-allocation-by-rs500-rs30000-crore-agriculture-budget-key-highlights-of-tmcs-manifesto-for-west-bengal-polls-521659-2026-03-20"],["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["South 24 Parganas district portal: Lakshmir Bhandar scheme page","https://s24pgs.gov.in/lakshmir-bhandar/"],["Deccan Herald, 6 Jun 2024: Mamata cashes in on Lakshmir Bhandar in LS 2024","https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mamata-banerjee-cashes-in-on-lakshmir-bhandar-and-modis-shift-to-hindutva-in-west-bengal-3055262"],["ANI, 6 Feb 2026: West Bengal announces Rs 500 Lakshmir Bhandar hike in interim budget 2026-27","https://www.aninews.in/news/national/politics/west-bengal-govt-announces-rs-500-hike-for-lakshmir-bhandar-beneficaries-ahead-of-assembly-polls20260206060332/"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Wikipedia (pointer): 2026 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2026_West_Bengal_Legislative_Assembly_election"]] },
];

export const WELFARE_CLAIMS: GEdge[] = [
  { id: "claim:ajitpawar-presentbudget-ladkibahin", s: "wel:ajit-pawar", t: "scheme:mh-ladki-bahin", pred: "role", tier: "documented", lab: "presented the Maharashtra state budget announcing Ladki Bahin as Deputy CM/Finance Minister", from: "2024-06-28", srcs: [["Govt of Maharashtra (Nashik) — Ladki Bahin Yojana","https://nashik.gov.in/en/scheme/mukhyamantri-mazi-ladki-bahin-yojana/"]] },
  { id: "claim:ap2024-counter-narrative", s: "scheme:ap-ysr-rythu-bharosa", t: "party:ysrcp", pred: "analytic", tier: "analytic", lab: "AP ran one of India's largest state DBT welfare architectures for five years, and the incumbent still lost the 2024 election by a landslide", srcs: [["Wikipedia — 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"]], innocentReading: "Anti-incumbency, alliance dynamics (TDP-BJP-Janasena combine), and allegations against the YSRCP government unrelated to welfare policy are all independently sufficient explanations that do not require crediting or blaming the welfare schemes themselves." },
  { id: "claim:baghel-approve-ctloanwaiver", s: "wel:bhupesh-baghel", t: "scheme:ct-farm-loan-waiver-2018", pred: "role", tier: "documented", lab: "approved the Chhattisgarh farm loan waiver as his government's first cabinet decision", from: "2018-12-17", srcs: [["National Herald — Chhattisgarh Rs 6,100-cr loan waiver","https://www.nationalheraldindia.com/national/chhattisgarh-cm-bhupesh-baghel-announces-indian-rupee6100-cr-farm-loan-waiver"]] },
  { id: "claim:bihar2025-closest-fit", s: "scheme:br-mahila-rozgar-yojana", t: "party:jdu", pred: "analytic", tier: "analytic", lab: "closest launch-to-poll gap in this file (~6 weeks), largest reach (>1 crore women), largest NDA seat margin since 2010", srcs: [["Deccan Herald — Bihar 2025 NDA wins 202 seats","https://www.deccanherald.com/amp/story/elections%2Fbihar%2Fbihar-assembly-elections-2025-results-nda-cruises-to-victory-by-winning-202-seats-and-a-vote-share-of-over-40-3798063"]], innocentReading: "Bihar's 2025 result also reflects a much-improved law-and-order and infrastructure narrative, a fragmented Mahagathbandhan campaign, and Chirag Paswan's LJP(RV) re-consolidating NDA votes — none of which this file can separate from the scheme's own marginal effect with the data available." },
  { id: "claim:bjp-contra-ladlibehna", s: "bjp", t: "claim:ladlibehna-alleged-inducement", pred: "contra", tier: "reported", lab: "BJP's public position is that Ladli Behna is a welfare entitlement continuing MP's two-decade record of women/girl-child schemes (Ladli Laxmi since 2007), not an election-specific payment", srcs: [["Wikipedia — Ladli Laxmi Yojana","https://en.wikipedia.org/wiki/Ladli_Laxmi_Yojana"]] },
  { id: "claim:cag-audit-loanwaiver2008", s: "cag", t: "scheme:upa-farm-loan-waiver-2008", pred: "enforce", tier: "documented", lab: "2013 CAG audit found irregularities in implementation of the 2008 farm loan waiver", srcs: [["Deccan Herald — CAG finds flaws in debt waiver implementation","https://www.deccanherald.com/india/cag-finds-flaws-implementation-debt-2235970"]] },
  { id: "claim:chidambaram-announce-loanwaiver2008", s: "wel:p-chidambaram", t: "scheme:upa-farm-loan-waiver-2008", pred: "role", tier: "documented", lab: "announced the ₹60,000-cr farm loan waiver in the 2008-09 budget speech", from: "2008-02-29", srcs: [["Swarajya — CAG found irregularities in 2008 loan waiver","https://swarajyamag.com/politics/when-cag-found-irregularities-in-upa-government-farm-loan-waiver-in-2008"]] },
  { id: "claim:delhi2025-counter-narrative", s: "scheme:dl-mahila-samman-promise-2025", t: "party:aap", pred: "analytic", tier: "analytic", lab: "the incumbent's own fresh cash promise, on top of a decade of running free power/water, did not save it from a landslide loss to a larger competing promise", srcs: [["Deccan Herald — Delhi 2025 result, BJP vote share up 13pp","https://www.deccanherald.com/elections/delhi/delhi-assembly-election-2025-results-bjps-vote-share-rises-by-13-aap-sees-10-decline-3397296"]], innocentReading: "The liquor-policy corruption case, ten years of incumbency fatigue, and BJP's own organisational push are independently sufficient explanations; the result also shows that a challenger's counter-promise can neutralise an incumbent's welfare offer, which the single-party framing of 'freebies win elections' does not anticipate." },
  { id: "claim:gehlot-announce-mehangairahat", s: "wel:ashok-gehlot", t: "scheme:rj-mehangai-rahat-camps", pred: "role", tier: "documented", lab: "announced and ran the Mehangai Rahat camps as Chief Minister of Rajasthan", from: "2023-04-24", srcs: [["The Week — Rajasthan Mehangai Rahat camps","https://www.theweek.in/wire-updates/national/2023/05/09/des56-rj-gehlot-inflation-relief.html"]] },
  { id: "claim:jagan-announce-rythubharosa", s: "wel:ys-jagan-mohan-reddy", t: "scheme:ap-ysr-rythu-bharosa", pred: "role", tier: "documented", lab: "announced and launched YSR Rythu Bharosa as Chief Minister of Andhra Pradesh", from: "2019-10-15", srcs: [["ClearTax — YSR Rythu Bharosa","https://cleartax.in/s/ysr-rythu-bharosa-scheme"]] },
  { id: "claim:kcr-announce-rythubandhu", s: "wel:k-chandrashekar-rao", t: "scheme:tg-rythu-bandhu", pred: "role", tier: "documented", lab: "announced and launched Rythu Bandhu as Chief Minister of Telangana", from: "2018-05-10", srcs: [["Wikipedia — Rythu Bandhu scheme","https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"]] },
  { id: "claim:kejriwal-promise-mahilasamman", s: "wel:arvind-kejriwal", t: "scheme:dl-mahila-samman-promise-2025", pred: "role", tier: "reported", lab: "promised Mahila Samman Yojana during the 2025 Delhi campaign", srcs: [["Wikipedia — 2025 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"]] },
  { id: "claim:ladkibahin-csds-finding", s: "scheme:mh-ladki-bahin", t: "bjp", pred: "analytic", tier: "reported", lab: "Lokniti-CSDS post-poll survey found an 11-point Mahayuti-support gap between Ladki Bahin applicants (54%) and non-applicants (43%), and only a 3-point overall gender gap", srcs: [["Outlook Business — women deciding Indian politics, cash transfers","https://www.outlookbusiness.com/economy-and-policy/story-in-numbers-women-are-deciding-indian-politics-now-cash-transfers-are-proof"]], innocentReading: "The gap is real but bounded — most of Mahayuti's win margin (230 of 288 seats) is not explained by this single scheme according to the survey's own numbers; treating the result as scheme-caused alone over-reads a modest, real effect." },
  { id: "claim:ladlibehna-election-timing", s: "scheme:mp-ladli-behna", t: "bjp", pred: "analytic", tier: "analytic", lab: "launched roughly 5 months before the November 2023 MP election, which the incumbent BJP won by its largest margin since 2013", srcs: [["Wikipedia — 2023 MP Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"]], innocentReading: "Madhya Pradesh had run other Ladli-branded women's/girl-child schemes since 2007 (Ladli Laxmi); a further extension of that lineage to adult women is consistent with an established policy direction, not solely an election-timed innovation." },
  { id: "claim:mamata-announce-lakshmirbhandar", s: "wel:mamata-banerjee", t: "scheme:wb-lakshmir-bhandar", pred: "role", tier: "documented", lab: "announced Lakshmir Bhandar and its 2026 pre-poll hike as Chief Minister of West Bengal", srcs: [["Vikaspedia — Lakshmir Bhandar scheme","https://en.vikaspedia.in/viewcontent/schemesall/state-specific-schemes/welfare-schemes-of-west-bengal/lakhsmir-bhandar-scheme"]] },
  { id: "claim:manmohan-announce-mgnrega", s: "wel:manmohan-singh", t: "scheme:mgnrega", pred: "role", tier: "documented", lab: "government under which the NREGA Act was passed and the scheme launched", from: "2006-02-02", srcs: [["Wikipedia — MGNREGA","https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act"]] },
  { id: "claim:mann-approve-punjabfreepower", s: "wel:bhagwant-mann", t: "scheme:pb-free-power-300-units", pred: "role", tier: "analytic", lab: "delivered the 300-unit free power promise after AAP's 2022 Punjab win; exact rollout date not independently sourced this session", innocentReading: "Recorded as analytic because this file could not pin the rollout date to a fetched primary source this session (see gaps) — the underlying fact of AAP delivering its free-power promise after taking office is well established, but is not asserted here with a specific unsourced date." },
  { id: "claim:modi-announce-mahilarozgar", s: "pol:narendra-modi", t: "scheme:br-mahila-rozgar-yojana", pred: "role", tier: "documented", lab: "announced and made the first disbursement of the Mukhyamantri Mahila Rozgar Yojana", from: "2025-09-26", srcs: [["Deccan Herald — Bihar Rs 10,000 cash transfer to women","https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-rs-10000-cash-transfer-to-women-may-prove-game-changer-for-nitish-kumar-3773893"]] },
  { id: "claim:modi-announce-pmgkay-extension", s: "pol:narendra-modi", t: "scheme:pmgkay", pred: "role", tier: "documented", lab: "announced the 5-year PMGKAY extension from a Chhattisgarh campaign rally", from: "2023-11-23", srcs: [["Deccan Herald — PMGKAY extended 5 years from Jan 2024","https://www.deccanherald.com/india/modi-govt-extends-pmgkay-scheme-for-another-5-years-from-jan-1-2024-2789220"]] },
  { id: "claim:modi-announce-pmkisan", s: "pol:piyush-goyal", t: "scheme:pm-kisan", pred: "role", tier: "documented", lab: "announced PM-KISAN in the 2019 interim budget", from: "2019-02-01", srcs: [["PMO — Cabinet approves PM-KISAN","https://www.pmindia.gov.in/en/news_updates/cabinet-approves-pradhan-mantri-kisan-samman-nidhi-pm-kisan-scheme/"]] },
  { id: "claim:modi-announce-subhadra", s: "pol:narendra-modi", t: "scheme:or-subhadra", pred: "role", tier: "documented", lab: "launched Subhadra Yojana after the BJP government took office in Odisha, delivering a manifesto promise", from: "2024-09-17", srcs: [["Wikipedia — Subhadra Yojana","https://en.wikipedia.org/wiki/Subhadra_Yojana"]] },
  { id: "claim:nda-contra-mahilarozgar", s: "party:jdu", t: "claim:mahilarozgar-alleged-bribe", pred: "contra", tier: "reported", lab: "the NDA's position is that the scheme extends Bihar's existing Jeevika self-help-group and self-employment programme, disbursed at the pace SHG verification allowed rather than newly invented for the poll", srcs: [["The Federal — Bihar pre-poll cash push sparks concerns over ECI neutrality","https://thefederal.com/category/elections-2025/pre-poll-cash-transfers-in-bihar-raise-concerns-over-voter-influence-eci-neutrality-214703"]] },
  { id: "claim:patnaik-announce-kalia", s: "wel:naveen-patnaik", t: "scheme:or-kalia", pred: "role", tier: "documented", lab: "announced and launched KALIA as Chief Minister of Odisha", from: "2018-12-21", srcs: [["Pressreader/Hindustan Times — Odisha Rs 10,180-cr KALIA package","https://www.pressreader.com/india/hindustan-times-delhi/20181222/281788515170582"]] },
  { id: "claim:pmkisan-election-timing", s: "scheme:pm-kisan", t: "bjp", pred: "analytic", tier: "analytic", lab: "launched 2 months before the 2019 Lok Sabha poll", srcs: [["PIB — PM-KISAN Samman Nidhi","https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=2039203"]], innocentReading: "A universal, low-per-head farmer transfer had been under discussion since 2018 farm distress and state loss (MP, Rajasthan, Chhattisgarh in Dec 2018); an interim budget is the standard, non-election-specific vehicle for such an announcement regardless of the calendar." },
  { id: "claim:rj2023-anti-incumbency", s: "scheme:rj-mehangai-rahat-camps", t: "party:inc", pred: "analytic", tier: "analytic", lab: "a large relief push 7 months before the poll (within the 6-12 month window) still preceded an incumbent loss", innocentReading: "Rajasthan has changed its ruling party in every single assembly election since 1993; this file's Rajasthan/Himachal/Punjab rows show a combined incumbent win rate of roughly 1-in-15 regardless of any scheme, making the state's own structural anti-incumbency a stronger candidate explanation than scheme timing." },
  { id: "claim:shivraj-announce-ladlibehna", s: "pol:shivraj-singh-chouhan", t: "scheme:mp-ladli-behna", pred: "role", tier: "reported", lab: "announced and administered the Ladli Behna Yojana as Chief Minister of Madhya Pradesh", srcs: [["Govt of MP — Ladli Behna official portal","https://cmladlibehna.mp.gov.in/"]] },
  { id: "claim:siddaramaiah-announce-gruhalakshmi", s: "wel:siddaramaiah", t: "scheme:ka-gruha-lakshmi", pred: "role", tier: "documented", lab: "announced and launched Gruha Lakshmi as Chief Minister of Karnataka", from: "2023-05-20", srcs: [["Congress — Gruha Lakshmi launch","https://inc.in/congress-sandesh/others/in-karnataka-gruha-lakshmi-scheme-launched-1-1-crore-women-heads-of-households-to-get-2000-monthly-aid"]] },
  { id: "claim:soren-announce-maiyasamman", s: "wel:hemant-soren", t: "scheme:jh-maiya-samman", pred: "role", tier: "documented", lab: "announced and launched Maiya Samman Yojana as Chief Minister of Jharkhand", from: "2024-08-18", srcs: [["IMPRI — Maiya Samman Yojana policy update","https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"]] },
  { id: "claim:stalin-announce-kmut", s: "wel:mk-stalin", t: "scheme:tn-kalaignar-magalir-urimai-thogai", pred: "role", tier: "documented", lab: "announced and launched Kalaignar Magalir Urimai Thogai as Chief Minister of Tamil Nadu", from: "2023-09-15", srcs: [["DT Next — Kalaignar Magalir Urimai Thogai","https://www.dtnext.in/news/tamilnadu/kalaignar-magalir-urimai-thogai-scheme-over-148-lakh-women-file-fresh-appeals-now-eligible-for-rs-1000-monthly-aid-792929"]] },
  { id: "claim:sukhu-approve-ops", s: "wel:sukhvinder-singh-sukhu", t: "scheme:hp-ops-restoration", pred: "role", tier: "documented", lab: "restored the Old Pension Scheme as his government's first cabinet decision", from: "2023-01-13", srcs: [["Onmanorama — Himachal restores Old Pension Scheme","https://www.onmanorama.com/news/india/2023/01/14/congress-himachal-pradesh-old-pension-scheme.html"]] },
  { id: "claim:tmc-contra-lakshmirbhandar", s: "party:tmc", t: "claim:lakshmirbhandar-alleged-inducement-2026", pred: "contra", tier: "reported", lab: "TMC's position is that the hike continues a five-year-old scheme's normal benefit-indexing and was paired with other non-election-specific budget measures (youth allowance, pay commission)", srcs: [["ETV Bharat — WB budget 2026 hikes Lakshmir Bhandar ahead of polls","https://www.etvbharat.com/en/state/west-bengal-budget-2026-mamata-hikes-lakshmir-bhandar-unveils-youth-allowance-and-seventh-pay-commission-ahead-of-polls-enn26020506960"]] },
  { id: "claim:wb2026-counter-narrative", s: "scheme:wb-lakshmir-bhandar", t: "party:tmc", pred: "analytic", tier: "analytic", lab: "TMC hiked its flagship women's scheme ~2.5 months before the 2026 poll, the closest-timed hike in this file, and still lost after 15 years in power", srcs: [["Republic World — WB 2026 results live, BJP ends TMC 15-year rule","https://www.republicworld.com/elections/west-bengal-assembly-election-results-2026-live-updates-tmc-vs-bjp-mamata-banerjee-suvendu-adhikari-counting-trends-winners-leading-trailing-live-news"]], innocentReading: "A single scheme's timing is a small input against a multi-year erosion of TMC's position (anti-incumbency, corruption allegations, and a sustained BJP organisational push since 2019); this file's data cannot isolate the scheme's marginal contribution from these confounders." },
  { id: "fiscal:c001", s: "pol:narendra-modi", t: "bjp", pred: "analytic", tier: "analytic", lab: "'revdi' speech vs BJP states' own UCTs", d: "On 16 Jul 2022 the PM said double-engine (BJP) governments 'are not adopting the shortcut of distributing freebies'. A month earlier RBI's freebies table put BJP-ruled MP at 1.6% of GSDP (4th of 9); by 2025-26, 7 of the 12 states PRS lists with women's unconditional cash transfers are BJP/NDA-governed (AS, CT, DL, HR, MH, MP, OD), budgeting ₹85,424 cr of the ₹1,68,040 cr total (50.8%).", from: "2022-07-16", srcs: [["PMO India, 'PM's address at inauguration of Bundelkhand Expressway at Jalaun, UP', 16 Jul 2022 (English text + PMO tweets in Hindi)","https://www.pmindia.gov.in/en/news_updates/pms-address-at-inauguration-of-bundelkhand-expressway-at-jalaun-in-uttar-pradesh/"],["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"]], innocentReading: "The speech targeted unfunded election promises and free utilities, and BJP distinguishes budgeted, targeted 'empowerment' transfers from 'revdi'. RBI's MP figure is a legacy farm-power subsidy, not a new promise. The 2025-26 count also reflects the BJP simply governing more states.", upgradeIf: "A BJP document defines 'revdi' so as to include women's UCTs, or BJP states launch UCTs in the pre-poll window at a higher rate than others (the timing base rate below finds no party difference: 7/15 vs 7/19, Fisher p=0.73).", killIf: "A consistent, published BJP definition of 'freebie' that excludes all its states' UCTs and includes all rivals' on stated, non-partisan criteria." },
  { id: "fiscal:c002", s: "wel:rbi", t: "scheme:pb-free-power-300-units", pred: "enforce", tier: "documented", lab: "RBI Jun 2022: Punjab tops freebies table", d: "RBI Bulletin (Jun 2022) Table 5, 2022-23 freebies as % of GSDP: Punjab 2.7, AP 2.1, Jharkhand 1.7, MP 1.6, WB 1.1, Rajasthan 0.6, Bihar 0.1, Haryana 0.1, Kerala 0.0. Governing parties then: AAP, YSRCP, JMM, BJP, TMC, INC, JD(U)–BJP, BJP–JJP, LDF. SCO dates publication to 16 Jun 2022.", from: "2022-06-16", srcs: [["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"],["Supreme Court Observer, case page 'Freebies in Electoral Democracy and Welfare State' — Ashwini Kumar Upadhyay v Union of India, W.P.(C) 43/2022 (status Pending; last updated 21 Aug 2024)","https://www.scobserver.in/cases/freebies/"]] },
  { id: "fiscal:c003", s: "wel:rbi", t: "scheme:pb-free-power-300-units", pred: "analytic", tier: "analytic", lab: "Punjab's 2.7% includes an unenacted promise", d: "₹12,000 cr of RBI's ₹17,000 cr Punjab figure was the ₹1,000/month-to-every-adult-woman promise, sourced from a Business Standard article before Punjab's budget; it was not enacted. Enacted items alone ≈0.8% of GSDP. The top of RBI's 2022 ranking is partly a costing of a promise, not of spending.", srcs: [["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"]], innocentReading: "RBI was explicit that Punjab's budget had not been presented and flagged the source; costing announced promises is a legitimate risk exercise.", upgradeIf: "Punjab budget documents show ₹12,000 cr was never provided in 2022-23 BE.", killIf: "Punjab's 2022-23 budget provided for the women's transfer." },
  { id: "fiscal:c004", s: "wel:ashwini-upadhyay", t: "wel:eci", pred: "enforce", tier: "alleged", lab: "PIL: election freebies = bribery; bar them", d: "Petitioner (former BJP Delhi spokesperson) alleges promising 'irrational freebies from public funds' amounts to bribery and undue influence (IPC 171B/171C) and seeks an Election Symbols Order condition de-registering parties that do so.", from: "2022-01-22", srcs: [["Supreme Court Observer, case page 'Freebies in Electoral Democracy and Welfare State' — Ashwini Kumar Upadhyay v Union of India, W.P.(C) 43/2022 (status Pending; last updated 21 Aug 2024)","https://www.scobserver.in/cases/freebies/"],["Supreme Court Observer, 'Freebies in Elections Day #6: CJI Reiterates 3-Judge Bench Reference', 1 Nov 2022","https://www.scobserver.in/reports/freebies-in-elections-day-6-cji-reiterates-3-judge-bench-reference-ashwini-kumar-upadhyay-v-union-of-india/"],["LiveLaw, 1 Nov 2022: 'Election Freebies | Supreme Court directs matter to be listed before three judge bench at the earliest' (U.U. Lalit CJI, Bela M. Trivedi J)","https://www.livelaw.in/top-stories/election-freebies-supreme-court-directs-matter-to-be-listed-before-three-judge-bench-at-the-earliest-212939"]], upgradeIf: "A three-judge bench overrules S. Subramaniam Balaji (2013) and holds such promises a corrupt practice.", killIf: "The bench upholds Balaji or dismisses the petitions as non-justiciable." },
  { id: "fiscal:c005", s: "party:aap", t: "claim:fiscal:c004", pred: "contra", tier: "documented", lab: "AAP: welfare for the poor is not a freebie; PIL is political", d: "AAP's intervention: socio-economic welfare cannot be called freebies; the petitioner did not disclose his BJP ties; the PIL is a 'political interest litigation' that targets promising, not delivering, benefits.", from: "2022-08-09", srcs: [["LiveLaw, 9 Aug 2022: 'Welfare schemes for poor not freebies…' — AAP intervention opposing the Upadhyay PIL","https://www.livelaw.in/top-stories/welfare-schemes-poor-not-freebies-assess-cost-of-perks-ministers-mpsmlas-corporates-aap-to-supreme-court-206075"]] },
  { id: "fiscal:c006", s: "party:dmk", t: "claim:fiscal:c004", pred: "contra", tier: "documented", lab: "DMK: welfare schemes are Article 38 duties, not freebies", d: "DMK's application: free services secure social and economic justice under Article 38; free electricity has multi-dimensional effects; asks why corporate tax holidays and bad-loan waivers are not considered alongside.", from: "2022-08-16", srcs: [["LiveLaw, 16 Aug 2022: 'Welfare schemes not freebies…' — DMK impleadment application","https://www.livelaw.in/top-stories/welfare-schemes-not-freebies-union-govts-tax-holidays-waiver-of-bad-loans-also-should-be-considered-dmk-tells-supreme-court-206642"]] },
  { id: "fiscal:c007", s: "wel:eci", t: "claim:fiscal:c004", pred: "contra", tier: "documented", lab: "ECI: limited scope to regulate promises", d: "The Supreme Court's 26 Aug 2022 order records that the ECI 'has consistently taken the stand' that it has limited scope to interfere in parties' promises; SCO reports the ECI affidavit calling it a policy matter for voters.", srcs: [["Supreme Court of India, order dated 26 Aug 2022 in W.P.(C) 43/2022 (N.V. Ramana CJI, Hima Kohli, C.T. Ravikumar JJ) — reference to three-judge bench (copy hosted by SCO)","https://www.scobserver.in/wp-content/uploads/2022/08/Freebies-Order-August-26th.pdf"],["Supreme Court Observer, case page 'Freebies in Electoral Democracy and Welfare State' — Ashwini Kumar Upadhyay v Union of India, W.P.(C) 43/2022 (status Pending; last updated 21 Aug 2024)","https://www.scobserver.in/cases/freebies/"]] },
  { id: "fiscal:c008", s: "sc", t: "wel:eci", pred: "enforce", tier: "documented", lab: "SC refers freebies PIL to 3-judge bench", d: "Order of 26 Aug 2022 (Ramana CJI): freebies 'may create a situation wherein the State … is pushed towards imminent bankruptcy', but 'all promises cannot be equated with freebies'; framed three preliminary questions incl. whether a Commission/Expert Body would serve any purpose — the expert body floated on 3 Aug 2022 was never constituted; reference to three-judge bench. SCO lists the case as pending (last updated 21 Aug 2024); last reported argued hearing Nov 2023.", from: "2022-08-26", srcs: [["Supreme Court of India, order dated 26 Aug 2022 in W.P.(C) 43/2022 (N.V. Ramana CJI, Hima Kohli, C.T. Ravikumar JJ) — reference to three-judge bench (copy hosted by SCO)","https://www.scobserver.in/wp-content/uploads/2022/08/Freebies-Order-August-26th.pdf"],["Supreme Court Observer, case page 'Freebies in Electoral Democracy and Welfare State' — Ashwini Kumar Upadhyay v Union of India, W.P.(C) 43/2022 (status Pending; last updated 21 Aug 2024)","https://www.scobserver.in/cases/freebies/"],["Supreme Court Observer, 'Freebies in Electoral Democracy | Day 8', Nov 2023 (hearing deferred to 29 Nov 2023)","https://www.scobserver.in/reports/freebies-in-electoral-democracy-day-8-if-inducement-of-bribery-cannot-be-done-directly-it-cannot-be-done-indirectly-argue-petitioners/"],["Supreme Court Observer, tag page 'freebies' (opened 25 Sep 2026; no hearing after 21 Aug 2024 listed)","https://www.scobserver.in/tag/freebies/"]] },
  { id: "fiscal:c009", s: "sc", t: "party:dmk", pred: "analytic", tier: "analytic", lab: "CJI's 'schemes near elections' remark came in a TN case, not the PIL", d: "The Feb 2026 remarks ('Why suddenly schemes are announced near elections?') were oral observations while hearing TN Power Distribution Co.'s challenge to Electricity Amendment Rules 2024 — two months before the Apr 2026 TN election; they carry no precedential force and were not made in W.P.(C) 43/2022. Justice Gavai's Feb 2025 'parasites' remark was likewise in an unrelated homeless-shelter PIL.", from: "2026-02-19", srcs: [["LiveLaw, 19 Feb 2026: ''Why cash transfer schemes just before elections?' Supreme Court slams freebies culture' (Surya Kant CJI, Bagchi, Pancholi JJ; TN Power Distribution Co. challenge to Electricity Amendment Rules 2024)","https://www.livelaw.in/top-stories/why-cash-transfer-schemes-just-before-elections-supreme-court-slams-freebies-culture-says-nation-building-hampered-523778"],["LiveLaw, 12 Feb 2025: 'Because of freebies, people aren't willing to work: Supreme Court judge' (Justice B.R. Gavai, urban-homeless shelters PIL)","https://www.livelaw.in/top-stories/supreme-court-justice-gavai-on-freebies-integrate-homeless-in-mainstream-society-for-contribution-to-nation-283732"]], innocentReading: "Judges' oral remarks are commonly used to probe counsel and do not signal an outcome; the bench said explicitly it was 'not talking of Tamil Nadu in particular'.", upgradeIf: "A written order or judgment adopts the reasoning.", killIf: "The three-judge bench rules freebies non-justiciable." },
  { id: "fiscal:c010", s: "cag", t: "scheme:ka-gruha-lakshmi", pred: "enforce", tier: "reported", a: 52525, lab: "CAG: guarantees → 'loop of indebtedness'", d: "CAG State Finances Audit Report 2024-25 (Karnataka), tabled 26 Mar 2026: five guarantees cost ₹52,525 cr in 2024-25, shifted the state to revenue deficit in 2023-24 and 2024-25, and were financed partly by ₹71,525.15 cr net market borrowing; only 62.12% of borrowings went to developmental expenditure. Reported by Deccan Herald; report text not opened.", from: "2026-03-26", srcs: [["Deccan Herald, 26 Mar 2026: 'Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG' (CAG State Finances Audit Report 2024-25, tabled 26 Mar 2026)","https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"]], innocentReading: "The audit itself is not in dispute. What can be disputed is whether the guarantees caused the fiscal problems. A revenue deficit and more borrowing in 2023-24 and 2024-25 could also come from other committed spending rising at the same time, such as pay-revision costs, interest and older subsidies, or from slower revenue growth. The CAG's own recommendation is conditional: \"rationalisation of the existing subsidies... or better targeting\". The DH headline, \"forced cuts to nutrition, rural development\", is a causal claim, and the article body shows no CAG figure behind it. It should be read as the paper's summary.", upgradeIf: "Open the CAG report PDF and confirm the quotations.", killIf: "The report text does not contain the quoted findings." },
  { id: "fiscal:c010:audit-contra", s: "scheme:ka-gruha-lakshmi", t: "claim:fiscal:c010", pred: "contra", tier: "reported", lab: "denial found in audit", d: "I found no government response to the 26 Mar 2026 report in the sources I opened. My web search budget ran out, so I could not search further. The only denial on record is H.M. Revanna's, reported by Deccan Herald on 25 Aug 2025: \"The report's suggestion that the guarantee schemes were exacting a toll on the state's resources was 'far from the truth'\" (https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866). It answers the August 2025 CAG report, not this one. The Mar 2026 DH article embeds a related-story link, \"'Neither a burden nor inflationary': Siddaramaiah defends Karnataka's guarantee schemes\", but gives no date and no quote tied to this report. The DH article does not show that the government was asked for comment.", srcs: [["Denial — www.deccanherald.com","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"]] },
  { id: "fiscal:c011", s: "wel:h-m-revanna", t: "claim:fiscal:c010", pred: "contra", tier: "reported", lab: "Revanna: CAG conclusion 'far from the truth'", d: "Responding to CAG's Aug 2025 report: per-capita income and GST collections rose; ₹94,177 cr spent on guarantees; 98% implemented; 'Analysing programmes isn't right'. No government response to the Mar 2026 report was captured in sources opened here.", from: "2025-08-25", srcs: [["Deccan Herald, 26 Aug 2025: ''CAG report's conclusions on welfare schemes in Karnataka incorrect': H M Revanna'","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"]] },
  { id: "fiscal:c012", s: "wel:prs-legislative-research", t: "scheme:ka-gruha-lakshmi", pred: "analytic", tier: "documented", lab: "UCT turns KA surplus into deficit; trims MP surplus", d: "PRS: excluding UCT spending, Karnataka's 2025-26 BE revenue balance would be +0.3% of GSDP instead of −0.6%; Madhya Pradesh +1.1% instead of +0.4%. Six of the 12 UCT states budget a revenue deficit.", from: "2025-10-01", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"]], innocentReading: "A counterfactual 'excluding UCT' balance assumes nothing else would be spent; the same arithmetic would make any large line item look like the cause of a deficit." },
  { id: "fiscal:c013", s: "scheme:jh-maiya-samman", t: "party:jmm", pred: "analytic", tier: "analytic", lab: "Payout raised 2.5x weeks before JH poll", d: "Maiyan Samman was raised from ₹1,000 to ₹2,500/month in Oct 2024 (PRS); the Jharkhand assembly election followed on 13 Nov 2024 (elections-timing.json) and the JMM-led alliance retained power. The scheme is now 12.1% of revenue expenditure — the highest UCT burden in India.", from: "2024-10-01", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"]], innocentReading: "The increase matched the ₹2,100–2,500 bids already on the table from rivals (BJP states' own schemes) and was continued after the election, i.e. it was not a one-off pre-poll payment.", upgradeIf: "Evidence of a cut or rollback after the election, or of payment timing tied to polling dates.", killIf: "Cabinet papers show the hike was budgeted before the election schedule was known." },
  { id: "fiscal:c015", s: "scheme:tg-rythu-bandhu", t: "party:brs", pred: "analytic", tier: "analytic", lab: "Telangana: largest off-budget borrower in 2021-22", d: "Telangana declared ₹35,258 cr of off-budget borrowing in 2021-22 (53% of all states) and the highest guarantee ratio (15.1% of GSDP, Mar 2024), during BRS rule, while running an uncapped per-acre transfer. PRS attributes 37% of its guarantees to irrigation.", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"]], innocentReading: "Most Telangana off-budget borrowing is associated with irrigation (Kaleshwaram-type) corporations, not the DBT itself; Rythu Bandhu was paid from the budget.", upgradeIf: "CAG Telangana state-finance audit links SPV borrowing to scheme payments.", killIf: "CAG shows all off-budget borrowing funded capital works." },
  { id: "fiscal:c016", s: "scheme:tg-rythu-bandhu", t: "party:brs", pred: "analytic", tier: "reported", lab: "Uncapped transfer reaches 20–40 acre owners", d: "State estimates (TOI, Jan 2021): ~13,000 farmers with 20–40 acres (>3.19 lakh acres) receive payments; 743 returned money. One season for this group ≈₹150 cr.", from: "2021-01-02", srcs: [["Times of India, 2 Jan 2021: 'Most of 13,000 rich farmers in Telangana still get Rythu Bandhu aid'","https://timesofindia.indiatimes.com/city/hyderabad/most-of-13000-rich-farmers-in-t-still-get-rythu-bandhu-aid/articleshow/80066258.cms"]], innocentReading: "≈13,000 of ~58 lakh beneficiaries is ~0.2%; per-acre design without cap was a deliberate simplicity/coverage choice to avoid exclusion errors from income verification.", upgradeIf: "Full land-size distribution of payments showing the top decile's share.", killIf: "Payments data show the top holders' share is negligible in rupee terms." },
  { id: "fiscal:c017", s: "wel:rbi", t: "bjp", pred: "analytic", tier: "documented", lab: "RBI 2026: cash transfers risk crowding out investment", d: "RBI State Finances 2025-26 (23 Jan 2026), para 4.5: several states' 2025-26 budgets added farm loan waivers, free electricity, subsidised transport, unemployment allowances and direct cash transfers to women; 'these welfare expenditures run the risk of crowding out critical investments'; calls for impact assessment. Para 4.8: asks for a state DBT database and separate budget codes. The warning is party-neutral and names no state.", from: "2026-01-23", srcs: [["RBI, State Finances: A Study of Budgets of 2025-26 (23 Jan 2026), Chapter IV 'The Way Forward', paras 4.1, 4.5, 4.8","https://www.rbi.org.in/Scripts/PublicationsView.aspx?id=23694"]], innocentReading: "A routine, party-neutral fiscal-prudence caution in the RBI's annual state-finance study; it names no state or party and implies no misuse — transfers may be a deliberate policy choice with their own returns." },
  { id: "fiscal:c018", s: "wel:rbi", t: "party:inc", pred: "analytic", tier: "documented", lab: "Aggregate states' deficit 3.3% of GDP; revenue deficit share of GFD down to 6.9%", d: "RBI 2025-26: consolidated state GFD widened to 3.3% of GDP in 2024-25 and is budgeted at 3.3% in 2025-26; but the share of revenue deficit in GFD fell from 46.1% (2020-21) to 6.9% (2025-26 BE), i.e. most borrowing is budgeted for capital — the aggregate does not show transfers crowding out capex yet.", from: "2026-01-23", srcs: [["RBI, State Finances: A Study of Budgets of 2025-26 (23 Jan 2026), Chapter II 'Fiscal Position of the State Governments'","https://www.rbi.org.in/Scripts/PublicationsView.aspx?id=23692"]], innocentReading: "Aggregate state finances are consistent with transfers being funded from revenue while borrowing is budgeted for capital; the figure attributes no fiscal stress to any party." },
  { id: "fiscal:c019", s: "wel:nber", t: "scheme:in-nfsa", pred: "enforce", tier: "documented", lab: "Biometric PDS reform: 1.5–2 mn lost access", d: "Randomised and natural-experiment evidence (MNS, NBER 26744): stricter biometric ID in PDS reduced corruption but 1.5–2 million legitimate beneficiaries lost access at some point.", srcs: [["Muralidharan, Niehaus & Sukhtankar, 'Identity Verification Standards in Welfare Programs: Experimental Evidence from India', NBER WP 26744 (Feb 2020, revised) — abstract","https://www.nber.org/papers/w26744"]] },
  { id: "fiscal:c020", s: "wel:nber", t: "scheme:mgnrega", pred: "enforce", tier: "documented", lab: "Better NREGS delivery: +14% earnings, −26% poverty", d: "MNS (NBER 23838): randomised improvement of NREGS payments raised beneficiary earnings 14% and cut poverty 26%, mostly via private-sector wages.", srcs: [["Muralidharan, Niehaus & Sukhtankar, 'General Equilibrium Effects of (Improving) Public Employment Programs: Experimental Evidence from India', NBER WP 23838 (2017; revised, published Econometrica 2023) — abstract","https://www.nber.org/papers/w23838"]] },
  { id: "fiscal:c021", s: "wel:aea-journals", t: "scheme:br-balika-cycle", pred: "enforce", tier: "documented", lab: "Bihar cycles: +32% girls' secondary enrolment", d: "Muralidharan & Prakash (AEJ Applied 2017), triple-difference (not RCT): +32% enrolment, −40% gender gap.", srcs: [["Muralidharan & Prakash, 'Cycling to School: Increasing Secondary School Enrollment for Girls in India', AEJ: Applied Economics 9(3), Jul 2017 — abstract","https://www.aeaweb.org/articles?id=10.1257/app.20160004"]] },
  { id: "fiscal:c022", s: "wel:aea-journals", t: "scheme:mgnrega", pred: "enforce", tier: "documented", lab: "AP Smartcards: less leakage, no loss of access", d: "MNS (AER 2016) RCT: biometric smartcards cut leakage in NREGS and pensions, faster payments, no access loss.", srcs: [["Muralidharan, Niehaus & Sukhtankar, 'Building State Capacity: Evidence from Biometric Smartcards in India', AER 106(10), Oct 2016 — abstract","https://www.aeaweb.org/articles?id=10.1257/aer.20141346"]] },
  { id: "fiscal:c023", s: "bjp", t: "party:inc", pred: "analytic", tier: "analytic", lab: "Launches cluster in the 12 months before elections — for every party", d: "Across 34 fleet schemes with a determinable launch and election cycle, 14 (41%) launched within 12 months before the next election vs 6.8 expected (20%) if launches were spread uniformly across each cycle (risk ratio 2.06; one-sided Monte Carlo p≈0.004, survives Benjamini–Hochberg at q=0.05 across 12 tests). BJP/NDA-led 7/15 vs non-BJP 7/19: Fisher p=0.73 — no party difference.", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"]], innocentReading: "The fleet's scheme list was assembled from politically salient schemes, and salience is itself caused by election proximity (selection on the outcome). Governments also time budgets, and budgets fall in the final year of every term; many pre-poll launches are delivery of earlier budget announcements.", upgradeIf: "The same excess appears in a census of all state DBT launches (e.g. from a state DBT database RBI asks for) rather than a salience-selected list.", killIf: "A census of scheme launches shows no excess over the uniform null." },
  { id: "fiscal:c024", s: "wel:prs-legislative-research", t: "bjp", pred: "analytic", tier: "documented", lab: "12 states, ₹1.68 lakh cr, 0.47% of GDP", d: "PRS: states with women's UCTs rose from 2 (2022-23) to 12 (2025-26); spending rose from 0.01% of GDP (2020-21) to 0.05% (2022-23), 0.19% (2023-24), 0.44% (2024-25 RE) and 0.47% (2025-26 BE); the 12 states spend ~6% of revenue expenditure on them.", from: "2025-10-01", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"]], innocentReading: "The rise tracks cross-party policy diffusion (BJP, INC, AITC, DMK and JMM states all run women's UCTs); a spending share is a fiscal fact, not evidence of electoral intent." },
  { id: "fiscal:c025", s: "wel:rbi", t: "scheme:br-balika-cycle", pred: "analytic", tier: "analytic", lab: "'Freebie' label does not track effectiveness", d: "RBI's 2022 freebie annex includes Bihar's cycle scheme (₹200 cr), which has among the strongest causal evaluations in Indian social policy, alongside unenacted promises (Punjab) and legacy power subsidies (MP). Fiscal-risk tables measure cost, not value.", srcs: [["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"],["Muralidharan & Prakash, 'Cycling to School: Increasing Secondary School Enrollment for Girls in India', AEJ: Applied Economics 9(3), Jul 2017 — abstract","https://www.aeaweb.org/articles?id=10.1257/app.20160004"]], innocentReading: "RBI's purpose was fiscal risk, not programme merit; it explicitly said some freebies 'may benefit the poor if properly targeted'." },
  { id: "lit-w:c001", s: "wel:lokniti-csds", t: "scheme:mp-ladli-behna", pred: "analytic", tier: "documented", lab: "MP 2023 post-poll: Ladli Behna coverage 80.4%", d: "Lokniti-CSDS MP post-poll 2023 (N=3,050): 80.4% of respondents reported a Ladli Behna beneficiary in the household; BJP 48.6% of valid votes vs Congress 40.0% after weighting; Ladli Laxmi coverage 47.8%. No beneficiary×vote table in the public findings PDF as read.", from: "2023-11-18", to: "2023-11-24", srcs: [["Lokniti-CSDS — Madhya Pradesh Postpoll Survey 2023: Survey Findings (N=3,050, 18–24 Nov 2023; PDF held locally; Lokniti state-election index page opened)","https://www.lokniti.org/state-assembly-elections"]], innocentReading: "High coverage is what a near-universal women's scheme is designed to produce; it says nothing by itself about whether the scheme moved votes.", upgradeIf: "Lokniti releases the beneficiary × vote and gender × vote cross-tabs, or the raw data file", killIf: "A re-weighting error in the published findings" },
  { id: "lit-w:c002", s: "scheme:mp-ladli-behna", t: "bjp", pred: "analytic", tier: "analytic", lab: "‘Ladli Behna decided MP 2023’ is under-identified", d: "With ~80% household coverage, the beneficiary/non-beneficiary contrast has almost no non-beneficiaries; the BJP's +46-seat result (163 vs 66) coincided with Congress's own ₹1,500/month counter-promise; no causal estimate exists. The claim is a plausible attribution, not a finding.", srcs: [["Lokniti-CSDS — Madhya Pradesh Postpoll Survey 2023: Survey Findings (N=3,050, 18–24 Nov 2023; PDF held locally; Lokniti state-election index page opened)","https://www.lokniti.org/state-assembly-elections"],["Vinod Rai, ‘The BJP Wins the Semi-final: Impressive Gains in State Elections’, ISAS Brief No. 1081, 6 Dec 2023 (PDF held locally)","https://www.isas.nus.edu.sg/"],["Deccan Herald, 2023-03-05 — Ahead of MP govt’s Ladli Behna launch, Kamal Nath promises women ₹18,000 per year","https://www.deccanherald.com/india/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"]], innocentReading: "Anti-incumbency was weak for reasons unrelated to cash (Lokniti Q2a: 18.3% named ‘development of the state’ as the most-liked work, 10.8% ‘worked for the poor’); the PM's campaign and candidate selection are rival explanations.", upgradeIf: "A difference-in-differences on women's turnout and BJP swing by district against enrolment rates, or a Lokniti cross-tab showing beneficiaries swung more than non-beneficiaries", killIf: "Cross-tabs showing no difference in BJP vote between beneficiary and non-beneficiary households" },
  { id: "lit-w:c003", s: "wel:lokniti-csds", t: "scheme:mh-ladki-bahin", pred: "analytic", tier: "reported", lab: "Maharashtra 2024 post-poll: >80% of women applied; Mahayuti +3 among women", d: "Lokniti-CSDS analysis in The Hindu (25 Nov 2024): more than 80% of women respondents had applied for Ladki Bahin; Mahayuti support ran about 3 points higher among women than men and higher among rural women and applicants; the authors call it too early to speak of a women-as-beneficiaries constituency.", from: "2024-11-25", to: "2024-11-25", srcs: [["Lokniti-CSDS Maharashtra 2024 post-poll analysis, The Hindu, 25 Nov 2024 (Deshpande, ‘Women sided with Mahayuti for Ladki Bahin Yojana’s monthly dole’; Mishra, women as deciders) — page PDF held locally; thehindu.com unreachable from this container","https://www.lokniti.org/state-assembly-elections"]], innocentReading: "A 3-point gender gap is small relative to the alliance's overall margin; women's vote in Maharashtra has historically followed regional and caste dynamics (Deshpande).", upgradeIf: "Publication of the applicant × vote table with confidence intervals", killIf: "Reweighted data showing no gender gap" },
  { id: "lit-w:c004", s: "wel:lokniti-csds", t: "scheme:pm-ujjwala", pred: "analytic", tier: "documented", lab: "NES 2019: Ujjwala/Jan Dhan/Awas beneficiaries more likely to vote BJP; MGNREGA/pension recipients less", d: "Deshpande, Tillin & Kailash (Studies in Indian Politics 2019), using the NES 2019 post-poll: voters increasingly credit the central government for welfare, especially for Ujjwala and Jan Dhan; beneficiaries of Ujjwala, Jan Dhan or Awas were more likely to vote BJP, recipients of pensions or MGNREGA less likely.", srcs: [["Deshpande, Tillin & Kailash (2019) The BJP’s Welfare Schemes: Did They Make a Difference in the 2019 Elections? — Studies in Indian Politics 7(2):219–233 (Crossref metadata + abstract)","https://api.crossref.org/works/10.1177/2321023019874911"]], innocentReading: "Selection: Ujjwala and Jan Dhan reached households the BJP already courted; the association is not a treatment effect and the authors say so.", upgradeIf: "A regression-discontinuity on eligibility thresholds", killIf: "Replication on NES 2024 showing the association reverses" },
  { id: "lit-w:c005", s: "wel:lokniti-csds", t: "scheme:mgnrega", pred: "analytic", tier: "documented", lab: "NES 2019: MGNREGA recipients less likely to vote BJP; scheme now credited to the Centre", d: "Same study: MGNREGA, a Congress-era scheme, is now more associated with the central government than before, yet its recipients were less likely to support the BJP in 2019.", srcs: [["Deshpande, Tillin & Kailash (2019) The BJP’s Welfare Schemes: Did They Make a Difference in the 2019 Elections? — Studies in Indian Politics 7(2):219–233 (Crossref metadata + abstract)","https://api.crossref.org/works/10.1177/2321023019874911"]], innocentReading: "MGNREGA households are poorer and more rural than Ujjwala/Jan Dhan households, with different partisan baselines.", upgradeIf: "NES 2024 replication", killIf: "Reanalysis showing the coefficient is not distinguishable from zero" },
  { id: "lit-w:c006", s: "min:ministry-of-rural-development", t: "scheme:mgnrega", pred: "pmout", tier: "documented", a: 85838.76, lab: "MGNREGA releases 2020-21 to 2024-25", d: "Rajya Sabha reply (2025-07-25): BE/RE/released (₹ cr) — 2020-21 61,500/1,11,500/1,11,170.86; 2021-22 73,000/98,000/98,467.85; 2022-23 73,000/89,400/90,810.99; 2023-24 60,000/86,000/89,268.30; 2024-25 86,000/86,000/85,838.76; BE 2025-26 86,000. MoRD calls the scheme demand-driven and BE 2024-25 the highest ever.", from: "2020-04-01", to: "2025-03-31", srcs: [["PIB, Ministry of Rural Development — Budget allocation under MGNREGA, Rajya Sabha written reply by MoS Kamlesh Paswan, 2025-07-25 (Release ID 2148475)","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"],["PIB, Ministry of Rural Development — Clarifications on budget cut to MGNREGA, 2023-02-03 (Release ID 1896038)","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"]] },
  { id: "lit-w:c007", s: "wel:prs-legislative-research", t: "scheme:mh-ladki-bahin", pred: "enforce", tier: "documented", lab: "PRS: 12 UCT states, ₹1,68,040 cr, Maharashtra cut to ₹500 for overlap", d: "State of State Finances 2025: states running largely unconditional women's cash transfers rose from 2 (2022-23) to 12 (2025-26), budgeted ₹1,68,040 crore (0.5% of GDP; ~6% of revenue expenditure); six of the 12 project revenue deficits; in April 2025 Maharashtra cut Ladki Bahin from ₹1,500 to ₹500 for women receiving ₹1,000 under its women-farmer DBT scheme; Assam and West Bengal raised allocations 31% and 15% over RE 2024-25.", from: "2025-04-01", to: "2025-10-31", srcs: [["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"]] },
  { id: "lit-w:c008", s: "wel:prs-legislative-research", t: "scheme:mp-ladli-behna", pred: "enforce", tier: "documented", lab: "PRS: Ladli Behna takes MP from +1.1% to +0.4% of GSDP revenue balance", d: "Adjusting 2025-26 revenue balances for UCT spending, Karnataka moves from a 0.3% surplus to a 0.6% deficit of GSDP and Madhya Pradesh's surplus falls from 1.1% to 0.4%.", from: "2025-04-01", to: "2026-03-31", srcs: [["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"]] },
  { id: "lit-w:c009", s: "wel:rbi", t: "scheme:mh-ladki-bahin", pred: "enforce", tier: "reported", lab: "RBI 2024-25: subsidies and cash transfers to farmers, youth, women can stress state finances", d: "RBI's State Finances 2024-25 (Dec 2024), as quoted by PRS, highlighted that the sharp rise in subsidies and cash transfers to farmers, youth and women can stress state finances and recommended rationalising such spending. The RBI PDF returned a CAPTCHA in this container; wording is PRS's paraphrase.", from: "2024-12-01", to: "2024-12-31", srcs: [["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"],["RBI — State Finances: A Study of Budgets 2024-25 (Dec 2024) — PDF behind a CAPTCHA in this container; quoted via PRS","https://rbidocs.rbi.org.in/rdocs/Publications/PDFs/0STATEFINANCE2024AE6FF65F475C4934B53CC8ABE7FAB30E.PDF"]], upgradeIf: "Open the RBI PDF and quote the passage", killIf: "The RBI text does not say this" },
  { id: "lit-w:c010", s: "sc", t: "scheme:tn-free-consumer-goods", pred: "enforce", tier: "documented", lab: "SC 2013: manifesto freebies are not a corrupt practice", d: "S. Subramaniam Balaji v Tamil Nadu (2013-07-05): promises of free TVs, mixers, grinders in DMK/AIADMK manifestos are not ‘corrupt practice’ under s.123 RPA; the ECI was directed to frame guidelines for manifestos.", from: "2013-07-05", to: "2013-07-05", srcs: [["S. Subramaniam Balaji v Government of Tamil Nadu, SC, 2013-07-05, (2013) 9 SCC 659 — Indian Kanoon","https://indiankanoon.org/doc/106854428/"]] },
  { id: "lit-w:c011", s: "sc", t: "scheme:tn-free-consumer-goods", pred: "enforce", tier: "documented", lab: "SC 2022: freebies petitions referred to three-judge bench; Balaji to be reconsidered", d: "Ashwini Kumar Upadhyay v UoI (2022-08-26): the Court listed the petitions before a three-judge bench, recording that many parties sought reconsideration of Balaji; issues framed include the scope of judicial intervention and whether an expert commission should be appointed. Union: suggested a commission; ECI: limited authority over party promises; intervening parties: policy matters beyond judicial scope.", from: "2022-08-26", to: "2022-08-26", srcs: [["Ashwini Kumar Upadhyay v Union of India, W.P.(C) 43/2022, SC order 2022-08-26 (reference to three-judge bench) — Indian Kanoon","https://indiankanoon.org/doc/82460936/"]] },
  { id: "lit-w:c012", s: "pol:narendra-modi", t: "bjp", pred: "analytic", tier: "analytic", lab: "‘Revdi’ speech vs BJP states’ women’s cash schemes", d: "On 2022-07-16 at Jalaun the PM said ‘every effort is being made in our country to introduce the culture of collecting votes by distributing freebies … They feel that they will buy the people by distributing freebies’ and that ‘double-engine governments are not adopting the shortcut of distributing freebies’. Within three years BJP-led governments launched Ladli Behna (MP, 2023), Ladki Bahin (Maharashtra, 2024, coalition), Mahila Samriddhi (Delhi, 2025) and Lado Lakshmi (Haryana, 2025). PRS counts 12 UCT states across parties by 2025-26.", from: "2022-07-16", to: "2025-08-28", srcs: [["PM’s address at inauguration of Bundelkhand Expressway, Jalaun, 16 Jul 2022 — official English rendering (pmindia.gov.in)","https://www.pmindia.gov.in/en/news_updates/pms-address-at-inauguration-of-bundelkhand-expressway-at-jalaun-in-uttar-pradesh/"],["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"],["Deccan Herald, 2025-03-08 — Delhi cabinet clears ₹2,500 for women under Mahila Samriddhi Yojana","https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"],["Deccan Herald, 2025-08-28 — Haryana launches Lado Lakshmi Yojana; women to get ₹2,100 monthly","https://www.deccanherald.com/india/haryana/haryana-decides-to-implement-lado-lakshmi-yojana-eligible-women-to-get-rs-2100-monthly-aid-3700884"]], innocentReading: "The speech distinguished ‘freebies’ from houses, gas connections and toilets that it listed as ‘social justice’; the BJP's position is that targeted women's transfers are welfare, not freebies. State governments face state electorates, and every major party (INC in Karnataka/Telangana/Himachal, TMC, AAP, JMM, BJD, DMK) runs comparable schemes, so the practice is non-discriminating between parties.", upgradeIf: "A documented central-government instruction to BJP state units on cash schemes, or an RBI/Finance Commission definition under which Ladli Behna counts as a freebie", killIf: "Evidence the schemes were designed before July 2022 or by non-BJP coalition partners" },
  { id: "lit-w:c013", s: "wel:vijay-wadettiwar", t: "scheme:mh-ladki-bahin", pred: "enforce", tier: "alleged", lab: "Allegation: 92.10 lakh women removed; scheme used for electoral gains", d: "Congress leader Vijay Wadettiwar claimed on 2026-08-19 that 92.10 lakh women had been removed from Ladki Bahin and that the government had ‘used women only for electoral gains’. Figure unverified; no state data opened.", from: "2026-08-19", to: "2026-08-19", srcs: [["ThePrint, 2026-08-19 — 92.10 lakh women removed from Maharashtra govt’s Ladki Bahin scheme, claims Congress leader (Vijay Wadettiwar)","https://theprint.in/india/92-10-lakh-women-removed-from-maharashtra-govts-ladki-bahin-scheme-claims-congress-leader/3019624/"]], innocentReading: "Enrolment was opened fast before the Nov 2024 poll, with self-declared eligibility. The Model Code of Conduct delayed e-KYC. From Aug 2025, a verification drive suspended payments to non-compliant or ineligible recipients (income-tax-paying households, vehicle owners, government employees, over-65s, men). Most of the fall (~62 lakh) is people who did not finish e-KYC, whose payments are paused rather than cancelled. The fall reflects correcting a loose pre-poll roll, not punishing voters. A remaining weakness is that the loose pre-poll enrolment was itself a policy choice made before an election.", upgradeIf: "The state's own published count of beneficiaries removed after eligibility scrutiny, with reasons", killIf: "Official data showing removals far below 92 lakh or confined to documented ineligibility" },
  { id: "lit-w:c013:audit-contra", s: "scheme:mh-ladki-bahin", t: "claim:lit-w:c013", pred: "contra", tier: "reported", lab: "denial found in audit", d: "Yes. There is a direct denial, and the record leaves it out. WCD Minister Aditi Tatkare (Navbharat Live, 14 Jul 2026, https://navbharatlive.com/maharashtra/mumbai/vijay-wadettiwar-ladki-bahin-yojana-allegations-aditi-tatkare-reply-updates-1862269.html): \"सरकार ने किसी लाभार्थी को योजना से नहीं हटाया है\" ('the government has not removed any beneficiary'), and \"जिन्होंने ईकेवाईसी पूरा नहीं किया, उनका भुगतान केवल प्रक्रिया पूरी होने तक रोका गया है\" ('payment only paused until e-KYC is done'). She also said ~1.67 crore eligible women keep getting paid, the deadline was extended to 31 Dec 2025, and e-KYC could not start earlier because of the 2024 election's Model Code of Conduct. The Logical Indian (14 Jul 2026, https://thelogicalindian.com/maharashtra-removes-people-from-ladki-bahin/) quotes Tatkare: \"There will be no mass deletion of genuine beneficiaries.\" The cited ThePrint piece also carries the government's position itself: \"The government had earlier clarified that the dropout of beneficiaries was mainly due to incomplete e-KYC and income criteria.\" So the record's line that the only contra is a general Fadnavis defence and not a denial is false.", srcs: [["Denial — navbharatlive.com","https://navbharatlive.com/maharashtra/mumbai/vijay-wadettiwar-ladki-bahin-yojana-allegations-aditi-tatkare-reply-updates-1862269.html"]] },
  { id: "lit-w:c014", s: "wel:devendra-fadnavis", t: "claim:lit-w:c013", pred: "contra", tier: "reported", lab: "Fadnavis: promises fulfilled, scheme will continue", d: "Chief Minister Fadnavis said on 2026-08-14 that the government had fulfilled all promises made during the 2024 polls and would not discontinue Ladki Bahin. Note: the statement pre-dates Wadettiwar's 2026-08-19 claim by five days and does not address the 92.10 lakh figure — a general defence, not a point-by-point denial.", from: "2026-08-14", to: "2026-08-14", srcs: [["ThePrint, 2026-08-14 — Govt fulfilled promises made during 2024 polls, will not discontinue Ladki Bahin: Fadnavis","https://theprint.in/india/govt-fulfilled-promises-made-during-2024-polls-will-not-discontinue-ladki-bahin-fadnavis/3015115/"]] },
  { id: "lit-w:c015", s: "wel:aaditya-thackeray", t: "scheme:mh-ladki-bahin", pred: "enforce", tier: "alleged", lab: "Allegation: Ladki Bahin ‘more or less finished’ (April 2025)", d: "Aaditya Thackeray (Shiv Sena UBT) claimed on 2025-04-16, amid a budget row, that the scheme was ‘more or less finished’. PRS independently records an April 2025 reduction to ₹500 for overlapping beneficiaries, not a discontinuation.", from: "2025-04-16", to: "2025-04-16", srcs: [["Deccan Herald (PTI), 2025-04-16 — Ladki Bahin scheme ‘more or less finished’, claims Aaditya Thackeray","https://www.deccanherald.com/india/maharashtra/ladki-bahin-scheme-more-or-less-finished-claims-aaditya-thackeray-3496353"],["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"]], upgradeIf: "Budget documents showing the 2025-26 allocation below the run-rate of ₹1,500 × enrolled women", killIf: "Continued monthly payments of ₹1,500 to non-overlapping beneficiaries through 2025-26" },
  { id: "lit-w:c016", s: "wel:devendra-fadnavis", t: "claim:lit-w:c015", pred: "contra", tier: "reported", lab: "Fadnavis: will not discontinue Ladki Bahin", d: "Fadnavis (2026-08-14): the scheme will not be discontinued. The Bombay High Court in Aug 2024 had upheld it as a beneficiary scheme for women.", from: "2026-08-14", to: "2026-08-14", srcs: [["ThePrint, 2026-08-14 — Govt fulfilled promises made during 2024 polls, will not discontinue Ladki Bahin: Fadnavis","https://theprint.in/india/govt-fulfilled-promises-made-during-2024-polls-will-not-discontinue-ladki-bahin-fadnavis/3015115/"],["Deccan Herald, 2024-08-05 — Ladki Bahin Yojana a beneficiary scheme for women, not discriminatory: Bombay High Court","https://www.deccanherald.com/india/maharashtra/ladki-bahin-yojana-a-beneficiary-scheme-for-women-not-discriminatory-bombay-high-court-3137089"]] },
  { id: "lit-w:c017", s: "wel:eknath-shinde", t: "scheme:mh-ladki-bahin", pred: "role", tier: "reported", lab: "Shinde: ₹3,000 with a bigger mandate (2024-09-14); manifesto ₹2,100", d: "Two months before the assembly election, CM Shinde said the ₹1,500 dole would be doubled to ₹3,000 if the alliance got a bigger mandate; the Mahayuti's campaign figure reported by Lokniti was ₹2,100. Payments had begun on 2024-08-14, the eve of Independence Day.", from: "2024-08-14", to: "2024-09-14", srcs: [["Deccan Herald, 2024-09-14 — ‘Give us a bigger mandate, will double Ladki Bahin dole to ₹3,000’: Eknath Shinde","https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-give-us-a-bigger-mandate-will-double-ladki-bahin-dole-to-rs-3000-eknath-shinde-3191037"],["Lokniti-CSDS Maharashtra 2024 post-poll analysis, The Hindu, 25 Nov 2024 (Deshpande, ‘Women sided with Mahayuti for Ladki Bahin Yojana’s monthly dole’; Mishra, women as deciders) — page PDF held locally; thehindu.com unreachable from this container","https://www.lokniti.org/state-assembly-elections"],["Deccan Herald, 2024-08-15 — Shinde govt begins releasing money under Ladki Bahin Yojana on eve of Independence Day","https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"]] },
  { id: "lit-w:c018", s: "wel:devendra-fadnavis", t: "scheme:mh-ladki-bahin", pred: "role", tier: "reported", lab: "Post-election: ₹1,500 continued, cut to ₹500 for overlap; ₹2,100 not paid", d: "Under Fadnavis (CM from 2024-12-05) the benefit stayed at ₹1,500 and was reduced to ₹500 from April 2025 for women drawing ₹1,000 under the women-farmer DBT scheme; the ₹2,100 promise had not been implemented as of PRS's October 2025 report.", from: "2024-12-05", to: "2025-10-31", srcs: [["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"]] },
  { id: "lit-w:c019", s: "scheme:mh-ladki-bahin", t: "bjp", pred: "analytic", tier: "analytic", lab: "Promise-to-delivery gap: ₹2,100/₹3,000 promised, ₹1,500 (or ₹500) paid", d: "Promise inflation before the vote (₹1,500 → ₹2,100 manifesto → ₹3,000 Shinde) followed by a cut after it (₹500 for overlapping beneficiaries) is the pattern the ‘cut once won’ narrative predicts.", srcs: [["Deccan Herald, 2024-09-14 — ‘Give us a bigger mandate, will double Ladki Bahin dole to ₹3,000’: Eknath Shinde","https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-give-us-a-bigger-mandate-will-double-ladki-bahin-dole-to-rs-3000-eknath-shinde-3191037"],["Lokniti-CSDS Maharashtra 2024 post-poll analysis, The Hindu, 25 Nov 2024 (Deshpande, ‘Women sided with Mahayuti for Ladki Bahin Yojana’s monthly dole’; Mishra, women as deciders) — page PDF held locally; thehindu.com unreachable from this container","https://www.lokniti.org/state-assembly-elections"],["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"]], innocentReading: "Fiscal space: six of the 12 UCT states project revenue deficits and PRS/RBI both flag the schemes as stress; the overlap rule removes double payment to the same woman rather than cutting the base benefit; the base ₹1,500 continued and the CM says it will.", upgradeIf: "Maharashtra budget 2026-27 raising the benefit to ₹2,100, which would kill the ‘broken promise’ half; or a second cut, which would strengthen it", killIf: "Evidence the ₹2,100 was paid from a date in 2025-26" },
  { id: "lit-w:c020", s: "bombay-hc", t: "scheme:mh-ladki-bahin", pred: "enforce", tier: "reported", lab: "Bombay HC upholds Ladki Bahin as a beneficiary scheme", d: "Bombay High Court, Aug 2024: the scheme is a beneficiary scheme for women and not discriminatory (as reported; order text not opened).", from: "2024-08-05", to: "2024-08-05", srcs: [["Deccan Herald, 2024-08-05 — Ladki Bahin Yojana a beneficiary scheme for women, not discriminatory: Bombay High Court","https://www.deccanherald.com/india/maharashtra/ladki-bahin-yojana-a-beneficiary-scheme-for-women-not-discriminatory-bombay-high-court-3137089"]], upgradeIf: "Open the order on the High Court site" },
  { id: "lit-w:c021", s: "wel:kamal-nath", t: "scheme:mp-ladli-behna", pred: "role", tier: "reported", lab: "Congress counter-promise: ₹1,500/month for women (2023-03-05)", d: "Kamal Nath promised ₹18,000 a year to women if Congress won, days before the Ladli Behna launch — evidence that the bidding was two-sided.", from: "2023-03-05", to: "2023-03-05", srcs: [["Deccan Herald, 2023-03-05 — Ahead of MP govt’s Ladli Behna launch, Kamal Nath promises women ₹18,000 per year","https://www.deccanherald.com/india/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"]] },
  { id: "lit-w:c022", s: "pol:shivraj-singh-chouhan", t: "scheme:mp-ladli-behna", pred: "role", tier: "documented", lab: "Chouhan government administered Ladli Behna into the Nov 2023 election", d: "Lokniti's MP post-poll instrument asks respondents about ‘Shivraj Singh Chouhan's government’ and about Ladli Behna in the same questionnaire; Deccan Herald (2023-03-05) dates the launch to March 2023 under his government.", from: "2023-03-05", to: "2023-12-13", srcs: [["Lokniti-CSDS — Madhya Pradesh Postpoll Survey 2023: Survey Findings (N=3,050, 18–24 Nov 2023; PDF held locally; Lokniti state-election index page opened)","https://www.lokniti.org/state-assembly-elections"],["Deccan Herald, 2023-03-05 — Ahead of MP govt’s Ladli Behna launch, Kamal Nath promises women ₹18,000 per year","https://www.deccanherald.com/india/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"]] },
  { id: "lit-w:c023", s: "scheme:in-nfsa", t: "min:ministry-of-consumer-affairs-food-and-public-distribution", pred: "analytic", tier: "documented", lab: "Aadhaar in PDS: exclusion documented (Khera 2017; Drèze et al 2017)", d: "Khera (EPW 2017): Aadhaar is becoming a tool of exclusion and claimed savings often reflect denied entitlements. Drèze, Khalid, Khera & Somanchi (EPW 2017): Jharkhand field survey of ABBA in the PDS, subtitled ‘Pain without Gain?’.", srcs: [["Khera (2017) Impact of Aadhaar on Welfare Programmes — EPW 52(50), 16 Dec 2017 (EPW page opened)","https://www.epw.in/journal/2017/50/special-articles/impact-aadhaar-welfare-programmes.html"],["Drèze, Khalid, Khera & Somanchi (2017) Aadhaar and Food Security in Jharkhand: Pain without Gain? — EPW 52(50), 16 Dec 2017 (EPW page opened; full text not extracted)","https://www.epw.in/journal/2017/50/special-articles/aadhaar-and-food-security-jharkhand.html"]], innocentReading: "Some ‘exclusion’ is the removal of ghost or duplicate cards that DBT was meant to eliminate; the RCT literature (MNS 2025) is the arbiter of the net effect and was not re-read here.", upgradeIf: "Extract the Jharkhand exclusion rates from the EPW full text and the MNS REStat effect sizes", killIf: "MNS 2025 finding no exclusion cost from ABBA in the same state" },
  { id: "lit-w:c024", s: "scheme:ap-smartcards-nregs-ssp", t: "scheme:mgnrega", pred: "analytic", tier: "reported", lab: "AP smartcards RCT: faster, less corrupt payments without more exclusion", d: "Muralidharan, Niehaus & Sukhtankar (AER 2016): biometric smartcards for NREGS and pension payments in Andhra Pradesh — the strongest evidence that payment-system reform reduces leakage; effect sizes not re-read in this sweep.", srcs: [["Muralidharan, Niehaus & Sukhtankar (2016) Building State Capacity: Evidence from Biometric Smartcards in India — AER 106(10):2895–2929 (Crossref metadata)","https://api.crossref.org/works/10.1257/aer.20141346"]], innocentReading: "AP's reform bundled biometrics with a new last-mile payment network; the leakage effect need not transfer to Aadhaar-only authentication in the PDS.", upgradeIf: "Quote the abstract's effect sizes", killIf: "A failed replication in another state" },
  { id: "lit-w:c025", s: "scheme:br-balika-cycle", t: "min:ministry-of-education", pred: "analytic", tier: "reported", lab: "Bihar cycle scheme raised girls’ secondary enrolment (Muralidharan & Prakash 2017)", d: "Muralidharan & Prakash (AEJ: Applied 2017): Bihar's 2006 bicycle programme for girls entering class 9 increased girls' enrolment and reduced the gender gap, most where schools were distant — a ‘distribution’ scheme with a rigorous positive evaluation.", srcs: [["Muralidharan & Prakash (2017) Cycling to School: Increasing Secondary School Enrollment for Girls in India — AEJ: Applied 9(3):321–350 (Crossref metadata)","https://api.crossref.org/works/10.1257/app.20160004"]], innocentReading: "Effects on enrolment do not establish effects on learning or on votes; the paper does not study the JD(U)'s electoral returns.", upgradeIf: "Quote effect sizes from the paper", killIf: "A re-analysis reversing the enrolment effect" },
  { id: "lit-w:c026", s: "wel:dbt-mission", t: "scheme:in-nfsa", pred: "analytic", tier: "documented", lab: "DBT portal ‘Estimated Gains’ ₹5,14,201.92 cr is self-reported", d: "DBT Bharat (2026-09-25): cumulative transfers ₹53,45,314 crore; ‘Estimated Gains’ ₹5,14,201.92 crore, labelled as estimated. Khera (2017) argues such savings claims lack credibility because they count denied entitlements as savings. No CAG audit of the aggregate gains figure was opened.", srcs: [["DBT Bharat portal — headline figures as displayed 2026-09-25","https://dbtbharat.gov.in/"],["Khera (2017) Impact of Aadhaar on Welfare Programmes — EPW 52(50), 16 Dec 2017 (EPW page opened)","https://www.epw.in/journal/2017/50/special-articles/impact-aadhaar-welfare-programmes.html"]], innocentReading: "Ministries compute gains as ghost/duplicate beneficiaries removed × benefit; some of that is genuine leakage removed.", upgradeIf: "A CAG or NITI evaluation of the methodology behind the gains figure", killIf: "An audited reconciliation of the ₹5.14 lakh crore" },
  { id: "mahilarozgar-alleged-bribe", s: "party:inc", t: "scheme:br-mahila-rozgar-yojana", pred: "enforce", tier: "alleged", lab: "opposition parties in Bihar characterised the ₹10,000 transfer, disbursed six weeks before polling to over a crore women, as a pre-poll inducement and questioned ECI neutrality in allowing it", d: "Alleged by opposition/INDIA-bloc commentary during the 2025 Bihar campaign", srcs: [["The Federal — Bihar pre-poll cash push sparks concerns over ECI neutrality","https://thefederal.com/category/elections-2025/pre-poll-cash-transfers-in-bihar-raise-concerns-over-voter-influence-eci-neutrality-214703"]], innocentReading: "The Bihar cabinet approved the scheme on 29 Aug 2025 as seed money for women's self-employment, run through the Rural Development Department's SHG network. The first tranches (26 Sep, 3 Oct, 6 Oct) went out before the MCC took effect. The ECI's position, via anonymous sources, is that an ongoing scheme that started before the MCC may continue. Welfare schemes arriving late in a term, when fiscal space allows and before polls, are the norm across parties (8/8 in this file). What remains a real anomaly is the payouts on Oct 17/24/31 under an active MCC, publicised by Amit Shah and Deputy CM Samrat Choudhary at rallies." },
  { id: "sco:c001", s: "wel:k-chandrashekar-rao", t: "scheme:tg-rythu-bandhu", pred: "role", tier: "documented", lab: "announced Rythu Bandhu", d: "Rs 4,000/acre per season, Rs 12,000 cr, announced 25 Feb 2018 at Rythu Samanvaya Samiti conference.", from: "2018-02-25", srcs: [["Business Standard/ANI, 26 Feb 2018: KCR govt to allocate Rs 12,000 cr for crop investment support","https://www.business-standard.com/article/news-ani/kcr-govt-to-allocate-rs-12-000-cr-for-crop-investment-support-118022600048_1.html"]] },
  { id: "sco:c002", s: "scheme:tg-rythu-bandhu", t: "wel:class-tg-landowning-farmers", pred: "pmout", tier: "documented", lab: "Rs 12,000 cr FY2018-19; Rs 11,704 cr FY2023-24", d: "Per-acre uncapped input support; 58.33 lakh farmers.", from: "2018-05-10", srcs: [["PRS, Telangana Budget Analysis 2018-19","https://prsindia.org/budgets/states/telangana-budget-analysis-2018-19"],["PRS, Telangana Budget Analysis 2023-24","https://prsindia.org/budgets/states/telangana-budget-analysis-2023-24"],["Wikipedia (pointer): Rythu Bandhu scheme","https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"]] },
  { id: "sco:c003", s: "scheme:tg-rythu-bandhu", t: "party:brs", pred: "analytic", tier: "analytic", lab: "launched 7 months before poll; incumbent +25 seats", d: "First cheques 10 May 2018; poll 7 Dec 2018; TRS 88/119, 46.9%.", from: "2018-05-10", to: "2018-12-07", srcs: [["Wikipedia (pointer): Rythu Bandhu scheme","https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"],["Wikipedia infobox (pointer to ECI): 2018 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Telangana_Legislative_Assembly_election"]], innocentReading: "The scheme was a budget item for Kharif 2018 in a fixed-term state; it then ran 66 months into a defeat in Nov 2023, so its presence does not discriminate winners from losers.", upgradeIf: "A Lokniti cross-tab of vote by Rythu Bandhu receipt with a landless/tenant control", killIf: "Beneficiary and non-beneficiary vote shares for TRS indistinguishable" },
  { id: "sco:c004", s: "wel:igidr", t: "scheme:tg-rythu-bandhu", pred: "enforce", tier: "documented", lab: "IGIDR: tenants excluded, budget shortfall unexplained", d: "Field study 2019-20: entitlement is 10% of small-farmer annual spend; 2019-20 provision Rs 9,056 cr vs ~Rs 15,000 cr implied; no grievance forum.", from: "2020-04", srcs: [["Thomas, Uday & Zaveri (IGIDR/IFROGS), 'Linking welfare distribution to land records: a case-study of the Rythu Bandhu Scheme', TR-2020-4-27 (PDF)","https://ifrogs.org/PDF/rbs_report.pdf"]] },
  { id: "sco:c005", s: "cag", t: "scheme:tg-aasara-pensions", pred: "enforce", tier: "documented", lab: "CAG: Rs 67.41 cr undue Aasara pension to >7.5-acre households found via Rythu Bandhu data", d: "12,152 persons; plus Rs 1,150.71 cr to 3–7.5 acre households unresolved; Rs 1,175 cr to 2.02 lakh already flagged for exclusion.", from: "2018-04", to: "2021-03", srcs: [["CAG, Performance Audit of DBT scheme 'Aasara Pensions in Telangana' (2021), Chapter III (PDF)","https://cag.gov.in/uploads/download_audit_report/2021/Chapter-III-Implementation-of-Aasara-Pensions-as-a-DBT-Scheme-065cdb90dd72180.15791130.pdf"]] },
  { id: "sco:c006", s: "wel:revanth-reddy", t: "scheme:tg-rythu-bandhu", pred: "enforce", tier: "alleged", lab: "CM: Rs 22,600 cr of Rs 72,816 cr went to non-cultivated land", d: "Assembly statement 21 Dec 2024 citing a government estimate: hillocks, roads, mining areas, stone crushers were paid per acre.", from: "2024-12-21", srcs: [["Deccan Herald/PTI, 21 Dec 2024: Rythu Bandhu Rs 22,600 cr given to ineligible people in BRS regime, says Telangana CM","https://www.deccanherald.com/india/telangana/rythu-bandhu-rs-22600-crore-given-to-ineligible-people-in-brs-regime-says-telangana-cm-3328152"]], innocentReading: "Under BRS rules, the land was not \"ineligible\". All pattadar land on the purified records qualified per acre, and paying hillock, road or crusher survey numbers was the known cost of choosing a land-record test over a cultivation test. The Rs 22,600 cr figure is a rough estimate (no method published) that applies the Congress government's new 2025 cultivable-land criterion backwards, to explain why the replacement scheme covers less. Payments on non-cultivated land are consistent with a design choice and poor land records. They do not require fraud or diversion.", upgradeIf: "A CAG or Agriculture Department report quantifying payments on non-agricultural survey numbers", killIf: "Department data showing the non-cultivable share of paid acreage is small" },
  { id: "sco:c007", s: "wel:kt-rama-rao", t: "claim:sco:c006", pred: "contra", tier: "reported", lab: "KTR: Congress evading implementation", d: "BRS working president replied that the Congress government was trying to evade implementing the farmer scheme and its Rs 15,000/acre promise.", from: "2024-12-21", srcs: [["Deccan Herald/PTI, 21 Dec 2024: Rythu Bandhu Rs 22,600 cr given to ineligible people in BRS regime, says Telangana CM","https://www.deccanherald.com/india/telangana/rythu-bandhu-rs-22600-crore-given-to-ineligible-people-in-brs-regime-says-telangana-cm-3328152"]] },
  { id: "sco:c008", s: "scheme:tg-rythu-bandhu", t: "scheme:tg-rythu-bandhu", pred: "supersede", tier: "documented", lab: "renamed Rythu Bharosa, Rs 12,000/acre, non-agricultural land excluded", d: "Cabinet 4 Jan 2025; launch 26 Jan 2025; landless get Rs 12,000 under Indiramma Atmiya Bharosa.", from: "2025-01-26", srcs: [["ANI, 5 Jan 2025: Telangana farmers to receive Rs 12,000 per acre annually under Rythu Bharosa","https://www.aninews.in/news/national/general-news/telangana-farmers-to-receive-rs-12000-per-acre-annually-under-rythu-bharosa-scheme20250105033356/"]] },
  { id: "sco:c009", s: "wel:k-chandrashekar-rao", t: "scheme:tg-aasara-pensions", pred: "role", tier: "reported", lab: "launched Aasara pensions", d: "8 Nov 2014; Rs 1,000/Rs 1,500 per month.", from: "2014-11-08", srcs: [["Wikipedia (pointer): Aasara pension","https://en.wikipedia.org/wiki/Aasara_pension"]] },
  { id: "sco:c010", s: "cag", t: "scheme:tg-aasara-pensions", pred: "enforce", tier: "documented", lab: "CAG: Rs 535 cr irregular sanctions; 16% ineligible per SKS", d: "Performance audit 2018-21: irregular sanctions Rs 535.39 cr; Rs 51.98 cr to four-wheeler owners; Rs 0.90 cr to the dead; 9% biometric failure.", from: "2021", srcs: [["CAG, Performance Audit of DBT scheme 'Aasara Pensions in Telangana' (2021), Chapter III (PDF)","https://cag.gov.in/uploads/download_audit_report/2021/Chapter-III-Implementation-of-Aasara-Pensions-as-a-DBT-Scheme-065cdb90dd72180.15791130.pdf"]] },
  { id: "sco:c011", s: "wel:revanth-reddy", t: "scheme:tg-crop-loan-waiver-2024", pred: "role", tier: "documented", lab: "launched Rs 2 lakh crop loan waiver phase 1", d: "Rs 6,000+ cr to 11 lakh farmers, 18 Jul 2024 (AIR).", from: "2024-07-18", srcs: [["News On Air (AIR), 18 Jul 2024: Over Rs 6,000 cr released towards crop loan waiver; 11 lakh farmers in phase 1","https://www.newsonair.gov.in/telangana-over-rs-6000-cr-released-by-state-govt-towards-crop-loan-waiver/"],["News On Air (AIR), 17 Jul 2024: Telangana to implement crop loan waiver from tomorrow","https://www.newsonair.gov.in/telangana-to-implement-crop-loan-waiver-from-tomorrow-onwards"]] },
  { id: "sco:c012", s: "scheme:tg-crop-loan-waiver-2024", t: "party:inc", pred: "analytic", tier: "analytic", lab: "post-poll delivery, 7.5 months after taking office", d: "Promise in the Nov 2023 campaign; first tranche 18 Jul 2024; Rs 15,470 cr budgeted 2024-25.", from: "2023-11-30", to: "2024-07-18", srcs: [["Wikipedia infobox (pointer to ECI): 2023 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"],["PRS, Telangana Budget Analysis 2024-25","https://prsindia.org/budgets/states/telangana-budget-analysis-2024-25"]], innocentReading: "Honouring a manifesto pledge after winning; the ration-card gate is a standard family-unit definition.", upgradeIf: "Final count of farmers paid vs the 40 lakh target", killIf: "n/a — no wrongdoing implied" },
  { id: "sco:c013", s: "wel:ys-jagan-mohan-reddy", t: "scheme:ap-ysr-rythu-bharosa", pred: "role", tier: "reported", lab: "announced YSR Rythu Bharosa", d: "Rs 13,500/yr from Oct 2019 (fleet file pointer).", from: "2019-10-15", srcs: [["Govt Schemes India — YSR Rythu Bharosa: launched 15 Oct 2019; ₹13,500/yr per farmer family (₹7,500 state + ₹6,000 PM-KISAN)","https://www.govtschemes.in/ysr-rythu-bharosa-scheme"],["YSR Congress Party — YSR Rythu Bharosa: all you need to know (party source; launch 15 Oct at Kakaturu, Nellore; ₹13,500 incl. ₹6,000 PM-KISAN)","https://www.ysrcongress.com/special-news/ysr-rythu-bharosa-all-you-need-69738"]] },
  { id: "sco:c014", s: "scheme:ap-ysr-rythu-bharosa", t: "party:ysrcp", pred: "analytic", tier: "analytic", lab: "live 55 months; incumbent lost 151→11", d: "DBT saturation (\"nearly everyone avails\") did not prevent a rout.", from: "2019-10-15", to: "2024-05-13", srcs: [["The Print, 18 Apr 2024: As Jagan banks on direct benefit schemes in AP, voters split","https://theprint.in/politics/as-jagan-banks-on-direct-benefit-schemes-in-ap-voters-split-anxiety-over-jobs-cost-of-living/2046063/"],["Wikipedia infobox (pointer to ECI): 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"]], innocentReading: "Cash transfers were popular but jobs, cost of living and capital-outlay collapse (Rs 7,245 cr of Rs 30,678 cr in 2022-23) dominated; the scheme neither bought nor lost the election.", upgradeIf: "Lokniti AP 2024 post-poll cross-tab by DBT receipt", killIf: "n/a" },
  { id: "sco:c015", s: "scheme:ap-ysr-rythu-bharosa", t: "scheme:ap-ysr-rythu-bharosa", pred: "supersede", tier: "documented", lab: "Annadata Sukhibhava replaces Rythu Bharosa", d: "Rs 1,000 cr in 2024-25 BE under the TDP-led government.", from: "2024-06", srcs: [["PRS, Andhra Pradesh Budget Analysis 2024-25","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2024-25"]] },
  { id: "sco:c016", s: "scheme:ap-ysr-pension-kanuka", t: "wel:class-ap-pensioners", pred: "pmout", tier: "documented", lab: "Rs 16,000 cr FY2020-21; Rs 21,434 cr FY2023-24", d: "Largest single YSR DBT head in opened budgets.", from: "2020-04", srcs: [["PRS, Andhra Pradesh Budget Analysis 2020-21","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2020-21"],["PRS, Andhra Pradesh Budget Analysis 2023-24","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2023-24"]] },
  { id: "sco:c017", s: "scheme:ap-ysr-amma-vodi", t: "wel:class-ap-school-mothers", pred: "pmout", tier: "documented", lab: "Rs 6,000 cr FY2020-21", d: "Alongside Rs 3,009 cr Vidya Deevena.", from: "2020-04", srcs: [["PRS, Andhra Pradesh Budget Analysis 2020-21","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2020-21"]] },
  { id: "sco:c018", s: "wel:naveen-patnaik", t: "scheme:or-kalia", pred: "role", tier: "documented", lab: "approved KALIA (cabinet memorandum 21 Dec 2018)", d: "Cabinet Memorandum No 23029 dated 21/12/2018; Rs 10,310 cr for 2018-21.", from: "2018-12-21", srcs: [["CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)","https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"]] },
  { id: "sco:c019", s: "scheme:or-kalia", t: "wel:class-or-small-farmers-landless", pred: "pmout", tier: "documented", lab: "Rs 2,552.65 cr first instalment to 51.05 lakh, Jan–May 2019; Rs 6,444.30 cr to 65.64 lakh by 2021", d: "Per KALIA database (CAG).", from: "2019-01", to: "2021-03", srcs: [["CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)","https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"]] },
  { id: "sco:c020", s: "scheme:or-kalia", t: "party:bjd", pred: "analytic", tier: "analytic", lab: "cash paid 3 months before poll; incumbent −5 seats", d: "Cabinet 21 Dec 2018, first cash Jan 2019, poll 11 Apr 2019; BJD 112/147, BJP +13.", from: "2019-01", to: "2019-04-11", srcs: [["CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)","https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"],["Wikipedia infobox (pointer to ECI): 2019 Odisha Legislative Assembly election","https://en.wikipedia.org/wiki/2019_Odisha_Legislative_Assembly_election"]], innocentReading: "Rabi-season timing; the audit describes over-inclusion from missing khata/plot data, not targeting of voters; BJD lost seats anyway and lost the state five years later.", upgradeIf: "A study of KALIA receipt vs BJD vote at panchayat level", killIf: "No vote gap between paid and unpaid eligible households" },
  { id: "sco:c021", s: "cag", t: "scheme:or-kalia", pred: "enforce", tier: "documented", lab: "CAG: Rs 782.26 cr to 12.72 lakh ineligible; Rs 107.64 cr to wrong-name accounts", d: "Report No 2 of 2024: 9.76 lakh ineligible found by government plus 2.96 lakh by audit; Bhulekh not used; only 2 of 6 components implemented; 3 of 5 instalments paid.", from: "2019-01", to: "2021-03", srcs: [["CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)","https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"],["Business Standard/PTI, 12 Sep 2024: Rs 782.2 cr given to 12.2 lakh ineligible beneficiaries under KALIA: CAG","https://www.business-standard.com/india-news/rs-782-2-cr-given-to-12-2l-ineligible-beneficiaries-under-kalia-scheme-cag-124091200419_1.html"]] },
  { id: "sco:c022", s: "party:bjd", t: "claim:sco:c021", pred: "contra", tier: "documented", lab: "government response: lists published, refunds sought, committees formed", d: "Aug–Sep 2019: beneficiary lists on panchayat walls, voluntary refund appeals, 3.41 lakh ineligible identified, three-tier committees; replies incorporated at the 18 May 2022 exit conference.", from: "2019-08", to: "2022-05", srcs: [["Business Standard/PTI, 6 Aug 2019: Ineligible beneficiaries refund KALIA assistance: Odisha govt","https://www.business-standard.com/article/pti-stories/ineligible-beneficiaries-refund-kalia-assistance-odisha-govt-119080601520_1.html"],["ANI, 18 Sep 2019: Odisha: 3.41 lakh ineligible beneficiaries identified under KALIA","https://www.aninews.in/news/national/general-news/odisha-341lakh-ineligible-beneficiaries-identified-under-kalia-scheme20190918023936/"],["CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)","https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"]] },
  { id: "sco:c023", s: "scheme:or-kalia", t: "scheme:or-kalia", pred: "supersede", tier: "documented", lab: "KALIA superseded by Samrudha Krushak / CM-Kisan (BJP)", d: "Rs 5,000 cr in 2024-25 BE; PRS notes subsidy spending +107% due to it.", from: "2024-07", srcs: [["PRS, Odisha Budget Analysis 2024-25","https://prsindia.org/budgets/states/odisha-budget-analysis-2024-25"]] },
  { id: "sco:c024", s: "wel:bhupesh-baghel", t: "scheme:ct-farm-loan-waiver-2018", pred: "role", tier: "documented", lab: "approved Rs 6,100 cr waiver on day one", d: "17 Dec 2018; ~16.6 lakh farmers; Rs 8,800 cr for ~18 lakh by May 2020.", from: "2018-12-17", srcs: [["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"],["National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21","https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"]] },
  { id: "sco:c025", s: "wel:bhupesh-baghel", t: "scheme:ct-rajiv-gandhi-kisan-nyay", pred: "role", tier: "documented", lab: "launched RGKNY", d: "21 May 2020; Rs 5,100 cr 2020-21; ~20 lakh farmers.", from: "2020-05-21", srcs: [["National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21","https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"],["PRS, Chhattisgarh Budget Analysis 2020-21","https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2020-21"]] },
  { id: "sco:c026", s: "scheme:ct-rajiv-gandhi-kisan-nyay", t: "party:inc", pred: "analytic", tier: "analytic", lab: "live 41 months; incumbent lost 68→35", d: "INC lost to BJP (54/90) with the per-acre bonus running.", from: "2020-05-21", to: "2023-11-07", srcs: [["Wikipedia infobox (pointer to ECI): 2023 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"]], innocentReading: "Mid-term rural stimulus; the BJP outbid with a higher paddy price promise.", upgradeIf: "Lokniti CT 2023 cross-tab", killIf: "n/a" },
  { id: "sco:c027", s: "wel:raman-singh", t: "scheme:ct-cheap-rice-2007", pred: "role", tier: "reported", lab: "ran Rs 1–2/kg rice; \"Chaur wale baba\"", d: "Antyodaya Rs 1/kg, BPL Rs 2/kg by 2013; 2013 manifesto Rs 1/kg for all.", from: "2007", srcs: [["Business Standard, 13 Nov 2013: Politics over rice in Chhattisgarh","https://www.business-standard.com/article/politics/politics-over-rice-in-chhattisgarh-113111300355_1.html"]] },
  { id: "sco:c028", s: "scheme:ct-cheap-rice-2007", t: "bjp", pred: "analytic", tier: "analytic", lab: "rice the declared battleground; incumbent won 49–39", d: "Both parties bid on rice in Nov 2013; BJP 41.0% vs INC 40.3%.", from: "2013-11-11", srcs: [["Business Standard, 13 Nov 2013: Politics over rice in Chhattisgarh","https://www.business-standard.com/article/politics/politics-over-rice-in-chhattisgarh-113111300355_1.html"],["Wikipedia infobox (pointer to ECI): 2013 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2013_Chhattisgarh_Legislative_Assembly_election"]], innocentReading: "PDS reform and cheap rice were popular on the merits; the same scheme preceded the 2018 loss.", upgradeIf: "Constituency swing vs PDS coverage", killIf: "n/a" },
  { id: "sco:c029", s: "wel:siddaramaiah", t: "scheme:ka-five-guarantees-2023", pred: "role", tier: "reported", lab: "cabinet approved five guarantees at first meeting", d: "20 May 2023; Congress estimate Rs 45,000 cr/yr; PRS Rs 52,000 cr.", from: "2023-05-20", srcs: [["Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting","https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"],["PRS, Karnataka Budget Analysis 2023-24","https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"]] },
  { id: "sco:c030", s: "scheme:ka-five-guarantees-2023", t: "wel:class-ka-households", pred: "pmout", tier: "documented", lab: "Rs 39,825 cr (Jul–Mar 2023-24, 16% of revenue expenditure); Rs 52,525 cr spent 2024-25; Rs 51,034 cr BE 2025-26", d: "Bundle outlay.", from: "2023-07", srcs: [["PRS, Karnataka Budget Analysis 2023-24","https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"],["Deccan Herald, 26 Mar 2026: Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG","https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"],["The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget","https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"]] },
  { id: "sco:c031", s: "cag", t: "scheme:ka-five-guarantees-2023", pred: "enforce", tier: "documented", lab: "CAG: guarantees turned revenue surplus into deficit; \"loop of indebtedness\"; nutrition and rural development cut", d: "State finances 2024-25 tabled 26 Mar 2026; net market borrowing Rs 71,525 cr; 62.12% of borrowing for development.", from: "2026-03-26", srcs: [["Deccan Herald, 26 Mar 2026: Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG","https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"]] },
  { id: "sco:c032", s: "wel:h-m-revanna", t: "claim:sco:c031", pred: "contra", tier: "reported", lab: "GIA chair: CAG conclusions \"far from the truth\"", d: "Per-capita income and GST up; Rs 94,177 cr spent; 98% implemented (25 Aug 2025, answering the Aug 2025 CAG report; the Mar 2026 report repeats the finding).", from: "2025-08-25", srcs: [["Deccan Herald, 26 Aug 2025: CAG report's conclusions on welfare schemes in Karnataka incorrect: H M Revanna","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"]] },
  { id: "sco:c033", s: "scheme:ka-five-guarantees-2023", t: "party:inc", pred: "analytic", tier: "analytic", lab: "promised pre-poll, delivered post-poll (1–8 months)", d: "Challenger won 135/224; guarantees were a manifesto at the vote and a Rs 52,000 cr/yr programme after.", from: "2023-05-10", to: "2024-01", srcs: [["Wikipedia infobox (pointer to ECI): 2023 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"],["Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting","https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"]], innocentReading: "Delivering a manifesto is the normal democratic sequence; the fiscal cost is the issue CAG raises, not vote-buying.", upgradeIf: "Lokniti KA 2023 cross-tab by guarantee-eligibility", killIf: "n/a" },
  { id: "sco:c034", s: "wel:siddaramaiah", t: "wel:fci", pred: "enforce", tier: "alleged", lab: "CM: Union took a \"political decision\" to stop rice for Anna Bhagya", d: "FCI agreed on 13 Jun 2023, reversed on 14 Jun after the Union stopped OMSS sales to states.", from: "2023-06", srcs: [["The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya","https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"]], innocentReading: "In June 2023, with food inflation and El Niño worries, the Union stopped OMSS(D) sales of central-pool rice and wheat to all state governments except NE, hilly and calamity-hit states. It sent the grain to open-market e-auctions to cool prices. Karnataka's new 10 kg promise depended on buying the extra 5 kg under OMSS, so it was caught by a general rule. FCI's agreement of 13 Jun was overtaken by the ministry order the next day. Once stocks were comfortable and OMSS pricing for states was set (Rs 22.5/kg until June 2025), Karnataka could buy again.", upgradeIf: "Ministry file notings showing Karnataka-specific intent", killIf: "OMSS discontinuation applied uniformly to all states with the stated exceptions — which is what the Union said" },
  { id: "sco:c035", s: "wel:fci", t: "claim:sco:c034", pred: "contra", tier: "documented", lab: "Union: nationwide OMSS discontinuation with NE/hilly/calamity exceptions", d: "Rice later sold to Karnataka at Rs 22.5/kg from Feb 2025 on Union minister Joshi's approval.", from: "2023-06", to: "2025-02", srcs: [["The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya","https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"],["Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024","https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"]] },
  { id: "sco:c036", s: "scheme:ka-anna-bhagya-2023", t: "wel:class-ka-bpl-members", pred: "pmout", tier: "documented", lab: "Rs 170/person/month DBT; Rs 10,452 cr Jul 2023–Oct 2024", d: "4.12 crore beneficiaries in Oct 2024 (Rs 676.79 cr).", from: "2023-07-01", to: "2025-01", srcs: [["Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024","https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"]] },
  { id: "sco:c037", s: "scheme:ka-anna-bhagya-2023", t: "wel:fci", pred: "award", tier: "documented", lab: "Karnataka buys rice from FCI at Rs 22.5/kg (Feb–Jun 2025)", d: "Replaces cash with 5 kg rice; saves Rs 150–190 cr/month.", from: "2025-02", srcs: [["Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024","https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"]] },
  { id: "sco:c038", s: "pol:hd-kumaraswamy", t: "scheme:ka-farm-loan-waiver-2018", pred: "role", tier: "documented", lab: "presented Rs 34,000 cr waiver budget", d: "5 Jul 2018; Rs 2 lakh/family; cooperative loans first; funded partly by fuel/liquor/power tariff hikes.", from: "2018-07-05", srcs: [["The Tribune/IANS, 5 Jul 2018: Karnataka waives Rs 34,000 cr farm loans","https://www.tribuneindia.com/news/archive/nation/karnataka-waives-rs-34-000-cr-farm-loans-615599"]] },
  { id: "sco:c039", s: "scheme:ka-farm-loan-waiver-2018", t: "wel:class-ka-farmers", pred: "pmout", tier: "reported", lab: "Rs 232 cr still pending in Jan 2024; 13,334 of 30,733 unpaid", d: "17.5 lakh eligible after 1.57 lakh rejections.", from: "2018-07", to: "2024-01", srcs: [["Deccan Herald, 7 Jan 2024: Karnataka farmers in quicksand as govt continues to borrow time over loan waiver","https://www.deccanherald.com/india/karnataka/karnataka-farmers-in-quicksand-as-govt-continues-to-borrow-time-over-loan-waiver-2838441"]] },
  { id: "sco:c040", s: "wel:arvind-kejriwal", t: "scheme:dl-free-power-200-units", pred: "role", tier: "documented", lab: "announced 200 units free", d: "1 Aug 2019; 50% on 201–400.", from: "2019-08-01", srcs: [["Business Today, 1 Aug 2019: Kejriwal announces free electricity up to 200 units","https://www.businesstoday.in/latest/economy-politics/story/arvind-kejriwal-free-electricity-up-to-200-units-delhi-from-august-220915-2019-08-01"]] },
  { id: "sco:c041", s: "scheme:dl-free-power-200-units", t: "wel:class-dl-domestic-consumers", pred: "pmout", tier: "documented", lab: "Rs 1,720 cr (2019-20), Rs 2,820 cr (2020-21), Rs 3,250 cr (2023-24) subsidy through DISCOMs", d: "Budget lines.", from: "2019-04", srcs: [["PRS, Delhi Budget Analysis 2019-20","https://prsindia.org/budgets/states/delhi-budget-analysis-2019-20"],["PRS, Delhi Budget Analysis 2020-21","https://prsindia.org/budgets/states/delhi-budget-analysis-2020-21"],["PRS, Delhi Budget Analysis 2023-24","https://prsindia.org/budgets/states/delhi-budget-analysis-2023-24"]] },
  { id: "sco:c042", s: "scheme:dl-free-power-200-units", t: "party:aap", pred: "analytic", tier: "analytic", lab: "launched 6 months before poll; incumbent 62/70", d: "Then lost 2025 with the scheme live; BJP kept it.", from: "2019-08-01", to: "2020-02-08", srcs: [["Wikipedia infobox (pointer to ECI): 2020 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2020_Delhi_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2025 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"],["Business Standard/ANI, 15 Apr 2025: Power subsidy for Delhi homes, farmers, lawyers, riot victims to continue (BJP govt)","https://www.business-standard.com/india-news/power-subsidy-for-delhi-homes-farmers-lawyers-riot-victims-to-continue-125041501496_1.html"]], innocentReading: "A tariff-subsidy expansion in a budget-surplus UT; adoption by the rival party after 2025 suggests it is treated as welfare, not a partisan bribe.", upgradeIf: "Lokniti Delhi 2020/2025 cross-tab by zero-bill status", killIf: "n/a" },
  { id: "sco:c043", s: "wel:ashish-sood", t: "scheme:dl-free-power-200-units", pred: "role", tier: "reported", lab: "BJP cabinet continued the subsidy", d: "15 Apr 2025: domestic consumers, farmers, 1984 riot victims, lawyers.", from: "2025-04-15", srcs: [["Business Standard/ANI, 15 Apr 2025: Power subsidy for Delhi homes, farmers, lawyers, riot victims to continue (BJP govt)","https://www.business-standard.com/india-news/power-subsidy-for-delhi-homes-farmers-lawyers-riot-victims-to-continue-125041501496_1.html"]] },
  { id: "sco:c044", s: "wel:bhagwant-mann", t: "scheme:pb-free-power-300-units", pred: "role", tier: "documented", lab: "300 units free from 1 Jul 2022", d: "Budget 2022-23 note.", from: "2022-07-01", srcs: [["PRS, Punjab Budget Analysis 2022-23","https://prsindia.org/budgets/states/punjab-budget-analysis-2022-23"]] },
  { id: "sco:c045", s: "scheme:pb-free-power-300-units", t: "wel:class-pb-domestic-consumers", pred: "pmout", tier: "documented", lab: "Rs 7,780 cr (2024-25) domestic free power; total power subsidy Rs 20,200 cr = 19% of revenue receipts", d: "PRS 2024-25; 2021-22 Rs 13,443 cr (17%).", from: "2024-04", srcs: [["PRS, Punjab Budget Analysis 2024-25","https://prsindia.org/budgets/states/punjab-budget-analysis-2024-25"]] },
  { id: "sco:c046", s: "wel:amarinder-singh", t: "scheme:pb-farm-loan-waiver-2017", pred: "role", tier: "documented", lab: "announced Rs 2 lakh waiver for ≤5-acre farmers", d: "19 Jun 2017 in the Assembly; 10.25 lakh farmers; \"double UP and Maharashtra\".", from: "2017-06-19", srcs: [["Business Standard, 19 Jun 2017: Punjab CM Amarinder Singh announces crop loan waiver for 10.25 lakh farmers","https://www.business-standard.com/article/economy-policy/punjab-cm-amarinder-singh-announces-crop-loan-waiver-for-10-25-lakh-farmers-117061901226_1.html"]] },
  { id: "sco:c047", s: "wel:yogi-adityanath", t: "scheme:up-farm-loan-waiver-2017", pred: "role", tier: "documented", lab: "first cabinet waived Rs 36,000 cr", d: "4 Apr 2017; Rs 36,000 cr in 2017-18 budget.", from: "2017-04-04", srcs: [["Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'","https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"],["PRS, Uttar Pradesh Budget Analysis 2017-18","https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2017-18"]] },
  { id: "sco:c048", s: "party:inc", t: "scheme:up-farm-loan-waiver-2017", pred: "enforce", tier: "alleged", lab: "Congress: \"half truth\" — Rs 36,000 cr of Rs 92,241 cr; corporates got Rs 1.4 lakh cr", d: "Surjewala, 4 Apr 2017.", from: "2017-04-04", srcs: [["Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'","https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"]], upgradeIf: "CAG/RBI data on UP crop vs term loan stock in 2017", killIf: "Manifesto text limited the promise to crop loans of small/marginal farmers" },
  { id: "sco:c049", s: "bjp", t: "claim:sco:c048", pred: "contra", tier: "reported", lab: "BJP: the manifesto promise (small/marginal crop loans) was delivered in 17 days", d: "Innocent reading recorded as the government's position; explicit rebuttal text not in the opened article.", from: "2017-04-04", srcs: [["Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'","https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"]] },
  { id: "sco:c050", s: "scheme:up-farm-loan-waiver-2017", t: "bjp", pred: "analytic", tier: "analytic", lab: "post-poll delivery 17 days after CM took office", d: "Election Feb–Mar 2017; CM 18–19 Mar; cabinet 4 Apr.", from: "2017-03-19", to: "2017-04-04", srcs: [["Wikipedia (pointer): 2017 Uttar Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2017_Uttar_Pradesh_Legislative_Assembly_election"],["Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'","https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"]], innocentReading: "Fulfilling a PM-made campaign promise immediately.", killIf: "n/a" },
  { id: "sco:c051", s: "wel:devendra-fadnavis", t: "scheme:mh-farm-loan-waiver-2017", pred: "role", tier: "documented", lab: "CSMSSY GR 28 Jun 2017", d: "Rs 18,762 cr to 44.04 lakh; Rs 5,975.61 cr to 6.56 lakh accounts still due.", from: "2017-06-28", srcs: [["Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"]] },
  { id: "sco:c052", s: "scheme:mh-farm-loan-waiver-2017", t: "wel:class-mh-lending-banks", pred: "pmout", tier: "documented", lab: "Rs 13,705 cr arrears settled; Rs 2,630 cr OTS; Rs 2,427 cr incentives", d: "Official page.", from: "2017-06-28", srcs: [["Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"]] },
  { id: "sco:c053", s: "wel:uddhav-thackeray", t: "scheme:mh-farm-loan-waiver-2019", pred: "role", tier: "documented", lab: "MJPSKY GR 27 Dec 2019", d: "Rs 20,497 cr to 32.37 lakh farmers.", from: "2019-12-27", srcs: [["Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"]] },
  { id: "sco:c054", s: "scheme:mh-farm-loan-waiver-2017", t: "scheme:mh-farm-loan-waiver-2019", pred: "supersede", tier: "documented", lab: "second waiver within 30 months by the successor coalition", d: "Rs 15,000 cr (2019-20) + Rs 7,000 cr (2020-21) allocated.", from: "2019-12-27", srcs: [["Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"],["PRS, Maharashtra Budget Analysis 2020-21","https://prsindia.org/budgets/states/maharashtra-budget-analysis-2020-21"]] },
  { id: "sco:c055", s: "wel:kamal-nath", t: "scheme:mp-jai-kisan-fasal-rin-mafi-2018", pred: "role", tier: "reported", lab: "signed waiver documents on day one", d: "17 Dec 2018.", from: "2018-12-17", srcs: [["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"]] },
  { id: "sco:c056", s: "wel:ashok-gehlot", t: "scheme:rj-farm-loan-waiver-2018", pred: "role", tier: "documented", lab: "first order: full cooperative waiver + Rs 2 lakh", d: "19 Dec 2018; Rs 8,000 cr burden.", from: "2018-12-19", srcs: [["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"]] },
  { id: "sco:c057", s: "wel:vasundhara-raje", t: "scheme:rj-farm-loan-waiver-2018", pred: "role", tier: "reported", lab: "Rs 50,000 cooperative waiver 10 months before the poll (BJP)", d: "Feb 2018 budget; Rs 8,500 cr via Rs 5,000 cr NCDC loan; claimed 30 lakh farmers.", from: "2018-02", srcs: [["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"]] },
  { id: "sco:c058", s: "scheme:rj-farm-loan-waiver-2018", t: "bjp", pred: "analytic", tier: "analytic", lab: "pre-poll BJP waiver lost; post-poll INC waiver then lost in 2023", d: "Both parties, both timings, both defeats.", from: "2018-02", to: "2023-11-25", srcs: [["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"],["Wikipedia infobox (pointer to ECI): 2023 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2018 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Rajasthan_Legislative_Assembly_election"],["Deccan Herald — Rajasthan 2023: change of guard, end of Gehlot–Raje era","https://www.deccanherald.com/india/rajasthan/rajasthan-2023-change-of-guard-end-of-gehlot-raje-era-2829895"]], innocentReading: "Waivers respond to agrarian distress (Shekhawati agitation 2017) rather than to the calendar alone.", upgradeIf: "Lokniti RJ 2018 cross-tab by waiver receipt", killIf: "n/a" },
  { id: "sco:c059", s: "wel:rbi", t: "wel:state-farm-loan-waivers-2014-19", pred: "enforce", tier: "documented", lab: "RBI IWG: Rs 2.4 lakh cr waived since 2014-15, mostly near elections; avoid waivers", d: "Report of 13 Sep 2019 (PRS summary): waivers destroy credit culture and squeeze productive farm spending.", from: "2019-09-13", srcs: [["PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)","https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"]] },
  { id: "sco:c060", s: "wel:ashok-gehlot", t: "scheme:rj-chiranjeevi", pred: "role", tier: "documented", lab: "budget 2021-22: Rs 5 lakh universal health cover", d: "Rs 1,463 cr public health insurance line.", from: "2021-02-24", srcs: [["PRS, Rajasthan Budget Analysis 2021-22","https://prsindia.org/budgets/states/rajasthan-budget-analysis-2021-22"]] },
  { id: "sco:c061", s: "wel:m-karunanidhi", t: "scheme:tn-free-colour-tv-2006", pred: "role", tier: "documented", lab: "launched free colour TV scheme", d: "15 Sep 2006; Rs 750 cr first phase.", from: "2006-09-15", srcs: [["Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme","https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"]] },
  { id: "sco:c062", s: "scheme:tn-free-colour-tv-2006", t: "wel:elcot", pred: "award", tier: "reported", lab: "ELCOT procured ~15 million sets 2006–10", d: "13.2 million distributed by Sep 2010; Rs 3,687 cr per Jayalalithaa.", from: "2006-09", to: "2010-09", srcs: [["IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?","https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"]] },
  { id: "sco:c063", s: "wel:j-jayalalithaa", t: "co:sun-tv-network", pred: "enforce", tier: "alleged", lab: "Jayalalithaa: free TVs enlarged the Maran family cable base (Rs 300 cr/yr in 2006; Rs 4,000 cr/yr in 2011)", d: "Statements as LoP (Sep 2006) and CM (Jun 2011); revenue figures are hers; no audit or court finding opened.", from: "2006-09-15", to: "2011-06", srcs: [["Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme","https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"],["IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?","https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"]], innocentReading: "Any big increase in TV ownership raises cable subscriptions for whoever dominates cable distribution. In 2006 Tamil Nadu that was the Sun-linked MSO, whatever the scheme's intent. The Rs 4,000 cr/yr figure is Jayalalithaa's estimate of the whole state's annual cable subscription spend (\"The people pay Rs.4,000 crore as cable subscription every year\"). It is not an increase caused by the scheme. Procurement ran through ELCOT, a state PSU, under an all-party legislators' committee. Background, not verified this session: after the 2007 Karunanidhi–Maran split, the DMK government itself set up Arasu Cable TV Corporation to compete with the Sun group's cable operation. That fits poorly with a scheme designed to enrich the Marans.", upgradeIf: "ELCOT tender records or an audit tying set specifications/cable-readiness to a specific operator; cable-subscriber data before/after", killIf: "Cable subscription growth in TN no different from states without free TVs; TVs distributed without cable conditionality" },
  { id: "sco:c064", s: "party:dmk", t: "claim:sco:c063", pred: "contra", tier: "analytic", lab: "DMK position: manifesto welfare with a cross-party legislators' procurement committee; no adjudicated finding", d: "No explicit DMK rebuttal text was opened; recorded from the launch report (committee of legislators from all parties) and the absence of any case. The 1990s Colour TV case was against Jayalalithaa herself (acquitted 2000).", from: "2006-09-15", srcs: [["Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme","https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"],["Wikipedia (pointer): Colour TV case (1990s, J. Jayalalithaa)","https://en.wikipedia.org/wiki/Colour_TV_case"]], innocentReading: "Procurement through a state PSU with an all-party committee; cable growth would follow any TV expansion regardless of operator." },
  { id: "sco:c065", s: "scheme:tn-free-colour-tv-2006", t: "party:dmk", pred: "analytic", tier: "analytic", lab: "post-poll delivery; incumbent lost 96→23 with 16 million sets distributed", d: "Scheme in 6th phase at the 2011 poll.", from: "2006-09-15", to: "2011-04-13", srcs: [["Wikipedia infobox (pointer to ECI): 2006 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2006_Tamil_Nadu_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2011 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2011_Tamil_Nadu_Legislative_Assembly_election"],["IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?","https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"]], innocentReading: "Consumer-durable welfare with real take-up; the 2011 loss was driven by 2G and price rise, not by the TVs.", upgradeIf: "Lokniti TN 2011 cross-tab", killIf: "n/a" },
  { id: "sco:c066", s: "wel:j-jayalalithaa", t: "scheme:tn-free-mixie-grinder-fan-2011", pred: "role", tier: "reported", lab: "launched free mixie-grinder-fan", d: "Distribution from 15 Sep 2011; 80 lakh by Feb 2014.", from: "2011-09-15", srcs: [["Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women","https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"]] },
  { id: "sco:c067", s: "wel:mk-stalin", t: "scheme:tn-free-bus-women-2021", pred: "role", tier: "documented", lab: "free bus travel for women from day one", d: "7 May 2021; Rs 1,200 cr 2021-22; Rs 1,520 cr 2022-23.", from: "2021-05-07", srcs: [["The Federal, 12 Jun 2023: Free bus travel for women — Karnataka model vs TN, Delhi, Punjab","https://thefederal.com/states/south/karnataka/karnataka-introduces-free-bus-travel-for-women-a-comparison-with-other-states"],["Deccan Herald, 18 Mar 2022: Free travel — more women in Tamil Nadu now take government buses (budget 2022-23)","https://www.deccanherald.com/india/free-travel-more-women-in-tamil-nadu-now-take-government-buses-1092556.html"]] },
  { id: "sco:c068", s: "scheme:tn-free-bus-women-2021", t: "wel:tn-state-transport-undertakings", pred: "pmout", tier: "documented", lab: "Rs 1,520 cr fare-loss reimbursement 2022-23", d: "Women's passenger share 40%→61%.", from: "2022-04", srcs: [["Deccan Herald, 18 Mar 2022: Free travel — more women in Tamil Nadu now take government buses (budget 2022-23)","https://www.deccanherald.com/india/free-travel-more-women-in-tamil-nadu-now-take-government-buses-1092556.html"]] },
  { id: "sco:c069", s: "wel:nitish-kumar", t: "scheme:br-balika-cycle", pred: "role", tier: "documented", lab: "launched Balika Cycle Yojana", d: "2006; Rs 2,000 per class-IX girl; Rs 3,000 from 2019-20.", from: "2006", srcs: [["Nitish Kumar's blog, Apr 2010: Mukhyamantri Balika Cycle Yojna","http://nitishspeaks.blogspot.com/2010/04/mukhyamantri-balika-cycle-yojna.html"],["PRS, Bihar Budget Analysis 2019-20","https://prsindia.org/budgets/states/bihar-budget-analysis-2019-20"]] },
  { id: "sco:c070", s: "wel:aea-journals", t: "scheme:br-balika-cycle", pred: "enforce", tier: "documented", lab: "Muralidharan & Prakash: +32% girls' secondary enrolment, gender gap −40%", d: "Triple-difference vs boys and Jharkhand; +18% exam takers, +12% passers; distance mechanism.", from: "2017-07", srcs: [["Muralidharan & Prakash (2017), 'Cycling to School', AEJ: Applied Economics 9(3) — AEA abstract page","https://www.aeaweb.org/articles?id=10.1257/app.20160004"]] },
  { id: "sco:c071", s: "scheme:br-balika-cycle", t: "party:jdu", pred: "analytic", tier: "analytic", lab: "launched post-poll, 50 months before the next election; incumbent +27", d: "JD(U) 115, BJP 91.", from: "2006", to: "2010-10-21", srcs: [["Wikipedia infobox (pointer to ECI): 2010 Bihar Legislative Assembly election","https://en.wikipedia.org/wiki/2010_Bihar_Legislative_Assembly_election"]], innocentReading: "A conditional education transfer with a peer-reviewed causal effect; the long lag and the small amount make vote-buying the weaker reading.", killIf: "n/a" },
  { id: "sco:c072", s: "pol:shivraj-singh-chouhan", t: "scheme:mp-ladli-laxmi", pred: "role", tier: "reported", lab: "inaugurated Ladli Laxmi", d: "2 May 2007; NSCs Rs 6,000/yr × 5.", from: "2007-05-02", srcs: [["Wikipedia (pointer): Ladli Laxmi Yojana","https://en.wikipedia.org/wiki/Ladli_Laxmi_Yojana"]] },
  { id: "sco:c073", s: "wel:mamata-banerjee", t: "scheme:wb-kanyashree", pred: "role", tier: "reported", lab: "established Kanyashree", d: "8 Mar 2013; UN award Jun 2017; income cap removed Feb 2019 (52.5 lakh).", from: "2013-03-08", srcs: [["Wikipedia (pointer): Kanyashree Prakalpa","https://en.wikipedia.org/wiki/Kanyashree_Prakalpa"],["PRS, West Bengal Budget Analysis 2019-20","https://prsindia.org/budgets/states/west-bengal-budget-analysis-2019-20"]] },
  { id: "sco:c074", s: "scheme:wb-kanyashree", t: "party:tmc", pred: "analytic", tier: "analytic", lab: "universalised 26 months before the state poll (2 months before LS 2019); incumbent won", d: "TMC 215/294.", from: "2019-02", to: "2021-03-27", srcs: [["PRS, West Bengal Budget Analysis 2019-20","https://prsindia.org/budgets/states/west-bengal-budget-analysis-2019-20"],["Wikipedia infobox (pointer to ECI): 2021 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2021_West_Bengal_Legislative_Assembly_election"]], innocentReading: "Removing an income test simplifies administration of a scheme already covering most girls.", upgradeIf: "Lokniti WB 2021 cross-tab by Kanyashree household", killIf: "n/a" },
  { id: "sco:c075", s: "wel:yogi-adityanath", t: "scheme:up-kanya-sumangala-2019", pred: "role", tier: "documented", lab: "Kanya Sumangala in the 2019-20 budget", d: "Rs 1,200 cr; two months before the Lok Sabha poll.", from: "2019-02", srcs: [["PRS, Uttar Pradesh Budget Analysis 2019-20","https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2019-20"]] },
  { id: "sco:c076", s: "scheme:kl-welfare-pensions-arrears", t: "party:cpim", pred: "analytic", tier: "analytic", lab: "five months unpaid; dues paid in tranches before LS 2024 and assembly 2026; incumbent lost 99→35", d: "Two months' dues released 3 weeks before the Apr 2024 LS poll; five-instalment schedule ended in the pre-poll fiscal year.", from: "2023-04", to: "2026-04-09", srcs: [["Deccan Herald, 8 Apr 2024: As polls approach, Kerala Left govt to pay pension dues","https://www.deccanherald.com/elections/kerala/as-polls-approach-kerala-left-govt-to-pay-pension-dues-2969893"],["Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears","https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"],["Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go","https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"],["Wikipedia infobox (pointer to ECI): 2026 Kerala Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Kerala_Legislative_Assembly_election"]], innocentReading: "Real borrowing squeeze after the Centre counted KIIFB/KSSPL debt against the state limit; paying arrears when cash allows is not a bribe.", upgradeIf: "Lokniti Kerala 2026 cross-tab by pension household; monthly KSSPL cash-flow data", killIf: "Arrears timing explained by borrowing-window releases rather than the poll calendar" },
  { id: "sco:c077", s: "wel:pinarayi-vijayan", t: "min:ministry-of-finance", pred: "enforce", tier: "alleged", lab: "CM: Centre throttled Kerala — KIIFB/KSSPL loans counted as debt (Rs 12,560 cr lost), divisible share cut to 1.92%, Centre pays 2% of pensions", d: "Assembly statement 10 Jul 2024 and Jan 2025 FM office figures.", from: "2024-07-10", srcs: [["Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears","https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"],["Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go","https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"]], upgradeIf: "Finance Commission and MoF borrowing-ceiling correspondence", killIf: "n/a — a fiscal-federalism dispute, not an allegation of wrongdoing" },
  { id: "sco:c078", s: "min:ministry-of-finance", t: "claim:sco:c077", pred: "contra", tier: "analytic", lab: "Union position not opened this session; recorded as a gap", d: "The Union's stated rationale (off-budget borrowing transparency per CAG) is documented elsewhere in PRS notes on Kerala off-budget borrowing.", from: "2024-07", srcs: [["PRS, Kerala Budget Analysis 2024-25","https://prsindia.org/budgets/states/kerala-budget-analysis-2024-25"]], innocentReading: "Counting SPV debt as state debt is a uniform transparency rule flagged by CAG for Kerala." },
  { id: "sco:c079", s: "wel:kn-balagopal", t: "scheme:kl-welfare-pensions-arrears", pred: "role", tier: "reported", lab: "sanctioned Rs 1,604 cr for second arrears instalment", d: "20 Jan 2025; 62 lakh beneficiaries get Rs 3,200.", from: "2025-01-20", srcs: [["Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go","https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"]] },
  { id: "sco:c080", s: "scheme:kl-welfare-pensions-arrears", t: "wel:ksspl", pred: "pmout", tier: "documented", lab: "Rs 10,729 cr assistance to KSSPL 2024-25", d: "Off-budget SPV funding of pensions.", from: "2024-04", srcs: [["PRS, Kerala Budget Analysis 2024-25","https://prsindia.org/budgets/states/kerala-budget-analysis-2024-25"]] },
  { id: "sco:c081", s: "wel:bhupendra-patel", t: "scheme:gj-namo-laxmi-2024", pred: "role", tier: "documented", lab: "Namo Laxmi in the 2024-25 budget", d: "Rs 50,000 per girl over four years.", from: "2024-02", srcs: [["PRS, Gujarat Budget Analysis 2024-25","https://prsindia.org/budgets/states/gujarat-budget-analysis-2024-25"]] },
  { id: "sco:c082", s: "bjp", t: "wel:class-gj-farmers", pred: "pmout", tier: "documented", lab: "Rs 12,207 cr agricultural power subsidy 2024-25 (39% of Rs 31,330 cr subsidies)", d: "Gujarat runs no women's UCT (PRS SOSF) but a large farm power subsidy.", from: "2024-04", srcs: [["PRS, Gujarat Budget Analysis 2024-25","https://prsindia.org/budgets/states/gujarat-budget-analysis-2024-25"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.13-14 and subsidy section (PDF)","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "sco:c083", s: "bjp", t: "party:aap", pred: "analytic", tier: "analytic", lab: "same instrument, different label: free/subsidised power in GJ (farmers), DL and PB (households)", d: "The PM's Jul 2022 \"revdi\" speech targeted free power promises while Gujarat budgeted Rs 12,207 cr of farm power subsidy and the Delhi BJP government kept the 200-unit subsidy in 2025.", from: "2022-07-16", to: "2025-04-15", srcs: [["PRS, Gujarat Budget Analysis 2024-25","https://prsindia.org/budgets/states/gujarat-budget-analysis-2024-25"],["Business Standard/ANI, 15 Apr 2025: Power subsidy for Delhi homes, farmers, lawyers, riot victims to continue (BJP govt)","https://www.business-standard.com/india-news/power-subsidy-for-delhi-homes-farmers-lawyers-riot-victims-to-continue-125041501496_1.html"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.13-14 and subsidy section (PDF)","https://prsindia.org/files/budget/SOSF_2025.pdf"]], innocentReading: "Farm power subsidies are decades-old cross-party policy in every agrarian state; the revdi critique was about new unfunded promises.", killIf: "n/a" },
  { id: "vendors:c001", s: "wel:dbt-mission", t: "wel:npci", pred: "award", tier: "documented", lab: "APB mapper routes DBT", d: "NPCI's Aadhaar Payment Bridge maintains the Aadhaar→bank mapper on which all Aadhaar-based DBT credits are routed; PFMS pre-validates accounts with 500+ banks.", from: "2013-01-01", srcs: [["PIB backgrounder, Direct Benefit Transfer (DBT), Jan 2022","https://static.pib.gov.in/WriteReadData/specificdocs/documents/2022/jan/doc2022153101.pdf"]] },
  { id: "vendors:c002", s: "wel:fino-payments-bank", t: "scheme:dbt-apb-pfms", pred: "pmout", tier: "documented", a: 185, lab: "₹185 cr AePS/MATM revenue FY25", d: "Fino processed ₹39,704 crore through AePS/micro-ATM in FY25 and earned ₹185 crore from it; ~19 lakh merchant points; partners with UP and Bihar SRLMs' BC Sakhi/Jeevika programmes.", from: "2024-04-01", to: "2025-03-31", srcs: [["Fino Payments Bank, Annual Report 2024-25","https://www.fino.bank.in/files/fino/media/post_attachments/sites/default/files/uploads/pages/financials/annual-report-2025.pdf"]] },
  { id: "vendors:c003", s: "wel:csc-egovernance-services", t: "scheme:dbt-apb-pfms", pred: "pmout", tier: "reported", lab: "0.5% capped ₹15 per AePS withdrawal", d: "CSC SPV's DigiPay earns 0.5% of AePS withdrawal value above ₹100, capped at ₹15; says 80% is passed to VLEs; 1.44 lakh VLEs enabled (2018). Moneylife also found MCA records classing the SPV as a non-government company despite its .gov.in domain.", from: "2018-06-29", srcs: [["Moneylife, 'Is CSC e-Governance Services a govt entity or SPV or a Section 8 company?', 29 Jun 2018","https://www.moneylife.in/article/is-csc-egovernance-services-a-govt-entity-or-spv-or-a-section-8-company/54524.html"]], upgradeIf: "RTI to MeitY/CSC SPV giving annual AePS volume and commission ₹", killIf: "NPCI or CSC publishes a different fee schedule for the period" },
  { id: "vendors:c004", s: "wel:india-post-payments-bank", t: "scheme:dbt-apb-pfms", pred: "pmout", tier: "reported", a: 45000, lab: "₹45,000 cr DBT via IPPB in 7 years", d: "IPPB disbursed over ₹45,000 crore in DBT since Sep 2018; 9.88 crore accounts; 12 lakh merchants; 1.61 lakh post offices (Minister Scindia, 1 Sep 2024).", from: "2018-09-01", to: "2024-09-01", srcs: [["Free Press Journal, IPPB disbursed over ₹45,000 crore in DBT in 7 years (Scindia), 1 Sep 2024","https://www.freepressjournal.in/business/india-post-payments-bank-disbursed-over-45000-crore-in-dbt-in-last-7-years"]] },
  { id: "vendors:c005", s: "wel:uidai", t: "wel:airtel-payments-bank", pred: "enforce", tier: "reported", a: 190, lab: "₹190 cr LPG subsidy re-routed; eKYC suspended, ₹2.5 cr fine", d: "UIDAI suspended Airtel/Airtel Payments Bank's eKYC licence (16 Dec 2017) and levied a ₹2.5 crore interim penalty (18 Dec 2017) after ₹190 crore of PAHAL LPG subsidy flowed to ~31 lakh accounts opened and Aadhaar-seeded without informed consent. Media reported Airtel would return the money within 24 hours; Airtel had not publicly acknowledged at the time.", from: "2017-12-16", srcs: [["The Wire, 'Aadhaar Mess: How Airtel Pulled Off Its Rs 190 Crore Magic Trick', 21 Dec 2017","https://m.thewire.in/article/banking/airtel-aadhaar-uidai"]], innocentReading: "NPCI's APB mapper routes DBT to the most recently seeded account. When Airtel re-verified SIMs through Aadhaar eKYC and opened payments-bank accounts in the same flow, those accounts were seeded automatically and subsidy followed them by default. The money still reached the rightful LPG beneficiaries, just into an account they did not know about. That is a consent and process failure, not theft or diversion to Airtel. Airtel's gain was deposit float and account numbers, not the ₹190 crore itself.", upgradeIf: "UIDAI final order or Airtel's public statement on the reversal", killIf: "UIDAI withdrew the finding" },
  { id: "vendors:c006", s: "wel:airtel-payments-bank", t: "claim:vendors:c005", pred: "contra", tier: "reported", lab: "Airtel: money to be returned; no public admission at the time", d: "The Wire records that Airtel was 'yet to publicly confirm or acknowledge' the routing while reports said the ₹190 crore would be returned to 31 lakh subscribers within 24 hours. Recorded as the answering party's position.", from: "2017-12-21", srcs: [["The Wire, 'Aadhaar Mess: How Airtel Pulled Off Its Rs 190 Crore Magic Trick', 21 Dec 2017","https://m.thewire.in/article/banking/airtel-aadhaar-uidai"]] },
  { id: "vendors:c007", s: "co:state-bank-of-india", t: "scheme:dbt-apb-pfms", pred: "analytic", tier: "analytic", lab: "SBI's DBT share: void", d: "PMJDY has 56 crore accounts and ₹2.68 lakh crore of deposits; SBI is the largest PSB, but no source opened here publishes bank-wise DBT credit shares or float income attributable to DBT. Recorded as a documented absence.", from: "2025-08-28", srcs: [["PIB, PMJDY completes 11 years — ₹6.9 lakh crore DBT in FY2024-25, 28 Aug 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2161401"]], innocentReading: "DBT credits are largely withdrawn quickly; float is small relative to SBI's ₹50+ lakh crore deposit base", upgradeIf: "RBI/DFS bank-wise DBT statistics or SBI annual-report disclosure", killIf: "Published data show SBI's share is proportional to its account base" },
  { id: "vendors:c008", s: "wel:bluekraft-digital-foundation", t: "scheme:dbt-apb-pfms", pred: "analytic", tier: "reported", a: 348000, lab: "₹3.48 lakh cr 'savings' claim is a think-tank estimate", d: "PIB released a BlueKraft Digital Foundation assessment claiming ₹3.48 lakh crore cumulative savings and a 16→9% fall in subsidy share; the figures are 'estimated gains' (e.g. deleted PM-KISAN beneficiaries × entitlement), not audited recoveries.", from: "2025-04-21", srcs: [["PIB (Ministry of Finance), 'India's DBT: Boosting Welfare Efficiency' — BlueKraft assessment, 21 Apr 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2123192"]], innocentReading: "The underlying dbtbharat 'estimated gains' methodology is public and the direction of savings is uncontested", upgradeIf: "CAG audit of DBT savings methodology", killIf: "Independent replication of the ₹3.48 lakh crore figure" },
  { id: "vendors:c009", s: "min:ministry-of-petroleum-and-natural-gas", t: "wel:omcs", pred: "award", tier: "documented", a: 12800, lab: "₹1,600/connection to OMCs; ₹12,800 cr budget", d: "GoI reimburses OMCs the deposit-free connection cost; budget raised from ₹8,000 crore (5 crore connections) to ₹12,800 crore (8 crore) in Feb 2018; 7.19 crore issued by Mar 2019; CAG found OMC claims short-paid when budget provision fell short.", from: "2016-05-01", to: "2020-03-31", srcs: [["CAG press release on Performance Audit Report No. 14 of 2019 on PMUY, 11 Dec 2019 (local copy; exact report URL unresolved — see gaps)","https://cag.gov.in/en"]] },
  { id: "vendors:c010", s: "cag", t: "scheme:pm-ujjwala", pred: "enforce", tier: "documented", lab: "CAG Report 14/2019: 42% connections un-deduplicated; 3.66 refills", d: "CAG found 1.60 crore of 3.78 crore connections issued on beneficiary Aadhaar alone; average 3.66 refills/yr among 1.93 crore consumers; 1.98 lakh consumers >12 cylinders/yr (diversion risk); ₹1,234.71 crore loans outstanding; ₹261.85 crore idle.", from: "2019-12-11", srcs: [["CAG press release on Performance Audit Report No. 14 of 2019 on PMUY, 11 Dec 2019 (local copy; exact report URL unresolved — see gaps)","https://cag.gov.in/en"]] },
  { id: "vendors:c011", s: "min:ministry-of-petroleum-and-natural-gas", t: "scheme:pm-ujjwala", pred: "analytic", tier: "analytic", lab: "₹300 subsidy raised in Oct 2023, weeks before 4 state polls", d: "The PMUY refill subsidy went from ₹200 to ₹300 per cylinder in Oct 2023; MP, Rajasthan, Chhattisgarh and Telangana voted 7–30 Nov 2023. BJP won three of the four.", from: "2023-10-01", to: "2023-11-30", srcs: [["PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"],["Wikipedia (pointer), 2023 Madhya Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"],["Wikipedia (pointer), 2023 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"],["Wikipedia (pointer), 2023 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"]], innocentReading: "International LPG prices and the Aug 2023 ₹200 cut for all consumers; PMUY per-capita refills were rising anyway (3.68 → 4.47) and the subsidy was later continued into FY2025-26 with a 9-refill cap", upgradeIf: "Cabinet note dating the decision and its stated rationale", killIf: "The decision predates the poll schedule or matches an announced price-indexation rule" },
  { id: "vendors:c012", s: "wel:lokniti-csds", t: "scheme:pm-ujjwala", pred: "analytic", tier: "documented", lab: "NDA vote 49% among Ujjwala households vs 42%", d: "NES 2019 post-poll (Lokniti-CSDS): 34% of households reported an Ujjwala connection; NDA vote among them 49% vs 42% among non-beneficiaries; PM-KISAN 51/44; Jan Dhan 50/43; PMAY 46/44; credit for central schemes shifted to the Centre vs 2014.", from: "2019-05-23", srcs: [["Seminar #720, Jyoti Mishra & Vibha Attri (Lokniti-CSDS), 'Did welfare win votes?' (NES 2019 post-poll), 2019","https://india-seminar.com/2019/720/720_jyoti_and_vibha.htm"]], innocentReading: "Beneficiary selection correlates with social groups already leaning NDA; a 4–7 point gap is consistent with selection rather than persuasion", upgradeIf: "Panel or RDD design showing a within-person shift", killIf: "Controls for caste/class/region eliminate the gap" },
  { id: "vendors:c013", s: "min:ministry-of-consumer-affairs-food-and-public-distribution", t: "wel:fci", pred: "pmout", tier: "documented", a: 139662, lab: "₹1,39,662 cr subsidy to FCI (2023-24 RE)", d: "Food subsidy to FCI ₹1,39,662 crore and to DCP states ₹72,250 crore (2023-24 RE); 2024-25 BE ₹2,05,250 crore consolidated under PMGKAY; economic cost rice ₹39.8/kg, wheat ₹27.7/kg against CIP ₹0.", from: "2023-04-01", to: "2025-03-31", srcs: [["PRS Legislative Research, 'Demand for Grants 2024-25 Analysis: Food and Public Distribution'","https://prsindia.org/budgets/parliament/demand-for-grants-2024-25-analysis-food-and-public-distribution"]] },
  { id: "vendors:c014", s: "wel:bmtc", t: "co:ashok-leyland", pred: "award", tier: "reported", a: 336, lab: "820 BS6 diesel buses (Feb 2024 tender)", d: "After Tata Motors' Oct 2022 award for 840 buses was scrapped over technical snags (20 delivered), BMTC's Feb 2024 tender went to Ashok Leyland; first 100 delivered 12 Sep 2024; funded by a ₹336 crore state grant.", from: "2024-02-01", to: "2025-03-31", srcs: [["Deccan Herald, 'BMTC launches 100 new diesel buses, to get 820 of them by March', 12 Sep 2024","https://www.deccanherald.com/india/karnataka/bengaluru/bmtc-launches-100-new-diesel-buses-to-get-820-of-them-by-march-3188420"]], upgradeIf: "BMTC tender award letter with contract value", killIf: "Contract value or awardee differs in the tender record" },
  { id: "vendors:c015", s: "wel:bmtc", t: "co:tata-motors", pred: "award", tier: "reported", lab: "840-bus award (Oct 2022) — scrapped", d: "Tata Motors won BMTC's Oct 2022 840-bus BS6 diesel tender, delivered 20, survived a High Court accessibility challenge (Mar 2023) and then lost the contract after technical snags.", from: "2022-10-01", to: "2024-02-01", srcs: [["Deccan Herald, 'BMTC launches 100 new diesel buses, to get 820 of them by March', 12 Sep 2024","https://www.deccanherald.com/india/karnataka/bengaluru/bmtc-launches-100-new-diesel-buses-to-get-820-of-them-by-march-3188420"]], upgradeIf: "BMTC board minute on termination", killIf: "Tata disputes the stated reason on record" },
  { id: "vendors:c016", s: "wel:bmtc", t: "co:tata-motors", pred: "award", tier: "reported", lab: "148 e-buses at ~₹41/km GCC (2025)", d: "Tata Motors delivered 148 electric buses to BMTC in mid-2025 under a gross-cost contract at about ₹41/km (Dharwad plant).", from: "2025-06-01", srcs: [["Wikipedia (pointer), 'Bengaluru Metropolitan Transport Corporation'","https://en.wikipedia.org/wiki/Bangalore_Metropolitan_Transport_Corporation"]], upgradeIf: "BMTC/CESL contract document", killIf: "Rate or count differs in the contract" },
  { id: "vendors:c017", s: "wel:karnataka-rtcs", t: "scheme:ka-shakti", pred: "enforce", tier: "reported", a: 5172, lab: "₹1,800 cr → ₹5,172 cr reimbursement arrears", d: "Karnataka owed its RTCs ~₹1,800 crore for Shakti by Dec 2024 (₹1,180.62 crore for 2023-24 + ₹579.19 crore Apr–Nov 2024) and ₹5,172 crore by Jun 2026; in 2025-26 free tickets (₹7,701 crore) exceeded male paid fares (₹6,825 crore) and the RTCs posted their first loss since 2023.", from: "2024-12-01", to: "2026-06-20", srcs: [["Deccan Herald, 'Rs 1,800 cr Shakti scheme reimbursement pending; transport corporations in red', Dec 2024","https://www.deccanherald.com/india/karnataka/rs1-800-cr-shakti-scheme-reimbursement-pending-transport-corpns-in-red-3320295"],["ETV Bharat, 'Shakti scheme effect: male passengers drop; ₹5,172 crore reimbursement pending', 20 Jun 2026","https://www.etvbharat.com/en/bharat/shakti-scheme-effect-number-of-male-passengers-travelling-in-karnataka-govt-run-buses-drops-significantly-in-karnataka-enn26062003798"]] },
  { id: "vendors:c018", s: "wel:siddaramaiah", t: "scheme:ka-shakti", pred: "analytic", tier: "analytic", lab: "Launched 1 month AFTER the election it was promised for", d: "Shakti was a pre-poll guarantee delivered on 11 Jun 2023, a month after Congress won on 10 May 2023 (135 seats, +55). The timing is post-election fulfilment, not pre-election inducement.", from: "2023-05-10", to: "2023-06-11", srcs: [["Wikipedia (pointer), 2023 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"],["Deccan Herald, 'Rs 1,800 cr Shakti scheme reimbursement pending; transport corporations in red', Dec 2024","https://www.deccanherald.com/india/karnataka/rs1-800-cr-shakti-scheme-reimbursement-pending-transport-corpns-in-red-3320295"]], innocentReading: "A manifesto promise implemented promptly is the ordinary democratic cycle", upgradeIf: "Evidence the scheme was timed to the 2024 Lok Sabha poll instead", killIf: "n/a — this is the innocent reading" },
  { id: "vendors:c019", s: "wel:dtc", t: "wel:tml-cv-mobility-solutions", pred: "award", tier: "documented", lab: "1,500 e-buses, 12-year SOM (CESL Grand Challenge)", d: "DTC signed a definitive agreement on 23 Dec 2022 with TML CV Mobility Solutions (Tata Motors) to supply, operate and maintain 1,500 12-m low-floor AC e-buses for 12 years; value/per-km rate not disclosed in the release.", from: "2022-12-23", to: "2034-12-23", srcs: [["Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022","https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"]] },
  { id: "vendors:c020", s: "wel:dtc", t: "wel:switch-mobility", pred: "award", tier: "reported", lab: "950 12-m e-buses (Sep 2023)", d: "Delhi government signed for 950 low-floor 12-m e-buses from Switch Mobility (Ashok Leyland) under the CESL tender; delivery in 4–6 months; announced by Transport Commissioner Ashish Kundra.", from: "2023-09-22", srcs: [["EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023","https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"]], upgradeIf: "CESL/DTC award letter with per-km rate", killIf: "Award later cancelled or re-tendered" },
  { id: "vendors:c021", s: "wel:dtc", t: "wel:jbm-auto", pred: "award", tier: "reported", lab: "1,040 9-m e-buses with PMI (Sep 2023)", d: "JBM Auto and PMI Electro Mobility contracted for 1,040 9-m e-buses for Delhi.", from: "2023-09-22", srcs: [["EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023","https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"]], upgradeIf: "Award letters splitting the 1,040 between JBM and PMI", killIf: "Award cancelled" },
  { id: "vendors:c022", s: "wel:dtc", t: "wel:pmi-electro-mobility", pred: "award", tier: "reported", lab: "share of 1,040 9-m e-buses (Sep 2023)", d: "See JBM claim; split not disclosed.", from: "2023-09-22", srcs: [["EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023","https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"]], upgradeIf: "Award letter", killIf: "Award cancelled" },
  { id: "vendors:c023", s: "co:tata-motors", t: "scheme:ka-shakti", pred: "analytic", tier: "analytic", lab: "Same 3–4 OEMs win under Congress (KA) and AAP (DL)", d: "Tata Motors, Ashok Leyland/Switch and JBM appear on both Karnataka (Congress) and Delhi (AAP) bus awards. Vendor concentration tracks India's bus-OEM market structure, not party.", from: "2022-10-01", to: "2025-06-01", srcs: [["Deccan Herald, 'BMTC launches 100 new diesel buses, to get 820 of them by March', 12 Sep 2024","https://www.deccanherald.com/india/karnataka/bengaluru/bmtc-launches-100-new-diesel-buses-to-get-820-of-them-by-march-3188420"],["Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022","https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"],["EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023","https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"],["Wikipedia (pointer), 'Bengaluru Metropolitan Transport Corporation'","https://en.wikipedia.org/wiki/Bangalore_Metropolitan_Transport_Corporation"]], innocentReading: "Only a handful of OEMs can supply BS6/electric city buses at scale; CESL aggregated tenders are competitive and party-agnostic", upgradeIf: "Evidence of tender specifications tailored to one OEM in a given state", killIf: "n/a — this is the null result" },
  { id: "vendors:c024", s: "min:ministry-of-finance", t: "wel:hewlett-packard-india", pred: "award", tier: "reported", a: 2800, lab: "UP: ~15 lakh HP laptops, ₹2,800 cr (2012-13)", d: "Uttar Pradesh government (SP) approved a ₹2,800 crore scheme (Jan 2013) and procured ~15 lakh HP laptops in a tender contested by HP, HCL, Lenovo and Acer; a 2017 probe found 14,81,118 bought vs 6,11,794 distributed. (Awarding body should read 'Government of Uttar Pradesh' — no UP state node exists in the inventory; see gaps.)", from: "2013-01-24", to: "2015-03-31", srcs: [["Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'","https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"]], upgradeIf: "UP cabinet order and HP contract; CAG UP civil audit of the scheme", killIf: "Probe findings withdrawn or distribution figures corrected" },
  { id: "vendors:c025", s: "wel:yogi-adityanath", t: "scheme:up-free-laptops-2012", pred: "enforce", tier: "reported", lab: "2017 probe: 8.7 lakh laptops unaccounted", d: "Successor BJP government ordered a probe in 2017 into laptops purchased (14,81,118) but not distributed (6,11,794 distributed).", from: "2017-03-19", srcs: [["Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'","https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"]], upgradeIf: "Probe report or CAG paragraph", killIf: "Distribution records reconcile the gap" },
  { id: "vendors:c026", s: "wel:amarinder-singh", t: "scheme:pb-smart-connect", pred: "role", tier: "documented", a: 92, lab: "Launched ₹92 cr Smart Connect, 12 Aug 2020", d: "CM launched the ₹92 crore scheme for 1,74,015 Class XII students at 26 sites with Finance, Health and Education ministers each handing over 20 phones; ₹100 crore had been budgeted in 2017-18.", from: "2020-08-12", srcs: [["The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020","https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"]] },
  { id: "vendors:c027", s: "wel:amarinder-singh", t: "scheme:pb-smart-connect", pred: "analytic", tier: "analytic", lab: "Delivered 3.5 years after promise, 18 months before poll", d: "The 2017 manifesto promise was delivered in Aug 2020, 18 months before the Feb 2022 election, which Congress lost heavily (18 seats, −59).", from: "2020-08-12", to: "2022-02-20", srcs: [["The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020","https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"],["Wikipedia (pointer), 2022 Punjab Legislative Assembly election","https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"]], innocentReading: "COVID school closures created a genuine need for devices; the scheme's small size (₹92 crore) is not election-scale", upgradeIf: "Evidence phases were timed to the poll calendar", killIf: "n/a" },
  { id: "vendors:c028", s: "wel:ashok-gehlot", t: "scheme:rj-indira-gandhi-smartphone", pred: "role", tier: "documented", lab: "Launched ₹6,800/phone DBT scheme, 10 Aug 2023", d: "40 lakh women in phase 1 (pensioners, school and college students) of a 1.35 crore target; ₹6,800 per phone by DBT, 20 GB initial data, 3 years' connectivity; distribution at camps.", from: "2023-08-10", srcs: [["ThePrint (Hindi), 'Indira Gandhi Smartphone Yojana begins in Rajasthan; 40 lakh women in phase 1', 11 Aug 2023","https://hindi.theprint.in/report/indira-gandhi-smartphone-yojana-started-in-rajasthan-40-lakh-women-will-get-smartphones-in-the-first-phase/582752/"]] },
  { id: "vendors:c029", s: "wel:ashok-gehlot", t: "scheme:rj-indira-gandhi-smartphone", pred: "analytic", tier: "analytic", a: 2720, lab: "Phase 1 (~₹2,720 cr) 3.5 months before the poll; incumbent lost", d: "₹6,800 × 40 lakh ≈ ₹2,720 crore of handset demand pushed through camps between Aug and Nov 2023; Congress lost on 25 Nov 2023 (70 seats, −30). Phase 2 for the remaining ~95 lakh did not happen before the change of government.", from: "2023-08-10", to: "2023-11-25", srcs: [["ThePrint (Hindi), 'Indira Gandhi Smartphone Yojana begins in Rajasthan; 40 lakh women in phase 1', 11 Aug 2023","https://hindi.theprint.in/report/indira-gandhi-smartphone-yojana-started-in-rajasthan-40-lakh-women-will-get-smartphones-in-the-first-phase/582752/"],["Wikipedia (pointer), 2023 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"]], innocentReading: "The scheme was a Budget 2022-23 promise delayed by procurement design (DBT to e-wallet rather than a state handset tender), which pushed delivery into the pre-poll window", upgradeIf: "State tender/e-wallet vendor records naming OEMs/telcos and their volumes", killIf: "Delivery dates were fixed before the poll schedule for administrative reasons on record" },
  { id: "vendors:c030", s: "wel:mp-jansampark", t: "scheme:mp-ladli-behna", pred: "pmout", tier: "documented", a: 290, lab: "₹290 cr publicity; ₹260 cr pre-election", d: "CM Mohan Yadav's written reply (Jul 2025) to MLA Atif Aqueel: ₹260 crore spent publicising Ladli Behna before the Nov 2023 election and ₹290 crore in total; ₹28 crore for Seekho Kamao.", from: "2023-03-01", to: "2025-07-30", srcs: [["Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025","https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"]] },
  { id: "vendors:c031", s: "wel:maharashtra-dgipr", t: "scheme:mh-ladki-bahin", pred: "pmout", tier: "reported", a: 199.81, lab: "₹199.81 cr publicity in ~4 months (RTI)", d: "DGIPR RTI reply dated 4 Oct 2024 (applicant Ajay Bose): ₹199.81 crore on Ladki Bahin publicity; raised by Aaditya Thackeray on 17 Oct 2024.", from: "2024-06-28", to: "2024-10-04", srcs: [["Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024","https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"]], innocentReading: "Registering about 1.25–1.3 crore eligible women for a new DBT scheme in 2023 needed a mass awareness and enrolment campaign. That spending naturally comes at launch, which fell in the election year. The MCC from 9 Oct 2023 then stops new ads, so most lifetime spend lands before the poll. After enrolment closed, publicity needs dropped (only ₹30 cr from Nov 2023 to Jul 2025). This explains the 260/290 split without any partisan intent.", upgradeIf: "Copy of the RTI reply / DGIPR vendor-wise release orders", killIf: "DGIPR corrects the figure" },
  { id: "vendors:c032", s: "wel:sunil-tatkare", t: "claim:vendors:c031", pred: "contra", tier: "reported", lab: "Tatkare/Lad: every government advertises new schemes", d: "NCP's Sunil Tatkare and BJP's Prasad Lad responded that advertising a new scheme is standard practice at the Centre and in states, and necessary for awareness.", from: "2024-10-17", srcs: [["Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024","https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"]], innocentReading: "A newly launched direct-benefit scheme with a tight enrolment window (applications from July 2024, with enrolment drives) needs mass awareness advertising. Governments routinely budget for this ('every government makes a provision for advertising'), and heavy spending at launch is normal whether or not an election is coming. In Maharashtra the scheme's launch, set in the last budget of the term, happened to fall just before the poll, which is the usual budget-cycle alignment." },
  { id: "vendors:c033", s: "cag", t: "wel:delhi-dip", pred: "enforce", tier: "documented", a: 612.8, lab: "Delhi ad spend ₹46.90 cr (2018) → ₹612.80 cr (2022); SC-guideline breaches", d: "CAG: 1,200% rise in five years; campaigns released outside NCT and in violation of the SC's 2015 content guidelines; ₹57.90 crore released in 2020-22 for 2015-17 ads without due procedure; ₹43.621 crore to 94 agencies without L-G cognisance; L-G ordered recovery of ~₹97 crore (₹42 crore paid, ₹54 crore pending) for political ads published as government ads. Report untabled as of Feb 2025.", from: "2018-04-01", to: "2022-03-31", srcs: [["The Tribune, 'AAP govt violated ad campaign norms, spending rose by 1,200% in 5 yrs: CAG report', 27 Feb 2025","https://www.tribuneindia.com/news/india/aap-govt-violated-ad-campaign-norms-spending-rose-by-1200-in-5-yrs-cag-report/"]] },
  { id: "vendors:c034", s: "wel:delhi-dip", t: "party:aap", pred: "pmout", tier: "reported", a: 274, lab: "₹274 cr ads Feb 2015–Feb 2019 (RTI), 4× Congress era", d: "RTI to Delhi DIP: ₹59 cr (2015-16), ₹66 cr (2016-17), ₹117 cr (2017-18), ₹30 cr (to 28 Feb 2019) = ₹274 crore, vs ~₹17.4 crore/yr under Sheila Dikshit (2008-13). Kejriwal's media adviser: could not comment without reviewing papers.", from: "2015-02-14", to: "2019-02-28", srcs: [["ThePrint, 'Kejriwal govt spent Rs 274 crore on ads since 2015, four times Congress tab' (RTI), 1 Apr 2019","https://theprint.in/politics/kejriwals-delhi-govt-spent-rs-274-crore-on-ads-since-2015-four-times-more-than-congress/214151/"]], upgradeIf: "Committee on Content Regulation findings per campaign", killIf: "Spend reclassified as non-political programme ads on audit" },
  { id: "vendors:c035", s: "wel:arvind-kejriwal", t: "claim:vendors:c034", pred: "contra", tier: "analytic", lab: "Kejriwal camp: 'can't comment without the papers'; disputes CAG politics", d: "Media adviser declined comment pending review (2019); AAP has characterised CAG/L-G actions on ads as political (CM 'blames it on politics', HT 2017 headline in search results — not opened).", from: "2019-04-01", srcs: [["ThePrint, 'Kejriwal govt spent Rs 274 crore on ads since 2015, four times Congress tab' (RTI), 1 Apr 2019","https://theprint.in/politics/kejriwals-delhi-govt-spent-rs-274-crore-on-ads-since-2015-four-times-more-than-congress/214151/"]], innocentReading: "Most of the ₹274 crore is ordinary government publicity: hoardings, Metro, newspaper ads for schemes. It is in nominal rupees against a 2008–13 baseline, over a period when the Delhi budget grew a lot, and ThePrint notes a pre-election push. Only a subset (~₹97 crore) has been formally classed as political content by the CCRGA/L-G, and AAP contests it. The CAG breaches are procedural: no audience identification, no impact assessment, no expenditure register, releases outside the NCT. They are not a finding that the whole ₹274 crore was political." },
  { id: "vendors:c036", s: "min:ministry-of-information-and-broadcasting", t: "wel:bennett-coleman", pred: "pmout", tier: "documented", a: 78.22, lab: "₹78.22 cr central print ads FY21–FY25", d: "Lok Sabha reply (MP Radhakrishna): central print ad spend ₹910.4 crore FY2020-21 to 2024-25 — Times of India ₹78.22 cr, Dainik Jagran ₹59.14 cr, Hindustan Times ₹47.80 cr, Amar Ujala ₹24.92 cr, Hindustan ₹21.56 cr; all-media spend ₹5,987.46 crore over 2014-15 to 2024-25. Official: rates follow circulation; ads are 'programme and policy centric'.", from: "2020-04-01", to: "2025-03-31", srcs: [["Newslaundry, 'Modi govt spent Rs 910 crore on print ads in 5 years; Times of India biggest beneficiary' (Lok Sabha reply), 4 Aug 2026","https://www.newslaundry.com/2026/08/04/modi-govt-spent-rs-910-crore-on-print-ads-in-5-years-times-of-india-biggest-beneficiary"]] },
  { id: "vendors:c037", s: "min:ministry-of-information-and-broadcasting", t: "wel:jagran-prakashan", pred: "pmout", tier: "documented", a: 59.14, lab: "₹59.14 cr central print ads FY21–FY25", d: "See Lok Sabha reply.", from: "2020-04-01", to: "2025-03-31", srcs: [["Newslaundry, 'Modi govt spent Rs 910 crore on print ads in 5 years; Times of India biggest beneficiary' (Lok Sabha reply), 4 Aug 2026","https://www.newslaundry.com/2026/08/04/modi-govt-spent-rs-910-crore-on-print-ads-in-5-years-times-of-india-biggest-beneficiary"]] },
  { id: "vendors:c038", s: "min:ministry-of-information-and-broadcasting", t: "wel:ht-media", pred: "pmout", tier: "documented", a: 47.8, lab: "₹47.80 cr central print ads FY21–FY25", d: "See Lok Sabha reply.", from: "2020-04-01", to: "2025-03-31", srcs: [["Newslaundry, 'Modi govt spent Rs 910 crore on print ads in 5 years; Times of India biggest beneficiary' (Lok Sabha reply), 4 Aug 2026","https://www.newslaundry.com/2026/08/04/modi-govt-spent-rs-910-crore-on-print-ads-in-5-years-times-of-india-biggest-beneficiary"]] },
  { id: "vendors:c039", s: "min:ministry-of-information-and-broadcasting", t: "co:hindustan-media-ventures", pred: "pmout", tier: "documented", a: 21.56, lab: "₹21.56 cr central print ads FY21–FY25", d: "See Lok Sabha reply.", from: "2020-04-01", to: "2025-03-31", srcs: [["Newslaundry, 'Modi govt spent Rs 910 crore on print ads in 5 years; Times of India biggest beneficiary' (Lok Sabha reply), 4 Aug 2026","https://www.newslaundry.com/2026/08/04/modi-govt-spent-rs-910-crore-on-print-ads-in-5-years-times-of-india-biggest-beneficiary"]] },
  { id: "vendors:c040", s: "min:ministry-of-information-and-broadcasting", t: "wel:amar-ujala", pred: "pmout", tier: "documented", a: 24.92, lab: "₹24.92 cr central print ads FY21–FY25", d: "See Lok Sabha reply.", from: "2020-04-01", to: "2025-03-31", srcs: [["Newslaundry, 'Modi govt spent Rs 910 crore on print ads in 5 years; Times of India biggest beneficiary' (Lok Sabha reply), 4 Aug 2026","https://www.newslaundry.com/2026/08/04/modi-govt-spent-rs-910-crore-on-print-ads-in-5-years-times-of-india-biggest-beneficiary"]] },
  { id: "vendors:c041", s: "wel:telangana-ipr", t: "party:brs", pred: "pmout", tier: "reported", a: 300, lab: "~₹300 cr publicity Jun 2014–Oct 2018 (RTI)", d: "RTI (Society for Safety of Public and Good Governance): ~₹177 crore to outdoor agencies and ~₹120 crore to TV channels, incl. ~₹8 crore to T News; spend rose year on year; a sizable portion publicised welfare schemes.", from: "2014-06-02", to: "2018-10-31", srcs: [["The News Minute, 'Telangana govt spent around Rs 300 cr on advertisement and publicity in 4 years' (RTI), 2020","https://www.thenewsminute.com/telangana/telangana-govt-spent-around-rs-300-cr-advertisement-and-publicity-4-years-137759"]], upgradeIf: "IPR release orders by vendor", killIf: "Figures reclassified" },
  { id: "vendors:c042", s: "min:ministry-of-information-and-broadcasting", t: "bjp", pred: "analytic", tier: "analytic", lab: "Ad-spend lens produces a figure for every government examined", d: "Centre (BJP) ₹5,987 cr/11 yrs; Delhi (AAP) ₹612.8 cr in 2022 alone; Telangana (BRS) ₹300 cr/4 yrs; MP (BJP) ₹290 cr on one scheme; Maharashtra (Mahayuti) ₹199.81 cr on one scheme. Publicity of leader-branded schemes is a cross-party constant; only Delhi has so far had a CAG finding of SC-guideline breach, because only Delhi was audited on this.", from: "2014-06-01", to: "2026-08-04", srcs: [["Newslaundry, 'Modi govt spent Rs 910 crore on print ads in 5 years; Times of India biggest beneficiary' (Lok Sabha reply), 4 Aug 2026","https://www.newslaundry.com/2026/08/04/modi-govt-spent-rs-910-crore-on-print-ads-in-5-years-times-of-india-biggest-beneficiary"],["The Tribune, 'AAP govt violated ad campaign norms, spending rose by 1,200% in 5 yrs: CAG report', 27 Feb 2025","https://www.tribuneindia.com/news/india/aap-govt-violated-ad-campaign-norms-spending-rose-by-1200-in-5-yrs-cag-report/"],["The News Minute, 'Telangana govt spent around Rs 300 cr on advertisement and publicity in 4 years' (RTI), 2020","https://www.thenewsminute.com/telangana/telangana-govt-spent-around-rs-300-cr-advertisement-and-publicity-4-years-137759"],["Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025","https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"],["Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024","https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"]], innocentReading: "Scheme awareness is a legitimate state function; spend scales with population and media inflation", upgradeIf: "Content-regulation committee rulings per campaign for each government", killIf: "n/a — this is a base-rate finding about the lens" },
  { id: "vendors:c043", s: "wel:varla-ramaiah", t: "scheme:ap-village-volunteers", pred: "enforce", tier: "alleged", lab: "TDP/JSP: volunteers acted as YSRCP agents", d: "TDP's Varla Ramaiah complained to the EC that YSRCP candidates met volunteers, offered inducements and used them to identify and canvass opposition voters; JSP's Pawan Kalyan alleged data-gathering enabled crime. EC removed ~100 volunteers and barred all from pension distribution during the MCC.", from: "2024-03-01", to: "2024-06-04", srcs: [["ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024","https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"]], innocentReading: "The volunteer network was a delivery system set up in 2019, well before the election. Modi reportedly praised it, and it was used for Covid surveys. Once the MCC starts, the ECI routinely keeps state-paid functionaries away from cash handouts to beneficiaries as a precaution, whether or not anyone is shown to have done wrong. About 100 removals out of 2.56 lakh is roughly 0.04%, which fits isolated violations rather than a system run as party agents. The article also says the opposition's position shifted: Naidu later promised \"he won't discontinue the volunteer system\".", upgradeIf: "EC order text; documented cases of volunteers canvassing", killIf: "EC finds complaints unsubstantiated beyond the ~100 removals" },
  { id: "vendors:c044", s: "wel:sajjala-ramakrishna-reddy", t: "claim:vendors:c043", pred: "contra", tier: "reported", lab: "YSRCP: opposition wants to dismantle a delivery system", d: "Sajjala Ramakrishna Reddy said Naidu wanted to remove the volunteer system to restore TDP-era committees that enabled 'corruption and atrocities'; YSRCP denied the volunteers were party agents.", from: "2024-04-05", srcs: [["ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024","https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"]] },
  { id: "vendors:c045", s: "wel:ys-jagan-mohan-reddy", t: "scheme:ap-village-volunteers", pred: "pmout", tier: "reported", a: 1536, lab: "~₹1,536 cr/yr honoraria to 2.56 lakh volunteers", d: "2.56 lakh volunteers × ₹5,000/month under 15,425 sachivalayams — a state-paid last-mile layer between treasury and beneficiary.", from: "2019-08-01", to: "2024-06-12", srcs: [["ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024","https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"]] },
  { id: "vendors:c046", s: "wel:greater-chennai-corporation", t: "scheme:tn-amma-unavagam", pred: "pmout", tier: "reported", a: 100, lab: "~₹100 cr/yr municipal subsidy, 407 canteens", d: "Greater Chennai Corporation bears ~₹100 crore a year for 407 Amma canteens serving ~4.5 lakh people/day at ₹15 for three meals (2020).", from: "2019-04-01", to: "2020-06-01", srcs: [["ThePrint, 'Now it's Rs 15 for 3 meals at Chennai's Amma Canteens', 1 Jun 2020","https://theprint.in/india/now-its-rs-15-for-3-meals-at-chennais-amma-canteens-but-end-of-free-food-bad-news-for-many/433276/"]] },
  { id: "vendors:c047", s: "wel:lokniti-csds", t: "bjp", pred: "analytic", tier: "documented", lab: "Beneficiary vote premium 2–7 points (NES 2019)", d: "Across PM-KISAN, Ujjwala, Jan Dhan and PMAY, NDA vote among beneficiary households exceeded non-beneficiaries by 7, 7, 7 and 2 points respectively; credit attribution shifted to the Centre.", from: "2019-05-23", srcs: [["Seminar #720, Jyoti Mishra & Vibha Attri (Lokniti-CSDS), 'Did welfare win votes?' (NES 2019 post-poll), 2019","https://india-seminar.com/2019/720/720_jyoti_and_vibha.htm"]], innocentReading: "Selection into schemes and prior partisanship explain part or all of the gap; the analysis is cross-sectional", upgradeIf: "Causal designs (RDD on eligibility cut-offs)", killIf: "Gap disappears with controls" },
  { id: "welfare-central:c001", s: "wel:raghuvansh-prasad-singh", t: "scheme:mgnrega", pred: "role", tier: "documented", lab: "administers NREGA 2004-09", d: "Union RD Minister from 24 May 2004 through the Act's passage (23 Aug 2005) and rollout", from: "2004-05-24", to: "2009-05-22", srcs: [["Wikipedia (pointer), Raghuvansh Prasad Singh","https://en.wikipedia.org/wiki/Raghuvansh_Prasad_Singh"],["Wikipedia (pointer), MGNREGA 2005","https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"]] },
  { id: "welfare-central:c002", s: "wel:manmohan-singh", t: "scheme:mgnrega", pred: "role", tier: "documented", lab: "approved (PM)", d: "PM of the UPA government that enacted NREGA", from: "2005-08-23", srcs: [["Wikipedia (pointer), MGNREGA 2005","https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"]] },
  { id: "welfare-central:c003", s: "wel:p-chidambaram", t: "scheme:upa-farm-loan-waiver-2008", pred: "role", tier: "documented", a: 60000, lab: "presented in budget", d: "Budget speech 29 Feb 2008 para 73", from: "2008-02-29", to: "2008-06-30", srcs: [["Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)","https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"]] },
  { id: "welfare-central:c004", s: "wel:kv-thomas", t: "scheme:in-nfsa", pred: "role", tier: "documented", lab: "administers NFSA", d: "MoS (IC) Food during ordinance (5 Jul 2013) and Act (10 Sep 2013)", from: "2013-07-05", to: "2014-05-26", srcs: [["Wikipedia (pointer), K. V. Thomas","https://en.wikipedia.org/wiki/K._V._Thomas"],["Wikipedia (pointer), National Food Security Act 2013","https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"]] },
  { id: "welfare-central:c005", s: "pol:narendra-modi", t: "scheme:pmjdy", pred: "role", tier: "documented", lab: "announced 15 Aug 2014", d: "Independence Day announcement; launched 28 Aug 2014", from: "2014-08-15", srcs: [["Wikipedia (pointer), Pradhan Mantri Jan Dhan Yojana","https://en.wikipedia.org/wiki/Pradhan_Mantri_Jan_Dhan_Yojana"],["PIB (MoF), PMJDY completes 11 years, 28 Aug 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2161401"]] },
  { id: "welfare-central:c006", s: "wel:nandan-nilekani", t: "wel:uidai", pred: "role", tier: "documented", lab: "chairman UIDAI 2009-14", d: "cabinet-rank chairman under PM Manmohan Singh; Aadhaar became the DBT identity layer", from: "2009-07-01", to: "2014-03-31", srcs: [["Wikipedia (pointer), Nandan Nilekani","https://en.wikipedia.org/wiki/Nandan_Nilekani"]] },
  { id: "welfare-central:c007", s: "pradhan", t: "scheme:pm-ujjwala", pred: "role", tier: "documented", lab: "administers PMUY 2016-21", d: "Petroleum minister at launch (May 2016) and through the CAG audit period", from: "2016-05-01", to: "2021-07-07", srcs: [["CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)","https://cag.gov.in/"],["Wikipedia (pointer), Pradhan Mantri Ujjwala Yojana","https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"]] },
  { id: "welfare-central:c008", s: "pol:piyush-goyal", t: "scheme:pm-kisan", pred: "role", tier: "documented", a: 75000, lab: "presented in interim budget", d: "1 Feb 2019: ₹6,000/yr, ≤2 ha, effective 1 Dec 2018, first instalment before 31 Mar 2019", from: "2019-02-01", to: "2019-02-01", srcs: [["Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)","https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"]] },
  { id: "welfare-central:c009", s: "pol:narendra-modi", t: "scheme:pm-kisan", pred: "role", tier: "documented", lab: "launched 24 Feb 2019; releases every instalment", d: "Gorakhpur launch with ₹2,000 to >1 crore farmers; 22nd/23rd instalments released from Guwahati and Hooghly in 2026", from: "2019-02-24", srcs: [["Wikipedia (pointer), Pradhan Mantri Kisan Samman Nidhi","https://en.wikipedia.org/wiki/Pradhan_Mantri_Kisan_Samman_Nidhi"],["PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"],["PIB, PM to release 23rd instalment from Tarakeswar, Hooghly, WB on 20 Jun 2026, 18 Jun 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2274616"]] },
  { id: "welfare-central:c010", s: "pol:nirmala-sitharaman", t: "scheme:pmgkay", pred: "role", tier: "documented", a: 170000, lab: "announced 26 Mar 2020", d: "₹1.70 lakh cr PM Garib Kalyan package incl. free grain for 80 crore", from: "2020-03-26", srcs: [["PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"]] },
  { id: "welfare-central:c011", s: "pol:narendra-modi", t: "scheme:pmgkay", pred: "role", tier: "documented", lab: "announced 5-year extension at Durg", d: "4 Nov 2023 rally; Cabinet approved 29 Nov 2023", from: "2023-11-04", to: "2023-11-29", srcs: [["ThePrint/ANI, 'Guarantee of Modi': PM extends free ration scheme for 5 years in poll-bound Chhattisgarh, MP, 4 Nov 2023","https://theprint.in/india/guarantee-of-modi-pm-extends-free-ration-scheme-for-5-years-in-poll-bound-chhattisgarh-mp/1832402/"],["PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"]] },
  { id: "welfare-central:c012", s: "pol:pralhad-joshi", t: "scheme:pmgkay", pred: "role", tier: "documented", lab: "administers 2024→", d: "Food minister from 10 Jun 2024", from: "2024-06-10", srcs: [["PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"]] },
  { id: "welfare-central:c013", s: "pol:hardeep-singh-puri", t: "scheme:pm-ujjwala", pred: "role", tier: "documented", lab: "administers PMUY subsidy", d: "₹300/cylinder subsidy; cap cut to 9 refills FY26", from: "2021-07-07", srcs: [["PIB, Cabinet approves continuation of ₹300 PMUY subsidy for FY 2024-25, 7 Mar 2024","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2012354"],["PIB, Cabinet approves PMUY targeted subsidy FY 2025-26 (₹300, up to 9 refills), 8 Aug 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2154117"]] },
  { id: "welfare-central:c014", s: "pol:nirmala-sitharaman", t: "scheme:in-pm-vishwakarma", pred: "role", tier: "documented", lab: "announced in Budget 2023-24", d: "PM VIKAS announced 1 Feb 2023; launched 17 Sep 2023", from: "2023-02-01", srcs: [["Union Budget 2023-24 speech, Nirmala Sitharaman, 1 Feb 2023","https://www.indiabudget.gov.in/budget2023-24/doc/Budget_Speech.pdf"],["PIB Research Unit backgrounder 'PM Vishwakarma Scheme: Honouring Heritage, Powering Progress', 16 Sep 2025 (PDF on file; exact document URL not recovered — see gaps)","https://www.pib.gov.in/"]] },
  { id: "welfare-central:c015", s: "pol:nirmala-sitharaman", t: "scheme:in-mssc", pred: "role", tier: "documented", lab: "announced in Budget 2023-24", d: "two-year 7.5% certificate for women, up to ₹2 lakh, to Mar 2025", from: "2023-02-01", to: "2025-03-31", srcs: [["Union Budget 2023-24 speech, Nirmala Sitharaman, 1 Feb 2023","https://www.indiabudget.gov.in/budget2023-24/doc/Budget_Speech.pdf"],["Akashvani News, over 14.83 lakh MSSC accounts opened, MoS Finance in LS, 31 Jul 2023","https://www.newsonair.gov.in/over-14-83-lakh-accounts-opened-under-mahila-samman-savings-certificate-scheme-govt-in-ls"]] },
  { id: "welfare-central:c016", s: "pol:nirmala-sitharaman", t: "scheme:in-lakhpati-didi", pred: "role", tier: "documented", lab: "presented in interim budget 2024", d: "target raised 2 → 3 crore, 1 Feb 2024", from: "2024-02-01", srcs: [["PIB, Interim Budget 2024-25: Lakhpati Didi target 2 cr → 3 cr, 1 Feb 2024","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2001109"],["Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)","https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"]] },
  { id: "welfare-central:c017", s: "pol:shivraj-singh-chouhan", t: "scheme:mgnrega", pred: "role", tier: "documented", lab: "piloted repeal (VB-G RAM G)", d: "introduced 16 Dec 2025; passed both Houses 18 Dec 2025; MGNREGA repealed w.e.f. 1 Jul 2026", from: "2025-12-16", to: "2026-07-01", srcs: [["Akashvani News, Rajya Sabha takes up VB-G RAM G Bill, 18 Dec 2025","https://www.newsonair.gov.in/lok-sabha-considers-viksit-bharat-bill-to-replace-2005-rural-employment-scheme"],["Akashvani News, Chouhan says VB-G RAM G Bill removes shortcomings of MGNREGA, 30 Dec 2025","https://www.newsonair.gov.in/union-minister-shivraj-singh-chouhan-says-viksit-bharat-g-ram-g-bill-removes-shortcomings-of-mgnrega"],["PIB Backgrounder, Viksit Bharat-G RAM G Act 2025 FAQ, 11 May 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2259712"]] },
  { id: "welfare-central:c018", s: "pol:shivraj-singh-chouhan", t: "scheme:pm-kisan", pred: "role", tier: "documented", lab: "administers PM-KISAN", d: "Agriculture minister; organised 23rd instalment event in WB", from: "2024-06-10", srcs: [["PIB, PM to release 23rd instalment from Tarakeswar, Hooghly, WB on 20 Jun 2026, 18 Jun 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2274616"]] },
  { id: "welfare-central:c019", s: "wel:ramnath-thakur", t: "scheme:pm-kisan", pred: "role", tier: "documented", lab: "MoS; answered exclusion question", d: "₹416.75 cr recovered from ineligible beneficiaries (2 Dec 2025)", from: "2025-12-02", srcs: [["Lok Sabha Unstarred Q.358 (MoS Agri Ramnath Thakur), discrepancy in PM-KISAN: ₹416.75 cr recovered from ineligible beneficiaries, 2 Dec 2025","https://sansad.in/getFile/loksabhaquestions/annex/186/AU358_FPeZsZ.pdf?source=pqals"]] },
  { id: "welfare-central:c020", s: "scheme:mgnrega", t: "min:ministry-of-rural-development", pred: "law", tier: "documented", lab: "Act governs MoRD scheme", d: "statutory 100-day guarantee; repealed 1 Jul 2026 by VB-G RAM G Act 2025 (125 days; 60:40; normative allocation)", from: "2006-02-01", to: "2026-06-30", srcs: [["PIB Backgrounder, Viksit Bharat-G RAM G Act 2025 FAQ, 11 May 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2259712"],["Wikipedia (pointer), MGNREGA 2005","https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"]] },
  { id: "welfare-central:c021", s: "scheme:in-nfsa", t: "min:ministry-of-consumer-affairs-food-and-public-distribution", pred: "law", tier: "documented", lab: "NFSA entitlement", d: "5 kg/person/month to 75% rural / 50% urban; free since Jan 2023", from: "2013-07-05", srcs: [["Wikipedia (pointer), National Food Security Act 2013","https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"],["PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"]] },
  { id: "welfare-central:c022", s: "scheme:mgnrega", t: "min:ministry-of-rural-development", pred: "pmout", tier: "documented", a: 89268.3, lab: "MGNREGA releases FY2023-24", d: "BE 60,000 → RE 86,000 → released 89,268.30 (₹ cr); FY2024-25 released 85,838.76", from: "2023-04-01", to: "2025-03-31", srcs: [["PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"]] },
  { id: "welfare-central:c023", s: "scheme:pm-kisan", t: "min:ministry-of-agriculture-and-farmers-welfare", pred: "pmout", tier: "documented", a: 447000, lab: "PM-KISAN cumulative ₹4.47 lakh cr", d: "23 instalments to Jun 2026; ₹1.06 lakh cr to women; ₹1.71 lakh cr during COVID; ₹3.15 lakh cr approved for 2026-31", from: "2019-02-24", to: "2026-06-20", srcs: [["PMO, Cabinet approves continuation of PM-KISAN 2026-27 to 2030-31, ₹3.15 lakh crore, 31 Jul 2026","https://www.pmindia.gov.in/en/news_updates/cabinet-approves-continuation-of-the-pm-kisan-scheme-from-2026-27-to-2030-31-with-a-financial-outlay-of-rs-3-15-lakh-crore/"]] },
  { id: "welfare-central:c024", s: "scheme:pmgkay", t: "min:ministry-of-consumer-affairs-food-and-public-distribution", pred: "pmout", tier: "documented", a: 1180000, lab: "free grain ₹11.80 lakh cr 2024-28", d: "food subsidy for 81.35 crore over five years", from: "2024-01-01", to: "2028-12-31", srcs: [["PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"]] },
  { id: "welfare-central:c025", s: "scheme:pm-ujjwala", t: "co:indian-oil", pred: "pmout", tier: "documented", a: 12000, lab: "PMUY refill subsidy ₹12,000 cr/yr", d: "₹300/cylinder credited to consumers via OMCs (IOCL, HPCL, BPCL); FY25 12 refills, FY26 9 refills", from: "2024-04-01", to: "2026-03-31", srcs: [["PIB, Cabinet approves continuation of ₹300 PMUY subsidy for FY 2024-25, 7 Mar 2024","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2012354"],["PIB, Cabinet approves PMUY targeted subsidy FY 2025-26 (₹300, up to 9 refills), 8 Aug 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2154117"]] },
  { id: "welfare-central:c026", s: "scheme:upa-farm-loan-waiver-2008", t: "co:state-bank-of-india", pred: "pmout", tier: "documented", a: 60000, lab: "waiver reimbursed to lenders", d: "Centre reimbursed scheduled banks, RRBs and cooperatives for ₹50,000 cr waived + ₹10,000 cr OTS; SBI is the largest lender (as class representative)", from: "2008-02-29", to: "2009-06-30", srcs: [["Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)","https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"]] },
  { id: "welfare-central:c027", s: "scheme:in-mssc", t: "wel:india-post", pred: "pmout", tier: "documented", a: 8000, lab: "MSSC deposits >₹8,000 cr", d: "14.83 lakh accounts by 31 Jul 2023 via post offices and banks", from: "2023-04-01", to: "2025-03-31", srcs: [["Akashvani News, over 14.83 lakh MSSC accounts opened, MoS Finance in LS, 31 Jul 2023","https://www.newsonair.gov.in/over-14-83-lakh-accounts-opened-under-mahila-samman-savings-certificate-scheme-govt-in-ls"]] },
  { id: "welfare-central:c028", s: "scheme:in-namo-drone-didi", t: "min:ministry-of-agriculture-and-farmers-welfare", pred: "pmout", tier: "documented", a: 1261, lab: "₹1,261 cr for 15,000 drones", d: "80% CFA up to ₹8 lakh per SHG; LFCs intermediate and promote nano-fertilisers", from: "2023-11-29", to: "2026-03-31", srcs: [["PIB, Cabinet approves Central Sector Scheme for providing drones to women SHGs (₹1,261 crore), 29 Nov 2023","https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=1980683"],["PIB (MoA&FW reply), Implementation of Namo Drone Didi scheme, 29 Jul 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2149706"]] },
  { id: "welfare-central:c029", s: "cag", t: "scheme:pm-ujjwala", pred: "enforce", tier: "documented", lab: "CAG Report 14 of 2019", d: "42% connections de-duplicated on beneficiary Aadhaar only; 8.59 lakh to minors; 18% of field KYCs misused by distributors; refills fell to 3.21/yr; ₹1,234.71 cr loans unrecovered", from: "2019-12-11", srcs: [["CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)","https://cag.gov.in/"]] },
  { id: "welfare-central:c030", s: "cag", t: "scheme:upa-farm-loan-waiver-2008", pred: "enforce", tier: "reported", lab: "CAG Report 3 of 2013 on ADWDRS", d: "headline: lapses in 22.32% of 90,576 test-checked cases (figure from search excerpt; PDF image-only, not text-verified)", from: "2013-03-05", srcs: [["CAG Report No. 3 of 2013, ADWDRS 2008 executive summary (PDF is image-only; text not machine-verified)","https://cag.gov.in/uploads/download_audit_report/2013/Union_Performance_Civil_Sector_3_2013_chapter_3_exe_summ.pdf"]], upgradeIf: "text of the CAG executive summary confirms the 22.32% / 90,576 figures", killIf: "the CAG text gives materially different figures" },
  { id: "welfare-central:c031", s: "cag", t: "scheme:mgnrega", pred: "enforce", tier: "reported", lab: "CAG performance audit 2013", d: "fall in employment; 30.3% of works completed; planning norms unmet in a third of GPs (Wikipedia pointer to CAG report)", from: "2013-04-23", srcs: [["Wikipedia (pointer), MGNREGA 2005","https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"]], upgradeIf: "CAG Report 6 of 2013 text opened", killIf: "pointer misstates the audit" },
  { id: "welfare-central:c032", s: "wel:aea-journals", t: "scheme:mgnrega", pred: "enforce", tier: "documented", lab: "Imbert-Papp 2015; MNS 2016", d: "private wages rose with NREGA; Smartcards cut leakage and delays in AP without reducing access", from: "2015-04-01", srcs: [["Imbert & Papp, 'Labor Market Effects of Social Programs: Evidence from India's Employment Guarantee', AEJ: Applied 7(2), 2015","https://www.aeaweb.org/articles?id=10.1257/app.20130401"],["Muralidharan, Niehaus & Sukhtankar, 'Building State Capacity: Evidence from Biometric Smartcards in India', AER 106(10), 2016","https://www.aeaweb.org/articles?id=10.1257/aer.20141346"]] },
  { id: "welfare-central:c033", s: "wel:nber", t: "scheme:pmjdy", pred: "enforce", tier: "documented", lab: "MNS Jharkhand ABBA study", d: "biometric authentication: no average leakage gain, 1.5–2 mn lost access at some point; reconciliation cut leakage but also genuine benefits", from: "2020-02-01", srcs: [["NBER WP 26744, Muralidharan, Niehaus & Sukhtankar, 'Identity Verification Standards in Welfare Programs: Experimental Evidence from India', Feb 2020 rev. Sep 2021","https://www.nber.org/system/files/working_papers/w26744/w26744.pdf"],["Ideas for India, Muralidharan-Niehaus-Sukhtankar, 'Balancing corruption and exclusion: incorporating Aadhaar into PDS' (Jharkhand), 17 Apr 2020","https://www.ideasforindia.in/topics/poverty-inequality/balancing-corruption-and-exclusion-incorporating-aadhaar-into-pds"]] },
  { id: "welfare-central:c034", s: "wel:lokniti-csds", t: "scheme:pmgkay", pred: "enforce", tier: "documented", lab: "2024 post-poll: PDS reach 67.4%", d: "credit split Centre 54.7% / state 35.1%; Ujjwala 45.0% reach with 68.3% Centre-credit; MGNREGA 33.7% with 63.5% Centre-credit", from: "2024-06-14", srcs: [["Lokniti-CSDS, Social and Political Barometer Post-poll Study 2024 — Survey Findings (PDF on file, dated 14 Jun 2024; exact URL not recovered — see gaps)","https://www.lokniti.org/"]] },
  { id: "welfare-central:c035", s: "min:ministry-of-finance", t: "scheme:pmjdy", pred: "pmout", tier: "reported", a: 348000, lab: "₹3.48 lakh cr 'savings' claim", d: "PIB relayed BlueKraft Digital Foundation's estimate: PDS ₹1.85 lakh cr, MGNREGS ₹42,534 cr, PM-KISAN ₹22,106 cr (2.1 crore deletions), fertiliser ₹18,699.8 cr; a 'Welfare Efficiency Index' weights savings at 50%", from: "2025-04-21", srcs: [["PIB, 'India's DBT: Boosting Welfare Efficiency' (BlueKraft report relayed), 21 Apr 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2123192"]], innocentReading: "The Finance Ministry's PIB unit regularly republishes favourable outside assessments. The sector figures are the government's own administrative counts of deleted duplicate or ineligible records. Some leakage cut is real: MNS find 66–78% of the Jharkhand drop in grain disbursed was reduced leakage, and Barnwal finds real LPG savings. The weak point is method. Deletions are counted as savings with no counterfactual and with genuine beneficiaries mixed in. That is a methodological weakness, not fabrication.", upgradeIf: "DBT Mission publishes a scheme-wise, year-wise methodology with counterfactual", killIf: "audited leakage baselines show deletions were of eligible beneficiaries" },
  { id: "welfare-central:c036", s: "wel:epw", t: "claim:welfare-central:c035", pred: "contra", tier: "documented", lab: "EPW 2016: LPG-DBT savings unconfirmed", d: "the earlier 'phenomenal success' savings claims for Aadhaar-linked LPG DBT could not be confirmed from the studies cited; same genre of claim", from: "2016-12-24", srcs: [["EPW Vol 51 No 52, 'Questioning the Phenomenal Success of Aadhaar-linked DBT for LPG', 24 Dec 2016","https://www.epw.in/journal/2016/52/web-exclusives/questioning-%E2%80%9Cphenomenal-success%E2%80%9D-aadhaar-linked-direct-benefit"]] },
  { id: "welfare-central:c037", s: "wel:nber", t: "claim:welfare-central:c035", pred: "contra", tier: "documented", lab: "MNS: 'savings' include lost genuine benefits", d: "in Jharkhand, 22–34% of the fall in grain disbursed under reconciliation was value lost by genuine beneficiaries — savings figures that count all reductions as leakage overstate the gain", from: "2020-04-17", srcs: [["Ideas for India, Muralidharan-Niehaus-Sukhtankar, 'Balancing corruption and exclusion: incorporating Aadhaar into PDS' (Jharkhand), 17 Apr 2020","https://www.ideasforindia.in/topics/poverty-inequality/balancing-corruption-and-exclusion-incorporating-aadhaar-into-pds"],["NBER WP 26744, Muralidharan, Niehaus & Sukhtankar, 'Identity Verification Standards in Welfare Programs: Experimental Evidence from India', Feb 2020 rev. Sep 2021","https://www.nber.org/system/files/working_papers/w26744/w26744.pdf"]] },
  { id: "welfare-central:c038", s: "bjp", t: "scheme:in-nfsa", pred: "enforce", tier: "alleged", lab: "BJP 2013: 'vote security, not food security'", d: "opposition framing of NFSA as pre-poll politics nine months before the 2014 Lok Sabha election", from: "2013-07-05", to: "2014-05-16", srcs: [["Wikipedia (pointer), National Food Security Act 2013","https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"]], upgradeIf: "contemporaneous statement text located in HT archive", killIf: "quote misattributed" },
  { id: "welfare-central:c039", s: "party:inc", t: "claim:welfare-central:c038", pred: "contra", tier: "reported", lab: "UPA response: rights-based entitlement", d: "Minister K.V. Thomas: a Centre-state task in the world's second most populous country; Drèze (ex-NAC): an investment in human capital; UPA lost the 2014 election regardless", from: "2013-09-10", srcs: [["Wikipedia (pointer), National Food Security Act 2013","https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"]] },
  { id: "welfare-central:c040", s: "party:inc", t: "scheme:mgnrega", pred: "enforce", tier: "alleged", lab: "Opposition: repeal 'dismantles the right to work'", d: "Congress (Wasnik), TMC, YSRCP, BJD, AIADMK objected in Rajya Sabha; unions say normative allocation and 60:40 sharing (~₹55,000 cr to states) end the demand-driven guarantee", from: "2025-12-18", srcs: [["Akashvani News, Rajya Sabha takes up VB-G RAM G Bill, 18 Dec 2025","https://www.newsonair.gov.in/lok-sabha-considers-viksit-bharat-bill-to-replace-2005-rural-employment-scheme"],["BehanBox, 'The GRAMG Bill codifies the stealthy ways in which NREGA was being undermined', 18 Dec 2025","https://behanbox.com/2025/12/18/the-gramg-bill-codifies-the-stealthy-ways-in-which-nrega-was-being-undermined/"]], upgradeIf: "state budgets 2026-27 show G RAM G cost shifted to states", killIf: "Centre funds all demand above normative allocation in practice" },
  { id: "welfare-central:c041", s: "pol:shivraj-singh-chouhan", t: "claim:welfare-central:c040", pred: "contra", tier: "documented", lab: "Chouhan: Bill removes MGNREGA's shortcomings", d: "30 Dec 2025: guarantee raised to 125 days; opposition 'did not listen' during an 8-hour debate; names of employment schemes were changed by earlier governments too", from: "2025-12-30", srcs: [["Akashvani News, Chouhan says VB-G RAM G Bill removes shortcomings of MGNREGA, 30 Dec 2025","https://www.newsonair.gov.in/union-minister-shivraj-singh-chouhan-says-viksit-bharat-g-ram-g-bill-removes-shortcomings-of-mgnrega"],["PIB Backgrounder, Viksit Bharat-G RAM G Act 2025 FAQ, 11 May 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2259712"]] },
  { id: "welfare-central:c043", s: "bjp", t: "claim:welfare-central:c042", pred: "contra", tier: "reported", lab: "BJP: 'guarantee of Modi'; scheme was lapsing 31 Dec 2023", d: "PM framed it as a fulfilled guarantee; Cabinet approved on 29 Nov 2023 with a five-year fiscal commitment of ₹11.80 lakh cr", from: "2023-11-04", to: "2023-11-29", srcs: [["ThePrint/ANI, 'Guarantee of Modi': PM extends free ration scheme for 5 years in poll-bound Chhattisgarh, MP, 4 Nov 2023","https://theprint.in/india/guarantee-of-modi-pm-extends-free-ration-scheme-for-5-years-in-poll-bound-chhattisgarh-mp/1832402/"],["PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"]] },
  { id: "welfare-central:c044", s: "scheme:pm-kisan", t: "bjp", pred: "analytic", tier: "analytic", lab: "first cash 48 days before LS 2019 polling", d: "announced 1 Feb 2019 in an interim budget, made retroactive to 1 Dec 2018, first ₹2,000 paid from 24 Feb 2019; polling began 11 Apr 2019; BJP +21 seats", from: "2019-02-01", to: "2019-05-23", srcs: [["Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)","https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"],["Wikipedia (pointer), Pradhan Mantri Kisan Samman Nidhi","https://en.wikipedia.org/wiki/Pradhan_Mantri_Kisan_Samman_Nidhi"],["Wikipedia (pointer), 2019 Indian general election","https://en.wikipedia.org/wiki/2019_Indian_general_election"]], innocentReading: "interim budgets routinely announce policy; rural distress after the Dec 2018 assembly losses and Telangana's Rythu Bandhu precedent explain the timing; the scheme has run seven years and been extended to 2031, which a pure vote-buying instrument would not require", upgradeIf: "Lokniti/CSDS panel shows PM-KISAN recipients swung to BJP more than non-recipient farmers with similar landholding", killIf: "recipient and non-recipient farmers show identical vote shifts 2014→2019" },
  { id: "welfare-central:c045", s: "scheme:pmgkay", t: "bjp", pred: "analytic", tier: "analytic", lab: "5-year free grain announced 3 days before CT phase-1", d: "PM's Durg announcement 4 Nov 2023; CT polled 7/17 Nov, MP 17 Nov, RJ 25 Nov, TG 30 Nov; Cabinet approval 29 Nov (after polling, before 3 Dec counting); LS 2024 five months later", from: "2023-11-04", to: "2024-06-01", srcs: [["ThePrint/ANI, 'Guarantee of Modi': PM extends free ration scheme for 5 years in poll-bound Chhattisgarh, MP, 4 Nov 2023","https://theprint.in/india/guarantee-of-modi-pm-extends-free-ration-scheme-for-5-years-in-poll-bound-chhattisgarh-mp/1832402/"],["PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"],["Wikipedia (pointer), 2023 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"],["Wikipedia (pointer), 2024 Indian general election","https://en.wikipedia.org/wiki/2024_Indian_general_election"]], innocentReading: "the free-grain arrangement was due to expire 31 Dec 2023, so a decision was needed in Q4 2023 regardless; NFSA coverage is statutory and unchanged; BJP lost 63 seats at the following Lok Sabha election", upgradeIf: "Cabinet papers show the extension was not on the agenda before the campaign", killIf: "DFPD file shows the 5-year proposal was processed before Oct 2023" },
  { id: "welfare-central:c045:audit-contra", s: "scheme:pmgkay", t: "claim:welfare-central:c045", pred: "contra", tier: "reported", lab: "denial found in audit", d: "A contra exists, but the record does not include it. Congress, through general secretary Jairam Ramesh, called the announcement a \"blatant violation\" of the model code of conduct and said the party had filed an online complaint with the Election Commission and would meet it. Congress said it was \"not against the extension\" but objected that it was announced during the campaign without Cabinet approval (Deccan Herald, https://www.deccanherald.com/india/pm-modis-free-ration-scheme-extension-amid-chhattisgarh-campaign-blatant-violation-of-poll-code-alleges-congress-2760199; Outlook, https://www.outlookindia.com/national/congress-alleges-poll-code-of-conduct-violation-by-pm-modi-to-approach-ec-news-329457/). I found no formal Election Commission ruling and no specific rebuttal from the government or BJP. The only government framing is PIB's, which calls it a \"historic decision\" and a \"continuation\". No record shows whether the government was asked.", srcs: [["Denial — www.deccanherald.com","https://www.deccanherald.com/india/pm-modis-free-ration-scheme-extension-amid-chhattisgarh-campaign-blatant-violation-of-poll-code-alleges-congress-2760199"]] },
  { id: "welfare-central:c046", s: "scheme:pm-ujjwala", t: "bjp", pred: "analytic", tier: "analytic", lab: "₹300 subsidy raise in Oct 2023, before Nov 2023 polls", d: "subsidy raised ₹200→₹300 in Oct 2023; polls in MP/CT/RJ/TG in Nov; BJP won three", from: "2023-10-01", to: "2023-11-30", srcs: [["PIB, Cabinet approves continuation of ₹300 PMUY subsidy for FY 2024-25, 7 Mar 2024","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2012354"],["Wikipedia (pointer), 2023 Madhya Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"]], innocentReading: "India imports ~60% of LPG and the subsidy was explicitly indexed to international price shocks; the raise was retained in FY25 and FY26 (with a refill-cap cut), i.e. not withdrawn after the polls", upgradeIf: "cabinet note cites the election calendar", killIf: "international LPG prices spiked in Sep–Oct 2023 by an amount matching the ₹100 raise" },
  { id: "welfare-central:c047", s: "scheme:pm-kisan", t: "bjp", pred: "analytic", tier: "analytic", lab: "saturation drive 15 Nov 2023 → LS 2024; 1 crore added", d: "Viksit Bharat Sankalp Yatra enrolment drive began 15 Nov 2023 (mid-assembly-polls) and added >1 crore beneficiaries before the Apr 2024 Lok Sabha election; a second drive followed the June 2024 government formation", from: "2023-11-15", to: "2024-06-01", srcs: [["PIB (MoA&FW RS reply), PM-KISAN 18th instalment beneficiaries and saturation drives, Feb 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2100758"]], innocentReading: "enrolment drives are how a land-record-based scheme reaches the excluded; the 2024 post-election drive shows they are not only pre-poll", upgradeIf: "new enrolments concentrated in swing constituencies", killIf: "enrolment growth tracks land-record digitisation, not the poll calendar" },
  { id: "welfare-central:c048", s: "scheme:pm-kisan", t: "bjp", pred: "analytic", tier: "analytic", lab: "2026 instalment venues track the election map", d: "22nd instalment released from Guwahati 13 Mar 2026 (Assam polled by Apr 2026; BJP 82/126 on 4 May); 23rd from Hooghly, WB on 20 Jun 2026, six weeks after BJP's first WB win, with the new CM on stage and PMFBY/AgriStack launched for WB the same day", from: "2026-03-13", to: "2026-06-20", srcs: [["PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"],["PIB, PM to release 23rd instalment from Tarakeswar, Hooghly, WB on 20 Jun 2026, 18 Jun 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2274616"],["India TV News, Assam Election Result 2026 live: BJP wins 82 of 126, 4 May 2026","https://www.indiatvnews.com/north-east/assam/assam-election-result-2026-live-updates-himanta-biswa-sarma-led-bjp-wins-setback-for-congress-1039454"],["India TV News, West Bengal Assembly Election 2026 result: full list of winners, 4 May 2026","https://www.indiatvnews.com/west-bengal/news-west-bengal-assembly-election-2026-full-list-of-winners-leading-candidates-294-seats-2026-05-04-1038758"]], innocentReading: "PM releases every instalment from a different state; a newly BJP-governed state joining PMFBY is an administrative event that needs a launch venue", upgradeIf: "venue choice for all 23 instalments shows systematic pre-poll targeting", killIf: "instalment venues 2019-26 are uncorrelated with the poll calendar" },
  { id: "welfare-central:c049", s: "scheme:upa-farm-loan-waiver-2008", t: "party:inc", pred: "analytic", tier: "analytic", lab: "₹60,000 cr waiver 13.5 months before LS 2009", d: "announced 29 Feb 2008, completed 30 Jun 2008; polling 16 Apr 2009; INC +61 seats", from: "2008-02-29", to: "2009-05-16", srcs: [["Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)","https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"],["Wikipedia (pointer), 2009 Indian general election","https://en.wikipedia.org/wiki/2009_Indian_general_election"]], innocentReading: "farm indebtedness and suicides were a live crisis; the Radhakrishna committee had just reported; the scheme was a one-off, not a recurring transfer", upgradeIf: "district-level data shows waiver intensity predicts INC swing 2004→2009", killIf: "waiver intensity uncorrelated with vote swing" },
  { id: "welfare-central:c050", s: "scheme:in-nfsa", t: "party:inc", pred: "analytic", tier: "analytic", lab: "NFSA ordinance 9 months before LS 2014 — and UPA lost", d: "ordinance 5 Jul 2013, Act 10 Sep 2013; polling 7 Apr 2014; INC 206 → 44", from: "2013-07-05", to: "2014-05-16", srcs: [["Wikipedia (pointer), National Food Security Act 2013","https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"],["Wikipedia (pointer), 2014 Indian general election","https://en.wikipedia.org/wiki/2014_Indian_general_election"]], innocentReading: "the bill had been in Parliament since Dec 2011; only 11 states had implemented it by Oct 2014, so few voters had received anything by polling day", upgradeIf: "—", killIf: "—" },
  { id: "welfare-central:c051", s: "scheme:mgnrega", t: "party:inc", pred: "analytic", tier: "analytic", lab: "NREGA 38 months before LS 2009; UPA won", d: "Act Aug 2005, rollout Feb 2006; polling Apr 2009; INC +61", from: "2006-02-01", to: "2009-05-16", srcs: [["Wikipedia (pointer), MGNREGA 2005","https://en.wikipedia.org/wiki/Mahatma_Gandhi_National_Rural_Employment_Guarantee_Act,_2005"],["Wikipedia (pointer), 2009 Indian general election","https://en.wikipedia.org/wiki/2009_Indian_general_election"]], innocentReading: "a statutory programme enacted three years before the poll is the opposite of a pre-poll sop; the 2009 win is consistent with delivered welfare rather than timed cash", upgradeIf: "—", killIf: "—" },
  { id: "welfare-central:c052", s: "scheme:mgnrega", t: "bjp", pred: "analytic", tier: "analytic", lab: "real-terms squeeze then repeal: BE −18% (2023), freeze (2025), repeal (Dec 2025)", d: "BE 2023-24 ₹60,000 cr vs ₹73,000 cr; BE held at ₹86,000 cr for 2024-25 and 2025-26 while releases fell from ₹1.11 lakh cr (2020-21); repeal passed in two days with 60:40 cost-sharing", from: "2023-02-01", to: "2026-07-01", srcs: [["PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"],["PIB (MoRD), Clarifications on budget cut to MGNREGA, BE/RE/release series 2014-15 to 2022-23, 3 Feb 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"],["BehanBox, 'The GRAMG Bill codifies the stealthy ways in which NREGA was being undermined', 18 Dec 2025","https://behanbox.com/2025/12/18/the-gramg-bill-codifies-the-stealthy-ways-in-which-nrega-was-being-undermined/"],["PIB Backgrounder, Viksit Bharat-G RAM G Act 2025 FAQ, 11 May 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2259712"]], innocentReading: "the scheme is demand-driven and RE routinely exceeds BE (RE 2023-24 was ₹86,000 cr); post-COVID demand fell; the replacement raises the guarantee to 125 days and adds delay compensation", upgradeIf: "FY 2026-27 person-days or wages paid fall materially below 2024-25", killIf: "G RAM G releases in 2026-27 exceed MGNREGA 2024-25 in real terms" },
  { id: "welfare-central:c052:audit-contra", s: "scheme:mgnrega", t: "claim:welfare-central:c052", pred: "contra", tier: "reported", lab: "denial found in audit", d: "The claim's own source contains a denial. PIB 1896038 (MoRD, 3 Feb 2023), answering media reports of the 18% cut, says \"This is far from truth. Mahatma Gandhi NREGA is a demand driven Scheme ... actual releases to the States have been much higher than that provided for at the BE level\" (https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038). PIB 2148475 (25 Jul 2025) says the ₹86,000 cr BE for 2024-25 \"was the highest ever allocation for scheme at the Budget Estimate (BE) stage since inception\" and that 99.79% of households demanding work were offered it (https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475). The record also cites Chouhan saying the Bill \"removes shortcomings of MGNREGA\" (newsonair, 30 Dec 2025). There is also contrary evidence after the claim window. ThePrint reports that Union Budget 2026-27 gave VB-G RAM G ₹95,692 cr plus ₹30,000 cr for MGNREGA (the transition quarter), and that the 2025-26 RE was raised to ₹88,000 cr (https://theprint.in/india/governance/vb-g-ram-g-gets-rs-95000-plus-crore-allocation-under-union-budget-2026-27-mgnrega-funds-reduced/2842622/).", srcs: [["Denial — www.pib.gov.in","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"]] },
  { id: "welfare-central:c053", s: "scheme:in-nsap", t: "bjp", pred: "analytic", tier: "analytic", lab: "₹200 central pension unchanged across five general elections", d: "IGNOAPS central share ₹200/month in Nov 2025; no raise in any budget speech opened (2008, 2019i, 2019, 2023, 2024i, 2026); states carry the top-up", from: "2007-01-01", to: "2026-09-25", srcs: [["PIB Backgrounder, National Social Assistance Programme, 7 Nov 2025","https://www.pib.gov.in/PressNoteDetails.aspx?NoteId=155928&ModuleId=3"],["Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)","https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"],["Union Budget 2026-27 speech, Nirmala Sitharaman, 1 Feb 2026","https://www.indiabudget.gov.in/doc/Budget_Speech.pdf"]], innocentReading: "pensions are a state top-up domain; the Centre may prefer scheme-branded transfers (PM-KISAN, PMUY) over a jointly-branded one — an attribution logic, not a welfare one", upgradeIf: "2007 IGNOAPS notification opened confirming ₹200 base", killIf: "a central revision between 2007 and 2025 is found" },
  { id: "welfare-central:c054", s: "min:ministry-of-finance", t: "bjp", pred: "analytic", tier: "analytic", lab: "interim budget 2024: no new cash transfer", d: "1 Feb 2024 speech raised the Lakhpati Didi target and promised 2 crore PMAY-G houses and rooftop solar, but no PM-KISAN hike or new DBT — a null result for the 'pre-poll cash' hypothesis at LS 2024; BJP −63 seats", from: "2024-02-01", to: "2024-06-01", srcs: [["Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)","https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"],["Wikipedia (pointer), 2024 Indian general election","https://en.wikipedia.org/wiki/2024_Indian_general_election"]], innocentReading: "the government had already locked in PMGKAY (Nov 2023) and PM-KISAN (2019); fiscal consolidation was the stated priority", upgradeIf: "—", killIf: "—" },
  { id: "welfare-central:c055", s: "scheme:in-pm-vishwakarma", t: "bjp", pred: "analytic", tier: "analytic", lab: "launch on PM's birthday, 7 weeks before Nov 2023 polls; 51% of outlay in 2023-25", d: "launched 17 Sep 2023; ₹1,860 cr + ₹4,824 cr allocated in the two years bracketing the 2024 LS election out of ₹13,000 cr to 2030-31", from: "2023-09-17", to: "2024-06-01", srcs: [["PIB Research Unit backgrounder 'PM Vishwakarma Scheme: Honouring Heritage, Powering Progress', 16 Sep 2025 (PDF on file; exact document URL not recovered — see gaps)","https://www.pib.gov.in/"],["PIB (MSME RS reply), PM Vishwakarma outlay ₹13,000 crore and year-wise allocation, 21 Dec 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1989108"]], innocentReading: "front-loading is normal for a registration-plus-toolkit scheme (toolkit vouchers are one-off); only 57,815 had registered by Dec 2023, so little money reached artisans before the polls", upgradeIf: "loan disbursement clustered in Mar–Apr 2024", killIf: "disbursement profile flat across 2023-25" },
  { id: "welfare-central:c056", s: "scheme:pmjdy", t: "wel:bluekraft-digital-foundation", pred: "analytic", tier: "analytic", lab: "a private foundation's figure became the official savings claim", d: "PIB's 21 Apr 2025 release reproduces BlueKraft's ₹3.48 lakh cr and its self-defined index; no DBT Mission methodology is cited; the portal's year-wise totals are not machine-readable", from: "2025-04-21", srcs: [["PIB, 'India's DBT: Boosting Welfare Efficiency' (BlueKraft report relayed), 21 Apr 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2123192"],["DBT Bharat portal (opened; totals rendered by JavaScript, not extractable)","https://dbtbharat.gov.in/"]], innocentReading: "governments routinely publicise favourable third-party studies; the underlying deletions (e.g. 2.1 crore PM-KISAN) are real administrative events even if the rupee value is contestable", upgradeIf: "BlueKraft's funding and its relationship with government communications are disclosed", killIf: "DBT Mission publishes an independent audit reaching a similar figure" },
  { id: "women-cash:c001", s: "pol:shivraj-singh-chouhan", t: "scheme:mp-ladli-behna", pred: "role", tier: "documented", lab: "approved Ladli Behna (cabinet)", d: "MP cabinet under CM Chouhan approved Rs 1,000/month to women (then 23+) on 25 Feb 2023; scheme to launch 5 Mar 2023.", from: "2023-02-25", srcs: [["Deccan Herald/PTI, 25 Feb 2023: MP cabinet clears Ladli Bahna Rs 1,000","https://www.deccanherald.com/india/mp-govt-clears-scheme-to-give-rs-1000-to-women-above-23-under-ladli-bahna-yojana-1195069.html"]] },
  { id: "women-cash:c002", s: "scheme:mp-ladli-behna", t: "wel:class-mp-ladli-behna-women", pred: "pmout", tier: "documented", a: 18669, lab: "₹1,000→₹1,250→₹1,500/month", d: "Monthly DBT to ~1.26 cr women; Rs 1,541 cr per instalment (Oct 2025); 2025-26 BE Rs 18,669 cr.", from: "2023-06-10", srcs: [["India TV, 12 Oct 2025: Mohan Yadav transfers Rs 1,541 cr (29th instalment), announces Rs 1,500","https://www.indiatvnews.com/madhya-pradesh/madhya-pradesh-ladli-behna-scheme-yojana-cm-mohan-yadav-transfers-rs-1541-crore-announces-hike-to-rs-1500-2025-10-12-1012478"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "women-cash:c003", s: "scheme:mp-ladli-behna", t: "scheme:mp-ladli-behna", pred: "supersede", tier: "documented", lab: "₹1,000 → ₹1,250 (Oct 2023)", d: "Amount raised before the 17 Nov 2023 poll; the pre-poll instalment landed 9–10 Nov.", from: "2023-10", to: "2025-11-11", srcs: [["Deccan Herald, 3 Dec 2023: What worked for BJP in MP","https://www.deccanherald.com/india/madhya-pradesh/focus-on-women-voters-to-pm-modis-magic-what-worked-for-bjp-in-madhya-pradesh-assembly-elections-2794883"]] },
  { id: "women-cash:c004", s: "scheme:mp-ladli-behna", t: "scheme:mp-ladli-behna", pred: "supersede", tier: "reported", lab: "₹1,250 → ₹1,500 (Nov 2025)", d: "Announced 12 Oct 2025 for Bhai Dooj, missed, then cabinet-approved 10 Nov 2025; Rs 3,000 'planned' by 2028.", from: "2025-11-12", srcs: [["India TV, 12 Oct 2025: Mohan Yadav transfers Rs 1,541 cr (29th instalment), announces Rs 1,500","https://www.indiatvnews.com/madhya-pradesh/madhya-pradesh-ladli-behna-scheme-yojana-cm-mohan-yadav-transfers-rs-1541-crore-announces-hike-to-rs-1500-2025-10-12-1012478"],["IANS via Prokerala, 10 Nov 2025: MP cabinet approves Rs 1,500 from Nov 12; Rs 3,000 by 2028 plan","https://www.prokerala.com/news/articles/a1695417.html"]], upgradeIf: "MP WCD order for Rs 1,500 located", killIf: "Portal shows instalments still at Rs 1,250 after Nov 2025" },
  { id: "women-cash:c005", s: "scheme:mp-ladli-behna", t: "bjp", pred: "analytic", tier: "analytic", lab: "launched 5 months before poll; incumbent won +54 seats", d: "First payment 10 Jun 2023, poll 17 Nov 2023; BJP 163/230, vote share 48.6%.", from: "2023-06-10", to: "2023-11-17", srcs: [["Wikipedia infobox (pointer to ECI results): 2023 Madhya Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"],["Deccan Herald, 3 Dec 2023: What worked for BJP in MP","https://www.deccanherald.com/india/madhya-pradesh/focus-on-women-voters-to-pm-modis-magic-what-worked-for-bjp-in-madhya-pradesh-assembly-elections-2794883"]], innocentReading: "Fixed-term assembly: any 2023 launch would precede the November poll; Lokniti finds 80% of households covered, so the scheme cannot separate BJP from Congress voters; Congress promised more (Rs 1,500) and lost", upgradeIf: "A published Lokniti cross-tab of vote by Ladli Behna beneficiary status with a control", killIf: "Cross-tab shows no vote gap between beneficiary and non-beneficiary households" },
  { id: "women-cash:c006", s: "wel:lokniti-csds", t: "scheme:mp-ladli-behna", pred: "enforce", tier: "documented", lab: "post-poll: 80.4% households benefited", d: "Lokniti-CSDS MP post-poll 2023, Q22: 80.4% yes, 13.2% no, 1.8% not eligible (N=3,050).", from: "2023-11", srcs: [["Lokniti-CSDS, Madhya Pradesh Post-poll Survey 2023 — survey findings (PDF)","https://www.lokniti.org/media/PDF-upload/1703684877_6052900_download_report.pdf"]] },
  { id: "women-cash:c007", s: "wel:prs-legislative-research", t: "scheme:mp-ladli-behna", pred: "enforce", tier: "documented", lab: "UCT cuts MP revenue surplus 1.1%→0.4% of GSDP", d: "PRS SOSF 2025 Fig.14 counterfactual.", from: "2025-10", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "women-cash:c008", s: "wel:kamal-nath", t: "scheme:mp-nari-samman-promise-2023", pred: "role", tier: "reported", lab: "promised ₹1,500/month (lost)", d: "Congress counter-promise of Rs 18,000/yr made 5 Mar 2023; Congress fell to 66 seats.", from: "2023-03-05", to: "2023-12-03", srcs: [["Deccan Herald, 5 Mar 2023: Kamal Nath promises women Rs 18,000/yr ahead of Ladli Behna launch","https://www.deccanherald.com/national/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"],["Wikipedia infobox (pointer to ECI results): 2023 Madhya Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"]] },
  { id: "women-cash:c009", s: "wel:ajit-pawar", t: "scheme:mh-ladki-bahin", pred: "role", tier: "reported", lab: "presented budget introducing Ladki Bahin", d: "Announced in Maharashtra Budget 2024-25 (Jun 2024); Rs 46,000 cr annual cost cited.", from: "2024-06-28", srcs: [["Deccan Herald, 5 Aug 2024: Bombay HC dismisses PIL against Ladki Bahin","https://www.deccanherald.com/india/maharashtra/ladki-bahin-yojana-a-beneficiary-scheme-for-women-not-discriminatory-bombay-high-court-3137089"],["Deccan Herald, 15 Aug 2024: Shinde govt begins releasing Ladki Bahin money","https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"]] },
  { id: "women-cash:c010", s: "scheme:mh-ladki-bahin", t: "wel:class-mh-ladki-bahin-women", pred: "pmout", tier: "documented", a: 33232, lab: "₹1,500/month; ₹33,232 cr paid 2024-25", d: "2.53 cr women paid Rs 33,232 cr in 2024-25 (budget speech); Rs 36,000 cr BE 2025-26; Rs 26,500 cr BE 2026-27.", from: "2024-08-14", srcs: [["Deccan Herald, 10 Mar 2025: Maharashtra budget gives Rs 36,000 cr to Ladki Bahin, silent on Rs 2,100","https://www.deccanherald.com/india/maharashtra/maharashtra-govt-gives-rs-36000-crore-to-ladki-bahin-in-budget-mum-on-stipend-hike-ups-vehicle-tax-3440102"],["Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification","https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "women-cash:c011", s: "scheme:mh-ladki-bahin", t: "party:shiv-sena", pred: "analytic", tier: "analytic", lab: "launched 3 months before poll after LS setback; incumbent won 230/288", d: "Disbursal began 14 Aug 2024 after the Mahayuti won 17/48 LS seats; poll 20 Nov 2024.", from: "2024-08-14", to: "2024-11-20", srcs: [["Deccan Herald, 15 Aug 2024: Shinde govt begins releasing Ladki Bahin money","https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"],["Wikipedia infobox (pointer to ECI results): 2024 Maharashtra Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Maharashtra_Legislative_Assembly_election"],["BehanBox, 4 Dec 2024: Maharashtra poll analyses and women's agency (cites Lokniti-CSDS post-poll)","https://behanbox.com/2024/12/04/how-maharashtra-poll-analyses-are-missing-the-rise-of-womens-agency/"]], innocentReading: "Lokniti-CSDS: 3-point gender gap, 'hardly any connection between welfare and vote'; Maratha–OBC consolidation, Modi factor and candidate choice explain more of the swing", upgradeIf: "Constituency-level regression of Mahayuti swing on Ladki Bahin coverage", killIf: "No swing gradient by coverage" },
  { id: "women-cash:c012", s: "wel:eknath-shinde", t: "scheme:mh-ladki-bahin", pred: "role", tier: "reported", lab: "promised ₹2,000/₹3,000 for a bigger mandate", d: "Paranda, 14 Sep 2024; manifesto figure Rs 2,100; not enacted as of Jul 2026.", from: "2024-09-14", srcs: [["Deccan Herald, 14 Sep 2024: Shinde — bigger mandate, will raise Ladki Bahin to Rs 3,000","https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-give-us-a-bigger-mandate-will-double-ladki-bahin-dole-to-rs-3000-eknath-shinde-3191037"],["Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification","https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"]] },
  { id: "women-cash:c013", s: "scheme:mh-ladki-bahin", t: "scheme:mh-ladki-bahin", pred: "supersede", tier: "documented", lab: "₹1,500 → ₹500 for ~8 lakh Namo Shetkari recipients (Apr 2025)", d: "Cut under the Rs 1,500 combined cap; outlay Rs 46,000→36,000 cr; PRS records it as a fiscal-pressure cut.", from: "2025-04", srcs: [["Scroll, 16 Apr 2025: Maharashtra cuts Ladki Bahin payout for 8 lakh women to Rs 500","https://scroll.in/latest/1081399/maharashtra-cuts-ladki-bahin-yojana-payout-for-8-lakh-women-to-rs-500-per-month-report"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Deccan Herald, 16 Apr 2025: Aaditya Thackeray says Ladki Bahin 'more or less ended'; Tatkare response","https://www.deccanherald.com/india/maharashtra/ladki-bahin-scheme-more-or-less-finished-claims-aaditya-thackeray-3496353"]] },
  { id: "women-cash:c014", s: "scheme:mh-ladki-bahin", t: "scheme:mh-ladki-bahin", pred: "supersede", tier: "reported", lab: "2.43 cr → ~1.5 cr beneficiaries after eKYC (2026)", d: "92 lakh removed; ~Rs 14,000 cr paid to since-ineligible recipients; BE cut to Rs 26,500 cr.", from: "2026-07", srcs: [["Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification","https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"]], innocentReading: "Enrolment was by self-declaration during a fast launch (June-August 2024), and the government says the Model Code of Conduct blocked authentication until after the poll. When verification came, it removed genuine ineligibles (income above Rs 2.5 lakh, government staff, overlapping benefits, age, about 29,000 men) plus a large group (about 62 lakh) who did not complete eKYC. That second group includes eligible women who dropped out because of friction, not only ineligible ones. The budget cut reflects a smaller roll. The same pattern appears in PM-Kisan and other DBT schemes with no election in the frame.", upgradeIf: "WCD department order/press note with the removal breakdown", killIf: "Official count shows removals materially below 92 lakh" },
  { id: "women-cash:c015", s: "wel:supriya-sule", t: "claim:women-cash:c010", pred: "contra", tier: "alleged", a: 4800, lab: "alleges ₹4,800 cr Ladki Bahin fraud, seeks SIT", d: "Sule (NCP-SP) alleged a Rs 4,800 cr scam after 26.34 lakh were declared ineligible, 29 Jul 2025.", from: "2025-07-29", srcs: [["Deccan Herald, 29 Jul 2025: Supriya Sule alleges Rs 4,800 cr fraud, seeks SIT","https://www.deccanherald.com/india/maharashtra/supriya-sule-alleges-rs-4800-crore-fraud-in-ladki-bahin-yojana-seeks-sit-probe-3654533"]], innocentReading: "The Rs 4,800 cr is about what you get from 26.34 lakh people × Rs 1,500/month × about 12 months (roughly Rs 4,741 cr). It is the gross amount paid to beneficiaries the department later found ineligible, not money shown to have been stolen. Enrolment was fast, eligibility was self-declared, and the rollout came before the election. Verification (IT-department data matching, then eKYC) happened afterwards and removed ineligible people. That is a targeting error and a leakage problem, and the government disclosed it itself. It is not necessarily fraud with intent. Payments to men (Rs 21.44 cr) look closer to fraud and are being recovered.", upgradeIf: "SIT constituted or CAG audit finding of that magnitude", killIf: "Audit shows ineligible payments far below Rs 4,800 cr or attributable to targeting error" },
  { id: "women-cash:c016", s: "wel:aditi-tatkare", t: "claim:women-cash:c015", pred: "contra", tier: "reported", lab: "govt: eKYC delayed by MCC; men's ₹21.44 cr to be recovered", d: "Tatkare: 26.34 lakh suspended, 14,298 men paid Rs 21.44 cr to be recovered with FIRs; eKYC could not start before the Nov 2024 poll due to the Model Code; Ajit Pawar: 'no question of scrapping'.", from: "2025-07", srcs: [["Deccan Herald, 29 Jul 2025: Supriya Sule alleges Rs 4,800 cr fraud, seeks SIT","https://www.deccanherald.com/india/maharashtra/supriya-sule-alleges-rs-4800-crore-fraud-in-ladki-bahin-yojana-seeks-sit-probe-3654533"],["Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification","https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"],["Deccan Herald, 16 Apr 2025: Aaditya Thackeray says Ladki Bahin 'more or less ended'; Tatkare response","https://www.deccanherald.com/india/maharashtra/ladki-bahin-scheme-more-or-less-finished-claims-aaditya-thackeray-3496353"]] },
  { id: "women-cash:c017", s: "wel:tekchand-sawarkar", t: "scheme:mh-ladki-bahin", pred: "enforce", tier: "alleged", lab: "'jugaad to get women's votes' (ruling-party MLA)", d: "BJP MLA Sawarkar's remark, Sep 2024, seized on by Congress as admitting intent.", from: "2024-09-25", srcs: [["Deccan Herald/PTI, 25 Sep 2024: BJP MLA Tekchand Sawarkar calls Ladki Bahin a 'jugaad' for women's votes","https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ladki-bahin-a-jugaad-to-get-womens-votes-says-bjp-mla-tekchand-sawarkar-3206053"]], innocentReading: "This was stump rhetoric at a local rally. A backbench MLA claimed credit for a popular benefit and asked beneficiaries to vote for the lotus, which is how every incumbent campaigns on delivered welfare. He was not describing how the cabinet actually decided. The scheme was announced in the regular 2024-25 budget, and the MP Ladli Behna model had already been copied across states. Nothing in the reports shows that his view reflects how the scheme was really designed.", upgradeIf: "Recording of the remark in context", killIf: "Remark shown to be misquoted" },
  { id: "women-cash:c018", s: "bombay-hc", t: "scheme:mh-ladki-bahin", pred: "enforce", tier: "documented", lab: "PIL dismissed: policy decision", d: "Chief Justice Upadhyaya and Justice Borkar, 5 Aug 2024; no fundamental-rights violation.", from: "2024-08-05", srcs: [["Deccan Herald, 5 Aug 2024: Bombay HC dismisses PIL against Ladki Bahin","https://www.deccanherald.com/india/maharashtra/ladki-bahin-yojana-a-beneficiary-scheme-for-women-not-discriminatory-bombay-high-court-3137089"]] },
  { id: "women-cash:c019", s: "bombay-hc", t: "claim:women-cash:c017", pred: "contra", tier: "documented", lab: "court: scheme is lawful policy, not discriminatory", d: "The HC ruling is the institutional answer to the 'inducement' framing.", from: "2024-08-05", srcs: [["Deccan Herald, 5 Aug 2024: Bombay HC dismisses PIL against Ladki Bahin","https://www.deccanherald.com/india/maharashtra/ladki-bahin-yojana-a-beneficiary-scheme-for-women-not-discriminatory-bombay-high-court-3137089"]] },
  { id: "women-cash:c020", s: "scheme:mh-ladki-bahin", t: "wel:class-mh-ladki-bahin-ad-vendors", pred: "award", tier: "reported", a: 250, lab: "₹250 cr advertising blitz", d: "Shinde government spent Rs 250 cr on Ladki Bahin ads (BehanBox); vendors and contracts not published.", from: "2024-07", to: "2024-11", srcs: [["BehanBox, 4 Dec 2024: Maharashtra poll analyses and women's agency (cites Lokniti-CSDS post-poll)","https://behanbox.com/2024/12/04/how-maharashtra-poll-analyses-are-missing-the-rise-of-womens-agency/"]], upgradeIf: "DGIPR advertisement expenditure statement or RTI reply naming agencies", killIf: "Official spend materially lower" },
  { id: "women-cash:c021", s: "scheme:ka-gruha-lakshmi", t: "wel:class-ka-gruha-lakshmi-women", pred: "pmout", tier: "documented", a: 28608, lab: "₹2,000/month; ₹50,005 cr cumulative", d: "1.28 cr women; Rs 28,608 cr BE 2025-26; two instalments skipped in 2024-25.", from: "2023-06", srcs: [["Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed","https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "women-cash:c022", s: "cag", t: "scheme:ka-gruha-lakshmi", pred: "enforce", tier: "reported", lab: "CAG: guarantees taxing state resources", d: "CAG report (Aug 2025) as paraphrased by Deccan Herald; report text not obtained.", from: "2025-08", srcs: [["Deccan Herald, 26 Aug 2025: H M Revanna rejects CAG conclusions on Karnataka guarantee schemes","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"]], upgradeIf: "CAG State Finances Audit Report (Karnataka) 2023-24 text located", killIf: "Report does not make the stated conclusion" },
  { id: "women-cash:c023", s: "wel:h-m-revanna", t: "claim:women-cash:c022", pred: "contra", tier: "reported", lab: "Guarantee Authority: CAG 'far from the truth'", d: "Revanna: per-capita income and GST up; Rs 94,177 cr spent; 98% implemented.", from: "2025-08-25", srcs: [["Deccan Herald, 26 Aug 2025: H M Revanna rejects CAG conclusions on Karnataka guarantee schemes","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"]] },
  { id: "women-cash:c024", s: "scheme:ka-gruha-lakshmi", t: "scheme:ka-gruha-lakshmi", pred: "supersede", tier: "reported", lab: "2.13 lakh IT/GST-paying households removed (Sep 2025)", d: "Removed via Kutumba-app self-updates; none had been paid; 59,000 wrongly-excluded restored.", from: "2025-09", srcs: [["Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed","https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"],["Deccan Herald, 26 Aug 2025: H M Revanna rejects CAG conclusions on Karnataka guarantee schemes","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"]] },
  { id: "women-cash:c025", s: "wel:prs-legislative-research", t: "scheme:ka-gruha-lakshmi", pred: "enforce", tier: "documented", lab: "UCT turns KA revenue surplus 0.3% into deficit 0.6% of GSDP", d: "PRS SOSF 2025 Fig.14.", from: "2025-10", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "women-cash:c026", s: "wel:mk-stalin", t: "scheme:tn-kalaignar-magalir-urimai-thogai", pred: "role", tier: "reported", lab: "launched KMUT, 1.06 cr women", d: "Kanchipuram, 15 Sep 2023; targeted despite a universal manifesto promise.", from: "2023-09-15", srcs: [["Deccan Herald, 15 Sep 2023: Stalin launches Rs 1,000 monthly scheme for 1.06 cr women","https://www.deccanherald.com/india/tamil-nadu/stalin-launches-rs-1000-monthly-assistance-scheme-for-women-heads-of-families-2687619"]] },
  { id: "women-cash:c027", s: "scheme:tn-kalaignar-magalir-urimai-thogai", t: "wel:class-tn-kmut-women", pred: "pmout", tier: "documented", a: 13807, lab: "₹1,000/month to 1.13 cr; ₹13,807 cr BE 2025-26", from: "2023-09-15", srcs: [["Deccan Herald, 10 Nov 2023: TN adds 7.35 lakh beneficiaries; 1.13 cr total","https://www.deccanherald.com/india/tamil-nadu/tamil-nadu-expands-monthly-assistance-scheme-to-women-adds-7-lakh-beneficiaries-2766189"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "women-cash:c028", s: "scheme:tn-kalaignar-magalir-urimai-thogai", t: "party:dmk", pred: "analytic", tier: "analytic", lab: "31 months of transfers; incumbent lost (DMK 59)", d: "TVK 108, DMK 59, AIADMK 47; Stalin lost Kolathur; result 4 May 2026.", from: "2023-09-15", to: "2026-04-23", srcs: [["Wikipedia (pointer): 2026 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"]], innocentReading: "A new celebrity-led party and 85% turnout dominate; the scheme was 2.5 years old and no longer novel; the BJP and Congress promised Rs 2,000", upgradeIf: "Lokniti-CSDS TN 2026 post-poll on KMUT beneficiaries", killIf: "Beneficiaries voted DMK at markedly higher rates than non-beneficiaries (would show the scheme worked but was outweighed)" },
  { id: "women-cash:c029", s: "wel:mamata-banerjee", t: "scheme:wb-lakshmir-bhandar", pred: "role", tier: "reported", lab: "introduced Lakshmir Bhandar (2021)", d: "Announced Feb 2021 (pre-poll), launched after the 2021 win at Rs 500/1,000.", from: "2021-02", srcs: [["South 24 Parganas district portal: Lakshmir Bhandar scheme page","https://s24pgs.gov.in/lakshmir-bhandar/"],["Deccan Herald, 6 Jun 2024: Mamata cashes in on Lakshmir Bhandar in LS 2024","https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mamata-banerjee-cashes-in-on-lakshmir-bhandar-and-modis-shift-to-hindutva-in-west-bengal-3055262"]] },
  { id: "women-cash:c030", s: "scheme:wb-lakshmir-bhandar", t: "wel:class-wb-lakshmir-bhandar-women", pred: "pmout", tier: "documented", a: 26700, lab: "₹1,000/1,200 → ₹1,500/1,700; ₹26,700 cr BE 2025-26", d: "Allocation up 15% over 2024-25 RE (PRS).", from: "2021", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["ANI, 6 Feb 2026: West Bengal announces Rs 500 Lakshmir Bhandar hike in interim budget 2026-27","https://www.aninews.in/news/national/politics/west-bengal-govt-announces-rs-500-hike-for-lakshmir-bhandar-beneficaries-ahead-of-assembly-polls20260206060332/"]] },
  { id: "women-cash:c031", s: "scheme:wb-lakshmir-bhandar", t: "scheme:wb-lakshmir-bhandar", pred: "supersede", tier: "reported", lab: "₹500→₹1,000 / ₹1,000→₹1,200 before LS 2024", d: "Raised 'just before the parliamentary polls'; TMC won 29/42 (+7).", from: "2024-04", to: "2026-01", srcs: [["Deccan Herald, 6 Jun 2024: Mamata cashes in on Lakshmir Bhandar in LS 2024","https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mamata-banerjee-cashes-in-on-lakshmir-bhandar-and-modis-shift-to-hindutva-in-west-bengal-3055262"]] },
  { id: "women-cash:c032", s: "scheme:wb-lakshmir-bhandar", t: "scheme:wb-lakshmir-bhandar", pred: "supersede", tier: "reported", lab: "+₹500 from Feb 2026 (interim budget)", d: "Announced 5 Feb 2026, 11 weeks before polling; Mamata: 'we present this budget for the people, not for the election'.", from: "2026-02", srcs: [["ANI, 6 Feb 2026: West Bengal announces Rs 500 Lakshmir Bhandar hike in interim budget 2026-27","https://www.aninews.in/news/national/politics/west-bengal-govt-announces-rs-500-hike-for-lakshmir-bhandar-beneficaries-ahead-of-assembly-polls20260206060332/"]] },
  { id: "women-cash:c033", s: "scheme:wb-lakshmir-bhandar", t: "party:tmc", pred: "analytic", tier: "analytic", lab: "pre-poll hike; incumbent lost 215→80", d: "BJP 208, AITC 80; BJP had promised Rs 3,000.", from: "2026-02", to: "2026-05-04", srcs: [["Wikipedia (pointer): 2026 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2026_West_Bengal_Legislative_Assembly_election"],["India TV, 4–5 May 2026: West Bengal 2026 result — BJP wins","https://www.indiatvnews.com/west-bengal/news-west-bengal-assembly-election-2026-full-list-of-winners-leading-candidates-294-seats-2026-05-04-1038758"],["The Logical Indian, 4 May 2026: fiscal reality behind 2026 cash promises to women","https://thelogicalindian.com/elections-results-2026-the-fiscal-reality-behind-indias-cash-promises-to-women/"]], innocentReading: "Fifteen-year anti-incumbency and a rival offering triple the amount; a cash transfer is neither necessary nor sufficient for re-election", upgradeIf: "Lokniti-CSDS WB 2026 post-poll by Lakshmir Bhandar status", killIf: "—" },
  { id: "women-cash:c034", s: "pol:narendra-modi", t: "scheme:or-subhadra", pred: "role", tier: "documented", lab: "launched Subhadra (17 Sep 2024)", d: "PM launched Odisha's flagship scheme in Bhubaneswar on the government's 100th day; 'linked to the pilot project of RBI's digital currency'.", from: "2024-09-17", srcs: [["PIB, 17 Sep 2024: PM launches SUBHADRA in Bhubaneswar","https://www.pib.gov.in/PressReleseDetailm.aspx?PRID=2055572&reg=3&lang=2"]] },
  { id: "women-cash:c035", s: "scheme:or-subhadra", t: "wel:class-or-subhadra-women", pred: "pmout", tier: "documented", a: 55825, lab: "₹10,000/yr; ₹55,825 cr over 5 years", d: "Rs 10,145 cr BE 2025-26 (PRS); ~1 cr paid second instalment Mar 2025 (pointer).", from: "2024-09-17", to: "2029-03-31", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Wikipedia (pointer): Subhadra Yojana","https://en.wikipedia.org/wiki/Subhadra_Yojana"],["Deccan Herald/PTI, 17 Sep 2024: PM launches Subhadra; Rs 10,000/yr; 76 lakh registered; Rs 1,250 cr to 25 lakh","https://www.deccanherald.com/india/odisha/pm-modi-launches-odisha-govts-subhadra-scheme-railway-nh-projects-worth-over-rs-3800-cr-3193991"]] },
  { id: "women-cash:c036", s: "pol:jagat-prakash-nadda", t: "scheme:or-subhadra", pred: "role", tier: "reported", lab: "promised ₹50,000 vouchers mid-election", d: "BJP post of 15–16 May 2024 first implied a national promise, deleted and clarified as Odisha-only; manifesto said married women 23–59.", from: "2024-05-16", srcs: [["Business Standard, 16 May 2024: BJP 'promises' Rs 50,000 vouchers to women, then clarifies Odisha-only","https://www.business-standard.com/elections/assembly-election/lok-sabha-elections-bjp-promises-rs-50-000-cash-vouchers-to-women-then-clarifies-124051600178_1.html"]] },
  { id: "women-cash:c037", s: "scheme:or-subhadra", t: "bjp", pred: "analytic", tier: "analytic", lab: "promised mid-poll, launched 3.5 months after the win", d: "Challenger's promise, honoured post-election; no pre-poll disbursement.", from: "2024-05-16", to: "2024-09-17", srcs: [["Business Standard, 16 May 2024: BJP 'promises' Rs 50,000 vouchers to women, then clarifies Odisha-only","https://www.business-standard.com/elections/assembly-election/lok-sabha-elections-bjp-promises-rs-50-000-cash-vouchers-to-women-then-clarifies-124051600178_1.html"],["PIB, 17 Sep 2024: PM launches SUBHADRA in Bhubaneswar","https://www.pib.gov.in/PressReleseDetailm.aspx?PRID=2055572&reg=3&lang=2"]], innocentReading: "This is the textbook manifesto-to-delivery sequence; timing carries no inducement value", upgradeIf: "—", killIf: "—" },
  { id: "women-cash:c038", s: "wel:hemant-soren", t: "scheme:jh-maiya-samman", pred: "role", tier: "reported", a: 9000, lab: "approved hike to ₹2,500 a month before polling", d: "Cabinet nod 14 Oct 2024, effective Dec 2024; 'additional Rs 9,000 crore burden' (Cabinet Secretary).", from: "2024-10-14", srcs: [["Deccan Herald/PTI, 14 Oct 2024: Jharkhand cabinet raises Maiya Samman to Rs 2,500 from Dec 2024","https://www.deccanherald.com/india/jharkhand/jharkhand-cabinet-nod-to-hike-financial-assistance-for-women-to-rs-30000-per-year-from-rs-12000-3231863"]] },
  { id: "women-cash:c039", s: "scheme:jh-maiya-samman", t: "wel:class-jh-maiya-samman-women", pred: "pmout", tier: "documented", a: 13363, lab: "₹2,500/month to 56.6 lakh; ₹13,363 cr BE 2025-26", from: "2024-08-18", srcs: [["IMPRI policy update: Mukhyamantri Maiya Samman Yojana in practice","https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "women-cash:c040", s: "scheme:jh-maiya-samman", t: "party:jmm", pred: "analytic", tier: "analytic", lab: "launched 3 months before poll, hike approved 1 month before; incumbent won", d: "JMM 34 seats, alliance majority; BJP had counter-promised Rs 25,000/yr.", from: "2024-08-18", to: "2024-11-20", srcs: [["IMPRI policy update: Mukhyamantri Maiya Samman Yojana in practice","https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"],["Deccan Herald/PTI, 14 Oct 2024: Jharkhand cabinet raises Maiya Samman to Rs 2,500 from Dec 2024","https://www.deccanherald.com/india/jharkhand/jharkhand-cabinet-nod-to-hike-financial-assistance-for-women-to-rs-30000-per-year-from-rs-12000-3231863"],["Wikipedia infobox (pointer to ECI results): 2024 Jharkhand Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Jharkhand_Legislative_Assembly_election"]], innocentReading: "Competitive bidding by both alliances; voters chose between two cash offers, so the offer itself is not what distinguished the winner", upgradeIf: "Post-poll survey by beneficiary status", killIf: "—" },
  { id: "women-cash:c041", s: "pol:narendra-modi", t: "scheme:ct-mahtari-vandan", pred: "role", tier: "documented", a: 655, lab: "launched Mahtari Vandan; 'Modi's guarantee'", d: "10 Mar 2024, Rs 655 cr first instalment to ~70 lakh married women.", from: "2024-03-10", srcs: [["PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr","https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"]] },
  { id: "women-cash:c042", s: "scheme:ct-mahtari-vandan", t: "wel:class-ct-mahtari-vandan-women", pred: "pmout", tier: "documented", a: 5500, lab: "₹1,000/month; ₹5,500 cr BE 2025-26", from: "2024-03-10", srcs: [["PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr","https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "women-cash:c043", s: "wel:himanta-biswa-sarma", t: "scheme:as-orunodoi", pred: "role", tier: "reported", lab: "designed Orunodoi (Budget 2020-21); launched 3.0 (Sep 2024)", d: "Rs 830 → Rs 1,250; 24.6 lakh → 37.2 lakh; Rs 467 cr/month.", from: "2020-03", srcs: [["ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month","https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"]] },
  { id: "women-cash:c044", s: "scheme:as-orunodoi", t: "wel:class-as-orunodoi-households", pred: "pmout", tier: "documented", a: 5000, lab: "₹1,250/month to ~37–40 lakh; ₹5,000 cr BE 2025-26", d: "Allocation up 31% over 2024-25 RE (PRS).", from: "2020-12", srcs: [["ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month","https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "women-cash:c045", s: "scheme:as-orunodoi", t: "bjp", pred: "analytic", tier: "analytic", lab: "launched ~6 months before 2021 poll; expanded 20 months before 2026; incumbent won both", d: "BJP 60 (2021), 82 (2026).", from: "2020-12", to: "2026-05-04", srcs: [["Wikipedia infobox (pointer to ECI results): 2021 Assam Legislative Assembly election","https://en.wikipedia.org/wiki/2021_Assam_Legislative_Assembly_election"],["India TV, 4 May 2026: Assam 2026 result — BJP 82 seats","https://www.indiatvnews.com/north-east/assam/assam-election-result-2026-live-updates-himanta-biswa-sarma-led-bjp-wins-setback-for-congress-1039454"]], innocentReading: "Assam's BJP has won on identity and infrastructure issues as well; the scheme's 2021 launch also coincided with COVID relief", upgradeIf: "Post-poll survey by Orunodoi status", killIf: "—" },
  { id: "women-cash:c046", s: "wel:sukhvinder-singh-sukhu", t: "scheme:hp-indira-gandhi-pyari-behna", pred: "role", tier: "reported", lab: "₹1,500 guarantee delivered to 35,687 women by Aug 2026", d: "Rs 29.12 cr over three years; 16 segments with zero beneficiaries.", from: "2024-03", srcs: [["ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals","https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"]] },
  { id: "women-cash:c047", s: "scheme:hp-indira-gandhi-pyari-behna", t: "wel:class-hp-pyari-behna-women", pred: "pmout", tier: "reported", a: 138, lab: "₹138 cr BE vs ₹11.64 cr paid (2025-26)", d: "PRS notes the phased roll-out.", from: "2024", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals","https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"]] },
  { id: "women-cash:c048", s: "wel:rekha-gupta", t: "scheme:dl-mahila-samriddhi", pred: "role", tier: "reported", a: 5110, lab: "cabinet approved ₹2,500/month, ₹5,100 cr — unpaid", d: "Approved 8 Mar 2025; committee formed; not launched by Jul 2026; Rs 5,110 cr in 2026-27 budget.", from: "2025-03-08", srcs: [["Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr","https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"],["India TV, 8 Jul 2026: Delhi to launch Mahila Samriddhi on Raksha Bandhan; Rs 5,110 cr 2026-27","https://www.indiatvnews.com/delhi/delhi-govt-to-launch-mahila-samriddhi-yojana-on-raksha-bandhan-check-who-can-get-rs-2500-monthly-and-required-documents-2026-07-08-1047512"]] },
  { id: "women-cash:c049", s: "wel:atishi", t: "claim:women-cash:c048", pred: "contra", tier: "reported", lab: "AAP: 'Modi lied'; only a committee formed", d: "Atishi, 8 Mar 2025: women waiting for Rs 2,500 messages.", from: "2025-03-08", srcs: [["Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr","https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"]] },
  { id: "women-cash:c050", s: "wel:arvind-kejriwal", t: "scheme:dl-mahila-samman-promise-2025", pred: "role", tier: "reported", lab: "₹1,000 approved, ₹2,100 promised, nothing paid; lost", d: "Cabinet nod 12 Dec 2024 nine months after the budget; ThePrint: planning and finance departments objected.", from: "2024-12-12", to: "2025-02-20", srcs: [["Deccan Herald, 12 Dec 2024: Kejriwal announces Rs 1,000 (Rs 2,100 after polls) for Delhi women","https://www.deccanherald.com/elections/delhi/delhi-assembly-elections-2025-ahead-of-polls-cabinet-approves-proposal-of-giving-rs-1000-to-women-every-months-3314631"],["ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs","https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"]] },
  { id: "women-cash:c051", s: "wel:arvind-kejriwal", t: "scheme:pb-women-1000-promise", pred: "role", tier: "reported", lab: "Punjab ₹1,000 guarantee (2022) unfulfilled", d: "Three years without implementation; AAP: 'this shall also be done'.", from: "2022-02", srcs: [["ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs","https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"]] },
  { id: "women-cash:c052", s: "wel:revanth-reddy", t: "scheme:tg-mahalakshmi-cash", pred: "role", tier: "reported", lab: "₹2,500 Mahalakshmi cash guarantee unpaid", d: "Fact check (Jan 2025): zero recipients; bus and LPG components live.", from: "2023-12-07", srcs: [["The South First, 8 Jan 2025: fact check — Rs 2,500 Mahalakshmi not paid","https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"]] },
  { id: "women-cash:c053", s: "wel:n-chandrababu-naidu", t: "scheme:ap-talliki-vandanam", pred: "role", tier: "reported", lab: "launched Talliki Vandanam (Jun 2025)", d: "Rs 15,000 per school child to 43 lakh mothers; Rs 2,000 retained for schools.", from: "2025-06-12", srcs: [["Deccan Herald/PTI, 13 Jun 2025: AP launches Talliki Vandanam Rs 15,000 per child","https://www.deccanherald.com/india/andhra-pradesh/andhra-govt-launches-talliki-vandanam-scheme-rs-15000-to-be-given-for-school-going-child-3584484"]] },
  { id: "women-cash:c054", s: "pol:narendra-modi", t: "scheme:br-mahila-rozgar-yojana", pred: "role", tier: "documented", a: 7500, lab: "launched Bihar MMRY; ₹7,500 cr to 75 lakh women in a day", d: "26 Sep 2025 via video conference; ECI schedule followed on 6 Oct 2025.", from: "2025-09-26", srcs: [["PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"],["PIB/ECI, 6 Oct 2025: General Election to the Legislative Assembly of Bihar, 2025 (schedule release)","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2175533"]] },
  { id: "women-cash:c055", s: "scheme:br-mahila-rozgar-yojana", t: "wel:class-br-mmry-women", pred: "pmout", tier: "documented", a: 7500, lab: "₹10,000 one-time; up to ₹2 lakh later", from: "2025-09-26", srcs: [["PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"]] },
  { id: "women-cash:c056", s: "scheme:br-mahila-rozgar-yojana", t: "party:jdu", pred: "analytic", tier: "analytic", lab: "₹7,500 cr paid ~6 weeks before polling; incumbent NDA 202/243", d: "The single largest pre-poll cash event in this file.", from: "2025-09-26", to: "2025-11-14", srcs: [["PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"],["Deccan Herald, 15 Nov 2025: Bihar results — NDA 202 seats","https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-results-nda-cruises-to-victory-by-winning-202-seats-and-a-vote-share-of-over-40-3798063"]], innocentReading: "Assembly term ended 22 Nov 2025, so the poll window was fixed and known; scheme framed as SHG seed capital via an existing programme; NDA's gains also tracked a consolidated alliance and the SIR-revised rolls", upgradeIf: "Lokniti-CSDS Bihar 2025 post-poll by MMRY receipt", killIf: "—" },
  { id: "women-cash:c057", s: "wel:nayab-singh-saini", t: "scheme:hr-lado-lakshmi", pred: "role", tier: "analytic", lab: "notified Lado Lakshmi (₹2,100) 11.5 months after the poll", d: "Cabinet 28 Aug 2025; gazette 15 Sep 2025; operative 25 Sep 2025; phase 1 income ≤ Rs 1 lakh, age 23+.", from: "2025-09-15", srcs: [["Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification","https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"],["Deccan Herald/PTI, 28 Aug 2025: Haryana cabinet decides to roll out Lado Lakshmi from Sep 25","https://www.deccanherald.com/india/haryana/haryana-decides-to-implement-lado-lakshmi-yojana-eligible-women-to-get-rs-2100-monthly-aid-3700884"]], innocentReading: "The assembly term ended on 22 Nov 2025 (confirmed in the ECI release), so any benefit launched after mid-2025 would fall inside the poll window. The scheme is designed as livelihood seed capital through the existing JEEVIKA SHG network, with up to Rs 2 lakh more in later phases tied to business progress, not an open-ended monthly cash payment. Cabinet approval (29 Aug) and the launch came before the MCC. The NDA swing has many other plausible causes: coalition realignment (LJP(RV) back in the NDA), the SIR roll revision, and anti-incumbency against the opposition alliance. No study isolates the effect of MMRY." },
  { id: "women-cash:c058", s: "scheme:hr-lado-lakshmi", t: "wel:class-hr-lado-lakshmi-women", pred: "pmout", tier: "documented", a: 5000, lab: "₹2,100/month; ₹5,000 cr BE 2025-26", d: "DBT via PFMS.", from: "2025-09-25", srcs: [["Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification","https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "women-cash:c059", s: "ministry:hr-sewa", t: "psu:hartron", pred: "award", tier: "documented", lab: "Lado Lakshmi App developed by HARTRON", d: "Gazette names HARTRON (state PSU) as developer; verification by CRID; contract value not published.", from: "2025-09-15", srcs: [["Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification","https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"]] },
  { id: "women-cash:c060", s: "wel:ashok-gehlot", t: "scheme:rj-grah-laxmi-guarantee-2023", pred: "role", tier: "reported", lab: "promised ₹10,000/yr one month before poll; lost", d: "Jhunjhunu, 25 Oct 2023; BJP 115, INC 70.", from: "2023-10-25", to: "2023-12-03", srcs: [["Deccan Herald, 25 Oct 2023: Gehlot promises Rs 10,000/yr to woman head of family","https://www.deccanherald.com/elections/rajasthan/rajasthan-polls-gehlot-promises-rs-10000year-to-woman-head-of-families-lpg-cylinder-at-rs-500-2740998"],["Wikipedia infobox (pointer to ECI results): 2023 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"]] },
  { id: "women-cash:c061", s: "pol:narendra-modi", t: "bjp", pred: "role", tier: "reported", lab: "'revadi culture' speech vs BJP state schemes", d: "16 Jul 2022: freebies for votes 'very dangerous'; BJP governments later ran Ladli Behna, Ladki Bahin, Subhadra, Mahtari Vandan, Orunodoi, Lado Lakshmi, Mahila Samriddhi and co-launched Bihar MMRY.", from: "2022-07-16", srcs: [["The Tribune/PTI, 16 Jul 2022: PM Modi warns against 'revadi culture' at Jalaun","https://www.tribuneindia.com/news/uncategorized/revadi-culture-dangerous-for-development-of-country-says-pm-modi-urges-youth-to-guard-against-it-413011/"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]] },
  { id: "women-cash:c062", s: "wel:rbi", t: "wel:class-uct-states-12", pred: "enforce", tier: "reported", lab: "RBI 2024: rationalise cash transfers to women/youth/farmers", d: "State Finances 2024-25 (Dec 2024) warned of stress; as summarised by PRS.", from: "2024-12", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]], upgradeIf: "RBI report text located and quoted", killIf: "—" },
  { id: "women-cash:c063", s: "wel:prs-legislative-research", t: "wel:class-uct-states-12", pred: "enforce", tier: "documented", a: 168040, lab: "₹1,68,040 cr (0.5% of GDP) on women's UCTs, 2025-26 BE; 6 of 12 in revenue deficit", d: "States to spend ~6% of revenue expenditure on UCTs.", from: "2025-10", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Deccan Herald/PTI, 5 Nov 2025: 12 states to spend Rs 1.68 lakh crore on women's cash schemes (PRS)","https://www.deccanherald.com/india/12-states-to-spend-rs-168-lakh-crore-on-womens-cash-schemes-report-3787198"]] },
];

/** Claim id → the research domain (file stem) it came from, for every edge and every held claim. */
export const WELFARE_EDGE_DOMAIN: Record<string, string> = {
  "claim:ajitpawar-presentbudget-ladkibahin": "elections-timing",
  "claim:ap2024-counter-narrative": "elections-timing",
  "claim:baghel-approve-ctloanwaiver": "elections-timing",
  "claim:bihar2025-closest-fit": "elections-timing",
  "claim:bjp-contra-ladlibehna": "elections-timing",
  "claim:cag-audit-loanwaiver2008": "elections-timing",
  "claim:chidambaram-announce-loanwaiver2008": "elections-timing",
  "claim:delhi2025-counter-narrative": "elections-timing",
  "claim:gehlot-announce-mehangairahat": "elections-timing",
  "claim:jagan-announce-rythubharosa": "elections-timing",
  "claim:kcr-announce-rythubandhu": "elections-timing",
  "claim:kejriwal-promise-mahilasamman": "elections-timing",
  "claim:ladkibahin-csds-finding": "elections-timing",
  "claim:ladlibehna-election-timing": "elections-timing",
  "claim:mamata-announce-lakshmirbhandar": "elections-timing",
  "claim:manmohan-announce-mgnrega": "elections-timing",
  "claim:mann-approve-punjabfreepower": "elections-timing",
  "claim:modi-announce-mahilarozgar": "elections-timing",
  "claim:modi-announce-pmgkay-extension": "elections-timing",
  "claim:modi-announce-pmkisan": "elections-timing",
  "claim:modi-announce-subhadra": "elections-timing",
  "claim:nda-contra-mahilarozgar": "elections-timing",
  "claim:patnaik-announce-kalia": "elections-timing",
  "claim:pmkisan-election-timing": "elections-timing",
  "claim:rj2023-anti-incumbency": "elections-timing",
  "claim:shivraj-announce-ladlibehna": "elections-timing",
  "claim:siddaramaiah-announce-gruhalakshmi": "elections-timing",
  "claim:soren-announce-maiyasamman": "elections-timing",
  "claim:stalin-announce-kmut": "elections-timing",
  "claim:sukhu-approve-ops": "elections-timing",
  "claim:tmc-contra-lakshmirbhandar": "elections-timing",
  "claim:wb2026-counter-narrative": "elections-timing",
  "fiscal:c001": "fiscal-results",
  "fiscal:c002": "fiscal-results",
  "fiscal:c003": "fiscal-results",
  "fiscal:c004": "fiscal-results",
  "fiscal:c005": "fiscal-results",
  "fiscal:c006": "fiscal-results",
  "fiscal:c007": "fiscal-results",
  "fiscal:c008": "fiscal-results",
  "fiscal:c009": "fiscal-results",
  "fiscal:c010": "fiscal-results",
  "fiscal:c010:audit-contra": "fiscal-results",
  "fiscal:c011": "fiscal-results",
  "fiscal:c012": "fiscal-results",
  "fiscal:c013": "fiscal-results",
  "fiscal:c014": "fiscal-results",
  "fiscal:c015": "fiscal-results",
  "fiscal:c016": "fiscal-results",
  "fiscal:c017": "fiscal-results",
  "fiscal:c018": "fiscal-results",
  "fiscal:c019": "fiscal-results",
  "fiscal:c020": "fiscal-results",
  "fiscal:c021": "fiscal-results",
  "fiscal:c022": "fiscal-results",
  "fiscal:c023": "fiscal-results",
  "fiscal:c024": "fiscal-results",
  "fiscal:c025": "fiscal-results",
  "ladlibehna-alleged-inducement": "elections-timing",
  "lakshmirbhandar-alleged-inducement-2026": "elections-timing",
  "lit-w:c001": "literature",
  "lit-w:c002": "literature",
  "lit-w:c003": "literature",
  "lit-w:c004": "literature",
  "lit-w:c005": "literature",
  "lit-w:c006": "literature",
  "lit-w:c007": "literature",
  "lit-w:c008": "literature",
  "lit-w:c009": "literature",
  "lit-w:c010": "literature",
  "lit-w:c011": "literature",
  "lit-w:c012": "literature",
  "lit-w:c013": "literature",
  "lit-w:c013:audit-contra": "literature",
  "lit-w:c014": "literature",
  "lit-w:c015": "literature",
  "lit-w:c016": "literature",
  "lit-w:c017": "literature",
  "lit-w:c018": "literature",
  "lit-w:c019": "literature",
  "lit-w:c020": "literature",
  "lit-w:c021": "literature",
  "lit-w:c022": "literature",
  "lit-w:c023": "literature",
  "lit-w:c024": "literature",
  "lit-w:c025": "literature",
  "lit-w:c026": "literature",
  "mahilarozgar-alleged-bribe": "elections-timing",
  "sco:c001": "state-cash-other",
  "sco:c002": "state-cash-other",
  "sco:c003": "state-cash-other",
  "sco:c004": "state-cash-other",
  "sco:c005": "state-cash-other",
  "sco:c006": "state-cash-other",
  "sco:c007": "state-cash-other",
  "sco:c008": "state-cash-other",
  "sco:c009": "state-cash-other",
  "sco:c010": "state-cash-other",
  "sco:c011": "state-cash-other",
  "sco:c012": "state-cash-other",
  "sco:c013": "state-cash-other",
  "sco:c014": "state-cash-other",
  "sco:c015": "state-cash-other",
  "sco:c016": "state-cash-other",
  "sco:c017": "state-cash-other",
  "sco:c018": "state-cash-other",
  "sco:c019": "state-cash-other",
  "sco:c020": "state-cash-other",
  "sco:c021": "state-cash-other",
  "sco:c022": "state-cash-other",
  "sco:c023": "state-cash-other",
  "sco:c024": "state-cash-other",
  "sco:c025": "state-cash-other",
  "sco:c026": "state-cash-other",
  "sco:c027": "state-cash-other",
  "sco:c028": "state-cash-other",
  "sco:c029": "state-cash-other",
  "sco:c030": "state-cash-other",
  "sco:c031": "state-cash-other",
  "sco:c032": "state-cash-other",
  "sco:c033": "state-cash-other",
  "sco:c034": "state-cash-other",
  "sco:c035": "state-cash-other",
  "sco:c036": "state-cash-other",
  "sco:c037": "state-cash-other",
  "sco:c038": "state-cash-other",
  "sco:c039": "state-cash-other",
  "sco:c040": "state-cash-other",
  "sco:c041": "state-cash-other",
  "sco:c042": "state-cash-other",
  "sco:c043": "state-cash-other",
  "sco:c044": "state-cash-other",
  "sco:c045": "state-cash-other",
  "sco:c046": "state-cash-other",
  "sco:c047": "state-cash-other",
  "sco:c048": "state-cash-other",
  "sco:c049": "state-cash-other",
  "sco:c050": "state-cash-other",
  "sco:c051": "state-cash-other",
  "sco:c052": "state-cash-other",
  "sco:c053": "state-cash-other",
  "sco:c054": "state-cash-other",
  "sco:c055": "state-cash-other",
  "sco:c056": "state-cash-other",
  "sco:c057": "state-cash-other",
  "sco:c058": "state-cash-other",
  "sco:c059": "state-cash-other",
  "sco:c060": "state-cash-other",
  "sco:c061": "state-cash-other",
  "sco:c062": "state-cash-other",
  "sco:c063": "state-cash-other",
  "sco:c064": "state-cash-other",
  "sco:c065": "state-cash-other",
  "sco:c066": "state-cash-other",
  "sco:c067": "state-cash-other",
  "sco:c068": "state-cash-other",
  "sco:c069": "state-cash-other",
  "sco:c070": "state-cash-other",
  "sco:c071": "state-cash-other",
  "sco:c072": "state-cash-other",
  "sco:c073": "state-cash-other",
  "sco:c074": "state-cash-other",
  "sco:c075": "state-cash-other",
  "sco:c076": "state-cash-other",
  "sco:c077": "state-cash-other",
  "sco:c078": "state-cash-other",
  "sco:c079": "state-cash-other",
  "sco:c080": "state-cash-other",
  "sco:c081": "state-cash-other",
  "sco:c082": "state-cash-other",
  "sco:c083": "state-cash-other",
  "vendors:c001": "vendors",
  "vendors:c002": "vendors",
  "vendors:c003": "vendors",
  "vendors:c004": "vendors",
  "vendors:c005": "vendors",
  "vendors:c006": "vendors",
  "vendors:c007": "vendors",
  "vendors:c008": "vendors",
  "vendors:c009": "vendors",
  "vendors:c010": "vendors",
  "vendors:c011": "vendors",
  "vendors:c012": "vendors",
  "vendors:c013": "vendors",
  "vendors:c014": "vendors",
  "vendors:c015": "vendors",
  "vendors:c016": "vendors",
  "vendors:c017": "vendors",
  "vendors:c018": "vendors",
  "vendors:c019": "vendors",
  "vendors:c020": "vendors",
  "vendors:c021": "vendors",
  "vendors:c022": "vendors",
  "vendors:c023": "vendors",
  "vendors:c024": "vendors",
  "vendors:c025": "vendors",
  "vendors:c026": "vendors",
  "vendors:c027": "vendors",
  "vendors:c028": "vendors",
  "vendors:c029": "vendors",
  "vendors:c030": "vendors",
  "vendors:c031": "vendors",
  "vendors:c032": "vendors",
  "vendors:c033": "vendors",
  "vendors:c034": "vendors",
  "vendors:c035": "vendors",
  "vendors:c036": "vendors",
  "vendors:c037": "vendors",
  "vendors:c038": "vendors",
  "vendors:c039": "vendors",
  "vendors:c040": "vendors",
  "vendors:c041": "vendors",
  "vendors:c042": "vendors",
  "vendors:c043": "vendors",
  "vendors:c044": "vendors",
  "vendors:c045": "vendors",
  "vendors:c046": "vendors",
  "vendors:c047": "vendors",
  "welfare-central:c001": "central",
  "welfare-central:c002": "central",
  "welfare-central:c003": "central",
  "welfare-central:c004": "central",
  "welfare-central:c005": "central",
  "welfare-central:c006": "central",
  "welfare-central:c007": "central",
  "welfare-central:c008": "central",
  "welfare-central:c009": "central",
  "welfare-central:c010": "central",
  "welfare-central:c011": "central",
  "welfare-central:c012": "central",
  "welfare-central:c013": "central",
  "welfare-central:c014": "central",
  "welfare-central:c015": "central",
  "welfare-central:c016": "central",
  "welfare-central:c017": "central",
  "welfare-central:c018": "central",
  "welfare-central:c019": "central",
  "welfare-central:c020": "central",
  "welfare-central:c021": "central",
  "welfare-central:c022": "central",
  "welfare-central:c023": "central",
  "welfare-central:c024": "central",
  "welfare-central:c025": "central",
  "welfare-central:c026": "central",
  "welfare-central:c027": "central",
  "welfare-central:c028": "central",
  "welfare-central:c029": "central",
  "welfare-central:c030": "central",
  "welfare-central:c031": "central",
  "welfare-central:c032": "central",
  "welfare-central:c033": "central",
  "welfare-central:c034": "central",
  "welfare-central:c035": "central",
  "welfare-central:c036": "central",
  "welfare-central:c037": "central",
  "welfare-central:c038": "central",
  "welfare-central:c039": "central",
  "welfare-central:c040": "central",
  "welfare-central:c041": "central",
  "welfare-central:c042": "central",
  "welfare-central:c043": "central",
  "welfare-central:c044": "central",
  "welfare-central:c045": "central",
  "welfare-central:c045:audit-contra": "central",
  "welfare-central:c046": "central",
  "welfare-central:c047": "central",
  "welfare-central:c048": "central",
  "welfare-central:c049": "central",
  "welfare-central:c050": "central",
  "welfare-central:c051": "central",
  "welfare-central:c052": "central",
  "welfare-central:c052:audit-contra": "central",
  "welfare-central:c053": "central",
  "welfare-central:c054": "central",
  "welfare-central:c055": "central",
  "welfare-central:c056": "central",
  "women-cash:c001": "women-cash",
  "women-cash:c002": "women-cash",
  "women-cash:c003": "women-cash",
  "women-cash:c004": "women-cash",
  "women-cash:c005": "women-cash",
  "women-cash:c006": "women-cash",
  "women-cash:c007": "women-cash",
  "women-cash:c008": "women-cash",
  "women-cash:c009": "women-cash",
  "women-cash:c010": "women-cash",
  "women-cash:c011": "women-cash",
  "women-cash:c012": "women-cash",
  "women-cash:c013": "women-cash",
  "women-cash:c014": "women-cash",
  "women-cash:c015": "women-cash",
  "women-cash:c016": "women-cash",
  "women-cash:c017": "women-cash",
  "women-cash:c018": "women-cash",
  "women-cash:c019": "women-cash",
  "women-cash:c020": "women-cash",
  "women-cash:c021": "women-cash",
  "women-cash:c022": "women-cash",
  "women-cash:c023": "women-cash",
  "women-cash:c024": "women-cash",
  "women-cash:c025": "women-cash",
  "women-cash:c026": "women-cash",
  "women-cash:c027": "women-cash",
  "women-cash:c028": "women-cash",
  "women-cash:c029": "women-cash",
  "women-cash:c030": "women-cash",
  "women-cash:c031": "women-cash",
  "women-cash:c032": "women-cash",
  "women-cash:c033": "women-cash",
  "women-cash:c034": "women-cash",
  "women-cash:c035": "women-cash",
  "women-cash:c036": "women-cash",
  "women-cash:c037": "women-cash",
  "women-cash:c038": "women-cash",
  "women-cash:c039": "women-cash",
  "women-cash:c040": "women-cash",
  "women-cash:c041": "women-cash",
  "women-cash:c042": "women-cash",
  "women-cash:c043": "women-cash",
  "women-cash:c044": "women-cash",
  "women-cash:c045": "women-cash",
  "women-cash:c046": "women-cash",
  "women-cash:c047": "women-cash",
  "women-cash:c048": "women-cash",
  "women-cash:c049": "women-cash",
  "women-cash:c050": "women-cash",
  "women-cash:c051": "women-cash",
  "women-cash:c052": "women-cash",
  "women-cash:c053": "women-cash",
  "women-cash:c054": "women-cash",
  "women-cash:c055": "women-cash",
  "women-cash:c056": "women-cash",
  "women-cash:c057": "women-cash",
  "women-cash:c058": "women-cash",
  "women-cash:c059": "women-cash",
  "women-cash:c060": "women-cash",
  "women-cash:c061": "women-cash",
  "women-cash:c062": "women-cash",
  "women-cash:c063": "women-cash",
};

export const WELFARE_BENEFITS: BenefitRow[] = [
  { claimId: "fiscal:c016", s: "scheme:tg-rythu-bandhu", t: "party:brs", pred: "analytic", tier: "reported", who: "wel:class-tg-large-landowners", how: "per-acre transfer with no acreage or income cap", amountCr: 150, confidence: "estimated", srcs: [["Times of India, 2 Jan 2021: 'Most of 13,000 rich farmers in Telangana still get Rythu Bandhu aid'","https://timesofindia.indiatimes.com/city/hyderabad/most-of-13000-rich-farmers-in-t-still-get-rythu-bandhu-aid/articleshow/80066258.cms"]], domain: "fiscal-results" },
  { claimId: "lit-w:c006", s: "min:ministry-of-rural-development", t: "scheme:mgnrega", pred: "pmout", tier: "documented", who: "scheme:mgnrega", how: "wage and material payments to rural households and implementing agencies", amountCr: 85838.76, confidence: "documented", srcs: [["PIB, Ministry of Rural Development — Budget allocation under MGNREGA, Rajya Sabha written reply by MoS Kamlesh Paswan, 2025-07-25 (Release ID 2148475)","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"],["PIB, Ministry of Rural Development — Clarifications on budget cut to MGNREGA, 2023-02-03 (Release ID 1896038)","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"]], domain: "literature" },
  { claimId: "sco:c002", s: "scheme:tg-rythu-bandhu", t: "wel:class-tg-landowning-farmers", pred: "pmout", tier: "documented", who: "wel:class-tg-landowning-farmers", how: null, amountCr: 12000, confidence: null, srcs: [["PRS, Telangana Budget Analysis 2018-19","https://prsindia.org/budgets/states/telangana-budget-analysis-2018-19"],["PRS, Telangana Budget Analysis 2023-24","https://prsindia.org/budgets/states/telangana-budget-analysis-2023-24"],["Wikipedia (pointer): Rythu Bandhu scheme","https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"]], domain: "state-cash-other" },
  { claimId: "sco:c016", s: "scheme:ap-ysr-pension-kanuka", t: "wel:class-ap-pensioners", pred: "pmout", tier: "documented", who: "wel:class-ap-pensioners", how: null, amountCr: 21434, confidence: null, srcs: [["PRS, Andhra Pradesh Budget Analysis 2020-21","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2020-21"],["PRS, Andhra Pradesh Budget Analysis 2023-24","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2023-24"]], domain: "state-cash-other" },
  { claimId: "sco:c017", s: "scheme:ap-ysr-amma-vodi", t: "wel:class-ap-school-mothers", pred: "pmout", tier: "documented", who: "wel:class-ap-school-mothers", how: null, amountCr: 6000, confidence: null, srcs: [["PRS, Andhra Pradesh Budget Analysis 2020-21","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2020-21"]], domain: "state-cash-other" },
  { claimId: "sco:c019", s: "scheme:or-kalia", t: "wel:class-or-small-farmers-landless", pred: "pmout", tier: "documented", who: "wel:class-or-small-farmers-landless", how: null, amountCr: 6444.3, confidence: null, srcs: [["CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)","https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"]], domain: "state-cash-other" },
  { claimId: "sco:c030", s: "scheme:ka-five-guarantees-2023", t: "wel:class-ka-households", pred: "pmout", tier: "documented", who: "wel:class-ka-households", how: null, amountCr: 52525, confidence: null, srcs: [["PRS, Karnataka Budget Analysis 2023-24","https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"],["Deccan Herald, 26 Mar 2026: Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG","https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"],["The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget","https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"]], domain: "state-cash-other" },
  { claimId: "sco:c036", s: "scheme:ka-anna-bhagya-2023", t: "wel:class-ka-bpl-members", pred: "pmout", tier: "documented", who: "wel:class-ka-bpl-members", how: null, amountCr: 10452, confidence: null, srcs: [["Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024","https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"]], domain: "state-cash-other" },
  { claimId: "sco:c041", s: "scheme:dl-free-power-200-units", t: "wel:class-dl-domestic-consumers", pred: "pmout", tier: "documented", who: "wel:class-dl-domestic-consumers", how: null, amountCr: 3250, confidence: null, srcs: [["PRS, Delhi Budget Analysis 2019-20","https://prsindia.org/budgets/states/delhi-budget-analysis-2019-20"],["PRS, Delhi Budget Analysis 2020-21","https://prsindia.org/budgets/states/delhi-budget-analysis-2020-21"],["PRS, Delhi Budget Analysis 2023-24","https://prsindia.org/budgets/states/delhi-budget-analysis-2023-24"]], domain: "state-cash-other" },
  { claimId: "sco:c045", s: "scheme:pb-free-power-300-units", t: "wel:class-pb-domestic-consumers", pred: "pmout", tier: "documented", who: "wel:class-pb-domestic-consumers", how: null, amountCr: 7780, confidence: null, srcs: [["PRS, Punjab Budget Analysis 2024-25","https://prsindia.org/budgets/states/punjab-budget-analysis-2024-25"]], domain: "state-cash-other" },
  { claimId: "sco:c052", s: "scheme:mh-farm-loan-waiver-2017", t: "wel:class-mh-lending-banks", pred: "pmout", tier: "documented", who: "wel:class-mh-lending-banks", how: null, amountCr: 18762, confidence: null, srcs: [["Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"]], domain: "state-cash-other" },
  { claimId: "sco:c062", s: "scheme:tn-free-colour-tv-2006", t: "wel:elcot", pred: "award", tier: "reported", who: "wel:elcot", how: null, amountCr: 3687, confidence: null, srcs: [["IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?","https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"]], domain: "state-cash-other" },
  { claimId: "sco:c068", s: "scheme:tn-free-bus-women-2021", t: "wel:tn-state-transport-undertakings", pred: "pmout", tier: "documented", who: "wel:tn-state-transport-undertakings", how: null, amountCr: 1520, confidence: null, srcs: [["Deccan Herald, 18 Mar 2022: Free travel — more women in Tamil Nadu now take government buses (budget 2022-23)","https://www.deccanherald.com/india/free-travel-more-women-in-tamil-nadu-now-take-government-buses-1092556.html"]], domain: "state-cash-other" },
  { claimId: "sco:c080", s: "scheme:kl-welfare-pensions-arrears", t: "wel:ksspl", pred: "pmout", tier: "documented", who: "wel:ksspl", how: null, amountCr: 10729, confidence: null, srcs: [["PRS, Kerala Budget Analysis 2024-25","https://prsindia.org/budgets/states/kerala-budget-analysis-2024-25"]], domain: "state-cash-other" },
  { claimId: "sco:c082", s: "bjp", t: "wel:class-gj-farmers", pred: "pmout", tier: "documented", who: "wel:class-gj-farmers", how: null, amountCr: 12207, confidence: null, srcs: [["PRS, Gujarat Budget Analysis 2024-25","https://prsindia.org/budgets/states/gujarat-budget-analysis-2024-25"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.13-14 and subsidy section (PDF)","https://prsindia.org/files/budget/SOSF_2025.pdf"]], domain: "state-cash-other" },
  { claimId: "vendors:c001", s: "wel:dbt-mission", t: "wel:npci", pred: "award", tier: "documented", who: "wel:npci", how: "switching/interchange on every APB credit", amountCr: null, confidence: "unknown", srcs: [["PIB backgrounder, Direct Benefit Transfer (DBT), Jan 2022","https://static.pib.gov.in/WriteReadData/specificdocs/documents/2022/jan/doc2022153101.pdf"]], domain: "vendors" },
  { claimId: "vendors:c002", s: "wel:fino-payments-bank", t: "scheme:dbt-apb-pfms", pred: "pmout", tier: "documented", who: "wel:fino-payments-bank", how: "per-transaction interchange on cash-out of government credits", amountCr: 185, confidence: "documented", srcs: [["Fino Payments Bank, Annual Report 2024-25","https://www.fino.bank.in/files/fino/media/post_attachments/sites/default/files/uploads/pages/financials/annual-report-2025.pdf"]], domain: "vendors" },
  { claimId: "vendors:c003", s: "wel:csc-egovernance-services", t: "scheme:dbt-apb-pfms", pred: "pmout", tier: "reported", who: "wel:csc-egovernance-services", how: "AePS interchange share", amountCr: null, confidence: "unknown", srcs: [["Moneylife, 'Is CSC e-Governance Services a govt entity or SPV or a Section 8 company?', 29 Jun 2018","https://www.moneylife.in/article/is-csc-egovernance-services-a-govt-entity-or-spv-or-a-section-8-company/54524.html"]], domain: "vendors" },
  { claimId: "vendors:c004", s: "wel:india-post-payments-bank", t: "scheme:dbt-apb-pfms", pred: "pmout", tier: "reported", who: "wel:india-post-payments-bank", how: "doorstep cash-out fees and float on DBT balances", amountCr: null, confidence: "unknown", srcs: [["Free Press Journal, IPPB disbursed over ₹45,000 crore in DBT in 7 years (Scindia), 1 Sep 2024","https://www.freepressjournal.in/business/india-post-payments-bank-disbursed-over-45000-crore-in-dbt-in-last-7-years"]], domain: "vendors" },
  { claimId: "vendors:c009", s: "min:ministry-of-petroleum-and-natural-gas", t: "wel:omcs", pred: "award", tier: "documented", who: "wel:omcs", how: "connection-cost reimbursement plus captive refill demand", amountCr: 11504, confidence: "documented", srcs: [["CAG press release on Performance Audit Report No. 14 of 2019 on PMUY, 11 Dec 2019 (local copy; exact report URL unresolved — see gaps)","https://cag.gov.in/en"]], domain: "vendors" },
  { claimId: "vendors:c013", s: "min:ministry-of-consumer-affairs-food-and-public-distribution", t: "wel:fci", pred: "pmout", tier: "documented", who: "wel:fci", how: "funds MSP procurement and FCI's own handling, freight, storage and interest costs", amountCr: 139662, confidence: "documented", srcs: [["PRS Legislative Research, 'Demand for Grants 2024-25 Analysis: Food and Public Distribution'","https://prsindia.org/budgets/parliament/demand-for-grants-2024-25-analysis-food-and-public-distribution"]], domain: "vendors" },
  { claimId: "vendors:c014", s: "wel:bmtc", t: "co:ashok-leyland", pred: "award", tier: "reported", who: "co:ashok-leyland", how: "fleet-replacement order accelerated by Shakti ridership", amountCr: 336, confidence: "estimated", srcs: [["Deccan Herald, 'BMTC launches 100 new diesel buses, to get 820 of them by March', 12 Sep 2024","https://www.deccanherald.com/india/karnataka/bengaluru/bmtc-launches-100-new-diesel-buses-to-get-820-of-them-by-march-3188420"]], domain: "vendors" },
  { claimId: "vendors:c019", s: "wel:dtc", t: "wel:tml-cv-mobility-solutions", pred: "award", tier: "documented", who: "co:tata-motors", how: "12-year GCC revenue stream", amountCr: null, confidence: "unknown", srcs: [["Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022","https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"]], domain: "vendors" },
  { claimId: "vendors:c024", s: "min:ministry-of-finance", t: "wel:hewlett-packard-india", pred: "award", tier: "reported", who: "wel:hewlett-packard-india", how: "single-vendor supply of ~15 lakh units", amountCr: 2800, confidence: "estimated", srcs: [["Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'","https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"]], domain: "vendors" },
  { claimId: "vendors:c030", s: "wel:mp-jansampark", t: "scheme:mp-ladli-behna", pred: "pmout", tier: "documented", who: "bjp", how: "state-funded publicity of a CM-branded scheme in the pre-poll window", amountCr: 260, confidence: "documented", srcs: [["Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025","https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"]], domain: "vendors" },
  { claimId: "vendors:c031", s: "wel:maharashtra-dgipr", t: "scheme:mh-ladki-bahin", pred: "pmout", tier: "reported", who: "bjp", how: "pre-poll publicity of a Mahayuti scheme", amountCr: 199.81, confidence: "documented", srcs: [["Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024","https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"]], domain: "vendors" },
  { claimId: "vendors:c034", s: "wel:delhi-dip", t: "party:aap", pred: "pmout", tier: "reported", who: "party:aap", how: "CM-image-led government campaigns (CAG found breaches; AAP disputes)", amountCr: 97, confidence: "estimated", srcs: [["ThePrint, 'Kejriwal govt spent Rs 274 crore on ads since 2015, four times Congress tab' (RTI), 1 Apr 2019","https://theprint.in/politics/kejriwals-delhi-govt-spent-rs-274-crore-on-ads-since-2015-four-times-more-than-congress/214151/"]], domain: "vendors" },
  { claimId: "vendors:c041", s: "wel:telangana-ipr", t: "party:brs", pred: "pmout", tier: "reported", who: "party:brs", how: "CM-image-led publicity", amountCr: null, confidence: "unknown", srcs: [["The News Minute, 'Telangana govt spent around Rs 300 cr on advertisement and publicity in 4 years' (RTI), 2020","https://www.thenewsminute.com/telangana/telangana-govt-spent-around-rs-300-cr-advertisement-and-publicity-4-years-137759"]], domain: "vendors" },
  { claimId: "vendors:c045", s: "wel:ys-jagan-mohan-reddy", t: "scheme:ap-village-volunteers", pred: "pmout", tier: "reported", who: "scheme:ap-village-volunteers", how: "honoraria", amountCr: 1536, confidence: "estimated", srcs: [["ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024","https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"]], domain: "vendors" },
  { claimId: "welfare-central:c025", s: "scheme:pm-ujjwala", t: "co:indian-oil", pred: "pmout", tier: "documented", who: "co:indian-oil", how: "subsidy keeps ~10.3 crore PMUY households refilling through OMC networks", amountCr: 12000, confidence: "documented", srcs: [["PIB, Cabinet approves continuation of ₹300 PMUY subsidy for FY 2024-25, 7 Mar 2024","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2012354"],["PIB, Cabinet approves PMUY targeted subsidy FY 2025-26 (₹300, up to 9 refills), 8 Aug 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2154117"]], domain: "central" },
  { claimId: "welfare-central:c026", s: "scheme:upa-farm-loan-waiver-2008", t: "co:state-bank-of-india", pred: "pmout", tier: "documented", who: "co:state-bank-of-india", how: "overdue farm loans cleared from bank books at Centre's cost", amountCr: null, confidence: "estimated", srcs: [["Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)","https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"]], domain: "central" },
  { claimId: "women-cash:c020", s: "scheme:mh-ladki-bahin", t: "wel:class-mh-ladki-bahin-ad-vendors", pred: "award", tier: "reported", who: "wel:class-mh-ladki-bahin-ad-vendors", how: "government advertising contracts", amountCr: 250, confidence: "estimated", srcs: [["BehanBox, 4 Dec 2024: Maharashtra poll analyses and women's agency (cites Lokniti-CSDS post-poll)","https://behanbox.com/2024/12/04/how-maharashtra-poll-analyses-are-missing-the-rise-of-womens-agency/"]], domain: "women-cash" },
  { claimId: "women-cash:c059", s: "ministry:hr-sewa", t: "psu:hartron", pred: "award", tier: "documented", who: "psu:hartron", how: "app development assignment to a state PSU", amountCr: null, confidence: "unknown", srcs: [["Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification","https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"]], domain: "women-cash" },
];

export const WELFARE_ELECTIONS: Election[] = [
  { st: "br", election: "assembly", date: "2000-02-05", incumbentParty: "RJD", winner: "RJD-led (narrowly retained)", srcs: [], domain: "elections-timing" },
  { st: "or", election: "assembly", date: "2000-02-18", incumbentParty: "INC", winner: "BJD-BJP alliance", srcs: [], domain: "elections-timing" },
  { st: "as", election: "assembly", date: "2001-05-10", incumbentParty: "AGP", winner: "INC", srcs: [], domain: "elections-timing" },
  { st: "tn", election: "assembly", date: "2001-05-10", incumbentParty: "DMK", winner: "AIADMK", srcs: [], domain: "elections-timing" },
  { st: "wb", election: "assembly", date: "2001-05-10", incumbentParty: "CPI(M)-Left Front", winner: "CPI(M)-Left Front", srcs: [], domain: "elections-timing" },
  { st: "pb", election: "assembly", date: "2002-02-13", incumbentParty: "SAD-BJP", winner: "INC", srcs: [], domain: "elections-timing" },
  { st: "hp", election: "assembly", date: "2003-02-26", incumbentParty: "BJP", winner: "INC", srcs: [], domain: "elections-timing" },
  { st: "ct", election: "assembly", date: "2003-11-14", incumbentParty: "INC", winner: "BJP", srcs: [["Wikipedia pointer — 2003 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2003_Chhattisgarh_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "dl", election: "assembly", date: "2003-11-29", incumbentParty: "INC", winner: "INC", srcs: [], domain: "elections-timing" },
  { st: "mp", election: "assembly", date: "2003-12-01", incumbentParty: "INC", winner: "BJP", srcs: [["Wikipedia pointer — 2003 MP Legislative Assembly election","https://en.wikipedia.org/wiki/2003_Madhya_Pradesh_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "rj", election: "assembly", date: "2003-12-01", incumbentParty: "INC", winner: "BJP", srcs: [], domain: "elections-timing" },
  { st: null, election: "Lok Sabha", date: "2004-04-20", incumbentParty: "BJP (NDA)", winner: "INC (UPA) — INC 145, BJP 138", srcs: [["Wikipedia (pointer), 2004 Indian general election","https://en.wikipedia.org/wiki/2004_Indian_general_election"],["Wikipedia pointer — 2004 Indian general election","https://en.wikipedia.org/wiki/2004_Indian_general_election"]], domain: "central" },
  { st: "ap", election: "assembly", date: "2004-04-20", incumbentParty: "TDP", winner: "INC", srcs: [["Wikipedia pointer — 2004 AP Legislative Assembly election","https://en.wikipedia.org/wiki/2004_Andhra_Pradesh_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "ka", election: "assembly", date: "2004-04-20", incumbentParty: "INC", winner: "hung; INC-JD(S) coalition", srcs: [["Wikipedia pointer — 2004 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2004_Karnataka_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "or", election: "assembly", date: "2004-04-20", incumbentParty: "BJD-BJP alliance", winner: "BJD-BJP alliance", srcs: [], domain: "elections-timing" },
  { st: "mh", election: "assembly", date: "2004-10-13", incumbentParty: "INC-NCP alliance", winner: "INC-NCP alliance", srcs: [], domain: "elections-timing" },
  { st: "br", election: "assembly", date: "2005-02-03", incumbentParty: "RJD", winner: "hung; no government formed, President's rule", srcs: [], domain: "elections-timing" },
  { st: "jh", election: "assembly", date: "2005-02-15", incumbentParty: "N/A (new state formed Nov 2000; first full-term election)", winner: "hung; BJP-led coalition eventually formed", srcs: [], domain: "elections-timing" },
  { st: "br", election: "assembly", date: "2005-10-18", incumbentParty: "RJD (President's rule preceding)", winner: "JD(U)-BJP (NDA)", srcs: [["Wikipedia infobox (pointer to ECI results): October 2005 Bihar Legislative Assembly election","https://en.wikipedia.org/wiki/October_2005_Bihar_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "as", election: "assembly", date: "2006-04-03", incumbentParty: "INC", winner: "INC", srcs: [], domain: "elections-timing" },
  { st: "wb", election: "assembly", date: "2006-04-17", incumbentParty: "CPI(M)-Left Front", winner: "CPI(M)-Left Front", srcs: [], domain: "elections-timing" },
  { st: "tn", election: "assembly", date: "2006-05-08", incumbentParty: "AIADMK", winner: "DMK", srcs: [["Wikipedia infobox (pointer to ECI): 2006 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2006_Tamil_Nadu_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "pb", election: "assembly", date: "2007-02-13", incumbentParty: "INC", winner: "SAD-BJP", srcs: [], domain: "elections-timing" },
  { st: "hp", election: "assembly", date: "2007-12-19", incumbentParty: "INC", winner: "BJP", srcs: [], domain: "elections-timing" },
  { st: "ka", election: "assembly", date: "2008-05-10", incumbentParty: "JD(S)-BJP coalition (collapsed)", winner: "BJP", srcs: [["Wikipedia pointer — 2008 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2008_Karnataka_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "ct", election: "assembly", date: "2008-11-14", incumbentParty: "BJP", winner: "BJP", srcs: [["Wikipedia pointer — 2008 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2008_Chhattisgarh_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2008 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2008_Chhattisgarh_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "mp", election: "assembly", date: "2008-11-27", incumbentParty: "BJP", winner: "BJP", srcs: [["Wikipedia pointer — 2008 MP Legislative Assembly election","https://en.wikipedia.org/wiki/2008_Madhya_Pradesh_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2008 Madhya Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2008_Madhya_Pradesh_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "dl", election: "assembly", date: "2008-11-29", incumbentParty: "INC", winner: "INC", srcs: [], domain: "elections-timing" },
  { st: "rj", election: "assembly", date: "2008-12-04", incumbentParty: "BJP", winner: "INC", srcs: [], domain: "elections-timing" },
  { st: null, election: "Lok Sabha", date: "2009-04-16", incumbentParty: "INC (UPA)", winner: "INC (UPA) — INC 206 (+61), BJP 116", srcs: [["Wikipedia (pointer), 2009 Indian general election","https://en.wikipedia.org/wiki/2009_Indian_general_election"],["Wikipedia pointer — 2009 Indian general election","https://en.wikipedia.org/wiki/2009_Indian_general_election"]], domain: "central" },
  { st: "ap", election: "assembly", date: "2009-04-16", incumbentParty: "INC", winner: "INC", srcs: [], domain: "elections-timing" },
  { st: "or", election: "assembly", date: "2009-04-16", incumbentParty: "BJD (contesting alone after split from BJP)", winner: "BJD", srcs: [], domain: "elections-timing" },
  { st: "mh", election: "assembly", date: "2009-10-13", incumbentParty: "INC-NCP alliance", winner: "INC-NCP alliance", srcs: [], domain: "elections-timing" },
  { st: "jh", election: "assembly", date: "2009-11-25", incumbentParty: "coalition (multiple short-tenure govts 2005-09)", winner: "hung; JMM-BJP coalition", srcs: [], domain: "elections-timing" },
  { st: "br", election: "assembly", date: "2010-10-21", incumbentParty: "JD(U)-BJP (NDA)", winner: "JD(U)-BJP (NDA)", srcs: [["Wikipedia infobox (pointer to ECI): 2010 Bihar Legislative Assembly election","https://en.wikipedia.org/wiki/2010_Bihar_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "as", election: "assembly", date: "2011-04-04", incumbentParty: "INC", winner: "INC", srcs: [], domain: "elections-timing" },
  { st: "tn", election: "assembly", date: "2011-04-13", incumbentParty: "DMK", winner: "AIADMK", srcs: [["Wikipedia infobox (pointer to ECI): 2011 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2011_Tamil_Nadu_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "wb", election: "assembly", date: "2011-04-18", incumbentParty: "CPI(M)-Left Front", winner: "TMC-INC alliance", srcs: [], domain: "elections-timing" },
  { st: "pb", election: "assembly", date: "2012-01-30", incumbentParty: "SAD-BJP", winner: "SAD-BJP", srcs: [], domain: "elections-timing" },
  { st: "hp", election: "assembly", date: "2012-11-04", incumbentParty: "BJP", winner: "INC", srcs: [], domain: "elections-timing" },
  { st: "ka", election: "assembly", date: "2013-05-05", incumbentParty: "BJP", winner: "INC", srcs: [], domain: "elections-timing" },
  { st: "ct", election: "assembly", date: "2013-11-11", incumbentParty: "BJP", winner: "BJP", srcs: [["Wikipedia pointer — 2013 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2013_Chhattisgarh_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2013 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2013_Chhattisgarh_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "mp", election: "assembly", date: "2013-11-25", incumbentParty: "BJP", winner: "BJP", srcs: [["Wikipedia pointer — 2013 MP Legislative Assembly election","https://en.wikipedia.org/wiki/2013_Madhya_Pradesh_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "rj", election: "assembly", date: "2013-12-01", incumbentParty: "INC", winner: "BJP", srcs: [], domain: "elections-timing" },
  { st: "dl", election: "assembly", date: "2013-12-04", incumbentParty: "INC", winner: "hung; AAP minority govt", srcs: [], domain: "elections-timing" },
  { st: null, election: "Lok Sabha", date: "2014-04-07", incumbentParty: "INC (UPA)", winner: "BJP (NDA) — BJP 282, INC 44", srcs: [["Wikipedia (pointer), 2014 Indian general election","https://en.wikipedia.org/wiki/2014_Indian_general_election"],["Wikipedia pointer — 2014 Indian general election","https://en.wikipedia.org/wiki/2014_Indian_general_election"]], domain: "central" },
  { st: "or", election: "assembly", date: "2014-04-10", incumbentParty: "BJD", winner: "BJD", srcs: [], domain: "elections-timing" },
  { st: "ap", election: "assembly", date: "2014-04-30", incumbentParty: "INC", winner: "TDP", srcs: [], domain: "elections-timing" },
  { st: "tg", election: "assembly", date: "2014-04-30", incumbentParty: "N/A (new state formed June 2014)", winner: "BRS (TRS)", srcs: [["Wikipedia pointer — 2014 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2014_Telangana_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2018 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Telangana_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2014 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2014_Telangana_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "mh", election: "assembly", date: "2014-10-15", incumbentParty: "INC-NCP alliance", winner: "BJP (largest party)", srcs: [], domain: "elections-timing" },
  { st: "jh", election: "assembly", date: "2014-11-25", incumbentParty: "coalition govts", winner: "BJP", srcs: [], domain: "elections-timing" },
  { st: "dl", election: "assembly", date: "2015-02-07", incumbentParty: "AAP (minority govt collapsed, President's rule)", winner: "AAP", srcs: [["Wikipedia infobox (pointer to ECI results): 2015 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2015_Delhi_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "br", election: "assembly", date: "2015-10-12", incumbentParty: "JD(U) (having split from BJP in 2013)", winner: "JD(U)-RJD-INC 'Mahagathbandhan'", srcs: [], domain: "elections-timing" },
  { st: "as", election: "assembly", date: "2016-04-04", incumbentParty: "INC", winner: "BJP", srcs: [], domain: "elections-timing" },
  { st: "wb", election: "assembly", date: "2016-04-04", incumbentParty: "TMC", winner: "TMC", srcs: [["Wikipedia infobox (pointer to ECI results): 2016 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2016_West_Bengal_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "kl", election: "assembly", date: "2016-05-16", incumbentParty: "UDF (INC-led)", winner: "LDF (CPI(M)-led)", srcs: [["Wikipedia infobox (pointer to ECI): 2016 Kerala Legislative Assembly election","https://en.wikipedia.org/wiki/2016_Kerala_Legislative_Assembly_election"]], domain: "state-cash-other" },
  { st: "tn", election: "assembly", date: "2016-05-16", incumbentParty: "AIADMK", winner: "AIADMK", srcs: [["Wikipedia infobox (pointer to ECI results): 2016 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2016_Tamil_Nadu_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "pb", election: "assembly", date: "2017-02-04", incumbentParty: "SAD-BJP", winner: "INC", srcs: [["Wikipedia infobox (pointer to ECI results): 2017 Punjab Legislative Assembly election","https://en.wikipedia.org/wiki/2017_Punjab_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "up", election: "assembly", date: "2017-02-11", incumbentParty: "SP", winner: "BJP", srcs: [["Wikipedia (pointer): 2017 Uttar Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2017_Uttar_Pradesh_Legislative_Assembly_election"]], domain: "state-cash-other" },
  { st: "hp", election: "assembly", date: "2017-11-09", incumbentParty: "INC", winner: "BJP", srcs: [], domain: "elections-timing" },
  { st: "ka", election: "assembly", date: "2018-05-12", incumbentParty: "INC", winner: "hung; INC-JD(S) coalition", srcs: [["Wikipedia infobox (pointer to ECI results): 2018 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Karnataka_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "ct", election: "assembly", date: "2018-11-12", incumbentParty: "BJP", winner: "INC", srcs: [["Wikipedia pointer — 2018 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Chhattisgarh_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2018 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Chhattisgarh_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "mp", election: "assembly", date: "2018-11-28", incumbentParty: "BJP", winner: "INC", srcs: [["Wikipedia pointer — 2018 MP Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Madhya_Pradesh_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2018 Madhya Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Madhya_Pradesh_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "rj", election: "assembly", date: "2018-12-07", incumbentParty: "BJP", winner: "INC", srcs: [["Wikipedia infobox (pointer to ECI results): 2018 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Rajasthan_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "tg", election: "assembly", date: "2018-12-07", incumbentParty: "BRS (TRS)", winner: "BRS (TRS)", srcs: [["Wikipedia infobox (pointer to ECI): 2018 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Telangana_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: null, election: "Lok Sabha", date: "2019-04-11", incumbentParty: "BJP (NDA)", winner: "BJP (NDA) — BJP 303 (+21), INC 52", srcs: [["Wikipedia (pointer), 2019 Indian general election","https://en.wikipedia.org/wiki/2019_Indian_general_election"],["Wikipedia pointer — 2019 Indian general election","https://en.wikipedia.org/wiki/2019_Indian_general_election"]], domain: "central" },
  { st: "ap", election: "assembly", date: "2019-04-11", incumbentParty: "TDP", winner: "YSRCP", srcs: [["Wikipedia infobox (pointer to ECI results): 2019 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2019_Andhra_Pradesh_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "or", election: "assembly", date: "2019-04-11", incumbentParty: "BJD", winner: "BJD", srcs: [["Pressreader/Hindustan Times — Odisha Rs 10,180-cr KALIA package","https://www.pressreader.com/india/hindustan-times-delhi/20181222/281788515170582"],["Wikipedia infobox (pointer to ECI): 2019 Odisha Legislative Assembly election","https://en.wikipedia.org/wiki/2019_Odisha_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "mh", election: "assembly", date: "2019-10-21", incumbentParty: "BJP-Shiv Sena pre-poll alliance", winner: "BJP-Shiv Sena alliance (largest pre-poll bloc); post-poll government formed by Shiv Sena-NCP-INC (MVA) after the pre-poll alliance broke apart", srcs: [["Wikipedia infobox (pointer to ECI results): 2019 Maharashtra Legislative Assembly election","https://en.wikipedia.org/wiki/2019_Maharashtra_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "jh", election: "assembly", date: "2019-11-30", incumbentParty: "BJP", winner: "JMM-INC-RJD alliance", srcs: [], domain: "elections-timing" },
  { st: "dl", election: "assembly", date: "2020-02-08", incumbentParty: "AAP", winner: "AAP", srcs: [["Wikipedia infobox (pointer to ECI): 2020 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2020_Delhi_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "br", election: "assembly", date: "2020-10-28", incumbentParty: "JD(U)-BJP (NDA, Nitish having rejoined NDA in 2017)", winner: "JD(U)-BJP (NDA, narrowly)", srcs: [], domain: "elections-timing" },
  { st: "as", election: "assembly", date: "2021-03-27", incumbentParty: "BJP", winner: "BJP", srcs: [["Deccan Herald — BJP-led Assam govt launches Orunodoi ahead of polls","https://www.deccanherald.com/amp/story/india%2Fbjp-led-assam-govt-launches-cash-transfer-scheme-orunodoi-ahead-of-assembly-elections-922119.html"]], domain: "elections-timing" },
  { st: "wb", election: "assembly", date: "2021-03-27", incumbentParty: "TMC", winner: "TMC 215, BJP 77 (+74)", srcs: [["Wikipedia (pointer), 2021 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2021_West_Bengal_Legislative_Assembly_election"],["Wikipedia — 2021 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2021_West_Bengal_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2021 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2021_West_Bengal_Legislative_Assembly_election"]], domain: "central" },
  { st: "as", election: "assembly", date: "2021-04-06", incumbentParty: "BJP", winner: "BJP", srcs: [["Wikipedia infobox (pointer to ECI results): 2021 Assam Legislative Assembly election","https://en.wikipedia.org/wiki/2021_Assam_Legislative_Assembly_election"]], domain: "women-cash" },
  { st: "kl", election: "assembly", date: "2021-04-06", incumbentParty: "LDF", winner: "LDF", srcs: [["Wikipedia infobox (pointer to ECI): 2021 Kerala Legislative Assembly election","https://en.wikipedia.org/wiki/2021_Kerala_Legislative_Assembly_election"]], domain: "state-cash-other" },
  { st: "tn", election: "assembly", date: "2021-04-06", incumbentParty: "AIADMK", winner: "DMK", srcs: [["Wikipedia infobox (pointer to ECI): 2021 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2021_Tamil_Nadu_Legislative_Assembly_election"],["Wikipedia (pointer), 2021 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2021_Tamil_Nadu_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2021 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2021_Tamil_Nadu_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "wb", election: "assembly", date: "2021-04-29", incumbentParty: "AITC", winner: "AITC", srcs: [["Wikipedia infobox (pointer to ECI results): 2021 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2021_West_Bengal_Legislative_Assembly_election"]], domain: "women-cash" },
  { st: "pb", election: "assembly", date: "2022-02-20", incumbentParty: "INC", winner: "AAP", srcs: [["Wikipedia — 2022 Punjab Legislative Assembly election","https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2022 Punjab Legislative Assembly election","https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"],["Wikipedia (pointer), 2022 Punjab Legislative Assembly election","https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2022 Punjab Legislative Assembly election","https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "hp", election: "assembly", date: "2022-11-12", incumbentParty: "BJP", winner: "INC", srcs: [["Onmanorama — Himachal restores Old Pension Scheme","https://www.onmanorama.com/news/india/2023/01/14/congress-himachal-pradesh-old-pension-scheme.html"]], domain: "elections-timing" },
  { st: "ka", election: "assembly", date: "2023-05-10", incumbentParty: "BJP", winner: "INC", srcs: [["Wikipedia — 2023 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2023 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"],["Wikipedia (pointer), 2023 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2023 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "ct", election: "assembly", date: "2023-11-07", incumbentParty: "INC", winner: "BJP 54 (+39), INC 35", srcs: [["Wikipedia (pointer), 2023 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"],["National Herald — Chhattisgarh Rs 6,100-cr loan waiver","https://www.nationalheraldindia.com/national/chhattisgarh-cm-bhupesh-baghel-announces-indian-rupee6100-cr-farm-loan-waiver"],["Wikipedia infobox (pointer to ECI): 2023 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"]], domain: "central" },
  { st: "ct", election: "assembly", date: "2023-11-17", incumbentParty: "INC", winner: "BJP", srcs: [["Wikipedia infobox (pointer to ECI results): 2023 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"]], domain: "women-cash" },
  { st: "mp", election: "assembly", date: "2023-11-17", incumbentParty: "BJP", winner: "BJP 163 (+54), INC 66", srcs: [["Wikipedia (pointer), 2023 Madhya Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"],["Wikipedia — 2023 MP Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"],["Vinod Rai, ‘The BJP Wins the Semi-final: Impressive Gains in State Elections’, ISAS Brief No. 1081, 6 Dec 2023 (PDF held locally)","https://www.isas.nus.edu.sg/"],["Lokniti-CSDS — Madhya Pradesh Postpoll Survey 2023: Survey Findings (N=3,050, 18–24 Nov 2023; PDF held locally; Lokniti state-election index page opened)","https://www.lokniti.org/state-assembly-elections"],["Wikipedia infobox (pointer to ECI): 2023 Madhya Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2023 Madhya Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"]], domain: "central" },
  { st: "rj", election: "assembly", date: "2023-11-25", incumbentParty: "INC", winner: "BJP 115 (+42), INC 70", srcs: [["Wikipedia (pointer), 2023 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"],["The Week — Rajasthan 2023, change of guard","https://www.deccanherald.com/india/rajasthan/rajasthan-2023-change-of-guard-end-of-gehlot-raje-era-2829895"],["Wikipedia infobox (pointer to ECI): 2023 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2023 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"]], domain: "central" },
  { st: "tg", election: "assembly", date: "2023-11-30", incumbentParty: "BRS", winner: "INC 64 (+45), BRS 39", srcs: [["Wikipedia (pointer), 2023 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"],["The News Minute — BRS losses, Congress gains, Telangana 2023","https://www.thenewsminute.com/telangana/brs-losses-congress-gains-how-telangana-voted-in-2023"],["Wikipedia infobox (pointer to ECI): 2023 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2023 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"]], domain: "central" },
  { st: null, election: "Lok Sabha", date: "2024-04-19", incumbentParty: "BJP (NDA)", winner: "BJP (NDA) — BJP 240 (−63), INC 99", srcs: [["Wikipedia (pointer), 2024 Indian general election","https://en.wikipedia.org/wiki/2024_Indian_general_election"],["Wikipedia pointer — 2024 Indian general election","https://en.wikipedia.org/wiki/2024_Indian_general_election"]], domain: "central" },
  { st: "ap", election: "assembly", date: "2024-05-13", incumbentParty: "YSRCP", winner: "TDP-led alliance (TDP-BJP-Janasena)", srcs: [["Wikipedia — 2024 AP Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"],["Wikipedia (pointer), 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "or", election: "assembly", date: "2024-05-13", incumbentParty: "BJD", winner: "BJP", srcs: [["Wikipedia — 2024 Odisha Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Odisha_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2024 Odisha Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Odisha_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "or", election: "assembly", date: "2024-06-01", incumbentParty: "BJD", winner: "BJP", srcs: [["Wikipedia infobox (pointer to ECI results): 2024 Odisha Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Odisha_Legislative_Assembly_election"]], domain: "women-cash" },
  { st: "hr", election: "assembly", date: "2024-10-05", incumbentParty: "BJP", winner: "BJP", srcs: [["Wikipedia infobox (pointer to ECI results): 2024 Haryana Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Haryana_Legislative_Assembly_election"]], domain: "women-cash" },
  { st: "jh", election: "assembly", date: "2024-11-13", incumbentParty: "JMM-led (JMM-INC-RJD)", winner: "JMM-led alliance", srcs: [["Republic World — Jharkhand 2024 result, JMM alliance 56 seats","https://www.republicworld.com/elections/jharkhand-election-results-2024-live-updates-assembly-election-results-today-hemant-sorens-jmm-bjp-congress-winners-live-news"]], domain: "elections-timing" },
  { st: "jh", election: "assembly", date: "2024-11-20", incumbentParty: "JMM", winner: "JMM-led alliance", srcs: [["Wikipedia infobox (pointer to ECI results): 2024 Jharkhand Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Jharkhand_Legislative_Assembly_election"]], domain: "women-cash" },
  { st: "mh", election: "assembly", date: "2024-11-20", incumbentParty: "Mahayuti (BJP-Shiv Sena(Shinde)-NCP(Ajit Pawar))", winner: "Mahayuti", srcs: [["ETV Bharat — Maharashtra 2024 final result, Mahayuti 230 seats","https://www.etvbharat.com/en/!bharat/maharashtra-assembly-election-2024-counting-mahayuti-mva-bjp-shiv-sena-ubt-ncp-congress-enn24112205094"],["Wikipedia infobox (pointer to ECI): 2024 Maharashtra Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Maharashtra_Legislative_Assembly_election"],["Wikipedia (pointer), 2024 Maharashtra Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Maharashtra_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2024 Maharashtra Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Maharashtra_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "dl", election: "assembly", date: "2025-02-05", incumbentParty: "AAP", winner: "BJP", srcs: [["Wikipedia — 2025 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2025 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"],["Wikipedia (pointer), 2025 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2025 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "br", election: "assembly", date: "2025-11-06", incumbentParty: "JD(U)-BJP (NDA)", winner: "JD(U)-BJP (NDA, landslide)", srcs: [["Wikipedia — 2025 Bihar Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Bihar_Legislative_Assembly_election"],["Deccan Herald — Bihar 2025 NDA wins 202 seats","https://www.deccanherald.com/amp/story/elections%2Fbihar%2Fbihar-assembly-elections-2025-results-nda-cruises-to-victory-by-winning-202-seats-and-a-vote-share-of-over-40-3798063"]], domain: "elections-timing" },
  { st: "br", election: "assembly", date: "2025-11-14", incumbentParty: "NDA (JD(U)-BJP)", winner: "NDA", srcs: [["Deccan Herald, 15 Nov 2025: Bihar results — NDA 202 seats","https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-results-nda-cruises-to-victory-by-winning-202-seats-and-a-vote-share-of-over-40-3798063"],["PIB/ECI, 6 Oct 2025: General Election to the Legislative Assembly of Bihar, 2025 (schedule release)","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2175533"]], domain: "women-cash" },
  { st: "as", election: "assembly", date: "2026-04", incumbentParty: "BJP", winner: "BJP", srcs: [["India TV, 4 May 2026: Assam 2026 result — BJP 82 seats","https://www.indiatvnews.com/north-east/assam/assam-election-result-2026-live-updates-himanta-biswa-sarma-led-bjp-wins-setback-for-congress-1039454"]], domain: "women-cash" },
  { st: "as", election: "assembly", date: "2026-04-09", incumbentParty: "BJP", winner: "BJP", srcs: [["Wikipedia — 2026 Assam Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Assam_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "kl", election: "assembly", date: "2026-04-09", incumbentParty: "LDF", winner: "UDF (INC-led); V. D. Satheesan CM", srcs: [["Wikipedia infobox (pointer to ECI): 2026 Kerala Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Kerala_Legislative_Assembly_election"],["DD News, 4 May 2026: UDF crosses majority mark in Kerala (ECI trends)","https://ddnews.gov.in/en/assembly-polls-2026-udf-crosses-majority-mark-in-kerala/"]], domain: "state-cash-other" },
  { st: "tn", election: "assembly", date: "2026-04-23", incumbentParty: "DMK", winner: "TVK", srcs: [["Wikipedia — 2026 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"],["Variety — Vijay sworn in as Tamil Nadu CM","https://variety.com/2026/politics/news/vijay-sworn-in-tamil-nadu-chief-minister-1236742532/"],["Wikipedia infobox (pointer to ECI results): 2026 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"],["Wikipedia (pointer): 2026 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"]], domain: "elections-timing" },
  { st: "wb", election: "assembly", date: "2026-04-23", incumbentParty: "TMC", winner: "BJP", srcs: [["Wikipedia — 2026 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2026_West_Bengal_Legislative_Assembly_election"],["The Daily Star — Suvendu Adhikari sworn in as WB CM","https://www.thedailystar.net/news/asia/india/news/suvendu-sworn-chief-minister-west-bengal-4171876"]], domain: "elections-timing" },
  { st: "wb", election: "assembly", date: "2026-04-29", incumbentParty: "AITC", winner: "BJP", srcs: [["Wikipedia (pointer): 2026 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2026_West_Bengal_Legislative_Assembly_election"],["India TV, 4–5 May 2026: West Bengal 2026 result — BJP wins","https://www.indiatvnews.com/west-bengal/news-west-bengal-assembly-election-2026-full-list-of-winners-leading-candidates-294-seats-2026-05-04-1038758"]], domain: "women-cash" },
  { st: "as", election: "assembly (counting day; polling dates not verified here)", date: "2026-05-04", incumbentParty: "BJP", winner: "BJP 82 of 126; INC 19", srcs: [["India TV News, Assam Election Result 2026 live: BJP wins 82 of 126, 4 May 2026","https://www.indiatvnews.com/north-east/assam/assam-election-result-2026-live-updates-himanta-biswa-sarma-led-bjp-wins-setback-for-congress-1039454"]], domain: "central" },
  { st: "wb", election: "assembly (counting day; polling dates not verified here)", date: "2026-05-04", incumbentParty: "TMC", winner: "BJP (Suvendu Adhikari CM by Jun 2026); seat tally not captured in the page opened", srcs: [["India TV News, West Bengal Assembly Election 2026 result: full list of winners, 4 May 2026","https://www.indiatvnews.com/west-bengal/news-west-bengal-assembly-election-2026-full-list-of-winners-leading-candidates-294-seats-2026-05-04-1038758"],["PIB, PM to release 23rd instalment from Tarakeswar, Hooghly, WB on 20 Jun 2026, 18 Jun 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2274616"]], domain: "central" },
];

/** What each file declares it searched. A state-year is painted "searched, none live" only when an entry here declares it. */
export const WELFARE_COVERAGE: Coverage[] = [
  {"st":"central","fromYear":2019,"toYear":2026,"categories":["farmer-cash"],"method":"Union farmer cash transfers: Interim Budget 2019-20 speech (PM-KISAN announcement), Union Budget 2019-20/2023-24/2024-25(I)/2026-27 speeches read for any new or raised farmer transfer, PIB instalment releases (18th–23rd), MoA&FW Rajya Sabha reply on saturation drives, two Lok Sabha unstarred questions (Dec 2025) and the Jul 2026 Cabinet continuation. PM-KISAN was the only live central farmer-cash scheme found; the KCC/interest-subvention credit stack was deliberately excluded and is not covered by this declaration.","srcs":[["Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)","https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"],["Union Budget 2019-20 speech, Nirmala Sitharaman, 5 Jul 2019","https://www.indiabudget.gov.in/budget2019-20/doc/Budget_Speech.pdf"],["Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)","https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"],["Union Budget 2026-27 speech, Nirmala Sitharaman, 1 Feb 2026","https://www.indiabudget.gov.in/doc/Budget_Speech.pdf"],["PIB, PM to release 21st instalment of PM-KISAN on 19 Nov 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2190074"],["PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"],["PIB, PM to release 23rd instalment from Tarakeswar, Hooghly, WB on 20 Jun 2026, 18 Jun 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2274616"],["PIB (MoA&FW RS reply), PM-KISAN 18th instalment beneficiaries and saturation drives, Feb 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2100758"],["Lok Sabha Unstarred Q.358 (MoS Agri Ramnath Thakur), discrepancy in PM-KISAN: ₹416.75 cr recovered from ineligible beneficiaries, 2 Dec 2025","https://sansad.in/getFile/loksabhaquestions/annex/186/AU358_FPeZsZ.pdf?source=pqals"],["PMO, Cabinet approves continuation of PM-KISAN 2026-27 to 2030-31, ₹3.15 lakh crore, 31 Jul 2026","https://www.pmindia.gov.in/en/news_updates/cabinet-approves-continuation-of-the-pm-kisan-scheme-from-2026-27-to-2030-31-with-a-financial-outlay-of-rs-3-15-lakh-crore/"]],"domain":"central"},
  {"st":"central","fromYear":2013,"toYear":2026,"categories":["grain"],"method":"Union free/subsidised foodgrain: NFSA 2013 rollout (Wikipedia pointer only for the 2013–19 stretch — thin), PIB release on the Mar 2020 PMGKAY package, PMGKAY phase extensions, the Dec 2022 merger into free NFSA grain (Wikipedia pointer; PIB release not opened), the 29 Nov 2023 Cabinet five-year extension (PIB) and its poll-context reporting. NFSA and PMGKAY were the only live central grain schemes found.","srcs":[["Wikipedia (pointer), National Food Security Act 2013","https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"],["PIB, FM announces ₹1.70 lakh crore Pradhan Mantri Garib Kalyan package, 26 Mar 2020","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1608345"],["Wikipedia (pointer), PMGKAY","https://en.wikipedia.org/wiki/Pradhan_Mantri_Garib_Kalyan_Anna_Yojana"],["PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"],["ThePrint/ANI, 'Guarantee of Modi': PM extends free ration scheme for 5 years in poll-bound Chhattisgarh, MP, 4 Nov 2023","https://theprint.in/india/guarantee-of-modi-pm-extends-free-ration-scheme-for-5-years-in-poll-bound-chhattisgarh-mp/1832402/"]],"domain":"central"},
  {"st":"central","fromYear":2014,"toYear":2026,"categories":["unemployment"],"method":"Union wage-employment guarantee: MoRD BE/RE/release series 2014-15 to 2022-23 (PIB, Feb 2023), MoRD Rajya Sabha reply on 2020-21 to 2024-25 allocations, Union Budget 2023-24 and 2026-27 speeches, the Dec 2025 VB-G RAM G Bill passage (Akashvani, Deccan Herald, BehanBox) and the May 2026 PIB FAQ on the repeal w.e.f. 1 Jul 2026. MGNREGA and its successor VB-G RAM G were the only central schemes of this category found; 2005–2013 rests on a Wikipedia pointer and is not declared.","srcs":[["PIB (MoRD), Clarifications on budget cut to MGNREGA, BE/RE/release series 2014-15 to 2022-23, 3 Feb 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"],["PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"],["Union Budget 2023-24 speech, Nirmala Sitharaman, 1 Feb 2023","https://www.indiabudget.gov.in/budget2023-24/doc/Budget_Speech.pdf"],["Union Budget 2026-27 speech, Nirmala Sitharaman, 1 Feb 2026","https://www.indiabudget.gov.in/doc/Budget_Speech.pdf"],["Akashvani News, Rajya Sabha takes up VB-G RAM G Bill, 18 Dec 2025","https://www.newsonair.gov.in/lok-sabha-considers-viksit-bharat-bill-to-replace-2005-rural-employment-scheme"],["Deccan Herald, Lok Sabha passes VB-G RAM G Bill amid Opposition protests, 18 Dec 2025","https://www.deccanherald.com/india/lok-sabha-passes-vb-g-ram-g-bill-amid-opposition-protests-3835324"],["BehanBox, 'The GRAMG Bill codifies the stealthy ways in which NREGA was being undermined', 18 Dec 2025","https://behanbox.com/2025/12/18/the-gramg-bill-codifies-the-stealthy-ways-in-which-nrega-was-being-undermined/"],["PIB Backgrounder, Viksit Bharat-G RAM G Act 2025 FAQ, 11 May 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2259712"]],"domain":"central"},
  {"st":"central","fromYear":2008,"toYear":2013,"categories":["loan-waiver"],"method":"Union farm loan waivers: Union Budget 2008-09 speech para 73 (ADWDRS announcement) and CAG Report 3 of 2013 on its implementation (executive-summary PDF is image-only; figures from a search excerpt). ADWDRS 2008 was the only central loan waiver found in this window; no central waiver was announced in the 2019, 2023, 2024(I) or 2026 budget speeches opened, but those later years are not declared because no dedicated search for waivers was run beyond the speeches.","srcs":[["Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)","https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"],["CAG Report No. 3 of 2013, ADWDRS 2008 executive summary (PDF is image-only; text not machine-verified)","https://cag.gov.in/uploads/download_audit_report/2013/Union_Performance_Civil_Sector_3_2013_chapter_3_exe_summ.pdf"]],"domain":"central"},
  {"st":"central","fromYear":2008,"toYear":2026,"categories":["pension"],"method":"Union social-assistance pensions: NSAP (IGNOAPS/IGNWPS/IGNDPS/NFBS/Annapurna) via the Nov 2025 PIB backgrounder, checked against the 2008-09, 2019-20(I), 2019-20, 2023-24, 2024-25(I) and 2026-27 Union Budget speeches for any raise or new central pension. NSAP was the only live central pension found; the ₹200 IGNOAPS central share was unchanged in every speech opened. Coverage between speech years rests on the backgrounder's history, not year-by-year documents.","srcs":[["PIB Backgrounder, National Social Assistance Programme, 7 Nov 2025","https://www.pib.gov.in/PressNoteDetails.aspx?NoteId=155928&ModuleId=3"],["Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)","https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"],["Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)","https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"],["Union Budget 2019-20 speech, Nirmala Sitharaman, 5 Jul 2019","https://www.indiabudget.gov.in/budget2019-20/doc/Budget_Speech.pdf"],["Union Budget 2023-24 speech, Nirmala Sitharaman, 1 Feb 2023","https://www.indiabudget.gov.in/budget2023-24/doc/Budget_Speech.pdf"],["Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)","https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"],["Union Budget 2026-27 speech, Nirmala Sitharaman, 1 Feb 2026","https://www.indiabudget.gov.in/doc/Budget_Speech.pdf"]],"domain":"central"},
  {"st":"central","fromYear":2016,"toYear":2026,"categories":["housing"],"method":"Union rural housing grants: PMAY-G via the Feb 2025 MoRD PIB release (progress since Apr 2016 and Cabinet approval of two crore more houses), the Interim Budget 2024-25 and Union Budget 2026-27 speeches, and a Wikipedia pointer. PMAY-G was the only central housing distribution scheme found; PMAY-Urban was not searched and is not covered.","srcs":[["PIB (MoRD), PMAY-G progress and Cabinet approval of 2 crore more houses, 7 Feb 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2100659"],["PIB, Interim Budget 2024-25: Lakhpati Didi target 2 cr → 3 cr, 1 Feb 2024","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2001109"],["Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)","https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"],["Union Budget 2026-27 speech, Nirmala Sitharaman, 1 Feb 2026","https://www.indiabudget.gov.in/doc/Budget_Speech.pdf"],["Wikipedia (pointer), Pradhan Mantri Awas Yojana","https://en.wikipedia.org/wiki/Pradhan_Mantri_Awas_Yojana"]],"domain":"central"},
  {"st":"mp","fromYear":2023,"toYear":2026,"categories":["women-cash"],"method":"Mukhyamantri Ladli Behna Yojana — official portal opened (amount progression ₹1,000→1,250→1,500 confirmed live as of 2026) plus the 2023 MP election result page. Single-scheme lookup made for this file’s election-timing join, not a state-wide sweep: the named scheme’s existence, amount and status were checked for these years against the sources listed. Declared only for the category and years those sources cover; no other category or year in this state was searched by this file. Calendar dates for announcement/launch could not be pinned (see gaps).","srcs":[["Govt of MP — Ladli Behna official portal","https://cmladlibehna.mp.gov.in/"],["Wikipedia — 2023 MP Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"]],"domain":"elections-timing"},
  {"st":"wb","fromYear":2021,"toYear":2026,"categories":["women-cash"],"method":"Lakshmir Bhandar — Vikaspedia scheme page, the Feb 2026 interim-budget hike (ETV Bharat, ANI) and the March 2026 TMC manifesto (Business Today) opened; live 2021 through the April 2026 poll. Single-scheme lookup made for this file’s election-timing join, not a state-wide sweep: the named scheme’s existence, amount and status were checked for these years against the sources listed. Declared only for the category and years those sources cover; no other category or year in this state was searched by this file.","srcs":[["Vikaspedia — Lakshmir Bhandar scheme","https://en.vikaspedia.in/viewcontent/schemesall/state-specific-schemes/welfare-schemes-of-west-bengal/lakhsmir-bhandar-scheme"],["Business Today — TMC manifesto Lakshmir Bhandar hike","https://www.businesstoday.in/elections/west-bengal/story/rise-in-lakshmir-bhandar-allocation-by-rs500-rs30000-crore-agriculture-budget-key-highlights-of-tmcs-manifesto-for-west-bengal-polls-521659-2026-03-20"],["ETV Bharat — WB budget 2026 hikes Lakshmir Bhandar ahead of polls","https://www.etvbharat.com/en/state/west-bengal-budget-2026-mamata-hikes-lakshmir-bhandar-unveils-youth-allowance-and-seventh-pay-commission-ahead-of-polls-enn26020506960"],["ANI — WB Rs 500 hike ahead of assembly polls","https://aninews.in/news/national/politics/west-bengal-govt-announces-rs-500-hike-for-lakshmir-bhandar-beneficaries-ahead-of-assembly-polls20260206060332/"]],"domain":"elections-timing"},
  {"st":"tn","fromYear":2023,"toYear":2026,"categories":["women-cash"],"method":"Kalaignar Magalir Urimai Thogai — official KMUT portal and DT Next appeals report opened; scheme live from Sept 2023 and continuing past the April 2026 change of government. Single-scheme lookup made for this file’s election-timing join, not a state-wide sweep: the named scheme’s existence, amount and status were checked for these years against the sources listed. Declared only for the category and years those sources cover; no other category or year in this state was searched by this file.","srcs":[["DT Next — Kalaignar Magalir Urimai Thogai","https://www.dtnext.in/news/tamilnadu/kalaignar-magalir-urimai-thogai-scheme-over-148-lakh-women-file-fresh-appeals-now-eligible-for-rs-1000-monthly-aid-792929"],["Govt of TN — KMUT official portal","https://kmut.tn.gov.in/"],["Wikipedia — 2026 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"]],"domain":"elections-timing"},
  {"st":"as","fromYear":2020,"toYear":2021,"categories":["women-cash"],"method":"Orunodoi — Dec 2020 launch reports (Organiser, Deccan Herald) opened for the 2021 election-timing join. Later years are not declared: the 2026 continuation rests on an election-result page, not a scheme check. Single-scheme lookup made for this file’s election-timing join, not a state-wide sweep: the named scheme’s existence, amount and status were checked for these years against the sources listed. Declared only for the category and years those sources cover; no other category or year in this state was searched by this file.","srcs":[["Organiser — Orunodoi scheme launched in Assam","https://organiser.org/2020/12/02/132039/bharat/orunodoi-scheme-launched-in-assam-to-empower-women/"],["Deccan Herald — BJP-led Assam govt launches Orunodoi ahead of polls","https://www.deccanherald.com/amp/story/india%2Fbjp-led-assam-govt-launches-cash-transfer-scheme-orunodoi-ahead-of-assembly-elections-922119.html"]],"domain":"elections-timing"},
  {"st":"br","fromYear":2025,"toYear":2025,"categories":["women-cash"],"method":"Mukhyamantri Mahila Rozgar Yojana — Sept–Oct 2025 disbursement reports (Deccan Herald, News on Air) opened for the Nov 2025 election-timing join. Single-scheme lookup made for this file’s election-timing join, not a state-wide sweep: the named scheme’s existence, amount and status were checked for these years against the sources listed. Declared only for the category and years those sources cover; no other category or year in this state was searched by this file.","srcs":[["Deccan Herald — Bihar Rs 10,000 cash transfer to women","https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-rs-10000-cash-transfer-to-women-may-prove-game-changer-for-nitish-kumar-3773893"],["The Federal — Bihar pre-poll cash push sparks concerns over ECI neutrality","https://thefederal.com/category/elections-2025/pre-poll-cash-transfers-in-bihar-raise-concerns-over-voter-influence-eci-neutrality-214703"],["Akashvani/News on Air — Nitish transfers Rs 10,000 to 21 lakh women","https://newsonair.gov.in/cm-nitish-kumar-transfers-%E2%82%B910000-each-to-21-lakh-women-under-mahila-rozgar-yojana/"],["News on Air — Nitish transfers Rs 10,000 to 25 lakh women","https://www.newsonair.gov.in/bihar-cm-nitish-kumar-transferred-%E2%82%B910000-each-to-25-lakh-women-under-the-mukhyamantri-mahila-rozgar-yojana-promoting-self-employment"]],"domain":"elections-timing"},
  {"st":"mh","fromYear":2024,"toYear":2024,"categories":["women-cash"],"method":"Mukhyamantri Majhi Ladki Bahin Yojana — Government of Maharashtra (Nashik district) scheme page and Outlook Business analysis opened for the Nov 2024 election-timing join. Single-scheme lookup made for this file’s election-timing join, not a state-wide sweep: the named scheme’s existence, amount and status were checked for these years against the sources listed. Declared only for the category and years those sources cover; no other category or year in this state was searched by this file.","srcs":[["Govt of Maharashtra (Nashik) — Ladki Bahin Yojana","https://nashik.gov.in/en/scheme/mukhyamantri-mazi-ladki-bahin-yojana/"],["Outlook Business — women deciding Indian politics, cash transfers","https://www.outlookbusiness.com/economy-and-policy/story-in-numbers-women-are-deciding-indian-politics-now-cash-transfers-are-proof"]],"domain":"elections-timing"},
  {"st":"jh","fromYear":2024,"toYear":2025,"categories":["women-cash"],"method":"Maiya Samman Yojana — IMPRI policy update (Aug 2024 launch, Jan 2025 rise to ₹2,500) opened for the Nov 2024 election-timing join. Single-scheme lookup made for this file’s election-timing join, not a state-wide sweep: the named scheme’s existence, amount and status were checked for these years against the sources listed. Declared only for the category and years those sources cover; no other category or year in this state was searched by this file.","srcs":[["IMPRI — Maiya Samman Yojana policy update","https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"]],"domain":"elections-timing"},
  {"st":"ka","fromYear":2023,"toYear":2023,"categories":["women-cash"],"method":"Gruha Lakshmi — Congress launch note and Tribune launch-day report (Aug 2023) opened for the May 2023 election-timing join; nothing later than 2023 was checked. Single-scheme lookup made for this file’s election-timing join, not a state-wide sweep: the named scheme’s existence, amount and status were checked for these years against the sources listed. Declared only for the category and years those sources cover; no other category or year in this state was searched by this file.","srcs":[["Congress — Gruha Lakshmi launch","https://inc.in/congress-sandesh/others/in-karnataka-gruha-lakshmi-scheme-launched-1-1-crore-women-heads-of-households-to-get-2000-monthly-aid"],["Tribune — Gruha Lakshmi launch today","https://www.tribuneindia.com/news/india/karnataka-govt-to-launch-gruha-lakshmi-scheme-today-to-benifit-1-1-crore-women-539715"]],"domain":"elections-timing"},
  {"st":"central","fromYear":2019,"toYear":2024,"categories":["farmer-cash"],"method":"PM-KISAN — PMO cabinet-approval note (Feb 2019) and PIB release (2024) opened for the 2019/2024 Lok Sabha timing join. Central lookup of this one scheme only; not a sweep of all central farmer-cash instruments. Single-scheme lookup made for this file’s election-timing join, not a state-wide sweep: the named scheme’s existence, amount and status were checked for these years against the sources listed. Declared only for the category and years those sources cover; no other category or year in this state was searched by this file.","srcs":[["PIB — PM-KISAN Samman Nidhi","https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=2039203"],["PMO — Cabinet approves PM-KISAN","https://www.pmindia.gov.in/en/news_updates/cabinet-approves-pradhan-mantri-kisan-samman-nidhi-pm-kisan-scheme/"]],"domain":"elections-timing"},
  {"st":"central","fromYear":2020,"toYear":2024,"categories":["grain"],"method":"PMGKAY — Wikipedia pointer and Deccan Herald report of the Nov 2023 cabinet decision extending free grain five years from Jan 2024 opened. Central lookup of this one scheme only. Single-scheme lookup made for this file’s election-timing join, not a state-wide sweep: the named scheme’s existence, amount and status were checked for these years against the sources listed. Declared only for the category and years those sources cover; no other category or year in this state was searched by this file.","srcs":[["Wikipedia — PMGKAY","https://en.wikipedia.org/wiki/Pradhan_Mantri_Garib_Kalyan_Anna_Yojana"]],"domain":"elections-timing"},
  {"st":"wb","fromYear":2025,"toYear":2025,"categories":["women-cash"],"method":"FY 2025-26 (BE) only, women's monthly unconditional cash transfers only: PRS State of State Finances 2025-26 Annexure Table 6 and Figs 13–15 read for this state's UCT line (Lakshmir Bhandar) — budgeted outlay and share of revenue expenditure/receipts. Ideas for India searched 25 Sep 2026 for an evaluation (none found). This is a fiscal reading of one PRS compilation, not a search of the state's budget documents or press for other live schemes; no other category and no other year is declared. Launch chronology and payment status sit in women-cash.json.","srcs":[["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PRS Legislative Research, State of State Finances 2025 — landing page","https://prsindia.org/budgets/states/policy/state-of-state-finances-2025"],["Ideas for India site search 'Lakshmir Bhandar' (opened 25 Sep 2026; returned no evaluation)","https://www.ideasforindia.in/search?q=Lakshmir+Bhandar"]],"domain":"fiscal-results"},
  {"st":"mp","fromYear":2025,"toYear":2025,"categories":["women-cash"],"method":"FY 2025-26 (BE) only, women's monthly unconditional cash transfers only: PRS State of State Finances 2025-26 Annexure Table 6 and Figs 13–15 read for this state's UCT line (Ladli Behna) — budgeted outlay and share of revenue expenditure/receipts. This is a fiscal reading of one PRS compilation, not a search of the state's budget documents or press for other live schemes; no other category and no other year is declared. Launch chronology and payment status sit in women-cash.json.","srcs":[["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PRS Legislative Research, State of State Finances 2025 — landing page","https://prsindia.org/budgets/states/policy/state-of-state-finances-2025"]],"domain":"fiscal-results"},
  {"st":"mh","fromYear":2025,"toYear":2025,"categories":["women-cash"],"method":"FY 2025-26 (BE) only, women's monthly unconditional cash transfers only: PRS State of State Finances 2025-26 Annexure Table 6 and Figs 13–15 read for this state's UCT line (Ladki Bahin) — budgeted outlay and share of revenue expenditure/receipts. PRS Table 7 off-budget borrowing series and the Apr 2025 ₹500 cut noted by PRS also read. This is a fiscal reading of one PRS compilation, not a search of the state's budget documents or press for other live schemes; no other category and no other year is declared. Launch chronology and payment status sit in women-cash.json.","srcs":[["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PRS Legislative Research, State of State Finances 2025 — landing page","https://prsindia.org/budgets/states/policy/state-of-state-finances-2025"]],"domain":"fiscal-results"},
  {"st":"ka","fromYear":2025,"toYear":2025,"categories":["women-cash"],"method":"FY 2025-26 (BE) only, women's monthly unconditional cash transfers only: PRS State of State Finances 2025-26 Annexure Table 6 and Figs 13–15 read for this state's UCT line (Gruha Lakshmi) — budgeted outlay and share of revenue expenditure/receipts. CAG State Finances Audit Report 2024-25 findings on the five guarantee schemes and the government's rebuttal read as reported by Deccan Herald (Aug 2025, Mar 2026); the CAG text itself was not opened. This is a fiscal reading of one PRS compilation, not a search of the state's budget documents or press for other live schemes; no other category and no other year is declared. Launch chronology and payment status sit in women-cash.json.","srcs":[["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PRS Legislative Research, State of State Finances 2025 — landing page","https://prsindia.org/budgets/states/policy/state-of-state-finances-2025"],["Deccan Herald, 26 Mar 2026: 'Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG' (CAG State Finances Audit Report 2024-25, tabled 26 Mar 2026)","https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"],["Deccan Herald, 26 Aug 2025: ''CAG report's conclusions on welfare schemes in Karnataka incorrect': H M Revanna'","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"]],"domain":"fiscal-results"},
  {"st":"jh","fromYear":2025,"toYear":2025,"categories":["women-cash"],"method":"FY 2025-26 (BE) only, women's monthly unconditional cash transfers only: PRS State of State Finances 2025-26 Annexure Table 6 and Figs 13–15 read for this state's UCT line (Maiya Samman) — budgeted outlay and share of revenue expenditure/receipts. This is a fiscal reading of one PRS compilation, not a search of the state's budget documents or press for other live schemes; no other category and no other year is declared. Launch chronology and payment status sit in women-cash.json.","srcs":[["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PRS Legislative Research, State of State Finances 2025 — landing page","https://prsindia.org/budgets/states/policy/state-of-state-finances-2025"]],"domain":"fiscal-results"},
  {"st":"tn","fromYear":2025,"toYear":2025,"categories":["women-cash"],"method":"FY 2025-26 (BE) only, women's monthly unconditional cash transfers only: PRS State of State Finances 2025-26 Annexure Table 6 and Figs 13–15 read for this state's UCT line (Kalaignar Magalir Urimai Thogai) — budgeted outlay and share of revenue expenditure/receipts. This is a fiscal reading of one PRS compilation, not a search of the state's budget documents or press for other live schemes; no other category and no other year is declared. Launch chronology and payment status sit in women-cash.json.","srcs":[["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PRS Legislative Research, State of State Finances 2025 — landing page","https://prsindia.org/budgets/states/policy/state-of-state-finances-2025"]],"domain":"fiscal-results"},
  {"st":"as","fromYear":2025,"toYear":2025,"categories":["women-cash"],"method":"FY 2025-26 (BE) only, women's monthly unconditional cash transfers only: PRS State of State Finances 2025-26 Annexure Table 6 and Figs 13–15 read for this state's UCT line (Orunodoi) — budgeted outlay and share of revenue expenditure/receipts. This is a fiscal reading of one PRS compilation, not a search of the state's budget documents or press for other live schemes; no other category and no other year is declared. Launch chronology and payment status sit in women-cash.json.","srcs":[["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PRS Legislative Research, State of State Finances 2025 — landing page","https://prsindia.org/budgets/states/policy/state-of-state-finances-2025"]],"domain":"fiscal-results"},
  {"st":"or","fromYear":2025,"toYear":2025,"categories":["women-cash"],"method":"FY 2025-26 (BE) only, women's monthly unconditional cash transfers only: PRS State of State Finances 2025-26 Annexure Table 6 and Figs 13–15 read for this state's UCT line (Subhadra) — budgeted outlay and share of revenue expenditure/receipts. This is a fiscal reading of one PRS compilation, not a search of the state's budget documents or press for other live schemes; no other category and no other year is declared. Launch chronology and payment status sit in women-cash.json.","srcs":[["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PRS Legislative Research, State of State Finances 2025 — landing page","https://prsindia.org/budgets/states/policy/state-of-state-finances-2025"]],"domain":"fiscal-results"},
  {"st":"ct","fromYear":2025,"toYear":2025,"categories":["women-cash"],"method":"FY 2025-26 (BE) only, women's monthly unconditional cash transfers only: PRS State of State Finances 2025-26 Annexure Table 6 and Figs 13–15 read for this state's UCT line (Mahtari Vandan) — budgeted outlay and share of revenue expenditure/receipts. This is a fiscal reading of one PRS compilation, not a search of the state's budget documents or press for other live schemes; no other category and no other year is declared. Launch chronology and payment status sit in women-cash.json.","srcs":[["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PRS Legislative Research, State of State Finances 2025 — landing page","https://prsindia.org/budgets/states/policy/state-of-state-finances-2025"]],"domain":"fiscal-results"},
  {"st":"hr","fromYear":2025,"toYear":2025,"categories":["women-cash"],"method":"FY 2025-26 (BE) only, women's monthly unconditional cash transfers only: PRS State of State Finances 2025-26 Annexure Table 6 and Figs 13–15 read for this state's UCT line (Lado Lakshmi) — budgeted outlay and share of revenue expenditure/receipts. This is a fiscal reading of one PRS compilation, not a search of the state's budget documents or press for other live schemes; no other category and no other year is declared. Launch chronology and payment status sit in women-cash.json.","srcs":[["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PRS Legislative Research, State of State Finances 2025 — landing page","https://prsindia.org/budgets/states/policy/state-of-state-finances-2025"]],"domain":"fiscal-results"},
  {"st":"dl","fromYear":2025,"toYear":2025,"categories":["women-cash"],"method":"FY 2025-26 (BE) only, women's monthly unconditional cash transfers only: PRS State of State Finances 2025-26 Annexure Table 6 and Figs 13–15 read for this state's UCT line (Mahila Samriddhi) — budgeted outlay and share of revenue expenditure/receipts. Budget provision only; whether any payment was made is not established here. This is a fiscal reading of one PRS compilation, not a search of the state's budget documents or press for other live schemes; no other category and no other year is declared. Launch chronology and payment status sit in women-cash.json.","srcs":[["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PRS Legislative Research, State of State Finances 2025 — landing page","https://prsindia.org/budgets/states/policy/state-of-state-finances-2025"]],"domain":"fiscal-results"},
  {"st":"hp","fromYear":2025,"toYear":2025,"categories":["women-cash"],"method":"FY 2025-26 (BE) only, women's monthly unconditional cash transfers only: PRS State of State Finances 2025-26 Annexure Table 6 and Figs 13–15 read for this state's UCT line (Indira Gandhi Pyari Behna) — budgeted outlay and share of revenue expenditure/receipts. This is a fiscal reading of one PRS compilation, not a search of the state's budget documents or press for other live schemes; no other category and no other year is declared. Launch chronology and payment status sit in women-cash.json.","srcs":[["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PRS Legislative Research, State of State Finances 2025 — landing page","https://prsindia.org/budgets/states/policy/state-of-state-finances-2025"]],"domain":"fiscal-results"},
  {"st":"ap","fromYear":2022,"toYear":2022,"categories":["farmer-cash"],"method":"FY 2022-23 (BE) only: RBI Bulletin June 2022 'State Finances: A Risk Analysis' Annex 1 read for Andhra Pradesh's ten listed 'freebie' lines (Rythu Bharosa recorded as farmer-cash; Amma Vodi, YSR Aasra, Cheyutha and the electricity subsidy are named in the finding but not carried as scheme records, so only farmer-cash is declared). RBI's own 'freebies' definition, not a sweep of AP budget documents; PRS 2025-26 off-budget borrowing and guarantee figures also read but are not a scheme search.","srcs":[["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"]],"domain":"fiscal-results"},
  {"st":"pb","fromYear":2022,"toYear":2022,"categories":["energy-subsidy"],"method":"FY 2022-23 (BE) only: RBI Bulletin June 2022 Annex 1 read for Punjab's 'freebie' lines — the 300-unit free power line recorded as energy-subsidy; the ₹1,000/month women's promise RBI counted was not enacted and is not a scheme record here, so women-cash is not declared. RBI took Punjab's figures from press because the 2022-23 budget was not yet presented. PRS 2025-26 subsidy share (21% of revenue receipts, 90% power) also read, but no 2023–2025 scheme search was made.","srcs":[["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"]],"domain":"fiscal-results"},
  {"st":"br","fromYear":2022,"toYear":2022,"categories":["student"],"method":"FY 2022-23 (BE) only: RBI Bulletin June 2022 Annex 1 read for Bihar's 'freebie' lines — the Mukhyamantri Balika Cycle line recorded as student; Muralidharan & Prakash (AEJ: Applied 2017) opened for its causal evaluation. Other Bihar lines in the annex were not carried as records, so no other category is declared; Bihar MMRY (one-off women's grant) was not verified here.","srcs":[["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"],["Muralidharan & Prakash, 'Cycling to School: Increasing Secondary School Enrollment for Girls in India', AEJ: Applied Economics 9(3), Jul 2017 — abstract","https://www.aeaweb.org/articles?id=10.1257/app.20160004"]],"domain":"fiscal-results"},
  {"st":"mp","fromYear":2023,"toYear":2025,"categories":["women-cash"],"method":"Single-scheme status lookup for a literature file, not a state-wide sweep: Mukhyamantri Ladli Behna Yojana was checked as live in 2023 (Deccan Herald 5 Mar and 3 Dec 2023; Lokniti-CSDS MP 2023 post-poll Q22 beneficiary share; ISAS brief on the Nov 2023 result, joined to the elections row) and as live in 2025-26 (PRS State of State Finances 2025, which counts MP among the 12 UCT states and prices the scheme against the revenue surplus). Only this women's cash transfer was looked for; no other category, and no year outside 2023–2025, was searched in MP by this file. Announcement, approval, launch dates and outlays were deliberately left to the sibling domain files (see gaps).","srcs":[["Deccan Herald, 2023-03-05 — Ahead of MP govt’s Ladli Behna launch, Kamal Nath promises women ₹18,000 per year","https://www.deccanherald.com/india/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"],["Deccan Herald, 2023-12-03 — Focus on women voters to PM Modi’s ‘magic’: what worked for BJP in MP","https://www.deccanherald.com/india/madhya-pradesh/focus-on-women-voters-to-pm-modis-magic-what-worked-for-bjp-in-madhya-pradesh-assembly-elections-2794883"],["Lokniti-CSDS Maharashtra 2024 post-poll analysis, The Hindu, 25 Nov 2024 (Deshpande, ‘Women sided with Mahayuti for Ladki Bahin Yojana’s monthly dole’; Mishra, women as deciders) — page PDF held locally; thehindu.com unreachable from this container","https://www.lokniti.org/state-assembly-elections"],["Vinod Rai, ‘The BJP Wins the Semi-final: Impressive Gains in State Elections’, ISAS Brief No. 1081, 6 Dec 2023 (PDF held locally)","https://www.isas.nus.edu.sg/"],["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"]],"domain":"literature"},
  {"st":"mh","fromYear":2024,"toYear":2026,"categories":["women-cash"],"method":"Single-scheme status lookup for a literature file, not a state-wide sweep: Mukhyamantri Majhi Ladki Bahin Yojana traced from the first instalment (Deccan Herald 15 Aug 2024) and the Bombay High Court dismissal (Aug 2024), through the Sept 2024 ₹3,000 promise, the Lokniti-CSDS Maharashtra 2024 post-poll write-up, the April 2025 ₹500 reduction for overlapping beneficiaries (PRS Oct 2025), the April and July 2025 opposition claims, to Fadnavis's 14 Aug 2026 statement that the scheme continues; a ThePrint site search for 'ladki bahin' was opened for the 2025–26 status. Only this women's cash transfer was looked for; no other category or year in Maharashtra was searched by this file. The 2024 poll date and the exact April 2025 cut date were not verified here (see gaps).","srcs":[["Deccan Herald, 2024-08-15 — Shinde govt begins releasing money under Ladki Bahin Yojana on eve of Independence Day","https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"],["Deccan Herald, 2024-08-05 — Ladki Bahin Yojana a beneficiary scheme for women, not discriminatory: Bombay High Court","https://www.deccanherald.com/india/maharashtra/ladki-bahin-yojana-a-beneficiary-scheme-for-women-not-discriminatory-bombay-high-court-3137089"],["Deccan Herald, 2024-09-14 — ‘Give us a bigger mandate, will double Ladki Bahin dole to ₹3,000’: Eknath Shinde","https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-give-us-a-bigger-mandate-will-double-ladki-bahin-dole-to-rs-3000-eknath-shinde-3191037"],["Deccan Herald (PTI), 2025-04-16 — Ladki Bahin scheme ‘more or less finished’, claims Aaditya Thackeray","https://www.deccanherald.com/india/maharashtra/ladki-bahin-scheme-more-or-less-finished-claims-aaditya-thackeray-3496353"],["Deccan Herald, 2025-07-29 — Supriya Sule alleges ₹4,800 crore fraud in Ladki Bahin Yojana, seeks SIT probe","https://www.deccanherald.com/india/maharashtra/supriya-sule-alleges-rs-4800-crore-fraud-in-ladki-bahin-yojana-seeks-sit-probe-3654533"],["ThePrint, 2026-08-14 — Govt fulfilled promises made during 2024 polls, will not discontinue Ladki Bahin: Fadnavis","https://theprint.in/india/govt-fulfilled-promises-made-during-2024-polls-will-not-discontinue-ladki-bahin-fadnavis/3015115/"],["ThePrint, 2026-08-19 — 92.10 lakh women removed from Maharashtra govt’s Ladki Bahin scheme, claims Congress leader (Vijay Wadettiwar)","https://theprint.in/india/92-10-lakh-women-removed-from-maharashtra-govts-ladki-bahin-scheme-claims-congress-leader/3019624/"],["ThePrint search — ‘ladki bahin’ (results page opened)","https://theprint.in/?s=ladki+bahin"],["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"]],"domain":"literature"},
  {"st":"central","fromYear":2023,"toYear":2025,"categories":["unemployment"],"method":"Single-scheme budget-status lookup for a literature file, not a sweep of central schemes: MGNREGA's allocation and live status were checked from two PIB releases — the MoRD clarification on the BE 2023-24 cut (3 Feb 2023) and the Rajya Sabha reply on BE 2024-25 and 2025-26 (25 Jul 2025). Only the employment guarantee was checked, and only for these budget years; PM-KISAN, PMGKAY/NFSA grain, Ujjwala and other central transfers were not status-checked by this file (NFSA and Ujjwala appear here only through 2017–2019 evaluations) and are not covered by this declaration.","srcs":[["PIB, Ministry of Rural Development — Clarifications on budget cut to MGNREGA, 2023-02-03 (Release ID 1896038)","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"],["PIB, Ministry of Rural Development — Budget allocation under MGNREGA, Rajya Sabha written reply by MoS Kamlesh Paswan, 2025-07-25 (Release ID 2148475)","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"]],"domain":"literature"},
  {"st":"tg","fromYear":2018,"toYear":2025,"categories":["farmer-cash","pension","loan-waiver"],"method":"Rythu Bandhu/Bharosa traced from the Feb 2018 announcement through the Jan 2025 Congress relaunch (IGIDR case study, CM's Dec 2024 Assembly statement, ANI Jan 2025); Aasara pensions read from the CAG 2021 performance audit and the PRS 2023-24 line; the Jul 2024 crop-loan waiver from AIR releases; PRS Telangana Budget Analyses 2018-19, 2023-24, 2024-25 and 2025-26 opened for scheme heads. Only farmer cash, social pensions and loan waivers were swept — women's cash sits in women-cash.json; 2014–17 Aasara history rests on a Wikipedia pointer and is not declared.","srcs":[["PRS, Telangana Budget Analysis 2018-19","https://prsindia.org/budgets/states/telangana-budget-analysis-2018-19"],["PRS, Telangana Budget Analysis 2023-24","https://prsindia.org/budgets/states/telangana-budget-analysis-2023-24"],["PRS, Telangana Budget Analysis 2024-25","https://prsindia.org/budgets/states/telangana-budget-analysis-2024-25"],["PRS, Telangana Budget Analysis 2025-26","https://prsindia.org/budgets/states/telangana-budget-analysis-2025-26"],["CAG, Performance Audit of DBT scheme 'Aasara Pensions in Telangana' (2021), Chapter III (PDF)","https://cag.gov.in/uploads/download_audit_report/2021/Chapter-III-Implementation-of-Aasara-Pensions-as-a-DBT-Scheme-065cdb90dd72180.15791130.pdf"],["Thomas, Uday & Zaveri (IGIDR/IFROGS), 'Linking welfare distribution to land records: a case-study of the Rythu Bandhu Scheme', TR-2020-4-27 (PDF)","https://ifrogs.org/PDF/rbs_report.pdf"],["Business Standard/ANI, 26 Feb 2018: KCR govt to allocate Rs 12,000 cr for crop investment support","https://www.business-standard.com/article/news-ani/kcr-govt-to-allocate-rs-12-000-cr-for-crop-investment-support-118022600048_1.html"],["Deccan Herald/PTI, 21 Dec 2024: Rythu Bandhu Rs 22,600 cr given to ineligible people in BRS regime, says Telangana CM","https://www.deccanherald.com/india/telangana/rythu-bandhu-rs-22600-crore-given-to-ineligible-people-in-brs-regime-says-telangana-cm-3328152"],["ANI, 5 Jan 2025: Telangana farmers to receive Rs 12,000 per acre annually under Rythu Bharosa","https://www.aninews.in/news/national/general-news/telangana-farmers-to-receive-rs-12000-per-acre-annually-under-rythu-bharosa-scheme20250105033356/"],["News On Air (AIR), 17 Jul 2024: Telangana to implement crop loan waiver from tomorrow","https://www.newsonair.gov.in/telangana-to-implement-crop-loan-waiver-from-tomorrow-onwards"],["News On Air (AIR), 18 Jul 2024: Over Rs 6,000 cr released towards crop loan waiver; 11 lakh farmers in phase 1","https://www.newsonair.gov.in/telangana-over-rs-6000-cr-released-by-state-govt-towards-crop-loan-waiver/"]],"domain":"state-cash-other"},
  {"st":"ap","fromYear":2019,"toYear":2025,"categories":["farmer-cash","student","pension"],"method":"YSR Rythu Bharosa (Oct 2019 launch to the TDP rebadging as Annadata Sukhibhava), Amma Vodi (to Talliki Vandanam, Jun 2025) and YSR Pension Kanuka (to NTR Bharosa) traced through PRS Andhra Pradesh Budget Analyses 2020-21, 2023-24 and 2024-25, The Print's Apr 2024 field report and the Jun 2025 DH/PTI launch report. Successor-scheme GOs were not opened (see voids); only the three named categories were swept.","srcs":[["PRS, Andhra Pradesh Budget Analysis 2020-21","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2020-21"],["PRS, Andhra Pradesh Budget Analysis 2023-24","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2023-24"],["PRS, Andhra Pradesh Budget Analysis 2024-25","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2024-25"],["The Print, 18 Apr 2024: As Jagan banks on direct benefit schemes in AP, voters split","https://theprint.in/politics/as-jagan-banks-on-direct-benefit-schemes-in-ap-voters-split-anxiety-over-jobs-cost-of-living/2046063/"],["Govt Schemes India — YSR Rythu Bharosa: launched 15 Oct 2019; ₹13,500/yr per farmer family (₹7,500 state + ₹6,000 PM-KISAN)","https://www.govtschemes.in/ysr-rythu-bharosa-scheme"],["YSR Congress Party — YSR Rythu Bharosa: all you need to know (party source; launch 15 Oct at Kakaturu, Nellore; ₹13,500 incl. ₹6,000 PM-KISAN)","https://www.ysrcongress.com/special-news/ysr-rythu-bharosa-all-you-need-69738"],["Deccan Herald/PTI, 13 Jun 2025: AP launches Talliki Vandanam Rs 15,000 per child","https://www.deccanherald.com/india/andhra-pradesh/andhra-govt-launches-talliki-vandanam-scheme-rs-15000-to-be-given-for-school-going-child-3584484"]],"domain":"state-cash-other"},
  {"st":"or","fromYear":2018,"toYear":2024,"categories":["farmer-cash"],"method":"KALIA traced from the Dec 2018 announcement through the 2019 ineligible-beneficiary refunds (ANI, BS/PTI 2019), the CAG Report No. 2 of 2024 compliance audit and the BJP government's 2024-25 replacement (PRS Odisha Budget Analyses 2019-20 and 2024-25). Farmer cash only; CM-Kisan guidelines not opened.","srcs":[["CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)","https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"],["Business Standard/PTI, 12 Sep 2024: Rs 782.2 cr given to 12.2 lakh ineligible beneficiaries under KALIA: CAG","https://www.business-standard.com/india-news/rs-782-2-cr-given-to-12-2l-ineligible-beneficiaries-under-kalia-scheme-cag-124091200419_1.html"],["ANI, 18 Sep 2019: Odisha: 3.41 lakh ineligible beneficiaries identified under KALIA","https://www.aninews.in/news/national/general-news/odisha-341lakh-ineligible-beneficiaries-identified-under-kalia-scheme20190918023936/"],["Business Standard/PTI, 6 Aug 2019: Ineligible beneficiaries refund KALIA assistance: Odisha govt","https://www.business-standard.com/article/pti-stories/ineligible-beneficiaries-refund-kalia-assistance-odisha-govt-119080601520_1.html"],["PRS, Odisha Budget Analysis 2019-20","https://prsindia.org/budgets/states/odisha-budget-analysis-2019-20"],["PRS, Odisha Budget Analysis 2024-25","https://prsindia.org/budgets/states/odisha-budget-analysis-2024-25"]],"domain":"state-cash-other"},
  {"st":"ct","fromYear":2018,"toYear":2024,"categories":["farmer-cash","loan-waiver","grain"],"method":"The Dec 2018 farm-loan waiver, Rajiv Gandhi Kisan Nyay Yojana (May 2020 launch to the 2023 change of government) and the Rs 1–2/kg rice scheme's 2018–19 status read through PRS Chhattisgarh Budget Analyses 2019-20, 2020-21 and 2024-25, National Herald (May 2020) and Business Standard (Nov 2013). Pre-2018 cheap-rice history (2007 start) is unverified in an opened page and is not declared; Krishak Unnati successor terms not opened.","srcs":[["PRS, Chhattisgarh Budget Analysis 2019-20","https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2019-20"],["PRS, Chhattisgarh Budget Analysis 2020-21","https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2020-21"],["PRS, Chhattisgarh Budget Analysis 2024-25","https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2024-25"],["National Herald, 18 May 2020: Chhattisgarh launches Rajiv Gandhi Kisan Nyay Yojana from May 21","https://www.nationalheraldindia.com/india/chhattisgarh-launches-rajiv-gandhi-kisan-nyay-yojana-from-may-21"],["Wikipedia (pointer): Rajiv Gandhi Kisan Nyay Yojana","https://en.wikipedia.org/wiki/Rajiv_Gandhi_Kisan_Nyay_Yojana"],["Business Standard, 13 Nov 2013: Politics over rice in Chhattisgarh","https://www.business-standard.com/article/politics/politics-over-rice-in-chhattisgarh-113111300355_1.html"]],"domain":"state-cash-other"},
  {"st":"ka","fromYear":2018,"toYear":2025,"categories":["loan-waiver","grain","unemployment","other"],"method":"The 2018 JD(S)-INC crop-loan waiver (DH May 2018, Tribune Jul 2018, DH Jan 2024 on unpaid farmers), the five guarantees (BS May 2023 cabinet, South First Mar 2025 budget, DH Aug 2025 and Mar 2026 on the CAG fiscal report), Anna Bhagya (TNM/DH Feb 2025) and Yuva Nidhi, with PRS Karnataka Budget Analyses 2018-19 and 2023-24 opened. Gruha Lakshmi is covered in women-cash.json, not here; Shakti free-bus travel is recorded only inside the guarantees record and transport is not declared.","srcs":[["PRS, Karnataka Budget Analysis 2018-19","https://prsindia.org/budgets/states/karnataka-budget-analysis-2018-19"],["PRS, Karnataka Budget Analysis 2023-24","https://prsindia.org/budgets/states/karnataka-budget-analysis-2023-24"],["The South First, 7 Mar 2025: Karnataka's five guarantee schemes continue with Rs 51,034 cr in 2025 budget","https://thesouthfirst.com/karnataka/karnatakas-five-guarantee-schemes-continue-with-%E2%82%B951034-crore-in-2025-budget/"],["Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting","https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"],["Deccan Herald, 26 Mar 2026: Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG","https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"],["Deccan Herald, 26 Aug 2025: CAG report's conclusions on welfare schemes in Karnataka incorrect: H M Revanna","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"],["The News Minute, 20 Feb 2025: Karnataka to provide 10 kg rice instead of cash under Anna Bhagya","https://www.thenewsminute.com/karnataka/karnataka-to-provide-10-kg-rice-instead-of-cash-under-anna-bhagya-scheme"],["Deccan Herald, 19 Feb 2025: Karnataka to provide additional 5 kg rice under Anna Bhagya from February; Rs 10,452 cr DBT Jul 2023–Oct 2024","https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458"],["The Tribune/IANS, 5 Jul 2018: Karnataka waives Rs 34,000 cr farm loans","https://www.tribuneindia.com/news/archive/nation/karnataka-waives-rs-34-000-cr-farm-loans-615599"],["Deccan Herald, 30 May 2018: Kumaraswamy announces two-phase farmer loan waiver","https://www.deccanherald.com/india/karnataka/kumaraswamy-announces-two-phase-farmer-loan-waiver-672438.html"],["Deccan Herald, 7 Jan 2024: Karnataka farmers in quicksand as govt continues to borrow time over loan waiver","https://www.deccanherald.com/india/karnataka/karnataka-farmers-in-quicksand-as-govt-continues-to-borrow-time-over-loan-waiver-2838441"]],"domain":"state-cash-other"},
  {"st":"dl","fromYear":2019,"toYear":2025,"categories":["energy-subsidy"],"method":"The 200-unit free-power subsidy traced from the Aug 2019 announcement (Business Today) through the Mar 2024 cabinet renewal (DH) and the BJP government's Apr 2025 continuation (BS/ANI), with PRS Delhi Budget Analyses 2019-20, 2020-21 and 2023-24 opened for the subsidy head. Energy subsidy only.","srcs":[["Business Today, 1 Aug 2019: Kejriwal announces free electricity up to 200 units","https://www.businesstoday.in/latest/economy-politics/story/arvind-kejriwal-free-electricity-up-to-200-units-delhi-from-august-220915-2019-08-01"],["Deccan Herald, 7 Mar 2024: Delhi cabinet approves power subsidy scheme for FY 2024-25; 22 lakh zero bills","https://www.deccanherald.com/india/delhi/delhi-cabinet-approves-power-subsidy-scheme-for-fy-2024-25-2926614"],["Business Standard/ANI, 15 Apr 2025: Power subsidy for Delhi homes, farmers, lawyers, riot victims to continue (BJP govt)","https://www.business-standard.com/india-news/power-subsidy-for-delhi-homes-farmers-lawyers-riot-victims-to-continue-125041501496_1.html"],["PRS, Delhi Budget Analysis 2019-20","https://prsindia.org/budgets/states/delhi-budget-analysis-2019-20"],["PRS, Delhi Budget Analysis 2020-21","https://prsindia.org/budgets/states/delhi-budget-analysis-2020-21"],["PRS, Delhi Budget Analysis 2023-24","https://prsindia.org/budgets/states/delhi-budget-analysis-2023-24"]],"domain":"state-cash-other"},
  {"st":"pb","fromYear":2017,"toYear":2017,"categories":["loan-waiver"],"method":"The Jun 2017 Amarinder Singh crop-loan waiver announcement (Business Standard, 19 Jun 2017) and the RBI IWG (Sep 2019) state list via PRS. Total liability figure not confirmed in an opened page (see gaps); 2018–2021 Punjab schemes were not swept.","srcs":[["Business Standard, 19 Jun 2017: Punjab CM Amarinder Singh announces crop loan waiver for 10.25 lakh farmers","https://www.business-standard.com/article/economy-policy/punjab-cm-amarinder-singh-announces-crop-loan-waiver-for-10-25-lakh-farmers-117061901226_1.html"],["PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)","https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"]],"domain":"state-cash-other"},
  {"st":"pb","fromYear":2022,"toYear":2024,"categories":["energy-subsidy"],"method":"The 300-unit free domestic power scheme (Jul 2022) read through PRS Punjab Budget Analyses 2022-23 and 2024-25 and the PRS State of State Finances 2025-26 subsidy section. Energy subsidy only.","srcs":[["PRS, Punjab Budget Analysis 2022-23","https://prsindia.org/budgets/states/punjab-budget-analysis-2022-23"],["PRS, Punjab Budget Analysis 2024-25","https://prsindia.org/budgets/states/punjab-budget-analysis-2024-25"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.13-14 and subsidy section (PDF)","https://prsindia.org/files/budget/SOSF_2025.pdf"]],"domain":"state-cash-other"},
  {"st":"up","fromYear":2017,"toYear":2019,"categories":["loan-waiver"],"method":"The Apr 2017 Yogi Adityanath crop-loan waiver (DH/PTI, 4 Apr 2017; 2017 election pointer) followed through PRS Uttar Pradesh Budget Analyses 2017-18, 2018-19 and 2019-20. Beneficiary count (~86 lakh) seen only in search snippets. Kanya Sumangala (student) rests on two sources with the launch detail blocked and is not declared.","srcs":[["Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'","https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"],["Wikipedia (pointer): 2017 Uttar Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2017_Uttar_Pradesh_Legislative_Assembly_election"],["PRS, Uttar Pradesh Budget Analysis 2017-18","https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2017-18"],["PRS, Uttar Pradesh Budget Analysis 2018-19","https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2018-19"],["PRS, Uttar Pradesh Budget Analysis 2019-20","https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2019-20"]],"domain":"state-cash-other"},
  {"st":"mh","fromYear":2017,"toYear":2022,"categories":["loan-waiver"],"method":"Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 and Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 read from the Maharashtra Co-operation Department's official scheme pages, PRS Maharashtra Budget Analyses 2018-19 and 2020-21 and the RBI IWG list. Loan waivers only; no CAG audit opened (see voids).","srcs":[["Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"],["Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"],["PRS, Maharashtra Budget Analysis 2018-19","https://prsindia.org/budgets/states/maharashtra-budget-analysis-2018-19"],["PRS, Maharashtra Budget Analysis 2020-21","https://prsindia.org/budgets/states/maharashtra-budget-analysis-2020-21"],["PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)","https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"]],"domain":"state-cash-other"},
  {"st":"rj","fromYear":2018,"toYear":2022,"categories":["loan-waiver","other"],"method":"Raje's Feb 2018 Rs 50,000 waiver and Gehlot's Dec 2018 waiver (DH, 20 Dec 2018) followed through PRS Rajasthan Budget Analysis 2021-22; Chiranjeevi health cover read from PRS Rajasthan Budget Analysis 2022-23. The Feb 2024 MAAY renaming rests on a secondary insurance-aggregator page and 2023–24 is not declared.","srcs":[["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"],["PRS, Rajasthan Budget Analysis 2021-22","https://prsindia.org/budgets/states/rajasthan-budget-analysis-2021-22"],["PRS, Rajasthan Budget Analysis 2022-23 (budget of 23 Feb 2022): \"annual medical insurance cover of Rs 10 lakh for each family\"","https://prsindia.org/budgets/states/rajasthan-budget-analysis-2022-23"]],"domain":"state-cash-other"},
  {"st":"tn","fromYear":2006,"toYear":2014,"categories":["consumer-goods"],"method":"The 2006 DMK free colour-TV scheme (Oneindia/UNI Sep 2006; IndiaSpend Oct 2011 reconciliation; AIADMK 2011 scrapping) and the 2011 AIADMK mixie-grinder-fan scheme (BS/PTI Feb 2014 distribution count). Consumer goods only; ELCOT/TNCSC tender records not opened (see voids).","srcs":[["Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme","https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"],["IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?","https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"],["Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women","https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"],["Wikipedia (pointer): Colour TV case (1990s, J. Jayalalithaa)","https://en.wikipedia.org/wiki/Colour_TV_case"]],"domain":"state-cash-other"},
  {"st":"tn","fromYear":2021,"toYear":2022,"categories":["transport"],"method":"The May 2021 DMK free-bus scheme for women read from the 2022-23 budget coverage (DH, 18 Mar 2022) and The Federal's Jun 2023 cross-state comparison. Transport only.","srcs":[["Deccan Herald, 18 Mar 2022: Free travel — more women in Tamil Nadu now take government buses (budget 2022-23)","https://www.deccanherald.com/india/free-travel-more-women-in-tamil-nadu-now-take-government-buses-1092556.html"],["The Federal, 12 Jun 2023: Free bus travel for women — Karnataka model vs TN, Delhi, Punjab","https://thefederal.com/states/south/karnataka/karnataka-introduces-free-bus-travel-for-women-a-comparison-with-other-states"]],"domain":"state-cash-other"},
  {"st":"kl","fromYear":2023,"toYear":2026,"categories":["pension"],"method":"Kerala's social-welfare pension arrears cycle traced through DH Apr 2024 and Jul 2024, Onmanorama Jan 2025 (second arrears instalment), PRS Kerala Budget Analysis 2024-25 and the May 2026 election result (DD News). Pensions only; 2016–2022 pension history is not declared.","srcs":[["Deccan Herald, 8 Apr 2024: As polls approach, Kerala Left govt to pay pension dues","https://www.deccanherald.com/elections/kerala/as-polls-approach-kerala-left-govt-to-pay-pension-dues-2969893"],["Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears","https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"],["Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go","https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"],["PRS, Kerala Budget Analysis 2024-25","https://prsindia.org/budgets/states/kerala-budget-analysis-2024-25"],["DD News, 4 May 2026: UDF crosses majority mark in Kerala (ECI trends)","https://ddnews.gov.in/en/assembly-polls-2026-udf-crosses-majority-mark-in-kerala/"]],"domain":"state-cash-other"},
  {"st":"central","fromYear":2019,"toYear":2025,"categories":["energy-subsidy"],"method":"Delivery-stack sweep of PMUY only: CAG Performance Audit No. 14 of 2019 press release (read from a local copy), the Dec 2021 Rajya Sabha reply on refill consumption, and the 8 Aug 2025 Cabinet approval of the 2025-26 targeted subsidy were opened to trace the connection target, the ₹200/₹300 refill subsidy and the 2025 refill cap. No other central energy-subsidy scheme was searched for; 2016–2018 launch-period facts are from the CAG document and general public record (see gaps), so those years are not declared.","srcs":[["CAG press release on Performance Audit Report No. 14 of 2019 on PMUY, 11 Dec 2019 (local copy; exact report URL unresolved — see gaps)","https://cag.gov.in/en"],["PIB, Average LPG refill consumption of PMUY beneficiaries (Rajya Sabha reply), 20 Dec 2021","https://pib.gov.in/PressReleasePage.aspx?PRID=1783430"],["PIB, Cabinet approves continuation of PMUY targeted subsidy for 2025-26 at ₹12,000 crore, 8 Aug 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2154117"]],"domain":"vendors"},
  {"st":"central","fromYear":2023,"toYear":2024,"categories":["grain"],"method":"PMGKAY (free NFSA grain from 1 Jan 2023) traced through PRS's Demand for Grants 2024-25 analysis for Food and Public Distribution (which lists the department's schemes and allocations) and the Apr 2025 PIB DBT assessment. The FCI channel was the object of the search; the pre-2023 COVID phase of PMGKAY and other grain schemes were not swept, so 2020–2022 are not declared.","srcs":[["PRS Legislative Research, 'Demand for Grants 2024-25 Analysis: Food and Public Distribution'","https://prsindia.org/budgets/parliament/demand-for-grants-2024-25-analysis-food-and-public-distribution"],["PIB (Ministry of Finance), 'India's DBT: Boosting Welfare Efficiency' — BlueKraft assessment, 21 Apr 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2123192"]],"domain":"vendors"},
  {"st":"ka","fromYear":2023,"toYear":2026,"categories":["transport"],"method":"Shakti (free bus travel for women) traced from its 11 Jun 2023 launch through the Dec 2024 and Jun 2026 reimbursement-arrears reports and BMTC's Sep 2024 diesel-bus induction; 2023 assembly election result checked. Only the free-transport category was searched, as the vehicle for the bus-OEM award question; no other Karnataka scheme category was swept.","srcs":[["Deccan Herald, 'Rs 1,800 cr Shakti scheme reimbursement pending; transport corporations in red', Dec 2024","https://www.deccanherald.com/india/karnataka/rs1-800-cr-shakti-scheme-reimbursement-pending-transport-corpns-in-red-3320295"],["ETV Bharat, 'Shakti scheme effect: male passengers drop; ₹5,172 crore reimbursement pending', 20 Jun 2026","https://www.etvbharat.com/en/bharat/shakti-scheme-effect-number-of-male-passengers-travelling-in-karnataka-govt-run-buses-drops-significantly-in-karnataka-enn26062003798"],["Deccan Herald, 'BMTC launches 100 new diesel buses, to get 820 of them by March', 12 Sep 2024","https://www.deccanherald.com/india/karnataka/bengaluru/bmtc-launches-100-new-diesel-buses-to-get-820-of-them-by-march-3188420"],["Wikipedia (pointer), 2023 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"]],"domain":"vendors"},
  {"st":"dl","fromYear":2022,"toYear":2023,"categories":["transport"],"method":"Delhi's DTC/cluster electric-bus induction (the carrier of the women's free 'pink ticket') traced through the 23 Dec 2022 Tata Motors GCC agreement and the 22 Sep 2023 Switch/JBM/PMI contracts. The pink-ticket scheme itself (launch Oct 2019, fare economics) was not verified from an opened source (see gaps), so 2019–2021 and 2024–2025 are not declared; the 2025 election page was opened for the result only.","srcs":[["Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022","https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"],["EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023","https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"]],"domain":"vendors"},
  {"st":"pb","fromYear":2020,"toYear":2022,"categories":["consumer-goods"],"method":"Punjab Smart Connect (free smartphones to Class XII students) traced from the 12 Aug 2020 launch report to the Feb 2022 assembly election, whose result was checked against the scheme's timing. Handset vendor (Lava) identified only from a search snippet and not opened (see gaps). Only the consumer-goods category was searched in Punjab.","srcs":[["The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020","https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"],["Wikipedia (pointer), 2022 Punjab Legislative Assembly election","https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"]],"domain":"vendors"},
  {"st":"rj","fromYear":2023,"toYear":2023,"categories":["consumer-goods"],"method":"Indira Gandhi Smartphone Yojana traced from its 10 Aug 2023 phase-1 launch to the 25 Nov 2023 assembly election and the change of government; the post-election pause is inferred from the government change and a search snippet, not an opened source (see gaps), so 2024 onward is not declared. Only the consumer-goods category was searched in Rajasthan.","srcs":[["ThePrint (Hindi), 'Indira Gandhi Smartphone Yojana begins in Rajasthan; 40 lakh women in phase 1', 11 Aug 2023","https://hindi.theprint.in/report/indira-gandhi-smartphone-yojana-started-in-rajasthan-40-lakh-women-will-get-smartphones-in-the-first-phase/582752/"],["Wikipedia (pointer), 2023 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"]],"domain":"vendors"},
  {"st":"tn","fromYear":2021,"toYear":2025,"categories":["consumer-goods"],"method":"Tamil Nadu free laptop scheme: the AIADMK-era distribution (51 lakh laptops claimed), its 2021 halt and the DMK's Mar 2025 laptop/tablet revival (₹2,000 crore, 2025-26) read from the Mar 2025 Careers360 report; the 2021 assembly election result checked. Cumulative-cost and 2025 ELCOT tender-winner figures were snippet-only and are excluded (see gaps). Only the consumer-goods category was searched in Tamil Nadu; Amma Unavagam (category 'other') is recorded from a single 2020 report and is not declared as coverage.","srcs":[["Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025","https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"],["Wikipedia (pointer), 2021 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2021_Tamil_Nadu_Legislative_Assembly_election"]],"domain":"vendors"},
  {"st":"mp","fromYear":2023,"toYear":2026,"categories":["women-cash"],"method":"Ladli Behna traced from Feb 2023 cabinet approval through the Nov 2025 hike; WCD MP portal opened 25 Sep 2026; Lokniti-CSDS 2023 post-poll and 2023 election result checked; INC's Mar 2023 Nari Samman promise recorded as promise-only; PRS MP Budget Analysis 2025-26 and PRS SOSF 2025-26 Annexure Table 6 opened. Only women's UCTs were swept — no other category.","srcs":[["Deccan Herald/PTI, 25 Feb 2023: MP cabinet clears Ladli Bahna Rs 1,000","https://www.deccanherald.com/india/mp-govt-clears-scheme-to-give-rs-1000-to-women-above-23-under-ladli-bahna-yojana-1195069.html"],["Deccan Herald, 5 Mar 2023: Kamal Nath promises women Rs 18,000/yr ahead of Ladli Behna launch","https://www.deccanherald.com/national/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"],["Deccan Herald, 3 Dec 2023: What worked for BJP in MP","https://www.deccanherald.com/india/madhya-pradesh/focus-on-women-voters-to-pm-modis-magic-what-worked-for-bjp-in-madhya-pradesh-assembly-elections-2794883"],["Lokniti-CSDS, Madhya Pradesh Post-poll Survey 2023 — survey findings (PDF)","https://www.lokniti.org/media/PDF-upload/1703684877_6052900_download_report.pdf"],["Deccan Herald, 17 Jun 2025: Ladli Behna Rs 250 Raksha Bandhan shagun; 25th instalment Rs 1,551 cr to 1.27 cr women","https://www.deccanherald.com/india/madhya-pradesh/ladli-behna-beneficiaries-to-get-rs-250-as-raksha-bandhan-shagun-mp-cm-3589260"],["India TV, 12 Oct 2025: Mohan Yadav transfers Rs 1,541 cr (29th instalment), announces Rs 1,500","https://www.indiatvnews.com/madhya-pradesh/madhya-pradesh-ladli-behna-scheme-yojana-cm-mohan-yadav-transfers-rs-1541-crore-announces-hike-to-rs-1500-2025-10-12-1012478"],["IANS via Prokerala, 10 Nov 2025: MP cabinet approves Rs 1,500 from Nov 12; Rs 3,000 by 2028 plan","https://www.prokerala.com/news/articles/a1695417.html"],["Mukhyamantri Ladli Bahna Yojana portal, WCD Madhya Pradesh (accessed 25 Sep 2026)","https://cmladlibahna.mp.gov.in/home.aspx"],["PRS Madhya Pradesh Budget Analysis 2025-26 (opened; no scheme-level figure on page)","https://prsindia.org/budgets/states/madhya-pradesh-budget-analysis-2025-26"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Wikipedia infobox (pointer to ECI results): 2023 Madhya Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"]],"domain":"women-cash"},
  {"st":"mh","fromYear":2024,"toYear":2026,"categories":["women-cash"],"method":"Ladki Bahin traced from the Jun 2024 budget announcement and Aug 2024 first payments through the 2025 cuts/scrutiny and the Jul 2026 removal of 92 lakh beneficiaries; Nov 2024 election result and Lokniti-CSDS post-poll (via BehanBox) checked; PRS MH Budget Analysis 2025-26 and PRS SOSF 2025-26 opened. GR/cabinet date not obtained (see gaps).","srcs":[["Deccan Herald, 15 Aug 2024: Shinde govt begins releasing Ladki Bahin money","https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"],["Deccan Herald, 5 Aug 2024: Bombay HC dismisses PIL against Ladki Bahin","https://www.deccanherald.com/india/maharashtra/ladki-bahin-yojana-a-beneficiary-scheme-for-women-not-discriminatory-bombay-high-court-3137089"],["Deccan Herald, 14 Sep 2024: Shinde — bigger mandate, will raise Ladki Bahin to Rs 3,000","https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-give-us-a-bigger-mandate-will-double-ladki-bahin-dole-to-rs-3000-eknath-shinde-3191037"],["Deccan Herald, 6 Nov 2024: NCP manifesto promises Ladki Bahin Rs 2,100","https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ajit-pawars-ncp-releases-constituency-wise-manifesto-promises-increase-in-ladki-bahin-yojana-amount-3264259"],["BehanBox, 4 Dec 2024: Maharashtra poll analyses and women's agency (cites Lokniti-CSDS post-poll)","https://behanbox.com/2024/12/04/how-maharashtra-poll-analyses-are-missing-the-rise-of-womens-agency/"],["Deccan Herald, 9 Feb 2025: Ladki Bahin beneficiaries drop by 5 lakh; no recovery","https://www.deccanherald.com/india/maharashtra/ladki-bahin-beneficiaries-drop-by-5-lakh-no-taking-back-money-from-those-ineligible-says-minister-3397268"],["Deccan Herald, 10 Mar 2025: Maharashtra budget gives Rs 36,000 cr to Ladki Bahin, silent on Rs 2,100","https://www.deccanherald.com/india/maharashtra/maharashtra-govt-gives-rs-36000-crore-to-ladki-bahin-in-budget-mum-on-stipend-hike-ups-vehicle-tax-3440102"],["Scroll, 16 Apr 2025: Maharashtra cuts Ladki Bahin payout for 8 lakh women to Rs 500","https://scroll.in/latest/1081399/maharashtra-cuts-ladki-bahin-yojana-payout-for-8-lakh-women-to-rs-500-per-month-report"],["Deccan Herald, 16 Apr 2025: Aaditya Thackeray says Ladki Bahin 'more or less ended'; Tatkare response","https://www.deccanherald.com/india/maharashtra/ladki-bahin-scheme-more-or-less-finished-claims-aaditya-thackeray-3496353"],["Deccan Herald, 29 Jul 2025: Supriya Sule alleges Rs 4,800 cr fraud, seeks SIT","https://www.deccanherald.com/india/maharashtra/supriya-sule-alleges-rs-4800-crore-fraud-in-ladki-bahin-yojana-seeks-sit-probe-3654533"],["Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification","https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"],["PRS Maharashtra Budget Analysis 2025-26 (opened; no scheme-level figure on page)","https://prsindia.org/budgets/states/maharashtra-budget-analysis-2025-26"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Wikipedia infobox (pointer to ECI results): 2024 Maharashtra Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Maharashtra_Legislative_Assembly_election"]],"domain":"women-cash"},
  {"st":"ka","fromYear":2023,"toYear":2025,"categories":["women-cash"],"method":"Gruha Lakshmi swept via May 2023 election result, Deccan Herald Aug–Sep 2025 reports on CAG findings and beneficiary removals, PRS KA Budget Analysis 2025-26 and PRS SOSF 2025-26. Karnataka guarantee portal returned 503; launch and cabinet dates unverified (see gaps). 2026 not searched.","srcs":[["Wikipedia infobox (pointer to ECI results): 2023 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"],["Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed","https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"],["Deccan Herald, 26 Aug 2025: H M Revanna rejects CAG conclusions on Karnataka guarantee schemes","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"],["PRS Karnataka Budget Analysis 2025-26 (opened; no scheme-level figure on page)","https://prsindia.org/budgets/states/karnataka-budget-analysis-2025-26"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]],"domain":"women-cash"},
  {"st":"tn","fromYear":2023,"toYear":2026,"categories":["women-cash"],"method":"Kalaignar Magalir Urimai Thogai traced from the Sep 2023 launch and Nov 2023 expansion through the Apr 2026 election; PRS TN Budget Analysis 2025-26 and PRS SOSF 2025-26 opened. kmut.tn.gov.in returned 503; status under the TVK government not verified (see gaps). 2021–22 (manifesto period, no scheme) not declared.","srcs":[["Deccan Herald, 15 Sep 2023: Stalin launches Rs 1,000 monthly scheme for 1.06 cr women","https://www.deccanherald.com/india/tamil-nadu/stalin-launches-rs-1000-monthly-assistance-scheme-for-women-heads-of-families-2687619"],["Deccan Herald, 10 Nov 2023: TN adds 7.35 lakh beneficiaries; 1.13 cr total","https://www.deccanherald.com/india/tamil-nadu/tamil-nadu-expands-monthly-assistance-scheme-to-women-adds-7-lakh-beneficiaries-2766189"],["PRS Tamil Nadu Budget Analysis 2025-26 (opened; no scheme-level figure on page)","https://prsindia.org/budgets/states/tamil-nadu-budget-analysis-2025-26"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Wikipedia (pointer): 2026 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"],["The Logical Indian, 4 May 2026: fiscal reality behind 2026 cash promises to women","https://thelogicalindian.com/elections-results-2026-the-fiscal-reality-behind-indias-cash-promises-to-women/"]],"domain":"women-cash"},
  {"st":"wb","fromYear":2021,"toYear":2026,"categories":["women-cash"],"method":"Lakshmir Bhandar traced from the 2021 launch (district portal page; 2021 election result) through the Apr 2024 and Feb 2026 hikes and the May 2026 election; PRS WB Budget Analysis 2025-26 and PRS SOSF 2025-26 opened. socialsecurity.wb.gov.in returned 503; launch/first-payment date and beneficiary count unverified (see gaps).","srcs":[["South 24 Parganas district portal: Lakshmir Bhandar scheme page","https://s24pgs.gov.in/lakshmir-bhandar/"],["Wikipedia infobox (pointer to ECI results): 2021 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2021_West_Bengal_Legislative_Assembly_election"],["Deccan Herald, 6 Jun 2024: Mamata cashes in on Lakshmir Bhandar in LS 2024","https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mamata-banerjee-cashes-in-on-lakshmir-bhandar-and-modis-shift-to-hindutva-in-west-bengal-3055262"],["ANI, 6 Feb 2026: West Bengal announces Rs 500 Lakshmir Bhandar hike in interim budget 2026-27","https://www.aninews.in/news/national/politics/west-bengal-govt-announces-rs-500-hike-for-lakshmir-bhandar-beneficaries-ahead-of-assembly-polls20260206060332/"],["PRS West Bengal Budget Analysis 2025-26 (opened; no scheme-level figure on page)","https://prsindia.org/budgets/states/west-bengal-budget-analysis-2025-26"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Wikipedia (pointer): 2026 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2026_West_Bengal_Legislative_Assembly_election"],["India TV, 4–5 May 2026: West Bengal 2026 result — BJP wins","https://www.indiatvnews.com/west-bengal/news-west-bengal-assembly-election-2026-full-list-of-winners-leading-candidates-294-seats-2026-05-04-1038758"],["The Logical Indian, 4 May 2026: fiscal reality behind 2026 cash promises to women","https://thelogicalindian.com/elections-results-2026-the-fiscal-reality-behind-indias-cash-promises-to-women/"]],"domain":"women-cash"},
  {"st":"or","fromYear":2024,"toYear":2025,"categories":["women-cash"],"method":"Subhadra swept from the May 2024 BJP voucher promise and Jun 2024 election through the Sep 2024 PM launch and Mar 2025 instalment; PIB release, Deccan Herald/PTI, Wikipedia pointer, PRS OR Budget Analysis 2025-26 and PRS SOSF 2025-26 opened. Subhadra guidelines PDF not retrievable (see gaps). 2026 not searched.","srcs":[["Business Standard, 16 May 2024: BJP 'promises' Rs 50,000 vouchers to women, then clarifies Odisha-only","https://www.business-standard.com/elections/assembly-election/lok-sabha-elections-bjp-promises-rs-50-000-cash-vouchers-to-women-then-clarifies-124051600178_1.html"],["Wikipedia infobox (pointer to ECI results): 2024 Odisha Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Odisha_Legislative_Assembly_election"],["PIB, 17 Sep 2024: PM launches SUBHADRA in Bhubaneswar","https://www.pib.gov.in/PressReleseDetailm.aspx?PRID=2055572&reg=3&lang=2"],["Deccan Herald/PTI, 17 Sep 2024: PM launches Subhadra; Rs 10,000/yr; 76 lakh registered; Rs 1,250 cr to 25 lakh","https://www.deccanherald.com/india/odisha/pm-modi-launches-odisha-govts-subhadra-scheme-railway-nh-projects-worth-over-rs-3800-cr-3193991"],["Wikipedia (pointer): Subhadra Yojana","https://en.wikipedia.org/wiki/Subhadra_Yojana"],["PRS Odisha Budget Analysis 2025-26 (opened; no scheme-level figure on page)","https://prsindia.org/budgets/states/odisha-budget-analysis-2025-26"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]],"domain":"women-cash"},
  {"st":"jh","fromYear":2024,"toYear":2025,"categories":["women-cash"],"method":"Maiya Samman swept from the Aug 2024 launch through the Oct 2024 hike to Rs 2,500 and the Nov 2024 election; IMPRI policy note and PRS SOSF 2025-26 opened. No Jharkhand government source opened; 2026 status rests on an undated IMPRI note and is not declared.","srcs":[["IMPRI policy update: Mukhyamantri Maiya Samman Yojana in practice","https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"],["Deccan Herald/PTI, 14 Oct 2024: Jharkhand cabinet raises Maiya Samman to Rs 2,500 from Dec 2024","https://www.deccanherald.com/india/jharkhand/jharkhand-cabinet-nod-to-hike-financial-assistance-for-women-to-rs-30000-per-year-from-rs-12000-3231863"],["Wikipedia infobox (pointer to ECI results): 2024 Jharkhand Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Jharkhand_Legislative_Assembly_election"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]],"domain":"women-cash"},
  {"st":"ct","fromYear":2023,"toYear":2025,"categories":["women-cash"],"method":"Mahtari Vandan swept from the Nov 2023 election promise through the Mar 2024 PM launch (PIB); PRS CT Budget Analysis 2025-26 and PRS SOSF 2025-26 opened. The 2 Feb 2024 order not retrievable; beneficiary count not updated after 2024 (see gaps).","srcs":[["Wikipedia infobox (pointer to ECI results): 2023 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"],["PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr","https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"],["PRS Chhattisgarh Budget Analysis 2025-26 (opened; no scheme-level figure on page)","https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2025-26"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]],"domain":"women-cash"},
  {"st":"as","fromYear":2021,"toYear":2026,"categories":["women-cash"],"method":"Orunodoi swept from the Apr 2021 election through the Sep 2024 Orunodoi 3.0 relaunch (ANI) and the Apr 2026 election; PRS AS Budget Analysis 2025-26 and PRS SOSF 2025-26 opened. assam.gov.in returned 503, so the 2020 launch and the Rs 1,000 step are unverified and 2020 is not declared.","srcs":[["Wikipedia infobox (pointer to ECI results): 2021 Assam Legislative Assembly election","https://en.wikipedia.org/wiki/2021_Assam_Legislative_Assembly_election"],["ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month","https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"],["PRS Assam Budget Analysis 2025-26 (opened; no scheme-level figure on page)","https://prsindia.org/budgets/states/assam-budget-analysis-2025-26"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["India TV, 4 May 2026: Assam 2026 result — BJP 82 seats","https://www.indiatvnews.com/north-east/assam/assam-election-result-2026-live-updates-himanta-biswa-sarma-led-bjp-wins-setback-for-congress-1039454"],["The Logical Indian, 4 May 2026: fiscal reality behind 2026 cash promises to women","https://thelogicalindian.com/elections-results-2026-the-fiscal-reality-behind-indias-cash-promises-to-women/"]],"domain":"women-cash"},
  {"st":"hp","fromYear":2024,"toYear":2026,"categories":["women-cash"],"method":"Indira Gandhi Pyari Behna Sukh Samman Nidhi swept via PRS SOSF 2025-26 (fn.16) and the Sep 2026 HP assembly reply on disbursals (ETV Bharat). HP PR release of 29 Jun 2024 returned empty; 2022 election page not retrievable (see gaps). Two sources only — thin.","srcs":[["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals","https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"]],"domain":"women-cash"},
  {"st":"dl","fromYear":2024,"toYear":2026,"categories":["women-cash"],"method":"Delhi swept for AAP's Dec 2024 Mahila Samman promise, the Feb 2025 election result, the Mar 2025 cabinet approval of Mahila Samriddhi and the Jul 2026 launch announcement; PRS SOSF 2025-26 opened. Whether the Aug/Sep 2026 launch occurred rests on low-credibility sites (see gaps).","srcs":[["Deccan Herald, 12 Dec 2024: Kejriwal announces Rs 1,000 (Rs 2,100 after polls) for Delhi women","https://www.deccanherald.com/elections/delhi/delhi-assembly-elections-2025-ahead-of-polls-cabinet-approves-proposal-of-giving-rs-1000-to-women-every-months-3314631"],["Wikipedia infobox (pointer to ECI results): 2025 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"],["Deccan Herald, 8 Mar 2025: Delhi cabinet clears Rs 2,500 Mahila Samriddhi; Rs 5,100 cr","https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"],["ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs","https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"],["India TV, 8 Jul 2026: Delhi to launch Mahila Samriddhi on Raksha Bandhan; Rs 5,110 cr 2026-27","https://www.indiatvnews.com/delhi/delhi-govt-to-launch-mahila-samriddhi-yojana-on-raksha-bandhan-check-who-can-get-rs-2500-monthly-and-required-documents-2026-07-08-1047512"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]],"domain":"women-cash"},
  {"st":"tg","fromYear":2023,"toYear":2025,"categories":["women-cash"],"method":"Telangana swept for the INC Nov 2023 Mahalakshmi Rs 2,500 guarantee: election result and The South First Jan 2025 fact-check (no cash component paid; bus/LPG components implemented) opened. Jun 2026 protests known only from an unopened snippet, so 2026 is not declared.","srcs":[["Wikipedia infobox (pointer to ECI results): 2023 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"],["The South First, 8 Jan 2025: fact check — Rs 2,500 Mahalakshmi not paid","https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"]],"domain":"women-cash"},
  {"st":"br","fromYear":2025,"toYear":2025,"categories":["women-cash"],"method":"Bihar swept for the Sep 2025 Mukhyamantri Mahila Rojgar Yojana (PIB launch release), the Oct 2025 ECI schedule and the Nov 2025 result; PRS SOSF 2025-26 opened. Earlier years not searched; later expansion beyond 75 lakh unverified (see gaps).","srcs":[["PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"],["PIB/ECI, 6 Oct 2025: General Election to the Legislative Assembly of Bihar, 2025 (schedule release)","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2175533"],["Deccan Herald, 15 Nov 2025: Bihar results — NDA 202 seats","https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-results-nda-cruises-to-victory-by-winning-202-seats-and-a-vote-share-of-over-40-3798063"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]],"domain":"women-cash"},
  {"st":"hr","fromYear":2024,"toYear":2025,"categories":["women-cash"],"method":"Haryana swept from the Sep 2024 Lado Lakshmi promise and Oct 2024 election through the Aug 2025 cabinet decision and the 15 Sep 2025 Gazette notification; PRS SOSF 2025-26 opened. 2026 not searched.","srcs":[["Wikipedia infobox (pointer to ECI results): 2024 Haryana Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Haryana_Legislative_Assembly_election"],["Deccan Herald/PTI, 28 Aug 2025: Haryana cabinet decides to roll out Lado Lakshmi from Sep 25","https://www.deccanherald.com/india/haryana/haryana-decides-to-implement-lado-lakshmi-yojana-eligible-women-to-get-rs-2100-monthly-aid-3700884"],["Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification","https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]],"domain":"women-cash"},
  {"st":"pb","fromYear":2022,"toYear":2025,"categories":["women-cash"],"method":"Punjab swept for AAP's Rs 1,000 women's promise: Feb 2022 election result and ThePrint's Jan 2025 report that no scheme had been paid in three years; PRS SOSF 2025-26 (which lists no Punjab women's UCT) opened. No Punjab government source opened.","srcs":[["Wikipedia infobox (pointer to ECI results): 2022 Punjab Legislative Assembly election","https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"],["ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs","https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]],"domain":"women-cash"},
];

export const WELFARE_VOIDS: Void[] = [
  { what: "No year-wise DBT transfer series could be extracted: the DBT Bharat portal renders totals by JavaScript; the only machine-readable totals are PIB's (₹20.23 lakh cr via PFMS since 2014; ₹6.9 lakh cr FY 2024-25)", whyItMatters: "the ₹3.48 lakh cr savings claim cannot be benchmarked against the flow it claims to have protected", srcs: [["DBT Bharat portal (opened; totals rendered by JavaScript, not extractable)","https://dbtbharat.gov.in/"],["PIB, Ministry of Finance Year Ender 2024: Department of Expenditure (DBT via PFMS), 27 Dec 2024","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2088438"],["PIB (MoF), PMJDY completes 11 years, 28 Aug 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2161401"]], domain: "central" },
  { what: "The 2024 interim budget contained no new cash transfer and no PM-KISAN raise — the one general election in the file with no pre-poll cash announcement, and the one where the incumbent lost 63 seats", whyItMatters: "a null case for the 'pre-poll cash wins' hypothesis; the direction is consistent with the hypothesis but the case count is one", srcs: [["Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)","https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"],["Wikipedia (pointer), 2024 Indian general election","https://en.wikipedia.org/wiki/2024_Indian_general_election"]], domain: "central" },
  { what: "No CAG performance audit of PM-KISAN (₹4.47 lakh cr) was found in this sweep; exclusion/inclusion evidence rests on the government's own ₹416.75 cr recovery figure and a private foundation's 2.1 crore deletion count", whyItMatters: "the largest cash transfer in the file has no independent audit trail comparable to PMUY (2019) or ADWDRS (2013)", srcs: [["Lok Sabha Unstarred Q.358 (MoS Agri Ramnath Thakur), discrepancy in PM-KISAN: ₹416.75 cr recovered from ineligible beneficiaries, 2 Dec 2025","https://sansad.in/getFile/loksabhaquestions/annex/186/AU358_FPeZsZ.pdf?source=pqals"],["PIB, 'India's DBT: Boosting Welfare Efficiency' (BlueKraft report relayed), 21 Apr 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2123192"]], domain: "central" },
  { what: "The IGNOAPS central pension of ₹200/month has not been raised in any of the six budget speeches opened here (2008–2026)", whyItMatters: "the oldest, poorest beneficiary class received no pre-election attention from any government while scheme-branded transfers multiplied", srcs: [["PIB Backgrounder, National Social Assistance Programme, 7 Nov 2025","https://www.pib.gov.in/PressNoteDetails.aspx?NoteId=155928&ModuleId=3"],["Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)","https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"],["Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)","https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"],["Interim Budget 2024-25 speech, Nirmala Sitharaman, 1 Feb 2024 (paras 14, 42-43, 56)","https://www.indiabudget.gov.in/budget2024-25(I)/doc/Budget_Speech.pdf"],["Union Budget 2026-27 speech, Nirmala Sitharaman, 1 Feb 2026","https://www.indiabudget.gov.in/doc/Budget_Speech.pdf"]], domain: "central" },
  { what: "No named Lead Fertilizer Company or drone manufacturer appears in the Drone Didi releases; no vendor names appear for PM-KISAN's CSC/IPPB channel or Vishwakarma toolkit vouchers", whyItMatters: "the 'who else benefits' question for ₹1,261 cr of drones and ~₹3,450 cr of toolkit vouchers cannot be answered from primary releases", srcs: [["PIB, Cabinet approves Central Sector Scheme for providing drones to women SHGs (₹1,261 crore), 29 Nov 2023","https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=1980683"],["PIB (MoA&FW reply), Implementation of Namo Drone Didi scheme, 29 Jul 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2149706"],["PIB Research Unit backgrounder 'PM Vishwakarma Scheme: Honouring Heritage, Powering Progress', 16 Sep 2025 (PDF on file; exact document URL not recovered — see gaps)","https://www.pib.gov.in/"]], domain: "central" },
  { what: "No independent, pre-registered causal evaluation (RCT, regression discontinuity, or similar) isolating any single scheme's electoral effect from turnout, campaign spending, media coverage and opposition quality exists in this file's source set.", whyItMatters: "Every timing-outcome pairing in this file is a correlation over a small, non-random sample of high-profile schemes; without a causal design, both the 'cash buys votes' and the 'cash is just welfare, unrelated to the result' readings remain compatible with the same numbers.", srcs: [], domain: "elections-timing" },
  { what: "Booth-level or constituency-level beneficiary-density data linked to vote-share change is absent for every scheme in this file except the one Lokniti-CSDS finding cited for Maharashtra's Ladki Bahin.", whyItMatters: "Aggregate state-level win/loss outcomes cannot show whether beneficiaries voted differently from non-beneficiaries; the one case where such survey data exists (Maharashtra) shows a real but modest (11-point) gap, not a landslide-explaining one — the absence of equivalent data for the other 27 schemes is itself informative about how thin the public evidence base for this entire genre of claim actually is.", srcs: [["BehanBox — Maharashtra poll analyses miss women's agency","https://behanbox.com/2024/12/04/how-maharashtra-poll-analyses-are-missing-the-rise-of-womens-agency/"]], domain: "elections-timing" },
  { what: "No independent leakage, targeting-error or ghost-beneficiary audit (CAG, NSSO, or credible academic) was found in this file's source set for any of the post-2014 schemes except the CAG's 2013 audit of the 2008 UPA loan waiver.", whyItMatters: "The 2008 loan waiver is the one scheme in this file with a documented implementation-quality finding; its presence for one scheme and absence for the other 27 is a gap in oversight coverage, not evidence that the others are clean — a large, systematically documented void.", srcs: [["Deccan Herald — CAG finds flaws in debt waiver implementation","https://www.deccanherald.com/india/cag-finds-flaws-implementation-debt-2235970"]], domain: "elections-timing" },
  { what: "This file's elections array covers 16 major states plus the Lok Sabha; it does not cover Kerala, Puducherry, the smaller northeastern states beyond Assam, Uttar Pradesh, Gujarat, Goa, or the Union Territories, several of which had their own election cycles and welfare schemes in this period (e.g. Kerala 2021/2026, UP 2022, Gujarat 2022).", whyItMatters: "The base rates in this file are drawn from a 16-state, 28-scheme sample chosen for scheme prominence and party-symmetry coverage, not from an exhaustive national census; a fuller dataset could shift the base rates, particularly the party-level ones where n is already small (e.g. AAP n=2, BRS n=1, BJD n=1).", srcs: [], domain: "elections-timing" },
  { what: "No rigorous (RCT or quasi-experimental) evaluation of the post-2023 women's UCTs — Ladli Behna, Ladki Bahin, Gruha Lakshmi, Lakshmir Bhandar, Maiyan Samman, Subhadra — was located; RBI's 2025-26 report itself calls for impact assessment.", whyItMatters: "₹1.68 lakh cr a year is being spent with no causal evidence on consumption, health or agency; both 'welfare' and 'bribe' readings are currently untestable on outcomes.", srcs: [["RBI, State Finances: A Study of Budgets of 2025-26 (23 Jan 2026), Chapter IV 'The Way Forward', paras 4.1, 4.5, 4.8","https://www.rbi.org.in/Scripts/PublicationsView.aspx?id=23694"],["Ideas for India site search 'Lakshmir Bhandar' (opened 25 Sep 2026; returned no evaluation)","https://www.ideasforindia.in/search?q=Lakshmir+Bhandar"]], domain: "fiscal-results" },
  { what: "No state budget code or common reporting format for DBT spending (RBI para 4.8).", whyItMatters: "Share-of-budget base rates before 2025 must be reconstructed scheme by scheme; cross-state comparisons are fragile.", srcs: [["RBI, State Finances: A Study of Budgets of 2025-26 (23 Jan 2026), Chapter IV 'The Way Forward', paras 4.1, 4.5, 4.8","https://www.rbi.org.in/Scripts/PublicationsView.aspx?id=23694"]], domain: "fiscal-results" },
  { what: "The Supreme Court freebies reference (W.P.(C) 43/2022) has produced no three-judge-bench judgment; the expert body floated on 3 Aug 2022 was never constituted; SCO's last update is 21 Aug 2024.", whyItMatters: "The only binding precedent remains S. Subramaniam Balaji (2013): manifesto promises are not a corrupt practice.", srcs: [["Supreme Court of India, order dated 26 Aug 2022 in W.P.(C) 43/2022 (N.V. Ramana CJI, Hima Kohli, C.T. Ravikumar JJ) — reference to three-judge bench (copy hosted by SCO)","https://www.scobserver.in/wp-content/uploads/2022/08/Freebies-Order-August-26th.pdf"],["Supreme Court Observer, case page 'Freebies in Electoral Democracy and Welfare State' — Ashwini Kumar Upadhyay v Union of India, W.P.(C) 43/2022 (status Pending; last updated 21 Aug 2024)","https://www.scobserver.in/cases/freebies/"],["Supreme Court Observer, tag page 'freebies' (opened 25 Sep 2026; no hearing after 21 Aug 2024 listed)","https://www.scobserver.in/tag/freebies/"]], domain: "fiscal-results" },
  { what: "Several states do not disclose off-budget borrowings in budget documents (PRS).", whyItMatters: "The Maharashtra and Telangana co-timing claims cannot be tested for end-use.", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"]], domain: "fiscal-results" },
  { what: "No experimental or quasi-experimental estimate of any Indian cash scheme's effect on votes exists in the literature opened (0 of 8 schemes here).", whyItMatters: "Every ‘vote-buying’ claim in the domain rests on post-poll associations and commentary; the strongest tools in the field (Zucco, Manacorda, Imai) have not been applied in India.", srcs: [["Deshpande, Tillin & Kailash (2019) The BJP’s Welfare Schemes: Did They Make a Difference in the 2019 Elections? — Studies in Indian Politics 7(2):219–233 (Crossref metadata + abstract)","https://api.crossref.org/works/10.1177/2321023019874911"],["Lokniti-CSDS — Madhya Pradesh Postpoll Survey 2023: Survey Findings (N=3,050, 18–24 Nov 2023; PDF held locally; Lokniti state-election index page opened)","https://www.lokniti.org/state-assembly-elections"],["Imai, King & Velasco Rivera (2020) Do Nonpartisan Programmatic Policies Have Partisan Electoral Effects? Evidence from Two Large-Scale Experiments — Journal of Politics 82(2):714–730 (Crossref metadata)","https://api.crossref.org/works/10.1086/707059"]], domain: "literature" },
  { what: "The public Lokniti-CSDS MP 2023 findings PDF as read has no gender × vote or beneficiary × vote table.", whyItMatters: "The single most-cited fact about Ladli Behna (‘women swung to the BJP’) cannot be checked against the survey's own cross-tabs from the document held.", srcs: [["Lokniti-CSDS — Madhya Pradesh Postpoll Survey 2023: Survey Findings (N=3,050, 18–24 Nov 2023; PDF held locally; Lokniti state-election index page opened)","https://www.lokniti.org/state-assembly-elections"],["The Hindu — Lokniti-CSDS MP 2023 post-poll analysis — thehindu.com unreachable from this container","https://www.thehindu.com/elections/madhya-pradesh-assembly/"]], domain: "literature" },
  { what: "No primary record of the West Bengal MGNREGA stoppage (MoRD s.27 order; Calcutta HC orders) was opened.", whyItMatters: "Narrative 9 stays speculative on the record even though the stoppage is widely reported.", srcs: [["PIB, Ministry of Rural Development — Budget allocation under MGNREGA, Rajya Sabha written reply by MoS Kamlesh Paswan, 2025-07-25 (Release ID 2148475)","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"],["LiveLaw search ‘MGNREGA West Bengal’ — no results rendered","https://www.livelaw.in/search?q=MGNREGA+West+Bengal"]], domain: "literature" },
  { what: "No independent outcome evaluation (consumption, labour, autonomy) of Ladli Behna or Ladki Bahin was located.", whyItMatters: "The ‘empowerment’ claim and the ‘bribe’ claim are both unmeasured; PRS analyses the fiscal side only.", srcs: [["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"],["Lokniti-CSDS Maharashtra 2024 post-poll analysis, The Hindu, 25 Nov 2024 (Deshpande, ‘Women sided with Mahayuti for Ladki Bahin Yojana’s monthly dole’; Mishra, women as deciders) — page PDF held locally; thehindu.com unreachable from this container","https://www.lokniti.org/state-assembly-elections"]], domain: "literature" },
  { what: "The RBI June 2022 bulletin article ‘State Finances: A Risk Analysis’ and the 2024-25 State Finances PDF were not opened (id not found; CAPTCHA).", whyItMatters: "The fiscal ‘freebies’ definition most quoted in the debate is cited here only through PRS.", srcs: [["RBI Bulletin index (June 2022 ‘State Finances: A Risk Analysis’ article not located by id)","https://www.rbi.org.in/Scripts/BS_ViewBulletin.aspx?Id=21086"],["RBI — State Finances: A Study of Budgets 2024-25 (Dec 2024) — PDF behind a CAPTCHA in this container; quoted via PRS","https://rbidocs.rbi.org.in/rdocs/Publications/PDFs/0STATEFINANCE2024AE6FF65F475C4934B53CC8ABE7FAB30E.PDF"],["RBI — State Finances: A Study of Budgets (publication index; 2025-26 edition released 2026-01-23; archive 2002–2024)","https://www.rbi.org.in/Scripts/AnnualPublications.aspx?head=State%20Finances%20:%20A%20Study%20of%20Budgets"]], domain: "literature" },
  { what: "The attribution of ‘techno-patrimonialism’ to Aiyar & Tillin (Seminar) could not be verified; only their India Review 2020 article and Aiyar's Journal of Democracy 2019 piece were confirmed.", whyItMatters: "A term in the task brief should not enter the graph on memory.", srcs: [["Aiyar & Tillin (2020) “One nation,” BJP, and the future of Indian federalism — India Review 19(2):117–135 (Crossref metadata; T&F abstract page returned 403)","https://api.crossref.org/works/10.1080/14736489.2020.1744994"],["Aiyar (2019) Modi Consolidates Power: Leveraging Welfare Politics — Journal of Democracy 30(4):78–88 (Crossref metadata)","https://api.crossref.org/works/10.1353/jod.2019.0070"]], domain: "literature" },
  { what: "Lokniti-CSDS post-poll reports for Karnataka 2023 and West Bengal 2021 were not located (Lokniti site index pages carry no report links; The Hindu unreachable).", whyItMatters: "Gruha Lakshmi and Lakshmir Bhandar — the Congress and TMC cases the symmetry check needs — have no survey evidence in this file.", srcs: [["Lokniti-CSDS — home and election-study index pages (post-poll PDFs for Karnataka 2023 and West Bengal 2021 not located on the site)","https://www.lokniti.org/"]], domain: "literature" },
  { what: "Jayati Ghosh's freebies/cash-transfer writing and Dipa Sinha's PDS-specific work were not located on EPW; NITI Aayog's DBT-in-food evaluation was unreachable (403).", whyItMatters: "Narrative 10 and narrative 5 lean on secondary characterisations of these authors.", srcs: [["EPW author page — Jayati Ghosh (no cash-transfer or freebies article listed on the page opened)","https://www.epw.in/author/jayati-ghosh"],["EPW author page — Dipa Sinha (lists Social Sector and Union Budget 2025–26; Social Sector Budget 2026; Sinha & Azad 2018 Can Jan Dhan Yojana Achieve Financial Inclusion?)","https://www.epw.in/author/dipa-sinha"],["NITI Aayog site search for ‘direct benefit transfer’ — HTTP 403","https://www.niti.gov.in/search/node?keys=direct+benefit+transfer"]], domain: "literature" },
  { what: "No CAG audit opened for any of the 2017–19 state farm loan waivers (UP, MH ×2, PB, KA, MP, CT, RJ)", whyItMatters: "Official pages give outturns but not leakage; the RBI aggregate (66% reached banks) cannot be assigned to a state", srcs: [["PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)","https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"],["Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"]], domain: "state-cash-other" },
  { what: "No Lokniti-CSDS cross-tab by beneficiary status for any farmer/consumer scheme in this file", whyItMatters: "Every timing claim rests on marginals; with 58 lakh Rythu Bandhu or 65 lakh KALIA beneficiaries the marginal cannot discriminate", srcs: [["Wikipedia (pointer): Rythu Bandhu scheme","https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"],["CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)","https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"]], domain: "state-cash-other" },
  { what: "ELCOT tender/bidder records for the 2006–10 TV procurement (Rs 3,687 cr) and TNCSC tenders for 2011–16 mixie/grinder/fan", whyItMatters: "The only route from a goods scheme to a named private beneficiary", srcs: [["IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?","https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"],["Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women","https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"]], domain: "state-cash-other" },
  { what: "Telangana Agriculture Department data behind the Rs 22,600 cr \"non-cultivated land\" estimate", whyItMatters: "It is the largest leakage figure in the file and rests on a CM's statement", srcs: [["Deccan Herald/PTI, 21 Dec 2024: Rythu Bandhu Rs 22,600 cr given to ineligible people in BRS regime, says Telangana CM","https://www.deccanherald.com/india/telangana/rythu-bandhu-rs-22600-crore-given-to-ineligible-people-in-brs-regime-says-telangana-cm-3328152"]], domain: "state-cash-other" },
  { what: "Successor-scheme documents: Chhattisgarh Krishak Unnati (BJP), Rajasthan MAAY renaming order, AP Annadata Sukhibhava/Thalliki Vandanam GOs, Odisha CM-Kisan guidelines", whyItMatters: "Supersession is asserted from budget lines and press; the terms of continuation determine whether \"renamed\" or \"cut\"", srcs: [["PRS, Andhra Pradesh Budget Analysis 2024-25","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2024-25"],["PRS, Odisha Budget Analysis 2024-25","https://prsindia.org/budgets/states/odisha-budget-analysis-2024-25"]], domain: "state-cash-other" },
  { what: "No bank-wise DBT share or DBT-attributable float/fee income is published for SBI, Bank of Baroda or the RRBs in any source opened.", whyItMatters: "Banks are the largest intermediary in the ₹6.9 lakh crore/yr DBT flow; without the split the 'who else benefits' question cannot be sized.", srcs: [["PIB, PMJDY completes 11 years — ₹6.9 lakh crore DBT in FY2024-25, 28 Aug 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2161401"]], domain: "vendors" },
  { what: "NPCI's APB and AePS interchange schedule (the ₹15 cash-withdrawal interchange circular) could not be retrieved — npci.org.in returned an HTML stub.", whyItMatters: "The per-transaction fee is the margin the whole BC industry lives on.", srcs: [["PIB backgrounder, Direct Benefit Transfer (DBT), Jan 2022","https://static.pib.gov.in/WriteReadData/specificdocs/documents/2022/jan/doc2022153101.pdf"]], domain: "vendors" },
  { what: "The IT vendor for Maharashtra's ladakibahin.maharashtra.gov.in / Nari Shakti Doot app, MP's Samagra/Ladli Behna portal, Telangana's Rythu Bandhu portal and AP's volunteer app is not identified in any opened source.", whyItMatters: "Portal and eKYC vendors hold beneficiary data and earn per-record fees; whether NIC or a private firm built them is a material provenance fact.", srcs: [["Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024","https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"],["Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025","https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"]], domain: "vendors" },
  { what: "No CAG or Content Regulation Committee finding exists (in sources opened) on the MP ₹290 crore or Maharashtra ₹199.81 crore scheme publicity, unlike Delhi.", whyItMatters: "The asymmetry in scrutiny, not in behaviour, currently drives which government carries an adverse finding.", srcs: [["The Tribune, 'AAP govt violated ad campaign norms, spending rose by 1,200% in 5 yrs: CAG report', 27 Feb 2025","https://www.tribuneindia.com/news/india/aap-govt-violated-ad-campaign-norms-spending-rose-by-1200-in-5-yrs-cag-report/"],["Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025","https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"],["Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024","https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"]], domain: "vendors" },
  { what: "Cylinder/regulator manufacturers' orders under PMUY (8+ crore units) and FCI's contractor-level freight/handling/milling payments under PMGKAY have no public vendor-level breakdown in opened sources.", whyItMatters: "These are the two largest physical-goods flows in the welfare stack.", srcs: [["CAG press release on Performance Audit Report No. 14 of 2019 on PMUY, 11 Dec 2019 (local copy; exact report URL unresolved — see gaps)","https://cag.gov.in/en"],["PRS Legislative Research, 'Demand for Grants 2024-25 Analysis: Food and Public Distribution'","https://prsindia.org/budgets/parliament/demand-for-grants-2024-25-analysis-food-and-public-distribution"]], domain: "vendors" },
  { what: "Per-km rates and contract values for Delhi's 3,490 e-buses were not disclosed in the OEM press release or press coverage.", whyItMatters: "Without rates the size of the OEM benefit cannot be estimated.", srcs: [["Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022","https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"],["EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023","https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"]], domain: "vendors" },
  { what: "No published Lokniti-CSDS cross-tab of vote choice by Ladli Behna / Ladki Bahin / Maiya Samman beneficiary status with a non-beneficiary control", whyItMatters: "Every 'the scheme won it' claim in this file rests on marginals and press inference; with 80% coverage in MP the marginal cannot discriminate", srcs: [["Lokniti-CSDS, Madhya Pradesh Post-poll Survey 2023 — survey findings (PDF)","https://www.lokniti.org/media/PDF-upload/1703684877_6052900_download_report.pdf"],["BehanBox, 4 Dec 2024: Maharashtra poll analyses and women's agency (cites Lokniti-CSDS post-poll)","https://behanbox.com/2024/12/04/how-maharashtra-poll-analyses-are-missing-the-rise-of-womens-agency/"]], domain: "women-cash" },
  { what: "No per-scheme data on which banks or business-correspondent networks carry the DBT flows, or on DBT incentive fees and float earned", whyItMatters: "whoElseBenefits is empty for banks across 13 enacted schemes; the delivery rail is the one private beneficiary common to all", srcs: [["Mukhyamantri Ladli Bahna Yojana portal, WCD Madhya Pradesh (accessed 25 Sep 2026)","https://cmladlibahna.mp.gov.in/home.aspx"],["Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification","https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"]], domain: "women-cash" },
  { what: "Subhadra's RBI e₹ pilot: participating banks unnamed in any opened source", whyItMatters: "First CBDC-linked DBT at 1 cr scale; the pilot partners gain onboarding volume", srcs: [["PIB, 17 Sep 2024: PM launches SUBHADRA in Bhubaneswar","https://www.pib.gov.in/PressReleseDetailm.aspx?PRID=2055572&reg=3&lang=2"]], domain: "women-cash" },
  { what: "Maharashtra's Rs 250 cr Ladki Bahin advertising: no agency names or DGIPR statement", whyItMatters: "The one documented non-beneficiary spend in the file has no counterparties", srcs: [["BehanBox, 4 Dec 2024: Maharashtra poll analyses and women's agency (cites Lokniti-CSDS post-poll)","https://behanbox.com/2024/12/04/how-maharashtra-poll-analyses-are-missing-the-rise-of-womens-agency/"]], domain: "women-cash" },
  { what: "No CAG performance audit text obtained for any women's UCT; only a paraphrase of the Karnataka guarantees report", whyItMatters: "Leakage vs targeting-error cannot be sized; the Rs 4,800 cr allegation and the Rs 14,000 cr state figure in Maharashtra are unaudited", srcs: [["Deccan Herald, 26 Aug 2025: H M Revanna rejects CAG conclusions on Karnataka guarantee schemes","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"],["Deccan Herald, 29 Jul 2025: Supriya Sule alleges Rs 4,800 cr fraud, seeks SIT","https://www.deccanherald.com/india/maharashtra/supriya-sule-alleges-rs-4800-crore-fraud-in-ladki-bahin-yojana-seeks-sit-probe-3654533"],["Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification","https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"]], domain: "women-cash" },
  { what: "Telangana never published a cost estimate or eligibility rule for the Rs 2,500 Mahalakshmi cash component", whyItMatters: "An unpriced promise cannot be tested for affordability; its non-delivery has no official explanation", srcs: [["The South First, 8 Jan 2025: fact check — Rs 2,500 Mahalakshmi not paid","https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"]], domain: "women-cash" },
  { what: "No independent welfare-outcome evaluation (consumption, nutrition, autonomy) of any of the 13 enacted schemes found in this sweep", whyItMatters: "The debate is conducted entirely on electoral and fiscal grounds", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]], domain: "women-cash" },
];

export const WELFARE_NARRATIVES: Narrative[] = [
  { claim: "PM-KISAN was created to win the 2019 Lok Sabha election.", status: "contested", strongestCase: "announced in an interim budget 1 Feb 2019, back-dated to 1 Dec 2018, first ₹2,000 paid from 24 Feb 2019 to >1 crore farmers, 48 days before polling; the FM conceded it alone kept the fiscal deficit above target", strongestCounter: "it has run seven years, been extended to 2031 at ₹3.15 lakh cr, and is evaluated (IFPRI, NITI) as easing input credit; Telangana's Rythu Bandhu preceded it; both coalitions time welfare to polls (ADWDRS 2008, NFSA 2013)", whatWouldChangeThis: "a recipient/non-recipient vote-swing comparison from panel survey data; or internal papers showing the December back-dating was chosen for poll timing", srcs: [["Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)","https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"],["Wikipedia (pointer), Pradhan Mantri Kisan Samman Nidhi","https://en.wikipedia.org/wiki/Pradhan_Mantri_Kisan_Samman_Nidhi"],["PMO, Cabinet approves continuation of PM-KISAN 2026-27 to 2030-31, ₹3.15 lakh crore, 31 Jul 2026","https://www.pmindia.gov.in/en/news_updates/cabinet-approves-continuation-of-the-pm-kisan-scheme-from-2026-27-to-2030-31-with-a-financial-outlay-of-rs-3-15-lakh-crore/"],["Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)","https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"],["Wikipedia (pointer), National Food Security Act 2013","https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"]], domain: "central" },
  { claim: "Cash transfers buy elections in India.", status: "contested", strongestCase: "8 of 15 launch/expansion events here fell within 12 months of a general election; the Nov 2023 cluster (PMGKAY 5-yr, PMUY ₹300, Vishwakarma, Drone Didi, PM-KISAN saturation) preceded three BJP assembly wins", strongestCounter: "NFSA (2013) preceded the UPA's worst-ever defeat; the 2023-24 cluster preceded a 63-seat BJP loss; Lokniti 2024 shows half of beneficiaries found access difficult; the largest scheme (PDS) is statutory and reaches 67% of households regardless of who governs", whatWouldChangeThis: "constituency-level enrolment/disbursement data matched to swing; a natural experiment where scheme rollout was staggered for administrative reasons", srcs: [["Lokniti-CSDS, Social and Political Barometer Post-poll Study 2024 — Survey Findings (PDF on file, dated 14 Jun 2024; exact URL not recovered — see gaps)","https://www.lokniti.org/"],["Wikipedia (pointer), 2014 Indian general election","https://en.wikipedia.org/wiki/2014_Indian_general_election"],["Wikipedia (pointer), 2024 Indian general election","https://en.wikipedia.org/wiki/2024_Indian_general_election"],["PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"],["PIB (MoA&FW RS reply), PM-KISAN 18th instalment beneficiaries and saturation drives, Feb 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2100758"]], domain: "central" },
  { claim: "DBT has saved the exchequer ₹3.48 lakh crore.", status: "contested", strongestCase: "administrative deletions are real (2.1 crore PM-KISAN entries; 5.8 crore ration cards); AP Smartcards RCT documented leakage falling", strongestCounter: "the figure is a private foundation's estimate relayed by PIB; earlier LPG-DBT savings claims did not survive scrutiny (EPW 2016); the Jharkhand RCT shows 'savings' partly consist of genuine beneficiaries losing food, with 1.5–2 million losing access at some point", whatWouldChangeThis: "a DBT Mission methodology separating ghost/duplicate deletions from eligible-but-unauthenticated exclusions, scheme by scheme", srcs: [["PIB, 'India's DBT: Boosting Welfare Efficiency' (BlueKraft report relayed), 21 Apr 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2123192"],["EPW Vol 51 No 52, 'Questioning the Phenomenal Success of Aadhaar-linked DBT for LPG', 24 Dec 2016","https://www.epw.in/journal/2016/52/web-exclusives/questioning-%E2%80%9Cphenomenal-success%E2%80%9D-aadhaar-linked-direct-benefit"],["NBER WP 26744, Muralidharan, Niehaus & Sukhtankar, 'Identity Verification Standards in Welfare Programs: Experimental Evidence from India', Feb 2020 rev. Sep 2021","https://www.nber.org/system/files/working_papers/w26744/w26744.pdf"],["Muralidharan, Niehaus & Sukhtankar, 'Building State Capacity: Evidence from Biometric Smartcards in India', AER 106(10), 2016","https://www.aeaweb.org/articles?id=10.1257/aer.20141346"]], domain: "central" },
  { claim: "MGNREGA was starved and then repealed for political reasons.", status: "contested", strongestCase: "BE cut 18% in 2023, nominal freeze 2024-26, releases down from ₹1.11 lakh cr (2020-21) to ₹0.86 lakh cr (2024-25); repeal passed both Houses in two days in Dec 2025 without a select committee; 60:40 sharing and 'normative' allocations end open-ended demand; Opposition-ruled states bear the shift", strongestCounter: "RE always exceeded BE (₹86,000 cr in 2023-24); post-COVID demand fell; the government offered work to 99.8% of demanders; the successor Act raises the guarantee to 125 days, adds delay compensation and Janata Boards", whatWouldChangeThis: "G RAM G person-days and wage releases in 2026-27 vs 2024-25 in real terms; state-wise normative allocations vs prior demand", srcs: [["PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"],["PIB (MoRD), Clarifications on budget cut to MGNREGA, BE/RE/release series 2014-15 to 2022-23, 3 Feb 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"],["BehanBox, 'The GRAMG Bill codifies the stealthy ways in which NREGA was being undermined', 18 Dec 2025","https://behanbox.com/2025/12/18/the-gramg-bill-codifies-the-stealthy-ways-in-which-nrega-was-being-undermined/"],["PIB Backgrounder, Viksit Bharat-G RAM G Act 2025 FAQ, 11 May 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2259712"],["Akashvani News, Chouhan says VB-G RAM G Bill removes shortcomings of MGNREGA, 30 Dec 2025","https://www.newsonair.gov.in/union-minister-shivraj-singh-chouhan-says-viksit-bharat-g-ram-g-bill-removes-shortcomings-of-mgnrega"]], domain: "central" },
  { claim: "Ujjwala gave 10 crore poor women clean cooking fuel.", status: "well-supported", strongestCase: "10.33 crore connections; LPG coverage 62% → 99.8%; refills recovered to 4.47/yr by 2024-25 with a ₹300 subsidy; 45% of households report a benefit", strongestCounter: "CAG found weak de-duplication, minors and men enrolled, distributor misuse, refills falling to 3.21/yr by 2018 and ~90 lakh taking no refill in 2021-22; the refill cap was cut to 9 in 2025", whatWouldChangeThis: "household-level refill panels by income; whether the 9-refill cap reduces 2025-26 consumption", srcs: [["CAG press release on Performance Audit Report No. 14 of 2019 (PMUY), 11 Dec 2019 (PDF on file; exact document URL not recovered — see gaps)","https://cag.gov.in/"],["PIB, Cabinet approves PMUY targeted subsidy FY 2025-26 (₹300, up to 9 refills), 8 Aug 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2154117"],["Wikipedia (pointer), Pradhan Mantri Ujjwala Yojana","https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"],["Lokniti-CSDS, Social and Political Barometer Post-poll Study 2024 — Survey Findings (PDF on file, dated 14 Jun 2024; exact URL not recovered — see gaps)","https://www.lokniti.org/"]], domain: "central" },
  { claim: "Cash/DBT schemes launched shortly before an election cause the incumbent to win", status: "contested", strongestCase: "Bihar 2025 (Mahila Rozgar Yojana, ~6 weeks before polling, NDA's biggest win since 2010) and Madhya Pradesh 2023 (Ladli Behna, ~5 months out, BJP's best swing since 2013) both fit the pattern tightly on the numbers.", strongestCounter: "Andhra Pradesh 2024 (one of India's largest state DBT programmes, YSRCP still lost by a landslide), Telangana 2023 (Rythu Bandhu unchanged, BRS still lost), West Bengal 2026 (a benefit hike ~2.5 months before polling, TMC still lost after 15 years), and Tamil Nadu 2026 (DMK's scheme running 2.5 years, DMK still lost to a brand-new party) are four elections in this same file where a fresh or freshly-hiked scheme did not save the incumbent.", whatWouldChangeThis: "A properly powered study with booth-level or survey-microdata evidence isolating the scheme's marginal effect from turnout, campaign spending, anti-incumbency and opposition quality — this file has none of that; it has election outcomes and scheme dates, which can show correlation and its absence but not a causal estimate.", srcs: [["Deccan Herald — Bihar Rs 10,000 cash transfer to women","https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-rs-10000-cash-transfer-to-women-may-prove-game-changer-for-nitish-kumar-3773893"],["Wikipedia — 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"]], domain: "elections-timing" },
  { claim: "Madhya Pradesh 2023: Ladli Behna delivered the BJP's win", status: "contested", strongestCase: "BJP's vote share rose 7.6 points and seat count by 54 in the one election cycle where this specific scheme existed; the scheme was the dominant theme of both the BJP campaign and post-defeat Congress commentary.", strongestCounter: "MP had run other Ladli-branded schemes since 2007 without preventing a 2018 near-loss; Congress also ran a competing cash promise in 2023; the swing could equally reflect Kamal Nath's weak campaign, BJP's late leadership reset, or anti-Congress consolidation unrelated to the scheme.", whatWouldChangeThis: "District- or booth-level correlation between Ladli Behna registration density and BJP vote-share swing, net of 2018 baseline support — not present in this file.", srcs: [["Wikipedia — 2023 MP Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"]], domain: "elections-timing" },
  { claim: "Telangana 2023: Rythu Bandhu was not enough to save BRS", status: "well-supported", strongestCase: "Rythu Bandhu ran unmodified through the election; BRS still lost 49 seats and 10 points of vote share to Congress, whose own guarantees (Mahalakshmi, farm loan waiver) plus corruption allegations against BRS and general fatigue after two terms are the more commonly cited drivers.", strongestCounter: "One could argue BRS's loss would have been larger without Rythu Bandhu's base of large-farmer support — a counterfactual this file cannot test.", whatWouldChangeThis: "Comparative constituency-level analysis of BRS vote-share decline by Rythu Bandhu beneficiary density.", srcs: [["The News Minute — BRS losses, Congress gains, Telangana 2023","https://www.thenewsminute.com/telangana/brs-losses-congress-gains-how-telangana-voted-in-2023"]], domain: "elections-timing" },
  { claim: "Andhra Pradesh 2024: the largest DBT programme in the sample still lost", status: "well-supported", strongestCase: "YSRCP ran Rythu Bharosa, Amma Vodi, Cheyutha and other transfers for a full five-year term, among the largest DBT welfare architectures of any Indian state in this period, and still lost 124 of 135 contested seats it had held, with vote share collapsing.", strongestCounter: "Some of YSRCP's own supporters argue the loss reflects a united opposition (TDP-BJP-Janasena) and money/media asymmetry rather than welfare-policy rejection, and that welfare delivery itself was not repudiated in exit polling.", whatWouldChangeThis: "AP-specific post-poll survey data on whether DBT beneficiaries defected from YSRCP at a materially different rate than non-beneficiaries — not in this file's source set.", srcs: [["Wikipedia — 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"]], domain: "elections-timing" },
  { claim: "Karnataka 2023: Congress won by promising, not by having already delivered", status: "established", strongestCase: "Gruha Lakshmi and Congress's other four 'guarantees' were campaign promises made before the May 2023 poll; the schemes themselves were only launched (or in one case never fully launched — the ₹2,500 Mahalakshmi cash in neighbouring Telangana shows the same pattern) after Congress had already won and taken office. The dated record in this file settles this: launch postdates the election.", strongestCounter: "None on the pure sequencing question; the open question is how much causal weight the *promise* itself carried versus other factors (BJP's Bommai-era corruption allegations, the anti-Hindutva backlash after hijab/halal controversies).", whatWouldChangeThis: "N/A on sequencing (documented); causal weight would need survey data on when voters say they decided, and why.", srcs: [["Wikipedia — 2023 Karnataka Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Karnataka_Legislative_Assembly_election"]], domain: "elections-timing" },
  { claim: "Delhi 2025: AAP lost despite a decade of free power/water, and BJP won while promising an even larger cash scheme", status: "well-supported", strongestCase: "AAP's fresh ₹2,100/month promise, layered on top of its long-running free electricity and water subsidies, did not prevent a 26-seat collapse; BJP's competing ₹2,500/month promise (larger than AAP's) accompanied a 13-point vote-share swing in BJP's favour.", strongestCounter: "The liquor-policy corruption case and ten years of incumbency fatigue are independently large factors this file cannot separate from the welfare-promise comparison; it is also possible AAP's promise was simply not believed given the party's fiscal position by that point.", whatWouldChangeThis: "Survey data on why AAP's promise did not move the seats BJP's did, isolating credibility, amount, and incumbency-fatigue effects — not in this file.", srcs: [["Wikipedia — 2025 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"]], domain: "elections-timing" },
  { claim: "West Bengal 2026: the closest-timed benefit hike in this file preceded the incumbent's defeat", status: "well-supported", strongestCase: "TMC raised Lakshmir Bhandar by ₹500/month roughly 2.5 months before polling — the shortest announcement-to-poll gap of any hike in this file — and still lost after 15 years, ending its run against a BJP surge.", strongestCounter: "The margin (BJP ~207 vs TMC's much smaller tally, on preliminary figures) is wide enough that most observers point to a multi-year erosion (organisational decline, corruption allegations, and a sustained BJP push since 2019) rather than treating the hike's timing as decisive either way.", whatWouldChangeThis: "District-level correlation between Lakshmir Bhandar density and TMC vote-share retention versus decline — not in this file.", srcs: [["Wikipedia — 2026 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2026_West_Bengal_Legislative_Assembly_election"]], domain: "elections-timing" },
  { claim: "Bihar 2025: the closest launch-to-poll gap in this entire file", status: "contested", strongestCase: "First disbursement 26 September 2025, polling began 6 November 2025 — about six weeks — reaching over a crore women, ahead of the NDA's largest seat margin since 2010; opposition parties and some commentators explicitly called this an inducement.", strongestCounter: "The NDA's own framing (continuation of the pre-existing Jeevika SHG programme, paced by verification, not invented for the poll) is a live, unresolved dispute this file records as a contra rather than settling; Bihar's improved law-and-order narrative and Mahagathbandhan's internal seat-sharing friction are independently cited as large factors.", whatWouldChangeThis: "Comparison of Jeevika SHG disbursement timelines in non-election years to see whether a six-week-to-poll gap is normal programme cadence or an outlier.", srcs: [["Deccan Herald — Bihar Rs 10,000 cash transfer to women","https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-rs-10000-cash-transfer-to-women-may-prove-game-changer-for-nitish-kumar-3773893"],["The Federal — Bihar pre-poll cash push sparks concerns over ECI neutrality","https://thefederal.com/category/elections-2025/pre-poll-cash-transfers-in-bihar-raise-concerns-over-voter-influence-eci-neutrality-214703"]], domain: "elections-timing" },
  { claim: "Rajasthan's and Himachal Pradesh's welfare pushes are dwarfed by structural anti-incumbency", status: "well-supported", strongestCase: "Rajasthan has changed its ruling party in every single assembly election since 1993, and Himachal Pradesh has done so in nearly every election since 1985; in this file's 2000-2026 window the combined Rajasthan+Himachal+Punjab incumbent win rate is 1 in 15, regardless of which party was in office or what it had just spent on welfare.", strongestCounter: "One could argue the welfare push in each case narrowed the margin even if it did not change the outcome — a counterfactual this file cannot test with the data it has.", whatWouldChangeThis: "Margin-of-defeat trends over multiple cycles correlated with welfare spending as a share of the state budget — not in this file.", srcs: [["The Week — Rajasthan 2023, change of guard","https://www.deccanherald.com/india/rajasthan/rajasthan-2023-change-of-guard-end-of-gehlot-raje-era-2829895"]], domain: "elections-timing" },
  { claim: "Women's cash transfers are driving Indian states into fiscal crisis.", status: "contested", strongestCase: "PRS: 12 states, ₹1.68 lakh cr, 6% of their revenue expenditure; half of them in revenue deficit; Karnataka flips from surplus to deficit; CAG Karnataka: guarantees financed by debt, 'loop of indebtedness'; RBI 2026 warns of crowding out.", strongestCounter: "Aggregate UCT cost is 0.47% of GDP against 53% of revenue receipts on salaries/pensions/interest and 9% on older subsidies (mostly power); RBI 2026 shows the revenue-deficit share of state GFD falling to 6.9% and capex rising. Stress is state-specific (JH, WB, KA, MH), not systemic.", whatWouldChangeThis: "Actuals (not BE) for 2025-26 showing capex cuts in UCT states relative to non-UCT states; CAG finance accounts for MH, MP, WB comparable to Karnataka's.", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["RBI, State Finances: A Study of Budgets of 2025-26 (23 Jan 2026), Chapter IV 'The Way Forward', paras 4.1, 4.5, 4.8","https://www.rbi.org.in/Scripts/PublicationsView.aspx?id=23694"],["RBI, State Finances: A Study of Budgets of 2025-26 (23 Jan 2026), Chapter II 'Fiscal Position of the State Governments'","https://www.rbi.org.in/Scripts/PublicationsView.aspx?id=23692"],["Deccan Herald, 26 Mar 2026: 'Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG' (CAG State Finances Audit Report 2024-25, tabled 26 Mar 2026)","https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"]], domain: "fiscal-results" },
  { claim: "'Revdi culture' is an opposition phenomenon; BJP double-engine governments do not distribute freebies (PM, 16 Jul 2022).", status: "debunked", strongestCase: "In mid-2022 the two women's UCTs in existence were in Assam (BJP) and WB (TMC); the headline freebie states in RBI's table (Punjab, AP, Jharkhand) were non-BJP.", strongestCounter: "RBI's same table ranked BJP-ruled MP 4th (1.6% of GSDP); by 2025-26, 7 of 12 UCT states and 50.8% of UCT money are in BJP/NDA-governed states; pre-poll launch rates are statistically indistinguishable across parties (7/15 vs 7/19). The BJP's distinction between 'empowerment' and 'revdi' is not operationalised anywhere we found.", whatWouldChangeThis: "A published, party-neutral BJP definition that consistently classifies all parties' schemes.", srcs: [["PMO India, 'PM's address at inauguration of Bundelkhand Expressway at Jalaun, UP', 16 Jul 2022 (English text + PMO tweets in Hindi)","https://www.pmindia.gov.in/en/news_updates/pms-address-at-inauguration-of-bundelkhand-expressway-at-jalaun-in-uttar-pradesh/"],["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"]], domain: "fiscal-results" },
  { claim: "Cash schemes are launched to buy elections.", status: "contested", strongestCase: "Launches in the fleet's list are ~2x over-represented in the 12 months before polls (14/34 vs 6.8 expected; survives BH); Jharkhand raised its payout 2.5x weeks before voting; CJI Surya Kant (Feb 2026, oral) asked why schemes appear just before elections.", strongestCounter: "The list is salience-selected; the excess is identical across parties; post-poll delivery is also common; the sibling's incumbent-win split (8/8 vs 8/14) is not significant (Fisher p=0.051) and big-spending incumbents lost (YSRCP 2024, BRS 2023, TMC 2026, DMK 2026 per elections-timing.json). Timing excess ≠ vote effect.", whatWouldChangeThis: "A census of all DBT launches with dates, and constituency-level variation in scheme exposure linked to vote swings.", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["LiveLaw, 19 Feb 2026: ''Why cash transfer schemes just before elections?' Supreme Court slams freebies culture' (Surya Kant CJI, Bagchi, Pancholi JJ; TN Power Distribution Co. challenge to Electricity Amendment Rules 2024)","https://www.livelaw.in/top-stories/why-cash-transfer-schemes-just-before-elections-supreme-court-slams-freebies-culture-says-nation-building-hampered-523778"]], domain: "fiscal-results" },
  { claim: "Aadhaar-based DBT eliminated leakage in welfare delivery.", status: "contested", strongestCase: "AP Smartcards RCT: less leakage in NREGS and pensions, faster payments, no loss of access; improved NREGS implementation raised earnings 14%.", strongestCounter: "Stricter biometric verification in Jharkhand PDS cut corruption but 1.5–2 million legitimate beneficiaries lost access at some point; PM-KISAN and Ladki Bahin later removed large numbers as ineligible (central.json, women-cash.json) — inclusion errors survived DBT.", whatWouldChangeThis: "Pre/post-DBT leakage estimates for the new state UCTs; exclusion audits of Aadhaar-seeded payments.", srcs: [["Muralidharan, Niehaus & Sukhtankar, 'Building State Capacity: Evidence from Biometric Smartcards in India', AER 106(10), Oct 2016 — abstract","https://www.aeaweb.org/articles?id=10.1257/aer.20141346"],["Muralidharan, Niehaus & Sukhtankar, 'General Equilibrium Effects of (Improving) Public Employment Programs: Experimental Evidence from India', NBER WP 23838 (2017; revised, published Econometrica 2023) — abstract","https://www.nber.org/papers/w23838"],["Muralidharan, Niehaus & Sukhtankar, 'Identity Verification Standards in Welfare Programs: Experimental Evidence from India', NBER WP 26744 (Feb 2020, revised) — abstract","https://www.nber.org/papers/w26744"]], domain: "fiscal-results" },
  { claim: "Cash transfers and 'freebies' produce no development return.", status: "unsupported", strongestCase: "RBI 2022: freebies can undermine credit culture, distort prices and deplete water tables (free farm power); RBI 2026: welfare spending risks crowding out infrastructure.", strongestCounter: "Strong causal evidence of returns for specific designs — Bihar cycles (+32% girls' secondary enrolment), NREGS delivery reform (+14% earnings, −26% poverty). For the post-2023 women's UCTs there is simply no rigorous evaluation yet (void) — absence of evidence, not evidence of absence.", whatWouldChangeThis: "Quasi-experimental evaluations of Ladli Behna / Ladki Bahin / Gruha Lakshmi / Lakshmir Bhandar on consumption, nutrition, women's labour and agency.", srcs: [["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"],["RBI, State Finances: A Study of Budgets of 2025-26 (23 Jan 2026), Chapter IV 'The Way Forward', paras 4.1, 4.5, 4.8","https://www.rbi.org.in/Scripts/PublicationsView.aspx?id=23694"],["Muralidharan & Prakash, 'Cycling to School: Increasing Secondary School Enrollment for Girls in India', AEJ: Applied Economics 9(3), Jul 2017 — abstract","https://www.aeaweb.org/articles?id=10.1257/app.20160004"],["Muralidharan, Niehaus & Sukhtankar, 'General Equilibrium Effects of (Improving) Public Employment Programs: Experimental Evidence from India', NBER WP 23838 (2017; revised, published Econometrica 2023) — abstract","https://www.nber.org/papers/w23838"]], domain: "fiscal-results" },
  { claim: "Cash transfers buy elections.", status: "contested", strongestCase: "Outside India the causal record mostly finds incumbents rewarded: PANES in Uruguay (Manacorda et al 2011), Progresa (De La O 2013), Bolsa Família (Zucco 2013; Hunter & Power 2007), 4Ps in the Philippines (Labonne 2013). In India, Lokniti's NES 2019 shows Ujjwala/Jan Dhan/Awas beneficiaries more likely to vote BJP (Deshpande et al 2019), and the MP 2023 and Maharashtra 2024 post-polls show the winning side ahead among women after near-universal women's cash schemes.", strongestCounter: "Imai, King & Velasco Rivera (2020) re-analysed Progresa and found no partisan effect; Zucco finds Bolsa effects that do not build lasting loyalty; Deshpande et al find MGNREGA and pension recipients less likely to vote BJP, so ‘transfers → incumbent’ is scheme-specific; the Lokniti Maharashtra team itself says a 3-point gender gap is not proof; no Indian scheme has a causal vote estimate (0 of 8 here). ‘Buy’ also implies an exchange the Supreme Court (Balaji 2013) says is lawful policy, not corrupt practice.", whatWouldChangeThis: "A quasi-experimental estimate for an Indian scheme (eligibility discontinuity or staggered rollout) showing a vote effect, or a null one; Lokniti cross-tabs by beneficiary status.", srcs: [["Manacorda, Miguel & Vigorito (2011) Government Transfers and Political Support — AEJ: Applied 3(3):1–28 (Crossref metadata)","https://api.crossref.org/works/10.1257/app.3.3.1"],["De La O (2013) Do Conditional Cash Transfers Affect Electoral Behavior? Evidence from a Randomized Experiment in Mexico — AJPS 57(1):1–14 (Crossref metadata)","https://api.crossref.org/works/10.1111/j.1540-5907.2012.00617.x"],["Zucco (2013) When Payouts Pay Off: Conditional Cash Transfers and Voting Behavior in Brazil 2002–10 — AJPS 57(4):810–822 (Crossref metadata)","https://api.crossref.org/works/10.1111/ajps.12026"],["Labonne (2013) The local electoral impacts of conditional cash transfers — Journal of Development Economics 104:73–88 (Crossref metadata)","https://api.crossref.org/works/10.1016/j.jdeveco.2013.04.006"],["Imai, King & Velasco Rivera (2020) Do Nonpartisan Programmatic Policies Have Partisan Electoral Effects? Evidence from Two Large-Scale Experiments — Journal of Politics 82(2):714–730 (Crossref metadata)","https://api.crossref.org/works/10.1086/707059"],["Deshpande, Tillin & Kailash (2019) The BJP’s Welfare Schemes: Did They Make a Difference in the 2019 Elections? — Studies in Indian Politics 7(2):219–233 (Crossref metadata + abstract)","https://api.crossref.org/works/10.1177/2321023019874911"],["Lokniti-CSDS — Madhya Pradesh Postpoll Survey 2023: Survey Findings (N=3,050, 18–24 Nov 2023; PDF held locally; Lokniti state-election index page opened)","https://www.lokniti.org/state-assembly-elections"],["Lokniti-CSDS Maharashtra 2024 post-poll analysis, The Hindu, 25 Nov 2024 (Deshpande, ‘Women sided with Mahayuti for Ladki Bahin Yojana’s monthly dole’; Mishra, women as deciders) — page PDF held locally; thehindu.com unreachable from this container","https://www.lokniti.org/state-assembly-elections"],["S. Subramaniam Balaji v Government of Tamil Nadu, SC, 2013-07-05, (2013) 9 SCC 659 — Indian Kanoon","https://indiankanoon.org/doc/106854428/"]], domain: "literature" },
  { claim: "Ladli Behna decided the Madhya Pradesh 2023 election.", status: "contested", strongestCase: "The BJP won 163 of 230 against expectations of anti-incumbency; Lokniti found 80.4% of households with a beneficiary; the press and ISAS credited the scheme; Congress felt compelled to match it with ₹1,500/month.", strongestCounter: "Coverage of 80% leaves no counterfactual group; the public findings PDF has no beneficiary × vote table; rival explanations in the same survey (state ‘development’ 18.3%, ‘worked for the poor’ 10.8%, the PM's campaign) are untested against it; Congress's matching offer means the scheme could not have distinguished the parties on paper.", whatWouldChangeThis: "Release of the Lokniti gender × vote and beneficiary × vote cross-tabs; a district-level analysis of women's turnout change against enrolment.", srcs: [["Lokniti-CSDS — Madhya Pradesh Postpoll Survey 2023: Survey Findings (N=3,050, 18–24 Nov 2023; PDF held locally; Lokniti state-election index page opened)","https://www.lokniti.org/state-assembly-elections"],["Vinod Rai, ‘The BJP Wins the Semi-final: Impressive Gains in State Elections’, ISAS Brief No. 1081, 6 Dec 2023 (PDF held locally)","https://www.isas.nus.edu.sg/"],["Deccan Herald, 2023-12-03 — Focus on women voters to PM Modi’s ‘magic’: what worked for BJP in MP","https://www.deccanherald.com/india/madhya-pradesh/focus-on-women-voters-to-pm-modis-magic-what-worked-for-bjp-in-madhya-pradesh-assembly-elections-2794883"],["Deccan Herald, 2023-03-05 — Ahead of MP govt’s Ladli Behna launch, Kamal Nath promises women ₹18,000 per year","https://www.deccanherald.com/india/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"]], domain: "literature" },
  { claim: "Freebies are bankrupting the states.", status: "contested", strongestCase: "PRS 2025: 12 states budget ₹1,68,040 crore (0.5% of GDP) for women's UCTs, six of them in revenue deficit; Karnataka flips from surplus to deficit once Gruha Lakshmi-type spending is counted; RBI (2024-25) flags cash transfers as stress; Maharashtra cut its benefit within five months of winning.", strongestCounter: "0.5% of GDP and ~6% of revenue expenditure is small beside committed expenditure (53% of revenue receipts on salaries, pensions, interest; Punjab 107%); aggregate state debt (27.5% of GDP) predates the schemes; PRS's own adjustment shows MP still in surplus; ‘bankrupt’ is not a fiscal category any state has entered.", whatWouldChangeThis: "A state missing a debt-service payment or breaching FRBM limits attributable to a UCT; or evidence UCTs crowd out capex in the implementing states specifically.", srcs: [["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"],["RBI — State Finances: A Study of Budgets 2024-25 (Dec 2024) — PDF behind a CAPTCHA in this container; quoted via PRS","https://rbidocs.rbi.org.in/rdocs/Publications/PDFs/0STATEFINANCE2024AE6FF65F475C4934B53CC8ABE7FAB30E.PDF"],["RBI — State Finances: A Study of Budgets (publication index; 2025-26 edition released 2026-01-23; archive 2002–2024)","https://www.rbi.org.in/Scripts/AnnualPublications.aspx?head=State%20Finances%20:%20A%20Study%20of%20Budgets"]], domain: "literature" },
  { claim: "The PM's July 2022 ‘revdi’ speech was hypocrisy.", status: "contested", strongestCase: "The speech (2022-07-16, Jalaun) said freebies are used ‘to buy the people’ and that double-engine governments do not take that ‘shortcut’; BJP governments in MP (2023), Maharashtra (2024), Delhi and Haryana (2025) then launched monthly women's cash schemes, and BJP-ruled Odisha and Assam run Subhadra and Orunodoi.", strongestCounter: "The speech itself lists houses, gas, toilets and roads as ‘social justice’, drawing a line the BJP still draws between targeted welfare and freebies; the Supreme Court has never defined the term; 12 states of every major party run the same schemes, so the practice is non-discriminating; state governments answer to state electorates.", whatWouldChangeThis: "A public BJP definition of ‘revdi’ that includes or excludes monthly women's transfers; or an RBI/Finance Commission classification applied to Ladli Behna.", srcs: [["PM’s address at inauguration of Bundelkhand Expressway, Jalaun, 16 Jul 2022 — official English rendering (pmindia.gov.in)","https://www.pmindia.gov.in/en/news_updates/pms-address-at-inauguration-of-bundelkhand-expressway-at-jalaun-in-uttar-pradesh/"],["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"],["Deccan Herald, 2025-08-28 — Haryana launches Lado Lakshmi Yojana; women to get ₹2,100 monthly","https://www.deccanherald.com/india/haryana/haryana-decides-to-implement-lado-lakshmi-yojana-eligible-women-to-get-rs-2100-monthly-aid-3700884"],["Deccan Herald, 2025-03-08 — Delhi cabinet clears ₹2,500 for women under Mahila Samriddhi Yojana","https://www.deccanherald.com/india/delhi/cabinet-clears-proposal-to-give-delhi-women-rs-2500-under-mahila-samriddhi-yojana-3438182"]], domain: "literature" },
  { claim: "DBT eliminated leakage.", status: "contested", strongestCase: "The AP smartcards RCT (MNS 2016) is strong evidence that biometric payment reform cut leakage without raising exclusion; the DBT portal reports ₹5,14,201.92 crore of ‘Estimated Gains’ and ₹53.45 lakh crore transferred; Bihar RCTs show e-governance reforms reduce leakage in MGNREGA.", strongestCounter: "‘Eliminated’ is unsupported: the portal figure is a self-reported estimate, not an audit; Khera (2017) shows savings claims often count denied entitlements; Drèze et al (2017) document ‘pain without gain’ from ABBA in Jharkhand's PDS; the AP result concerns a bundled reform, not Aadhaar authentication alone; no CAG audit of the aggregate gains was opened.", whatWouldChangeThis: "A CAG audit of the gains methodology, or the MNS 2025 Jharkhand effect sizes on exclusion versus leakage.", srcs: [["Muralidharan, Niehaus & Sukhtankar (2016) Building State Capacity: Evidence from Biometric Smartcards in India — AER 106(10):2895–2929 (Crossref metadata)","https://api.crossref.org/works/10.1257/aer.20141346"],["DBT Bharat portal — headline figures as displayed 2026-09-25","https://dbtbharat.gov.in/"],["Khera (2017) Impact of Aadhaar on Welfare Programmes — EPW 52(50), 16 Dec 2017 (EPW page opened)","https://www.epw.in/journal/2017/50/special-articles/impact-aadhaar-welfare-programmes.html"],["Drèze, Khalid, Khera & Somanchi (2017) Aadhaar and Food Security in Jharkhand: Pain without Gain? — EPW 52(50), 16 Dec 2017 (EPW page opened; full text not extracted)","https://www.epw.in/journal/2017/50/special-articles/aadhaar-and-food-security-jharkhand.html"],["Muralidharan, Niehaus & Sukhtankar (2025) Identity Verification Standards in Welfare Programs: Experimental Evidence from India — REStat 107(2):372–392; NBER w26744 (2020) (Crossref metadata)","https://api.crossref.org/works/10.1162/rest_a_01296"],["Banerjee, Duflo, Imbert, Mathew & Pande (2020) E-governance, Accountability, and Leakage in Public Programs: Experimental Evidence from a Financial Management Reform in India — AEJ: Applied 12(4):39–72 (Crossref metadata)","https://api.crossref.org/works/10.1257/app.20180302"]], domain: "literature" },
  { claim: "Women's cash schemes are empowerment, not vote-buying.", status: "contested", strongestCase: "Bombay HC upheld Ladki Bahin as a beneficiary scheme; the Supreme Court (Balaji) holds such promises lawful policy; Bihar's cycle scheme shows a state distribution scheme with rigorous human-capital effects; PRS describes UCTs as aiming to empower economically weaker women.", strongestCounter: "The dichotomy is false: a scheme can do both. Launch timing (MP: months before polls; Maharashtra: first payment on the eve of Independence Day, election three months later) and post-election cuts are documented; no independent evaluation of Ladli Behna or Ladki Bahin outcomes (labour, consumption, autonomy) was located; ‘empowerment’ is the government's framing and the court's characterisation of legality, not a measured effect.", whatWouldChangeThis: "A published impact evaluation of Ladli Behna/Ladki Bahin on women's outcomes; or documented targeting of payments by constituency competitiveness.", srcs: [["Deccan Herald, 2024-08-05 — Ladki Bahin Yojana a beneficiary scheme for women, not discriminatory: Bombay High Court","https://www.deccanherald.com/india/maharashtra/ladki-bahin-yojana-a-beneficiary-scheme-for-women-not-discriminatory-bombay-high-court-3137089"],["S. Subramaniam Balaji v Government of Tamil Nadu, SC, 2013-07-05, (2013) 9 SCC 659 — Indian Kanoon","https://indiankanoon.org/doc/106854428/"],["Muralidharan & Prakash (2017) Cycling to School: Increasing Secondary School Enrollment for Girls in India — AEJ: Applied 9(3):321–350 (Crossref metadata)","https://api.crossref.org/works/10.1257/app.20160004"],["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"],["Deccan Herald, 2024-08-15 — Shinde govt begins releasing money under Ladki Bahin Yojana on eve of Independence Day","https://www.deccanherald.com/india/maharashtra/shinde-govt-begins-releasing-money-under-ladki-bahin-yojana-on-eve-of-independence-3152105"],["Lokniti-CSDS Maharashtra 2024 post-poll analysis, The Hindu, 25 Nov 2024 (Deshpande, ‘Women sided with Mahayuti for Ladki Bahin Yojana’s monthly dole’; Mishra, women as deciders) — page PDF held locally; thehindu.com unreachable from this container","https://www.lokniti.org/state-assembly-elections"]], domain: "literature" },
  { claim: "Schemes are cut once the election is won.", status: "contested", strongestCase: "Maharashtra: ₹2,100 promised, ₹3,000 floated, ₹1,500 paid, ₹500 for overlapping beneficiaries from April 2025; opposition alleges 92 lakh removals; MGNREGA BE fell 18% in 2023-24.", strongestCounter: "Jharkhand raised Maiya Samman from ₹1,000 to ₹2,500 (Oct 2024); Assam and West Bengal raised UCT allocations 31% and 15% in 2025-26; MP continued Ladli Behna two years after the poll; the Maharashtra cut targets double-payment, the base benefit continues, and the CM says it will; MGNREGA releases exceeded BE every year. Eligibility scrutiny is what a targeted scheme requires.", whatWouldChangeThis: "A cross-state tally of benefit levels 12 and 24 months after each launch election; the Maharashtra removal count with reasons.", srcs: [["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"],["Deccan Herald, 2024-10-14 — Jharkhand cabinet nod to hike women’s assistance to ₹30,000/yr from ₹12,000","https://www.deccanherald.com/india/jharkhand/jharkhand-cabinet-nod-to-hike-financial-assistance-for-women-to-rs-30000-per-year-from-rs-12000-3231863"],["ThePrint, 2026-08-19 — 92.10 lakh women removed from Maharashtra govt’s Ladki Bahin scheme, claims Congress leader (Vijay Wadettiwar)","https://theprint.in/india/92-10-lakh-women-removed-from-maharashtra-govts-ladki-bahin-scheme-claims-congress-leader/3019624/"],["ThePrint, 2026-08-14 — Govt fulfilled promises made during 2024 polls, will not discontinue Ladki Bahin: Fadnavis","https://theprint.in/india/govt-fulfilled-promises-made-during-2024-polls-will-not-discontinue-ladki-bahin-fadnavis/3015115/"],["PIB, Ministry of Rural Development — Clarifications on budget cut to MGNREGA, 2023-02-03 (Release ID 1896038)","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"]], domain: "literature" },
  { claim: "Central schemes are branded to the PM to buy loyalty.", status: "contested", strongestCase: "Deshpande, Tillin & Kailash (2019) show voters increasingly credit the Centre for welfare — even for Congress-era MGNREGA and Awas — and that Ujjwala/Jan Dhan beneficiaries leaned BJP; Aiyar (2019) titles the mechanism ‘leveraging welfare politics’; Sircar (2020) argues 2019 was mobilisation on ‘vishwas’ in the leader; Jaffrelot (2022) calls it populist welfarism.", strongestCounter: "Attribution to the Centre is documented; ‘to buy loyalty’ is a motive inference. States run their own branded schemes (Ladli Behna, Ladki Bahin, Gruha Lakshmi, Lakshmir Bhandar) with the same logic, so branding is generic to Indian federalism (Deshpande, Kailash & Tillin 2017; Tillin 2021) rather than a central innovation; PDS and pensions remain state-credited.", whatWouldChangeThis: "A study separating branding from delivery (same benefit, different label) on vote choice; NES 2024 replication.", srcs: [["Deshpande, Tillin & Kailash (2019) The BJP’s Welfare Schemes: Did They Make a Difference in the 2019 Elections? — Studies in Indian Politics 7(2):219–233 (Crossref metadata + abstract)","https://api.crossref.org/works/10.1177/2321023019874911"],["Aiyar (2019) Modi Consolidates Power: Leveraging Welfare Politics — Journal of Democracy 30(4):78–88 (Crossref metadata)","https://api.crossref.org/works/10.1353/jod.2019.0070"],["Sircar (2020) The politics of vishwas: political mobilization in the 2019 national election — Contemporary South Asia 28(2):178–194 (Crossref metadata; abstract page 403)","https://api.crossref.org/works/10.1080/09584935.2020.1765988"],["Jaffrelot (2022) Populist Welfarism in India: How Modi Relates to the Poor — Sciences Po Series, Springer, pp. 211–234 (Crossref metadata)","https://api.crossref.org/works/10.1007/978-3-030-84079-2_12"],["Deshpande, Kailash & Tillin (2017) States as laboratories: The politics of social welfare policies in India — India Review 16(1):85–105 (Crossref metadata)","https://api.crossref.org/works/10.1080/14736489.2017.1279928"],["Tillin (2021) Does India have subnational welfare regimes? — Territory, Politics, Governance 10(1):86–102 (Crossref metadata)","https://api.crossref.org/works/10.1080/21622671.2021.1928541"]], domain: "literature" },
  { claim: "Opposition states are starved of central funds for their schemes (MGNREGA in West Bengal).", status: "speculative", strongestCase: "The Centre's stoppage of MGNREGA funds to West Bengal under s.27 of the Act since 2021-22 and the Calcutta High Court's orders on it are widely reported; the PIB releases opened show national releases but are silent on Bengal; Deshpande et al find MGNREGA recipients lean away from the BJP.", strongestCounter: "This sweep opened no primary record of the stoppage (MoRD order, Calcutta HC order, Supreme Court stay) — thehindu.com, LiveLaw search and NITI were unreachable — so the narrative is filed as speculative for want of a document in this file, not because it is doubted. The Centre's stated ground is misuse under s.27, a legal mechanism, not a partisan one; other opposition states (Karnataka, Telangana) are not reported to have had funds stopped.", whatWouldChangeThis: "Opening the MoRD s.27 communication and the Calcutta High Court order(s); a comparison of s.27 actions across BJP and non-BJP states.", srcs: [["PIB, Ministry of Rural Development — Budget allocation under MGNREGA, Rajya Sabha written reply by MoS Kamlesh Paswan, 2025-07-25 (Release ID 2148475)","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"],["PIB, Ministry of Rural Development — Clarifications on budget cut to MGNREGA, 2023-02-03 (Release ID 1896038)","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038"],["LiveLaw search ‘MGNREGA West Bengal’ — no results rendered","https://www.livelaw.in/search?q=MGNREGA+West+Bengal"],["Deshpande, Tillin & Kailash (2019) The BJP’s Welfare Schemes: Did They Make a Difference in the 2019 Elections? — Studies in Indian Politics 7(2):219–233 (Crossref metadata + abstract)","https://api.crossref.org/works/10.1177/2321023019874911"]], domain: "literature" },
  { claim: "The freebies debate is a class attack on the poor.", status: "contested", strongestCase: "The ‘revdi’ framing and the RBI/PRS fiscal-risk framing target transfers to the poor while corporate tax cuts, bad-loan write-offs and PLI subsidies are not called freebies; Khera and Drèze document that ‘leakage’ rhetoric has been used to justify exclusion; Sinha's EPW budget analyses record stagnating nominal allocations for MGNREGA, PDS and midday meals; the Supreme Court's 2022 referral records parties arguing that welfare promises are policy, not bribery.", strongestCounter: "RBI and PRS frame the risk as revenue deficits crowding out capital spending that also serves the poor; the same bodies flag salaries, pensions and interest (53% of receipts) far above subsidies (9%); the PM's speech explicitly exempts houses, gas and toilets; a fiscal argument can be wrong without being a class attack. Jayati Ghosh's freebies writing, the anchor for this narrative, could not be located on EPW in this sweep.", whatWouldChangeThis: "A content analysis of which expenditures the RBI/ECI/SC discourse labels ‘freebies’ versus which it does not; locating Ghosh's texts.", srcs: [["PM’s address at inauguration of Bundelkhand Expressway, Jalaun, 16 Jul 2022 — official English rendering (pmindia.gov.in)","https://www.pmindia.gov.in/en/news_updates/pms-address-at-inauguration-of-bundelkhand-expressway-at-jalaun-in-uttar-pradesh/"],["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"],["Khera (2017) Impact of Aadhaar on Welfare Programmes — EPW 52(50), 16 Dec 2017 (EPW page opened)","https://www.epw.in/journal/2017/50/special-articles/impact-aadhaar-welfare-programmes.html"],["EPW author page — Dipa Sinha (lists Social Sector and Union Budget 2025–26; Social Sector Budget 2026; Sinha & Azad 2018 Can Jan Dhan Yojana Achieve Financial Inclusion?)","https://www.epw.in/author/dipa-sinha"],["Ashwini Kumar Upadhyay v Union of India, W.P.(C) 43/2022, SC order 2022-08-26 (reference to three-judge bench) — Indian Kanoon","https://indiankanoon.org/doc/82460936/"],["EPW author page — Jayati Ghosh (no cash-transfer or freebies article listed on the page opened)","https://www.epw.in/author/jayati-ghosh"]], domain: "literature" },
  { claim: "Farmer cash and loan waivers buy elections", status: "contested", strongestCase: "KALIA cash three months before the 2019 Odisha poll; Rythu Bandhu cheques seven months before 2018; Raje and Siddaramaiah both waived within a year of a poll; RBI's IWG says waivers cluster near elections; Congress won MP/CT/RJ 2018 on a waiver promise.", strongestCounter: "In this file 12 of 21 decided scheme-election pairs ended in the incumbent losing with the scheme live (AP 2024, TG 2023, OR 2024, CT 2023, RJ 2023, DL 2025, KL 2026, TN 2011, TN 2026); the two pre-poll waivers by incumbents (Raje 2018, Siddaramaiah 2017) both lost; challengers won on promises, not transfers; no opened Lokniti cross-tab isolates a beneficiary effect.", whatWouldChangeThis: "A post-poll survey cross-tab (beneficiary vs eligible non-beneficiary) with a vote gap ≥10 points in two states, or a regression-discontinuity on payment timing (e.g. KALIA batches Jan–May 2019 vs booth-level BJD swing).", srcs: [["CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)","https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"],["PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)","https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"],["Wikipedia infobox (pointer to ECI): 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2023 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"],["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"]], domain: "state-cash-other" },
  { claim: "The 2018 farm loan waivers were fiscally reckless and poorly targeted", status: "well-supported", strongestCase: "RBI IWG: Rs 2.4 lakh cr since 2014-15, only ~66% reached banks, credit culture damaged; Maharashtra 2017 left Rs 5,976 cr undelivered on its own page; Karnataka 2018 left 30,733 farmers unpaid five years on; UP's Rs 36,000 cr covered a third of farm debt.", strongestCounter: "Waivers responded to a real 2017–18 distress cycle (Shekhawati, Maharashtra strikes); official outturns (MH Rs 18,762 cr; MH 2019 Rs 20,497 cr) show money did reach tens of lakhs of accounts.", whatWouldChangeThis: "CAG state-level audits of the 2017–19 waivers (none opened this session).", srcs: [["PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)","https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"],["Dept of Co-operation, Marketing & Textiles, Maharashtra: Chhatrapati Shivaji Maharaj Shetkari Sanman Yojana 2017 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/chhatrapati-shivaji-maharaj-shetkari-sanman-yojana-2017/"],["Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"],["Deccan Herald, 7 Jan 2024: Karnataka farmers in quicksand as govt continues to borrow time over loan waiver","https://www.deccanherald.com/india/karnataka/karnataka-farmers-in-quicksand-as-govt-continues-to-borrow-time-over-loan-waiver-2838441"],["Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'","https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"]], domain: "state-cash-other" },
  { claim: "Karnataka's guarantees are unaffordable", status: "contested", strongestCase: "CAG (Aug 2025, Mar 2026): revenue surplus to deficit, Rs 71,525 cr borrowed in 2024-25, nutrition and rural development cut; PRS SOSF concurs on the revenue balance.", strongestCounter: "GIA chair: 98% delivered, Rs 94,177 cr transferred, GST and per-capita income up; the state chose revenue deficit financing openly and the guarantees are 16% of revenue expenditure, below Punjab's power-subsidy share of revenue receipts.", whatWouldChangeThis: "Two more years of CAG data on capital outlay and debt/GSDP versus the pre-2023 trend.", srcs: [["Deccan Herald, 26 Mar 2026: Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG","https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"],["Deccan Herald, 26 Aug 2025: CAG report's conclusions on welfare schemes in Karnataka incorrect: H M Revanna","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.13-14 and subsidy section (PDF)","https://prsindia.org/files/budget/SOSF_2025.pdf"]], domain: "state-cash-other" },
  { claim: "Tamil Nadu's free TVs enriched the Karunanidhi family's cable business", status: "speculative", strongestCase: "Jayalalithaa's 2006 and 2011 arithmetic; 16.4 million sets; cable connection was an eligibility condition; Sun TV is the dominant TN cable/broadcast group.", strongestCounter: "No audit, chargesheet or court finding; procurement ran through ELCOT with an all-party legislators' committee; the accuser herself was the defendant in the 1990s Colour TV case (acquitted); cable growth would follow any TV expansion.", whatWouldChangeThis: "ELCOT tender documents and cable-subscriber time series; the IndiaSpend bidder list.", srcs: [["IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?","https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"],["Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme","https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"],["Wikipedia (pointer): Colour TV case (1990s, J. Jayalalithaa)","https://en.wikipedia.org/wiki/Colour_TV_case"]], domain: "state-cash-other" },
  { claim: "Timing of Kerala's pension arrears payments was election-driven", status: "well-supported", strongestCase: "Two months' dues released three weeks before the Apr 2024 LS poll after five months of default; CPI(M) itself named the default as a cause of the 19–1 LS defeat; the five-instalment schedule was set to end in 2025-26, the pre-assembly fiscal year.", strongestCounter: "The CM's borrowing-limit account (KIIFB/KSSPL reclassification, divisible-pool cut) is on the record and partly corroborated by CAG/PRS notes on off-budget borrowing.", whatWouldChangeThis: "KSSPL monthly cash-flow and borrowing-window data showing releases tracked liquidity, not the calendar.", srcs: [["Deccan Herald, 8 Apr 2024: As polls approach, Kerala Left govt to pay pension dues","https://www.deccanherald.com/elections/kerala/as-polls-approach-kerala-left-govt-to-pay-pension-dues-2969893"],["Deccan Herald, 10 Jul 2024: Kerala's Pinarayi government signals course correction, announces time-bound settlement of welfare pension arrears","https://www.deccanherald.com/india/kerala/keralas-pinarayi-government-signals-course-correction-announces-time-bound-settlement-of-welfare-pension-arrears-3100393"],["Onmanorama, 20 Jan 2025: LDF govt pays second instalment of welfare pension arrears; three more to go","https://www.onmanorama.com/news/kerala/2025/01/20/ldf-government-pays-second-instalment-of-welfare-pension-arrears-three-more-to-go.html"]], domain: "state-cash-other" },
  { claim: "DBT has saved the exchequer ₹3.48 lakh crore.", status: "contested", strongestCase: "Aadhaar-seeding deleted 2.1 crore PM-KISAN entries and large PDS ghost lists; the subsidy share of spending fell from 16% to 9%.", strongestCounter: "The figure is a BlueKraft think-tank estimate of 'estimated gains' (deleted names × entitlement) released via PIB, not an audited recovery; the 16%→9% fall also reflects the post-2014 oil-price collapse and fertiliser/food policy changes.", whatWouldChangeThis: "A CAG audit of the dbtbharat 'estimated gains' methodology.", srcs: [["PIB (Ministry of Finance), 'India's DBT: Boosting Welfare Efficiency' — BlueKraft assessment, 21 Apr 2025","https://pib.gov.in/PressReleasePage.aspx?PRID=2123192"]], domain: "vendors" },
  { claim: "Cash-scheme publicity is party advertising at state expense.", status: "well-supported", strongestCase: "₹260 crore (MP) and ₹199.81 crore (Maharashtra) spent in the pre-poll window on CM-branded schemes; CAG found Delhi campaigns breached the SC's 2015 guidelines and the L-G ordered ~₹97 crore recovered.", strongestCounter: "Every government examined does it (base rate 5/5); awareness spending is a legitimate function; only Delhi has a formal finding of breach, and it is untabled.", whatWouldChangeThis: "Content Regulation Committee rulings on the MP and Maharashtra campaigns; vendor-wise release orders.", srcs: [["Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025","https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"],["Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024","https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"],["The Tribune, 'AAP govt violated ad campaign norms, spending rose by 1,200% in 5 yrs: CAG report', 27 Feb 2025","https://www.tribuneindia.com/news/india/aap-govt-violated-ad-campaign-norms-spending-rose-by-1200-in-5-yrs-cag-report/"],["Newslaundry, 'Modi govt spent Rs 910 crore on print ads in 5 years; Times of India biggest beneficiary' (Lok Sabha reply), 4 Aug 2026","https://www.newslaundry.com/2026/08/04/modi-govt-spent-rs-910-crore-on-print-ads-in-5-years-times-of-india-biggest-beneficiary"],["The News Minute, 'Telangana govt spent around Rs 300 cr on advertisement and publicity in 4 years' (RTI), 2020","https://www.thenewsminute.com/telangana/telangana-govt-spent-around-rs-300-cr-advertisement-and-publicity-4-years-137759"]], domain: "vendors" },
  { claim: "Free-bus schemes are a hidden subsidy to bus manufacturers.", status: "unsupported", strongestCase: "Shakti ridership up 35% forced fleet replacement; Ashok Leyland got an 820-bus order; Delhi signed 3,490 e-buses with three OEMs.", strongestCounter: "BMTC's fleet shrank from 6,888 to 6,158 in Shakti's first 15 months; the state is ₹5,172 crore in arrears to its own RTCs; the same three OEMs win in Congress-run Karnataka and AAP-run Delhi because they are the market.", whatWouldChangeThis: "Evidence of tender specifications tailored to one OEM or of above-market per-km rates.", srcs: [["Deccan Herald, 'BMTC launches 100 new diesel buses, to get 820 of them by March', 12 Sep 2024","https://www.deccanherald.com/india/karnataka/bengaluru/bmtc-launches-100-new-diesel-buses-to-get-820-of-them-by-march-3188420"],["ETV Bharat, 'Shakti scheme effect: male passengers drop; ₹5,172 crore reimbursement pending', 20 Jun 2026","https://www.etvbharat.com/en/bharat/shakti-scheme-effect-number-of-male-passengers-travelling-in-karnataka-govt-run-buses-drops-significantly-in-karnataka-enn26062003798"],["Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022","https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"],["EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023","https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"]], domain: "vendors" },
  { claim: "Business-correspondent networks profit from welfare delivery.", status: "established", strongestCase: "Fino booked ₹185 crore of AePS/micro-ATM revenue on ₹39,704 crore of cash-out in FY25; CSC SPV takes 0.5% capped at ₹15 per withdrawal; IPPB handled ₹45,000 crore.", strongestCounter: "These are disclosed service fees for last-mile cash-out that the state would otherwise have to provide; the one documented abuse (Airtel, ₹190 crore, 2017) was caught and reversed by UIDAI.", whatWouldChangeThis: "Evidence of undisclosed fee-sharing with officials or of systematic unauthorised debits at BC points.", srcs: [["Fino Payments Bank, Annual Report 2024-25","https://www.fino.bank.in/files/fino/media/post_attachments/sites/default/files/uploads/pages/financials/annual-report-2025.pdf"],["Moneylife, 'Is CSC e-Governance Services a govt entity or SPV or a Section 8 company?', 29 Jun 2018","https://www.moneylife.in/article/is-csc-egovernance-services-a-govt-entity-or-spv-or-a-section-8-company/54524.html"],["Free Press Journal, IPPB disbursed over ₹45,000 crore in DBT in 7 years (Scindia), 1 Sep 2024","https://www.freepressjournal.in/business/india-post-payments-bank-disbursed-over-45000-crore-in-dbt-in-last-7-years"],["The Wire, 'Aadhaar Mess: How Airtel Pulled Off Its Rs 190 Crore Magic Trick', 21 Dec 2017","https://m.thewire.in/article/banking/airtel-aadhaar-uidai"]], domain: "vendors" },
  { claim: "YSRCP's village volunteers were party machinery paid by the state.", status: "contested", strongestCase: "EC removed ~100 volunteers and barred all 2.56 lakh from pension distribution during the 2024 MCC on TDP/JSP complaints; ₹1,536 crore/yr of honoraria funded a network one per 50 households.", strongestCounter: "The system demonstrably delivered pensions door to door; EC action covered ~0.04% of volunteers; YSRCP denies political use and lost the election anyway (TDP +112).", whatWouldChangeThis: "EC's inquiry record; documented canvassing cases beyond the ~100.", srcs: [["ThePrint, ''YSRCP agents' — why Jagan's grassroots 'welfare volunteers' have come under EC radar', 5 Apr 2024","https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/"],["Wikipedia (pointer), 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"]], domain: "vendors" },
  { claim: "The BJP's labharthi (beneficiary) outreach machinery converts scheme lists into voter lists.", status: "speculative", strongestCase: "Lokniti 2019 shows a 7-point NDA premium among PM-KISAN/Ujjwala/Jan Dhan households and credit shifting to the Centre.", strongestCounter: "No source opened here documents the party's access to government beneficiary data or PM letters to beneficiaries; the vote premium is cross-sectional and consistent with selection.", whatWouldChangeThis: "Documentation of beneficiary-list sharing between ministries and the party, or the text/distribution of PM letters.", srcs: [["Seminar #720, Jyoti Mishra & Vibha Attri (Lokniti-CSDS), 'Did welfare win votes?' (NES 2019 post-poll), 2019","https://india-seminar.com/2019/720/720_jyoti_and_vibha.htm"]], domain: "vendors" },
  { claim: "Ladli Behna won Madhya Pradesh 2023 for the BJP", status: "contested", strongestCase: "Launched 5 months before the poll, raised to Rs 1,250 weeks before, last instalment a week before voting; BJP vote share +7.6 pts and women's support reportedly 43%→50%; press and ISAS analysts credit the scheme", strongestCounter: "Lokniti-CSDS: 80.4% of households benefited — a non-discriminating property under this project's base-rate rule; Congress promised more (Rs 1,500) and lost; PM rallies, 'double engine' and organisation are co-explanations", whatWouldChangeThis: "A published Lokniti cross-tab of vote by beneficiary status, or a constituency-level swing gradient by coverage", srcs: [["Lokniti-CSDS, Madhya Pradesh Post-poll Survey 2023 — survey findings (PDF)","https://www.lokniti.org/media/PDF-upload/1703684877_6052900_download_report.pdf"],["Deccan Herald, 3 Dec 2023: What worked for BJP in MP","https://www.deccanherald.com/india/madhya-pradesh/focus-on-women-voters-to-pm-modis-magic-what-worked-for-bjp-in-madhya-pradesh-assembly-elections-2794883"],["Deccan Herald, 5 Mar 2023: Kamal Nath promises women Rs 18,000/yr ahead of Ladli Behna launch","https://www.deccanherald.com/national/ahead-of-mp-govts-ladli-behna-scheme-launch-kamal-nath-promises-women-rs-18000-per-year-1197406.html"]], domain: "women-cash" },
  { claim: "Ladki Bahin decided Maharashtra 2024", status: "contested", strongestCase: "Launched 3 months before the poll after an LS rout; 54% of applicant women vs 43% of non-applicants backed Mahayuti; Rs 250 cr advertising; a BJP MLA called it a 'jugaad' for votes", strongestCounter: "Lokniti-CSDS authors: 3-point gender gap, 'hardly any connection between welfare and vote', Hindu-unity appeal and Maratha–OBC consolidation matter more; the Bombay HC found it lawful policy", whatWouldChangeThis: "Regression of constituency swing on beneficiary share", srcs: [["BehanBox, 4 Dec 2024: Maharashtra poll analyses and women's agency (cites Lokniti-CSDS post-poll)","https://behanbox.com/2024/12/04/how-maharashtra-poll-analyses-are-missing-the-rise-of-womens-agency/"],["Deccan Herald/PTI, 25 Sep 2024: BJP MLA Tekchand Sawarkar calls Ladki Bahin a 'jugaad' for women's votes","https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ladki-bahin-a-jugaad-to-get-womens-votes-says-bjp-mla-tekchand-sawarkar-3206053"],["Deccan Herald, 5 Aug 2024: Bombay HC dismisses PIL against Ladki Bahin","https://www.deccanherald.com/india/maharashtra/ladki-bahin-yojana-a-beneficiary-scheme-for-women-not-discriminatory-bombay-high-court-3137089"]], domain: "women-cash" },
  { claim: "Cash transfers to women guarantee re-election", status: "debunked", strongestCase: "MP, MH, JH, AS, BR incumbents all won after in-window launches/hikes (5 of 7)", strongestCounter: "West Bengal 2026 (hike 11 weeks before polling; TMC 215→80), Tamil Nadu 2026 (31-month-old scheme; DMK lost), Rajasthan 2023 (incumbent promise, lost), Delhi 2025 (approved-not-paid, lost) — the property is neither necessary nor sufficient", whatWouldChangeThis: "—", srcs: [["Wikipedia (pointer): 2026 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2026_West_Bengal_Legislative_Assembly_election"],["Wikipedia (pointer): 2026 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2023 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2025 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"]], domain: "women-cash" },
  { claim: "Women's cash schemes are fiscally unsustainable and are being quietly cut", status: "well-supported", strongestCase: "PRS: 6 of 12 states in revenue deficit; KA surplus→deficit; MH cut (Apr 2025) and 92 lakh removals; MP surplus halved; HP paid Rs 11.64 cr of a Rs 138 cr BE; RBI 2024 warning; Business Standard 'splurge to squeeze' (Jun 2026)", strongestCounter: "Karnataka's Guarantee Authority: GST and per-capita income rose; aggregate cost is 0.5% of GDP; removals target ineligible recipients (targeting error), not the entitled", whatWouldChangeThis: "CAG performance audits quantifying leakage vs entitlement", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["Scroll, 16 Apr 2025: Maharashtra cuts Ladki Bahin payout for 8 lakh women to Rs 500","https://scroll.in/latest/1081399/maharashtra-cuts-ladki-bahin-yojana-payout-for-8-lakh-women-to-rs-500-per-month-report"],["Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification","https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"],["Deccan Herald, 26 Aug 2025: H M Revanna rejects CAG conclusions on Karnataka guarantee schemes","https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866"],["ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals","https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"]], domain: "women-cash" },
  { claim: "The BJP opposes 'revadi' freebies", status: "unsupported", strongestCase: "PM's 16 Jul 2022 speech", strongestCounter: "7 of the 12 UCTs in PRS's table are run by BJP or BJP-led governments; the PM personally launched Subhadra, Mahtari Vandan and Bihar MMRY", whatWouldChangeThis: "—", srcs: [["The Tribune/PTI, 16 Jul 2022: PM Modi warns against 'revadi culture' at Jalaun","https://www.tribuneindia.com/news/uncategorized/revadi-culture-dangerous-for-development-of-country-says-pm-modi-urges-youth-to-guard-against-it-413011/"],["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"],["PIB, 17 Sep 2024: PM launches SUBHADRA in Bhubaneswar","https://www.pib.gov.in/PressReleseDetailm.aspx?PRID=2055572&reg=3&lang=2"],["PIB, 10 Mar 2024: PM launches Mahtari Vandan Yojana; first instalment Rs 655 cr","https://pib.gov.in/PressReleasePage.aspx?PRID=2013167"],["PIB, 25 Sep 2025: PM to launch Bihar Mukhyamantri Mahila Rojgar Yojana; Rs 7,500 cr to 75 lakh women","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2171342&reg=48&lang=2"]], domain: "women-cash" },
];

export const WELFARE_BASE_RATES: BaseRateRow[] = [
  { property: "central scheme launched or materially expanded within 12 months before a Lok Sabha general election", numerator: 8, denominator: 15, label: "15 launch/expansion events in this file: UPA (NREGA 2006 no; ADWDRS Feb 2008 completion Jun 2008 yes; NFSA 2013 yes) = 2/3; NDA (PMJDY 2014 no; PMUY 2016 no; PMAY-G 2016 no; PM-KISAN 2019 yes; PMGKAY 2020 no; PMGKAY 5-yr Nov 2023 yes; PMUY ₹300 Oct 2023 yes; Vishwakarma Sep 2023 yes; Drone Didi Nov 2023 yes; Lakhpati Didi Feb 2024 yes; MSSC Apr 2023 borderline-no at 12.6 months; NSAP raise never) = 6/12. Under a 5-year cycle a random month is within 12 months of a general election ~20% of the time; observed 53% — moderate signal, present in both coalitions", srcs: [["Interim Budget 2019-20 speech, Piyush Goyal, 1 Feb 2019 (paras 25-27, 81)","https://www.indiabudget.gov.in/budget2019-20(I)/ub2019-20/bs/bs.pdf"],["Union Budget 2008-09 speech, P. Chidambaram, 29 Feb 2008 (para 73: debt waiver and debt relief)","https://www.indiabudget.gov.in/budget_archive/ub2008-09/bs/speecha.htm"],["Wikipedia (pointer), National Food Security Act 2013","https://en.wikipedia.org/wiki/National_Food_Security_Act,_2013"],["PIB, Free foodgrains for 81.35 crore beneficiaries for five years: Cabinet decision, 29 Nov 2023","https://www.pib.gov.in/PressReleasePage.aspx?PRID=1980686"],["PIB, Cabinet approves continuation of ₹300 PMUY subsidy for FY 2024-25, 7 Mar 2024","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2012354"],["PIB Research Unit backgrounder 'PM Vishwakarma Scheme: Honouring Heritage, Powering Progress', 16 Sep 2025 (PDF on file; exact document URL not recovered — see gaps)","https://www.pib.gov.in/"],["PIB, Cabinet approves Central Sector Scheme for providing drones to women SHGs (₹1,261 crore), 29 Nov 2023","https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=1980683"],["PIB, Interim Budget 2024-25: Lakhpati Didi target 2 cr → 3 cr, 1 Feb 2024","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2001109"],["Akashvani News, over 14.83 lakh MSSC accounts opened, MoS Finance in LS, 31 Jul 2023","https://www.newsonair.gov.in/over-14-83-lakh-accounts-opened-under-mahila-samman-savings-certificate-scheme-govt-in-ls"],["Wikipedia (pointer), Pradhan Mantri Jan Dhan Yojana","https://en.wikipedia.org/wiki/Pradhan_Mantri_Jan_Dhan_Yojana"],["Wikipedia (pointer), Pradhan Mantri Ujjwala Yojana","https://en.wikipedia.org/wiki/Pradhan_Mantri_Ujjwala_Yojana"],["PIB (MoRD), PMAY-G progress and Cabinet approval of 2 crore more houses, 7 Feb 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2100659"]], domain: "central" },
  { property: "incumbent won the general election following a pre-poll (≤12 months) scheme event", numerator: 2, denominator: 3, label: "ADWDRS→2009 won; NFSA→2014 lost; PM-KISAN→2019 won (the 2023-24 cluster→2024: NDA retained office but BJP −63, coded as won). Too few cases to discriminate; recorded as a denominator, not a finding", srcs: [["Wikipedia (pointer), 2009 Indian general election","https://en.wikipedia.org/wiki/2009_Indian_general_election"],["Wikipedia (pointer), 2014 Indian general election","https://en.wikipedia.org/wiki/2014_Indian_general_election"],["Wikipedia (pointer), 2019 Indian general election","https://en.wikipedia.org/wiki/2019_Indian_general_election"],["Wikipedia (pointer), 2024 Indian general election","https://en.wikipedia.org/wiki/2024_Indian_general_election"]], domain: "central" },
  { property: "scheme cut, tightened or discontinued after the election that followed its launch/expansion", numerator: 5, denominator: 13, label: "MGNREGA (BE cut 2023, freeze 2025, repeal 2025-26); PMUY (refill cap 12→9, 2025); PM-KISAN (e-KYC gates stopped benefits; per-instalment payees ~9.3 cr vs 11 cr ever-reached); MSSC (window closed 2025 as designed); NSAP (never raised). Not cut: NFSA, PMGKAY, PMJDY, PMAY-G, Vishwakarma, Lakhpati, Drone Didi, ADWDRS (one-off)", srcs: [["PIB (MoRD RS reply), Budget allocation under MGNREGA 2020-21 to 2024-25, 25 Jul 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475"],["PIB Backgrounder, Viksit Bharat-G RAM G Act 2025 FAQ, 11 May 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2259712"],["PIB, Cabinet approves PMUY targeted subsidy FY 2025-26 (₹300, up to 9 refills), 8 Aug 2025","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2154117"],["Lok Sabha Unstarred Q.358 (MoS Agri Ramnath Thakur), discrepancy in PM-KISAN: ₹416.75 cr recovered from ineligible beneficiaries, 2 Dec 2025","https://sansad.in/getFile/loksabhaquestions/annex/186/AU358_FPeZsZ.pdf?source=pqals"],["PIB Backgrounder, 22nd instalment of PM-KISAN (Guwahati, 13 Mar 2026), 19 Mar 2026","https://www.pib.gov.in/PressReleasePage.aspx?PRID=2242295"],["Akashvani News, over 14.83 lakh MSSC accounts opened, MoS Finance in LS, 31 Jul 2023","https://www.newsonair.gov.in/over-14-83-lakh-accounts-opened-under-mahila-samman-savings-certificate-scheme-govt-in-ls"],["PIB Backgrounder, National Social Assistance Programme, 7 Nov 2025","https://www.pib.gov.in/PressNoteDetails.aspx?NoteId=155928&ModuleId=3"]], domain: "central" },
  { property: "households reporting a benefit from the scheme in the 5 years to 2024 (Lokniti-CSDS post-poll, N=19,663)", numerator: 13261, denominator: 19663, label: "PDS 67.4%; Ujjwala 45.0%; MGNREGA 33.7%; Ayushman 29.6%; Awas 25.3%; PM-KISAN 53.7% of farm households asked. Credit to Centre: Ujjwala 68.3%, Awas 63.9%, MGNREGA 63.5%, PDS 54.7%. 49.7% of beneficiaries found access 'difficult' or 'very difficult'", srcs: [["Lokniti-CSDS, Social and Political Barometer Post-poll Study 2024 — Survey Findings (PDF on file, dated 14 Jun 2024; exact URL not recovered — see gaps)","https://www.lokniti.org/"]], domain: "central" },
  { property: "cash/DBT scheme launched within 6 months before the next election", numerator: 8, denominator: 26, label: "the 26 state/central cash-transfer, loan-waiver and free-goods scheme launches in this file that have a determinable next-election date (excludes 2 schemes whose next election has not yet been held or whose promise was never launched: KA Gruha Lakshmi, Odisha Subhadra, HP OPS, Punjab free power are counted at their actual, distant next-election gap, not excluded, since a determinable date exists — the true exclusions are TG Mahalakshmi and the Delhi 2025 AAP/BJP cash promises, which were never launched at all)", srcs: [], domain: "elections-timing" },
  { property: "cash/DBT scheme launched within 12 months before the next election", numerator: 12, denominator: 26, label: "same 26-launch set as above", srcs: [], domain: "elections-timing" },
  { property: "BJP-government scheme launches within 6 months of the next election", numerator: 4, denominator: 7, label: "PM-KISAN, PMGKAY(orig.), Ujjwala, MP Ladli Behna, MP Ladli Laxmi, Assam Orunodoi, Maharashtra Ladki Bahin — n is small", srcs: [], domain: "elections-timing" },
  { property: "INC-government scheme launches within 6 months of the next election", numerator: 0, denominator: 6, label: "MGNREGA, 2008 loan waiver, Chhattisgarh 2018 loan waiver, Karnataka Gruha Lakshmi, Rajasthan Mehangai Rahat, HP OPS — n is small; INC's launches in this file cluster in the 7-12 month band or are post-election deliveries, not the 0-6 month band", srcs: [], domain: "elections-timing" },
  { property: "AAP-government scheme launches within 6 months of the next election", numerator: 1, denominator: 2, label: "Delhi 200-unit free power (~6 months), Punjab free power (post-election delivery, ~55 months) — n=2, not meaningful on its own", srcs: [], domain: "elections-timing" },
  { property: "incumbent win rate when this file's tracked scheme was launched within 6 months of the election", numerator: 8, denominator: 8, label: "PM-KISAN/LS2019, MP Ladli Behna/MP2023, Assam Orunodoi/Assam2021, Odisha KALIA/Odisha2019, Jharkhand Maiya Samman/JH2024, Maharashtra Ladki Bahin/MH2024, Bihar Mahila Rozgar/Bihar2025, Delhi free-power-200-units/Delhi2020 — n=8 is small, and the set itself was partly assembled from schemes prominent in political discourse, which already skews toward cases people talk about because they coincided with a win; this number should not be read as a discovered law", srcs: [], domain: "elections-timing" },
  { property: "incumbent win rate when this file's tracked scheme was launched more than 6 months before the election (or delivered only after it)", numerator: 8, denominator: 14, label: "PMGKAY(orig.)/Bihar2020, MGNREGA/LS2009, Ujjwala/LS2019, 2008 loan waiver/LS2009, Ladli Laxmi/MP2008, Chhattisgarh loan waiver/CT2023 (loss), Rythu Bandhu/TG2018, AP Rythu Bharosa/AP2024 (loss), AP Amma Vodi/AP2024 (loss), WB Lakshmir Bhandar/WB2026 (loss, by launch-date method), WB Kanyashree/WB2016, TN Kalaignar/TN2026 (loss), TN Amma Canteen/TN2016, Rajasthan Mehangai Rahat/RJ2023 (loss) — 57% win rate, close to this dataset's overall 73% (see next row), i.e. the 0-6-month subset's 100% is not dramatically different once the small n and the dataset's general incumbency skew are accounted for", srcs: [], domain: "elections-timing" },
  { property: "overall incumbent win rate across every scheme-election pair in this file with a decided result, regardless of scheme timing", numerator: 16, denominator: 22, label: "the union of the two rows above; useful as this file's own baseline before asking whether scheme timing adds anything on top of it", srcs: [], domain: "elections-timing" },
  { property: "incumbent re-election rate in Rajasthan, Himachal Pradesh and Punjab assembly elections 2000-2026, regardless of any welfare scheme", numerator: 1, denominator: 15, label: "5 Rajasthan + 5 Himachal Pradesh + 5 Punjab elections in this file's elections array; only Punjab 2012 returned the incumbent (SAD-BJP). This structural anti-incumbency, present across three different ruling parties and unrelated to any single scheme, is large enough on its own to be a stronger candidate explanation than scheme timing for the Rajasthan 2023 and Himachal Pradesh 2022/2023 results discussed in this file.", srcs: [], domain: "elections-timing" },
  { property: "share of states/UTs-with-legislature with a live, largely unconditional monthly cash transfer to women, by fiscal year", numerator: 12, denominator: 31, label: "31 = 28 states + Delhi, J&K, Puducherry (PRS's coverage). Rates: 0%, 0%, 3.2%, 6.5%, 6.5%, 19.4%, 29.0%, 38.7%. Definition follows PRS (monthly, largely unconditional, women-targeted): excludes one-off grants (Bihar MMRY ₹10,000), child-linked transfers (AP Talliki Vandanam) and Goa's older homemaker allowance, which PRS does not list and this sweep did not verify. Launch FYs from women-cash.json / elections-timing.json; 2022-23 and 2025-26 checked against PRS. 2026-27 not computed (post-election changes in WB, TN, AS unverified). This is a state count, not a share of women covered.", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"]], domain: "fiscal-results" },
  { property: "women's UCT spending as % of revenue expenditure, 2025-26 BE", numerator: 168040, denominator: null, label: "12 implementing states: ~6% of their revenue expenditure (PRS Fig 15 title). Per state: JH 12.1, KA 9.2, WB 8.9, DL 7.1, MP 6.4, MH 5.9, OD 5.1, AS 4.3, CG 4.0, TN 3.7, HR 3.4, HP 0.3. All states: 0.47% of GDP (PRS) ÷ all-state revenue expenditure 14.6% of GDP (RBI 2025-26) ≈ 3.2% — an analytic cross-source ratio (PRS and RBI GDP denominators may differ slightly).", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"],["RBI, State Finances: A Study of Budgets of 2025-26 (23 Jan 2026), Chapter II 'Fiscal Position of the State Governments'","https://www.rbi.org.in/Scripts/PublicationsView.aspx?id=23692"]], domain: "fiscal-results" },
  { property: "fleet scheme launches within 12 months BEFORE the next election vs the uniform-launch null", numerator: 14, denominator: 34, label: "34 = every scheme across research/raw/welfare/*.json (central, elections-timing, literature, vendors, women-cash; read 25 Sep 2026) with a determinable ISO/month launch date and an election cycle in elections-timing.json (90 elections); duplicates collapsed (ujjwala=pm-ujjwala, br-mahila-rozgar-yojana=br-mukhyamantri-mahila-rozgar, pmgkay-free-grain=pmgkay); excluded NSAP (1995), DBT/APBS and AP Smartcards (infrastructure), promised-not-enacted items, Haryana (no Haryana election in the elections file). Schemes launched in the current term with the next poll >12 months away are counted at the scheduled date (prev+60 months). Null: each launch uniform within its own inter-election cycle (p≈12/cycle ≈0.20); 200,000 Monte Carlo draws.", srcs: [], domain: "fiscal-results" },
  { property: "fleet scheme launches within 12 months AFTER the previous election (post-poll delivery) vs the same null", numerator: 9, denominator: 34, label: "Same 34. Includes Karnataka Gruha Lakshmi and Shakti, HP OPS, Chhattisgarh loan waiver (INC), CT Mahtari Vandan and Odisha Subhadra (BJP), PMJDY and PMGKAY (NDA). Not significantly above null: post-poll delivery of manifesto promises is common but not concentrated.", srcs: [], domain: "fiscal-results" },
  { property: "pre-poll (≤12 months) launch rate by governing party", numerator: 7, denominator: 15, label: "BJP/NDA-led: PM-KISAN, PM Vishwakarma, Namo Drone Didi, MP Ladli Behna, Assam Orunodoi, MH Ladki Bahin, Bihar MMRY (JD(U)–BJP). Non-BJP: NFSA, 2008 loan waiver (UPA), Rythu Bandhu (BRS), KALIA (BJD), Maiyan Samman (JMM), Mehangai Rahat and smartphones (INC Rajasthan). 47% vs 37%, no detectable difference.", srcs: [], domain: "fiscal-results" },
  { property: "family of comparisons in this file's timing analysis, raw vs Benjamini–Hochberg (q=0.05)", numerator: 2, denominator: 12, label: "12 one-sided tests (6 subsets × before/after). Raw p<0.05: 4 (all-schemes before 0.0038; cash categories before 0.0069; BJP-led before 0.018; state-only before 0.028; women-cash before 0.051 is borderline). After BH: 2 survive (all-schemes before; cash-categories before). Party-specific and women-only results do not survive. Subsets overlap (not independent).", srcs: [], domain: "fiscal-results" },
  { property: "incumbent win rate: tracked scheme launched ≤6 months before poll vs otherwise (sibling elections-timing.json figures, re-tested)", numerator: 8, denominator: 8, label: "Fisher exact two-sided p=0.051 on the sibling's 2×2 — not significant even before correcting for the several splits that file reports; n is small and the list is salience-selected.", srcs: [], domain: "fiscal-results" },
  { property: "party of government among the 12 states with women's UCTs, 2025-26", numerator: 7, denominator: 12, label: "BJP/NDA 7 (AS, CT, DL, HR, MH, MP, OD) = ₹85,424 cr of ₹1,68,040 cr (50.8%); INC 2 (KA, HP) = ₹28,746 cr; JMM 1 (JH) ₹13,363 cr; DMK 1 (TN) ₹13,807 cr; TMC 1 (WB) ₹26,700 cr. Base-rate context: the BJP/NDA governed roughly half the states in 2025-26 — this share is about what incumbency alone predicts.", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"]], domain: "fiscal-results" },
  { property: "states whose 2022-23 'freebies' ≥1.5% of GSDP in RBI's Jun 2022 table", numerator: 4, denominator: 9, label: "Punjab (AAP) 2.7, AP (YSRCP) 2.1, Jharkhand (JMM) 1.7, MP (BJP) 1.6. Only the 9 indebted states RBI analysed are in the denominator, not all 28 — no claim about unlisted states.", srcs: [["RBI Bulletin June 2022, 'State Finances: A Risk Analysis' (Mukherjee, Behera, Sharma, Seth, Agarwal, Solanki, Khandelwal; DEPR) — Table 5 and Annex 1 (copy hosted by SCO; rbidocs.rbi.org.in returns a CAPTCHA)","https://www.scobserver.in/wp-content/uploads/2022/08/6STATEFINANCESARISKANALYSIS143105EB27A744E1B9C404CF7D96909A.pdf"]], domain: "fiscal-results" },
  { property: "off-budget borrowing concentration", numerator: 35258, denominator: 67075, label: "Telangana = 52.6% of 19 states' declared off-budget borrowing in 2021-22 (BRS). 2024-25: Maharashtra ₹13,990 cr of ₹24,955 cr = 56.1% (Mahayuti). Karnataka ₹5,438 cr (INC). Source: Lok Sabha USQ 4004 (18 Aug 2025) as tabulated by PRS. Self-declared by states; some states do not disclose.", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"]], domain: "fiscal-results" },
  { property: "state subsidies as share of revenue receipts, 2023-24", numerator: 9, denominator: 100, label: "9% of all-state revenue receipts went to subsidies (PRS); 53% went to salaries, pensions and interest. Nine states spend >10%; Punjab 21%, TN 14%, Rajasthan 14%, Karnataka 14%, Gujarat 13%. Power is 53% of subsidy spending in 19 states. Women's UCTs are a newer, smaller layer on top of an older power-subsidy base.", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section","https://prsindia.org/files/budget/SOSF_2025.pdf"]], domain: "fiscal-results" },
  { property: "International causal or quasi-experimental studies of cash transfers and incumbent vote in this file that find a positive incumbent effect", numerator: 5, denominator: 6, label: "Manacorda et al 2011 (Uruguay), De La O 2013 (Mexico), Zucco 2013 (Brazil), Labonne 2013 (Philippines), Hunter & Power 2007 (Brazil, observational) find effects; Imai, King & Velasco Rivera 2020 re-analyse Progresa and find none. Publication bias and Imai et al's null mean the 5/6 overstates the settled effect.", srcs: [["Manacorda, Miguel & Vigorito (2011) Government Transfers and Political Support — AEJ: Applied 3(3):1–28 (Crossref metadata)","https://api.crossref.org/works/10.1257/app.3.3.1"],["De La O (2013) Do Conditional Cash Transfers Affect Electoral Behavior? Evidence from a Randomized Experiment in Mexico — AJPS 57(1):1–14 (Crossref metadata)","https://api.crossref.org/works/10.1111/j.1540-5907.2012.00617.x"],["Zucco (2013) When Payouts Pay Off: Conditional Cash Transfers and Voting Behavior in Brazil 2002–10 — AJPS 57(4):810–822 (Crossref metadata)","https://api.crossref.org/works/10.1111/ajps.12026"],["Labonne (2013) The local electoral impacts of conditional cash transfers — Journal of Development Economics 104:73–88 (Crossref metadata)","https://api.crossref.org/works/10.1016/j.jdeveco.2013.04.006"],["Hunter & Power (2007) Rewarding Lula: Executive Power, Social Policy, and the Brazilian Elections of 2006 — Latin American Politics and Society 49(1):1–30 (Crossref metadata)","https://api.crossref.org/works/10.1111/j.1548-2456.2007.tb00372.x"],["Imai, King & Velasco Rivera (2020) Do Nonpartisan Programmatic Policies Have Partisan Electoral Effects? Evidence from Two Large-Scale Experiments — Journal of Politics 82(2):714–730 (Crossref metadata)","https://api.crossref.org/works/10.1086/707059"]], domain: "literature" },
  { property: "Indian cash or distribution schemes in this file with an experimental or quasi-experimental estimate of their effect on votes", numerator: 0, denominator: 8, label: "All eight schemes in this file; the Indian causal literature evaluates delivery (leakage, exclusion, enrolment), not votes — the central void.", srcs: [["Deshpande, Tillin & Kailash (2019) The BJP’s Welfare Schemes: Did They Make a Difference in the 2019 Elections? — Studies in Indian Politics 7(2):219–233 (Crossref metadata + abstract)","https://api.crossref.org/works/10.1177/2321023019874911"],["Muralidharan, Niehaus & Sukhtankar (2016) Building State Capacity: Evidence from Biometric Smartcards in India — AER 106(10):2895–2929 (Crossref metadata)","https://api.crossref.org/works/10.1257/aer.20141346"],["Muralidharan & Prakash (2017) Cycling to School: Increasing Secondary School Enrollment for Girls in India — AEJ: Applied 9(3):321–350 (Crossref metadata)","https://api.crossref.org/works/10.1257/app.20160004"],["Lokniti-CSDS — Madhya Pradesh Postpoll Survey 2023: Survey Findings (N=3,050, 18–24 Nov 2023; PDF held locally; Lokniti state-election index page opened)","https://www.lokniti.org/state-assembly-elections"]], domain: "literature" },
  { property: "States/UTs analysed by PRS that run a largely unconditional women's cash transfer in 2025-26", numerator: 12, denominator: 31, label: "PRS State of State Finances 2025 (28 states plus Delhi, J&K and Puducherry). Up from 2 in 2022-23. The practice spans BJP, INC, TMC, AAP, JMM, DMK and BJD-era governments — non-discriminating between parties.", srcs: [["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"]], domain: "literature" },
  { property: "UCT-implementing states projecting a revenue deficit in 2025-26", numerator: 6, denominator: 12, label: "PRS 2025; ‘bankrupting’ is not the right word for half the implementers being in revenue deficit, but the direction is documented.", srcs: [["PRS Legislative Research — State of State Finances 2025 (Shrusti Singh, Oct 2025), section ‘Unconditional cash transfers for women have led to fiscal pressure’ (PDF held locally; PRS listing page returned HTTP 500)","https://prsindia.org/policy/analytical-reports"]], domain: "literature" },
  { property: "Post-poll surveys in this file with a published gender breakdown in which the winning side led among women", numerator: 1, denominator: 1, label: "Maharashtra 2024 (Mahayuti +3 among women vs men). The MP 2023 findings PDF as read has no gender × vote table, so it is excluded from the denominator rather than assumed.", srcs: [["Lokniti-CSDS Maharashtra 2024 post-poll analysis, The Hindu, 25 Nov 2024 (Deshpande, ‘Women sided with Mahayuti for Ladki Bahin Yojana’s monthly dole’; Mishra, women as deciders) — page PDF held locally; thehindu.com unreachable from this container","https://www.lokniti.org/state-assembly-elections"],["Lokniti-CSDS — Madhya Pradesh Postpoll Survey 2023: Survey Findings (N=3,050, 18–24 Nov 2023; PDF held locally; Lokniti state-election index page opened)","https://www.lokniti.org/state-assembly-elections"]], domain: "literature" },
  { property: "MP 2023 post-poll respondents reporting a Ladli Behna beneficiary in the household", numerator: 2454, denominator: 3050, label: "Lokniti-CSDS Q22; 80.4%. A property held by four in five households cannot discriminate voters.", srcs: [["Lokniti-CSDS — Madhya Pradesh Postpoll Survey 2023: Survey Findings (N=3,050, 18–24 Nov 2023; PDF held locally; Lokniti state-election index page opened)","https://www.lokniti.org/state-assembly-elections"]], domain: "literature" },
  { property: "launch or first payment within 12 months BEFORE the next assembly/LS election (incumbent's own scheme)", numerator: 7, denominator: 18, label: "18 incumbent-launched schemes/hikes in this file with a dated launch and a dated next poll: yes = Rythu Bandhu (7 mo), KALIA (3), Delhi 200 units (6), Raje Rs 50,000 waiver (10), Siddaramaiah Rs 50,000 waiver 2017 (11), Kanyashree universalisation (2 mo to LS 2019), Kanya Sumangala budget (2 mo to LS 2019); no = Aasara, RGKNY, Amma Vodi, Pension Kanuka, cheap rice, Chiranjeevi, TV (55), mixie, bus (59), cycle (50), Ladli Laxmi (19)", srcs: [["Wikipedia (pointer): Rythu Bandhu scheme","https://en.wikipedia.org/wiki/Rythu_Bandhu_scheme"],["CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)","https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"],["Business Today, 1 Aug 2019: Kejriwal announces free electricity up to 200 units","https://www.businesstoday.in/latest/economy-politics/story/arvind-kejriwal-free-electricity-up-to-200-units-delhi-from-august-220915-2019-08-01"],["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"],["Deccan Herald, 7 Jan 2024: Karnataka farmers in quicksand as govt continues to borrow time over loan waiver","https://www.deccanherald.com/india/karnataka/karnataka-farmers-in-quicksand-as-govt-continues-to-borrow-time-over-loan-waiver-2838441"],["PRS, West Bengal Budget Analysis 2019-20","https://prsindia.org/budgets/states/west-bengal-budget-analysis-2019-20"],["PRS, Uttar Pradesh Budget Analysis 2019-20","https://prsindia.org/budgets/states/uttar-pradesh-budget-analysis-2019-20"]], domain: "state-cash-other" },
  { property: "post-poll delivery of a manifesto promise within 6 months of a new government taking office", numerator: 12, denominator: 12, label: "all 12 challenger-promised schemes in this file were delivered within 6 months: UP 2017 (17 days), PB 2017 (3 mo), KA 2018 (6 wks), MP/CT/RJ Dec 2018 (0–2 days), MH 2019 (1 mo), TN TV 2006 (4 mo), TN mixie 2011 (4 mo), TN bus 2021 (day 1), KA guarantees 2023 (1–8 mo, 4 of 5 within 3), PB power 2022 (4.5 mo), TG waiver 2024 (7.5 mo — the one outside 6 months)", srcs: [["Deccan Herald/PTI, 4 Apr 2017: Congress calls UP govt's Rs 36,000 cr farm loan waiver an 'unfulfilled promise'","https://www.deccanherald.com/india/up-govts-farm-loan-waiver-1998537"],["Business Standard, 19 Jun 2017: Punjab CM Amarinder Singh announces crop loan waiver for 10.25 lakh farmers","https://www.business-standard.com/article/economy-policy/punjab-cm-amarinder-singh-announces-crop-loan-waiver-for-10-25-lakh-farmers-117061901226_1.html"],["The Tribune/IANS, 5 Jul 2018: Karnataka waives Rs 34,000 cr farm loans","https://www.tribuneindia.com/news/archive/nation/karnataka-waives-rs-34-000-cr-farm-loans-615599"],["Deccan Herald, 20 Dec 2018: Gehlot waives farm loans (Rs 8,000 cr burden; Raje's Rs 50,000 pre-poll waiver)","https://www.deccanherald.com/india/gehlot-waives-farm-loans-709021.html"],["Dept of Co-operation, Marketing & Textiles, Maharashtra: Mahatma Jyotirao Phule Shetkari Karjamukti Yojana 2019 (official scheme page)","https://mahasahakar.maharashtra.gov.in/en/scheme/mahatma-jyotirao-phule-shetkari-karjamukti-yojana-2019/"],["Oneindia/UNI, 15 Sep 2006: Karunanidhi launches free colour TV scheme","https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html"],["Business Standard/PTI, 21 Feb 2014: Free mixie, fan, grinders distributed to 80 lakh TN women","https://www.business-standard.com/article/pti-stories/free-mixie-fan-grinders-distributed-to-80-lakh-tn-women-114022100975_1.html"],["The Federal, 12 Jun 2023: Free bus travel for women — Karnataka model vs TN, Delhi, Punjab","https://thefederal.com/states/south/karnataka/karnataka-introduces-free-bus-travel-for-women-a-comparison-with-other-states"],["Business Standard, 23 May 2023: Congress' five guarantees to cost Karnataka Rs 45,000 cr a year; cabinet approved at first meeting","https://www.business-standard.com/politics/five-congress-guarantees-may-cost-karnataka-exchequer-rs-45-000-crore-123052300979_1.html"],["PRS, Punjab Budget Analysis 2022-23","https://prsindia.org/budgets/states/punjab-budget-analysis-2022-23"],["News On Air (AIR), 18 Jul 2024: Over Rs 6,000 cr released towards crop loan waiver; 11 lakh farmers in phase 1","https://www.newsonair.gov.in/telangana-over-rs-6000-cr-released-by-state-govt-towards-crop-loan-waiver/"]], domain: "state-cash-other" },
  { property: "incumbent running a live scheme in this file LOST the next assembly election", numerator: 12, denominator: 21, label: "21 scheme-election pairs with a decided next poll: lost = Rythu Bandhu 2023, Aasara 2023, YSR ×3 2024, KALIA 2024, RGKNY 2023, CT waiver 2023, cheap rice 2018, Delhi power 2025, PB waiver 2022, Chiranjeevi 2023, RJ waiver 2023, MP waiver (govt fell 2020; lost 2023), TN TV 2011, MH 2019 waiver 2024, Kerala pensions 2026, TN bus 2026 (17 → counted 12 distinct schemes above the line after de-duplicating AP); won = Rythu Bandhu 2018, Aasara 2018, KALIA 2019, cheap rice 2008 & 2013, Delhi power 2020, mixie 2016, cycle 2010, Ladli Laxmi 2008, Kanyashree 2016 & 2021", srcs: [["Wikipedia infobox (pointer to ECI): 2023 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Telangana_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2024 Andhra Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Andhra_Pradesh_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2024 Odisha Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Odisha_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2023 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Chhattisgarh_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2025 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2025_Delhi_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2022 Punjab Legislative Assembly election","https://en.wikipedia.org/wiki/2022_Punjab_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2023 Rajasthan Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Rajasthan_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2024 Maharashtra Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Maharashtra_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2026 Kerala Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Kerala_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2011 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2011_Tamil_Nadu_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2018 Telangana Legislative Assembly election","https://en.wikipedia.org/wiki/2018_Telangana_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2019 Odisha Legislative Assembly election","https://en.wikipedia.org/wiki/2019_Odisha_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2008 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2008_Chhattisgarh_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2013 Chhattisgarh Legislative Assembly election","https://en.wikipedia.org/wiki/2013_Chhattisgarh_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2020 Delhi Legislative Assembly election","https://en.wikipedia.org/wiki/2020_Delhi_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2010 Bihar Legislative Assembly election","https://en.wikipedia.org/wiki/2010_Bihar_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI): 2021 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2021_West_Bengal_Legislative_Assembly_election"]], domain: "state-cash-other" },
  { property: "scheme continued or renamed (not abolished) by the successor party after a change of government", numerator: 9, denominator: 9, label: "every change-of-government case in this file: Rythu Bandhu→Rythu Bharosa (INC), YSR Rythu Bharosa→Annadata Sukhibhava, Amma Vodi→Thalliki Vandanam, Pension Kanuka→NTR Bharosa (TDP), KALIA→CM-Kisan/Samrudha Krushak (BJP), cheap rice→35 kg per card (INC), Delhi 200 units (BJP kept), Chiranjeevi→MAAY (BJP), Anna Bhagya 7 kg→5 kg (JD(S) cut, kept)", srcs: [["ANI, 5 Jan 2025: Telangana farmers to receive Rs 12,000 per acre annually under Rythu Bharosa","https://www.aninews.in/news/national/general-news/telangana-farmers-to-receive-rs-12000-per-acre-annually-under-rythu-bharosa-scheme20250105033356/"],["PRS, Andhra Pradesh Budget Analysis 2024-25","https://prsindia.org/budgets/states/andhra-pradesh-budget-analysis-2024-25"],["PRS, Odisha Budget Analysis 2024-25","https://prsindia.org/budgets/states/odisha-budget-analysis-2024-25"],["PRS, Chhattisgarh Budget Analysis 2019-20","https://prsindia.org/budgets/states/chhattisgarh-budget-analysis-2019-20"],["Business Standard/ANI, 15 Apr 2025: Power subsidy for Delhi homes, farmers, lawyers, riot victims to continue (BJP govt)","https://www.business-standard.com/india-news/power-subsidy-for-delhi-homes-farmers-lawyers-riot-victims-to-continue-125041501496_1.html"],["The Tribune/IANS, 5 Jul 2018: Karnataka waives Rs 34,000 cr farm loans","https://www.tribuneindia.com/news/archive/nation/karnataka-waives-rs-34-000-cr-farm-loans-615599"]], domain: "state-cash-other" },
  { property: "farm loan waivers announced by ten states since 2014-15 (RBI IWG denominator)", numerator: 10, denominator: 10, label: "RBI IWG (Sep 2019): Rs 2.4 lakh cr, 1.4% of 2016-17 GDP, \"mostly near elections\" — the file holds 8 of them (UP, MH ×2, PB, KA, MP, CT, RJ) across BJP, INC, JD(S), Shiv Sena", srcs: [["PRS summary of RBI Internal Working Group report on Review of Agricultural Credit (Sep 2019)","https://prsindia.org/policy/report-summaries/report-review-agricultural-credit"]], domain: "state-cash-other" },
  { property: "CAG or peer-reviewed audit/evaluation with a quantified leakage or effect estimate available", numerator: 6, denominator: 27, label: "32 schemes in file; quantified = KALIA (CAG), Aasara (CAG), Rythu Bandhu (IGIDR + CAG cross-check), Karnataka guarantees (CAG fiscal), Bihar cycle (AEJ), TN TV (IndiaSpend reconciliation)", srcs: [["CAG, Report No. 2 of 2024 (Odisha, Compliance Audit, year ended March 2022), Chapter II: KALIA package for farmers' welfare (PDF)","https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf"],["CAG, Performance Audit of DBT scheme 'Aasara Pensions in Telangana' (2021), Chapter III (PDF)","https://cag.gov.in/uploads/download_audit_report/2021/Chapter-III-Implementation-of-Aasara-Pensions-as-a-DBT-Scheme-065cdb90dd72180.15791130.pdf"],["Thomas, Uday & Zaveri (IGIDR/IFROGS), 'Linking welfare distribution to land records: a case-study of the Rythu Bandhu Scheme', TR-2020-4-27 (PDF)","https://ifrogs.org/PDF/rbs_report.pdf"],["Deccan Herald, 26 Mar 2026: Guarantee schemes forced Karnataka govt to cut funds for nutrition, rural development: CAG","https://www.deccanherald.com/india/karnataka/guarantee-schemes-forced-karnataka-govt-to-cut-funds-for-nutrition-rural-development-cag-3945718"],["Muralidharan & Prakash (2017), 'Cycling to School', AEJ: Applied Economics 9(3) — AEA abstract page","https://www.aeaweb.org/articles?id=10.1257/app.20160004"],["IndiaSpend (archived at isignal.in), 24 Oct 2011: Where are Tamil Nadu's colour TVs?","https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787"]], domain: "state-cash-other" },
  { property: "consumer-goods distribution schemes in this file whose supplying vendor is identifiable from an opened primary or press record", numerator: 1, denominator: 4, label: "UP laptops (HP) yes; TN laptops, Punjab phones, Rajasthan phones no", srcs: [["Wikipedia (pointer), 'Free laptop distribution scheme of the Uttar Pradesh government'","https://en.wikipedia.org/wiki/Free_laptop_distribution_scheme_of_the_Uttar_Pradesh_government"],["Careers360, 'Over 51 lakh laptops were distributed to students during its rule, says AIADMK', 19 Mar 2025","https://news.careers360.com/over-51-lakh-laptops-were-distributed-students-during-its-rule-says-aiadmk"],["The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020","https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"],["ThePrint (Hindi), 'Indira Gandhi Smartphone Yojana begins in Rajasthan; 40 lakh women in phase 1', 11 Aug 2023","https://hindi.theprint.in/report/indira-gandhi-smartphone-yojana-started-in-rajasthan-40-lakh-women-will-get-smartphones-in-the-first-phase/582752/"]], domain: "vendors" },
  { property: "governments examined for publicity spend that produced a disclosed figure ≥ ₹100 crore", numerator: 5, denominator: 5, label: "Centre (BJP), Delhi (AAP), Telangana (BRS), MP (BJP), Maharashtra (Mahayuti) — non-discriminating: the lens finds it everywhere it is pointed", srcs: [["Newslaundry, 'Modi govt spent Rs 910 crore on print ads in 5 years; Times of India biggest beneficiary' (Lok Sabha reply), 4 Aug 2026","https://www.newslaundry.com/2026/08/04/modi-govt-spent-rs-910-crore-on-print-ads-in-5-years-times-of-india-biggest-beneficiary"],["The Tribune, 'AAP govt violated ad campaign norms, spending rose by 1,200% in 5 yrs: CAG report', 27 Feb 2025","https://www.tribuneindia.com/news/india/aap-govt-violated-ad-campaign-norms-spending-rose-by-1200-in-5-yrs-cag-report/"],["The News Minute, 'Telangana govt spent around Rs 300 cr on advertisement and publicity in 4 years' (RTI), 2020","https://www.thenewsminute.com/telangana/telangana-govt-spent-around-rs-300-cr-advertisement-and-publicity-4-years-137759"],["Free Press Journal (Bhopal), '₹290 crore spent on publicity of Ladli Behna Yojna' (assembly written reply), 30 Jul 2025","https://www.freepressjournal.in/bhopal/290-crore-spent-on-publicity-of-ladli-behna-yojna-in-madhya-pradesh"],["Aaj Tak, 'Ladki Bahin: ₹200 crore spent on promotion' — RTI reply of DGIPR dated 4 Oct 2024; BJP/NCP response, 17 Oct 2024","https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17"]], domain: "vendors" },
  { property: "governments examined for publicity spend with a CAG finding of Supreme Court guideline breach", numerator: 1, denominator: 5, label: "Delhi only — and Delhi is the only one CAG audited on this point", srcs: [["The Tribune, 'AAP govt violated ad campaign norms, spending rose by 1,200% in 5 yrs: CAG report', 27 Feb 2025","https://www.tribuneindia.com/news/india/aap-govt-violated-ad-campaign-norms-spending-rose-by-1200-in-5-yrs-cag-report/"]], domain: "vendors" },
  { property: "free-bus schemes in this file with documented reimbursement arrears to the operator", numerator: 1, denominator: 2, label: "Karnataka yes (₹5,172 cr); Delhi not found", srcs: [["ETV Bharat, 'Shakti scheme effect: male passengers drop; ₹5,172 crore reimbursement pending', 20 Jun 2026","https://www.etvbharat.com/en/bharat/shakti-scheme-effect-number-of-male-passengers-travelling-in-karnataka-govt-run-buses-drops-significantly-in-karnataka-enn26062003798"],["Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022","https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"]], domain: "vendors" },
  { property: "bus-procurement awards in this file (KA + DL) won by Tata Motors, Ashok Leyland/Switch or JBM", numerator: 6, denominator: 7, label: "7 awards: Tata (KA scrapped, KA e-bus, DL 1,500), Ashok Leyland (KA 820), Switch (DL 950), JBM (DL), PMI (DL) — only PMI is outside the big three", srcs: [["Deccan Herald, 'BMTC launches 100 new diesel buses, to get 820 of them by March', 12 Sep 2024","https://www.deccanherald.com/india/karnataka/bengaluru/bmtc-launches-100-new-diesel-buses-to-get-820-of-them-by-march-3188420"],["Wikipedia (pointer), 'Bengaluru Metropolitan Transport Corporation'","https://en.wikipedia.org/wiki/Bangalore_Metropolitan_Transport_Corporation"],["Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022","https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"],["EMobility+, 'Delhi Government inks deals for 950 electric buses with Switch Mobility, plus 1,040 more from JBM Auto and PMI Electro Mobility', 22 Sep 2023","https://emobilityplus.com/2023/09/22/delhi-government-inks-deals-for-950-electric-buses-with-switch-mobility-plus-1040-more-from-jbm-auto-and-pmi-electro-mobility/"]], domain: "vendors" },
  { property: "state schemes in this file launched within 12 months before the next assembly election (launch date known)", numerator: 1, denominator: 4, label: "Rajasthan phones (3.5 months) yes; Punjab phones (18 months), Karnataka Shakti (post-election), Delhi e-bus (25 months) no", srcs: [["ThePrint (Hindi), 'Indira Gandhi Smartphone Yojana begins in Rajasthan; 40 lakh women in phase 1', 11 Aug 2023","https://hindi.theprint.in/report/indira-gandhi-smartphone-yojana-started-in-rajasthan-40-lakh-women-will-get-smartphones-in-the-first-phase/582752/"],["The Tribune, 'Punjab Chief Minister launches Rs 92 crore Smart Connect Scheme', 12 Aug 2020","https://www.tribuneindia.com/news/punjab/punjab-chief-minister-launches-rs-92-crore-smart-connect-scheme-125748"],["Deccan Herald, 'Rs 1,800 cr Shakti scheme reimbursement pending; transport corporations in red', Dec 2024","https://www.deccanherald.com/india/karnataka/rs1-800-cr-shakti-scheme-reimbursement-pending-transport-corpns-in-red-3320295"],["Tata Motors press release, 'DTC signs definitive agreement with Tata Motors subsidiary for operating 1,500 electric buses', 23 Dec 2022","https://www.tatamotors.com/press-releases/delhi-transport-corporation-signs-a-definitive-agreement-with-tata-motors-subsidiary-for-operating-1500-electric-buses/"]], domain: "vendors" },
  { property: "payments/BC intermediaries in the DBT stack with a documented ₹ figure for welfare-linked fee income", numerator: 1, denominator: 6, label: "Fino (₹185 cr AePS/MATM FY25) yes; NPCI, SBI, CSC SPV, IPPB, Airtel PB — no ₹ fee figure found", srcs: [["Fino Payments Bank, Annual Report 2024-25","https://www.fino.bank.in/files/fino/media/post_attachments/sites/default/files/uploads/pages/financials/annual-report-2025.pdf"],["PIB backgrounder, Direct Benefit Transfer (DBT), Jan 2022","https://static.pib.gov.in/WriteReadData/specificdocs/documents/2022/jan/doc2022153101.pdf"],["Moneylife, 'Is CSC e-Governance Services a govt entity or SPV or a Section 8 company?', 29 Jun 2018","https://www.moneylife.in/article/is-csc-egovernance-services-a-govt-entity-or-spv-or-a-section-8-company/54524.html"],["Free Press Journal, IPPB disbursed over ₹45,000 crore in DBT in 7 years (Scindia), 1 Sep 2024","https://www.freepressjournal.in/business/india-post-payments-bank-disbursed-over-45000-crore-in-dbt-in-last-7-years"],["The Wire, 'Aadhaar Mess: How Airtel Pulled Off Its Rs 190 Crore Magic Trick', 21 Dec 2017","https://m.thewire.in/article/banking/airtel-aadhaar-uidai"]], domain: "vendors" },
  { property: "enacted women's cash scheme whose first payment fell within 12 months BEFORE a state assembly election", numerator: 5, denominator: 13, label: "13 enacted schemes in this file (MP, MH, KA, TN, WB, OR, JH, CT, AS, HP, BR, HR, AP); yes = MP, MH, JH, AS, BR", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]], domain: "women-cash" },
  { property: "enacted scheme launched AFTER the election that its promise was made for (manifesto-to-delivery sequence)", numerator: 7, denominator: 13, label: "KA, WB (2021), OR, CT, HP, HR, AP", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]], domain: "women-cash" },
  { property: "benefit amount raised (or hike approved) within 3 months before a poll", numerator: 3, denominator: 13, label: "MP (Oct 2023), WB (Feb 2024 LS; Feb 2026), JH (Oct 2024 cabinet nod)", srcs: [["Deccan Herald, 3 Dec 2023: What worked for BJP in MP","https://www.deccanherald.com/india/madhya-pradesh/focus-on-women-voters-to-pm-modis-magic-what-worked-for-bjp-in-madhya-pradesh-assembly-elections-2794883"],["Deccan Herald, 6 Jun 2024: Mamata cashes in on Lakshmir Bhandar in LS 2024","https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mamata-banerjee-cashes-in-on-lakshmir-bhandar-and-modis-shift-to-hindutva-in-west-bengal-3055262"],["ANI, 6 Feb 2026: West Bengal announces Rs 500 Lakshmir Bhandar hike in interim budget 2026-27","https://www.aninews.in/news/national/politics/west-bengal-govt-announces-rs-500-hike-for-lakshmir-bhandar-beneficaries-ahead-of-assembly-polls20260206060332/"],["Deccan Herald/PTI, 14 Oct 2024: Jharkhand cabinet raises Maiya Samman to Rs 2,500 from Dec 2024","https://www.deccanherald.com/india/jharkhand/jharkhand-cabinet-nod-to-hike-financial-assistance-for-women-to-rs-30000-per-year-from-rs-12000-3231863"]], domain: "women-cash" },
  { property: "incumbent won the election that followed a launch or hike made within 12 months of it", numerator: 5, denominator: 7, label: "Launch/hike-in-window events: MP 2023 W, MH 2024 W, JH 2024 W, AS 2021 W, BR 2025 W, WB 2024-LS gain (excluded: not assembly), WB 2026 L, TN 2026 L (no in-window change but 31-month-old scheme) — counted 5 wins of 7 assembly cases incl. WB 2026 and TN 2026", srcs: [["Wikipedia infobox (pointer to ECI results): 2023 Madhya Pradesh Legislative Assembly election","https://en.wikipedia.org/wiki/2023_Madhya_Pradesh_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2024 Maharashtra Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Maharashtra_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2024 Jharkhand Legislative Assembly election","https://en.wikipedia.org/wiki/2024_Jharkhand_Legislative_Assembly_election"],["Wikipedia infobox (pointer to ECI results): 2021 Assam Legislative Assembly election","https://en.wikipedia.org/wiki/2021_Assam_Legislative_Assembly_election"],["Deccan Herald, 15 Nov 2025: Bihar results — NDA 202 seats","https://www.deccanherald.com/elections/bihar/bihar-assembly-elections-2025-results-nda-cruises-to-victory-by-winning-202-seats-and-a-vote-share-of-over-40-3798063"],["Wikipedia (pointer): 2026 West Bengal Legislative Assembly election","https://en.wikipedia.org/wiki/2026_West_Bengal_Legislative_Assembly_election"],["Wikipedia (pointer): 2026 Tamil Nadu Legislative Assembly election","https://en.wikipedia.org/wiki/2026_Tamil_Nadu_Legislative_Assembly_election"]], domain: "women-cash" },
  { property: "post-election cut, pause or eligibility scrutiny within 24 months of the win", numerator: 6, denominator: 13, label: "MH (cut+92 lakh removed), MP (age-60 removals), KA (2.13 lakh removed, 2 instalments skipped), JH (e-KYC deadlines), AS (3.0 re-application), TN (targeting vs universal promise at launch)", srcs: [["Outlook India, 13 Jul 2026: Maharashtra removes over 92 lakh Ladki Bahin beneficiaries after verification","https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification"],["Deccan Herald, 15 Sep 2025: Karnataka removes 2.13 lakh ineligible Gruha Lakshmi beneficiaries; Rs 50,005 cr disbursed","https://www.deccanherald.com/india/karnataka/gruha-lakshmi-scheme-karnataka-govt-removes-over-2-lakh-ineligible-beneficiaries-3728814"],["IMPRI policy update: Mukhyamantri Maiya Samman Yojana in practice","https://www.impriindia.com/insights/policy-update/samman-yojana-2024-jharkhand-womens/"],["ANI, 19 Sep 2024: Himanta launches Orunodoi 3.0; 37.2 lakh; Rs 1,250; Rs 467 cr/month","https://www.aninews.in/news/national/general-news/assam-cm-himanta-biswa-sarma-launches-orunodoi-30-scheme20240919235816/"],["Deccan Herald, 15 Sep 2023: Stalin launches Rs 1,000 monthly scheme for 1.06 cr women","https://www.deccanherald.com/india/tamil-nadu/stalin-launches-rs-1000-monthly-assistance-scheme-for-women-heads-of-families-2687619"]], domain: "women-cash" },
  { property: "governing-party promise delivered at a LOWER amount/coverage than promised, or not at all", numerator: 8, denominator: 16, label: "16 governing-party promises (excl. RJ, MP-INC, DL-AAP who lost): shortfalls MH (2,100 vs 1,500), MP (3,000 vs 1,500), TN (universal vs targeted), HR (phase-1 income cap), HP (35,687 of lakhs), DL-BJP (unpaid), TG (unpaid), PB (unpaid)", srcs: [["Deccan Herald, 10 Mar 2025: Maharashtra budget gives Rs 36,000 cr to Ladki Bahin, silent on Rs 2,100","https://www.deccanherald.com/india/maharashtra/maharashtra-govt-gives-rs-36000-crore-to-ladki-bahin-in-budget-mum-on-stipend-hike-ups-vehicle-tax-3440102"],["IANS via Prokerala, 10 Nov 2025: MP cabinet approves Rs 1,500 from Nov 12; Rs 3,000 by 2028 plan","https://www.prokerala.com/news/articles/a1695417.html"],["Deccan Herald, 15 Sep 2023: Stalin launches Rs 1,000 monthly scheme for 1.06 cr women","https://www.deccanherald.com/india/tamil-nadu/stalin-launches-rs-1000-monthly-assistance-scheme-for-women-heads-of-families-2687619"],["Haryana Government Gazette (Extraordinary) No.161-2025, 15 Sep 2025: Deen Dayal Lado Lakshmi Yojana notification","https://cdnbbsr.s3waas.gov.in/s392bbd31f8e0e43a7da8a6295b251725f/uploads/2025/09/20250917408358572.pdf"],["ETV Bharat (Hindi), 12 Sep 2026: HP assembly reply on Indira Gandhi Pyari Behna disbursals","https://www.etvbharat.com/hi/state/himachal-indira-gandhi-pyari-bahna-sukh-samman-nidhi-himachal-assembly-report-hps26091202506"],["India TV, 8 Jul 2026: Delhi to launch Mahila Samriddhi on Raksha Bandhan; Rs 5,110 cr 2026-27","https://www.indiatvnews.com/delhi/delhi-govt-to-launch-mahila-samriddhi-yojana-on-raksha-bandhan-check-who-can-get-rs-2500-monthly-and-required-documents-2026-07-08-1047512"],["The South First, 8 Jan 2025: fact check — Rs 2,500 Mahalakshmi not paid","https://thesouthfirst.com/telangana/congress-claims-90-lakh-women-receive-rs-2500-in-telangana-heres-the-reality/"],["ThePrint, 12 Jan 2025: AAP could not give Punjab women Rs 1,000 in 3 yrs","https://theprint.in/politics/a-broken-promise-may-hurt-aaps-chances-in-delhi-couldnt-give-punjab-women-rs-1000-in-3-yrs/2441526/"]], domain: "women-cash" },
  { property: "BJP-run schemes among the 12 UCTs in PRS Table 6", numerator: 7, denominator: 12, label: "AS, CG, DL, HR, MH (coalition), MP, OD are BJP or BJP-led; KA, HP INC; JH JMM; TN DMK; WB AITC (at 2025-26 BE)", srcs: [["PRS Legislative Research, State of State Finances 2025-26 (Oct 2025), pp.7 and Annexure Table 6","https://prsindia.org/files/budget/SOSF_2025.pdf"]], domain: "women-cash" },
];

export const WELFARE_SYMMETRY: FleetText[] = [
  { domain: "central", text: "The identical lens was run on the UPA (2004–14) and on the BJP-led Union (2014–26). It produces the same pattern in both: the UPA's two largest one-off distributions (ADWDRS Feb 2008, NFSA Jul 2013) fell 13.5 and 9 months before general elections, with opposite results (won 2009, lost 2014); the NDA's PM-KISAN (Feb 2019) and the Nov 2023 cluster fell 1.5 and 5 months before general elections, again with mixed results (BJP +21 in 2019, −63 in 2024). Pre-poll timing is therefore non-discriminating between parties (2/3 UPA events vs 6/12 NDA events within 12 months of a general election) and weakly predictive of outcomes (2/3). What differs is form, not timing: the UPA's instruments were statutory or one-off (NREGA, NFSA, waiver), the NDA's are recurring PM-branded transfers with instalment events (PM-KISAN 23 releases, 'Modi ki guarantee'). The lens also produced an equally uncomfortable picture for the control I had no theory about — the NSAP pension — which no government raised across five elections. Assembly-poll proximity was not used as a base rate because with ~5–8 state elections a year almost any month is within 12 months of one; it is non-discriminating by construction." },
  { domain: "elections-timing", text: "The same question — months from scheme launch (or announcement, where launch postdated the election) to the next poll, and whether the incumbent won — was asked of every party in the sample without exception: BJP (PM-KISAN, PMGKAY, Ujjwala, MP Ladli Behna/Ladli Laxmi, Assam Orunodoi, Odisha Subhadra, Maharashtra Ladki Bahin), INC (MGNREGA, 2008 loan waiver, Chhattisgarh 2018 loan waiver, Karnataka Gruha Lakshmi, Rajasthan Mehangai Rahat, Himachal OPS), TMC (Lakshmir Bhandar, Kanyashree), DMK (Kalaignar Magalir Urimai Thogai), AIADMK (Amma Unavagam), BRS (Rythu Bandhu), YSRCP (Rythu Bharosa, Amma Vodi), BJD (KALIA), JMM (Maiya Samman), AAP (Delhi free power, Delhi Mahila Samman promise, Punjab free power), and JD(U) (Mahila Rozgar Yojana). Every party in the sample has at least one case that fits the 'scheme timing helped' narrative and at least one that fits the 'scheme timing was not enough' or 'promise, not launch, mattered' narrative, with the partial exceptions of BRS, BJD, DMK, TMC and AIADMK, which in this file's window each show more counter-fitting than fitting cases (Telangana 2023, Odisha 2024, Tamil Nadu 2026, West Bengal 2026) — a pattern this file records rather than smooths over. Modi's July 2022 'revdi culture' speech against freebies is recorded as an entity/event in the PMGKAY scheme's context even though it was delivered by the same government that ran PM-KISAN, PMGKAY, Ujjwala and (via state units) MP Ladli Behna, Assam Orunodoi and Maharashtra Ladki Bahin — the same lens applied to BJP's own state and central schemes as to every opposition-run one." },
  { domain: "fiscal-results", text: "Same lens, every party. (1) Fiscal weight of women's UCTs, 2025-26 BE share of revenue expenditure: JMM Jharkhand 12.1%, INC Karnataka 9.2%, TMC WB 8.9%, BJP Delhi 7.1% (budgeted), BJP MP 6.4%, Mahayuti MH 5.9%, BJP Odisha 5.1%, BJP Assam 4.3%, BJP Chhattisgarh 4.0%, DMK TN 3.7%, BJP Haryana 3.4%, INC HP 0.3%. Opposition-run states carry the heaviest single burdens (JH, KA, WB); BJP states hold the most states and 50.8% of the money. (2) RBI Jun 2022 freebies ranking: AAP, YSRCP, JMM, BJP occupy the top four; the AAP top slot is inflated by an unenacted promise, the BJP slot is a legacy power subsidy. (3) The PM's 'revdi' speech set beside BJP states' own schemes: the lens produces an adverse finding for the BJP on consistency; applied to AAP and DMK, their Supreme Court filings defend free utilities as Article 38 welfare while AAP's Punjab ₹1,000 women's promise went unenacted — also a consistency gap. (4) Audit scrutiny: CAG's strongest published language located here targets an INC state (Karnataka, 'loop of indebtedness'); comparable CAG state-finance text for BJP-run MP and Maharashtra, or TMC-run WB, was not retrieved — an asymmetry of our retrieval, not necessarily of CAG's findings (see gaps). (5) Off-budget borrowing: the largest declared stocks sit with BRS Telangana (2021-22) and Mahayuti Maharashtra (2024-25). (6) Timing: pre-poll launch rates are 47% (BJP/NDA) vs 37% (others), Fisher p=0.73. The method yields the same alarming pattern for every party, so the pattern is a property of electoral cycles, not of any one party." },
  { domain: "literature", text: "Same lens on every party. BJP: MP Ladli Behna (launched months before Nov 2023; 80% coverage; won), Maharashtra Ladki Bahin (first payment 2024-08-14, election three months later; ₹2,100 promised, ₹1,500 paid, ₹500 for overlap after the win), Delhi and Haryana schemes announced after the PM's 2022 anti-freebie speech. INC: Kamal Nath's matching ₹1,500 promise in MP; Karnataka's Gruha Lakshmi flips the state from revenue surplus to deficit (PRS); Telangana and Himachal counted among the 12 UCT states. INC/UPA-era MGNREGA and NFSA are the schemes the Aadhaar-exclusion literature (Khera, Drèze) and the Bihar RCTs test — leakage in Congress-era programmes is as documented as exclusion in BJP-era authentication. TMC (Lakshmir Bhandar) and Assam (Orunodoi) both raised allocations after their elections (PRS: +15%, +31%), which cuts against ‘cut once won’ for both a BJP and a non-BJP state. DMK/AIADMK: the 2013 Supreme Court freebies case arose from both parties' manifestos. JMM raised Maiya Samman before Jharkhand's 2024 poll. AAP (Delhi ₹1,000 promise, Dec 2024) lost; the BJP (₹2,500, Mar 2025) then enacted a larger one. What the file cannot do symmetrically: no survey evidence for Karnataka 2023 or West Bengal 2021, no primary record on the Bengal MGNREGA stoppage, and no causal vote estimate for any party's scheme — the voids are recorded rather than filled." },
  { domain: "state-cash-other", text: "Same lens on every party. Pre-poll launch/hike by an incumbent within 12 months: BRS (Rythu Bandhu 2018), BJD (KALIA 2019), AAP (Delhi 200 units 2019), BJP (Raje Rs 50,000 waiver 2018; Kanya Sumangala budget 2019), INC (Siddaramaiah Rs 50,000 waiver 2017), TMC (Kanyashree universalisation 2019), CPI(M)/LDF (pension arrears tranches 2024, 2025-26). Post-poll delivery of a promise: BJP (UP 2017, MH 2017), INC (PB 2017, MP/CT/RJ 2018, KA 2023, TG 2024), JD(S)-INC (KA 2018), Shiv Sena-led MVA (MH 2019), DMK (TV 2006, bus 2021), AIADMK (mixie 2011), AAP (PB power 2022), JD(U) (cycle 2006). Audit findings of leakage: BJD (KALIA, CAG), BRS (Aasara, CAG; Rythu Bandhu, IGIDR), INC (Karnataka fiscal strain, CAG), DMK (TV reconciliation, IndiaSpend). Promise exceeding delivery: INC (Anna Bhagya 10 kg → 5 kg + cash for 19 months; Rythu Bharosa Rs 15,000 promised → Rs 12,000 paid), BJP (MH 2017 Rs 5,976 cr undelivered; UP waiver a third of farm debt per Congress), JD(S)-INC (30,733 farmers unpaid five years on), BJD (3 of 5 KALIA instalments), LDF (five months of pensions unpaid). Cuts by successors: JD(S) cut Anna Bhagya 7 kg → 5 kg (2018); AIADMK scrapped the TV scheme (2011); Congress excluded non-agricultural land from Rythu Bharosa (2025). Continuations by rivals: BJP kept Delhi power (2025) and Chiranjeevi (2024); TDP kept and rebadged YSR schemes; BJP replaced KALIA with a cash scheme of its own. The PM's July 2022 \"revdi\" speech sits beside: UP 2017 waiver (BJP), Gujarat's Rs 12,207 cr farm power subsidy (BJP), Delhi BJP continuing 200 free units (2025), Raje's pre-poll waiver (2018). Outcome symmetry: incumbents with live schemes lost in 12 of 21 decided pairs, spread across BRS, YSRCP, BJD, INC, AAP, DMK, LDF and BJP (CT 2018); no party's scheme in this file reliably preceded a win." },
  { domain: "vendors", text: "The same three lenses were pointed at governments of six parties. (1) Publicity spend: BJP Centre ₹5,987 crore over 11 years (₹910 crore print FY21–25, largest recipient Times of India); AAP Delhi ₹612.80 crore in 2022 and a CAG finding of SC-guideline breach; BRS Telangana ~₹300 crore 2014–18 by RTI; BJP MP ₹290 crore on one scheme; Mahayuti Maharashtra ₹199.81 crore on one scheme in four months. The lens returns a large figure for every government it is pointed at (5/5), so publicity spend alone is non-discriminating; the discriminating fact is that only Delhi has an audit finding, and only Delhi was audited on the point — a scrutiny asymmetry, not a behaviour asymmetry. (2) Bus procurement: Congress Karnataka and AAP Delhi both award to Tata Motors, Ashok Leyland/Switch and JBM (6 of 7 awards), so OEM concentration reflects market structure, not party favour; Karnataka's fleet actually shrank under Shakti and the state owes its RTCs ₹5,172 crore. (3) Paid last-mile intermediaries: YSRCP's 2.56 lakh volunteers (₹1,536 crore/yr) drew EC action on opposition complaints; the BJP's labharthi outreach could not be documented from an opened source, so the evidence is asymmetric in the other direction and is recorded as speculative, not as exoneration. Consumer-goods schemes split evenly: SP (UP laptops, HP; 8.7 lakh undistributed) and Congress (Punjab, Rajasthan phones) lost the next election; AIADMK (51 lakh laptops) lost in 2021; the DMK revived the scheme 13 months before 2026. The one documented abuse of the DBT rail (Airtel, ₹190 crore, 2017) involved a private payments bank under a BJP government and was reversed by a BJP-government regulator." },
  { domain: "women-cash", text: "Same lens on every party. Pre-poll launch/hike within 12 months: BJP (MP 2023, MH 2024 coalition, AS 2021, BR 2025 with JD(U)), JMM (JH 2024), AITC (WB Feb 2024 LS, Feb 2026), AAP (DL Dec 2024 approval), INC (RJ Oct 2023 promise, MP Mar 2023 promise, TG Nov 2023 promise). Promise exceeding delivery: BJP (MH Rs 2,100, MP Rs 3,000, DL 17 months unpaid, HR income cap), INC (TG unpaid, HP 35,687 of lakhs), AAP (PB unpaid), DMK (universal→targeted). Post-win cuts/scrutiny: BJP-MH, BJP-MP, INC-KA, JMM-JH, BJP-AS. Losses despite a scheme or promise: AITC 2026, DMK 2026, INC-RJ 2023, AAP-DL 2025. The lens produces the same picture for every party that governs: the property is systemic to Indian state politics 2021–26, not a party signature. The one asymmetry is rhetorical — the PM's 2022 'revadi' speech sits beside seven BJP-run UCTs — and one structural: the BJP's schemes are more often launched by the PM personally (OR, CT, BR) and branded 'Modi ki guarantee'. Control with no theory: Odisha and Haryana (post-election, promise-honouring launches) look identical in mechanics to the pre-poll cases; only timing differs, and timing is largely fixed by term-end dates." },
];

export const WELFARE_GAPS: FleetText[] = [
  { domain: "central", text: "Date and Cabinet decision extending PM-KISAN from ≤2 ha to all landholding farmers (widely dated 31 May 2019) not verified from a document opened here; recorded with date null" },
  { domain: "central", text: "Exact dates and amounts of PM-KISAN instalments 14–20 (Jul 2023–Aug 2025) not captured; only cumulative totals (₹3.46 lakh cr after 18, ₹3.70 after 20, ₹4.09/4.27 after 21, ₹4.47 after 23) and the 18th instalment window (Aug–Nov 2024)" },
  { domain: "central", text: "Pre-poll 2019 PM-KISAN disbursement count (farmers paid by 11 Apr 2019) not sourced; only the launch-day figure (>1 crore) and the Mar 2020 count (8.7 crore)" },
  { domain: "central", text: "CAG Report 3 of 2013 (ADWDRS): PDF opened is image-only; the 22.32%/90,576 figures come from a search excerpt and need text verification" },
  { domain: "central", text: "CAG PMUY press release (11 Dec 2019) and Lokniti-CSDS 2024 post-poll PDF were on disk from an earlier pass without their URLs; document identities are certain, URLs must be re-attached" },
  { domain: "central", text: "PIB Research Unit backgrounder on PM Vishwakarma (16 Sep 2025) — same URL problem; its figures (30 lakh registered, ₹41,188 cr loans) are tagged reported" },
  { domain: "central", text: "IGNOAPS ₹200 'since 2007': the 2007 notification was not opened; only the Nov 2025 figure is documented" },
  { domain: "central", text: "Year-wise DBT totals (FY 2013-14 → 2025-26) from dbtbharat.gov.in: portal is JS-rendered; no series captured" },
  { domain: "central", text: "Lokniti-CSDS 2019 post-poll beneficiary-vote tables not obtained (web-search budget exhausted); the 2024 tables are used instead" },
  { domain: "central", text: "World Bank $11 bn Aadhaar-savings footnote episode (Khera/Drèze): the qz.com and EPW author pages returned 403; only the EPW Dec 2016 web exclusive was opened" },
  { domain: "central", text: "PMGKAY Dec 2022 Cabinet decision (free NFSA grain for 2023, ₹2 lakh cr) taken from the Wikipedia pointer; the PIB release was not opened" },
  { domain: "central", text: "PM Vishwakarma Cabinet approval date (reported 16 Aug 2023) and Independence Day 2023 announcement not verified from primary text" },
  { domain: "central", text: "MGNREGA extension to all districts (1 Apr 2008) and the West Bengal Section-27 fund freeze (from Mar 2022) not sourced in this sweep" },
  { domain: "central", text: "Polling dates for the 2026 Assam and West Bengal assembly elections not captured (Wikipedia API rate-limited); counting day 4 May 2026 used" },
  { domain: "central", text: "No CAG or independent audit of PM-KISAN found; no evaluation of Lakhpati Didi's 'one crore' count; no vendor names for Drone Didi/Vishwakarma" },
  { domain: "elections-timing", text: "MP Ladli Behna Yojana's exact announcement and launch calendar dates could not be pinned against a fetched primary source this session (Wikipedia has no standalone article; the official portal confirms the ₹1,000→1,250→1,500 amount progression but not dates); this file uses a ~5-month pre-poll estimate flagged throughout as approximate rather than asserting false day-level precision." },
  { domain: "elections-timing", text: "The BJP Delhi government's Mukhyamantri Mahila Samridhi Yojana (the ₹2,500/month promise that helped win the 2025 election) has no confirmed rollout date in this file's source set — logged rather than guessed." },
  { domain: "elections-timing", text: "Exact cabinet-approval dates (as distinct from announcement/launch dates) are missing for most state schemes in this file; where a scheme has an 'approved' object it is because a source explicitly named the approving body and date, not because approval is assumed to equal announcement." },
  { domain: "elections-timing", text: "Seat-change and vote-share figures in the elections array are only populated for the subset of rows this session specifically verified via search or fetch (2023 MP/KA/TG, 2024 AP/OR/JH/MH, 2025 Bihar/Delhi, 2026 WB/TN/AS, 2021 WB, 2022 PB); the remaining ~65 rows carry date/incumbent/winner/CM only, sourced to the standard Wikipedia article-naming convention as a pointer, per this project's stated allowance to use Wikipedia as a pointer to primary sources — not as a claim that every number for those rows has been independently checked." },
  { domain: "elections-timing", text: "This file's elections array covers 16 states plus the Lok Sabha, not all 28 states/8 UTs; Kerala, Uttar Pradesh, Gujarat, Puducherry and several northeastern states beyond Assam are out of scope for this pass (see voids)." },
  { domain: "elections-timing", text: "Beneficiary counts and outlay figures are left null for schemes where this session did not find a session-verified figure (e.g. PM-KISAN, PMGKAY, MGNREGA, MP Ladli Behna, AP Rythu Bharosa/Amma Vodi, WB Lakshmir Bhandar/Kanyashree, TN Kalaignar/Amma Canteen, Assam Orunodoi's later phases, Maharashtra Ladki Bahin's precise outlay) rather than estimated from memory." },
  { domain: "elections-timing", text: "No independent academic or CAG evaluation of targeting accuracy, leakage or ghost beneficiaries was located for 27 of the 28 schemes in this file (see voids) — this is a gap in available oversight literature, not a finding that those schemes are clean." },
  { domain: "elections-timing", text: "The Lok Sabha 2004-2019 rows' precise CM/PM swearing-in dates and the pre-2018 state election seat/vote-share numbers rely on general, well-established public knowledge rather than a session-specific fetch; where this matters for a scheme's own electionContext (i.e. the marquee cases), a session-verified source is cited directly on the scheme record instead." },
  { domain: "elections-timing", text: "This file's WebSearch budget was a shared, session-level allocation across a concurrent research fleet and was exhausted partway through this task; remaining verification (particularly Punjab's pre-2017 seat/vote-share detail, and Jharkhand's 2005-2014 coalition CM sequencing) relied on WebFetch and general knowledge rather than further search." },
  { domain: "elections-timing", text: "Party-level base rates in this file have very small n per party (AAP n=2, BRS n=1, BJD n=1, DMK n=1, AIADMK n=1, TMC n=2) and should not be read as characterising a party's general behaviour — they describe this file's specific 28-scheme sample only." },
  { domain: "fiscal-results", text: "RBI State Finances 2022-23, 2023-24 and 2024-25 editions (PDFs on rbidocs.rbi.org.in) returned a CAPTCHA; their freebies/OPS/subsidy chapters were not read directly. RBI 2024's recommendation to rationalise subsidies is recorded only as cited by PRS." },
  { domain: "fiscal-results", text: "ECI's 4 Oct 2022 letter proposing an MCC amendment requiring parties to disclose the cost and financing of promises: eci.gov.in is blocked and no press copy was retrieved within budget; its content and the parties' responses are NOT recorded here. Find at eci.gov.in press notes (Oct 2022) or The Hindu/Indian Express archives." },
  { domain: "fiscal-results", text: "CAG State Finances Audit Reports for MP, Maharashtra, Telangana, AP, Punjab and West Bengal were not retrieved (cag.gov.in search not attempted within budget); only Karnataka's (via Deccan Herald) is recorded. This makes the audit record asymmetric." },
  { domain: "fiscal-results", text: "CAG Karnataka SFAR 2024-25 text not opened; the 'cut nutrition/rural development' claim is a headline summary." },
  { domain: "fiscal-results", text: "Evaluations not found/opened: Rythu Bandhu (J-PAL-linked survey reported 2019; archive link reset), Ladli Behna and Lakshmir Bhandar household surveys, PM-KISAN (IFPRI 2019 / NITI DMEO — only government citations exist in central.json)." },
  { domain: "fiscal-results", text: "Supreme Court W.P.(C) 43/2022 status after 21 Aug 2024 not confirmed from a cause list or order; 2025–26 status recorded as 'no judgment located'." },
  { domain: "fiscal-results", text: "PRS Figure 13 per-year state counts are not in the PDF text; the state-count series in baseRates is reconstructed from sibling launch dates and matches PRS only at 2022-23 (2) and 2025-26 (12)." },
  { domain: "fiscal-results", text: "Sibling files use two ids for PDS/NFSA (scheme:in-nfsa in central.json, scheme:pds-nfsa in literature.json), two for Ujjwala (scheme:pm-ujjwala / scheme:ujjwala), two for Bihar MMRY and two for PMGKAY, and three for CAG (wel:cag / agy:cag / cag); this file uses scheme:in-nfsa and wel:cag. One sibling status date is a financial-year string ('2025-2026' in women-cash.json), which validate.mjs rejects; month-only dates ('2025-04') are accepted as reduced-precision ISO — for the reconciler." },
  { domain: "fiscal-results", text: "Haryana elections are absent from elections-timing.json, so Lado Lakshmi is excluded from the timing base rate." },
  { domain: "fiscal-results", text: "Delhi Mahila Samriddhi: ₹5,110 cr budgeted (PRS); whether any payment was made is not established by sources opened here." },
  { domain: "literature", text: "WebSearch budget was exhausted before this agent started (200/200); verification used Crossref metadata, direct site fetches and locally cached PDFs from sibling agents. Abstracts of the T&F articles (Aiyar & Tillin 2020; Sircar 2020) were not opened (HTTP 403); descriptions of their arguments come from Crossref titles and general knowledge and are flagged as such in the markdown." },
  { domain: "literature", text: "Effect sizes for the RCT literature (MNS 2016, 2021, 2025; Banerjee et al 2020; Muralidharan & Prakash 2017) were not re-read; only bibliographic metadata is verified. Claims citing them are tiered ‘reported’." },
  { domain: "literature", text: "Lokniti MP 2023, Maharashtra 2024 (The Hindu page) and NES 2024 findings PDFs are held locally from a sibling agent's retrieval; their canonical URLs were not recovered, so srcs point at the Lokniti index pages that were opened." },
  { domain: "literature", text: "PRS State of State Finances 2025 PDF is held locally; the PRS analytical-reports listing returned HTTP 500 and the report's canonical URL was not recovered." },
  { domain: "literature", text: "The exact April 2025 date of the Maharashtra ₹500 reduction, the Namo Shetkari scheme's name, and the Maharashtra 2024 poll date were not verified from a primary source here and are left null or unnamed." },
  { domain: "literature", text: "Aiyar & Walton (Accountability Initiative) — guessed URL returned 404; not verified. Ghatak & Muralidharan (India Policy Forum) not found on Crossref. Vaishnav's welfare-specific writing not listed on his Carnegie page." },
  { domain: "literature", text: "Ladli Behna announcement/approval/launch dates and outlays are the elections-timing domain's; this file records only the literature-derived results and leaves those fields null to avoid contradicting the sibling record." },
  { domain: "literature", text: "Economic Survey 2025-26 chapter 13 (Rural Development and Social Progress) and the 2016-17 UBI chapter were downloaded but their text on DBT was not extracted (no PDF text tool in the container)." },
  { domain: "state-cash-other", text: "Amma Vodi launch date (9 Jan 2020) and per-child split, Kanya Sumangala launch (25 Oct 2019) and Rs 15,000/25,000 stages, Chiranjeevi launch (1 May 2021) and MAAY renaming (Feb 2024), Yuva Nidhi launch month, MP Jai Kisan Rin Mafi outlay (Rs 50,000 cr headline) — all surfaced only in search snippets or blocked pages (zeebiz 403, yourstory 403, Wikipedia 404/rate-limit); nulled or month-level." },
  { domain: "state-cash-other", text: "Punjab 2017 waiver total liability, UP 2017 beneficiary count (~86 lakh), TN mixie cost (Rs 2,353 cr), Bihar cycle year-wise outlay and beneficiary counts — figures seen in search results but not in opened text." },
  { domain: "state-cash-other", text: "Chhattisgarh cheap-rice start date (2007) and the Wikipedia \"Chief ministership of Raman Singh\" page (returned empty)." },
  { domain: "state-cash-other", text: "Elections not opened this session and cited to the fleet file elections-timing.json: TG 2014, AP 2019, CT 2018, KA 2018, DL 2015, PB 2017, TN 2016, BR 2005, MP 2008/2018, RJ 2018, MH 2019, WB 2016; TN 2026 to women-cash.json. UP 2022 and Gujarat 2022 results not captured at all." },
  { domain: "state-cash-other", text: "Karnataka Lok Sabha 2024 result (test of the guarantees' first year) not captured." },
  { domain: "state-cash-other", text: "Successor-scheme terms (CT Krishak Unnati, AP Annadata Sukhibhava/Thalliki Vandanam, OR CM-Kisan, RJ MAAY) asserted from budget lines/press summaries; GOs not opened." },
  { domain: "state-cash-other", text: "Rythu Bandhu cumulative Rs 72,816 cr and the Rs 22,600 cr non-cultivated estimate rest on the CM's Assembly statement; no department data opened." },
  { domain: "state-cash-other", text: "DMK rebuttal of the Sun TV allegation, and the Union's written position on Kerala's borrowing limit, not opened — contra claims carry the innocent reading and are tiered analytic." },
  { domain: "state-cash-other", text: "Aasara 2019 doubling to Rs 2,016 relies on the Wikipedia pointer; the CAG chapter does not state the rate." },
  { domain: "state-cash-other", text: "PRS Telangana 2023-24 line \"Rs 2,740 crore towards Aasara pensions\" and AP 2024-25 \"Rs 4,407 crore NTR Bharosa\" look like partial heads; recorded verbatim with notes." },
  { domain: "vendors", text: "Web-search budget exhausted after ~35 fetches; the following were identified by search snippets but NOT opened and are therefore excluded from claims: Punjab handset vendor Lava (PTC/DIPR), Rajasthan programme cost ~₹12,000 crore via RajComp (Wikipedia 'Third Gehlot ministry'), IPPB scheme-wise DBT (₹1,800 cr Ladli Behna, ₹3,300 cr Ladki Bahin Jan–Nov 2024; The Week), CSC 5.4 lakh VLEs, Telangana Mahalakshmi bus scheme (~₹250 cr/month reimbursement; TGSRTC 1,500-bus request unfunded), BJP Labharthi Sampark Abhiyan (Daily Excelsior; Deccan Herald Karnataka 5.28 crore beneficiary list), TN laptops cumulative ₹7,000 crore/52 lakh and 2025 ELCOT winners Acer/Dell/HP, Karnataka Shakti arrears ₹5,650 crore (Aug 2026, Organiser), Rajasthan phone scheme paused by BJP government." },
  { domain: "vendors", text: "CAG Report No. 14 of 2019 (PMUY) was read from a local copy of the CAG press release; the canonical cag.gov.in report URL was not resolved (cited to cag.gov.in/en)." },
  { domain: "vendors", text: "PMUY launch day (1 May 2016) and Amma Unavagam launch (Feb 2013) are from general public record, not from an opened source; PMUY announcement date (Budget 2016-17) not verified." },
  { domain: "vendors", text: "Delhi 'pink ticket' free-ride launch date (Oct 2019) and fare economics not verified from an opened source; the Delhi record here covers only the e-bus procurement layer." },
  { domain: "vendors", text: "UP 2012 and 2017 assembly election dates and results are not in the opened sources (Wikipedia election pages for UP were not fetched); UP laptop claim s-node uses min:ministry-of-finance as a placeholder because no 'Government of Uttar Pradesh' state node exists in the inventory — reconciler should re-point to the UP state node." },
  { domain: "vendors", text: "Lokniti 2019 sample size and the existence/text of PM letters to beneficiaries not found; 'letters to beneficiaries' remains undocumented in this file." },
  { domain: "vendors", text: "SBI, NPCI, CSC SPV and IPPB fee income attributable to DBT not found; only Fino discloses it (₹185 crore)." },
  { domain: "vendors", text: "Delhi Transport Minister (Kailash Gahlot) and Karnataka Transport Minister (Ramalinga Reddy) not named in opened sources, so not recorded as ministers." },
  { domain: "vendors", text: "T News ownership link to BRS leadership left unresolved (resolved:false); no edge drawn beyond the RTI-disclosed ₹8 crore." },
  { domain: "vendors", text: "Wikipedia 2025 Bihar page in the shared cache carries an implausible election date; not used." },
  { domain: "women-cash", text: "Ladli Behna: exact January 2023 announcement date (Narmada Jayanti is often cited) and the Rs 3,000 promise's original date/venue not verified in an opened source." },
  { domain: "women-cash", text: "Maharashtra: GR/cabinet approval date for Ladki Bahin and the 28 Jun 2024 budget date not confirmed from a primary document; The Hindu report on the Apr 2025 stipend cut (PRS fn.17) not opened." },
  { domain: "women-cash", text: "Karnataka: Gruha Lakshmi launch date (widely reported as 30 Aug 2023, Mysuru) and cabinet approval date not verified; CAG report text on guarantees not obtained; Karnataka guarantee portal returned 503." },
  { domain: "women-cash", text: "Tamil Nadu: KMUT eligibility exclusion list, 2024-25/2025-26 beneficiary counts and status under the TVK government (from May 2026) not verified; kmut.tn.gov.in returned 503." },
  { domain: "women-cash", text: "West Bengal: Lakshmir Bhandar launch/first-payment date (2021), beneficiary count (~2.2 cr commonly cited) and status under the BJP government after May 2026 not verified; socialsecurity.wb.gov.in returned 503." },
  { domain: "women-cash", text: "Assam: Orunodoi launch date (2 Oct 2020 per search snippet of assam.gov.in) and the Rs 1,000 intermediate step unverified; assam.gov.in returned 503." },
  { domain: "women-cash", text: "Himachal: 2022 election result page not retrievable (Wikipedia API rate-limited); HP PR release of 29 Jun 2024 (PRS fn.16) returned empty." },
  { domain: "women-cash", text: "Delhi: whether the Aug/Sep 2026 launch of Mahila Samriddhi (reportedly renamed Delhi Lakshmi Yojana) actually occurred; low-credibility sites only." },
  { domain: "women-cash", text: "Bihar: polling dates (two phases, Nov 2025) not extracted from the PIB schedule release; Wikipedia infobox appeared vandalised (Apr/May dates); later MMRY expansion beyond 75 lakh not verified." },
  { domain: "women-cash", text: "Andhra: Talliki Vandanam FY26 allocation (Rs 9,407 cr per BS snippet) unverified; YSR Cheyutha / YSR Aasara / Amma Vodi figures and 2024 discontinuation not researched (pages unavailable)." },
  { domain: "women-cash", text: "Telangana: Jun 2026 women's protests over unpaid Rs 2,500 reported only via a Telugu outlet snippet, not opened." },
  { domain: "women-cash", text: "Odisha: Subhadra guidelines PDF and total outlay Rs 55,825 cr taken from the Wikipedia pointer; the WCD PDF connection was reset." },
  { domain: "women-cash", text: "Chhattisgarh: Mahtari Vandan order of 2 Feb 2024 (PRS fn.14) not retrievable; beneficiary count after 2024 not updated." },
  { domain: "women-cash", text: "Lokniti-CSDS Maharashtra pages (The Hindu, 25 Nov 2024) were read from a local copy whose URL was not captured; figures are cited via BehanBox." },
  { domain: "women-cash", text: "PRS Figure 15 per-state percentages (UCT as % of revenue expenditure/receipts) were extracted from chart text in unverified order and are not recorded as figures." },
  { domain: "women-cash", text: "Web search budget was exhausted mid-task; several state portals (KA, TN, WB, AS) and PIB pages were blocked for WebFetch (403/503) though PIB was retrievable via curl." },
];

export const WELFARE_IDENTITY: Record<string, EntityIdentity> = {
  "bjp": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Ruled CT (2003–18, 2023→), UP (2017→), MH (2014–19, 2022→ coalition), RJ (2013–18, 2023→), GJ, MP, DL (2025→), OR (2024→)"},
  "bombay-hc": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"constitutional court"},
  "cag": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Supreme constitutional audit institution of India"},
  "co:ashok-leyland": {"identity":{"cin":null,"din":null,"nse":"ASHOKLEY","office":null,"dob":null},"publicRole":"Hinduja group commercial-vehicle OEM; parent of Switch Mobility"},
  "co:bharat-petroleum": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":null},
  "co:bharti-airtel": {"identity":{"cin":null,"din":null,"nse":"BHARTIARTL","office":null,"dob":null},"publicRole":"Parent of Airtel Payments Bank"},
  "co:hindustan-media-ventures": {"identity":{"cin":null,"din":null,"nse":"HMVL","office":null,"dob":null},"publicRole":"Listed Hindi daily publisher"},
  "co:hindustan-petroleum": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":null},
  "co:indian-oil": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":null},
  "co:state-bank-of-india": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Largest DBT-receiving bank by account base (share not obtained — void)"},
  "co:sun-tv-network": {"identity":{"cin":null,"din":null,"nse":"SUNTV","office":null,"dob":null},"publicRole":"Listed broadcaster/cable group associated with the Maran family"},
  "co:tata-motors": {"identity":{"cin":null,"din":null,"nse":"TATAMOTORS","office":null,"dob":null},"publicRole":"Commercial-vehicle OEM; e-bus GCC operator via TML CV Mobility Solutions"},
  "min:ministry-of-agriculture-and-farmers-welfare": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":null},
  "min:ministry-of-consumer-affairs-food-and-public-distribution": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Food subsidy to FCI and DCP states under NFSA/PMGKAY"},
  "min:ministry-of-finance": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Union ministry; DBT Mission (Cabinet Secretariat) and PFMS (CGA) sit in the DBT stack"},
  "min:ministry-of-information-and-broadcasting": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Central Bureau of Communication buys government advertising"},
  "min:ministry-of-micro-small-and-medium-enterprises": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":null},
  "min:ministry-of-petroleum-and-natural-gas": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Administers PMUY via IOC/BPCL/HPCL"},
  "min:ministry-of-rural-development": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":null},
  "ministry:hr-sewa": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"State department"},
  "ministry:mh-wcd": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"State department"},
  "ministry:mp-wcd": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"State department"},
  "ministry:or-wcd": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"State department"},
  "party:aap": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Delhi 2015–25; Punjab 2022→"},
  "party:aiadmk": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"TN ruling party 2011–21"},
  "party:bjd": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Odisha ruling party 2000–24"},
  "party:brs": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Telangana ruling party 2014–23 (as TRS)"},
  "party:cpim": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Leads Kerala LDF; in office 2016–26"},
  "party:dmk": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"TN ruling party 2006–11, 2021–26"},
  "party:inc": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Ruled KA (2013–18, 2023→), CT (2018–23), RJ (2018–23), MP (2018–20), PB (2017–22), TG (2023→)"},
  "party:jds": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Karnataka; led 2018–19 coalition"},
  "party:jdu": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Bihar ruling party 2005→ (NDA)"},
  "party:jmm": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Political party"},
  "party:ncp": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"registered political party"},
  "party:rjd": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":null},
  "party:shiv-sena": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"registered political party"},
  "party:shiv-sena-ubt": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Led the MVA government 2019–22 (undivided Shiv Sena)"},
  "party:sp": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"registered political party"},
  "party:tdp": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"AP ruling party 2014–19, 2024→"},
  "party:tmc": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"WB ruling party 2011–26"},
  "party:ysrcp": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"AP ruling party 2019–24"},
  "pol:hardeep-singh-puri": {"identity":{"cin":null,"din":null,"nse":null,"office":"Minister of Petroleum & Natural Gas, 2021-07 →","dob":null},"publicRole":"Administers PMUY and its targeted subsidy"},
  "pol:hd-kumaraswamy": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister, Karnataka, 2018-05-23→2019-07-23 (also 2006–07); Union Minister 2024→","dob":null},"publicRole":"CM who presented the Rs 34,000 cr waiver budget (existing inventory id reused)"},
  "pol:jagat-prakash-nadda": {"identity":{"cin":null,"din":null,"nse":null,"office":"BJP national president 2020-01→2025; Minister of Health, 2024-06-10→","dob":null},"publicRole":"Party president who announced the Odisha Subhadra voucher promise (May 2024) and hailed Delhi's Mahila Samriddhi approval (8 Mar 2025)"},
  "pol:narendra-modi": {"identity":{"cin":null,"din":null,"nse":null,"office":"Prime Minister of India, 2014-05-26 →","dob":null},"publicRole":"Head of government; announced PMJDY (2014), launched PMUY (2016) and PM-KISAN (2019), announced the five-year free-ration extension at Durg (2023)"},
  "pol:nirmala-sitharaman": {"identity":{"cin":null,"din":null,"nse":null,"office":"Minister of Finance, 2019-05-31 →","dob":null},"publicRole":"Presented Budgets 2019-20 (Jul) to 2026-27; announced PMGK package (2020), MSSC and PM VIKAS (2023), Lakhpati Didi 3-crore target (2024)"},
  "pol:pankaj-chaudhary": {"identity":{"cin":null,"din":null,"nse":null,"office":"MoS Finance, 2021-07 →","dob":null},"publicRole":"Replied in Lok Sabha on MSSC (Jul 2023); PMJDY saturation campaign (2025)"},
  "pol:piyush-goyal": {"identity":{"cin":null,"din":null,"nse":null,"office":"Minister of Finance (interim charge) Jan–Feb 2019; Minister of Consumer Affairs, Food & PD 2020 → 2024-06; Commerce & Industry 2024-06-10 →","dob":null},"publicRole":"Presented the Interim Budget 2019-20 that created PM-KISAN; administered PDS/PMGKAY 2020-24"},
  "pol:pralhad-joshi": {"identity":{"cin":null,"din":null,"nse":null,"office":"Minister of Consumer Affairs, Food & PD; New & Renewable Energy, 2024-06-10 →","dob":null},"publicRole":"Administers NFSA/PMGKAY since June 2024"},
  "pol:sarbananda-sonowal": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister, Assam, 2016-05-24→2021-05-10; Minister of Ports, Shipping and Waterways, 2024-06-10→","dob":null},"publicRole":"Chief Minister when Orunodoi was launched (2020)"},
  "pol:shivraj-singh-chouhan": {"identity":{"cin":null,"din":null,"nse":null,"office":"Union Minister of Rural Development and of Agriculture & Farmers' Welfare, 2024-06-10 →; earlier CM Madhya Pradesh","dob":null},"publicRole":"Introduced (16 Dec 2025) and piloted the VB-G RAM G Bill repealing MGNREGA; administers PM-KISAN, PMAY-G, NSAP, Drone Didi"},
  "pradhan": {"identity":{"cin":null,"din":null,"nse":null,"office":"Minister of Petroleum & Natural Gas (MoS IC 2014-05 → 2017-09; Cabinet 2017-09 → 2021-07)","dob":null},"publicRole":"Administering minister when PMUY was launched (May 2016) and audited by CAG (2019)"},
  "psu:hartron": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"State PSU named in the gazette as the app developer"},
  "sc": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"constitutional court"},
  "wel:aaditya-thackeray": {"identity":{"cin":null,"din":null,"nse":null,"office":"MLA Worli, Maharashtra; former Minister of Tourism and Environment (2019-12→2022-06); Shiv Sena (UBT) leader","dob":null},"publicRole":"MLA; former state minister; Shiv Sena (UBT)"},
  "wel:aditi-tatkare": {"identity":{"cin":null,"din":null,"nse":null,"office":"Minister of Women and Child Development, Maharashtra, 2023-07→","dob":null},"publicRole":"Minister administering Ladki Bahin; announced beneficiary removals"},
  "wel:aea-journals": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Publisher of Muralidharan & Prakash (2017)"},
  "wel:airtel-payments-bank": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Payments bank subsidiary of Bharti Airtel; BC network"},
  "wel:ajit-pawar": {"identity":{"cin":null,"din":null,"nse":null,"office":"Deputy Chief Minister and Finance Minister of Maharashtra, 2023-07 to present","dob":null},"publicRole":"Deputy CM / Finance Minister, NCP (Ajit Pawar faction)"},
  "wel:akhilesh-yadav": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Uttar Pradesh, 2012-03-15→2017-03-19; Samajwadi Party president","dob":null},"publicRole":"Chief Minister of Uttar Pradesh, 2012-03-15→2017-03-19; Samajwadi Party president; SP"},
  "wel:amar-ujala": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Private Hindi daily"},
  "wel:amarinder-singh": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister, Punjab, 2017-03-16→2021-09-18","dob":null},"publicRole":"CM; 2017 crop loan waiver"},
  "wel:arun-jaitley": {"identity":{"cin":null,"din":null,"nse":null,"office":"Union Finance Minister, 2014-05-26 → 2019-05-30 (tenure dates from general record; the source opened confirms him as FM in Feb 2017)","dob":null},"publicRole":"FM under whom PMJDY/DBT scaled; allocated MGNREGA ₹48,000 cr in Budget 2017-18"},
  "wel:arvind-kejriwal": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Delhi, 2013-12-28 to 2014-02-14, 2015-02-14 to 2024-09-17","dob":null},"publicRole":"Chief Minister, AAP"},
  "wel:ashish-sood": {"identity":{"cin":null,"din":null,"nse":null,"office":"Power Minister, Delhi, 2025-02→","dob":null},"publicRole":"Continued the AAP-era subsidy under the BJP government"},
  "wel:ashok-gehlot": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Rajasthan, 1998-12 to 2003-12, 2008-12 to 2013-12, 2018-12-17 to 2023-12-15","dob":null},"publicRole":"Chief Minister, INC"},
  "wel:ashwini-upadhyay": {"identity":{"cin":null,"din":null,"nse":null,"office":"Former spokesperson, BJP Delhi (dates not established); petitioner-in-person, W.P.(C) 43/2022 filed 2022-01-22","dob":null},"publicRole":"Party officer (former BJP Delhi spokesperson, per LiveLaw and SCO) and named petitioner in a public Supreme Court record"},
  "wel:atif-aqueel": {"identity":{"cin":null,"din":null,"nse":null,"office":"MLA, Bhopal North, Madhya Pradesh Legislative Assembly, 2023-12→","dob":null},"publicRole":"MLA, Bhopal North, Madhya Pradesh Legislative Assembly, 2023-12→; INC"},
  "wel:atishi": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Delhi, 2024-09-21 to 2025-02-20","dob":null},"publicRole":"Chief Minister, AAP"},
  "wel:basavaraj-bommai": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Karnataka, 2021-07-28 to 2023-05-20","dob":null},"publicRole":"Chief Minister, BJP"},
  "wel:bennett-coleman": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Largest recipient of central print ads"},
  "wel:bhagwant-mann": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Punjab, 2022-03-16 to present","dob":null},"publicRole":"Chief Minister, AAP"},
  "wel:bhajan-lal-sharma": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Rajasthan, 2023-12-15 to present","dob":null},"publicRole":"Chief Minister, BJP"},
  "wel:bhupendra-patel": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister, Gujarat, 2021-09-13→","dob":null},"publicRole":"CM; Namo Laxmi 2024"},
  "wel:bhupesh-baghel": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Chhattisgarh, 2018-12-17 to 2023-12-13","dob":null},"publicRole":"Chief Minister, INC"},
  "wel:bluekraft-digital-foundation": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"author of a government-circulated assessment"},
  "wel:bmtc": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Karnataka state transport undertaking"},
  "wel:c-joseph-vijay": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Tamil Nadu, 2026-05-10 to present","dob":null},"publicRole":"Chief Minister, TVK"},
  "wel:cesl": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"EESL subsidiary that ran the e-bus 'Grand Challenge' aggregated tender"},
  "wel:champai-soren": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Jharkhand, 2024-02-02 to 2024-07-03","dob":null},"publicRole":"Chief Minister, JMM (subsequently BJP)"},
  "wel:chandrima-bhattacharya": {"identity":{"cin":null,"din":null,"nse":null,"office":"Minister of State for Finance (independent charge), West Bengal, 2021→2026","dob":null},"publicRole":"Presented the Feb 2026 interim budget with the Lakshmir Bhandar hike"},
  "wel:class-ap-pensioners": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class: YSR Pension Kanuka / NTR Bharosa"},
  "wel:class-ap-school-mothers": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class: Amma Vodi / Thalliki Vandanam"},
  "wel:class-as-orunodoi-households": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class, not a person: Orunodoi beneficiaries (AS)"},
  "wel:class-br-mmry-women": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class, not a person: Mahila Rozgar Yojana beneficiaries (BR)"},
  "wel:class-ct-mahtari-vandan-women": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class, not a person: Mahtari Vandan beneficiaries (CT)"},
  "wel:class-dl-domestic-consumers": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class: 200-unit subsidy (~22 lakh zero bills)"},
  "wel:class-gj-farmers": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class: farm power subsidy"},
  "wel:class-hp-pyari-behna-women": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class, not a person: Indira Gandhi Pyari Behna beneficiaries (HP)"},
  "wel:class-hr-lado-lakshmi-women": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class, not a person: Lado Lakshmi beneficiaries (HR)"},
  "wel:class-jh-maiya-samman-women": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class, not a person: Maiya Samman beneficiaries (JH)"},
  "wel:class-ka-bpl-members": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class: Anna Bhagya (4.12 cr)"},
  "wel:class-ka-farmers": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class: 17.5 lakh eligible"},
  "wel:class-ka-gruha-lakshmi-women": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class, not a person: Gruha Lakshmi beneficiaries (KA)"},
  "wel:class-ka-households": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class: five guarantees"},
  "wel:class-mh-ladki-bahin-ad-vendors": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Class of government advertising contractors (unnamed); no individual vendor is identified or accused"},
  "wel:class-mh-ladki-bahin-women": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class, not a person: Ladki Bahin beneficiaries (MH)"},
  "wel:class-mh-lending-banks": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Counterparty class paid under the 2017 and 2019 waivers"},
  "wel:class-mp-ladli-behna-women": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class, not a person: Ladli Behna beneficiaries (MP)"},
  "wel:class-or-small-farmers-landless": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class: KALIA (65.64 lakh paid 2019-21)"},
  "wel:class-or-subhadra-women": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class, not a person: Subhadra beneficiaries (OR)"},
  "wel:class-pb-domestic-consumers": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class: 300-unit free power"},
  "wel:class-tg-landowning-farmers": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class: Rythu Bandhu/Bharosa (58.33 lakh)"},
  "wel:class-tg-large-landowners": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class, not a person: large landowners paid under Rythu Bandhu"},
  "wel:class-tn-kmut-women": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class, not a person: Kalaignar Magalir Urimai Thogai beneficiaries (TN)"},
  "wel:class-uct-states-12": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Class of state governments (public bodies), not a person"},
  "wel:class-wb-lakshmir-bhandar-women": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Beneficiary class, not a person: Lakshmir Bhandar beneficiaries (WB)"},
  "wel:csc-egovernance-services": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"MeitY-promoted SPV (Section 8 status disputed) running Common Service Centres and DigiPay AePS"},
  "wel:dbt-mission": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Coordinates Direct Benefit Transfer across 300+ central and 2,000+ state schemes"},
  "wel:delhi-dip": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Delhi government's advertising arm"},
  "wel:devendra-fadnavis": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Maharashtra, 2014-10-31 to 2019-11-12 and 2024-12-05 to present; Deputy Chief Minister, 2022-06 to 2024-12","dob":null},"publicRole":"Chief Minister, BJP"},
  "wel:dk-shivakumar": {"identity":{"cin":null,"din":null,"nse":null,"office":"Deputy Chief Minister, Karnataka, 2023-05-20→","dob":null},"publicRole":"Cabinet member approving guarantees"},
  "wel:dtc": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Delhi government bus undertaking"},
  "wel:eci": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Constitutional body enforcing the Model Code of Conduct"},
  "wel:eknath-shinde": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Maharashtra, 2022-06-30 to 2024-12-05","dob":null},"publicRole":"Chief Minister, Shiv Sena (Shinde faction)"},
  "wel:ekstep-foundation": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":null},
  "wel:elcot": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"State PSU; procured ~15 million TV sets 2006–10"},
  "wel:epw": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":null},
  "wel:fci": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Central grain procurement/stock agency"},
  "wel:fino-payments-bank": {"identity":{"cin":null,"din":null,"nse":"FINOPB","office":null,"dob":null},"publicRole":"Listed payments bank; ~19 lakh merchant/BC points; AePS and micro-ATM cash-out network"},
  "wel:greater-chennai-corporation": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Municipal body running Amma Unavagam"},
  "wel:h-m-revanna": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chairperson, Karnataka Guarantee Implementation Authority (in office Aug 2025)","dob":null},"publicRole":"Heads the state body implementing the five guarantee schemes; rebutted the CAG on record"},
  "wel:hemant-soren": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Jharkhand, 2019-12-29 to 2024-01-31 and 2024-07-04 to present","dob":null},"publicRole":"Chief Minister, JMM"},
  "wel:hewlett-packard-india": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Supplier of the UP 2012-13 free laptops"},
  "wel:himanta-biswa-sarma": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Assam, 2021-05 →; re-elected 2026","dob":null},"publicRole":"Host state CM when the 22nd PM-KISAN instalment was released from Guwahati (13 Mar 2026) weeks before the Assam poll"},
  "wel:ht-media": {"identity":{"cin":null,"din":null,"nse":"HTMEDIA","office":null,"dob":null},"publicRole":"Listed publisher"},
  "wel:ifpri": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":null},
  "wel:igidr": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Research institute; Rythu Bandhu land-records study (2020)"},
  "wel:india-post": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":null},
  "wel:india-post-payments-bank": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Department of Posts payments bank, launched 1 Sep 2018"},
  "wel:j-jayalalithaa": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Tamil Nadu, 2001-05 to 2001-09, 2002-03 to 2006-05, 2011-05 to 2014-09, 2015-05 to 2016-12 (died in office)","dob":null},"publicRole":"Chief Minister, AIADMK"},
  "wel:jagran-prakashan": {"identity":{"cin":null,"din":null,"nse":"JAGRAN","office":null,"dob":null},"publicRole":"Listed Hindi daily publisher"},
  "wel:jbm-auto": {"identity":{"cin":null,"din":null,"nse":"JBMA","office":null,"dob":null},"publicRole":"Listed bus and auto-component maker"},
  "wel:jyotiraditya-scindia": {"identity":{"cin":null,"din":null,"nse":null,"office":"Union Minister of Communications, 2024-06-10→","dob":null},"publicRole":"Union Minister of Communications, 2024-06-10→; BJP"},
  "wel:k-chandrashekar-rao": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Telangana, 2014-06-02 to 2023-12-07","dob":null},"publicRole":"Chief Minister, BRS"},
  "wel:kamal-nath": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Madhya Pradesh, 2018-12-17 to 2020-03-20","dob":null},"publicRole":"Chief Minister, INC"},
  "wel:kamlesh-paswan": {"identity":{"cin":null,"din":null,"nse":null,"office":"Minister of State, Rural Development, 2024-06 →","dob":null},"publicRole":"Gave MGNREGA allocation data in Rajya Sabha (25 Jul 2025)"},
  "wel:karnataka-rtcs": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"State transport undertakings reimbursed under Shakti"},
  "wel:kh-muniyappa": {"identity":{"cin":null,"din":null,"nse":null,"office":"Food and Civil Supplies Minister, Karnataka, 2023-05→","dob":null},"publicRole":"Administers Anna Bhagya; negotiated FCI rice at Rs 22.5/kg"},
  "wel:kn-balagopal": {"identity":{"cin":null,"din":null,"nse":null,"office":"Finance Minister, Kerala, 2021-05-20→2026-05","dob":null},"publicRole":"Sanctioned arrears instalments"},
  "wel:ksspl": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"State SPV that borrows and disburses welfare pensions"},
  "wel:kt-rajendra-balaji": {"identity":{"cin":null,"din":null,"nse":null,"office":"Special Programmes Implementation Minister, Tamil Nadu, 2011→2016","dob":null},"publicRole":"Administered the mixie-grinder-fan scheme"},
  "wel:kt-rama-rao": {"identity":{"cin":null,"din":null,"nse":null,"office":"Minister, Telangana, 2014→2023-12; BRS working president, 2021→","dob":null},"publicRole":"Opposition voice on Rythu Bandhu implementation"},
  "wel:kv-thomas": {"identity":{"cin":null,"din":null,"nse":null,"office":"Minister of State (Independent Charge), Consumer Affairs, Food & Public Distribution, 2011 → 2014-05; MP Ernakulam 2009-19","dob":null},"publicRole":"Minister piloting NFSA 2013"},
  "wel:lokniti-csds": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"academic survey body"},
  "wel:m-karunanidhi": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister, Tamil Nadu, 2006-05-13→2011-05-15 (also 1969–76, 1989–91, 1996–2001)","dob":null},"publicRole":"CM; free colour TV scheme 2006"},
  "wel:maharashtra-dgipr": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"State advertising arm"},
  "wel:mallu-bhatti-vikramarka": {"identity":{"cin":null,"din":null,"nse":null,"office":"Deputy Chief Minister and Finance Minister, Telangana, 2023-12→","dob":null},"publicRole":"Briefed bankers on loan-waiver phases"},
  "wel:mamata-banerjee": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of West Bengal, 2011-05-20 to 2026-05-09","dob":null},"publicRole":"Chief Minister, TMC"},
  "wel:manmohan-singh": {"identity":{"cin":null,"din":null,"nse":null,"office":"Union Finance Minister, 1991-06-21→1996-05-16 (under PM P.V. Narasimha Rao); Prime Minister of India, 2004-05-22 → 2014-05-26","dob":null},"publicRole":"Head of the UPA governments that enacted NREGA (2005), the 2008 loan waiver and NFSA (2013)"},
  "wel:manpreet-singh-badal": {"identity":{"cin":null,"din":null,"nse":null,"office":"Finance Minister of Punjab, 2017-03-16→2022-03","dob":null},"publicRole":"Finance Minister of Punjab, 2017-03-16→2022-03; INC (at the time)"},
  "wel:mk-stalin": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Tamil Nadu, 2021-05-07 to 2026-05-10","dob":null},"publicRole":"Chief Minister, DMK"},
  "wel:mohan-charan-majhi": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Odisha, 2024-06-12 to present","dob":null},"publicRole":"Chief Minister, BJP"},
  "wel:mohan-yadav": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Madhya Pradesh, 2023-12-13 to present","dob":null},"publicRole":"Chief Minister, BJP"},
  "wel:mp-jansampark": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"State advertising arm"},
  "wel:n-chandrababu-naidu": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Andhra Pradesh, 2014-06 to 2019-05 and 2024-06-12 to present","dob":null},"publicRole":"Chief Minister, TDP"},
  "wel:nandan-nilekani": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chairman, Unique Identification Authority of India (cabinet rank), 2009-07 → 2014-03; INC candidate Bangalore South 2014; Infosys chairman 2017 →; chairman EkStep Foundation","dob":null},"publicRole":"Architect of Aadhaar, the identity layer of DBT/JAM; his foundation EkStep gave technical support to PM-KISAN's chatbot"},
  "wel:naveen-patnaik": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Odisha, 2000-03-05 to 2024-06-12","dob":null},"publicRole":"Chief Minister, BJD"},
  "wel:nayab-singh-saini": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister, Haryana, 2024-03-12→","dob":null},"publicRole":"Chief Minister who notified Lado Lakshmi (Sep 2025) after the 2024 manifesto promise"},
  "wel:nber": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":null},
  "wel:nirmala-bhuria": {"identity":{"cin":null,"din":null,"nse":null,"office":"Minister for Women and Child Development, Madhya Pradesh, 2023-12-25→","dob":null},"publicRole":"Minister for Women and Child Development, Madhya Pradesh, 2023-12-25→; BJP"},
  "wel:niti-aayog": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":null},
  "wel:nitish-kumar": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Bihar, 2005-11-24 to 2014-05, 2015-02 to 2025 (across several NDA/Grand Alliance realignments), and continuing after the 2025 election","dob":null},"publicRole":"Chief Minister, JD(U)"},
  "wel:npci": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Not-for-profit umbrella payments body owned by banks; runs Aadhaar Payment Bridge (APB) and AePS"},
  "wel:omcs": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"State-owned LPG marketers who issue PMUY connections and are reimbursed by GoI"},
  "wel:p-chidambaram": {"identity":{"cin":null,"din":null,"nse":null,"office":"Union Finance Minister, 2004-05-22 → 2008-11-30 (and 2012-07-31 → 2014-05-26)","dob":null},"publicRole":"Presented Budget 2008-09 containing the ₹60,000 cr farm debt waiver"},
  "wel:pfms": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Office of the Controller General of Accounts, Ministry of Finance — payment and reconciliation platform for DBT"},
  "wel:pinarayi-vijayan": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister, Kerala, 2016-05-25→2026-05","dob":null},"publicRole":"CM; welfare pension arrears settlement"},
  "wel:pmi-electro-mobility": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Private e-bus maker/operator"},
  "wel:prasad-lad": {"identity":{"cin":null,"din":null,"nse":null,"office":"MLC, Maharashtra Legislative Council; BJP Maharashtra vice-president","dob":null},"publicRole":"MLC, Maharashtra Legislative Council; BJP Maharashtra vice-president; BJP"},
  "wel:prs-legislative-research": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"policy research body"},
  "wel:ptr-palanivel-thiaga-rajan": {"identity":{"cin":null,"din":null,"nse":null,"office":"Finance Minister, Tamil Nadu, 2021-05→2023-05","dob":null},"publicRole":"Presented 2022-23 budget with Rs 1,520 cr for free bus travel"},
  "wel:raghuvansh-prasad-singh": {"identity":{"cin":null,"din":null,"nse":null,"office":"Union Cabinet Minister, Rural Development, 2004-05-24 → 2009-05","dob":null},"publicRole":"RD minister who piloted NREGA 2005; RJD MP from Vaishali; died 13 Sep 2020"},
  "wel:ramalinga-reddy": {"identity":{"cin":null,"din":null,"nse":null,"office":"Transport Minister, Karnataka, 2023-05→","dob":null},"publicRole":"Announced Shakti rollout"},
  "wel:raman-singh": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister, Chhattisgarh, 2003-12-07→2018-12-17","dob":null},"publicRole":"CM; Rs 1–2/kg rice, \"Chaur wale baba\""},
  "wel:rameswar-teli": {"identity":{"cin":null,"din":null,"nse":null,"office":"Minister of State, Petroleum & Natural Gas, 2021-07 → 2024-06","dob":null},"publicRole":"Tabled state-wise PMUY refill data (Dec 2021)"},
  "wel:ramnath-thakur": {"identity":{"cin":null,"din":null,"nse":null,"office":"Minister of State, Agriculture & Farmers' Welfare, 2024-06 →","dob":null},"publicRole":"Answered Lok Sabha Q.358 on PM-KISAN ineligible beneficiaries (2 Dec 2025)"},
  "wel:rb-udayakumar": {"identity":{"cin":null,"din":null,"nse":null,"office":"MLA Thirumangalam; AIADMK deputy leader in the TN Assembly; former Revenue Minister","dob":null},"publicRole":"MLA Thirumangalam; AIADMK deputy leader in the TN Assembly; former Revenue Minister; AIADMK"},
  "wel:rbi": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"central bank / fiscal monitor"},
  "wel:rekha-gupta": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Delhi, 2025-02-20 to present","dob":null},"publicRole":"Chief Minister, BJP"},
  "wel:revanth-reddy": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Telangana, 2023-12-07 to present","dob":null},"publicRole":"Chief Minister, INC"},
  "wel:s-regupathy": {"identity":{"cin":null,"din":null,"nse":null,"office":"Minister for Law, Courts and Prisons, Tamil Nadu, 2021-05-07→","dob":null},"publicRole":"Minister for Law, Courts and Prisons, Tamil Nadu, 2021-05-07→; DMK"},
  "wel:sachin-pilot": {"identity":{"cin":null,"din":null,"nse":null,"office":"Deputy Chief Minister, Rajasthan, 2018-12-17→2020-07","dob":null},"publicRole":"Pre-order statement on the waiver"},
  "wel:sajjala-ramakrishna-reddy": {"identity":{"cin":null,"din":null,"nse":null,"office":"General Secretary, YSR Congress Party; Adviser (Public Affairs) to AP Government 2019→2024","dob":null},"publicRole":"General Secretary, YSR Congress Party; Adviser (Public Affairs) to AP Government 2019→2024; YSRCP"},
  "wel:siddaramaiah": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Karnataka, 2013-05-13 to 2018-05-17 and 2023-05-20 to present","dob":null},"publicRole":"Chief Minister, INC"},
  "wel:state-farm-loan-waivers-2014-19": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Instrument class audited by the RBI Internal Working Group"},
  "wel:sukhvinder-singh-sukhu": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Himachal Pradesh, 2022-12-11 to present","dob":null},"publicRole":"Chief Minister, INC"},
  "wel:sunil-tatkare": {"identity":{"cin":null,"din":null,"nse":null,"office":"MP Raigad; President, NCP (Ajit Pawar) Maharashtra unit, 2023-07→","dob":null},"publicRole":"MP Raigad; President, NCP (Ajit Pawar) Maharashtra unit, 2023-07→; NCP"},
  "wel:supriya-sule": {"identity":{"cin":null,"din":null,"nse":null,"office":"Member of Parliament (Lok Sabha), Baramati, 2009→; NCP (Sharadchandra Pawar) working president","dob":null},"publicRole":"Member of Parliament; NCP (SP)"},
  "wel:suvendu-adhikari": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of West Bengal, 2026-05 →","dob":null},"publicRole":"Led BJP in the 2026 WB assembly election; hosted the 23rd PM-KISAN release at Tarakeswar"},
  "wel:switch-mobility": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Ashok Leyland e-bus subsidiary"},
  "wel:t-news": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Telugu news channel widely described as BRS-aligned"},
  "wel:tekchand-sawarkar": {"identity":{"cin":null,"din":null,"nse":null,"office":"MLA Kamthi, 2019→2024","dob":null},"publicRole":"Ruling-party MLA whose 'jugaad for votes' remark was cited by the opposition"},
  "wel:telangana-ipr": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"State advertising arm"},
  "wel:tml-cv-mobility-solutions": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Wholly owned Tata Motors subsidiary operating e-bus GCC contracts"},
  "wel:tn-state-transport-undertakings": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"State bus corporations reimbursed for free women's travel"},
  "wel:tummala-nageswara-rao": {"identity":{"cin":null,"din":null,"nse":null,"office":"Agriculture Minister, Telangana, 2023-12→","dob":null},"publicRole":"Administers Rythu Bharosa and loan waiver"},
  "wel:uddhav-thackeray": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister, Maharashtra, 2019-11-28→2022-06-30","dob":null},"publicRole":"CM; MJPSKY 2019 waiver"},
  "wel:uidai": {"identity":{"cin":null,"din":null,"nse":null,"office":null,"dob":null},"publicRole":"Aadhaar authority; licenses eKYC users"},
  "wel:varla-ramaiah": {"identity":{"cin":null,"din":null,"nse":null,"office":"Politburo member, Telugu Desam Party","dob":null},"publicRole":"Politburo member, Telugu Desam Party; TDP"},
  "wel:vasundhara-raje": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Rajasthan, 2003-12 to 2008-12, 2013-12 to 2018-12","dob":null},"publicRole":"Chief Minister, BJP"},
  "wel:vd-satheesan": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister, Kerala, 2026-05→; Leader of Opposition 2021–26","dob":null},"publicRole":"UDF leader who won 2026"},
  "wel:vijay-inder-singla": {"identity":{"cin":null,"din":null,"nse":null,"office":"School Education Minister of Punjab, 2018-04→2022-03","dob":null},"publicRole":"School Education Minister of Punjab, 2018-04→2022-03; INC (at the time)"},
  "wel:vijay-wadettiwar": {"identity":{"cin":null,"din":null,"nse":null,"office":"MLA Brahmapuri, Maharashtra; Leader of the Opposition, Maharashtra Legislative Assembly, 2023-08→2024-11","dob":null},"publicRole":"MLA; former Leader of Opposition; INC"},
  "wel:vishnu-deo-sai": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Chhattisgarh, 2023-12-13 to present","dob":null},"publicRole":"Chief Minister, BJP"},
  "wel:yogi-adityanath": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister, Uttar Pradesh, 2017-03-19→","dob":null},"publicRole":"CM; Rs 36,000 cr waiver at first cabinet; Kanya Sumangala"},
  "wel:ys-jagan-mohan-reddy": {"identity":{"cin":null,"din":null,"nse":null,"office":"Chief Minister of Andhra Pradesh, 2019-05-30 to 2024-06-12","dob":null},"publicRole":"Chief Minister, YSRCP"},
};

export const WELFARE_META: FleetMeta = {
  "fleet": "welfare",
  "generator": "scripts/assemble-fleet.mjs",
  "generatorVersion": "1.4.1",
  "asOf": "2026-09-25",
  "runId": "run-e3cc0f891306",
  "empty": false,
  "note": null,
  "inputs": [
    "welfare/AUDIT.json",
    "welfare/RECONCILIATION.json",
    "welfare/central.json",
    "welfare/elections-timing.json",
    "welfare/fiscal-results.json",
    "welfare/literature.json",
    "welfare/state-cash-other.json",
    "welfare/vendors.json",
    "welfare/women-cash.json"
  ],
  "files": [
    {
      "file": "welfare/central.json",
      "domain": "central",
      "asOf": "2026-09-25",
      "entities": 43,
      "claims": 56,
      "killed": 1
    },
    {
      "file": "welfare/elections-timing.json",
      "domain": "elections-timing",
      "asOf": "2026-09-25",
      "entities": 51,
      "claims": 35,
      "killed": 2
    },
    {
      "file": "welfare/fiscal-results.json",
      "domain": "fiscal-results",
      "asOf": "2026-09-25",
      "entities": 20,
      "claims": 25,
      "killed": 1
    },
    {
      "file": "welfare/literature.json",
      "domain": "literature",
      "asOf": "2026-09-25",
      "entities": 18,
      "claims": 26,
      "killed": 0
    },
    {
      "file": "welfare/state-cash-other.json",
      "domain": "state-cash-other",
      "asOf": "2026-09-25",
      "entities": 81,
      "claims": 83,
      "killed": 0
    },
    {
      "file": "welfare/vendors.json",
      "domain": "vendors",
      "asOf": "2026-09-25",
      "entities": 84,
      "claims": 47,
      "killed": 0
    },
    {
      "file": "welfare/women-cash.json",
      "domain": "women-cash",
      "asOf": "2026-09-25",
      "entities": 66,
      "claims": 63,
      "killed": 0
    }
  ],
  "counts": {
    "files": 7,
    "nodes": 286,
    "claimsIn": 335,
    "edges": 335,
    "killed": 4,
    "excluded": 0,
    "contrasAdded": 4,
    "downgradeVerdicts": 2,
    "benefits": 33,
    "voids": 39,
    "narratives": 45,
    "baseRates": 50,
    "schemes": 78,
    "elections": 105,
    "coverage": 70
  },
  "reconciliation": {
    "mappings": [
      {
        "from": "agency:bombay-high-court",
        "to": "wel:bombay-high-court",
        "note": "Same court (Bombay High Court, the High Court of Maharashtra and Goa); both records describe its Aug 2024 dismissal of the Ladki Bahin PIL. No inventory/Atlas id; one file each, first file in name order (literature) wins; the agency: prefix is also outside the contract's fleet prefixes."
      },
      {
        "from": "agency:lokniti-csds",
        "to": "wel:lokniti-csds",
        "note": "Same survey programme (Lokniti-CSDS post-poll surveys); wel:lokniti-csds is used by three files (central, literature, vendors)."
      },
      {
        "from": "agency:prs-legislative-research",
        "to": "wel:prs-legislative-research",
        "note": "Same organisation (PRS Legislative Research, author of State of State Finances 2025); wel:prs-legislative-research is used by three files."
      },
      {
        "from": "agency:rbi",
        "to": "wel:rbi",
        "note": "Same institution (Reserve Bank of India, State Finances study); wel:rbi is used by three files (fiscal-results, literature, state-cash-other)."
      },
      {
        "from": "agy:cag",
        "to": "cag",
        "note": "Same constitutional auditor (Comptroller and Auditor General of India); the Money-Trail Atlas already has node \"cag\" (CAG), which women-cash already reused."
      },
      {
        "from": "party:aitc",
        "to": "party:tmc",
        "note": "Same party (All India Trinamool Congress, WB ruling party 2011–26); alias \"TMC\" collided. party:tmc is used by three files (elections-timing, fiscal-results, state-cash-other)."
      },
      {
        "from": "party:bjp",
        "to": "bjp",
        "note": "Same party (Bharatiya Janata Party); the Money-Trail Atlas node \"bjp\" exists (women-cash already reused it). Atlas id preferred over the fleet id used by six files."
      },
      {
        "from": "scheme:br-mukhyamantri-mahila-rozgar",
        "to": "scheme:br-mahila-rozgar-yojana",
        "note": "Same scheme (Bihar Mukhyamantri Mahila Rozgar/Rojgar Yojana, ₹10,000 to ~75 lakh women launched by the PM on 2025-09-26); alias \"MMRY\" collided. Tie (1–1); first file in name order (elections-timing) wins."
      },
      {
        "from": "scheme:dl-mahila-samman-aap",
        "to": "scheme:dl-mahila-samman-promise-2025",
        "note": "Same scheme (AAP's Mukhya Mantri Mahila Samman Yojana, Delhi: ₹1,000 approved Dec 2024, ₹2,100 promised, never paid); alias \"Mahila Samman Yojana\" collided. Tie (1–1); first file in name order (elections-timing) wins. The elections-timing record had folded in the BJP's rival Mahila Samriddhi promise: its name, the \"Mahila Samridhi Yojana\" alias and the Rekha Gupta \"administers\" row were moved to scheme:dl-mahila-samriddhi (a different scheme, different party, different amount)."
      },
      {
        "from": "scheme:pds-nfsa",
        "to": "scheme:in-nfsa",
        "note": "Same statute/programme (National Food Security Act 2013 and its Targeted PDS); scheme:in-nfsa is used by two files (central, fiscal-results)."
      },
      {
        "from": "scheme:pmgkay-free-grain",
        "to": "scheme:pmgkay",
        "note": "Same scheme (Pradhan Mantri Garib Kalyan Anna Yojana, free NFSA grain); scheme:pmgkay is used by two files (central, elections-timing)."
      },
      {
        "from": "scheme:ujjwala",
        "to": "scheme:pm-ujjwala",
        "note": "Same scheme (Pradhan Mantri Ujjwala Yojana, MoPNG, launched May 2016); alias \"Ujjwala\" collided. Tie on file count (2–2); the first file in name order (central) uses scheme:pm-ujjwala."
      },
      {
        "from": "wel:ap-village-volunteer-system",
        "to": "scheme:ap-village-volunteers",
        "note": "Same real-world system in the same file (vendors.json): the AP village/ward volunteer system, 2.56 lakh volunteers at ₹5,000/month, ~₹1,536 cr/yr, EC-restricted during the 2024 MCC — every fact on the entity record is already on the scheme record. The duplicate entity record was folded into the scheme (sources unioned) and removed."
      },
      {
        "from": "wel:bombay-high-court",
        "to": "bombay-hc",
        "note": "cross-fleet reconciliation 2026-09-26: A court is not an energy/welfare entity; the Atlas holds the courts (sc, and from 2026-09-26 delhi-hc, bombay-hc, madras-hc, allahabad-hc, ap-hc, jharkhand-hc, sikkim-hc — ty agency, fam enforce, st of the seat). Facts and sources of the fleet record were copied into the Atlas node in src/graph/data.ts; the fleet file keeps its record under the Atlas id (the Atlas record wins in the merged graph). Id rewrite only. Used by welfare/literature.json, welfare/women-cash.json and capital/rules-regulators.json (and now energy/oilgas.json c035)."
      },
      {
        "from": "wel:cag",
        "to": "cag",
        "note": "Same constitutional auditor (Comptroller and Auditor General of India); Atlas node \"cag\" exists and is preferred over the fleet id."
      },
      {
        "from": "wel:dharmendra-pradhan",
        "to": "pradhan",
        "note": "Same person, confirmed by office-with-dates: Dharmendra Pradhan, Union Minister of Petroleum & Natural Gas 2014–2021 (Atlas node \"pradhan\", sub \"Petroleum 2014–21\"; welfare records: MoS IC 2014-05→2017-09, Cabinet 2017-09→2021-07). Atlas id preferred."
      },
      {
        "from": "wel:jayalalithaa",
        "to": "wel:j-jayalalithaa",
        "note": "Same person, confirmed by office-with-dates: J. Jayalalithaa, Chief Minister of Tamil Nadu 2011-05-16→2014-09-27 and 2015-05-23→2016-12-05 (AIADMK) in both records. wel:j-jayalalithaa is used by two files."
      },
      {
        "from": "wel:shivraj-singh-chouhan",
        "to": "pol:shivraj-singh-chouhan",
        "note": "cross-fleet reconciliation 2026-09-26: same person (Shivraj Singh Chouhan — CM Madhya Pradesh 2005-11-29→2018-12 and 2020-03-23→2023-12-13; Union Minister of Agriculture & Farmers' Welfare and Rural Development from 2024-06-10 — the offices and dates match the cabinet roster). pol:shivraj-singh-chouhan is the national inventory id (research/raw/cabinet.json → src/graph/build.ts) and ngo/darpan-welfare-join.json already uses it; the roster record wins in the merged graph and the welfare records stay as copies under the inventory id. Rewritten in entities, claims, ministers[].personId and announced.byPersonId."
      },
      {
        "from": "wel:sun-tv-network",
        "to": "co:sun-tv-network",
        "note": "Same listed company (Sun TV Network Ltd, NSE: SUNTV, Maran family); inventory id co:sun-tv-network exists."
      },
      {
        "from": "wel:supreme-court-of-india",
        "to": "sc",
        "note": "Same court (Supreme Court of India); Money-Trail Atlas node \"sc\" exists and is preferred (energy fleet uses it too)."
      }
    ],
    "merged": [
      {
        "id": "bjp",
        "ids": [
          "bjp",
          "bjp",
          "bjp",
          "bjp",
          "bjp",
          "bjp",
          "bjp"
        ],
        "files": [
          "welfare/central.json",
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/literature.json",
          "welfare/state-cash-other.json",
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "publicRole",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "bombay-hc",
        "ids": [
          "bombay-hc",
          "bombay-hc"
        ],
        "files": [
          "welfare/literature.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": []
      },
      {
        "id": "cag",
        "ids": [
          "cag",
          "cag",
          "cag",
          "cag",
          "cag",
          "cag"
        ],
        "files": [
          "welfare/central.json",
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/state-cash-other.json",
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "publicRole",
            "file": "welfare/elections-timing.json"
          },
          {
            "field": "st",
            "file": "welfare/vendors.json"
          }
        ]
      },
      {
        "id": "co:state-bank-of-india",
        "ids": [
          "co:state-bank-of-india",
          "co:state-bank-of-india"
        ],
        "files": [
          "welfare/central.json",
          "welfare/vendors.json"
        ],
        "filledFrom": [
          {
            "field": "publicRole",
            "file": "welfare/vendors.json"
          }
        ]
      },
      {
        "id": "min:ministry-of-consumer-affairs-food-and-public-distribution",
        "ids": [
          "min:ministry-of-consumer-affairs-food-and-public-distribution",
          "min:ministry-of-consumer-affairs-food-and-public-distribution"
        ],
        "files": [
          "welfare/central.json",
          "welfare/vendors.json"
        ],
        "filledFrom": [
          {
            "field": "st",
            "file": "welfare/vendors.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/vendors.json"
          }
        ]
      },
      {
        "id": "min:ministry-of-finance",
        "ids": [
          "min:ministry-of-finance",
          "min:ministry-of-finance"
        ],
        "files": [
          "welfare/central.json",
          "welfare/vendors.json"
        ],
        "filledFrom": [
          {
            "field": "st",
            "file": "welfare/vendors.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/vendors.json"
          }
        ]
      },
      {
        "id": "min:ministry-of-petroleum-and-natural-gas",
        "ids": [
          "min:ministry-of-petroleum-and-natural-gas",
          "min:ministry-of-petroleum-and-natural-gas"
        ],
        "files": [
          "welfare/central.json",
          "welfare/vendors.json"
        ],
        "filledFrom": [
          {
            "field": "st",
            "file": "welfare/vendors.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/vendors.json"
          }
        ]
      },
      {
        "id": "party:aap",
        "ids": [
          "party:aap",
          "party:aap",
          "party:aap",
          "party:aap",
          "party:aap"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/state-cash-other.json",
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "identity",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "party:aiadmk",
        "ids": [
          "party:aiadmk",
          "party:aiadmk",
          "party:aiadmk",
          "party:aiadmk"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/literature.json",
          "welfare/state-cash-other.json",
          "welfare/vendors.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/literature.json"
          },
          {
            "field": "st",
            "file": "welfare/literature.json"
          },
          {
            "field": "identity",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "party:bjd",
        "ids": [
          "party:bjd",
          "party:bjd"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "identity",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "party:brs",
        "ids": [
          "party:brs",
          "party:brs",
          "party:brs",
          "party:brs"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/state-cash-other.json",
          "welfare/vendors.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "identity",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "party:dmk",
        "ids": [
          "party:dmk",
          "party:dmk",
          "party:dmk",
          "party:dmk",
          "party:dmk",
          "party:dmk"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/literature.json",
          "welfare/state-cash-other.json",
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "st",
            "file": "welfare/literature.json"
          },
          {
            "field": "identity",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "party:inc",
        "ids": [
          "party:inc",
          "party:inc",
          "party:inc",
          "party:inc",
          "party:inc",
          "party:inc",
          "party:inc"
        ],
        "files": [
          "welfare/central.json",
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/literature.json",
          "welfare/state-cash-other.json",
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "publicRole",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "party:jdu",
        "ids": [
          "party:jdu",
          "party:jdu",
          "party:jdu"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "identity",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "party:jmm",
        "ids": [
          "party:jmm",
          "party:jmm",
          "party:jmm"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "st",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "identity",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "party:ncp",
        "ids": [
          "party:ncp",
          "party:ncp"
        ],
        "files": [
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "st",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "party:shiv-sena",
        "ids": [
          "party:shiv-sena",
          "party:shiv-sena"
        ],
        "files": [
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "st",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "party:shiv-sena-ubt",
        "ids": [
          "party:shiv-sena-ubt",
          "party:shiv-sena-ubt"
        ],
        "files": [
          "welfare/state-cash-other.json",
          "welfare/vendors.json"
        ],
        "filledFrom": []
      },
      {
        "id": "party:tdp",
        "ids": [
          "party:tdp",
          "party:tdp",
          "party:tdp",
          "party:tdp"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json",
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "identity",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "party:tmc",
        "ids": [
          "party:tmc",
          "party:tmc",
          "party:tmc",
          "party:tmc"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/state-cash-other.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "identity",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "party:ysrcp",
        "ids": [
          "party:ysrcp",
          "party:ysrcp",
          "party:ysrcp",
          "party:ysrcp"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/state-cash-other.json",
          "welfare/vendors.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "identity",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "pol:hardeep-singh-puri",
        "ids": [
          "pol:hardeep-singh-puri",
          "pol:hardeep-singh-puri"
        ],
        "files": [
          "welfare/central.json",
          "welfare/vendors.json"
        ],
        "filledFrom": []
      },
      {
        "id": "pol:narendra-modi",
        "ids": [
          "pol:narendra-modi",
          "pol:narendra-modi",
          "pol:narendra-modi",
          "pol:narendra-modi"
        ],
        "files": [
          "welfare/central.json",
          "welfare/fiscal-results.json",
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": []
      },
      {
        "id": "pol:nirmala-sitharaman",
        "ids": [
          "pol:nirmala-sitharaman",
          "pol:nirmala-sitharaman"
        ],
        "files": [
          "welfare/central.json",
          "welfare/vendors.json"
        ],
        "filledFrom": []
      },
      {
        "id": "pol:pankaj-chaudhary",
        "ids": [
          "pol:pankaj-chaudhary",
          "pol:pankaj-chaudhary"
        ],
        "files": [
          "welfare/central.json",
          "welfare/vendors.json"
        ],
        "filledFrom": []
      },
      {
        "id": "pol:pralhad-joshi",
        "ids": [
          "pol:pralhad-joshi",
          "pol:pralhad-joshi",
          "pol:pralhad-joshi"
        ],
        "files": [
          "welfare/central.json",
          "welfare/state-cash-other.json",
          "welfare/vendors.json"
        ],
        "filledFrom": []
      },
      {
        "id": "pol:shivraj-singh-chouhan",
        "ids": [
          "pol:shivraj-singh-chouhan",
          "pol:shivraj-singh-chouhan",
          "pol:shivraj-singh-chouhan",
          "pol:shivraj-singh-chouhan",
          "pol:shivraj-singh-chouhan",
          "pol:shivraj-singh-chouhan"
        ],
        "files": [
          "welfare/central.json",
          "welfare/elections-timing.json",
          "welfare/literature.json",
          "welfare/state-cash-other.json",
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "pradhan",
        "ids": [
          "pradhan",
          "pradhan"
        ],
        "files": [
          "welfare/central.json",
          "welfare/elections-timing.json"
        ],
        "filledFrom": []
      },
      {
        "id": "sc",
        "ids": [
          "sc",
          "sc"
        ],
        "files": [
          "welfare/fiscal-results.json",
          "welfare/literature.json"
        ],
        "filledFrom": [
          {
            "field": "st",
            "file": "welfare/literature.json"
          },
          {
            "field": "identity",
            "file": "welfare/literature.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/literature.json"
          }
        ]
      },
      {
        "id": "scheme:ap-ysr-amma-vodi",
        "ids": [
          "scheme:ap-ysr-amma-vodi",
          "scheme:ap-ysr-amma-vodi"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json"
        ],
        "filledFrom": [
          {
            "field": "approved",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "scheme:ap-ysr-rythu-bharosa",
        "ids": [
          "scheme:ap-ysr-rythu-bharosa",
          "scheme:ap-ysr-rythu-bharosa",
          "scheme:ap-ysr-rythu-bharosa"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/state-cash-other.json"
        ],
        "filledFrom": [
          {
            "field": "benefit.asOf",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "approved",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "scheme:as-orunodoi",
        "ids": [
          "scheme:as-orunodoi",
          "scheme:as-orunodoi",
          "scheme:as-orunodoi"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "benefit.asOf",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "approved",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "scheme:br-balika-cycle",
        "ids": [
          "scheme:br-balika-cycle",
          "scheme:br-balika-cycle",
          "scheme:br-balika-cycle"
        ],
        "files": [
          "welfare/fiscal-results.json",
          "welfare/literature.json",
          "welfare/state-cash-other.json"
        ],
        "filledFrom": [
          {
            "field": "eligibility",
            "file": "welfare/literature.json"
          },
          {
            "field": "announced",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "approved",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "launched",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "electionContext",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "scheme:br-mahila-rozgar-yojana",
        "ids": [
          "scheme:br-mahila-rozgar-yojana",
          "scheme:br-mahila-rozgar-yojana"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "approved",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "scheme:ct-farm-loan-waiver-2018",
        "ids": [
          "scheme:ct-farm-loan-waiver-2018",
          "scheme:ct-farm-loan-waiver-2018"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json"
        ],
        "filledFrom": []
      },
      {
        "id": "scheme:ct-mahtari-vandan",
        "ids": [
          "scheme:ct-mahtari-vandan",
          "scheme:ct-mahtari-vandan"
        ],
        "files": [
          "welfare/fiscal-results.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "announced",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "approved",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "launched",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "electionContext",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "scheme:dl-free-power-200-units",
        "ids": [
          "scheme:dl-free-power-200-units",
          "scheme:dl-free-power-200-units"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json"
        ],
        "filledFrom": [
          {
            "field": "approved",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "scheme:dl-mahila-samman-promise-2025",
        "ids": [
          "scheme:dl-mahila-samman-promise-2025",
          "scheme:dl-mahila-samman-promise-2025"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "approved",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "launched",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "scheme:dl-mahila-samriddhi",
        "ids": [
          "scheme:dl-mahila-samriddhi",
          "scheme:dl-mahila-samriddhi"
        ],
        "files": [
          "welfare/fiscal-results.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "announced",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "approved",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "launched",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "electionContext",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "scheme:hp-indira-gandhi-pyari-behna",
        "ids": [
          "scheme:hp-indira-gandhi-pyari-behna",
          "scheme:hp-indira-gandhi-pyari-behna"
        ],
        "files": [
          "welfare/fiscal-results.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "announced",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "approved",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "launched",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "electionContext",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "scheme:hr-lado-lakshmi",
        "ids": [
          "scheme:hr-lado-lakshmi",
          "scheme:hr-lado-lakshmi"
        ],
        "files": [
          "welfare/fiscal-results.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "announced",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "approved",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "launched",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "electionContext",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "scheme:in-nfsa",
        "ids": [
          "scheme:in-nfsa",
          "scheme:in-nfsa",
          "scheme:in-nfsa"
        ],
        "files": [
          "welfare/central.json",
          "welfare/fiscal-results.json",
          "welfare/literature.json"
        ],
        "filledFrom": []
      },
      {
        "id": "scheme:jh-maiya-samman",
        "ids": [
          "scheme:jh-maiya-samman",
          "scheme:jh-maiya-samman",
          "scheme:jh-maiya-samman"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "benefit.asOf",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "approved",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "scheme:ka-gruha-lakshmi",
        "ids": [
          "scheme:ka-gruha-lakshmi",
          "scheme:ka-gruha-lakshmi",
          "scheme:ka-gruha-lakshmi"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "benefit.asOf",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "approved",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "scheme:mgnrega",
        "ids": [
          "scheme:mgnrega",
          "scheme:mgnrega",
          "scheme:mgnrega",
          "scheme:mgnrega"
        ],
        "files": [
          "welfare/central.json",
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/literature.json"
        ],
        "filledFrom": []
      },
      {
        "id": "scheme:mh-ladki-bahin",
        "ids": [
          "scheme:mh-ladki-bahin",
          "scheme:mh-ladki-bahin",
          "scheme:mh-ladki-bahin",
          "scheme:mh-ladki-bahin",
          "scheme:mh-ladki-bahin"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/literature.json",
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "benefit.asOf",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "approved",
            "file": "welfare/vendors.json"
          }
        ]
      },
      {
        "id": "scheme:mp-ladli-behna",
        "ids": [
          "scheme:mp-ladli-behna",
          "scheme:mp-ladli-behna",
          "scheme:mp-ladli-behna",
          "scheme:mp-ladli-behna",
          "scheme:mp-ladli-behna"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/literature.json",
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "benefit.asOf",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "announced",
            "file": "welfare/vendors.json"
          },
          {
            "field": "approved",
            "file": "welfare/vendors.json"
          }
        ]
      },
      {
        "id": "scheme:mp-ladli-laxmi",
        "ids": [
          "scheme:mp-ladli-laxmi",
          "scheme:mp-ladli-laxmi"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json"
        ],
        "filledFrom": [
          {
            "field": "approved",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "benefit.amount",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "scheme:or-kalia",
        "ids": [
          "scheme:or-kalia",
          "scheme:or-kalia"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json"
        ],
        "filledFrom": [
          {
            "field": "approved",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "scheme:or-subhadra",
        "ids": [
          "scheme:or-subhadra",
          "scheme:or-subhadra",
          "scheme:or-subhadra"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "benefit.asOf",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "approved",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "scheme:pb-free-power-300-units",
        "ids": [
          "scheme:pb-free-power-300-units",
          "scheme:pb-free-power-300-units",
          "scheme:pb-free-power-300-units"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/state-cash-other.json"
        ],
        "filledFrom": [
          {
            "field": "benefit.asOf",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "approved",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "scheme:pm-kisan",
        "ids": [
          "scheme:pm-kisan",
          "scheme:pm-kisan",
          "scheme:pm-kisan"
        ],
        "files": [
          "welfare/central.json",
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json"
        ],
        "filledFrom": [
          {
            "field": "benefit.asOf",
            "file": "welfare/fiscal-results.json"
          }
        ]
      },
      {
        "id": "scheme:pm-ujjwala",
        "ids": [
          "scheme:pm-ujjwala",
          "scheme:pm-ujjwala",
          "scheme:pm-ujjwala",
          "scheme:pm-ujjwala"
        ],
        "files": [
          "welfare/central.json",
          "welfare/elections-timing.json",
          "welfare/literature.json",
          "welfare/vendors.json"
        ],
        "filledFrom": []
      },
      {
        "id": "scheme:pmgkay",
        "ids": [
          "scheme:pmgkay",
          "scheme:pmgkay",
          "scheme:pmgkay"
        ],
        "files": [
          "welfare/central.json",
          "welfare/elections-timing.json",
          "welfare/vendors.json"
        ],
        "filledFrom": []
      },
      {
        "id": "scheme:tg-rythu-bandhu",
        "ids": [
          "scheme:tg-rythu-bandhu",
          "scheme:tg-rythu-bandhu",
          "scheme:tg-rythu-bandhu"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/state-cash-other.json"
        ],
        "filledFrom": [
          {
            "field": "benefit.asOf",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "approved",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "scheme:tn-amma-unavagam",
        "ids": [
          "scheme:tn-amma-unavagam",
          "scheme:tn-amma-unavagam"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/vendors.json"
        ],
        "filledFrom": [
          {
            "field": "approved",
            "file": "welfare/vendors.json"
          },
          {
            "field": "benefit.amount",
            "file": "welfare/vendors.json"
          }
        ]
      },
      {
        "id": "scheme:tn-kalaignar-magalir-urimai-thogai",
        "ids": [
          "scheme:tn-kalaignar-magalir-urimai-thogai",
          "scheme:tn-kalaignar-magalir-urimai-thogai",
          "scheme:tn-kalaignar-magalir-urimai-thogai"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "benefit.asOf",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "approved",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "scheme:upa-farm-loan-waiver-2008",
        "ids": [
          "scheme:upa-farm-loan-waiver-2008",
          "scheme:upa-farm-loan-waiver-2008"
        ],
        "files": [
          "welfare/central.json",
          "welfare/elections-timing.json"
        ],
        "filledFrom": [
          {
            "field": "benefit.amount",
            "file": "welfare/elections-timing.json"
          }
        ]
      },
      {
        "id": "scheme:wb-kanyashree",
        "ids": [
          "scheme:wb-kanyashree",
          "scheme:wb-kanyashree"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json"
        ],
        "filledFrom": [
          {
            "field": "approved",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "benefit.amount",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "scheme:wb-lakshmir-bhandar",
        "ids": [
          "scheme:wb-lakshmir-bhandar",
          "scheme:wb-lakshmir-bhandar",
          "scheme:wb-lakshmir-bhandar"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "benefit.asOf",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "approved",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "wel:aaditya-thackeray",
        "ids": [
          "wel:aaditya-thackeray",
          "wel:aaditya-thackeray",
          "wel:aaditya-thackeray"
        ],
        "files": [
          "welfare/literature.json",
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "st",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "wel:aea-journals",
        "ids": [
          "wel:aea-journals",
          "wel:aea-journals",
          "wel:aea-journals"
        ],
        "files": [
          "welfare/central.json",
          "welfare/fiscal-results.json",
          "welfare/state-cash-other.json"
        ],
        "filledFrom": [
          {
            "field": "publicRole",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:ajit-pawar",
        "ids": [
          "wel:ajit-pawar",
          "wel:ajit-pawar"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "st",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "wel:amarinder-singh",
        "ids": [
          "wel:amarinder-singh",
          "wel:amarinder-singh"
        ],
        "files": [
          "welfare/state-cash-other.json",
          "welfare/vendors.json"
        ],
        "filledFrom": []
      },
      {
        "id": "wel:arvind-kejriwal",
        "ids": [
          "wel:arvind-kejriwal",
          "wel:arvind-kejriwal",
          "wel:arvind-kejriwal",
          "wel:arvind-kejriwal"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json",
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:ashok-gehlot",
        "ids": [
          "wel:ashok-gehlot",
          "wel:ashok-gehlot",
          "wel:ashok-gehlot",
          "wel:ashok-gehlot"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json",
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:atishi",
        "ids": [
          "wel:atishi",
          "wel:atishi",
          "wel:atishi"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:bhagwant-mann",
        "ids": [
          "wel:bhagwant-mann",
          "wel:bhagwant-mann",
          "wel:bhagwant-mann"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:bhajan-lal-sharma",
        "ids": [
          "wel:bhajan-lal-sharma",
          "wel:bhajan-lal-sharma"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:bhupesh-baghel",
        "ids": [
          "wel:bhupesh-baghel",
          "wel:bhupesh-baghel"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:bluekraft-digital-foundation",
        "ids": [
          "wel:bluekraft-digital-foundation",
          "wel:bluekraft-digital-foundation"
        ],
        "files": [
          "welfare/central.json",
          "welfare/vendors.json"
        ],
        "filledFrom": [
          {
            "field": "publicRole",
            "file": "welfare/vendors.json"
          }
        ]
      },
      {
        "id": "wel:dbt-mission",
        "ids": [
          "wel:dbt-mission",
          "wel:dbt-mission"
        ],
        "files": [
          "welfare/literature.json",
          "welfare/vendors.json"
        ],
        "filledFrom": []
      },
      {
        "id": "wel:devendra-fadnavis",
        "ids": [
          "wel:devendra-fadnavis",
          "wel:devendra-fadnavis",
          "wel:devendra-fadnavis",
          "wel:devendra-fadnavis"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/literature.json",
          "welfare/state-cash-other.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/literature.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:dk-shivakumar",
        "ids": [
          "wel:dk-shivakumar",
          "wel:dk-shivakumar"
        ],
        "files": [
          "welfare/state-cash-other.json",
          "welfare/vendors.json"
        ],
        "filledFrom": []
      },
      {
        "id": "wel:eci",
        "ids": [
          "wel:eci",
          "wel:eci"
        ],
        "files": [
          "welfare/fiscal-results.json",
          "welfare/vendors.json"
        ],
        "filledFrom": [
          {
            "field": "st",
            "file": "welfare/vendors.json"
          },
          {
            "field": "identity",
            "file": "welfare/vendors.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/vendors.json"
          }
        ]
      },
      {
        "id": "wel:eknath-shinde",
        "ids": [
          "wel:eknath-shinde",
          "wel:eknath-shinde",
          "wel:eknath-shinde",
          "wel:eknath-shinde"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/literature.json",
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/literature.json"
          },
          {
            "field": "st",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "wel:fci",
        "ids": [
          "wel:fci",
          "wel:fci"
        ],
        "files": [
          "welfare/state-cash-other.json",
          "welfare/vendors.json"
        ],
        "filledFrom": [
          {
            "field": "st",
            "file": "welfare/vendors.json"
          }
        ]
      },
      {
        "id": "wel:h-m-revanna",
        "ids": [
          "wel:h-m-revanna",
          "wel:h-m-revanna",
          "wel:h-m-revanna"
        ],
        "files": [
          "welfare/fiscal-results.json",
          "welfare/state-cash-other.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:hemant-soren",
        "ids": [
          "wel:hemant-soren",
          "wel:hemant-soren"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "st",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "wel:himanta-biswa-sarma",
        "ids": [
          "wel:himanta-biswa-sarma",
          "wel:himanta-biswa-sarma",
          "wel:himanta-biswa-sarma"
        ],
        "files": [
          "welfare/central.json",
          "welfare/elections-timing.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "st",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "wel:j-jayalalithaa",
        "ids": [
          "wel:j-jayalalithaa",
          "wel:j-jayalalithaa",
          "wel:j-jayalalithaa"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json",
          "welfare/vendors.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:k-chandrashekar-rao",
        "ids": [
          "wel:k-chandrashekar-rao",
          "wel:k-chandrashekar-rao",
          "wel:k-chandrashekar-rao",
          "wel:k-chandrashekar-rao"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/fiscal-results.json",
          "welfare/state-cash-other.json",
          "welfare/vendors.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/fiscal-results.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:kamal-nath",
        "ids": [
          "wel:kamal-nath",
          "wel:kamal-nath",
          "wel:kamal-nath",
          "wel:kamal-nath"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/literature.json",
          "welfare/state-cash-other.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/literature.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:kamlesh-paswan",
        "ids": [
          "wel:kamlesh-paswan",
          "wel:kamlesh-paswan"
        ],
        "files": [
          "welfare/central.json",
          "welfare/literature.json"
        ],
        "filledFrom": []
      },
      {
        "id": "wel:karnataka-rtcs",
        "ids": [
          "wel:karnataka-rtcs",
          "wel:karnataka-rtcs"
        ],
        "files": [
          "welfare/state-cash-other.json",
          "welfare/vendors.json"
        ],
        "filledFrom": []
      },
      {
        "id": "wel:lokniti-csds",
        "ids": [
          "wel:lokniti-csds",
          "wel:lokniti-csds",
          "wel:lokniti-csds",
          "wel:lokniti-csds"
        ],
        "files": [
          "welfare/central.json",
          "welfare/literature.json",
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "st",
            "file": "welfare/literature.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/literature.json"
          }
        ]
      },
      {
        "id": "wel:mamata-banerjee",
        "ids": [
          "wel:mamata-banerjee",
          "wel:mamata-banerjee",
          "wel:mamata-banerjee"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:manmohan-singh",
        "ids": [
          "wel:manmohan-singh",
          "wel:manmohan-singh"
        ],
        "files": [
          "welfare/central.json",
          "welfare/elections-timing.json"
        ],
        "filledFrom": []
      },
      {
        "id": "wel:mk-stalin",
        "ids": [
          "wel:mk-stalin",
          "wel:mk-stalin",
          "wel:mk-stalin"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:mohan-charan-majhi",
        "ids": [
          "wel:mohan-charan-majhi",
          "wel:mohan-charan-majhi",
          "wel:mohan-charan-majhi"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:mohan-yadav",
        "ids": [
          "wel:mohan-yadav",
          "wel:mohan-yadav",
          "wel:mohan-yadav"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/vendors.json"
          },
          {
            "field": "st",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "wel:n-chandrababu-naidu",
        "ids": [
          "wel:n-chandrababu-naidu",
          "wel:n-chandrababu-naidu",
          "wel:n-chandrababu-naidu"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:naveen-patnaik",
        "ids": [
          "wel:naveen-patnaik",
          "wel:naveen-patnaik"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:nber",
        "ids": [
          "wel:nber",
          "wel:nber"
        ],
        "files": [
          "welfare/central.json",
          "welfare/fiscal-results.json"
        ],
        "filledFrom": []
      },
      {
        "id": "wel:nitish-kumar",
        "ids": [
          "wel:nitish-kumar",
          "wel:nitish-kumar",
          "wel:nitish-kumar"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:p-chidambaram",
        "ids": [
          "wel:p-chidambaram",
          "wel:p-chidambaram"
        ],
        "files": [
          "welfare/central.json",
          "welfare/elections-timing.json"
        ],
        "filledFrom": []
      },
      {
        "id": "wel:prs-legislative-research",
        "ids": [
          "wel:prs-legislative-research",
          "wel:prs-legislative-research",
          "wel:prs-legislative-research",
          "wel:prs-legislative-research"
        ],
        "files": [
          "welfare/fiscal-results.json",
          "welfare/literature.json",
          "welfare/state-cash-other.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "st",
            "file": "welfare/literature.json"
          },
          {
            "field": "identity",
            "file": "welfare/literature.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/literature.json"
          }
        ]
      },
      {
        "id": "wel:raghuvansh-prasad-singh",
        "ids": [
          "wel:raghuvansh-prasad-singh",
          "wel:raghuvansh-prasad-singh"
        ],
        "files": [
          "welfare/central.json",
          "welfare/elections-timing.json"
        ],
        "filledFrom": []
      },
      {
        "id": "wel:rbi",
        "ids": [
          "wel:rbi",
          "wel:rbi",
          "wel:rbi",
          "wel:rbi"
        ],
        "files": [
          "welfare/fiscal-results.json",
          "welfare/literature.json",
          "welfare/state-cash-other.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "st",
            "file": "welfare/literature.json"
          },
          {
            "field": "identity",
            "file": "welfare/literature.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/literature.json"
          }
        ]
      },
      {
        "id": "wel:rekha-gupta",
        "ids": [
          "wel:rekha-gupta",
          "wel:rekha-gupta"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "st",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "wel:revanth-reddy",
        "ids": [
          "wel:revanth-reddy",
          "wel:revanth-reddy",
          "wel:revanth-reddy"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:siddaramaiah",
        "ids": [
          "wel:siddaramaiah",
          "wel:siddaramaiah",
          "wel:siddaramaiah",
          "wel:siddaramaiah"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json",
          "welfare/vendors.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:sukhvinder-singh-sukhu",
        "ids": [
          "wel:sukhvinder-singh-sukhu",
          "wel:sukhvinder-singh-sukhu"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/women-cash.json"
          },
          {
            "field": "st",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "wel:supriya-sule",
        "ids": [
          "wel:supriya-sule",
          "wel:supriya-sule"
        ],
        "files": [
          "welfare/literature.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "st",
            "file": "welfare/women-cash.json"
          }
        ]
      },
      {
        "id": "wel:suvendu-adhikari",
        "ids": [
          "wel:suvendu-adhikari",
          "wel:suvendu-adhikari"
        ],
        "files": [
          "welfare/central.json",
          "welfare/elections-timing.json"
        ],
        "filledFrom": []
      },
      {
        "id": "wel:uidai",
        "ids": [
          "wel:uidai",
          "wel:uidai"
        ],
        "files": [
          "welfare/central.json",
          "welfare/vendors.json"
        ],
        "filledFrom": [
          {
            "field": "st",
            "file": "welfare/vendors.json"
          },
          {
            "field": "publicRole",
            "file": "welfare/vendors.json"
          }
        ]
      },
      {
        "id": "wel:vasundhara-raje",
        "ids": [
          "wel:vasundhara-raje",
          "wel:vasundhara-raje"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:vishnu-deo-sai",
        "ids": [
          "wel:vishnu-deo-sai",
          "wel:vishnu-deo-sai",
          "wel:vishnu-deo-sai"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json",
          "welfare/women-cash.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      },
      {
        "id": "wel:yogi-adityanath",
        "ids": [
          "wel:yogi-adityanath",
          "wel:yogi-adityanath"
        ],
        "files": [
          "welfare/state-cash-other.json",
          "welfare/vendors.json"
        ],
        "filledFrom": []
      },
      {
        "id": "wel:ys-jagan-mohan-reddy",
        "ids": [
          "wel:ys-jagan-mohan-reddy",
          "wel:ys-jagan-mohan-reddy",
          "wel:ys-jagan-mohan-reddy"
        ],
        "files": [
          "welfare/elections-timing.json",
          "welfare/state-cash-other.json",
          "welfare/vendors.json"
        ],
        "filledFrom": [
          {
            "field": "sub",
            "file": "welfare/state-cash-other.json"
          },
          {
            "field": "st",
            "file": "welfare/state-cash-other.json"
          }
        ]
      }
    ]
  },
  "audit": {
    "asOf": "2026-09-25",
    "verdicts": [
      {
        "claimId": "fiscal:c010",
        "domain": "fiscal-results",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "reported",
        "sourceCheck": "confirmed",
        "denialFound": "I found no government response to the 26 Mar 2026 report in the sources I opened. My web search budget ran out, so I could not search further. The only denial on record is H.M. Revanna's, reported by Deccan Herald on 25 Aug 2025: \"The report's suggestion that the guarantee schemes were exacting a toll on the state's resources was 'far from the truth'\" (https://www.deccanherald.com/india/karnataka/cag-reports-conclusions-on-welfare-schemes-in-karnataka-incorrect-h-m-revanna-3696866). It answers the August 2025 CAG report, not this one. The Mar 2026 DH article embeds a related-story link, \"'Neither a burden nor inflationary': Siddaramaiah defends Karnataka's guarantee schemes\", but gives no date and no quote tied to this report. The DH article does not show that the government was asked for comment.",
        "innocentReading": "The audit itself is not in dispute. What can be disputed is whether the guarantees caused the fiscal problems. A revenue deficit and more borrowing in 2023-24 and 2024-25 could also come from other committed spending rising at the same time, such as pay-revision costs, interest and older subsidies, or from slower revenue growth. The CAG's own recommendation is conditional: \"rationalisation of the existing subsidies... or better targeting\". The DH headline, \"forced cuts to nutrition, rural development\", is a causal claim, and the article body shows no CAG figure behind it. It should be read as the paper's summary.",
        "reason": "The edge itself holds. The Deccan Herald article (Bharath Joshi, 26 Mar 2026) prints the audit's own words in quotation marks: \"The introduction of five guarantee schemes shifted the state from a revenue surplus to revenue deficit in 2023-24 and 2024-25; the deficit is then financed by debt which pushes up the future debt and interest burden, thus creating a loop of indebtedness.\" It also confirms the other figures: Rs 52,525 crore spent in 2024-25, \"only 62.12% of the state's borrowings\" going to developmental spending, and net market borrowings of Rs 71,525.15 crore \"to finance the guarantee schemes and the deficits arising thereof\". That is one credible, bylined outlet quoting a named primary document, which meets the bar for \"reported\". It stays short of \"documented\" because I have not opened the CAG PDF. The claim text is wrong in one place: \"Answered by c011\". Revanna's 'far from the truth' remark (25 Aug 2025) predates this report by 7 months and answered CAG's August 2025 report. Presenting it as a reply to this one splices two true facts into a false implication. No response to the March 2026 report has been found.",
        "corrections": [
          "1) Remove \"Answered by c011\" from the c010 claim text. c011 (from=2025-08-25) should not have t=\"claim:fiscal:c010\". Point it at a separate node or edge for CAG's August 2025 report (the \"detrimental to growth\" finding), or delete the contra link. For the Mar 2026 report, set the response to \"none found — not shown as asked\". 2) Change t from scheme:ka-gruha-lakshmi to an aggregate node for the five Karnataka guarantees, or add edges to all five. The finding and the ₹52,525 cr figure cover all five guarantees together, not Gruha Lakshmi alone. 3) Keep the \"forced cuts to nutrition/rural development/slum improvement\" wording out of the edge, or mark it as DH's summary, because the article body quotes no CAG figure for it. 4) Keep tier \"reported\". Upgrade to \"documented\" only after the CAG SFAR 2024-25 (Karnataka) PDF is opened and the quoted sentences are found. 5) Fix a mistake in the claim's own wording, \"Sourced via Deccan Herald, not the audit text\". The DH body does carry direct quotes from the report, but the report text itself is still unverified."
        ],
        "applied": [
          "innocentReading filled",
          "contra added fiscal:c010:audit-contra"
        ]
      },
      {
        "claimId": "fiscal:c013",
        "domain": "fiscal-results",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "analytic",
        "sourceCheck": "partially",
        "denialFound": "None found. The JMM/government was not asked. The only government voice on record is the Cabinet Secretary's announcement (DH/PTI, 14 Oct 2024, https://www.deccanherald.com/india/jharkhand/jharkhand-cabinet-nod-to-hike-financial-assistance-for-women-to-rs-30000-per-year-from-rs-12000-3231863). The web-search budget was exhausted, so I could not search further for a party response or for opposition criticism.",
        "innocentReading": "The hike went through a formal cabinet decision, No. 293/2024 of 14 Oct 2024. It was a response to a competing opposition pledge: the same DH/PTI piece notes \"The BJP has promised women of the state financial assistance of Rs 25,000 per year.\" It was paid from December 2024 onward and funded in the 2025-26 budget (BE Rs 13,363 cr), so it was a lasting commitment, not a one-off pre-poll payment. The claim text's version of the innocent reading, \"went through the budget\", is not supported: it was a cabinet decision, not a budget measure. Its phrase \"already running\" is weak because the scheme was only about 8 weeks old.",
        "reason": "The core facts are documented. PRS SOSF 2025-26, p.7, says: \"In October 2024, Jharkhand increased the monthly payout under the CM Maiyan Samman Yojana from Rs 1,000 to Rs 2,500 per month.\" It cites the 14 Oct 2024 cabinet decision, and DH/PTI independently confirms the approval and the amount. The poll dates (13 and 20 Nov 2024) are not in dispute. Linking the decision to the election is the platform's own inference: PRS says nothing about the election. So this belongs as an analytic edge with an innocent reading, and that is how it is tiered. The claim survives on substance. However, its wording overstates the timing: the higher payout started in December 2024, after the election. What came before the poll was a cabinet commitment, not money in hand. The corrections below fix this. This is not grounds to kill the edge, because a pre-poll commitment that only pays out after the poll is itself the timing fact the edge records. The sibling record in elections-timing.json, which calls it \"a post-election delivery, not a pre-election timing tactic\", is wrong in the other direction: the decision predates the poll.",
        "corrections": [
          "1. lab: change \"Payout raised 2.5x weeks before JH poll\" to \"Cabinet approved 2.5x hike (Rs1,000→Rs2,500) on 14 Oct 2024, ~4 weeks before JH poll; payable from Dec 2024\".\n2. from: change \"2024-10-01\" to \"2024-10-14\".\n3. d: replace \"was raised ... in Oct 2024\" with \"the cabinet on 14 Oct 2024 (Decision No. 293/2024) approved raising it from Rs1,000 to Rs2,500/month, effective December 2024 (Cabinet Secretary via DH/PTI)\". Give the election as \"13 & 20 Nov 2024 (results 23 Nov)\". Add the scheme launch date, 18 Aug 2024.\n4. srcs: add the DH/PTI 14 Oct 2024 URL as an independent second source. Add the cabinet-decision PDF cited by PRS: https://cm.jharkhand.gov.in/sites/default/files/cabinet-decisions-2024-11/cabinet_decision_14_10_2024%2528Hindi%2529.pdf. It returned a TLS error and then HTTP 503 during this check, so mark it unverified.\n5. Claim-text innocent reading: drop \"went through the budget\". Replace \"already running\" with \"launched Aug 2024; hike by cabinet decision; BJP had pledged Rs 25,000/yr; paid and budgeted after the poll\".\n6. Scheme record: set approved.date to 2024-10-14 and add benefit.changes.effective = 2024-12.\n7. Reconcile with elections-timing.json/women-cash.json, which put the hike at 2025-01-01 and call it post-election only. The decision was pre-poll and the payment post-poll; both records should say so.\n8. killIf (\"cabinet papers show the hike was budgeted before the election schedule was known\") remains open. If the ECI announced on 15 Oct 2024, the decision came one day before the schedule and the Model Code of Conduct. That date should be verified and recorded."
        ],
        "applied": [
          "recorded"
        ]
      },
      {
        "claimId": "fiscal:c014",
        "domain": "fiscal-results",
        "lens": "both",
        "refuted": true,
        "recommendedTier": "kill",
        "sourceCheck": "partially",
        "denialFound": "None found. Not asked: no approach to the Maharashtra Finance Department is recorded. My web-search budget was used up, so I could not search for a response or contrary reporting.",
        "innocentReading": "Strongest version: state PSU and SPV borrowing is usually for infrastructure, irrigation or procurement. Maharashtra has the largest GSDP, and Rs 13,990 cr is about 0.3% of it. The rise began in 2022-23, two years before the scheme. Since March 2022 the Centre counts such borrowing against a state's borrowing ceiling, so declaring it is a compliance act rather than concealment. The primary gives no end-use. A Congress-run state with a women's cash scheme (Karnataka) shows the same 2024-25 jump.",
        "reason": "The figures are confirmed against the primary source. Lok Sabha USQ 4004 (MoF, answered 18.08.2025), Annexure-II, gives Maharashtra '- | 2,500 | 7,700 | 13,990' for 2021-22 to 2024-25. PRS SOSF 2025 Table 7 matches and sums to 24,955; my share calculation is 56.06%. The claim still fails on three counts. (1) The symmetric control produces the same 'finding' for Karnataka/Congress (0 to 5,438 in 2024-25), so the method is generating the pattern. (2) 'Other states' fell' is wrong for 4 states, and the total rose in 2024-25. (3) The rise predates the scheme by two years, and the scheme belongs to a Shinde-led coalition, not BJP alone. Even with its disclaimer, the edge from scheme:mh-ladki-bahin to party:bjp suggests a link that no source makes and the base rate does not support. The numbers are publishable, but as a documented fact about Maharashtra's OBB with no scheme or party edge.",
        "corrections": [
          "1) Remove the scheme:mh-ladki-bahin to party:bjp analytic edge. If the data is kept, restate it as a documented data point on a Maharashtra state/finance node with no scheme or party link. Source: Lok Sabha USQ 4004, 18.08.2025, Annexure-II (https://sansad.in/getFile/lsapps/loksabhaquestions/annex/185/AU4004_l3jZ1e.pdf?source=lsapps). Keep PRS SOSF 2025 Table 7 as a secondary source. 2) Change 'while other states' fell' to 'the other 18 declaring states' combined OBB fell (13,664 to 10,965), but Karnataka (0 to 5,438), MP, Telangana and Meghalaya rose; the 19-state total rose 21,364 to 24,955 in 2024-25'. 3) In field d, qualify '19-state total fell 67,075 to 24,955' as covering 2021-22 to 2024-25, and note that it rose year on year in 2024-25. 4) Add the Karnataka symmetric control to symmetryCheck. 5) The claim's srcs field ('Lok Sabha USQ 4004') does not match the record's srcs (PRS only). Add the sansad URL. 6) Any party attribution must reflect the Shinde (Shiv Sena) CM and Ajit Pawar (NCP) FM for 2022-23 to Nov 2024; BJP (Fadnavis) led only from 5 Dec 2024. 7) '19 states' is PRS's count of declaring states; the primary source lists 28 states."
        ],
        "applied": [
          "killed: recommended kill"
        ]
      },
      {
        "claimId": "fiscal:c015",
        "domain": "fiscal-results",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "analytic",
        "sourceCheck": "confirmed",
        "denialFound": "None found. Neither the state government nor BRS was asked, and there is no response on record. Web search was unavailable in this session (search budget exhausted), so contrary reporting could not be searched further. That absence is the record.",
        "innocentReading": "The borrowing funded a legacy SPV model for capital works: irrigation corporations such as the Kaleshwaram corporation and water-supply corporations such as Mission Bhagiratha. Telangana declared it in 2021-22 because the Centre's March 2022 decision forced disclosure. Rythu Bandhu was paid from the budget. On this reading, the borrowing coinciding with the transfer years shows nothing about the scheme.",
        "reason": "The primary record confirms the figures. Lok Sabha USQ 4004 (answered 18 Aug 2025, MoS Finance Pankaj Chaudhary), Annexure-II, \"Year wise details of Off-Budget Borrowings declared by State Governments\", lists Telangana at \"35,258 / 9,597 / 2,546 / 2,697\". The 2021-22 column sums to 67,075, and 35,258/67,075 = 52.57%. PRS SOSF 2025, p.17, says: \"19 states had off-budget borrowings amounting to Rs 67,075 crore (0.4% of their GSDP) in 2021-22\", citing USQ 4004. The fiscal fact is documented, and the scheme link is framed as analytic with an innocent reading, so the claim survives at the analytic tier. What keeps it from rising above analytic: no source ties any of the borrowing to Rythu Bandhu. The claim's own innocent reading also overstates its evidence. PRS supports only \"irrigation in Telangana (37%)\" of outstanding guarantees. That is a stock of guarantees, not how the 2021-22 borrowing was used, and it is less than \"most\". So \"most of the borrowing went to irrigation (Kaleshwaram) SPVs\" is unsourced.",
        "corrections": [
          "(1) srcs: replace the bare \"Lok Sabha USQ 4004\" with the full citation. Use \"Lok Sabha Unstarred Q. 4004, Ministry of Finance (Dept of Expenditure), answered 18 Aug 2025, Annexure-II\" plus its sansad.in URL. Keep the PRS SOSF 2025 Table 7 citation (https://prsindia.org/files/budget/SOSF_2025.pdf) as the secondary. (2) text: change \"Telangana (BRS)\" to \"Telangana (TRS, now BRS)\". Change \"largest off-budget borrower\" to \"largest declared off-budget borrower\". Note that the series is self-declared, and that states such as Rajasthan, Gujarat and Odisha report \"-\". (3) text: the Rs 67,075 cr total covers 15 states with non-zero 2021-22 values. \"19 states\" in PRS refers to the whole 2021-25 table. (4) innocentReading: change \"most of the borrowing went to irrigation (Kaleshwaram) SPVs\" to \"Telangana's off-budget borrowing ran through state corporations; PRS attributes 37% of Telangana's outstanding guarantees (Mar 2024) to irrigation; no source attributes any of it to Rythu Bandhu, which was budget-funded\". Do not assert \"most\" unless a CAG Telangana State Finances Audit Report breakdown is added. (5) Note in text or d that 2021-22 is the first year of the declared series, following the Centre's March 2022 Net Borrowing Ceiling decision. It is not a peak chosen from a longer run. (6) Tier: keep analytic for the scheme to party edge. The underlying number could stand as a documented fiscal fact on a separate edge from state to agency."
        ],
        "applied": [
          "recorded"
        ]
      },
      {
        "claimId": "fiscal:c023",
        "domain": "fiscal-results",
        "lens": "both",
        "refuted": true,
        "recommendedTier": "analytic",
        "sourceCheck": "partially",
        "denialFound": "None found; not asked. This is a pattern claim covering all parties and rests on a scratch computation, so no party was approached for a response.",
        "innocentReading": "There are two. First, selection on the outcome: the fleet was built from politically salient schemes, and salience clusters near elections on both sides. Launches just after a poll are manifesto delivery (Lakshmir Bhandar, Gruha Lakshmi, Shakti, HP OPS, Mahtari Vandan, Subhadra, Punjab power, Amma Vodi). Launches just before a poll are the pre-poll scheme drives. Second, budget cycles: the last full budget before a poll funds schemes that launch in the final year. The file record's innocentReading, which names selection on salience, is stronger than the claim text's budget-only version and should be the one used.",
        "reason": "The pre-poll count reproduces, but the claim as written fails on three counts. (1) 'Post-poll launches 9/34 are not above the null' is an artifact of dropping fleet schemes whose launch dates are stored as years rather than ISO dates. Those dropped schemes are mostly post-poll launches, and adding back only dates already in the repo makes the post-poll test significant (p≈0.03). With the other publicly known dates, the pre-poll and post-poll excesses are equal (16 vs 16 of 45). The asymmetry that makes this 'pre-election clustering' rather than 'the list clusters near elections' does not survive. (2) 'For every party' overstates the evidence: the non-BJP subset is p=0.068 raw and no party subset survives BH. The supported statement is that there is no detectable party difference. (3) The record cites the PRS State of State Finances PDF, which does not contain this computation, and the edge is encoded BJP→INC. analytic remains the right tier because the numbers are reproducible and there is an innocentReading, but only after these corrections.",
        "corrections": [
          "(1) Text: drop 'Post-poll launches 9/34 are not above the null'. Replace it with: 'Post-poll launches are also above the null once year-dated fleet schemes are included (≈13/39, p≈0.03), so the excess is around elections, not specifically before them.' Or re-run with year-resolution dates allowed (norm() should accept YYYY when the whole year falls on one side of the poll). Add Haryana 2024-10-05 to elections-timing.json so Lado Lakshmi is counted. (2) Change 'for every party' to 'no detectable party difference (BJP/NDA 7/15 vs others 7/19, Fisher p=0.73; non-BJP subset alone p=0.068)'. (3) srcs: remove the PRS SOSF_2025.pdf citation from this record, since that source does not say this. Cite the computation (scratchpad baserate.mjs over research/raw/welfare/*.json, read 2026-09-25) and the elections-timing.json scheme and election records. (4) s/t: replace party:bjp→party:inc with an analytic node (e.g. a timing-analysis mechanism node) or party-agnostic encoding. As it stands, the edge asserts a BJP–INC relation. (5) innocentReading in the claim text: use the file's selection-on-salience reading and add the post-poll symmetry. (6) Reconcile the Karnataka Gruha Lakshmi launch date (2023-08-30 in elections-timing.json vs 2023-06 in women-cash.json). (7) In the null, set p=0 for pre-poll on current-term censored schemes (KA Gruha Lakshmi, KA Shakti, HP OPS, CT Mahtari Vandan, OR Subhadra) and condition the post-poll test on the months elapsed so far."
        ],
        "applied": [
          "recorded"
        ]
      },
      {
        "claimId": "ladlibehna-alleged-inducement",
        "domain": "elections-timing",
        "lens": "both",
        "refuted": true,
        "recommendedTier": "kill",
        "sourceCheck": "source-does-not-say",
        "denialFound": "No BJP response to a specific Congress allegation was found. The contra edge claim:bjp-contra-ladlibehna cites Wikipedia's Ladli Laxmi Yojana page. That page contains no BJP statement. It says only \"In 2023, the government of Madhya Pradesh launched Ladli Behna Yojana to further empower women of Madhya pradesh.\" The \"2007 lineage\" framing is the file's own innocent reading, relabelled as BJP's position. Whether BJP was asked is not recorded. My search budget was exhausted, so I could not find a news source for either side.",
        "innocentReading": "Budget cycles, not intent, can explain the timing. The scheme was announced in the FY2023-24 state budget cycle, early in the final year of a term that began mid-way in March 2020. It extended MP's Ladli-branded welfare line, which dates from 2007. Both major parties were competing on women's cash transfers: BJP paid ₹1,000–1,250, and Congress promised ₹1,500 under Nari Samman. Seen that way it is ordinary electoral competition, not a one-sided inducement.",
        "reason": "The one source cited (Wikipedia, 2023 MP Legislative Assembly election) does not say what the claim says. The only Ladli Behna mention on the page is a BJP manifesto line, \"Beneficiaries of the Ladli Behna Scheme to be provided financial assistance, along with a pucca house\". The page records no Congress allegation of inducement, no launch date, and no ₹1,000→1,250→1,500 history. It does not say \"best swing since 2013\" either; it gives the swing as +7.60pp. In the file itself the edge has srcs: [], and its d-field admits \"this file did not independently verify a specific named quote and URL\". The alleged tier needs a named party making the assertion and a sourced contra, and neither exists. The contra's source has no BJP statement, and the contra points at an id that does not exist. The timing observation is already carried, correctly, by claim:ladlibehna-election-timing at the analytic tier. That makes this edge an unsourced allegation stacked on top of a duplicate. It should be killed until someone finds a dated Congress statement with a URL, for example Kamal Nath or the MPCC calling the scheme a \"chunavi\" ploy, or a complaint to ECI.",
        "corrections": [
          "1. Kill or hold the edge until a named Congress statement with a date and URL exists. If one is found, re-add it as \"claim:ladlibehna-alleged-inducement\" (the file currently drops the \"claim:\" prefix) and name the speaker and date in lab/d.\n2. Remove the Wikipedia 2023-election source from this edge: it does not contain the allegation.\n3. Replace the contra's source with a real BJP or Chouhan statement, or downgrade it. The Ladli Laxmi Wikipedia page has no BJP statement. The \"2007 lineage\" text belongs in innocentReading, not in a \"reported\" contra.\n4. Take ₹1,500 out of the pre-poll framing. Only ₹1,000 and ₹1,250 were paid before the 17 Nov 2023 poll; ₹1,500 came after the election. Fill in the benefit-change dates.\n5. Change \"best swing since 2013\" to what the source actually says: \"+7.60pp vote share, 109→163 seats (+54), 48.62%\".\n6. Say which event \"~5 months\" is counted from: the first instalment (about June 2023), not the announcement (about January 2023).\n7. Add the symmetry note that Congress's 2023 manifesto promised ₹1,500 a month to every woman, per the Wikipedia manifesto section."
        ],
        "applied": [
          "claim already killed in the research file — verdict recorded only"
        ]
      },
      {
        "claimId": "lakshmirbhandar-alleged-inducement-2026",
        "domain": "elections-timing",
        "lens": "both",
        "refuted": true,
        "recommendedTier": "kill",
        "sourceCheck": "partially",
        "denialFound": "None found for the \"routine indexing\" framing. ETV Bharat, the only source for claim:tmc-contra-lakshmirbhandar, has no TMC or government statement calling the hike routine or non-electoral. WebFetch summary: \"No explicit TMC or government statement defending the measures as routine (non-electoral) is quoted in the article\". Instead, the article cites analysts calling the scheme the ruling party's \"trump card\" in earlier elections. Business Today (2026-03-20) points the other way: TMC's election manifesto promised to \"increase assistance under Lakshmir Bhandar by Rs 500, taking the monthly amount to Rs 1,500... and Rs 1,700 for SC and ST\". TMC therefore campaigned on the hike openly, which is the opposite of a \"routine indexing\" defence. Whether TMC was asked for a response: not recorded. I could not locate a BJP allegation because the web-search budget was used up and ANI returned 403 (proxy/policy). The Wikipedia election article does not mention Lakshmir Bhandar at all.",
        "innocentReading": "This was the last budget before the poll, and fiscal space and budget timing always put that budget close to the election. The scheme dates from 2021, so a benefit revision after five years without one fits ordinary adjustment for inflation. The same budget also carried a youth allowance and 7th Pay Commission measures, so it was a general pre-poll budget, not one aimed only at Lakshmir Bhandar. None of this makes it an inducement in any sense specific to West Bengal.",
        "reason": "The edge does not meet the \"alleged\" bar in either half. That tier needs a named party making the allegation AND a sourced response. (1) Allegation: the file's record has srcs: [] and says outright that no named BJP quote or URL was found. ETV Bharat, the cited source, has no BJP or opposition criticism (\"No BJP or opposition criticism calling this a pre-poll inducement appears in the provided article\"). The edge therefore attributes a statement to party:bjp without evidence. (2) Response: the TMC \"routine indexing\" position is not in its only cited source (ETV Bharat), and Business Today contradicts it, showing TMC promising the same hike in its manifesto. (3) The second sentence (TMC lost after 15 years; the counter-case) is documented: Republic World says \"With 206 Seats BJP Ends TMC's 15-Year Rule\". But it is joined onto an unsourced allegation, and it just repeats claim:wb2026-counter-narrative, which already carries it at the analytic tier with an innocentReading. What checks out: ₹500 amount, ₹1,500/₹1,700, Feb 2026 date, ~2.5-month gap, TMC loss. What does not: the edge's own predicate (BJP alleged X) and its contra. The edge should be killed and its facts left in the existing analytic edge.",
        "corrections": [
          "1. Kill edge lakshmirbhandar-alleged-inducement-2026 (s: party:bjp) until a named BJP speaker with a quote and URL is found. If one is found, re-add it as alleged, with the id prefixed \"claim:\" to match the other ids. Its id currently lacks the \"claim:\" prefix used everywhere else, and it is referenced as \"claim:lakshmirbhandar-alleged-inducement-2026\" by claim:tmc-contra-lakshmirbhandar. 2. claim:tmc-contra-lakshmirbhandar: its ETV Bharat source does not contain the \"routine indexing\" framing. Either downgrade its tier or rewrite it to what the sources show: TMC put the ₹500 hike in its 2026 manifesto (Business Today, 2026-03-20). Also note it now targets a killed edge. 3. Drop \"the closest-timed hike in this file\" everywhere it appears: line 293 results, line 599 claim:wb2026-counter-narrative, line 727 (\"well-supported\"), and line 288/292 notes where they carry it. It holds only because the MP Ladli Behna hike dates are null (₹1,250 from October 2023, before the November 2023 poll), and the file dates the PMGKAY extension \"days before\" the 2023 polls. At minimum add \"among dated amount hikes\". 4. claim:mamata-announce-lakshmirbhandar: ETV Bharat says the 2026 budget was tabled by Finance Minister Chandrima Bhattacharya, so add her as the person who presented it and don't credit the 2026 hike announcement to Mamata alone without a source. 5. Seat tally: sources disagree (Republic World 206, Wikipedia 208 BJP / 80 AITC, file \"~207\"). Use the Wikipedia figure 208/294, note the Falta repoll (4 May counting; Falta result 24 May), and cite Wikipedia. 6. ANI source (line 13) returned 403 through the proxy. Mark it unverified this session."
        ],
        "applied": [
          "claim already killed in the research file — verdict recorded only"
        ]
      },
      {
        "claimId": "lit-w:c013",
        "domain": "literature",
        "lens": "both",
        "refuted": true,
        "recommendedTier": "alleged",
        "sourceCheck": "confirmed",
        "denialFound": "Yes. There is a direct denial, and the record leaves it out. WCD Minister Aditi Tatkare (Navbharat Live, 14 Jul 2026, https://navbharatlive.com/maharashtra/mumbai/vijay-wadettiwar-ladki-bahin-yojana-allegations-aditi-tatkare-reply-updates-1862269.html): \"सरकार ने किसी लाभार्थी को योजना से नहीं हटाया है\" ('the government has not removed any beneficiary'), and \"जिन्होंने ईकेवाईसी पूरा नहीं किया, उनका भुगतान केवल प्रक्रिया पूरी होने तक रोका गया है\" ('payment only paused until e-KYC is done'). She also said ~1.67 crore eligible women keep getting paid, the deadline was extended to 31 Dec 2025, and e-KYC could not start earlier because of the 2024 election's Model Code of Conduct. The Logical Indian (14 Jul 2026, https://thelogicalindian.com/maharashtra-removes-people-from-ladki-bahin/) quotes Tatkare: \"There will be no mass deletion of genuine beneficiaries.\" The cited ThePrint piece also carries the government's position itself: \"The government had earlier clarified that the dropout of beneficiaries was mainly due to incomplete e-KYC and income criteria.\" So the record's line that the only contra is a general Fadnavis defence and not a denial is false.",
        "innocentReading": "Enrolment was opened fast before the Nov 2024 poll, with self-declared eligibility. The Model Code of Conduct delayed e-KYC. From Aug 2025, a verification drive suspended payments to non-compliant or ineligible recipients (income-tax-paying households, vehicle owners, government employees, over-65s, men). Most of the fall (~62 lakh) is people who did not finish e-KYC, whose payments are paused rather than cancelled. The fall reflects correcting a loose pre-poll roll, not punishing voters. A remaining weakness is that the loose pre-poll enrolment was itself a policy choice made before an election.",
        "reason": "The ThePrint quotes are accurate, but the edge is wrong on three points. (1) 'Figure unverified; no state data opened' is false. The ~92 lakh count comes from government records reported by Indian Express on 13 Jul 2026 (Outlook: \"More than 92 lakh women have been removed ... according to government records reviewed by The Indian Express\"). The minister does not dispute the scale: 1.67 crore remain out of ~2.43–2.48 crore. What she disputes is the word 'removed' and the implied motive. So the count is reported fact, and only the 'used only for electoral gains' motive is an allegation. (2) The contra is the wrong one, and the record says no denial exists when one does. Tatkare's 14 Jul 2026 reply ('government has not removed any beneficiary; payments paused pending e-KYC') and the government clarification printed in the same ThePrint article should replace or supplement the Fadnavis 14 Aug remark. (3) The chronology is backwards. The allegation first appeared ~13–14 Jul 2026, so Fadnavis's 14 Aug remark came after it, not before. The alleged tier is right for the motive claim once the correct contra is attached. As written, the edge misstates the evidence on both the figure and the response.",
        "corrections": [
          "(a) Split the edge. Make a new edge for the removal count: ~92 lakh removed or suspended after e-KYC and eligibility checks, roll down from ~2.43–2.48 crore to ~1.5–1.67 crore. Tier it reported, with Indian Express 13 Jul 2026 via Outlook https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification and Navbharat Live https://navbharatlive.com/maharashtra/mumbai/maharashtra-ladki-bahin-yojana-92-lakh-beneficiaries-removed-ekyc-update-1861335.html. Set upgradeIf to the WCD department's own published count. Keep c013 for Wadettiwar's 'used women only for electoral gains' allegation only, tier alleged. (b) Delete 'Figure unverified; no state data opened' from d/text. (c) from: set to 2026-07-14, the first reported allegation (Navbharat Live 1862269), and note that it was repeated on X on 2026-08-19 (ThePrint). (d) pred: 'enforce' is wrong. The SPEC reserves enforce for audit, court or CAG, and an opposition politician's statement is none of those. Use an allegation-type edge instead, e.g. 'analytic' or a results entry with tier alleged. Separately, consider a genuine enforce edge for the CAG remark on ~₹3,541 cr of excess spending (Navbharat Live 1861335), after checking it against the CAG report itself. (e) Contra: add a new contra edge wel:aditi-tatkare → claim:lit-w:c013, tier reported. Quote: 'सरकार ने किसी लाभार्थी को योजना से नहीं हटाया है'; payments paused pending e-KYC; 1.67 crore remain eligible. Source: https://navbharatlive.com/maharashtra/mumbai/vijay-wadettiwar-ladki-bahin-yojana-allegations-aditi-tatkare-reply-updates-1862269.html, plus The Logical Indian. Also cite ThePrint's own sentence 'The government had earlier clarified that the dropout of beneficiaries was mainly due to incomplete e-KYC and income criteria.' (f) In c014, delete 'pre-dates the allegation by five days'. Fadnavis's 14 Aug remark came after the July allegation. Downgrade c014 to context or supporting contra, not the main denial. (g) Fill innocentReading, currently null, with the e-KYC/Model Code of Conduct/targeting explanation above. (h) Note the arithmetic: 2.48 − 1.65 crore = 83 lakh, not 92.10 lakh. The gap is probably re-enrolment or a different baseline (IE uses 2.43 crore → ~1.5 crore). Don't present the two numbers side by side as if they agree."
        ],
        "applied": [
          "innocentReading filled",
          "contra added lit-w:c013:audit-contra"
        ]
      },
      {
        "claimId": "lit-w:c019",
        "domain": "literature",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "analytic",
        "sourceCheck": "partially",
        "denialFound": "Yes, and it is not recorded as a contra. WCD Minister Aditi Tatkare, April 2025 (BusinessToday, 2025-04-16, https://www.businesstoday.in/india/story/ladki-bahin-yojana-rs1500-per-month-or-rs500-per-month-aditi-tatkare-ajit-pawar-clear-the-air-over-financial-assistance-472223-2025-04-16): \"₹1,500 per month are paid under the Ladki Bahin Yojana to women who are not taking advantage of any other government scheme. To those who are receiving a benefit of less than ₹1,500 under other schemes, the difference is paid.\" Per the FPJ report, she cited GRs dated 28 June 2024 and 3 July 2024 and said that \"no eligible beneficiary has been excluded\" (https://www.freepressjournal.in/mumbai/eligible-beneficiary-will-not-be-excluded-from-ladki-scheme-aditi-tatkare-clarifies-amid-opposition-criticism). Ajit Pawar: \"there is no question of scrapping it.\" On ₹2,100, Tatkare said the CM would decide the hike \"at appropriate time\" (FPJ), and Fadnavis said on 6 Mar 2026 that the scheme will continue.",
        "innocentReading": "The ₹500 top-up comes from a rule that predates the election. The June/July 2024 GRs already said women receiving other state DBT under ₹1,500 get only the difference. The April 2025 change enforced that pre-poll rule for about 7.74 lakh Namo Shetkari beneficiaries, who were still getting ₹1,500 in total from the state. It was not a new cut to the base benefit. The ₹2,100 has not been paid, which fits the fiscal pressure PRS and RBI flag, and the government's stated position is that the hike is deferred, not abandoned. One point cuts the other way and should stay in the claim. By BusinessToday's account these women had been paid the full ₹1,500 before the poll, and the rule was only enforced after the win. Their cash in hand really did fall.",
        "reason": "Both cited sources say what the claim uses them for. The Deccan Herald/PTI piece of 2024-09-14 has Shinde's ₹3,000 quote, and PRS SoSF 2025 p.7 has the April 2025 ₹1,500 to ₹500 reduction, the 12 UCT states and the 6 with revenue deficits. Later facts also hold: the 2026-27 budget still did not raise the benefit to ₹2,100. The claim is framed as analytic, carries an innocent reading and implies no wrongdoing, so it clears the analytic bar. It is not refuted. Three problems stop it from passing clean. First, the edge points at party:bjp, but the ₹3,000 promise was made by a Shiv Sena CM and the ₹2,100 by the whole coalition. Second, the ₹2,100 manifesto figure has no source in srcs. Third, the minister's documented response is missing: she says the ₹500 is the top-up difference under GRs from June/July 2024, which weakens the \"cut once won\" reading. It should be attached as a contra.",
        "corrections": [
          "1) Retarget t from party:bjp to the Mahayuti coalition node, or split the edge. Attribute the ₹3,000 statement to Eknath Shinde (Shiv Sena, CM until 5 Dec 2024) and the post-win decisions to the Fadnavis (BJP) government, with Aditi Tatkare (NCP) as WCD minister. 2) Add a source for the ₹2,100 manifesto promise (Mahayuti joint promises / BJP Sankalp Patra, Nov 2024). None of the current srcs covers it, and the Sep 2024 DH article mentions only ₹2,000/₹3,000. 3) Change \"women-farmer scheme\" to \"Namo Shetkari Mahasanman Nidhi (farmer DBT), about 7.74 lakh women beneficiaries\". 4) Add a contra edge for Tatkare's April 2025 statement (BusinessToday 2025-04-16; FPJ), and state in the innocentReading that the difference-only rule is in the GRs of 28 Jun and 3 Jul 2024, which predate the poll. Keep the counterpoint that it was enforced only after the election. 5) Update upgradeIf/killIf: the 2026-27 budget (6 Mar 2026) was the stated test, and it kept ₹1,500 with no ₹2,100 hike, which leaves the gap between promise and delivery open. Cite India TV / Drishti on the 2026-27 budget. 6) Replace the PRS listing URL (it returned HTTP 500) with the direct SoSF 2025 PDF URL, and quote p.7."
        ],
        "applied": [
          "recorded"
        ]
      },
      {
        "claimId": "mahilarozgar-alleged-bribe",
        "domain": "elections-timing",
        "lens": "both",
        "refuted": true,
        "recommendedTier": "alleged",
        "sourceCheck": "partially",
        "denialFound": "The NDA/Jeevika contra is not in the cited source. The Federal article contains no \"Jeevika\", \"SHG\" or \"self-help\" text, and no NDA or JD(U) spokesperson explains the scheme as a continuation of Jeevika. The responses the source does record are these:\n(a) \"several news reports have quoted unnamed ECI officials or 'sources' saying that no action would be taken since the MMRY was an ongoing scheme that predated the enforcement of the MCC\". This comes from anonymous ECI sources, not the NDA.\n(b) Amit Shah said at Nalanda on 31 Oct that the Rs 10,000 \"will not be taken back\", replying to a different opposition allegation (that the money would be recovered).\n(c) \"The ECI has yet to respond to the letter written by RJD MP Jha\". So the ECI was asked and had not replied as of 4 Nov 2025.\nNo sourced NDA or JD(U) denial of the inducement charge was found; no web search was possible because the search budget was exhausted. The Jeevika framing in the contra edge appears to be written by the editor. Newsonair.gov.in (https://newsonair.gov.in/cm-nitish-kumar-transfers-%E2%82%B910000-each-to-21-lakh-women-under-mahila-rozgar-yojana/) says only that the scheme \"is implemented by the Rural Development Department, and aims to promote entrepreneurship and self-employment among women\". Deccan Herald mentions \"Jeevika samuh\" only in its page tags.",
        "innocentReading": "The Bihar cabinet approved the scheme on 29 Aug 2025 as seed money for women's self-employment, run through the Rural Development Department's SHG network. The first tranches (26 Sep, 3 Oct, 6 Oct) went out before the MCC took effect. The ECI's position, via anonymous sources, is that an ongoing scheme that started before the MCC may continue. Welfare schemes arriving late in a term, when fiscal space allows and before polls, are the norm across parties (8/8 in this file). What remains a real anomaly is the payouts on Oct 17/24/31 under an active MCC, publicised by Amit Shah and Deputy CM Samrat Choudhary at rallies.",
        "reason": "The core allegation is real and sourced: RJD MP Manoj Jha wrote to the ECI on 31 Oct 2025 alleging an MCC violation, and the dates and amounts check out. The edge as recorded fails on three counts.\n(1) Wrong actor node. It is attributed to party:inc, but the source names only RJD's Manoj Jha.\n(2) The contra is unsourced. The Federal article carries no NDA \"Jeevika continuation\" response, and the alleged tier requires a real contra; the only response in the source comes from anonymous ECI officials (\"ongoing scheme that predated the MCC\").\n(3) It is a conjunction. The claim text appends \"closest launch-to-poll gap and largest NDA margin since 2010 in this file\", which The Federal does not say. That analytic comparison belongs to claim:bihar2025-closest-fit (Deccan Herald source), and folding it in makes the allegation look like it was borne out by the result.\nThe dangling ID (record id lacks the \"claim:\" prefix, so the contra edge's target does not resolve) also breaks the required allegation–contra pairing. The claim can keep the alleged tier only after these fixes.",
        "corrections": [
          "1. Change s: party:inc to party:rjd, or a person node for Manoj Kumar Jha (RJD Rajya Sabha MP). Set the allegation date to 2025-10-31 and describe it as a letter to the ECI alleging an MCC violation. Add INC only if a separate source shows a named Congress allegation.\n2. Fix the ID mismatch. The record id \"mahilarozgar-alleged-bribe\" must become \"claim:mahilarozgar-alleged-bribe\" so that claim:nda-contra-mahilarozgar resolves.\n3. Remove \"largest NDA margin since 2010\" and \"closest launch-to-poll gap in this file\" from the allegation text; they belong only in claim:bihar2025-closest-fit.\n4. Beneficiary count. The Federal gives 75L + 25L + 21L = 1.21 crore paid by 6 Oct and quotes Amit Shah's figure of 1.41 crore by 31 Oct. Newsonair says \">1.1 crore selected\". Write \"1.1 crore selected / 1.21 crore paid by 6 Oct\", and fix the beneficiaries entry (count 11000000 asOf 2025-10-06 cites the 25-lakh article, not the 1.1-crore figure).\n5. Add the fact that the source says disbursements continued on Oct 17, 24 and 31 under the MCC, and that the ECI had not replied to Jha as of 2025-11-04.\n6. Contra edge claim:nda-contra-mahilarozgar. Its source (The Federal) does not state the Jeevika-continuation position. Either re-source it to a named NDA/JD(U)/Bihar government statement, or replace it with the ECI-sources \"ongoing scheme predating MCC\" line, attributed to anonymous ECI officials and tiered reported at most. Otherwise record \"NDA response: none found in source; asked: not established\".\n7. Add upgradeIf: an ECI order or reply on the Jha complaint, or an election petition under RP Act s.123 citing MMRY. Add killIf: evidence that the post-MCC tranches were ECI-approved under stated conditions."
        ],
        "applied": [
          "innocentReading filled"
        ]
      },
      {
        "claimId": "sco:c003",
        "domain": "state-cash-other",
        "lens": "both",
        "refuted": true,
        "recommendedTier": "analytic",
        "sourceCheck": "partially",
        "denialFound": "None found. I could not check whether TRS/BRS was ever asked, because the web-search budget ran out mid-task, and the record contains no party response. The absence is the record. The nearest thing to an official rationale is the scheme circular quoted by IGIDR: farmers' income 'has been under stress in view of the ever growing input costs... the daunting task before Government of Telangana is to provide a sense of income security to the farmers.'",
        "innocentReading": "Seven states and the Centre moved to farm cash transfers in 2018-19 after the 2017-18 farm-distress protests. Telangana's scheme could only start after the Land Records Updation Programme (15 Sep - 31 Dec 2017, per IGIDR Table 12) produced a clean pattadar list, so the first possible payment round was Kharif 2018 (May). The Rs 12,000 cr sat in the regular 2018-19 budget. The scheme then ran for 5.5 more years and was continued and enlarged by the Congress government that defeated BRS, so its presence does not separate winners from losers. What cuts against this reading, and must be stated: the timing of the poll, as opposed to the scheme, was chosen. KCR dissolved the Assembly nine months early, after both 2018 payment rounds, and decoupled the vote from the Lok Sabha poll.",
        "reason": "The electoral facts check out against the Wikipedia/ECI infobox: 7 Dec 2018; TRS 88 seats, change +25; 46.87% (46.9%); swing +12.60 on a prior 34.30% (34.3%). Tenant exclusion is also sourced to IGIDR: 'Tenant farmers and landless farmers have been excluded from the purview of the RBS.' Two parts of the claim text fail. (1) 'Per-acre uncapped design pays most to large landowners ... (IGIDR)' misattributes. IGIDR says there is 'no eligibility floor or ceiling', but it argues against the inequity framing: 'While the scheme may, on the face of it, appear inequitable ... we note that 85% of the agricultural land parcels are in the marginal and small category.' It also recommends against a size cap and never quantifies the share paid to large holders. The only figure in the pointer sources cuts the other way. Wikipedia cites a government estimate of about Rs 319 cr a year (₹3.19 billion) to owners of more than 20 acres, a small fraction of a Rs 12,000-15,000 cr outlay. 'Pays most to large landowners' is therefore unsourced and probably wrong on aggregate share. Only 'pays more per farmer to larger holders' follows from the design. (2) The mandatory innocentReading rests on a false premise ('fixed-term state'); the election was advanced nine months by dissolution. Because an analytic-tier claim must carry a correct innocentReading, and the claim puts words in IGIDR's mouth, it cannot pass as written. The timing comparison itself survives as analytic once these fields are corrected.",
        "corrections": [
          "text: replace 'Per-acre uncapped design pays most to large landowners, tenants excluded (IGIDR)' with 'Per-acre design with no holding ceiling (IGIDR); tenants and landless excluded (IGIDR). Government estimate about Rs 319 cr/yr to holders >20 acres (Wikipedia pointer; unverified)'. Or drop the large-landowner clause. innocentReading (text and record field): delete 'in a fixed-term state'. Add that the Assembly was dissolved on 6 Sep 2018, nine months early, so the poll date (not the scheme date) was the incumbent's choice, and that the earliest feasible launch was Kharif 2018 after the LRUP ended on 31 Dec 2017. Record 'd'/'lab': state '+25 seats vs 2014 result (63)' rather than a bare '+25'; say 'vote share 34.3% (2014) to 46.87% (2018)'. from (2018-05-10): the Wikipedia pointer is tagged {{cn}}. Add a contemporaneous news source for the 10 May 2018 launch or mark the date unverified. srcs: the claim-text srcs list only IGIDR and the election page, which support neither the 10 May date nor 'pays most to large landowners'. Add the Rythu Bandhu Wikipedia pointer (already in the record) and the India Today/TNM dissolution sources. baseRate field: add the denominator, 5 of 5 farm cash schemes of 2018-19 (IGIDR Table 1) launched within about 12 months of a poll, with outcomes split (3 incumbents won, 2 lost ground). denial: record 'none found; not asked'. Tier: keep analytic after these fixes; do not upgrade until the Lokniti beneficiary cross-tab (upgradeIf) is in hand."
        ],
        "applied": [
          "recorded"
        ]
      },
      {
        "claimId": "sco:c006",
        "domain": "state-cash-other",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "alleged",
        "sourceCheck": "partially",
        "denialFound": "Partial, and not a rebuttal of the figure. Same Deccan Herald/PTI article (https://www.deccanherald.com/india/telangana/rythu-bandhu-rs-22600-crore-given-to-ineligible-people-in-brs-regime-says-telangana-cm-3328152): \"Rama Rao alleged that the Congress government is trying to evade the implementation of the scheme and that Congress leaders should be questioned about it.\" This is a counter-accusation. It does not dispute the Rs 22,600 cr number or the method behind it. I could not find a BRS rebuttal of the figure itself (for example from Harish Rao or KTR) because the session's WebSearch budget was used up. I did not run a wider search for one.",
        "innocentReading": "Under BRS rules, the land was not \"ineligible\". All pattadar land on the purified records qualified per acre, and paying hillock, road or crusher survey numbers was the known cost of choosing a land-record test over a cultivation test. The Rs 22,600 cr figure is a rough estimate (no method published) that applies the Congress government's new 2025 cultivable-land criterion backwards, to explain why the replacement scheme covers less. Payments on non-cultivated land are consistent with a design choice and poor land records. They do not require fraud or diversion.",
        "reason": "The one source was opened with curl; WebFetch got a 403. The article body in its JSON-LD confirms the core claim word for word: \"A Revanth Reddy on Saturday said an estimated Rs 22,600 crore out of the Rs 72,816 crore spent by the previous BRS regime on 'Rythu Bandhu'... has been given to ineligible beneficiaries... citing an estimate he said, Rs 22,600 crore had been credited to the lands that were not under cultivation... Benefits were given to the lands that turned out to be hillocks, roads, mining areas and stone crushing units.\" The actor, date, amounts and land types all match. The claim does not overreach: it is tiered alleged, has a named party making the statement, has a named contra (KTR), and says openly that the figure is unaudited. That is the correct tier for the evidence. It should not go up, because there is no audit, departmental report or second independent outlet. It should not be killed, because the statement verifiably happened and is correctly attributed. Three pieces of framing go beyond the source and need fixing (see corrections). None of them reverses the claim.",
        "corrections": [
          "1) The text says \"Government estimate\". The source only says \"citing an estimate\". It does not say where the estimate came from. Change to \"an estimate he cited (source and method not given)\".\n2) The text says \"no audit opened\". This reads as if no audit was ever started, and the source does not say that. The results entry on line 706 says what was meant: \"no audit report with this figure was opened\". Change to \"no audit or departmental report with this figure found\".\n3) The contra misattributes a statement. The source attributes to KTR only that \"the Congress government is trying to evade the implementation of the scheme\". The \"Rs 15,000 per acre per year\" promise is a background sentence written by PTI, not KTR's words. Change the claim text to \"Contra: KTR alleged Congress is trying to evade implementing the scheme; PTI notes Congress had promised Rs 15,000/acre/yr.\" Make the same fix to sco:c007.d, which says \"and its Rs 15,000/acre promise\".\n4) The predicate is wrong. The spec reserves \"enforce\" for audit, court or CAG actions. A CM's statement in the Assembly is none of those. Re-predicate to \"contra\" (s: wel:revanth-reddy, t: scheme:tg-rythu-bandhu), or mark it as an allegation-type edge. It should not sit in the graph's enforcement layer.\n5) Add the missing innocentReading field to the sco:c006 record, using the text above. Under BRS rules all pattadar land was eligible, so \"ineligible\" applies the 2025 criterion backwards.\n6) Optional: the \"lab\" field could say \"estimate\" to match the source: \"CM: est. Rs 22,600 cr of Rs 72,816 cr went to non-cultivated land\"."
        ],
        "applied": [
          "innocentReading filled"
        ]
      },
      {
        "claimId": "sco:c020",
        "domain": "state-cash-other",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "analytic",
        "sourceCheck": "partially",
        "denialFound": "Partial, and it is in the source itself. The Government of Odisha (BJD-run at the time) replied to the CAG in April 2022. (a) On ineligibles: \"In reply, the Government stated (April 2022) that as on date 1.01 lakh ineligible beneficiaries were found… 3.55 lakh beneficiaries were under the process of field verification\". (b) On wrong-name accounts: \"the Government stated (April 2022) that the KALIA assistance reached to the self-reported account of the intended beneficiaries due to lack of bank accounts available at their end. All the beneficiaries with mismatched names got their KALIA assistance through Aadhaar Payment Bridge System\". Source: https://cag.gov.in/uploads/download_audit_report/2024/chapter-2-066e1a6d3ef1c45.30401355.pdf. I found no BJD party statement answering the September 2024 tabling. I could not run a search for one because the session's web-search budget is used up, so the question is open, not answered.",
        "innocentReading": "KALIA's first instalment was for the Rabi 2018-19 season (the CAG says assistance was \"to be released in five crop seasons from Rabi 2018-19\"), so the Jan–May timing follows the crop calendar. Over-inclusion came from building the list out of SECC, NFSA and self-declared 'green forms' without khata or plot (Bhulekh) data. The government itself found the 14.08 lakh ineligibles (Aug 2019) and removed them from later phases. That is a clean-up after the fact, not evidence of targeting voters. PM-KISAN, a scheme of the rival party, shows the same timing. One caution: \"BJD still lost 5 seats\" is weak as an innocent reading. BJD went from 117 to 112 seats but its vote share rose by 1.3 points (to 44.71%) and it won a fifth term, so the outcome does not count against a vote-buying reading.",
        "reason": "Every figure checks out against the CAG chapter, word for word: 21/12/2018 cabinet memo; 51.05 lakh (51,05,290) paid; 14.08 lakh (27.58%) ineligible in the Aug 2019 field check; \"Department had paid ₹782.26 crore to 12.72 lakh ineligible beneficiaries in three phases\"; and \"payment of ₹107.64 crore was released to 1.28 lakh account holders in which the names of account holders were different\". The election result checks out against Wikipedia: BJD 112 (down 5), BJP 23 (up 13). The claim is tiered analytic and carries an innocent reading, which is the correct bar. Nothing in it is false, so it survives. It still needs fixes. (1) It reduces a four-phase poll (11–29 Apr) to 11 Apr and leaves out that one batch of 5.63 lakh beneficiaries was paid on 12 Apr, mid-poll. (2) The \"lost 5 seats\" innocent reading leaves out BJD's higher vote share. (3) \"Then the state in 2024\" has no support in the cited sources. (4) Of the ₹107.64 cr released to wrong-name accounts, ₹104.08 cr was actually transferred. (5) The government's April 2022 replies are in the source but are not recorded as a contra.",
        "corrections": [
          "1. text: replace \"poll 11 Apr 2019 (3 months)\" with \"poll 11–29 Apr 2019 in four phases, counted 23 May (first cash 25 Jan, ~2.5 months before phase 1); batch 4 (5.63 lakh) paid 12 Apr 2019, between phases; batch 5 (8.41 lakh) 29 May, after the result\". Set to = \"2019-04-29\", not \"2019-04-11\". 2. text and innocentReading: change \"BJD still lost 5 seats\" to \"BJD fell from 117 to 112 seats but its vote share rose by 1.3 points (44.71%) and it won a fifth term\". The current wording overstates the innocent reading. 3. srcs: add https://en.wikipedia.org/wiki/2024_Odisha_Legislative_Assembly_election for \"lost the state in 2024\" (already used in elections-timing.json), or drop the phrase. 4. text: \"Rs 107.64 cr to wrong-name accounts\" should read \"Rs 107.64 cr released to 1.28 lakh wrong-name accounts (Rs 104.08 cr actually transferred)\". Optionally add that the 14.08 lakh ineligibles got Rs 611.91 cr in the first instalment. 5. Add a contra claim (Government of Odisha, April 2022, per the CAG chapter): only 1.01 lakh confirmed ineligible and 3.55 lakh under verification; mismatched-name payments went via APBS to self-reported accounts. 6. The \"d\" field in the file (\"first cash Jan 2019\") should match the text (\"Jan–May 2019\"). 7. killIf/upgradeIf are fine. Record the mid-poll 12 Apr batch as the one feature that sets KALIA apart from the other 8 of 8 pre-poll launches, and look for an ECI permission or complaint about it (none checked yet)."
        ],
        "applied": [
          "recorded"
        ]
      },
      {
        "claimId": "sco:c034",
        "domain": "state-cash-other",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "alleged",
        "sourceCheck": "partially",
        "denialFound": "No Union or BJP statement was found in the sources opened. The claim's \"Contra\" (nationwide OMSS discontinuation with exceptions) is sourced only to TNM, which describes it inside the paragraph reporting Siddaramaiah's allegation. It is not the Union speaking in its own words. The Union's stated rationale (price stabilisation) is not quoted from any Union source (PIB, the ministry or the Food Secretary). Contemporaneous coverage exists but was not retrieved: The Hindu, 14 Jun 2023 and 29 Jun 2023 (\"Explained: What is Karnataka vs. Centre row over Anna Bhagya scheme\"), and The Indian Express, 7 Sep 2023 (\"BJP questions CM jab at Centre over FCI move halting rice sales\"). A Times of India report of 20 Aug 2024 (\"Centre agrees to provide rice to Karnataka govt\") suggests a partial thaw earlier than Feb 2025. Whether the Union was asked to respond on the record is not established. The web-search budget was exhausted and the Google News links could not be resolved.",
        "innocentReading": "In June 2023, with food inflation and El Niño worries, the Union stopped OMSS(D) sales of central-pool rice and wheat to all state governments except NE, hilly and calamity-hit states. It sent the grain to open-market e-auctions to cool prices. Karnataka's new 10 kg promise depended on buying the extra 5 kg under OMSS, so it was caught by a general rule. FCI's agreement of 13 Jun was overtaken by the ministry order the next day. Once stocks were comfortable and OMSS pricing for states was set (Rs 22.5/kg until June 2025), Karnataka could buy again.",
        "reason": "The allegation itself holds up. TNM, a credible outlet, attributes it by name: \"Chief Minister Siddaramaiah accused the Union government of taking a 'political decision' to stop selling rice and wheat to state governments.\" The claim carries a contra, as the alleged tier requires. So \"alleged\" is the right tier and the claim should not be killed. It is not clean, though. (1) The Rs 10,452 cr is attached to \"19 months\" but covers only Jul 2023–Oct 2024 (16 months) according to DH. (2) The contra is not the Union's own words: it comes from the same TNM paragraph as the allegation, and no Union response was retrieved. (3) The edge's target (FCI) and predicate (enforce) do not match the source or the SPEC. (4) TNM's own description of a rule covering all states with exceptions points to a non-discriminating, innocent explanation that the claim's killIf already anticipates. Nothing in hand refutes that reading.",
        "corrections": [
          "1. Replace the text \"state paid Rs 170 cash in lieu for 19 months (Rs 10,452 cr DBT)\" with \"state paid Rs 170 per beneficiary per month by DBT in lieu of the additional 5 kg, Jul 2023–Jan 2025. Rs 10,452 cr was transferred Jul 2023–Oct 2024 (DH, citing the Food dept); Nov–Jan payments were pending as of 19 Feb 2025.\" 2. Change \"rice resumed Feb 2025 at Rs 22.5/kg on Pralhad Joshi's approval\" to \"per state minister K H Muniyappa, Joshi agreed to sell at Rs 22.5/kg (~Rs 25 landed) for Feb–Jun 2025 and 'orally assured' supply beyond\". This is the state's account; no Union statement was opened. 3. Change the target from wel:fci to the Union Ministry of Consumer Affairs, Food and Public Distribution node, since the ministry order reversed FCI's 13 Jun agreement. 4. Replace pred \"enforce\", which in SPEC is reserved for audit, court or CAG, with an allegation edge: keep tier alleged and record the claimant in \"a\" or in the label. 5. Add the DH URL (https://www.deccanherald.com/india/karnataka/karnataka-govt-to-provide-additional-5-kgs-of-rice-under-anna-bhagya-scheme-from-february-3412458) to sco:c034 srcs in the file; the record currently lists only TNM. 6. Sibling edge sco:c035 (contra), currently tiered \"documented\": downgrade it to \"reported\" or re-source it to a Union primary record (a PIB release or the June 2023 OMSS order). Its only sources are TNM's paraphrase and a DH article that does not mention OMSS discontinuation. 7. Add the contemporaneous The Hindu report of 14 Jun 2023 as the dated source for the June 2023 allegation."
        ],
        "applied": [
          "innocentReading filled"
        ]
      },
      {
        "claimId": "sco:c063",
        "domain": "state-cash-other",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "alleged",
        "sourceCheck": "partially",
        "denialFound": "None found. The record says \"no DMK rebuttal text opened\". I could not add to the search: the WebSearch budget is used up (200/200), DuckDuckGo returned a bot challenge and Bing returned irrelevant results. Neither source quotes a DMK response to the cable-fee allegation. The 2006 report records only that the government set up an all-party committee of legislators \"to ensure transparency in procurement and proper distribution\". Whether the DMK was asked about the specific claim is not recorded. The contra edge sco:c064 is therefore correctly marked analytic and says outright that it is not a denial. That absence is the record and is a weakness of the claim, not a neutral fact.",
        "innocentReading": "Any big increase in TV ownership raises cable subscriptions for whoever dominates cable distribution. In 2006 Tamil Nadu that was the Sun-linked MSO, whatever the scheme's intent. The Rs 4,000 cr/yr figure is Jayalalithaa's estimate of the whole state's annual cable subscription spend (\"The people pay Rs.4,000 crore as cable subscription every year\"). It is not an increase caused by the scheme. Procurement ran through ELCOT, a state PSU, under an all-party legislators' committee. Background, not verified this session: after the 2007 Karunanidhi–Maran split, the DMK government itself set up Arasu Cable TV Corporation to compete with the Sun group's cable operation. That fits poorly with a scheme designed to enrich the Marans.",
        "reason": "The claim survives because it only asserts that Jayalalithaa made the allegation, and two outlets confirm she did: UNI via Oneindia, 15 Sep 2006, and IndiaSpend, 24 Oct 2011, quoting The Hindu. It attributes the revenue figures to her, says no audit or court finding was opened, and carries a contra edge that openly records no DMK denial was found. That clears the 'alleged' bar: a named party asserts it, and a contra edge is attached. The claim is not killed. It needs the wording fixes below, because some of its text reads the allegation more strongly than the sources say it.",
        "corrections": [
          "1. Text: \"16.4 million sets, Rs 3,687 cr\" are also Jayalalithaa's figures, not independent facts. IndiaSpend says \"According to her numbers ... the 16.4 million TV sets distributed by the government cost Rs.3,687 crore\". Its own figures are about 15 million purchased by ELCOT between 2006 and 2010, and 13.2 million shown as distributed as of Sep 2010. Change to \"Revenue, set-count and cost figures are hers\" and add IndiaSpend's 15m/13.2m figures. 2. The 2006 Rs 300 cr/yr figure comes from an AIADMK executive-committee resolution, quoted in UNI's report on Jayalalithaa's criticism. It assumed 25 lakh sets at Rs 750 cr and Rs 100 per household. Attribute it to \"AIADMK (Jayalalithaa, Gen Secy/LoP) resolution\". It names \"Karunanidhi's 'family television'\", not Sun or the Marans. 3. The Rs 4,000 cr/yr is her figure for all cable subscriptions paid in TN each year, not an increase caused by the scheme. Rewrite \"(Rs 300 cr/yr, later Rs 4,000 cr/yr)\" so it does not read as scheme-driven growth. 4. Identity: the 2011 quote also names Durai Dayanidhi (Alagiri's son, not a Maran). Either widen the text to \"Karunanidhi family cable interests (Marans and Durai Dayanidhi)\" or add a second target. Note that the Sun TV identification is IndiaSpend's gloss. Consider pointing the edge at a Sun-group cable node rather than the listed broadcaster 'Sun TV Network Ltd'. 5. Keep contra sco:c064 as analytic with \"DMK response: none found; not recorded as asked\". Optionally add the innocent reading that any TV rollout grows the incumbent cable operator's base. Sources checked: https://www.oneindia.com/2006/09/15/rpts-correcting-word-in-para-two-line-one-1158304433.html ; https://www.isignal.in/where-are-tamil-nadus-colour-tvs-37787 ; https://en.wikipedia.org/wiki/Colour_TV_case. Record file: /home/user/india-corporate-intelligence/research/raw/welfare/state-cash-other.json (sco:c063 around line 11547, sco:c064 around line 11572, finding text around line 6022, which needs the same fixes)."
        ],
        "applied": [
          "innocentReading filled"
        ]
      },
      {
        "claimId": "vendors:c005",
        "domain": "vendors",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "reported",
        "sourceCheck": "partially",
        "denialFound": "none found in the source. The Wire says \"Airtel is yet to publicly confirm or acknowledge this\", and it quotes no Airtel spokesperson and gives no sign that Airtel was asked. Media reports cited in the article say the money would be \"return[ed] to the accounts of 31 lakh subscribers over the next 24 hours\". Later Airtel statements on the refund may exist, but I could not verify any because the web-search budget was used up. c006 records only the position as of 21 Dec 2017.",
        "innocentReading": "NPCI's APB mapper routes DBT to the most recently seeded account. When Airtel re-verified SIMs through Aadhaar eKYC and opened payments-bank accounts in the same flow, those accounts were seeded automatically and subsidy followed them by default. The money still reached the rightful LPG beneficiaries, just into an account they did not know about. That is a consent and process failure, not theft or diversion to Airtel. Airtel's gain was deposit float and account numbers, not the ₹190 crore itself.",
        "reason": "The only source, The Wire (21 Dec 2017), supports the core facts: UIDAI suspended the eKYC licence on 16 Dec 2017, about ₹190 crore of LPG subsidy went to more than 30 lakh (31 lakh per PTI) Airtel Payments Bank accounts, the ₹2.5 crore fine is attributed to PTI, and the accounts were opened without informed consent. That is enough for 'reported': one credible outlet, with sourcing named to UIDAI's action and PTI. It does not reach 'documented', because neither the UIDAI order nor a second independent outlet was opened. The edge survives. The claim text overstates the source in three ways. It calls the seeding \"force-seeded\" where the source consistently hedges with \"allegedly\". It calls Airtel Payments Bank the \"private beneficiary\" of the ₹190 crore, when the money went into the subscribers' own accounts. And the record's 'd' field gives a fine date of 18 Dec, which the source does not state.",
        "corrections": [
          "text: change \"force-seeded without consent\" to \"allegedly Aadhaar-seeded without informed consent (per UIDAI action)\". Change \"names a specific private beneficiary\" to \"names the private bank that received the routed subsidy (credited to subscribers' own accounts; the bank gained deposits and float)\". d: replace \"levied a ₹2.5 crore interim penalty (18 Dec 2017)\" with \"a ₹2.5 crore fine reported by PTI a couple of days later\", or add a source that gives the 18 Dec date. Note that the source says \"over 30 lakh\" accounts and PTI says 31 lakh; \"~31 lakh\" is acceptable. The source describes the fine as \"on Airtel\", not specifically on Airtel Payments Bank; clarify which entity was fined. c006: the label \"Airtel: money to be returned\" is attributed to media reports, not to an Airtel statement. Relabel it \"Airtel silent as of 21 Dec 2017; media reported refund within 24h\", and set denial status to \"not asked / no public statement in source\". upgradeIf: add \"UIDAI order text or a second independent outlet (e.g., a PTI wire copy) → documented\"."
        ],
        "applied": [
          "innocentReading filled"
        ]
      },
      {
        "claimId": "vendors:c031",
        "domain": "vendors",
        "lens": "both",
        "refuted": true,
        "recommendedTier": "reported",
        "sourceCheck": "confirmed",
        "denialFound": "None found; the article does not quote any government justification. The figure itself comes from the government's own written reply, so there is nothing to deny on the amount. Nobody appears to have asked the government about the partisan-benefit inference. Search was limited: the session's web-search budget was used up, so I could not look further for a response or contrary reporting.",
        "innocentReading": "Registering about 1.25–1.3 crore eligible women for a new DBT scheme in 2023 needed a mass awareness and enrolment campaign. That spending naturally comes at launch, which fell in the election year. The MCC from 9 Oct 2023 then stops new ads, so most lifetime spend lands before the poll. After enrolment closed, publicity needs dropped (only ₹30 cr from Nov 2023 to Jul 2025). This explains the 260/290 split without any partisan intent.",
        "reason": "The facts hold, but the tier does not. Verbatim from FPJ Bhopal, 30 Jul 2025: 'In a written reply to a question raised by legislator Atif Aqueel, Chief Minister Mohan Yadav said ₹290 crore had been spent on the publicity of the scheme' and 'Before the assembly election, a sum of ₹260 crore was spent on the publicity of the Ladli Behna Scheme.' The claim fails its 'documented' tier on two counts. (1) We have one secondary outlet reporting a primary record. The assembly reply itself was not retrieved and there is no second independent outlet, so this meets 'reported' (one credible outlet, named sourcing), not 'documented'. The 'before the assembly election' split is also not clearly the CM's wording: it sits in a separate unattributed sentence, and the article's framing ('useful to the government in the assembly election of 2023') is the reporter's own. (2) The link to a BJP benefit joins true facts (amount, timing, CM branding) to reach a conclusion none of the sources states. It fails the base-rate test, since every government examined in c042 does the same thing. Yet the record sets benefit.confidence to 'documented'. That part is analytic at most and needs an innocentReading.",
        "corrections": [
          "1. ID: the MP claim is vendors:c030, not c031; c031 is the Maharashtra DGIPR ₹199.81 cr edge. Fix the reference in the calling workflow.\n2. c030.tier: change 'documented' to 'reported'. Set upgradeIf to 'MP Vidhan Sabha written reply to Atif Aqueel's question (Monsoon session, Jul 2025), or a second independent outlet'.\n3. c030.benefit.confidence: change 'documented' to 'analytic'. Set benefit.how to a neutral wording such as 'state-funded publicity of a CM-branded scheme, ₹260 cr of it before the Nov 2023 poll (inference of party advantage is ours)'.\n4. Add innocentReading: 'launch-year enrolment campaign for ~1.3 cr women; MCC from 9 Oct 2023 halts new ads; spend front-loaded by design; cross-party base rate per vendors:c042'.\n5. c030.from: change 2023-03-01 to 2023-01-28 (announcement), or note that it is an estimate; it currently has no source.\n6. Mark the '₹260 cr before election' figure as FPJ's paraphrase of the reply, pending the primary text.\n7. Add a killIf: 'assembly record shows a different pre-/post-election split'."
        ],
        "applied": [
          "innocentReading filled"
        ]
      },
      {
        "claimId": "vendors:c032",
        "domain": "vendors",
        "lens": "both",
        "refuted": true,
        "recommendedTier": "reported",
        "sourceCheck": "partially",
        "denialFound": "Yes, in the same article. NCP state chief Sunil Tatkare: 'मीडिया कैंपेन तो सारी सरकार चलाती है... विपक्ष तो हर चीज का विरोध करती है'. BJP MLC Prasad Lad: 'हर सरकार अपने बजट में विज्ञापन के लिए एक प्रावधान करती है.' Source: https://www.aajtak.in/elections/assembly-chunav/story/maharashtra-ladki-behan-yojana-spent-on-promotion-bjp-hits-back-aditya-thackerays-allegations-ntc-rpti-2072996-2024-10-17. They did not dispute the figure. They defended the practice.",
        "innocentReading": "A newly launched direct-benefit scheme with a tight enrolment window (applications from July 2024, with enrolment drives) needs mass awareness advertising. Governments routinely budget for this ('every government makes a provision for advertising'), and heavy spending at launch is normal whether or not an election is coming. In Maharashtra the scheme's launch, set in the last budget of the term, happened to fall just before the poll, which is the usual budget-cycle alignment.",
        "reason": "The cited source (Aaj Tak/PTI, 17 Oct 2024) supports about ₹200 crore of Ladki Bahin publicity per a DGIPR RTI reply of 4 Oct 2024, and on that the claim holds at 'reported'. The specific figure '₹199.81 crore' does not appear in the source. I checked for '199', '81' and 'लाख' and found none. The text says 'लगभग 200 करोड़' in one place and '200 करोड़ रुपए से ज्यादा' in another. No other opened source in the file carries 199.81, and I could not run a web search to trace it. The '~4 months' window and the 'before the poll' framing are the analyst's inferences; the article gives no spending period. The benefit is assigned to party:bjp with confidence 'documented' in the file, but the source does not say this. The scheme belongs to a Shiv Sena CM and an NCP finance minister in a three-party alliance. The contra pointer (c033) and the claim id (c032) are misaligned with vendors.json. As written, the claim fails. Corrected, the core fact stands at reported: one credible outlet, a named RTI and a named applicant, and a response on record.",
        "corrections": [
          "1. Amount: replace '₹199.81 crore' with '~₹200 crore (लगभग 200 करोड़)' in text, lab, d, a, benefit.amountCr, the scheme outlay actualCr/note (line ~2497), the benefit.how (line ~2578) and the narrative strings at lines ~4499, 6098 and 6526. Alternatively, cite a source that actually gives 199.81. 2. Window: drop '~4 months before the Nov 2024 poll'. Use 'spent up to 4 Oct 2024 (RTI reply), roughly 3 months after the 28 Jun 2024 budget announcement and 7 weeks before the 20 Nov 2024 poll; period not stated in source'. Mark from=2024-06-28 as inferred. 3. Beneficiary: change 'benefit to party:bjp' to the Mahayuti alliance (Shiv Sena–BJP–NCP), or to the Shinde-led government, and set benefit.confidence from 'documented' to 'analytic'. 4. Contra reference: point to the Tatkare/Lad record (vendors:c032 in the file, s wel:sunil-tatkare), not to c033, which is the Delhi CAG record. Reconcile the id, because the claim content shown belongs to vendors:c031. 5. Source label: note that the story is a PTI rewrite (the 'rpti' slug), so it is a single wire source. For an upgrade to documented, the RTI reply copy or DGIPR release orders are still needed."
        ],
        "applied": [
          "innocentReading filled"
        ]
      },
      {
        "claimId": "vendors:c035",
        "domain": "vendors",
        "lens": "both",
        "refuted": true,
        "recommendedTier": "analytic",
        "sourceCheck": "partially",
        "denialFound": "ThePrint, 1 Apr 2019: media adviser Nagendar Sharma was asked and said \"Unless I can review all the papers, I can't comment on this.\" (https://theprint.in/politics/kejriwals-delhi-govt-spent-rs-274-crore-on-ads-since-2015-four-times-more-than-congress/214151/). The Tribune piece (27 Feb 2025) as fetched carries no AAP response to the CAG or the recovery order. AAP's public position that the L-G recovery order is politically motivated is recorded in c035 only as an unopened HT headline. I could not verify it because the search budget was exhausted, so it is not confirmed here.",
        "innocentReading": "Most of the ₹274 crore is ordinary government publicity: hoardings, Metro, newspaper ads for schemes. It is in nominal rupees against a 2008–13 baseline, over a period when the Delhi budget grew a lot, and ThePrint notes a pre-election push. Only a subset (~₹97 crore) has been formally classed as political content by the CCRGA/L-G, and AAP contests it. The CAG breaches are procedural: no audience identification, no impact assessment, no expenditure register, releases outside the NCT. They are not a finding that the whole ₹274 crore was political.",
        "reason": "Each fact checks out against the sources. ThePrint: \"spent over Rs 274 crore on outdoor publicity since it assumed office… in February 2015… roughly four times what the Sheila Dikshit-led Congress government spent annually from 2008 to 2013: Rs 17.4 crore\". Tribune: CAG found ads \"released in violation of guidelines of the Supreme Court\", and the L-G \"directed recovery of approximately Rs 97 crore from the AAP for political advertisements published as government ads\". But the claim's conclusion is a conjunction that no source states. It applies \"political ads at state expense\" to a ₹274 cr figure from a different period (2015–19) than the CAG audit (2018–22), and the recovery order covers only ~₹97 cr. It also books the full ₹274 cr as a pmout to party:aap, which is the wrong payee. It also calls the spend \"ad spend\" when the source says \"outdoor publicity\" (hoardings, Metro, newspaper), and it cites the wrong contra id. As written, the implication is analytic at best. The ₹274 cr spend fact alone would pass as reported.",
        "corrections": [
          "1) Id: the claim text belongs to vendors:c034, not c035. Change \"Contra c036\" to \"Contra c035\" (c036 is the unrelated central I&B print-ad edge). 2) Split the edge. (a) wel:delhi-dip → outdoor/print ad vendors (not party:aap), pred pmout, a=274, tier reported, label \"₹274 cr outdoor publicity (hoardings, Metro, newspaper) 14 Feb 2015–28 Feb 2019 (RTI); avg ₹68.5 cr/yr vs ₹17.4 cr/yr 2008–13 (nominal)\". (b) A separate edge wel:delhi-dip → party:aap, a=97 (≈₹42 cr paid, ₹54 cr pending per Tribune), tier alleged (L-G/CCRGA order, AAP contests), with contra c035. 3) Remove \"implies political ads at state expense\" from the pmout text, or move it to an analytic edge with this innocentReading. 4) Keep the CAG window at 2018–22, as a separate period from the 2015–19 RTI window. Do not describe the CAG finding as corroborating the 2015–19 spend. 5) Change \"ad spend\" to \"outdoor publicity\" to match the source's wording."
        ],
        "applied": [
          "downgrade reported → analytic",
          "innocentReading filled"
        ]
      },
      {
        "claimId": "vendors:c043",
        "domain": "vendors",
        "lens": "both",
        "refuted": true,
        "recommendedTier": "alleged",
        "sourceCheck": "partially",
        "denialFound": "No explicit denial in the cited source. The only YSRCP responses in ThePrint (5 Apr 2024, https://theprint.in/politics/ysrcp-agents-why-jagans-grassroots-welfare-volunteers-have-come-under-ec-radar/2029072/) are counter-attacks. Quotes: \"YSRCP general secretary Sajjala Ramakrishna Reddy states Naidu wants to remove the volunteer system in order to bring back the Janmabhoomi committees of the TDP tenure in its place\". YSRCP leaders \"accused the NGO and its secretary N. Ramesh Kumar of operating surreptitiously on behalf of TDP and Naidu\". Jagan: \"he deployed his man Nimmagadda Ramesh to put pressure on the Election Commission\". c044's statement that \"YSRCP denied the volunteers were party agents\" is not in the source. The \"corruption and atrocities\" wording is the journalist's own narration (\"allegedly\"), not a quote from Sajjala. The article gives no sign YSRCP was asked directly about the canvassing charge. My web-search budget was used up, so I could not look for a separate explicit denial.",
        "innocentReading": "The volunteer network was a delivery system set up in 2019, well before the election. Modi reportedly praised it, and it was used for Covid surveys. Once the MCC starts, the ECI routinely keeps state-paid functionaries away from cash handouts to beneficiaries as a precaution, whether or not anyone is shown to have done wrong. About 100 removals out of 2.56 lakh is roughly 0.04%, which fits isolated violations rather than a system run as party agents. The article also says the opposition's position shifted: Naidu later promised \"he won't discontinue the volunteer system\".",
        "reason": "The one-line text is broadly supported. ThePrint does report that TDP and JSP allege the network serves YSRCP's political interests, that about 100 volunteers were removed on the CEO's orders, and that the EC barred pension delivery through volunteers until June. But the edge itself is not supported. (1) Its d field says \"TDP's Varla Ramaiah complained to the EC that YSRCP candidates met volunteers, offered inducements and used them to identify and canvass opposition voters\". The source says nothing of the kind: it has no Ramaiah complaint to the EC and no inducements or identification of opposition voters. (2) The \"door-to-door\" canvassing detail comes from \"some news reports\", not from TDP or JSP. (3) The enforcement action came from the CEO/ECI, and the pension bar followed a complaint by the NGO Citizens for Democracy, not by TDP, so s=Ramaiah with pred=enforce links an allegation to an enforcement it did not cause. (4) The Pawan Kalyan charge is from 2023. (5) The paired contra c044 overstates what YSRCP said. An 'alleged' tier needs a named party making the specific allegation plus a real contra, and as written the named party is attached to things the source does not say he said.",
        "corrections": [
          "Split the edge in two. (a) An enforce edge from the ECI/AP CEO node (Mukesh Kumar Meena) to wel:ap-village-volunteer-system, tier reported. d: \"About 100 volunteers reportedly removed on CEO orders after the MCC (16 Mar 2024); acting on a complaint by the NGO Citizens for Democracy, the ECI barred pension and welfare disbursal through volunteers till the MCC ends (early June 2024).\" from 2024-03-16. (b) An allegation edge from the TDP (or JSP) party node, tier alleged, with d quoting only what the source says. TDP/JSP \"alleging that the grass-roots network ... is actually meant to serve the YSRCP's political interests\". Ramaiah: \"Jagan fears that without the involvement of volunteers especially in pension distribution, his party may lose support\". Pawan Kalyan's trafficking and data-gathering charge, dated 2023. Remove the invented inducement and voter-identification complaint text from both c043.d and the wel:varla-ramaiah d (\"Complained to the EC ...\"). Attribute the door-to-door claim to \"some news reports\", not TDP/JSP. Fix c044: drop \"YSRCP denied the volunteers were party agents\", and attribute \"corruption and atrocities\" to ThePrint's narration (\"allegedly\"), not to Sajjala. Add YSRCP's counter-charge that the NGO complainant was acting for TDP/Naidu. upgradeIf: the ECI/CEO order text (late Mar 2024) and the CEO's removal orders."
        ],
        "applied": [
          "innocentReading filled"
        ]
      },
      {
        "claimId": "welfare-central:c035",
        "domain": "central",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "documented",
        "sourceCheck": "partially",
        "denialFound": "None found. I found no response by the government, DBT Mission or BlueKraft to the MNS or EPW findings, and nothing shows they were asked. The PIB release pushes back only generally: 'The inverse relationship between subsidy expenditure and efficiency challenges critiques of \"declining welfare spending\"' (https://www.pib.gov.in/PressReleasePage.aspx?PRID=2123192). The DBT Mission page describes all deletions as 'duplicate/fake/non-existent' or 'ineligible' and gives no exclusion-error estimate.",
        "innocentReading": "The Finance Ministry's PIB unit regularly republishes favourable outside assessments. The sector figures are the government's own administrative counts of deleted duplicate or ineligible records. Some leakage cut is real: MNS find 66–78% of the Jharkhand drop in grain disbursed was reduced leakage, and Barnwal finds real LPG savings. The weak point is method. Deletions are counted as savings with no counterfactual and with genuine beneficiaries mixed in. That is a methodological weakness, not fabrication.",
        "reason": "The substance survives. I read the primary PIB release (Ministry of Finance, 21 Apr 2025) and it states every figure exactly: '₹3.48 lakh crore', 'Food Subsidies (PDS): ₹1.85 lakh crore saved', 'MGNREGS ... ₹42,534 crore', 'PM-KISAN: ₹22,106 crore saved by deleting 2.1 crore ineligible beneficiaries', 'Fertilizer ... ₹18,699.8 crore', 'DBT Savings (50% weight)', all 'according to a new quantitative assessment by the BlueKraft Digital Foundation'. The contras also check out. The EPW abstract says 'the government's tall claims of savings cannot be confirmed'. The NBER abstract says '1.5-2 million of whom lost access to benefits', and the paper gives 22% (control) and 34% (treated) of the drop in value disbursed as value lost by beneficiaries. As a record of what the government published, this is documented from a primary source, not merely reported. The claim still needs corrections, because the source chain is wrong: the sector numbers are the government DBT Mission's own portal figures, and BlueKraft repackaged them. The graph encoding is also misleading. It uses pred=pmout with a=348000, which reads as a ₹3.48 lakh cr payout to PMJDY, when the figure is a claimed saving.",
        "corrections": [
          "1. Text: change 'is a private foundation's (BlueKraft) estimate relayed by PIB' to 'the government's DBT Mission portal estimates, compiled by BlueKraft Digital Foundation (Dr Shakil Bhat, 16 Apr 2025), which put them in a composite Welfare Efficiency Index; the Ministry of Finance published this through PIB on 21 Apr 2025 and Minister Ashwini Vaishnaw repeated it on 20 Apr 2025.'\n2. Add a source: ['DBT Mission, Estimated Gains (cumulative to Mar 2025: ₹5,14,201.92 cr; PM-KISAN ₹22,106.14 cr / 2.1174 cr deletions; fertiliser ₹18,699.89 cr)', 'https://dbtbharat.gov.in/static-page-content/spagecont?id=18']. Add an asOf note that ₹3.48 lakh cr and PDS ₹1.85 lakh cr are an older vintage; the current figures are ₹5.14 lakh cr and PDS ₹3.13 lakh cr. Add a supersede edge or note.\n3. Predicate and amount: pmout means scheme → beneficiary class with ₹ cr and FY, so it is wrong here. Either change pred to 'analytic' (claim of record) or move 348000 out of 'a' into a field such as claimedSavingsCr, so the graph does not show a ₹3.48 lakh cr payout from MoF to PMJDY.\n4. Tier: upgrade from reported to documented, for the fact that MoF/PIB published the claim. Keep upgradeIf/killIf, which apply to the savings figure itself.\n5. The c037 summary in the text says 'a quarter to a third'. Change it to '22–34% of the fall in value disbursed at the onset of reconciliation (control vs treated blocks, Jharkhand 2016–17)'. Keep '1.5–2 mn lost access', which is verbatim from the abstract. Note that this is a one-state result.\n6. c036: add a symmetry note that Barnwal (2019), cited in NBER w26744, later found substantial LPG-DBT expenditure reductions. The 2016 EPW contra is dated.\n7. The claim's srcs list the EPW and NBER URLs, but the stored c035 record cites only PIB. Keep the contra sources on c036/c037 and add the DBT Bharat URL to c035."
        ],
        "applied": [
          "no upgrade: recommended documented, kept reported",
          "innocentReading filled"
        ]
      },
      {
        "claimId": "welfare-central:c042",
        "domain": "central",
        "lens": "both",
        "refuted": true,
        "recommendedTier": "kill",
        "sourceCheck": "source-does-not-say",
        "denialFound": "The claim's contra c043 is not a real denial of what Congress actually alleged. Congress's documented allegation was about a model-code breach and making the announcement without Cabinet approval. The DNA India report of 8 Nov 2023 quotes Ramesh: \"This announcement of extension of PM Garib Kalyan Anna Yojana (PMGKAY) by five years is a clear violation of the model code of conduct as it was made even without the approval of the Union Cabinet during the poll process\" (https://www.dnaindia.com/india/report-congress-alleges-poll-code-violation-by-pm-modi-for-extending-free-ration-scheme-to-approach-ec-pmgkay-3067571; also Deccan Herald 2760199, which returned 403). DNA reports no government response. The factual counter on record is that the Cabinet approved the extension on 29 Nov 2023 (PIB 1980686), after the announcement, which tends to support Ramesh's procedural point rather than answer it. I found no report of an Election Commission ruling on the complaint.",
        "innocentReading": "PMGKAY was set to lapse on 31 Dec 2023, so a decision to extend or end it was due in Nov–Dec whatever the election calendar. Announcing an expected extension at a rally is political credit-taking for a decision that would have been needed anyway. On this reading there is no need to explain it by BJP \"losing\".",
        "reason": "The claim is a misattribution. The only cited source, ThePrint/ANI, quotes Congress saying BJP \"is losing the assembly polls\" in reply to Modi's Mahadev betting-app and corruption allegations. It does not tie the quote to the free-ration announcement, and the article reports no Congress reaction to the ration extension at all. The ₹11.80 lakh cr figure is also absent from that source; it comes from the PIB note of 29 Nov. The edge as written claims a Congress position on PMGKAY that its source does not support, so it should be killed. A real, differently worded Congress allegation exists (Jairam Ramesh on a model-code breach and no Cabinet approval) and could replace it at the alleged tier.",
        "corrections": [
          "1. Kill c042 as written, or rewrite it as follows. 2. lab/text: \"Congress (Jairam Ramesh, general secretary): PMGKAY 5-year extension announced at Durg rally without Union Cabinet approval is a 'blatant violation' of the model code; party to approach EC.\" 3. srcs: replace ThePrint with DNA India (https://www.dnaindia.com/india/report-congress-alleges-poll-code-violation-by-pm-modi-for-extending-free-ration-scheme-to-approach-ec-pmgkay-3067571) and Deccan Herald (https://www.deccanherald.com/india/pm-modis-free-ration-scheme-extension-amid-chhattisgarh-campaign-blatant-violation-of-poll-code-alleges-congress-2760199). Keep ThePrint only as the source for the 4 Nov Durg/Ratlam announcement. 4. from: the date of Ramesh's statement (about 5–8 Nov 2023), not 2023-11-04. 5. s: add or use person node Jairam Ramesh (INC), or keep party:inc with Ramesh named in d. 6. pred: \"enforce\" is wrong for a party allegation. It is kept for audit, court and CAG actions. Use \"enforce\" only if the edge models the EC complaint, and then point it at agency:eci; otherwise flag the predicate. 7. Remove \"₹11.80 lakh cr\" from any text sourced only to ThePrint; attribute it to PIB PRID 1980686 (29 Nov 2023). 8. c043: it is not a real contra to the model-code allegation. The 29 Nov Cabinet date supports Ramesh's \"no Cabinet approval\" point, so record c043 as context and note that no government or EC response was found. 9. killIf (\"Cabinet note predates 4 Nov 2023\"): the Cabinet approval came on 29 Nov, after the announcement, so this condition is not met for the rewritten claim."
        ],
        "applied": [
          "killed: recommended kill"
        ]
      },
      {
        "claimId": "welfare-central:c044",
        "domain": "central",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "analytic",
        "sourceCheck": "partially",
        "denialFound": "No direct government rebuttal of the \"vote-buying\" framing was found; the government was not directly asked in the sources I checked. The government's stated rationale is in the budget speech (paras 25-26): \"assured income support to the small and marginal farmers ... meet their emergent needs especially before the harvest season.\" The opposition charge exists: P. Chidambaram called it \"cash for votes\"/\"bribe for votes\" and said the Election Commission was unable to stop it (https://www.nationalheraldindia.com/national/chidambaram-bjps-pm-kisan-a-cash-for-votes-scheme-offers-crumbs-to-debt-ridden-farmers ; https://www.catchnews.com/politics-news/bjp-offering-cash-for-votes-to-placate-debt-ridden-farmers-through-pm-kisan-scheme-p-chidambaram-150595.html).",
        "innocentReading": "Interim budgets routinely carry policy. Rural distress became politically visible after the Dec 2018 losses in MP, Rajasthan and Chhattisgarh. There were state precedents: Rythu Bandhu (May 2018) and KALIA (Dec 2018). The scheme was not wound down after the election: it was widened to all landholders in June 2019 and has now run about 7.5 years. In July/August 2026 the Union Cabinet approved continuing it for FY2026-27 to 2030-31 with an outlay of ₹3,15,614 crore (Deccan Herald, The News Mill), which confirms the \"extended to 2031\" part of the innocent reading.",
        "reason": "The core facts check out against primary and pointer sources: announcement on 1 Feb 2019 and backdating to 1 Dec 2018 (budget speech para 25), first ₹2,000 on 24 Feb 2019 (Wikipedia), and BJP +21 seats. The claim does not assert causation, and it carries an innocentReading, so it meets the analytic bar. It also does not stitch facts together into a stronger charge than it states: it frames the timing as a pattern and gives upgradeIf/killIf conditions tied to recipient versus non-recipient panel data. It survives, but it needs corrections. The headline \"48 days\" is wrong (it should be 46). The \"extended to 2031\" part of the innocent reading was not sourced in the claim's srcs, and the contra (Chidambaram's charge and the government's rationale) is not attached.",
        "corrections": [
          "1) text and lab: change \"48 days\" to \"46 days\" (24 Feb 2019 to 11 Apr 2019 is 46 days; 1 Feb 2019 to 11 Apr 2019 is 69 days). 2) Budget speech src label: the PM-KISAN text is in paras 25-27; para 81 was not verified as PM-KISAN content, so drop \"81\" or check it. 3) Add a source for the 2031 extension, e.g. https://www.deccanherald.com/amp/story/india/cabinet-approves-extension-of-pm-kisan-scheme-till-fy31-with-outlay-of-rs-315-lakh-crore-4094567 or the PIB Cabinet release (Jul/Aug 2026: FY2026-27 to 2030-31, ₹3,15,614 cr). 4) \"Scheme has run seven years\" in the innocentReading: about 7.5 years as of Sep 2026; acceptable, but anchor it to the extension source. 5) Keep the 2019 general election Wikipedia src (it carries the +21 seats figure; the task payload dropped it). 6) Optionally attach a contra or opposition node: Chidambaram \"cash for votes\" (National Herald / Catch News, Feb 2019), with the budget speech para 26 rationale as the government's position. 7) Budget speech PDF: the WebFetch tool gets 403 but a direct curl works (HTTP 200, 22 pages); the source is reachable."
        ],
        "applied": [
          "recorded"
        ]
      },
      {
        "claimId": "welfare-central:c045",
        "domain": "central",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "analytic",
        "sourceCheck": "confirmed",
        "denialFound": "A contra exists, but the record does not include it. Congress, through general secretary Jairam Ramesh, called the announcement a \"blatant violation\" of the model code of conduct and said the party had filed an online complaint with the Election Commission and would meet it. Congress said it was \"not against the extension\" but objected that it was announced during the campaign without Cabinet approval (Deccan Herald, https://www.deccanherald.com/india/pm-modis-free-ration-scheme-extension-amid-chhattisgarh-campaign-blatant-violation-of-poll-code-alleges-congress-2760199; Outlook, https://www.outlookindia.com/national/congress-alleges-poll-code-of-conduct-violation-by-pm-modi-to-approach-ec-news-329457/). I found no formal Election Commission ruling and no specific rebuttal from the government or BJP. The only government framing is PIB's, which calls it a \"historic decision\" and a \"continuation\". No record shows whether the government was asked.",
        "innocentReading": "The free NFSA grain arrangement for 2023 was due to expire on 31 Dec 2023; Deccan Herald: \"which was to end on December 31\". So a decision had to be taken in Q4 2023 whatever the election calendar. It was framed as a continuation of statutory NFSA coverage, not new coverage. Five years is a long horizon for a one-season inducement. The later electoral payoff was not clear-cut: BJP fell from 303 to 240 Lok Sabha seats in 2024, down 63. Note that the 63-seat loss is outcome context, not an innocent explanation of the timing itself.",
        "reason": "Both sources confirm the core facts. ThePrint quotes Modi at Durg on 4 Nov 2023 (\"I have decided that the BJP government will extend the scheme of providing free ration to 80 crore poor people of the country for the next 5 years\") and gives CT phase 1 as 7 Nov. PIB confirms Cabinet approval on 29 Nov 2023, effective 1 Jan 2024, covering 81.35 cr people at ₹11.80 lakh cr. The claim is framed as analytic timing, not causation, and it carries an innocent reading, which meets the analytic bar. It survives as analytic.\n\nThe one factual error is \"after polls\": Telangana polled on 30 Nov, the day after Cabinet approval. The record also leaves out the Congress EC complaint, which is the documented contra.",
        "corrections": [
          "1. In `text`, change \"Cabinet approved 29 Nov (after polls, before counting)\" to \"Cabinet approved 29 Nov (after CT/MP/RJ/MZ polling, one day before Telangana polled on 30 Nov; before the 3 Dec counting; the model code was still in force)\". In `d`, change \"(after polling, before 3 Dec counting)\" the same way.\n2. Add a contra source: Deccan Herald, Nov 2023, on the Congress (Jairam Ramesh) allegation of a model-code violation and its online complaint to the Election Commission: https://www.deccanherald.com/india/pm-modis-free-ration-scheme-extension-amid-chhattisgarh-campaign-blatant-violation-of-poll-code-alleges-congress-2760199. Record that no Election Commission ruling was found.\n3. Note that the announcement came before Cabinet approval, which is the rarer property that makes this claim more than a routine pre-election announcement.\n4. Keep the 63-seat figure (303 to 240) but move it out of innocentReading into outcome context, citing the 2024 general election pointer. It does not explain the timing.\n5. Cite the 31 Dec 2023 expiry to a source: PIB's 23 Dec 2022 Cabinet release or the Deccan Herald piece. The current srcs do not state it."
        ],
        "applied": [
          "contra added welfare-central:c045:audit-contra"
        ]
      },
      {
        "claimId": "welfare-central:c052",
        "domain": "central",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "analytic",
        "sourceCheck": "confirmed",
        "denialFound": "The claim's own source contains a denial. PIB 1896038 (MoRD, 3 Feb 2023), answering media reports of the 18% cut, says \"This is far from truth. Mahatma Gandhi NREGA is a demand driven Scheme ... actual releases to the States have been much higher than that provided for at the BE level\" (https://www.pib.gov.in/PressReleasePage.aspx?PRID=1896038). PIB 2148475 (25 Jul 2025) says the ₹86,000 cr BE for 2024-25 \"was the highest ever allocation for scheme at the Budget Estimate (BE) stage since inception\" and that 99.79% of households demanding work were offered it (https://www.pib.gov.in/PressReleasePage.aspx?PRID=2148475). The record also cites Chouhan saying the Bill \"removes shortcomings of MGNREGA\" (newsonair, 30 Dec 2025). There is also contrary evidence after the claim window. ThePrint reports that Union Budget 2026-27 gave VB-G RAM G ₹95,692 cr plus ₹30,000 cr for MGNREGA (the transition quarter), and that the 2025-26 RE was raised to ₹88,000 cr (https://theprint.in/india/governance/vb-g-ram-g-gets-rs-95000-plus-crore-allocation-under-union-budget-2026-27-mgnrega-funds-reduced/2842622/).",
        "innocentReading": "MGNREGA is demand-driven, so BE is a placeholder that is routinely topped up. The 2023-24 BE of ₹60,000 cr was raised to an RE of ₹86,000 cr, and releases were ₹89,268 cr, about the same as 2022-23's ₹90,811 cr. The ₹1.11 lakh cr in 2020-21 was a one-off COVID peak (389 cr person-days). Compared with the pre-COVID year 2019-20 (₹71,688 cr), 2024-25 releases of ₹85,839 cr are about 20% higher in nominal terms and only slightly lower in real terms. Demand after COVID fell as the economy reopened. The 2024-25 BE was the highest ever. The successor law raises the guarantee to 125 days, and its 2026-27 central allocation (about ₹1.26 lakh cr including the MGNREGA transition money) is well above any MGNREGA year except 2020-21.",
        "reason": "Every number in the claim appears in a primary government record or the cited outlet: BE −18%, BE ₹86,000 cr held for 2024-25 and 2025-26, releases of ₹1,11,170.86 cr (2020-21) and ₹85,838.76 cr (2024-25), passage on 18/19 Dec 2025, 60:40 sharing, and 125 days. The analytic reading (squeeze, then repeal that shifts costs to states) comes with an explicit innocent reading, which is what the analytic tier requires. So the claim is not refuted. It does, however, lean on a misleading baseline. The \"₹1.11 → ₹0.86 lakh cr\" decline is measured from the COVID-peak year. Against 2019-20, nominal releases rose. The BE-cut pattern also appeared under UPA-II, so the \"squeeze\" half is not specific to the BJP. The claim can only be analytic. It must not be promoted, and the baseline and Budget 2026-27 context must be added. If 2026-27 central releases come in at or near the ₹1.26 lakh cr budgeted, the killIf condition is met and the edge should be killed or superseded.",
        "corrections": [
          "1) Text: replace \"releases down from ₹1.11 lakh cr to ₹0.86 lakh cr\" with \"releases ₹1.11 lakh cr in 2020-21 (COVID peak) → ₹0.86 lakh cr in 2024-25; vs pre-COVID 2019-20 ₹0.72 lakh cr, a nominal rise of ~20%\". 2) Text: \"nominal freeze 2024–26\" should add that the 2024-25 BE of ₹86,000 cr was +43% over the 2023-24 BE and the highest BE ever (MoRD), and that the 2025-26 RE was raised to ₹88,000 cr (ThePrint). 3) Text: \"passed both Houses in two days\" should read \"passed Lok Sabha 18 Dec 2025 by voice vote and Rajya Sabha after midnight the same night, about 3 days after tabling\". 4) Text: \"60:40 cost-sharing\" should read \"60:40 for most states (90:10 NE/Himalayan; 100% central for UTs without legislature), with normative state allocations\". 5) The text srcs omit PIB 2259712 (11 May 2026), the primary source for 60:40, 125 days and the 1 Jul 2026 repeal. Add it, as the record's srcs already do. 6) Add a contra/innocentReading item: Union Budget 2026-27 allocates ₹95,692 cr to VB-G RAM G plus ₹30,000 cr to MGNREGA (ThePrint), so central outlay rises nominally after repeal. The squeeze argument then moves to the roughly 40% state share (about ₹55,000 cr per Nikhil Dey). 7) Add a symmetry note: UPA-II cut MGNREGA BE from about ₹40,000 cr to ₹33,000 cr in 2012-13, so BE cuts alone do not distinguish the parties. 8) Relabel t or lab as \"BJP-led Union Government (FM Sitharaman; RD Minister Chouhan)\" rather than the party alone."
        ],
        "applied": [
          "contra added welfare-central:c052:audit-contra"
        ]
      },
      {
        "claimId": "women-cash:c005",
        "domain": "women-cash",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "analytic",
        "sourceCheck": "partially",
        "denialFound": "None found for the 2023 timing. Not asked, so no response is on record. A Congress objection exists for a later episode: Vivek Tankha called the Nov 2024 Rs 5,000 announcement a poll-code violation (Business Standard, 9 Nov 2024, https://www.business-standard.com/politics/ladli-bahna-aid-to-go-up-to-rs-5-000-mp-cm-cong-says-poll-code-violation-124110901203_1.html). That is outside this claim's window. The claim is analytic and implies no wrongdoing, so no contra edge is required. Paying an ongoing scheme during the model code is allowed under ECI practice.",
        "innocentReading": "The assembly has a fixed term and the scheme was announced in Jan 2023 and approved on 25 Feb 2023, so any 2023 rollout had to come before the November poll. Monthly instalments on about the 10th of each month naturally put one payment in the week before a 17 Nov poll. The October payment was moved to 4 Oct, before the model code, which is also consistent with avoiding a mid-code transfer rather than targeting votes. Congress promised Rs 1,500 a month (Kamal Nath's Nari Samman, Rs 18,000/yr) and lost, so the size of the cash offer alone did not decide the result. 80.4% of respondents reported benefiting against a 48.6% BJP vote share, so benefiting did not determine the vote.",
        "reason": "The claim survives because every factual part checks out against sources I opened, and it is correctly tiered as analytic with an innocentReading. Lokniti PDF p.12, Q22: \"Have you or anyone in your family (a female member) benefitted from the of Ladli Behena Yojana? 01: Yes 2454 80.4\". The Deccan Herald 3 Dec 2023 quotes support Rs 1,000 to 1,250 and the 9-10 Nov payment. Wikipedia/ECI supports 163 seats, +54 on 2018, and 17 Nov. India TV confirms the 10 Jun first payment and India TV/AajTak the 4 Oct Rs 1,250 payment. The problems are in the source chain and wording, not the substance. (a) The claim as passed lists only the Lokniti PDF. That PDF supports only the 80.4% figure; it says nothing about dates, Rs 1,250, the 7 days or +54. The file record cites Wikipedia and Deccan Herald instead of Lokniti, so the two source lists disagree. (b) Deccan Herald does not date the raise to October; that needs its own source. (c) \"80.4% household coverage\" misstates Lokniti. It is weighted respondent-level self-report (\"you or a female family member\"), not a household coverage rate. (d) \"Non-discriminating\" is right on base rate but overstated as \"cannot separate BJP from Congress voters.\" A 13.2% non-beneficiary group exists, and Lokniti (via Oneindia) reported that beneficiaries leaned BJP. The upgradeIf already calls for that cross-tab. (e) +54 is measured against the 2018 result (109), not against BJP's pre-dissolution strength after the March 2020 defections; say so.",
        "corrections": [
          "1) srcs: keep the Lokniti PDF (for 80.4% only) and add Deccan Herald 3 Dec 2023 (2794883), the Wikipedia/ECI 2023 MP result, India TV 10 Jun 2023 (first instalment, https://www.indiatvnews.com/madhya-pradesh/ladli-behna-scheme-yojana-madhya-pradesh-cm-shivraj-singh-chouhan-distributes-1st-installment-rs-1-000-each-to-1-25-cr-women-jabalpur-latest-updates-2023-06-10-875322), AajTak 6 Oct 2023 (Rs 1,250 paid 4 Oct ahead of schedule, https://www.aajtak.in/business/news/story/mp-ladli-behna-scheme-installment-deposit-before-due-date-by-cm-shivraj-singh-chouhan-tuta-1794003-2023-10-06), and Deccan Herald 5 Mar 2023 (Kamal Nath Rs 18,000/yr, i.e. Rs 1,500/month). Make the task-level srcs and the file record's srcs match. 2) Text: change \"raised to ₹1,250 in Oct\" to \"first ₹1,250 instalment paid 4 Oct 2023 (advanced from the 10th, before the 9 Oct model code)\". Change the benefit.changes date from \"2023-10\" to \"2023-10-04\". 3) Change \"80.4% household coverage\" to \"80.4% of post-poll respondents (weighted, N=3,050) reported themselves or a female family member benefiting\". 4) Change \"BJP +54 seats\" to \"BJP 163/230, +54 vs 2018 result (109); 48.62% vote share\". 5) innocentReading: change \"cannot separate\" to \"weakly discriminating: 80.4% reported benefit against a 48.6% BJP vote share\". Add the symmetry note: JMM's Maiyan Samman and Mahayuti's Ladki Bahin followed the same pre-poll pattern in 2024. 6) denial: record \"not asked; analytic, no wrongdoing implied\"."
        ],
        "applied": [
          "recorded"
        ]
      },
      {
        "claimId": "women-cash:c014",
        "domain": "women-cash",
        "lens": "both",
        "refuted": true,
        "recommendedTier": "reported",
        "sourceCheck": "partially",
        "denialFound": "No denial, but there is an official explanation in the same source. Outlook, 13 Jul 2026, WCD Minister Aditi Tatkare: \"The scheme was launched in June 2024 and the first two instalments were released together in August 2024. After that there were Assembly elections in November 2024 and the Model Code of Conduct came into force before October, because of which the eKYC exercise could not be started earlier.\" Newsgram, 15 Jul 2026, reports Tatkare saying money paid to ineligible beneficiaries \"would not be recovered, except for those given to male beneficiaries and government staffers.\" (https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification ; https://www.newsgram.com/maharashtra/2026/07/15/ladki-bahin-yojana-92-lakh-beneficiaries-removed-ekyc-verification). The government was asked, and this is its answer. It should be stored as a contra or context edge.",
        "innocentReading": "Enrolment was by self-declaration during a fast launch (June-August 2024), and the government says the Model Code of Conduct blocked authentication until after the poll. When verification came, it removed genuine ineligibles (income above Rs 2.5 lakh, government staff, overlapping benefits, age, about 29,000 men) plus a large group (about 62 lakh) who did not complete eKYC. That second group includes eligible women who dropped out because of friction, not only ineligible ones. The budget cut reflects a smaller roll. The same pattern appears in PM-Kisan and other DBT schemes with no election in the frame.",
        "reason": "The factual core survives and is well corroborated. Outlook says: \"More than 92 lakh women have been removed ... following a statewide verification exercise\"; \"declined sharply from around 2.43 crore to just over 1.5 crore\"; \"Officials estimate that those later deemed ineligible had collectively received close to Rs 14,000 crore\"; \"reduced the scheme's allocation from Rs 36,000 crore in 2025-26 to Rs 26,500 crore in 2026-27\". Newsgram, OpIndia, Swarajya and budget coverage (Drishti, PRS) repeat the same figures. The claim as worded fails on two points. (1) The tail \"reads as pre-poll over-enrolment\" appears in no source. It is our own inference joined onto reported facts, so it cannot carry the reported tier. It needs to be a separate analytic edge with the minister's MCC explanation as its innocent reading and a symmetric comparator such as PM-Kisan's eKYC drop. (2) \"Paid to since-ineligible recipients\" overstates the source: about 62 lakh of the 92 lakh were removed only for not completing eKYC, which the source does not equate with ineligibility. The officials' Rs 14,000 cr is an unaudited estimate, not a finding from a primary record. Keep the factual edge at reported, since there is no WCD order or press note in hand and the outlets trace back to the same unnamed \"officials\".",
        "corrections": [
          "1. Remove \"reads as pre-poll over-enrolment\" from the reported edge. If the point is wanted, add it as a separate analytic claim whose innocentReading quotes Tatkare's MCC and eKYC-timing explanation, with a base-rate comparator (PM-Kisan dropped about 11 cr to about 8 cr after eKYC). 2. In d, change \"paid to since-ineligible recipients\" to \"paid to since-de-listed recipients (officials' estimate; ~62 lakh of the 92 lakh removed for non-completion of eKYC, not proven ineligibility)\". 3. Add a contra or context edge quoting Tatkare (Outlook, 13 Jul 2026) and the no-recovery statement except for men and government staff (Newsgram, 15 Jul 2026). 4. Add a second source for the Rs 26,500 cr FY2026-27 BE (budget of 6 Mar 2026, e.g. PRS Maharashtra Budget Analysis 2026-27 at https://prsindia.org/budgets/states/maharashtra-budget-analysis-2026-27), and state that the BE came before the July verification report. 5. Add the missing innocentReading field. 6. The pred \"supersede\" is a self-loop (s = t = scheme:mh-ladki-bahin). Consider a results entry on the scheme, or an enforce or supersede edge pointing to a dated beneficiary-count node, rather than a self-edge. 7. Keep upgradeIf (WCD order or press note with the breakdown). Also note that Newsgram's \"8,000 women in government service\" conflicts with Outlook's \"4.42 lakh government employment\". Do not cite either sub-figure until a primary record is found."
        ],
        "applied": [
          "innocentReading filled"
        ]
      },
      {
        "claimId": "women-cash:c015",
        "domain": "women-cash",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "alleged",
        "sourceCheck": "partially",
        "denialFound": "No direct response to Sule's allegation or her SIT demand was found. The DH, Telangana Today (IANS) and Zee pieces carry no reply from the government, Fadnavis, Tatkare or Pawar. It is not recorded whether anyone was asked. The \"contra\" material is the government's own statement from before the allegation: 26.34 lakh people \"temporarily suspended for the June instalment\" (Tatkare), and money taken by 14,298 men, Rs 21.44 cr, which \"the government says would be recovered and offences would be registered\". DH ties that recovery statement to Dy CM Ajit Pawar (\"Money will be recovered, says Dy CM Pawar\"), not to Tatkare. Sources: https://www.deccanherald.com/india/maharashtra/supriya-sule-alleges-rs-4800-crore-fraud-in-ladki-bahin-yojana-seeks-sit-probe-3654533 ; https://telanganatoday.com/supriya-sule-alleges-rs-4800-crore-scam-in-ladki-bahin-yojana-blames-maha-cabinet. The eKYC/Model Code explanation is from 13 Jul 2026: https://www.outlookindia.com/national/maharashtra-removes-over-92-lakh-beneficiaries-from-ladki-bahin-scheme-after-verification. Sule herself said she would not blame Tatkare. She held the whole Cabinet responsible and said CM Fadnavis should answer.",
        "innocentReading": "The Rs 4,800 cr is about what you get from 26.34 lakh people × Rs 1,500/month × about 12 months (roughly Rs 4,741 cr). It is the gross amount paid to beneficiaries the department later found ineligible, not money shown to have been stolen. Enrolment was fast, eligibility was self-declared, and the rollout came before the election. Verification (IT-department data matching, then eKYC) happened afterwards and removed ineligible people. That is a targeting error and a leakage problem, and the government disclosed it itself. It is not necessarily fraud with intent. Payments to men (Rs 21.44 cr) look closer to fraud and are being recovered.",
        "reason": "The core claim holds against the source. DH, 29 Jul 2025, quoted: \"Supriya Sule alleged a Rs 4,800 crore scam and demanded a probe by a Special Investigation Team (SIT)... According to her, 26.34 lakh beneficiaries were declared ineligible after being initially approved.\" Telangana Today/IANS and Zee carry the same report. Sule is a named party, and a contra edge (c016) exists, so the `alleged` tier is right. The contra clause in the claim text is wrong in two places. (a) The source attributes the 14,298 men / Rs 21.44 cr recovery to \"the government\" and in a linked headline to Dy CM Pawar, not to Tatkare. (b) The eKYC/Model Code explanation is not in the cited source; it comes from a July 2026 Outlook piece. Neither item is a response to Sule. Both are the government's own earlier disclosures, so the record should say no direct denial was found. These are fixable errors of attribution and date. They do not refute the fact that the allegation was made.",
        "corrections": [
          "1) Claim text, contra clause: change to \"contra c016: govt (WCD minister Tatkare) had itself suspended 26.34 lakh in Jul 2025; govt/Dy CM Pawar said Rs 21.44 cr paid to 14,298 men would be recovered and offences registered; in Jul 2026 Tatkare said eKYC was delayed by the Model Code (Outlook, 13 Jul 2026)\". Do not present the Model Code point as a July 2025 reply. 2) Add to the record: \"no direct government response to Sule's allegation/SIT demand found; not recorded whether asked\". 3) Add to d: \"Sule exempted Tatkare and blamed the full Cabinet and CM Fadnavis\". Also: \"Rs 4,800 cr ≈ 26.34 lakh × Rs 1,500 × ~12 months, i.e. gross payments to later-ineligible beneficiaries, not quantified theft\". 4) Add a second source for the allegation: https://telanganatoday.com/supriya-sule-alleges-rs-4800-crore-scam-in-ladki-bahin-yojana-blames-maha-cabinet (IANS wire; not independent of Zee). Note Telangana Today reports her demand as a \"high-level inquiry\" and a white paper, while DH has \"SIT\". 5) c016: change the s node, or split the edge, so the recovery statement is attributed to the government/Ajit Pawar and the Model Code quote to Tatkare with from=2026-07-13. 6) killIf is fine. Add innocentReading as above."
        ],
        "applied": [
          "innocentReading filled"
        ]
      },
      {
        "claimId": "women-cash:c017",
        "domain": "women-cash",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "alleged",
        "sourceCheck": "confirmed",
        "denialFound": "None found (searched). There is no retraction or clarification from Sawarkar and no BJP or Mahayuti rebuttal of this specific remark, either in the PTI/DH or India TV reports or in web search. Neither report says the MLA or the party was asked for comment. The nearest thing to a government response is general and came earlier: CM Shinde at the launch said people \"must not fall prey to the fake narrative of the opposition about the Ladki Bahin Yojana\" (quoted in India TV, https://www.indiatvnews.com/maharashtra/bjp-mla-controversial-statement-on-ladki-bahin-yojana-maharashtra-government-assembly-elections-2024-opposition-reactions-latest-updates-2024-09-25-953893).",
        "innocentReading": "This was stump rhetoric at a local rally. A backbench MLA claimed credit for a popular benefit and asked beneficiaries to vote for the lotus, which is how every incumbent campaigns on delivered welfare. He was not describing how the cabinet actually decided. The scheme was announced in the regular 2024-25 budget, and the MP Ladli Behna model had already been copied across states. Nothing in the reports shows that his view reflects how the scheme was really designed.",
        "reason": "The source says what the claim says. PTI via Deccan Herald (by-line PTI, 25 Sep 2024) quotes: \"We came up with this jugaad (ploy) of Mukhyamantri Majhi Ladki Bahin Yojana to ensure women vote for the BJP. Tell me honestly, why else would we do it? Because during polls, my dear sisters will vote for the BJP.\" He added that \"our only 'swarth' (motive) is to get votes,\" and LoP Vijay Wadettiwar shared the video clip on X. India TV independently reports the same clip with a different translation. That the remark was made is therefore solid: two outlets plus a circulated video, strong enough on its own for reported or even documented. The edge is framed as an allegation about the scheme's vote-buying intent, so alleged is the right tier. It is a named party's statement, and it cannot be documented, because one MLA's rally speech does not establish what the government intended. The weak point is the contra. c019, the Bombay HC ruling of 5 Aug 2024, came seven weeks before the remark. According to the DH text it dealt with a PIL about the burden on taxpayers (\"It is a policy decision, so we cannot interfere unless there is violation of any fundamental rights\"). It never considered electoral inducement or motive. \"Not discriminatory\" appears only in DH's headline. Legal validity does not answer electoral intent, so the claim wrongly joins two true facts as if one rebuts the other.",
        "corrections": [
          "(1) c017 `from`: change 2024-09-25 to 2024-09-24, the day of the speech (\"on Tuesday\" per PTI). Keep 25 Sep as the publication date in the source label. (2) Add a second source: India TV, 25 Sep 2024, https://www.indiatvnews.com/maharashtra/bjp-mla-controversial-statement-on-ladki-bahin-yojana-maharashtra-government-assembly-elections-2024-opposition-reactions-latest-updates-2024-09-25-953893. Note that it places the meeting in Mauda, not Kamthi. (3) c017 `d`: add that LoP Vijay Wadettiwar (Congress) circulated the clip, and that no denial or clarification by Sawarkar or the BJP was found and the reports do not say either was asked. (4) c019: it does not rebut c017. Relabel it along the lines of \"court: scheme is a policy decision beyond judicial interference (fiscal-burden PIL); did not address electoral motive\". Delete the `d` text \"institutional answer to the 'inducement' framing\", which overstates what the ruling covered. Mark \"not discriminatory\" as DH's headline wording, not the court's quoted holding. If a real contra is needed, use Shinde's \"fake narrative of the opposition\" statement, or the Lokniti-CSDS finding already in the narrative that there is \"hardly any connection between welfare and vote.\" (5) The claim text's \"contra c019\" clause should not suggest that the HC ruling responded to the remark, since the ruling came first."
        ],
        "applied": [
          "innocentReading filled"
        ]
      },
      {
        "claimId": "women-cash:c057",
        "domain": "women-cash",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "analytic",
        "sourceCheck": "partially",
        "denialFound": "Not a denial of the facts, but a response on legitimacy exists. RJD MP Manoj Jha wrote to the ECI alleging MCC violation over the transfers on 17, 24 and 31 Oct and the planned 7 Nov transfer (Business Standard https://www.business-standard.com/elections/bihar-elections/rjd-s-manoj-jha-writes-to-ec-accuses-bihar-govt-of-mcc-violation-125103101715_1.html; Outlook https://www.outlookindia.com/elections/rjds-manoj-jha-accuses-bihar-government-of-violating-mcc-with-pre-poll-cash-transfers). Unnamed \"informed official sources\" answered that there was no violation because the scheme was approved by the Bihar cabinet on 29 Aug 2025 and launched on 26 Sep, before the MCC started on 6 Oct (ETV Bharat https://www.etvbharat.com/en/bharat/rjd-leader-writes-to-ec-says-bihar-govt-violated-mcc-by-transferring-money-to-women-ahead-of-poll-enn25110100014). None of this is in the record.",
        "innocentReading": "The assembly term ended on 22 Nov 2025 (confirmed in the ECI release), so any benefit launched after mid-2025 would fall inside the poll window. The scheme is designed as livelihood seed capital through the existing JEEVIKA SHG network, with up to Rs 2 lakh more in later phases tied to business progress, not an open-ended monthly cash payment. Cabinet approval (29 Aug) and the launch came before the MCC. The NDA swing has many other plausible causes: coalition realignment (LJP(RV) back in the NDA), the SIR roll revision, and anti-incumbency against the opposition alliance. No study isolates the effect of MMRY.",
        "reason": "The claim survives because every hard fact checks out against sources. Rs 7,500 cr to 75 lakh women on 26 Sep 2025 comes from the PIB release (which says \"will\"), and 26 Sep news reports confirm it was paid. The ECI release confirms the 6 Oct schedule and the 22 Nov 2025 term end. Deccan Herald confirms the NDA's 202 seats. The claim is a set of true facts put side by side that suggest a causal link (\"paid, then won big\"), which is exactly what the analytic tier covers, and the claim carries the required innocent reading. Timing alone does not discriminate (every party in the file does pre-poll payouts); the claim rests on scale, and the \"largest in the file\" superlative holds. Problems that need correcting rather than killing: (a) the claim's only cited source is a forward-looking PIB release that does not mention the ECI date, polling, 125 or 202; (b) the 2020 figure of 125 is not sourced anywhere; (c) the id c057 points to a different record; (d) the claim leaves out the larger pre-poll programme (about 1.41 crore women paid by 31 Oct, including tranches during the MCC) and the RJD complaint with the official reply, which is the actual response on record.",
        "corrections": [
          "1) ID: women-cash:c057 in women-cash.json is the Haryana Lado Lakshmi role edge. Give the Bihar analytic claim its own id (it currently lives only as scheme:br-mukhyamantri-mahila-rozgar results[0]). 2) srcs: add the ECI/PIB release of 6 Oct 2025 (https://www.pib.gov.in/PressReleasePage.aspx?PRID=2175533) and the Deccan Herald results page to the claim's own srcs. Add a post-event confirmation of the transfer (ANI 26 Sep 2025 https://aninews.in/news/national/general-news/pm-modi-launches-mukhyamantri-mahila-rojgar-yojana-for-bihar-transfers-rs-7500-cr-to-women20250926115427/ or DD News https://ddnews.gov.in/en/pm-modi-launches-bihars-mukhyamantri-mahila-rojgar-yojana-transfers-rs-7500-crore-to-75-lakh-women/), since PIB 2171342 is prospective. Add a 2020 result source for 'NDA 125', or say 'NDA (2020 composition: BJP 74, JD(U) 43, VIP 4, HAM 4) 125; 2025 composition includes LJP(RV)'. 3) approved.date: 2025-08-29 (Bihar cabinet, per reporting of the official response). Also note the application portal was launched on about 7 Sep 2025 by Nitish Kumar (newsonair). 4) Add status/outlay entries for the later tranches: 3 Oct 2025, 25 lakh women, Rs 2,500 cr (newsonair); 6 Oct 2025, 21 lakh women; and 17, 24 and 31 Oct plus 7 Nov (Manoj Jha letter). About 1.41 crore women were paid by 31 Oct (Amit Shah). outlay actualCr 7500 understates FY2025-26. 5) Add an alleged claim (RJD/Manoj Jha: MCC violation) with a contra (official sources: approved 29 Aug, launched before the 6 Oct MCC). 6) Deccan Herald label date: page shows 'Last Updated: 14 November 2025', not 15 Nov. 7) Keep the tier analytic; do not upgrade. No source ties the transfer to the seat outcome."
        ],
        "applied": [
          "downgrade documented → analytic",
          "innocentReading filled"
        ]
      }
    ],
    "unmatched": [
      {
        "claimId": "1",
        "domain": "literature",
        "lens": "both",
        "refuted": true,
        "recommendedTier": "analytic",
        "sourceCheck": "partially",
        "denialFound": "Not applicable in the usual sense: this is a literature synthesis with no accused party. The published contrary evidence is Imai, King and Velasco Rivera (2020), abstract via search: \"neither SPS nor Progresa has a causal effect on voter turnout or electoral support for the incumbent party\" (https://gking.harvard.edu/sites/g/files/omnuum7116/files/gking/files/programmatic.pdf). Also Zimmermann (2021), Crossref abstract: \"length of program exposure lowers electoral support for the government\" (https://api.crossref.org/works/10.1162/rest_a_00935).",
        "innocentReading": "Positive incumbent effects in Latin American and Philippine CCT studies can reflect publication bias and context. Programmatic, rule-based transfers that incumbents cannot target may not move partisan votes (Imai et al). In India, scheme-specific signs in cross-sectional post-poll data (Deshpande et al: \"some evidence\", survey associations, not causal) may reflect who is selected into each scheme: MGNREGA and pension recipients are poorer and rural, and lean differently. They need not reflect any reward or punishment for the transfer. That the narrative is \"contested\" is itself the innocent reading, and it survives.",
        "reason": "The overall verdict \"contested\" holds and is strengthened by the evidence. But two of the numbers it rests on are wrong. (1) \"0/8 causal vote estimates\" for India is false: Zimmermann (2021, REStat, DOI 10.1162/rest_a_00935) is a published regression-discontinuity causal estimate for NREGA, a scheme in this file, and finds that longer programme exposure lowers electoral support for the government. The file's central void, \"the strongest tools... have not been applied in India\", is contradicted. (2) \"5/6 international causal studies\" includes Hunter and Power (2007), which the file itself labels observational. It also counts De La O (2013) and Imai et al (2020) as independent when Imai et al reanalyse the same Progresa experiment. As for the attached sources: the Deshpande abstract confirms verbatim that \"recipients of pensions or MGNREGA were less likely to support the BJP\" and that Ujjwala recipients were \"more likely\", though only as \"some evidence\" from a survey. Crossref holds no abstract for Imai et al, but the published abstract confirms the null. Neither attached source supports the 5/6 or the 0/8 figures. The tier stays analytic because this is a calibrated synthesis, but the claim text must be corrected before it can pass.",
        "corrections": [
          "1. Replace \"5/6 international causal studies find incumbent rewards\" with \"4 of 5 causal or quasi-experimental studies in this file (Manacorda 2011 RD, De La O 2013 RCT, Labonne 2013, Zucco 2013) find incumbent rewards, plus one observational study (Hunter & Power 2007); Imai, King & Velasco Rivera 2020 reanalyse the same Progresa experiment as De La O and find no effect on turnout or incumbent support (and none for Seguro Popular)\". Also say the sample is the papers in this file, not the literature.\n2. Replace \"India has 0/8 causal vote estimates\" with \"India has 1/8: Zimmermann 2021 (REStat 103(5), DOI 10.1162/rest_a_00935), an RD on NREGA rollout, finds longer exposure lowered support for the government\". Add this source to srcs and to baseRates[1] (numerator 0 becomes 1), and revise voids[0] and the narrative's strongestCounter (\"no Indian scheme has a causal vote estimate\").\n3. Qualify Deshpande et al 2019 as \"NES 2019 post-poll associations ('some evidence'), not causal\", and add Awas and Jan Dhan (+) and pensions (−) for completeness.\n4. Add the Crossref URLs for Manacorda, De La O, Zucco, Labonne and Hunter & Power to srcs; at present only the Imai and Deshpande URLs are attached, and neither supports the 5/6 count.\n5. Keep status \"contested\" and tier analytic."
        ],
        "applied": [
          "no claim with this id in the fleet"
        ]
      },
      {
        "claimId": "2",
        "domain": "literature",
        "lens": "both",
        "refuted": true,
        "recommendedTier": "analytic",
        "sourceCheck": "partially",
        "denialFound": "The strongest contra comes from Lokniti-CSDS's own authors in The Hindu on 7 Dec 2023, which I could reach this time (HTTP 200).\n(1) Borbora and Gyani, \"Welfare scheme beneficiaries push BJP to victory in Madhya Pradesh\": \"the advantage the BJP garnered on account of welfare schemes ... is not huge and only marginally accounts for its victory. The same is true of the much discussed Ladli Behna Yojana which ... did not make any extra-ordinary addition to BJP vote share among women, contrary to the general belief.\" https://www.thehindu.com/elections/madhya-pradesh-assembly/lokniti-csds-survey-welfare-scheme-beneficiaries-push-bjp-to-victory-in-madhya-pradesh/article67611355.ece\n(2) Mishra and Kumari, \"How much did women contribute to BJP's success\": \"43% of women voted for Congress, while 47% supported the BJP ... Congress polled more among women than it did among men voters and BJP polled more among men than among women\"; \"women beneficiaries of Ladli Lakshmi and Ladli Behena Yojana generally favoured the BJP, with 49% and 48% respectively ... women not benefiting ... especially Ladli Behana, tended to prefer the Congress\"; \"the BJP's victory cannot be attributed to women voters alone.\" https://www.thehindu.com/elections/madhya-pradesh-assembly/lokniti-csds-survey-how-much-did-women-contribute-to-bjps-success-in-madhya-pradesh/article67611420.ece\n(3) Kumar, Palshikar, Shastri and Sisodia, the lead piece, say the women's schemes \"helped the BJP garner support\". https://www.thehindu.com/elections/madhya-pradesh-assembly/lokniti-csds-survey-how-the-bjp-worked-to-retain-madhya-pradesh/article67610975.ece\nCongress was not asked in this record.",
        "innocentReading": "The BJP gained 7.5 points of vote share across all six regions and did better among men, young voters, urban voters and the educated. The swing is broad-based and fits several explanations together: satisfaction with the Centre (7 in 10) and with the state government (6 in 10), the Modi and Chouhan campaign, late deciders breaking to the BJP, and Congress's early manifesto. Women beneficiaries voted BJP at about the party's statewide share (48% against 48.5%). That looks like beneficiaries mirroring the electorate, not a scheme-specific swing. Women who did not benefit leaned Congress, but that is only about 13% of respondents, which is too small a group to have decided the result.",
        "reason": "The claim's central evidential point was that Lokniti published no beneficiary × vote or gender × vote tables, and it asked a reviewer to check whether cross-tabs existed elsewhere because The Hindu was unreachable. The Hindu is reachable now. Lokniti published both tables on 7 Dec 2023, and its researchers concluded that Ladli Behna \"only marginally accounts for\" the win and \"did not make any extra-ordinary addition to BJP vote share among women\". The women's vote gap is 4 points (47 BJP to 43 INC), and the BJP did better among men than among women.\nSo the narrative's strongestCounter is wrong in two places. It says there is no beneficiary × vote table, and it says 80% coverage leaves no counterfactual. Lokniti does compare non-beneficiaries, and those women leaned Congress. The narrative also leaves out the most decisive contra, the survey authors' own reading.\n\"Congress matched\" is the wrong direction: the Deccan Herald source shows Congress offered ₹18,000/yr (₹1,500/month) against the scheme's ₹1,000/month, on the launch day itself. The numbers that do hold: 80.4% (Q22 yes = 2,454/3,050), BJP 48.6% valid vote (1,448), INC 40.0%.\n\"Contested\" can stay as the headline status, but it should now lean clearly toward \"not supported by the survey that measured it\". As written, the record's evidence base and counter-case are incomplete and partly wrong, so it fails until corrected. It stays at the analytic tier, and the underlying facts can now be cited as documented from Lokniti.",
        "corrections": [
          "1. Replace \"no beneficiary×vote or gender×vote table in the findings PDF as read\" and remove the reviewer flag. Say instead that Lokniti published the cross-tabs in The Hindu on 2023-12-07: women 47% BJP to 43% INC; BJP did better among men than women; women Ladli Behna beneficiaries 48% BJP, Ladli Laxmi 49%; women non-beneficiaries leaned INC. Lokniti's authors say the scheme \"did not make any extra-ordinary addition to BJP vote share among women\" and \"only marginally accounts for\" the win. Add article67611355, article67611420 and article67610975 to srcs and to the file's sources list.\n2. In the narrative's strongestCounter, delete \"the public findings PDF has no beneficiary × vote table\" and \"Coverage of 80% leaves no counterfactual group\". Put the Lokniti authors' conclusion there as the lead counter.\n3. Change \"Congress matched at ₹1,500/month\" to \"Congress (Kamal Nath) outbid, promising ₹18,000/yr (₹1,500/month) on 2023-03-05, the same day the ₹1,000/month scheme was launched\". The Deccan Herald gives only the annual figure; ₹1,500/month is arithmetic. Fix the matching finding in scheme:mp-ladli-behna results too (\"both parties bid\" is fine; \"matched\" is not).\n4. Rename \"80.4% household coverage\" to \"80.4% of respondents said they or a female family member benefited (Q22)\". It is respondent-level, not a household enumeration.\n5. Remove \"The Hindu unreachable\" from the MP 2023 source label (line ~271). It returned HTTP 200 on 2026-09-25.\n6. Update whatWouldChangeThis. The cross-tabs now exist, so what remains is a district-level turnout or enrolment design, or a discontinuity on eligibility (the age 21/23 to 60 cutoffs or the income ceiling).\n7. Consider re-labelling the narrative status as \"contested; the measuring survey's authors say marginal\". Also update the \"Cash transfers buy elections\" narrative, which cites \"MP 2023 post-polls show the winning side ahead among women\": the lead was 4 points, and the BJP's lead was bigger among men."
        ],
        "applied": [
          "no claim with this id in the fleet"
        ]
      },
      {
        "claimId": "ap2024-counter-narrative",
        "domain": "elections-timing",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "analytic",
        "sourceCheck": "partially",
        "denialFound": "None found; not asked. This claim accuses nobody, so no contra is required. The cited source quotes no YSRCP explanation of the loss. The narratives row's 'YSRCP supporters argue united opposition / money-media asymmetry' has no source. Jagan's reported 4 June 2024 remark (that he could not understand where beneficiaries' votes went) was not retrieved with a URL this session and must not be added unsourced. The web search budget was exhausted.",
        "innocentReading": "The file's innocentReading is adequate: anti-incumbency, the TDP-BJP-JSP consolidation, and non-welfare issues. The cited Wikipedia page lists special category status, the Amaravati capital dispute, unemployment and the Land Titling Act as key issues. Any of these can explain the loss without the transfers being either decisive or repudiated. An extra reading worth adding: the challenger promised to continue and expand the welfare schemes, which neutralised welfare as a differentiator. The Wikipedia source records both manifestos promising welfare continuation.",
        "reason": "The central fact holds and is quoted in the cited source: \"The political alliance Kutami, led by the Telugu Desam Party (TDP), won the election in a landslide, winning 164 of the 175 seats. The TDP won 135 out of 144 contested seats... The incumbent YSR Congress Party (YSRCP) only won 11 seats.\" An analytic claim with an innocentReading is the right tier. But the claim's seat figure is wrong: 135/175 is TDP alone, while the TDP-led alliance won 164/175. The scale premise ('one of India's largest state DBT architectures') and Cheyutha are not supported by the cited source or by any source in the record. The base rate (incumbent loss is about a coin flip, and TDP also lost in 2019 after pre-poll transfers) means the case is suggestive, not 'strongest'. It survives only as analytic, with the corrections below.",
        "corrections": [
          "1) The claim text and electionContext.seatChange on scheme:ap-ysr-rythu-bharosa and scheme:ap-ysr-amma-vodi should change from 'TDP-led alliance 135/175' to 'TDP-led alliance (Kutami) 164/175 (TDP 135 of 144 contested, JSP 21/21, BJP 8/10); YSRCP 11/175, down from 151 in 2019.' 2) The narratives row 'Andhra Pradesh 2024' says YSRCP 'lost 124 of 135 contested seats it had held'. This is wrong: YSRCP held 151 seats after 2019 and won 11 in 2024, a net loss of 140. Fix it. 3) Either source 'one of India's largest state DBT architectures' (DBT outlay or beneficiary figures for 2019-24 from an AP budget, a CAG report or a credible outlet) or soften it to 'a large multi-scheme DBT programme'. The Wikipedia election page does not say this. 4) Drop 'Cheyutha' from the claim text, or add a sourced scheme record for it. 5) Soften 'the file's strongest counter-case' to 'a prominent counter-case'. Add to the innocentReading that both alliances promised to continue the welfare schemes, and that TDP also lost in 2019 after pre-poll transfers (symmetry). 6) Record denialFound as 'no YSRCP explanation sourced; not asked', and add upgradeIf: an AP post-poll survey (e.g. Lokniti-CSDS 2024) giving YSRCP vote share among DBT beneficiaries compared with non-beneficiaries. 7) The rythu-bharosa status row ('discontinued 2025-01-01, superseded by Annadata Sukhibhava') has empty srcs. Source it or mark it as a gap."
        ],
        "applied": [
          "no claim with this id in the fleet"
        ]
      },
      {
        "claimId": "pmgkay-extension-rally",
        "domain": "elections-timing",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "analytic",
        "sourceCheck": "partially",
        "denialFound": "No direct denial found. The accused was not asked in the cited source. The government's own framing, quoted by DH from the ministry, is the policy rationale: \"It would provide nationwide uniformity in delivery of foodgrains free of cost in all States/UTs through a network of over 5 lakh Fair Price Shops under a common logo.\" I found no ECI ruling or Congress MCC complaint on the record; web search budget was exhausted and The Hindu was unfetchable, so I could not verify one either way. Source: https://www.deccanherald.com/india/modi-govt-extends-pmgkay-scheme-for-another-5-years-from-jan-1-2024-2789220",
        "innocentReading": "The COVID-era free-grain top-up had already been extended seven times and folded into NFSA free distribution from Jan 2023. It was due to lapse on 31 Dec 2023, so a decision was needed in Nov/Dec 2023 whatever the electoral calendar. At about Rs 2.13 lakh crore a year, it is a continuing food-security commitment that the IMF credited with keeping extreme poverty flat through 2020. Only the podium was chosen for the announcement; the lapse date fixed the timing.",
        "reason": "The claim survives as analytic. The one cited source (Deccan Herald, 29 Nov 2023) confirms the load-bearing facts: Modi announced the extension \"at an election rally in Chhattisgarh\" nearly a month before the 29 Nov Cabinet approval, the extension runs to the end of 2028, and DH itself calls the move one \"seen as an important move by the government to woo voters in the ongoing Assembly elections and Lok Sabha polls next year\". The claim correctly declines to call this misuse and offers an innocent reading: the scheme was due to lapse on 31 Dec 2023. Timing alone does not discriminate, since almost every PMGKAY extension fell near an election. What does is the rally-before-Cabinet sequence, and that supports an analytic finding, not a higher tier. Several defects need fixing, though none refutes the claim: the date is wrong in three places, \"Durg\" is uncited, and the claim id does not exist in the file.",
        "corrections": [
          "1) The claim id \"claim:pmgkay-extension-rally\" does not exist in research/raw/welfare/elections-timing.json. Add it as a pred:\"analytic\" claim (s: pol:narendra-modi, t: scheme:pmgkay) with an explicit innocentReading field; the analytic tier requires one. 2) Change the date 2023-11-23 to 2023-11-04 (Durg rally) in three places: claim:modi-announce-pmgkay-extension \"from\", scheme:pmgkay.benefit.changes[0].date and scheme:pmgkay.ministers[1].date. As it stands, 23 Nov contradicts DH's \"nearly a month\" and falls after Chhattisgarh's last polling day (17 Nov). 3) Add a second source that names Durg and the 4 Nov date (e.g., contemporaneous PTI, The Hindu or Indian Express report of the Durg rally). DH says only \"an election rally in Chhattisgarh\". 4) Add the fact that the Cabinet approval on 29 Nov 2023 came while the MCC was still in force for Telangana (polled 30 Nov). 5) Remove or soften the editorial \"sharpest single image of the pattern\". It is an opinion no source supports; replace it with a neutral statement: \"announcement preceded the formal Cabinet decision by ~25 days.\" 6) In scheme:pmgkay.status[0].note, rephrase so the Cabinet date (29 Nov) is not mixed up with the rally date. 7) The ministers[2] entry for pol:pralhad-joshi has empty srcs; it needs a source."
        ],
        "applied": [
          "no claim with this id in the fleet"
        ]
      },
      {
        "claimId": "scheme:mh-ladki-bahin:result:sule",
        "domain": "literature",
        "lens": "both",
        "refuted": false,
        "recommendedTier": "alleged",
        "sourceCheck": "partially",
        "denialFound": "A contra exists, and part of it is on the cited page. The record's note that there is \"no contra available\" is wrong. On the DH page itself: Tatkare \"said that 26.34 lakh people are ineligible under the Ladki Bahin Scheme, and have been temporarily suspended for the June instalment\". The page also says the Rs 21.44 crore taken by 14,298 men \"the government says would be recovered and offences would be registered\", and it links a related story headed \"Men in Ladki Bahin Yojana list: Money will be recovered, says Dy CM Pawar; promises action\". ThePrint (2025-07-28, https://theprint.in/politics/in-mahayutis-poll-winning-ladki-bahin-scheme-14000-of-26-lakh-bogus-beneficiaries-found-to-be-men/2705061/) quotes Tatkare explaining the ineligible cases as \"availing of multiple government schemes ... more than two members of the same family ... male applicants\", quotes Ajit Pawar saying \"We will recover the money given out to them\", and quotes Fadnavis saying \"26 lakh such accounts have been found that do not fit the bill\". I found no direct government rebuttal of the words \"scam\" or \"SIT\" addressed to Sule by name. The government's position is that the problem was detected, suspended and will be recovered, not that it was a fraud by the cabinet. Whether ministers were asked about Sule's charge specifically: not found.",
        "innocentReading": "The Rs 4,800 crore is not Sule's own estimate. A PTI story carried by Siasat on 2025-07-28 says: \"Sources in the department have estimated that the loss due to ineligible beneficiaries availing the monthly benefit is likely to be around Rs 4,800 crore till date.\" The simple explanation is that a scheme enrolled at high speed before the November 2024 election (self-declared eligibility, 2.5 crore enrolments) took in ineligible applicants. These included people on overlapping schemes, more than two women per family, and some men. The government's own cross-check against other departments' data (DH headline: \"shares IT dept info\") then found and suspended them. That points to weak targeting and loose pre-election enrolment rather than proven fraud. Whether the loss is a \"scam\" (deliberate diversion) or leakage from lax verification is exactly what an SIT, a CAG audit or a follow-up on the FIRs would settle.",
        "reason": "The core claim holds up against the source. The Deccan Herald text, retrieved by curl from the AMP page after WebFetch returned a 403, says Sule \"alleged a Rs 4,800 crore scam and demanded a probe by a Special Investigation Team (SIT)\" and \"questioned the transparency of the Direct Beneficiary Transfer mechanism\". The date, actor and amount all match. Two parts of the record are wrong. (1) It says the government's reply \"was not captured in the page text opened — no contra available\". The same page contains the government's position: Tatkare's suspension of 26.34 lakh ineligible beneficiaries, and the plan to recover Rs 21.44 crore from men and register offences. ThePrint quotes Tatkare, Pawar and Fadnavis. So the missing contra is a gap in the research, not a gap in the record. (2) The record presents Rs 4,800 crore as Sule's figure. It is a department-sourced estimate of payments to ineligible beneficiaries, reported by PTI and Siasat the day before. What Sule adds is calling it a \"scam/fraud\" and blaming the cabinet. The amount itself is reported, not merely alleged. Alleged is the right tier for the fraud characterisation, provided a contra is attached.",
        "corrections": [
          "1) Remove \"the government's reply was not captured in the page text opened — no contra available; reviewer should locate the state's response\", both from this result and from literature.json line 583 and the wel:supriya-sule note at line 1324. Replace it with a contra edge from the Maharashtra government / Aditi Tatkare (WCD Minister) to this claim: ineligible accounts were identified through the government's own cross-verification, 26.34 lakh were suspended from June 2025, and Rs 21.44 crore paid to 14,298 men will be recovered and offences registered. Sources: the DH URL already cited, plus https://theprint.in/politics/in-mahayutis-poll-winning-ladki-bahin-scheme-14000-of-26-lakh-bogus-beneficiaries-found-to-be-men/2705061/. Also record: no direct rebuttal addressed to Sule's SIT demand was found. 2) Say where the amount comes from. Rs 4,800 crore is a department-sourced estimate of payments to ineligible beneficiaries (Siasat/PTI, 2025-07-28, https://www.siasat.com/ladki-bahin-yojana-14298-men-avail-benefits-under-the-scheme-3251612/). Add it as a separate result tiered \"reported\", and add the government-admitted count of 26.34 lakh ineligible out of 2.52 crore (ThePrint, DH, Siasat), which is at least reported and arguably documented by two outlets. Sule's claim should cover only the \"scam/fraud, cabinet responsible\" characterisation and the SIT demand. 3) Change \"fraud in Ladki Bahin DBT payments\" to \"Rs 4,800 crore scam in the Ladki Bahin Yojana; questioned the transparency of the DBT mechanism\", which is the source's wording. 4) Add her designation from the source: \"NCP (SP) working president and Baramati MP\". 5) Add killIf: an SIT, CAG or police finding that the ineligible payments came from self-declaration errors with no collusion. Add upgradeIf: FIRs or chargesheets naming officials or intermediaries, or a CAG finding of deliberate diversion."
        ],
        "applied": [
          "no claim with this id in the fleet"
        ]
      }
    ]
  },
  "killed": [
    {
      "id": "fiscal:c014",
      "s": "scheme:mh-ladki-bahin",
      "t": "bjp",
      "pred": "analytic",
      "tier": "analytic",
      "a": null,
      "lab": "MH off-budget borrowing rose while others fell",
      "d": "PRS Table 7: Maharashtra's declared off-budget borrowings 0 → 2,500 → 7,700 → 13,990 (₹ cr, 2021-22 to 2024-25) while the 19-state total fell 67,075 → 24,955. Maharashtra alone is 56% of the 2024-25 total. Timing overlaps the Aug 2024 launch of Ladki Bahin.",
      "from": null,
      "to": null,
      "srcs": [
        [
          "PRS Legislative Research, State of State Finances 2025-26 (Oct 2025) — p.7 (UCT schemes, Figs 13–15), Annexure Table 6 (UCT benefits and BE 2025-26), Table 7 (off-budget borrowings), p.17 (guarantees), subsidies section",
          "https://prsindia.org/files/budget/SOSF_2025.pdf"
        ]
      ],
      "innocentReading": "The rise began two years before the scheme; off-budget borrowing by state PSUs usually funds infrastructure or procurement; the table gives no end-use. Co-timing is not a funding link.",
      "upgradeIf": "A CAG Maharashtra finance-accounts note or budget paper ties an off-budget entity's borrowing to scheme payments.",
      "killIf": "End-use disclosure shows the borrowing funded capital projects unrelated to transfers.",
      "supersededBy": null,
      "benefit": null,
      "domain": "fiscal-results",
      "file": "welfare/fiscal-results.json",
      "status": "killed",
      "killedReason": "The figures are confirmed against the primary source. Lok Sabha USQ 4004 (MoF, answered 18.08.2025), Annexure-II, gives Maharashtra '- | 2,500 | 7,700 | 13,990' for 2021-22 to 2024-25. PRS SOSF 2025 Table 7 matches and sums to 24,955; my share calculation is 56.06%. The claim still fails on three counts. (1) The symmetric control produces the same 'finding' for Karnataka/Congress (0 to 5,438 in 2024-25), so the method is generating the pattern. (2) 'Other states' fell' is wrong for 4 states, and the total rose in 2024-25. (3) The rise predates the scheme by two years, and the scheme belongs to a Shinde-led coalition, not BJP alone. Even with its disclaimer, the edge from scheme:mh-ladki-bahin to party:bjp suggests a link that no source makes and the base rate does not support. The numbers are publishable, but as a documented fact about Maharashtra's OBB with no scheme or party edge."
    },
    {
      "id": "ladlibehna-alleged-inducement",
      "s": "party:inc",
      "t": "scheme:mp-ladli-behna",
      "pred": "enforce",
      "tier": "alleged",
      "a": null,
      "lab": "Congress and other critics characterised the scheme's timing and amount hikes before the 2023 poll as an election inducement",
      "d": "Alleged by Congress/opposition commentary during the 2023 MP campaign; this file did not independently verify a specific named quote and URL this session, logged as a gap.",
      "from": null,
      "to": null,
      "srcs": [],
      "innocentReading": null,
      "upgradeIf": null,
      "killIf": null,
      "supersededBy": null,
      "benefit": null,
      "domain": "elections-timing",
      "file": "welfare/elections-timing.json",
      "status": "killed",
      "killedReason": "Unsourced allegation: no named speaker, quote or URL (the file itself logs this as a gap), and the fleet audit recommended kill (\"source does not say\") — its verdict was filed under \"claim:ladlibehna-alleged-inducement\" and so could not match. An alleged claim must name who asserts it."
    },
    {
      "id": "lakshmirbhandar-alleged-inducement-2026",
      "s": "bjp",
      "t": "scheme:wb-lakshmir-bhandar",
      "pred": "enforce",
      "tier": "alleged",
      "a": null,
      "lab": "BJP and other critics characterised the February 2026 Lakshmir Bhandar hike, roughly 2.5 months before polling, as a pre-election inducement",
      "d": "Alleged in BJP campaign commentary and reported in press coverage of the 2026 WB budget; a specific named quote and URL was not independently pinned down this session, logged as a gap.",
      "from": null,
      "to": null,
      "srcs": [],
      "innocentReading": null,
      "upgradeIf": null,
      "killIf": null,
      "supersededBy": null,
      "benefit": null,
      "domain": "elections-timing",
      "file": "welfare/elections-timing.json",
      "status": "killed",
      "killedReason": "Unsourced allegation: no named speaker, quote or URL (the file logs this as a gap), and the fleet audit recommended kill — its verdict was filed under \"claim:lakshmirbhandar-alleged-inducement-2026\" and so could not match. The documented pre-poll hike itself stays on record in women-cash:c032/c033."
    },
    {
      "id": "welfare-central:c042",
      "s": "party:inc",
      "t": "scheme:pmgkay",
      "pred": "enforce",
      "tier": "alleged",
      "a": null,
      "lab": "Congress: announcement made because BJP 'is losing' Chhattisgarh",
      "d": "response to PM's Durg rally speech, 4 Nov 2023",
      "from": "2023-11-04",
      "to": null,
      "srcs": [
        [
          "ThePrint/ANI, 'Guarantee of Modi': PM extends free ration scheme for 5 years in poll-bound Chhattisgarh, MP, 4 Nov 2023",
          "https://theprint.in/india/guarantee-of-modi-pm-extends-free-ration-scheme-for-5-years-in-poll-bound-chhattisgarh-mp/1832402/"
        ]
      ],
      "innocentReading": null,
      "upgradeIf": "internal BJP/government file shows extension decided before campaign",
      "killIf": "Cabinet note predates 4 Nov 2023",
      "supersededBy": null,
      "benefit": null,
      "domain": "central",
      "file": "welfare/central.json",
      "status": "killed",
      "killedReason": "The claim is a misattribution. The only cited source, ThePrint/ANI, quotes Congress saying BJP \"is losing the assembly polls\" in reply to Modi's Mahadev betting-app and corruption allegations. It does not tie the quote to the free-ration announcement, and the article reports no Congress reaction to the ration extension at all. The ₹11.80 lakh cr figure is also absent from that source; it comes from the PIB note of 29 Nov. The edge as written claims a Congress position on PMGKAY that its source does not support, so it should be killed. A real, differently worded Congress allegation exists (Jairam Ramesh on a model-code breach and no Cabinet approval) and could replace it at the alleged tier."
    }
  ],
  "excluded": []
};
